webpackJsonp([1],{

/***/ "+4pX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _studentClassesActions = __webpack_require__("TEzo");
// map of student ids to class ids
var initialState = {};

/**
 * StudentClasses Reducer
 *
 * Consumes SET_STUDENT_CLASSES action
 *
 * @param {object} the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - new state
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _studentClassesActions.SET_STUDENT_CLASSES:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "+NxA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.courseInsightPropType = exports.activityMasteryPropTypeShape = exports.activityMasteryPropType = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var activityMasteryPropTypeShape = exports.activityMasteryPropTypeShape = {
  scoreBand: _propTypes["default"].shape({
    mastered: _propTypes["default"].number.isRequired,
    consolidating: _propTypes["default"].number.isRequired,
    developing: _propTypes["default"].number.isRequired,
    emerging: _propTypes["default"].number.isRequired,
    needsImproving: _propTypes["default"].number.isRequired
  }),
  goldBars: _propTypes["default"].number,
  totalActivities: _propTypes["default"].number
};
var activityMasteryPropType = exports.activityMasteryPropType = _propTypes["default"].shape(activityMasteryPropTypeShape);
var courseInsightPropType = exports.courseInsightPropType = _propTypes["default"].shape({
  levelObjectName: _propTypes["default"].string,
  title: _propTypes["default"].string,
  averageResult: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
});

/***/ }),

/***/ "+UNJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reselect = __webpack_require__("bndy");
var _filterConstants = __webpack_require__("cdWI");
/**
 * Redux selectors for dropdown data
 */

var selectDropdownData = function selectDropdownData(state) {
  return state.dropdownData;
};

/**
 * Selects only dropdown data for one list
 * References list types in filter-constants.js ie. CLASS_LIST
 * */
var selectDropdownDataByType = function selectDropdownDataByType(type) {
  return (0, _reselect.createSelector)([selectDropdownData], function (dropdownData) {
    return dropdownData.find(function (d) {
      return d.type === type;
    });
  });
};
var selectDropdownDataDatalistByType = function selectDropdownDataDatalistByType(type) {
  return (0, _reselect.createSelector)([selectDropdownDataByType(type)], function (dropdownItem) {
    if (dropdownItem) {
      return dropdownItem.data;
    }
    return [];
  });
};
var selectSelectedOptionByType = function selectSelectedOptionByType(type) {
  return (0, _reselect.createSelector)([selectDropdownDataByType(type)], function (dropdownItem) {
    return dropdownItem && dropdownItem.selectedOption;
  });
};
var selectAllSelectedOptions = (0, _reselect.createSelector)([selectDropdownData], function (dropdownData) {
  var selectedOptions = {};
  dropdownData.forEach(function (d) {
    var type = d.type,
      selectedOption = d.selectedOption;
    var filter = _filterConstants.DROPDOWN_TO_FILTER_MAP[d.type];
    if (type === _filterConstants.DATE_LIST) {
      selectedOptions[filter] = selectedOption;
    } else {
      selectedOptions[filter] = {
        id: selectedOption.value,
        name: selectedOption.label
      };
    }
  });
  return selectedOptions;
});
var _default = exports["default"] = {
  selectDropdownData: selectDropdownData,
  selectDropdownDataByType: selectDropdownDataByType,
  selectDropdownDataDatalistByType: selectDropdownDataDatalistByType,
  selectAllSelectedOptions: selectAllSelectedOptions,
  selectSelectedOptionByType: selectSelectedOptionByType
};

/***/ }),

/***/ "+iOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccuracyOverviewGraph = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _accuracyOverviewGraph = __webpack_require__("DuU+");
var _accuracyOverviewGraph2 = _interopRequireDefault(__webpack_require__("JfNJ"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AccuracyOverviewGraph = exports.AccuracyOverviewGraph = function AccuracyOverviewGraph(_ref) {
  var dateRange = _ref.dateRange,
    averageAccuracies = _ref.averageAccuracies;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, (0, _accuracyOverviewGraph.renderPercentageLines)(), /*#__PURE__*/_react["default"].createElement("div", {
    className: _accuracyOverviewGraph2["default"].chartPoints
  }, (0, _accuracyOverviewGraph.renderChartPoints)(dateRange, averageAccuracies))), /*#__PURE__*/_react["default"].createElement("div", {
    id: "months",
    className: _accuracyOverviewGraph2["default"].months
  }, (0, _accuracyOverviewGraph.renderDateRange)(dateRange)));
};
AccuracyOverviewGraph.propTypes = {
  dateRange: _propTypes["default"].string,
  averageAccuracies: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    accuracy: _propTypes["default"].number,
    weekStartDate: _propTypes["default"].string
  }))
};

/***/ }),

/***/ "/JVf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".report-container---uim4_ {\n  padding-top: 12px;\n  border-top: 1px solid #e1e1e1; }\n  .report-container---uim4_ .legends---1FRl2 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    margin-bottom: 12px; }\n  .report-container---uim4_ .legends---1FRl2 > div {\n      -webkit-box-flex: 0;\n          -ms-flex: 0 1 650px;\n              flex: 0 1 650px; }\n", ""]);

// exports
exports.locals = {
	"report-container": "report-container---uim4_",
	"legends": "legends---1FRl2"
};

/***/ }),

/***/ "/k3W":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".skill-quests-mastery-legend---3rHFG {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  padding: 4px 5px;\n  background-color: #dbe9f4;\n  border-radius: 5px;\n  width: auto; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 0 10px; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx:first-child {\n      margin-left: 5px;\n      margin-right: 10px; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx:last-child {\n      margin-left: 10px;\n      margin-right: 5px; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx .text---1Q8nZ {\n      color: #4e5c67;\n      font-size: 13px;\n      margin-left: 8px;\n      padding-top: 2px; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx .progress-complete---2Z4XY {\n    height: 19px;\n    width: 19px;\n    background-color: #37c97c;\n    background-image: url(" + __webpack_require__("W5D1") + ");\n    background-repeat: no-repeat;\n    background-size: 80% 100%;\n    background-position: center; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx .accuracy-complete---23in7 {\n    height: 19px;\n    width: 19px;\n    background-color: transparent;\n    background-image: url(" + __webpack_require__("pACL") + ");\n    background-repeat: no-repeat;\n    background-size: 80% 100%;\n    background-position: center; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx .green---3p43J {\n    height: 19px;\n    width: 19px;\n    background-color: #37c97c; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx .light-blue---2NG56 {\n    height: 19px;\n    width: 19px;\n    background-color: #81daab; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx .dark-blue---3cNL9 {\n    height: 19px;\n    width: 19px;\n    background-color: #e89e13; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx .orange---cC9PH {\n    height: 19px;\n    width: 19px;\n    background-color: #e06d3f; }\n  .skill-quests-mastery-legend---3rHFG .legend---1_3lx .red---2HV4Y {\n    height: 19px;\n    width: 19px;\n    background-color: #c53902; }\n", ""]);

// exports
exports.locals = {
	"skill-quests-mastery-legend": "skill-quests-mastery-legend---3rHFG",
	"legend": "legend---1_3lx",
	"text": "text---1Q8nZ",
	"progress-complete": "progress-complete---2Z4XY",
	"accuracy-complete": "accuracy-complete---23in7",
	"green": "green---3p43J",
	"light-blue": "light-blue---2NG56",
	"dark-blue": "dark-blue---3cNL9",
	"orange": "orange---cC9PH",
	"red": "red---2HV4Y"
};

/***/ }),

/***/ "/wMX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _strengthWeaknessTab = _interopRequireDefault(__webpack_require__("ndXM"));
var _strengthAndWeaknessesConstants = __webpack_require__("EaW9");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var StrengthWeaknessTab = /*#__PURE__*/function (_PureComponent) {
  function StrengthWeaknessTab(props) {
    var _this;
    _classCallCheck(this, StrengthWeaknessTab);
    _this = _callSuper(this, StrengthWeaknessTab, [props]);
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(StrengthWeaknessTab, _PureComponent);
  return _createClass(StrengthWeaknessTab, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isStrengthTab = _this$props.isStrengthTab,
        children = _this$props.children,
        onTabClick = _this$props.onTabClick;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _strengthWeaknessTab["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _strengthWeaknessTab["default"]['tab-container']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        className: isStrengthTab ? _strengthWeaknessTab["default"].active : _strengthWeaknessTab["default"].inactive,
        onClick: function onClick() {
          return onTabClick(_strengthAndWeaknessesConstants.STRENGTH_TAB);
        },
        text: this.i18n._('Button Label - Strengths')
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        className: !isStrengthTab ? _strengthWeaknessTab["default"].active : _strengthWeaknessTab["default"].inactive,
        onClick: function onClick() {
          return onTabClick(_strengthAndWeaknessesConstants.WEAKNESS_TAB);
        },
        text: this.i18n._('Label - RelativeWeaknesses')
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "strength-weakness-table"
      }, children));
    }
  }]);
}(_react.PureComponent);
StrengthWeaknessTab.propTypes = {
  children: _propTypes["default"].node,
  isStrengthTab: _propTypes["default"].bool,
  onTabClick: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_strengthWeaknessTab["default"])(StrengthWeaknessTab);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "060x":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lYPc");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./student-data-table.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./student-data-table.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "09qS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3AADO {\n  height: calc(100% - 135px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .component---3AADO h3 {\n    font-weight: normal; }\n  .component---3AADO .data-table---3XgwK {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 60%;\n            flex: 1 1 60%; }\n  .component---3AADO .data-table---3XgwK table {\n      width: calc(100% - 2px); }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 0;\n      background-color: white;\n      font-weight: 500;\n      color: #4e5c67;\n      height: 47px; }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type th {\n        border: none;\n        background: none;\n        font-weight: normal;\n        font-size: 12px;\n        white-space: nowrap; }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type th::after, .component---3AADO .data-table---3XgwK thead tr:first-of-type th::before {\n          content: '';\n          position: absolute;\n          left: 0;\n          width: 100%; }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type th::before {\n          top: -1px;\n          border-top: 1px solid #e5e5e5;\n          pointer-events: none; }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type th::after {\n          bottom: -1px;\n          border-bottom: 2px solid #e5e5e5;\n          pointer-events: none; }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type th::before {\n          left: -1px;\n          height: 46px;\n          border-left: 1px solid white;\n          border-right: 1px solid white; }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type th::after {\n          height: 46px;\n          border-left: 1px solid white;\n          right: 1px; }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type th:first-of-type {\n          font-size: 18px;\n          text-align: left; }\n  .component---3AADO .data-table---3XgwK thead tr:last-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 47px;\n      background-color: #e4eaef;\n      color: #278bcb;\n      font-weight: 600; }\n  .component---3AADO .data-table---3XgwK thead tr:last-of-type th::after, .component---3AADO .data-table---3XgwK thead tr:last-of-type th::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        width: 100%; }\n  .component---3AADO .data-table---3XgwK thead tr:last-of-type th::before {\n        top: -1px;\n        border-top: 1px solid #e5e5e5;\n        pointer-events: none; }\n  .component---3AADO .data-table---3XgwK thead tr:last-of-type th::after {\n        bottom: -1px;\n        border-bottom: 2px solid #e5e5e5;\n        pointer-events: none; }\n  .component---3AADO .data-table---3XgwK thead tr:first-of-type th:last-of-type {\n      font-size: 12px; }\n  .component---3AADO .data-table---3XgwK .class-name---A4_Ry svg path,\n    .component---3AADO .data-table---3XgwK .group-name---1C6SA svg path {\n      fill: #788189 !important; }\n  .component---3AADO .data-table---3XgwK .class-name---A4_Ry {\n      width: 30%;\n      max-width: 150px;\n      text-align: left; }\n  .component---3AADO .data-table---3XgwK .results---2s2N9 {\n      width: 55%;\n      padding: 0; }\n  .component---3AADO .data-table---3XgwK .total-activities---2uRXS {\n      width: 15%;\n      font-size: 16px;\n      background-color: #eef2f5; }\n  .component---3AADO .strength-weakness---2O6OK {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 40%;\n            flex: 1 1 40%;\n    padding-left: 20px;\n    text-align: left; }\n  .empty-component---6WmVN {\n  margin: auto;\n  width: 264px; }\n  .empty-component---6WmVN .icon-container---1JWdH {\n    width: 134px;\n    padding: 50px;\n    border-radius: 120px;\n    height: 144px;\n    background-color: #e4eaef;\n    margin-left: 15px;\n    margin-bottom: 32px; }\n  .empty-component---6WmVN p {\n    font-size: 26px;\n    text-align: center;\n    color: #1981c4;\n    font-weight: 500; }\n  .empty-component---6WmVN svg path {\n    fill: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3AADO",
	"data-table": "data-table---3XgwK",
	"class-name": "class-name---A4_Ry",
	"group-name": "group-name---1C6SA",
	"results": "results---2s2N9",
	"total-activities": "total-activities---2uRXS",
	"strength-weakness": "strength-weakness---2O6OK",
	"empty-component": "empty-component---6WmVN",
	"icon-container": "icon-container---1JWdH"
};

/***/ }),

/***/ "0Cvf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BusyIndicator = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _busyIndicatorActions = _interopRequireDefault(__webpack_require__("qS76"));
var _busyIndicator = _interopRequireDefault(__webpack_require__("gxHR"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * BusyIndicator Redux component
 * Displays an overlay on the application and a busy cursor while API requests are
 * being processed
 */
var BusyIndicator = exports.BusyIndicator = /*#__PURE__*/function (_Component) {
  function BusyIndicator(props) {
    var _this;
    _classCallCheck(this, BusyIndicator);
    _this = _callSuper(this, BusyIndicator, [props]);
    props.hideBusy();
    return _this;
  }
  _inherits(BusyIndicator, _Component);
  return _createClass(BusyIndicator, [{
    key: "render",
    value: function render() {
      if (this.props.busyIndicatorCount < 1) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _busyIndicator["default"].component
      });
    }
  }]);
}(_react.Component);
/**
 * Add Resources interceptors to dispatch busy indicator actions
 * when sending requests and receiving responses
 */
_defineProperty(BusyIndicator, "propTypes", {
  busyIndicatorCount: _propTypes["default"].number,
  hideBusy: _propTypes["default"].func
});
function addInterceptors(dispatch) {
  var env = _resources["default"].env;
  function requestInterceptor() {
    dispatch(_busyIndicatorActions["default"].showBusy());
  }
  function responseInterceptor(response) {
    if (!env.havePendingRequests()) {
      dispatch(_busyIndicatorActions["default"].hideBusy());
    }
    return response;
  }
  env.addRequestInterceptor(requestInterceptor);
  env.addResponseInterceptor(responseInterceptor);
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
  return {
    busyIndicatorCount: state.busyIndicatorCount
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  addInterceptors(dispatch);
  return (0, _redux.bindActionCreators)({
    hideBusy: _busyIndicatorActions["default"].hideBusy,
    showBusy: _busyIndicatorActions["default"].showBusy
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_busyIndicator["default"])(BusyIndicator));

/***/ }),

/***/ "0E9P":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1s1v");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./participation.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./participation.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "0OCq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _downloadReportActions = __webpack_require__("ylPA");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  reportTypes: [],
  isProcessingDownload: false
};
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _downloadReportActions.UPDATE_REPORT_SELECTION:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          reportTypes: getUpdatedReportType(state.reportTypes, action.reportTypes)
        });
      }
    case _downloadReportActions.DOWNLOAD_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isProcessingDownload: true
      });
    case _downloadReportActions.DOWNLOAD_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isProcessingDownload: false
      });
    case _downloadReportActions.RESET_REPORT_SELECTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        reportTypes: []
      });
    default:
      return state;
  }
}

/**
 * Multiple report formats can be selected. If exists we remove... if not we append
 * @param currentReportType: state.reportTypes
 * @param payload: action.payload
 * @returns updated report formats array
 */
function getUpdatedReportType(currentReportType, payload) {
  var updatedReportFormat = _toConsumableArray(currentReportType);
  if (currentReportType.includes(payload)) {
    return updatedReportFormat.filter(function (item) {
      return item !== payload;
    });
  }
  return [].concat(_toConsumableArray(updatedReportFormat), [payload]);
}

/***/ }),

/***/ "0brY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3RNVU {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  padding: 4px 16px;\n  background-color: #e4eaef;\n  border-radius: 5px; }\n  .component---3RNVU .legend---q7x06,\n  .component---3RNVU .gold-bars---1eyrH {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .component---3RNVU .legend---q7x06 .text---3YvR9,\n    .component---3RNVU .gold-bars---1eyrH .text---3YvR9 {\n      color: #4e5c67;\n      font-size: 13px;\n      margin-left: 8px; }\n  .component---3RNVU .gold-bars---1eyrH svg {\n    height: 24px;\n    width: 24px; }\n  .component---3RNVU .gold-bars---1eyrH svg path {\n      fill: #ffc90d !important; }\n  .component---3RNVU .legend---q7x06 .mastered-box---15FCp {\n    height: 19px;\n    width: 19px;\n    background-color: #37c97c; }\n  .component---3RNVU .legend---q7x06 .consolidating-box---2luuB {\n    height: 19px;\n    width: 19px;\n    background-color: #81daab; }\n  .component---3RNVU .legend---q7x06 .developing-box---3yyPR {\n    height: 19px;\n    width: 19px;\n    background-color: #e89e13; }\n  .component---3RNVU .legend---q7x06 .emerging-box---3kwyS {\n    height: 19px;\n    width: 19px;\n    background-color: #e06d3f; }\n  .component---3RNVU .legend---q7x06 .needsImproving-box---3EJeA {\n    height: 19px;\n    width: 19px;\n    background-color: #c53902; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3RNVU",
	"legend": "legend---q7x06",
	"gold-bars": "gold-bars---1eyrH",
	"text": "text---3YvR9",
	"mastered-box": "mastered-box---15FCp",
	"consolidating-box": "consolidating-box---2luuB",
	"developing-box": "developing-box---3yyPR",
	"emerging-box": "emerging-box---3kwyS",
	"needsImproving-box": "needsImproving-box---3EJeA"
};

/***/ }),

/***/ "0gIa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _allClassesActions = __webpack_require__("54Df");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  isLoading: false,
  data: null
};

/**
 * Skill Quests Mastery - All Classes Reducer
 *
 * Consumes SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _allClassesActions.SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true,
          data: null
        });
      }
    case _allClassesActions.SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        data: action.payload
      });
    default:
      return state;
  }
}

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1DBy":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".format-picker---T0fQv {\n  text-align: left; }\n  .format-picker---T0fQv .content---M-1UU {\n    margin: 0; }\n  .format-picker---T0fQv .report-format---3SEdZ {\n    margin-top: 20px; }\n  .format-picker---T0fQv .report-format---3SEdZ .header---2cp64 {\n      font-weight: bold; }\n  .format-picker---T0fQv .report-format---3SEdZ .footer---2_NGM {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: end;\n          -ms-flex-pack: end;\n              justify-content: flex-end;\n      margin-top: 10px; }\n  .format-picker---T0fQv .report-format---3SEdZ .radio-group---1LfjD {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      height: 40px;\n      border: 1px #a2c4e3 solid; }\n  .format-picker---T0fQv .report-format---3SEdZ .radio-group---1LfjD .radio---3O5rE {\n        margin: 0 10px; }\n", ""]);

// exports
exports.locals = {
	"format-picker": "format-picker---T0fQv",
	"content": "content---M-1UU",
	"report-format": "report-format---3SEdZ",
	"header": "header---2cp64",
	"footer": "footer---2_NGM",
	"radio-group": "radio-group---1LfjD",
	"radio": "radio---3O5rE"
};

/***/ }),

/***/ "1QGX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YEAR_GROUP_PATH = exports.TOTAL_CERTIFICATES_TYPE = exports.TEACHER_PATH = exports.STUDENT_PATH = exports.START_DATE = exports.SKILL_QUESTS_MASTERY_PATH = exports.REPORT_TYPE_TO_PATH_MAP = exports.REPORT_FORMATS = exports.PORTAL_MODULE = exports.PARTICIPATION_PATH = exports.MATHLETICS_ID = exports.LIVE_MATHS_PATH = exports.GROUP_PATH = exports.END_DATE = exports.ENDPOINT_PATH_THIS_WEEK = exports.ENDPOINT_PATH_THIS_SCHOOL_YEAR = exports.ENDPOINT_PATH_SKILL_QUESTS_MASTERY = exports.ENDPOINT_PATH_PARTICIPATION = exports.ENDPOINT_PATH_LIVE_MATHS = exports.ENDPOINT_PATH_LIFETIME = exports.ENDPOINT_PATH_LAST_WEEK = exports.ENDPOINT_PATH_CUSTOM_DATE = exports.ENDPOINT_PATH_ALL_YEARS = exports.ENDPOINT_PATH_ALL_TEACHERS = exports.ENDPOINT_PATH_ACTIVITY_MASTERY = exports.DATE_TYPE_MAP = exports.DATE_TYPE = exports.DATE_PARAM_MAP = exports.DATE_PARAMS = exports.DATE_OPTION_TO_PATH_MAP = exports.CONFIGURATION_KEYS = exports.CLASS_PATH = exports.ACTIVITY_MASTERY_PATH = void 0;
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* App routes */

var ACTIVITY_MASTERY_PATH = exports.ACTIVITY_MASTERY_PATH = '/activity-mastery';
var PARTICIPATION_PATH = exports.PARTICIPATION_PATH = '/participation';
var LIVE_MATHS_PATH = exports.LIVE_MATHS_PATH = '/live-mathletics';
var SKILL_QUESTS_MASTERY_PATH = exports.SKILL_QUESTS_MASTERY_PATH = '/skills-quest-mastery';
var REPORT_TYPE_TO_PATH_MAP = exports.REPORT_TYPE_TO_PATH_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _filterConstants.ACTIVITY_MASTERY, ACTIVITY_MASTERY_PATH), _filterConstants.PARTICIPATION, PARTICIPATION_PATH), _filterConstants.LIVE_MATHS, LIVE_MATHS_PATH), _filterConstants.SKILL_QUESTS_MASTERY, SKILL_QUESTS_MASTERY_PATH);
var YEAR_GROUP_PATH = exports.YEAR_GROUP_PATH = 'year';
var TEACHER_PATH = exports.TEACHER_PATH = 'teacher';
var CLASS_PATH = exports.CLASS_PATH = 'class';
var GROUP_PATH = exports.GROUP_PATH = 'group';
var STUDENT_PATH = exports.STUDENT_PATH = 'student';

/* Date query params */

var DATE_TYPE = exports.DATE_TYPE = 'dateType';
var START_DATE = exports.START_DATE = 'startDate';
var END_DATE = exports.END_DATE = 'endDate';
var DATE_PARAMS = exports.DATE_PARAMS = [DATE_TYPE, START_DATE, END_DATE];
var DATE_TYPE_MAP = exports.DATE_TYPE_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _reactComponents.DatePicker.THIS_WEEK, 0), _reactComponents.DatePicker.LAST_WEEK, 1), _reactComponents.DatePicker.THIS_SCHOOL_YEAR, 2), _reactComponents.DatePicker.CUSTOM_DATE, 3), _reactComponents.DatePicker.LIFETIME, 4);
var DATE_PARAM_MAP = exports.DATE_PARAM_MAP = {
  0: _reactComponents.DatePicker.THIS_WEEK,
  1: _reactComponents.DatePicker.LAST_WEEK,
  2: _reactComponents.DatePicker.THIS_SCHOOL_YEAR,
  3: _reactComponents.DatePicker.CUSTOM_DATE,
  4: _reactComponents.DatePicker.LIFETIME
};

/* API endpoints */

var ENDPOINT_PATH_ACTIVITY_MASTERY = exports.ENDPOINT_PATH_ACTIVITY_MASTERY = 'activity-mastery';
var ENDPOINT_PATH_PARTICIPATION = exports.ENDPOINT_PATH_PARTICIPATION = 'participation';
var ENDPOINT_PATH_LIVE_MATHS = exports.ENDPOINT_PATH_LIVE_MATHS = 'livemaths';
var ENDPOINT_PATH_SKILL_QUESTS_MASTERY = exports.ENDPOINT_PATH_SKILL_QUESTS_MASTERY = 'skill-mastery';
var ENDPOINT_PATH_THIS_WEEK = exports.ENDPOINT_PATH_THIS_WEEK = 'this-week';
var ENDPOINT_PATH_LAST_WEEK = exports.ENDPOINT_PATH_LAST_WEEK = 'last-week';
var ENDPOINT_PATH_THIS_SCHOOL_YEAR = exports.ENDPOINT_PATH_THIS_SCHOOL_YEAR = 'this-academic-year';
var ENDPOINT_PATH_CUSTOM_DATE = exports.ENDPOINT_PATH_CUSTOM_DATE = 'custom-date';
var ENDPOINT_PATH_LIFETIME = exports.ENDPOINT_PATH_LIFETIME = 'lifetime';
var ENDPOINT_PATH_ALL_YEARS = exports.ENDPOINT_PATH_ALL_YEARS = 'all';
var ENDPOINT_PATH_ALL_TEACHERS = exports.ENDPOINT_PATH_ALL_TEACHERS = 0;
var DATE_OPTION_TO_PATH_MAP = exports.DATE_OPTION_TO_PATH_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _reactComponents.DatePicker.THIS_WEEK, ENDPOINT_PATH_THIS_WEEK), _reactComponents.DatePicker.LAST_WEEK, ENDPOINT_PATH_LAST_WEEK), _reactComponents.DatePicker.THIS_SCHOOL_YEAR, ENDPOINT_PATH_THIS_SCHOOL_YEAR), _reactComponents.DatePicker.CUSTOM_DATE, ENDPOINT_PATH_CUSTOM_DATE), _reactComponents.DatePicker.LIFETIME, ENDPOINT_PATH_LIFETIME);
var REPORT_FORMATS = exports.REPORT_FORMATS = {
  CSV_REPORT: 1,
  PDF_REPORT: 2
};
var PORTAL_MODULE = exports.PORTAL_MODULE = {
  MANAGE_STUDENTS: 'StudentsManagementModuleId',
  ASSIGN_REVIEW: 'AssignReviewModuleId'
};
var CONFIGURATION_KEYS = exports.CONFIGURATION_KEYS = {
  SHOW_ACCURACY_OVERVIEW_GRAPH: 'showAccuracyOverviewGraph',
  MAX_CERTIFICATES_CAN_DOWNLOAD: 'maxCertificatesCanDownload'
};
var MATHLETICS_ID = exports.MATHLETICS_ID = 1;
var TOTAL_CERTIFICATES_TYPE = exports.TOTAL_CERTIFICATES_TYPE = 0;

/***/ }),

/***/ "1dJ6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WXir");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./all-classess.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./all-classess.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "1g86":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yearGroupPropType = exports.teacherPropType = exports.studentsByGroupPropType = exports.filterPropType = exports.dropdownItemPropType = exports.dateFilterPropType = exports.classPropType = exports.activeFiltersPropType = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var filterPropType = exports.filterPropType = _propTypes["default"].shape({
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  name: _propTypes["default"].string
});
var dateFilterPropType = exports.dateFilterPropType = _propTypes["default"].shape({
  type: _propTypes["default"].oneOf(_reactComponents.DatePicker.DATE_OPTIONS),
  startDate: _propTypes["default"].string,
  endDate: _propTypes["default"].string
});
var activeFiltersPropType = exports.activeFiltersPropType = _propTypes["default"].shape(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _filterConstants.SELECTED_YEAR_GROUP, filterPropType), _filterConstants.SELECTED_TEACHER, filterPropType), _filterConstants.SELECTED_CLASS, filterPropType), _filterConstants.SELECTED_GROUP, filterPropType), _filterConstants.SELECTED_STUDENT, filterPropType), _filterConstants.SELECTED_REPORT, filterPropType), _filterConstants.SELECTED_DATE, dateFilterPropType));
var dropdownItemPropType = exports.dropdownItemPropType = _propTypes["default"].shape({
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  label: _propTypes["default"].string
});
var yearGroupPropType = exports.yearGroupPropType = _propTypes["default"].shape({
  id: _propTypes["default"].number,
  year: _propTypes["default"].string
});
var teacherPropType = exports.teacherPropType = _propTypes["default"].shape({
  value: _propTypes["default"].number,
  label: _propTypes["default"].string
});
var classPropType = exports.classPropType = _propTypes["default"].shape({
  id: _propTypes["default"].number,
  name: _propTypes["default"].string
});
var studentsByGroupPropType = exports.studentsByGroupPropType = _propTypes["default"].shape({
  id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  name: _propTypes["default"].string,
  students: _propTypes["default"].arrayOf(dropdownItemPropType)
});

/***/ }),

/***/ "1s1v":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---o4P1h {\n  height: 100%;\n  min-width: 1100px; }\n  .component---o4P1h > div {\n    height: 100%; }\n  .component---o4P1h .report-container---3UqS6 {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---o4P1h",
	"report-container": "report-container---3UqS6"
};

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("x4K0");


/***/ }),

/***/ "25Ai":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateProgressBar = exports.Progress = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _progressBar = _interopRequireDefault(__webpack_require__("4doL"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Progress = exports.Progress = function Progress(_ref) {
  var style = _ref.style,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_progressBar["default"]['progress-wrapper'], " ").concat(_progressBar["default"][style]),
    style: {
      minWidth: "".concat(width, "px")
    }
  });
};
Progress.propTypes = {
  style: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var generateProgressBar = exports.generateProgressBar = function generateProgressBar(chartData) {
  return chartData.map(function (_ref2) {
    var color = _ref2.color,
      width = _ref2.width;
    return /*#__PURE__*/_react["default"].createElement(Progress, {
      color: color,
      width: width
    });
  });
};

/***/ }),

/***/ "27ps":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".page-header---3YKy5 {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0; }\n", ""]);

// exports
exports.locals = {
	"page-header": "page-header---3YKy5"
};

/***/ }),

/***/ "27qy":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("sgyZ");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./download-button.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./download-button.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "2jmR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _studentConstants = __webpack_require__("OCle");
var _improvementTypePicker = _interopRequireDefault(__webpack_require__("cQ73"));
var _improvementTypeTranslations = __webpack_require__("tBKH");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Component to pick the improvement calculation type to use when exporting student
 * participation report
 */
var ImprovementTypePicker = /*#__PURE__*/function (_Component) {
  function ImprovementTypePicker(props) {
    var _this;
    _classCallCheck(this, ImprovementTypePicker);
    _this = _callSuper(this, ImprovementTypePicker, [props]);
    _defineProperty(_this, "selectOption", function (value) {
      _this.setState({
        selected: value
      });
      _this.props.pickImprovementType(value);
    });
    var _improvementTypeTrans = (0, _improvementTypeTranslations.improvementTypeTranslations)(),
      AsIs = _improvementTypeTrans.AsIs,
      FirstHighest = _improvementTypeTrans.FirstHighest,
      FirstLatest = _improvementTypeTrans.FirstLatest,
      HighestLatest = _improvementTypeTrans.HighestLatest;
    _this.improvements = [{
      label: AsIs,
      value: _studentConstants.SELECTION_AS_IS
    }, {
      label: FirstHighest,
      value: _studentConstants.FIRST_VS_LATEST
    }, {
      label: FirstLatest,
      value: _studentConstants.HIGHEST_VS_LATEST
    }, {
      label: HighestLatest,
      value: _studentConstants.FIRST_VS_HIGHEST
    }];
    _this.state = {
      selected: props.initialSelection
    };
    return _this;
  }
  _inherits(ImprovementTypePicker, _Component);
  return _createClass(ImprovementTypePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var selected = this.state.selected;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _improvementTypePicker["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _improvementTypePicker["default"]['option-container']
      }, this.improvements.map(function (improvement) {
        return /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
          key: improvement.value,
          className: _improvementTypePicker["default"].option,
          value: improvement.value,
          label: improvement.label,
          selected: selected === improvement.value,
          onSelect: _this2.selectOption
        });
      })));
    }
  }]);
}(_react.Component);
_defineProperty(ImprovementTypePicker, "propTypes", {
  initialSelection: _propTypes["default"].string,
  pickImprovementType: _propTypes["default"].func.isRequired
});
var _default = exports["default"] = ImprovementTypePicker;

/***/ }),

/***/ "2y4p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exportActivityMasteryReport;
var _constants = __webpack_require__("1QGX");
var _activityMasteryDataConverter = _interopRequireDefault(__webpack_require__("Qaas"));
var _exportReportActions = __webpack_require__("oXgP");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Calculates the export parameters needed for the current activity mastery report
 */
function exportActivityMasteryReport(getState, reportLevel) {
  var state = getState();
  var activityMasteryAllClasses = state.activityMasteryAllClasses,
    activityMasterySingleClass = state.activityMasterySingleClass,
    activityMasteryStudent = state.activityMasteryStudent;
  var selectedDate = _activeFiltersSelectors["default"].selectDate(state);
  var resourcesMethod = _exportReportActions.EXPORT_RESOURCE_METHODS[reportLevel];
  var params = {
    reportType: _constants.ENDPOINT_PATH_ACTIVITY_MASTERY,
    fileFormat: _exportReportActions.FILE_FORMAT.PDF
  };
  var data;
  switch (reportLevel) {
    case _exportReportActions.REPORT_LEVEL_ALL_YEARS:
    case _exportReportActions.REPORT_LEVEL_ALL_CLASSES:
    case _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER:
      {
        data = _activityMasteryDataConverter["default"].convertAllClasses(activityMasteryAllClasses, selectedDate, _activeFiltersSelectors["default"].selectExportReportHeading(state), reportLevel === _exportReportActions.REPORT_LEVEL_ALL_YEARS);
        if (reportLevel === _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER) {
          params.yearGroupId = _activeFiltersSelectors["default"].selectYearGroupIdForApi(state);
          params.teacherId = _activeFiltersSelectors["default"].selectTeacherIdForApi(state);
        }
        break;
      }
    case _exportReportActions.REPORT_LEVEL_SINGLE_CLASS:
    case _exportReportActions.REPORT_LEVEL_GROUP:
      data = _activityMasteryDataConverter["default"].convertSingleClass(activityMasterySingleClass, selectedDate, reportLevel === _exportReportActions.REPORT_LEVEL_GROUP ? _activeFiltersSelectors["default"].selectGroupId(state) : null);
      params.classroomId = _activeFiltersSelectors["default"].selectClassId(state);
      break;
    case _exportReportActions.REPORT_LEVEL_STUDENT:
      {
        var selectedStudent = _activeFiltersSelectors["default"].selectStudent(state);
        data = _activityMasteryDataConverter["default"].convertStudent(activityMasteryStudent, selectedDate, selectedStudent);
        params.classroomId = _activeFiltersSelectors["default"].selectClassId(state);
        params.userProfileId = selectedStudent.id;
        break;
      }
    default:
  }
  return {
    data: data,
    resourcesMethod: resourcesMethod,
    params: params
  };
}

/***/ }),

/***/ "2z6x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// For local development, we can use mock-rest-server (or a similar REST server like json-server)
//
// You should be able to use this code as is, apart from perhaps changing MOCK_SERVICE_PORT to whatever
// port you're using for your mock server.

var MOCK_SERVICES_PORT = 4321; // TODO: 2. DEFINE THE PORT YOUR MOCK SERVER IS LISTENING ON

var MOCK_SERVICES_HOST = 'localhost';
var MOCK_SERVICES_URL = "http://".concat(MOCK_SERVICES_HOST, ":").concat(MOCK_SERVICES_PORT);

// The app's configuration will have a base URL for each service we use.  For local testing, we define
// the configuration to point to our local server.
//
// For each resource, we have a constant for the base URL, as it would be in production. For example,
// below we have "AvatarAdminBaseUrl" which represents the base of the URL for access to all of
// the Avatar Admin application's resources.  Replace that with the resource(s) your application uses.

var localConfig = {
  BaseName: '',
  AvatarAdminBaseUrl: "".concat(MOCK_SERVICES_URL, "/avatar/v1") // TODO: 3. REPLACE THIS WITH YOUR ACTUAL SERVICES
};
var _default = exports["default"] = localConfig;

/***/ }),

/***/ "32hn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _sessionIdActions = _interopRequireDefault(__webpack_require__("KYjY"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Handles intercepting responses and saving sessionId and intercepting requests and
 * appending sessionId query param
 */
var SessionIdHelper = exports["default"] = /*#__PURE__*/function () {
  function SessionIdHelper() {
    _classCallCheck(this, SessionIdHelper);
  }
  return _createClass(SessionIdHelper, null, [{
    key: "addInterceptors",
    value: function addInterceptors(store) {
      var reqInterceptor = this.appendSessionIdQueryParam.bind(this, store);
      var resInterceptor = this.saveSessionId.bind(this, store);
      _resources["default"].env.addRequestInterceptor(reqInterceptor);
      _resources["default"].env.addResponseInterceptor(resInterceptor);
    }
  }, {
    key: "appendSessionIdQueryParam",
    value: function appendSessionIdQueryParam(store, verb) {
      if (verb.url.indexOf('@StudentReportsGatewayBaseUrl') === 0) {
        var _store$getState = store.getState(),
          sessionId = _store$getState.sessionId;
        if (sessionId) {
          verb.withParams(_objectSpread(_objectSpread({}, verb.parameters), {}, {
            sessionId: sessionId
          }));
        }
      }
    }
  }, {
    key: "saveSessionId",
    value: function saveSessionId(store, response) {
      if (response.valid && response.data) {
        var sessionId = response.data.sessionId;
        if (sessionId) {
          if (store.getState().sessionId !== sessionId) {
            store.dispatch(_sessionIdActions["default"].setSessionId(sessionId));
          }
        }
      }
      return response;
    }
  }]);
}();

/***/ }),

/***/ "3C4M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
__webpack_require__("nIya");
var _badge = _interopRequireDefault(__webpack_require__("FOJt"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Badge = function Badge(_ref) {
  var _ref$background = _ref.background,
    background = _ref$background === void 0 ? '' : _ref$background,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _badge["default"]['badge-style'],
    style: {
      background: "".concat(background)
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, content)));
};
Badge.propTypes = {
  content: _propTypes["default"].string,
  background: _propTypes["default"].string
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_badge["default"])(Badge);

/***/ }),

/***/ "3Nfy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadPickerTranslation = void 0;
var _localeHelpers = __webpack_require__("rjLd");
var downloadPickerTranslation = exports.downloadPickerTranslation = function downloadPickerTranslation() {
  return {
    headerSelectText: (0, _localeHelpers.translate)('Download Picker - Please select the style of the report required.'),
    headerWarningText: (0, _localeHelpers.translate)('Download Picker - (NOTE: Large reports may take several minutes to download)'),
    reportFormatHeaderText: (0, _localeHelpers.translate)('Download Picker - Report Format *'),
    reportFormatFooterText: (0, _localeHelpers.translate)('Download Picker - * Required Selection'),
    reportTypeHeaderText: (0, _localeHelpers.translate)('Download Picker - Report Style *')
  };
};

/***/ }),

/***/ "3PpY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UPDATE_ACTIVE_FILTER = exports.SET_ACTIVE_FILTERS = void 0;
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SET_ACTIVE_FILTERS = exports.SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS';
var UPDATE_ACTIVE_FILTER = exports.UPDATE_ACTIVE_FILTER = 'UPDATE_ACTIVE_FILTER';

/**
 * Set all active filters
 * Values not provided will retain their current value
 */
function setActiveFilters(filters) {
  return function (dispatch, getState) {
    var selectedDate = filters[_filterConstants.SELECTED_DATE];
    if (selectedDate) {
      filters[_filterConstants.SELECTED_DATE] = validateDate(selectedDate, getState().academicYear);
    }
    dispatch({
      type: SET_ACTIVE_FILTERS,
      payload: filters
    });
  };
}

/**
 * Update one active filter to the specified value
 */
function updateActiveFilter(filterName, filterValue) {
  return function (dispatch, getState) {
    if (filterName === _filterConstants.SELECTED_DATE) {
      filterValue = validateDate(filterValue, getState().academicYear);
    }
    dispatch({
      type: UPDATE_ACTIVE_FILTER,
      payload: {
        filterName: filterName,
        filterValue: filterValue
      }
    });
  };
}
function setFiltersFromSelectedOptions() {
  return function (dispatch, getState) {
    var selectedOptions = _dropdownDataSelectors["default"].selectAllSelectedOptions(getState());
    dispatch(setActiveFilters(selectedOptions));
  };
}

/**
 * Enforces correct start/end dates for non-custom date ranges
 */
function validateDate(selectedDate, academicYear) {
  var startDate = selectedDate.startDate,
    endDate = selectedDate.endDate;
  switch (selectedDate.type) {
    case _reactComponents.DatePicker.THIS_WEEK:
      var _DateHelper$getThisWe = _reactComponents.DateHelper.getThisWeekStartEnd();
      startDate = _DateHelper$getThisWe.startDate;
      endDate = _DateHelper$getThisWe.endDate;
      break;
    case _reactComponents.DatePicker.LAST_WEEK:
      var _DateHelper$getLastWe = _reactComponents.DateHelper.getLastWeekStartEnd();
      startDate = _DateHelper$getLastWe.startDate;
      endDate = _DateHelper$getLastWe.endDate;
      break;
    case _reactComponents.DatePicker.THIS_SCHOOL_YEAR:
    case _reactComponents.DatePicker.LIFETIME:
      startDate = academicYear.startDate;
      endDate = academicYear.endDate;
      break;
    default:
  }
  return {
    type: selectedDate.type,
    startDate: startDate,
    endDate: endDate
  };
}
var _default = exports["default"] = {
  setActiveFilters: setActiveFilters,
  updateActiveFilter: updateActiveFilter,
  setFiltersFromSelectedOptions: setFiltersFromSelectedOptions
};

/***/ }),

/***/ "3VuW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _allClassess = _interopRequireDefault(__webpack_require__("1dJ6"));
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _filterConstants = __webpack_require__("cdWI");
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ALL_CLASSES_SKILL_QUESTS_MASTERY_TABLE_CONFIG = {
  cols: [{
    id: _skillQuestsMasteryConstants.CLASS_NAME.id,
    name: _skillQuestsMasteryConstants.CLASS_NAME.name,
    sort: {
      sortAs: 'string'
    },
    truncate: true,
    onClick: function onClick() {
      return null;
    },
    // this is set in the AllClasses component
    classes: _allClassess["default"]['class-name']
  }, {
    id: _skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id,
    name: _skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.name,
    classes: _allClassess["default"]['completed-quests']
  }, {
    id: _skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id,
    name: ''
  }, {
    id: _skillQuestsMasteryConstants.STANDARDS_COMPLETED.id,
    name: ''
  }, {
    id: _skillQuestsMasteryConstants.ASSIGNED_QUESTS.id,
    name: ''
  }, {
    id: _skillQuestsMasteryConstants.COMPLETED_QUESTS.id,
    name: ''
  }],
  colGroups: [[{
    name: _filterConstants.SKILL_QUESTS_MASTERY,
    colIds: [_skillQuestsMasteryConstants.CLASS_NAME.id, _skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id],
    headerTransform: function headerTransform() {
      return /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: (0, _localeHelpers.getTranslationKey)(_filterConstants.SKILL_QUESTS_MASTERY),
        showButton: false,
        translate: true
      });
    },
    classes: _allClassess["default"]['dark-header']
  }, {
    name: _skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.name,
    colIds: [_skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id],
    classes: _allClassess["default"]['light-header']
  }, {
    name: _skillQuestsMasteryConstants.STANDARDS_COMPLETED.name,
    colIds: [_skillQuestsMasteryConstants.STANDARDS_COMPLETED.id],
    classes: _allClassess["default"]['light-header']
  }, {
    name: _skillQuestsMasteryConstants.ASSIGNED_QUESTS.name,
    colIds: [_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id],
    classes: _allClassess["default"]['light-header']
  }, {
    name: _skillQuestsMasteryConstants.COMPLETED_QUESTS.name,
    colIds: [_skillQuestsMasteryConstants.COMPLETED_QUESTS.id],
    classes: _allClassess["default"]['light-header']
  }]],
  defaultSort: _skillQuestsMasteryConstants.CLASS_NAME.id,
  emptyDataMessage: 'No Skill Quests Mastery results found'
};
var _default = exports["default"] = ALL_CLASSES_SKILL_QUESTS_MASTERY_TABLE_CONFIG;

/***/ }),

/***/ "3ZNE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _singleClassActions = __webpack_require__("9vuV");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  isLoading: false,
  data: null
};

/**
 * Skill Quests Mastery - Class Reducer
 *
 * Consumes SKILL_QUESTS_MASTERY_CLASS_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _singleClassActions.SKILL_QUESTS_MASTERY_CLASS_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true,
          data: null
        });
      }
    case _singleClassActions.SKILL_QUESTS_MASTERY_CLASS_RETRIEVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        data: action.payload
      });
    default:
      return state;
  }
}

/***/ }),

/***/ "4/C/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _activityMastery = _interopRequireDefault(__webpack_require__("8wuy"));
var _subHeading = _interopRequireDefault(__webpack_require__("tecg"));
var _reportRoutes = _interopRequireDefault(__webpack_require__("lXLQ"));
var _allClasses = _interopRequireDefault(__webpack_require__("8m3f"));
var _singleClass = _interopRequireDefault(__webpack_require__("xhvn"));
var _student = _interopRequireDefault(__webpack_require__("czp5"));
var _emptyState = _interopRequireDefault(__webpack_require__("e7yh"));
var _emptyStateConstants = _interopRequireDefault(__webpack_require__("pYuN"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ActivityMastery = function ActivityMastery() {
  var routeComps = {
    allClasses: _allClasses["default"],
    singleClass: _singleClass["default"],
    student: _student["default"]
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _activityMastery["default"].component
  }, /*#__PURE__*/_react["default"].createElement(_emptyState["default"], {
    variant: _emptyStateConstants["default"].NO_STUDENTS
  }, /*#__PURE__*/_react["default"].createElement(_reportRoutes["default"], {
    components: routeComps
  }, /*#__PURE__*/_react["default"].createElement(_subHeading["default"], {
    isExportEnabled: true
  }))));
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_activityMastery["default"])(ActivityMastery);

/***/ }),

/***/ "4Hqn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".button---2FK0U {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 220px;\n  height: 40px;\n  margin-right: 15px;\n  border-radius: 40px;\n  color: #fff;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(103.65deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%);\n  cursor: pointer; }\n  .button---2FK0U .icon---6rIcc {\n    width: 16px;\n    height: 16px;\n    margin-right: 8px; }\n  .button---2FK0U[disabled] {\n  cursor: default; }\n", ""]);

// exports
exports.locals = {
	"button": "button---2FK0U",
	"icon": "icon---6rIcc"
};

/***/ }),

/***/ "4doL":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("nfN5");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./progress-bar.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./progress-bar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "54Df":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED = exports.SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST = void 0;
var _constants = __webpack_require__("1QGX");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED = exports.SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED = 'SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED';
var SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST = exports.SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST = 'SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST';
function getSkillQuestsMasteryData(selectedDate, selectedYearGroupId, selectedTeacherId, assignmentResultType) {
  return function (dispatch, getState) {
    var state = getState();
    if (state.isAdmin === true) {
      getAdminData(dispatch, selectedDate, selectedYearGroupId, selectedTeacherId, assignmentResultType);
    } else {
      getTeacherData(dispatch, selectedDate, assignmentResultType);
    }
  };
}
function getAdminData(dispatch, selectedDate, selectedYearGroupId, selectedTeacherId, assignmentResultType) {
  var yearGroupId = _constants.ENDPOINT_PATH_ALL_YEARS;
  var teacherId = _constants.ENDPOINT_PATH_ALL_TEACHERS;
  var resource = 'yearGroupReport';
  if (selectedYearGroupId !== null && selectedYearGroupId !== _filterConstants.ALL_YEARS) {
    yearGroupId = selectedYearGroupId;
  }
  if (selectedTeacherId !== null && selectedTeacherId !== _filterConstants.ALL_TEACHERS) {
    teacherId = selectedTeacherId;
    resource = 'teacherReport';
  }
  var pathParams = _objectSpread(_objectSpread({
    reportType: _constants.ENDPOINT_PATH_SKILL_QUESTS_MASTERY
  }, _dateParamHelper["default"].getDateTypePath(selectedDate)), {}, {
    yearGroupId: yearGroupId,
    teacherId: teacherId
  });
  var queryParams = _objectSpread(_objectSpread({}, _dateParamHelper["default"].getDateQueryParams(selectedDate)), {}, {
    assignmentResultType: assignmentResultType
  });
  getData({
    resource: resource,
    dispatch: dispatch,
    pathParams: pathParams,
    queryParams: queryParams
  });
}
function getTeacherData(dispatch, selectedDate, assignmentResultType) {
  var pathParams = _objectSpread({
    reportType: _constants.ENDPOINT_PATH_SKILL_QUESTS_MASTERY
  }, _dateParamHelper["default"].getDateTypePath(selectedDate));
  var queryParams = _objectSpread(_objectSpread({}, _dateParamHelper["default"].getDateQueryParams(selectedDate)), {}, {
    assignmentResultType: assignmentResultType
  });
  getData({
    resource: 'allClassesReport',
    dispatch: dispatch,
    pathParams: pathParams,
    queryParams: queryParams
  });
}
function manageData(data) {
  data.classes.map(function (classLevel) {
    classLevel.id = classLevel.classId;
    return classLevel;
  });
  return data;
}
function getData(_ref) {
  var resource = _ref.resource,
    dispatch = _ref.dispatch,
    pathParams = _ref.pathParams,
    queryParams = _ref.queryParams;
  dispatch({
    type: SKILL_QUESTS_MASTERY_ALL_CLASSES_REQUEST
  });
  _resources["default"][resource].get(pathParams).withParams(queryParams).send().then(function (payload) {
    // We need to add ids to class level to prevent console errors for DataTable display
    var returnedData = manageData(payload.data);
    dispatch({
      type: SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED,
      payload: returnedData
    });
  });
}
var _default = exports["default"] = {
  getSkillQuestsMasteryData: getSkillQuestsMasteryData
};

/***/ }),

/***/ "59Pb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BnJS");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./single-class.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./single-class.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "5Jg6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportSkillQuestsMasteryReport = exportSkillQuestsMasteryReport;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactComponents = __webpack_require__("fmgT");
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _exportReportActions = __webpack_require__("oXgP");
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _studentSelectors = _interopRequireDefault(__webpack_require__("kv6M"));
var _formatPicker = _interopRequireDefault(__webpack_require__("hfIg"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SKILL_QUESTS_EXPORT_FILE_TYPE = {
  PDF: 0,
  EXCEL: 1
};

/**
 * Switch statement manages sub heading export click handler
 * @param reportLevel
 * @param dispatch
 * @param state
 * @param i18n
 */
function exportSkillQuestsMasteryReport(reportLevel, dispatch, state, i18n) {
  var resourceMethod = '';
  var path = {};
  var selectedDate = _activeFiltersSelectors["default"].selectDate(state);
  var assignmentResultType = state.assignmentResultType;
  var isCustomDate = selectedDate.type === _reactComponents.DatePicker.CUSTOM_DATE;
  var query = {
    exportFileType: SKILL_QUESTS_EXPORT_FILE_TYPE.EXCEL,
    assignmentResultType: assignmentResultType,
    locale: (0, _localeHelpers.localeCode)()
  };
  switch (reportLevel) {
    case _exportReportActions.REPORT_LEVEL_ALL_CLASSES:
      {
        if (isCustomDate) {
          resourceMethod = _exportReportActions.SKILL_QUESTS_EXPORT_RESOURCE_METHODS.CLASSROOM_CUSTOM_DATE;
          query = _objectSpread(_objectSpread({}, query), {}, {
            startDate: selectedDate.startDate,
            endDate: selectedDate.endDate
          });
        } else {
          resourceMethod = _exportReportActions.SKILL_QUESTS_EXPORT_RESOURCE_METHODS.CLASSROOM;
        }
        break;
      }
    case _exportReportActions.REPORT_LEVEL_SINGLE_CLASS:
    case _exportReportActions.REPORT_LEVEL_GROUP:
      {
        path = {
          classroomId: _activeFiltersSelectors["default"].selectClassId(state)
        };
        if (isCustomDate) {
          resourceMethod = _exportReportActions.SKILL_QUESTS_EXPORT_RESOURCE_METHODS.GROUP_CUSTOM_DATE;
          query = _objectSpread(_objectSpread({}, query), {}, {
            startDate: selectedDate.startDate,
            endDate: selectedDate.endDate
          });
        } else {
          resourceMethod = _exportReportActions.SKILL_QUESTS_EXPORT_RESOURCE_METHODS.GROUP;
        }
        break;
      }
    case _exportReportActions.REPORT_LEVEL_STUDENT:
      {
        var _skillQuestsMasterySt = _studentSelectors["default"].selectCourseData(state),
          courseId = _skillQuestsMasterySt.courseId,
          courseVersion = _skillQuestsMasterySt.courseVersion;
        query = _objectSpread(_objectSpread({}, query), {}, {
          courseId: courseId,
          courseVersion: courseVersion
        });
        path = {
          classroomId: _activeFiltersSelectors["default"].selectClassId(state),
          userProfileId: _activeFiltersSelectors["default"].selectStudent(state).id
        };
        if (isCustomDate) {
          resourceMethod = _exportReportActions.SKILL_QUESTS_EXPORT_RESOURCE_METHODS.STUDENT_CUSTOM_DATE;
          query = _objectSpread(_objectSpread({}, query), {}, {
            startDate: selectedDate.startDate,
            endDate: selectedDate.endDate
          });
        } else {
          resourceMethod = _exportReportActions.SKILL_QUESTS_EXPORT_RESOURCE_METHODS.STUDENT;
        }
        break;
      }
    default:
      break;
  }
  var updateCallback = function updateCallback() {
    return getSkillQuestsReportData(resourceMethod, path, query);
  };
  dispatch(_modalActions["default"].openModal(getAllClassesModalContent(dispatch, updateCallback, i18n)));
}
function getAllClassesModalContent(dispatch, callback, i18n) {
  var text = {
    downloadText: i18n._(
    /*i18n*/
    {
      id: "Export - Download Skill Quests Mastery Report",
      defaults: "Download Skill Quests Mastery Report"
    }),
    cancelText: i18n._(
    /*i18n*/
    {
      id: "Export - Cancel",
      defaults: "Cancel"
    }),
    exportText: i18n._(
    /*i18n*/
    {
      id: "Export - Export",
      defaults: "Export"
    })
  };
  return {
    title: text.downloadText,
    content: /*#__PURE__*/_react["default"].createElement(_formatPicker["default"], null),
    buttons: [{
      text: text.cancelText,
      danger: true,
      handler: function handler() {
        return dispatch(_modalActions["default"].closeModal());
      }
    }, {
      text: text.exportText,
      primary: true,
      handler: function handler() {
        var action = callback();
        if (action) {
          dispatch(action);
          dispatch(_modalActions["default"].closeModal());
        }
      }
    }]
  };
}
function getSkillQuestsReportData(resourceMethod, path, query) {
  return _resources["default"][resourceMethod].get(path).withParams(query).send().then(function (payload) {
    if (payload.valid) {
      var authToken = _resources["default"].env.authToken;
      var updatedDownloadUrl = "".concat(payload.verb.url, "&authToken=").concat(authToken);
      return {
        type: _exportReportActions.REPORT_EXPORTED,
        payload: {
          downloadUrl: updatedDownloadUrl
        }
      };
    }
    return null;
  });
}

/***/ }),

/***/ "5YJm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("/k3W");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./skill-quests-mastery-legends.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./skill-quests-mastery-legends.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "5ceo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _icon_arrow_down = _interopRequireDefault(__webpack_require__("Njvy"));
var _icon_arrow_up = _interopRequireDefault(__webpack_require__("8TuU"));
var _participationImprovement = _interopRequireDefault(__webpack_require__("WBph"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays improvement in student participation tables when comparing 2 results (eg. first vs highest)
 */
var ParticipationImprovement = /*#__PURE__*/function (_Component) {
  function ParticipationImprovement() {
    var _this;
    _classCallCheck(this, ParticipationImprovement);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ParticipationImprovement, [].concat(args));
    _defineProperty(_this, "renderImprovementDifference", function (difference) {
      var isPositive = difference > 0;
      var icon = isPositive ? _icon_arrow_up["default"] : _icon_arrow_down["default"];
      var className = isPositive ? _participationImprovement["default"].positive : _participationImprovement["default"].negative;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
        className: _participationImprovement["default"]['arrow-icon'],
        src: icon,
        cacheGetRequests: true
      }), Math.abs(difference), "%");
    });
    return _this;
  }
  _inherits(ParticipationImprovement, _Component);
  return _createClass(ParticipationImprovement, [{
    key: "renderImprovement",
    value: function renderImprovement() {
      var improvement = this.props.improvement;
      var na = window.i18n._('Label - NA');
      switch (improvement) {
        case null:
        case undefined:
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _participationImprovement["default"]['null-improvement']
          }, na);
        case 0:
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _participationImprovement["default"].equal
          }, "=");
        default:
          return this.renderImprovementDifference(improvement);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _participationImprovement["default"].component
      }, this.renderImprovement());
    }
  }]);
}(_react.Component);
_defineProperty(ParticipationImprovement, "propTypes", {
  improvement: _propTypes["default"].number
});
var _default = exports["default"] = (0, _reactStyleable["default"])(_participationImprovement["default"])(ParticipationImprovement);

/***/ }),

/***/ "5tmF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8m9E");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./topic-box.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./topic-box.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6FHb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Vx94");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./participation-result.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./participation-result.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6FKu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _strengthWeaknessTopic = _interopRequireDefault(__webpack_require__("fwiS"));
var _strengthAndWeaknessesConstants = __webpack_require__("EaW9");
var _badge = _interopRequireDefault(__webpack_require__("3C4M"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays a strength/weakness topic with its result in a coloured badge
 */
var StrengthWeaknessTopic = /*#__PURE__*/function (_Component) {
  function StrengthWeaknessTopic() {
    var _this;
    _classCallCheck(this, StrengthWeaknessTopic);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StrengthWeaknessTopic, [].concat(args));
    _defineProperty(_this, "getBackgroundColor", function (range) {
      if (range >= 86 && range <= 100) {
        return _strengthAndWeaknessesConstants.SCORE_BAND_COLOURS.MASTERED;
      } else if (range >= 66 && range <= 85) {
        return _strengthAndWeaknessesConstants.SCORE_BAND_COLOURS.CONSOLIDATING;
      } else if (range >= 50 && range <= 65) {
        return _strengthAndWeaknessesConstants.SCORE_BAND_COLOURS.DEVELOPING;
      } else if (range >= 26 && range <= 49) {
        return _strengthAndWeaknessesConstants.SCORE_BAND_COLOURS.EMERGING;
      } else if (range >= 0 && range <= 25) {
        return _strengthAndWeaknessesConstants.SCORE_BAND_COLOURS.POOR;
      }
      return _strengthAndWeaknessesConstants.SCORE_BAND_COLOURS.DEFAULT;
    });
    return _this;
  }
  _inherits(StrengthWeaknessTopic, _Component);
  return _createClass(StrengthWeaknessTopic, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        topicName = _this$props.topicName,
        result = _this$props.result;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _strengthWeaknessTopic["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _strengthWeaknessTopic["default"].title
      }, topicName), /*#__PURE__*/_react["default"].createElement(_badge["default"], {
        content: "".concat(result, "%"),
        background: this.getBackgroundColor(result)
      }));
    }
  }]);
}(_react.Component);
_defineProperty(StrengthWeaknessTopic, "propTypes", {
  topicName: _propTypes["default"].string,
  result: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
});
_defineProperty(StrengthWeaknessTopic, "defaultProps", {
  topicName: '',
  result: '-'
});
var _default = exports["default"] = (0, _reactStyleable["default"])(_strengthWeaknessTopic["default"])(StrengthWeaknessTopic);

/***/ }),

/***/ "6Iqk":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".container---Fh154 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin: 20px 0 !important;\n  -webkit-box-shadow: 0 1px 4px 1px rgba(0, 25, 55, .1), 0 1px 8px 1px rgba(0, 25, 55, 0);\n          box-shadow: 0 1px 4px 1px rgba(0, 25, 55, .1), 0 1px 8px 1px rgba(0, 25, 55, 0);\n  border-radius: 16px;\n  height: 106px;\n  min-height: 106px; }\n  .container---Fh154 .block---1Xmm2 {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 25%;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    padding: 8px 10px 4px;\n    text-align: center;\n    border-right: 1px solid #dbe0e6; }\n  .container---Fh154 .block---1Xmm2:last-child {\n      border-right: none; }\n  .container---Fh154 .block---1Xmm2 .info---1-NPK {\n      font-size: 30px;\n      line-height: 30.8px;\n      font-weight: 400;\n      letter-spacing: -1.2px;\n      background: -webkit-gradient(linear, left top, right top, color-stop(-29.84%, #0fc5ff), color-stop(57.66%, #1a73e8));\n      background: linear-gradient(90deg, #0fc5ff -29.84%, #1a73e8 57.66%);\n      -webkit-text-fill-color: transparent;\n      background-clip: text; }\n  .container---Fh154 .block---1Xmm2 .title---3d94S {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 20.8px;\n      color: #00336f;\n      margin-top: 8px;\n      color: #00336f; }\n  .container---Fh154 .goldBar---2f0rH {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    width: 25%;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    padding: 8px 10px 4px;\n    text-align: center;\n    border-right: 1px solid #dbe0e6; }\n  .container---Fh154 .goldBar---2f0rH .info---1-NPK {\n      font-size: 30px;\n      line-height: 30.8px;\n      font-weight: 400;\n      letter-spacing: -1.2px;\n      background: -webkit-gradient(linear, left top, right top, color-stop(-29.84%, #f5bc23), color-stop(57.66%, #fb700f));\n      background: linear-gradient(90deg, #f5bc23 -29.84%, #fb700f 57.66%);\n      -webkit-text-fill-color: transparent;\n      background-clip: text; }\n  .container---Fh154 .goldBar---2f0rH .title---3d94S {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 20.8px;\n      color: #00336f;\n      margin-top: 8px;\n      background: -webkit-gradient(linear, left top, right top, color-stop(-29.84%, #f5bc23), color-stop(57.66%, #fb700f));\n      background: linear-gradient(90deg, #f5bc23 -29.84%, #fb700f 57.66%);\n      -webkit-text-fill-color: transparent;\n      background-clip: text; }\n", ""]);

// exports
exports.locals = {
	"container": "container---Fh154",
	"block": "block---1Xmm2",
	"info": "info---1-NPK",
	"title": "title---3d94S",
	"goldBar": "goldBar---2f0rH"
};

/***/ }),

/***/ "6MX9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _invalidRequestActions = __webpack_require__("oHUn");
var initialState = null;

/**
 * Invalid Request Reducer
 *
 * Consumes INVALID_REQUEST_MADE action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {string} - the action type
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _invalidRequestActions.INVALID_REQUEST_MADE:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "6QRH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfiguration = getConfiguration;
exports.getHasNoStudents = void 0;
exports.handleDefaults = handleDefaults;
exports.isDefined = isDefined;
exports.isEmptyArray = isEmptyArray;
exports.log = log;
exports.moveItemToFrontArray = moveItemToFrontArray;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function handleDefaults(defaultObj, dynamicObj) {
  for (var key in dynamicObj) {
    defaultObj[key] = dynamicObj[key];
  }
  return defaultObj;
}
function isEmptyArray(arr) {
  return arr.length === 0;
}
function moveItemToFrontArray(array, selector, value) {
  var selectedItem;
  if (array.length > 0 && value) {
    array = array.filter(function (item) {
      if (item[selector] === value) {
        selectedItem = item;
      }
      return item[selector] !== value;
    });
    array.unshift(selectedItem);
  }
  return array;
}
function isDefined(x) {
  return x !== undefined && x !== null;
}
function getConfiguration(_x) {
  return _getConfiguration.apply(this, arguments);
}
function _getConfiguration() {
  _getConfiguration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(name) {
    var windowObject, config, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          windowObject = _resources["default"].env.configuration.values;
          if (!isDefined(windowObject[name])) {
            _context.n = 1;
            break;
          }
          _t = JSON.parse(windowObject[name]);
          _context.n = 3;
          break;
        case 1:
          _context.n = 2;
          return _resources["default"].env.getConfigurationItem(name);
        case 2:
          _t = _context.v;
        case 3:
          config = _t;
          return _context.a(2, config);
      }
    }, _callee);
  }));
  return _getConfiguration.apply(this, arguments);
}
var getHasNoStudents = exports.getHasNoStudents = function getHasNoStudents(activeFilters, allClasses) {
  var selectedClassId = activeFilters[_filterConstants.SELECTED_CLASS].id;
  var result = allClasses.find(function (item) {
    return item.id === selectedClassId;
  });
  if (result) return result.isClassEmpty;
  return false;
};
function log() {}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "7NtK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RESET_LIVE_MATHS_LEVEL = exports.PICK_LIVE_MATHS_LEVEL = void 0;
var _reduxActions = __webpack_require__("sTbe");
var PICK_LIVE_MATHS_LEVEL = exports.PICK_LIVE_MATHS_LEVEL = 'PICK_LIVE_MATHS_LEVEL';
var RESET_LIVE_MATHS_LEVEL = exports.RESET_LIVE_MATHS_LEVEL = 'RESET_LIVE_MATHS_LEVEL';
var pickLevel = (0, _reduxActions.createAction)(PICK_LIVE_MATHS_LEVEL);
var resetLevel = (0, _reduxActions.createAction)(RESET_LIVE_MATHS_LEVEL);
var _default = exports["default"] = {
  pickLevel: pickLevel,
  resetLevel: resetLevel
};

/***/ }),

/***/ "7jvZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(_ref) {
  var i18n = _ref.i18n;
  return {
    CLASS_GROUP_81_TO_100_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Class Group 80 to 100",
      defaults: "81-100%"
    }),
    CLASS_GROUP_61_TO_80_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Class Group 61 to 80",
      defaults: "61-80%"
    }),
    CLASS_GROUP_41_TO_60_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Class Group 41 to 60",
      defaults: "41-60%"
    }),
    CLASS_GROUP_21_TO_40_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Class Group 21 to 40",
      defaults: "21-40%"
    }),
    CLASS_GROUP_1_TO_20_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Class Group 1 to 20",
      defaults: "1-20%"
    }),
    STUDENT_PROGRESS_100_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Progress 100",
      defaults: "100% complete"
    }),
    STUDENT_PROGRESS_81_TO_99_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Progress 81 to 99",
      defaults: "81-99%"
    }),
    STUDENT_PROGRESS_61_TO_80_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Progress 61 to 80",
      defaults: "61-80%"
    }),
    STUDENT_PROGRESS_41_TO_60_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Progress 41 to 60",
      defaults: "41-60%"
    }),
    STUDENT_PROGRESS_21_TO_40_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Progress 21 to 40",
      defaults: "21-40%"
    }),
    STUDENT_PROGRESS_1_TO_20_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Progress 1 to 20",
      defaults: "1-20%"
    }),
    STUDENT_ACCURACY_COMPLETE_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Accuracy Complete",
      defaults: "Complete"
    }),
    STUDENT_ACCURACY_81_TO_100_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Accuracy 81 to 100",
      defaults: "81-100%"
    }),
    STUDENT_ACCURACY_61_TO_80_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Accuracy 61 to 80",
      defaults: "61-80%"
    }),
    STUDENT_ACCURACY_41_TO_60_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Accuracy 41 to 60",
      defaults: "41-60%"
    }),
    STUDENT_ACCURACY_21_TO_40_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Accuracy 21 to 40",
      defaults: "21-40%"
    }),
    STUDENT_ACCURACY_1_TO_20_TEXT: i18n._(
    /*i18n*/
    {
      id: "Skill Quests Mastery Legends - Student Accuracy 1 to 20",
      defaults: "1-20%"
    })
  };
};

/***/ }),

/***/ "7qIq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jq2L");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./date-picker-trans.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./date-picker-trans.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "8/AG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _participationResult = _interopRequireDefault(__webpack_require__("6FHb"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays result or avg. result in student participation tables
 */
var ParticipationResult = /*#__PURE__*/function (_Component) {
  function ParticipationResult() {
    _classCallCheck(this, ParticipationResult);
    return _callSuper(this, ParticipationResult, arguments);
  }
  _inherits(ParticipationResult, _Component);
  return _createClass(ParticipationResult, [{
    key: "isResultNA",
    value: function isResultNA() {
      return this.props.result == null;
    }
  }, {
    key: "renderPercent",
    value: function renderPercent() {
      var result = this.props.result;
      var className = _participationResult["default"].attempt;
      if (this.isResultNA()) {
        className += " ".concat(_participationResult["default"]['null-attempt']);
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, /*#__PURE__*/_react["default"].createElement("span", null, this.isResultNA() ? '- ' : result), /*#__PURE__*/_react["default"].createElement("span", {
        className: _participationResult["default"].percent
      }, "%"));
    }
  }, {
    key: "render",
    value: function render() {
      var isAverage = this.props.isAverage;
      var na = window.i18n._('Label - NA');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _participationResult["default"].component
      }, this.isResultNA() && isAverage === true ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _participationResult["default"]['null-attempt']
      }, na) : this.renderPercent(), isAverage === true && /*#__PURE__*/_react["default"].createElement("div", {
        className: _participationResult["default"].avg
      }, "Avg"));
    }
  }]);
}(_react.Component);
_defineProperty(ParticipationResult, "propTypes", {
  result: _propTypes["default"].number,
  isAverage: _propTypes["default"].bool
});
var _default = exports["default"] = (0, _reactStyleable["default"])(_participationResult["default"])(ParticipationResult);

/***/ }),

/***/ "8m3f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AllClasses = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _reactComponents = __webpack_require__("fmgT");
var _allClasses = _interopRequireDefault(__webpack_require__("jf7A"));
var _allClassesActions = _interopRequireWildcard(__webpack_require__("jSO5"));
var _allClassesConstants = __webpack_require__("Xepm");
var _strengthAndWeaknessesConstants = __webpack_require__("EaW9");
var _activityStatusBar = _interopRequireDefault(__webpack_require__("jJ7R"));
var _activityMasteryPropType = __webpack_require__("+NxA");
var _allClassesStrengthWeakness = _interopRequireDefault(__webpack_require__("aCEn"));
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _routeHelper = _interopRequireDefault(__webpack_require__("H7F4"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _activityMasteryLegends = _interopRequireDefault(__webpack_require__("S6Bi"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AllClasses component
 * Displays Activity Mastery table and strengths & weaknesses tabs for all classes
 */
var AllClasses = exports.AllClasses = /*#__PURE__*/function (_Component) {
  function AllClasses(_props) {
    var _this;
    _classCallCheck(this, AllClasses);
    _this = _callSuper(this, AllClasses, [_props]);
    _defineProperty(_this, "getAllClassesActivityMasteryData", function (props) {
      var activeFilters = props.activeFilters,
        getActivityMasteryData = props.getActivityMasteryData;
      _this.setRouteType(props);
      getActivityMasteryData(activeFilters[_filterConstants.SELECTED_DATE], activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id, activeFilters[_filterConstants.SELECTED_TEACHER].id);
    });
    /**
     * Create table config by merging the data returned by the backend with
     * the TABLE_CONFIG constant
     * Some config is dependant on backend values, like the total activities column
     * header which displays the total number of all activities rather than a static string
     */
    _defineProperty(_this, "setTableConfig", function (props) {
      var activityMasteryData = props.activityMasteryData;
      if (!activityMasteryData) {
        return;
      }
      var allClassesActivityMastery = activityMasteryData.allClassesActivityMastery;
      var tableConfig;
      if (_this.isAllYearsRoute) {
        tableConfig = (0, _cloneDeep["default"])(_allClassesConstants.ALL_YEARS_TABLE_CONFIG);
      } else {
        tableConfig = (0, _cloneDeep["default"])(_allClassesConstants.ALL_CLASSES_TABLE_CONFIG);
      }

      // hide back button on landing page
      if (_this.isLandingPage) {
        tableConfig.colGroups[0][0].headerTransform = function () {
          return /*#__PURE__*/_react["default"].createElement("h3", null, _this.i18n._('Table Header - Activity Mastery'));
        };
      }
      var filterKey = _this.isAllYearsRoute ? _allClassesConstants.CLASS_ID : _allClassesConstants.CLASS_NAME;
      tableConfig.cols.find(function (col) {
        return col.id === filterKey;
      }).onClick = _this.loadItemPage;
      tableConfig.cols.find(function (col) {
        return col.id === _allClassesConstants.TOTAL_ACTIVITIES;
      }).name = "".concat(allClassesActivityMastery.totalActivities);
      tableConfig.cols.find(function (col) {
        return col.id === _allClassesConstants.ACTIVITY_RESULTS;
      }).headerTransform = function () {
        return /*#__PURE__*/_react["default"].createElement(_activityStatusBar["default"], {
          activityMastery: allClassesActivityMastery
        });
      };
      tableConfig = (0, _localeHelpers.translateTableLabels)(tableConfig);
      _this.setState({
        tableConfig: tableConfig
      });
    });
    _defineProperty(_this, "loadItemPage", function (selectedItem) {
      var itemType = _this.isAllYearsRoute ? _filterConstants.SELECTED_YEAR_GROUP : _filterConstants.SELECTED_CLASS;
      _this.props.updateActiveFilter(itemType, {
        id: selectedItem.id,
        name: selectedItem.name
      });
    });
    _this.isLandingPage = true;
    _this.isAllYearsRoute = false;
    _this.state = {
      tableConfig: _allClassesConstants.ALL_CLASSES_TABLE_CONFIG,
      strengthWeaknessTableConfig: _strengthAndWeaknessesConstants.ALL_CLASSES_STRENGTH_WEAKNESSES_TABLE_CONFIG,
      strengthData: [],
      weaknessData: []
    };
    _this.setRouteType(_props, true);
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(AllClasses, _Component);
  return _createClass(AllClasses, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeFilters = this.props.activeFilters;
      if (_filterHelper["default"].shouldLoadAllClasses(activeFilters)) {
        this.getAllClassesActivityMasteryData(this.props);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props = this.props,
        activeFilters = _this$props.activeFilters,
        activityMasteryData = _this$props.activityMasteryData,
        invalidRequest = _this$props.invalidRequest,
        updateActiveFilter = _this$props.updateActiveFilter,
        isAdmin = _this$props.isAdmin;
      var newActiveFilters = newProps.activeFilters,
        newActivityMasteryData = newProps.activityMasteryData,
        newInvalidRequest = newProps.invalidRequest,
        newIsAdmin = newProps.isAdmin;

      // load activity mastery data if params change
      if (_filterHelper["default"].shouldReloadAllClasses(activeFilters, newActiveFilters)) {
        this.getAllClassesActivityMasteryData(newProps);
      }
      if (activeFilters !== newActiveFilters || isAdmin !== newIsAdmin) {
        this.setRouteType(newProps);
      }

      // set config when activity mastery data is returned from backend
      if (activityMasteryData !== newActivityMasteryData) {
        this.setTableConfig(newProps);
        this.setState({
          strengthData: newActivityMasteryData.courseStrengths,
          weaknessData: newActivityMasteryData.courseWeaknesses
        });
      }
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _allClassesActions.ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "setStrengthWeaknessTableConfig",
    value: function setStrengthWeaknessTableConfig() {
      var strengthWeaknessTableConfig = (0, _cloneDeep["default"])(_strengthAndWeaknessesConstants.ALL_CLASSES_STRENGTH_WEAKNESSES_TABLE_CONFIG);
      if (this.isAllYearsRoute) {
        strengthWeaknessTableConfig.cols[0].name = this.i18n._('Export - All years');
      }
      this.setState({
        strengthWeaknessTableConfig: strengthWeaknessTableConfig
      });
    }
  }, {
    key: "setRouteType",
    value: function setRouteType(props, firstLoad) {
      var isAdmin = props.isAdmin,
        activeFilters = props.activeFilters;
      this.isLandingPage = _routeHelper["default"].isLandingPage(isAdmin, activeFilters);
      this.isAllYearsRoute = _routeHelper["default"].isAllYearsRoute(isAdmin, activeFilters);
      if (!firstLoad) {
        this.setTableConfig(props);
        this.setStrengthWeaknessTableConfig();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        tableConfig = _this$state.tableConfig,
        strengthWeaknessTableConfig = _this$state.strengthWeaknessTableConfig,
        strengthData = _this$state.strengthData,
        weaknessData = _this$state.weaknessData;
      var activityMasteryData = this.props.activityMasteryData;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_activityMasteryLegends["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClasses["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClasses["default"]['data-table']
      }, activityMasteryData && /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: tableConfig,
        data: activityMasteryData.classroomActivityMasterys
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClasses["default"]['strength-weakness']
      }, /*#__PURE__*/_react["default"].createElement(_allClassesStrengthWeakness["default"], {
        tableConfig: strengthWeaknessTableConfig,
        strengths: strengthData,
        weaknesses: weaknessData
      }))));
    }
  }]);
}(_react.Component);
_defineProperty(AllClasses, "propTypes", {
  activityMasteryData: _propTypes["default"].shape({
    allClassesActivityMastery: _activityMasteryPropType.activityMasteryPropType,
    courseStrengths: _propTypes["default"].arrayOf(_activityMasteryPropType.courseInsightPropType),
    courseWeaknesses: _propTypes["default"].arrayOf(_activityMasteryPropType.courseInsightPropType)
  }),
  activeFilters: _filterPropTypes.activeFiltersPropType,
  isAdmin: _propTypes["default"].bool,
  updateActiveFilter: _propTypes["default"].func,
  invalidRequest: _propTypes["default"].string,
  getActivityMasteryData: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    activityMasteryData: state.activityMasteryAllClasses,
    isAdmin: state.isAdmin,
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    invalidRequest: state.invalidRequest
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getActivityMasteryData: _allClassesActions["default"].getActivityMasteryData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_allClasses["default"])(AllClasses));

/***/ }),

/***/ "8m9E":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".learning-journey-box----G82I {\n  width: 20px;\n  height: 20px;\n  margin: 2px;\n  border-radius: 2px;\n  cursor: pointer;\n  position: relative; }\n  .learning-journey-box----G82I .box-context-modal---3jXk5 {\n    visibility: hidden;\n    opacity: 0;\n    display: none; }\n  .learning-journey-box----G82I:hover .box-context-modal---3jXk5 {\n    display: unset;\n    visibility: visible;\n    opacity: 1;\n    -webkit-transition: visibility 0s, opacity 0.2s linear;\n    transition: visibility 0s, opacity 0.2s linear;\n    left: -140px;\n    bottom: 30px;\n    width: 280px;\n    cursor: default; }\n  .learning-journey-box----G82I:hover .box-context-modal---3jXk5 p:first-child {\n      font-weight: bold;\n      margin-bottom: 5px; }\n  .learning-journey-box----G82I:last-child {\n    margin-right: 0; }\n  .learning-journey-box----G82I.NOT_ASSIGNED---2UU0Z, .learning-journey-box----G82I.ASSIGNED---2vsMG {\n    background-color: #fff;\n    border: 1px solid #778088; }\n  .learning-journey-box----G82I.IN_PROGRESS---Mk0EZ.RED---2xsk_ {\n    background-color: #c53902;\n    border: 1px solid #c53902; }\n  .learning-journey-box----G82I.IN_PROGRESS---Mk0EZ.ORANGE---2RIRz {\n    background-color: #e06d3f;\n    border: 1px solid #e06d3f; }\n  .learning-journey-box----G82I.IN_PROGRESS---Mk0EZ.DARK_BLUE---1L_OR {\n    background-color: #e89e13;\n    border: 1px solid #e89e13; }\n  .learning-journey-box----G82I.IN_PROGRESS---Mk0EZ.LIGHT_BLUE---3xUTa {\n    background-color: #81daab;\n    border: 1px solid #81daab; }\n  .learning-journey-box----G82I.IN_PROGRESS---Mk0EZ.GREEN---1fGao {\n    background-color: #37c97c;\n    border: 1px solid #37c97c; }\n  .learning-journey-box----G82I.COMPLETED---31XDq {\n    background-image: url(" + __webpack_require__("pACL") + ");\n    background-repeat: no-repeat;\n    background-size: 70% 70%;\n    background-position: center; }\n  .learning-journey-box----G82I.COMPLETED---31XDq.RED---2xsk_ {\n      background-color: #c53902;\n      border: 1px solid #c53902; }\n  .learning-journey-box----G82I.COMPLETED---31XDq.ORANGE---2RIRz {\n      background-color: #e06d3f;\n      border: 1px solid #e06d3f; }\n  .learning-journey-box----G82I.COMPLETED---31XDq.DARK_BLUE---1L_OR {\n      background-color: #e89e13;\n      border: 1px solid #e89e13; }\n  .learning-journey-box----G82I.COMPLETED---31XDq.LIGHT_BLUE---3xUTa {\n      background-color: #81daab;\n      border: 1px solid #81daab; }\n  .learning-journey-box----G82I.COMPLETED---31XDq.GREEN---1fGao {\n      background-color: #37c97c;\n      border: 1px solid #37c97c; }\n  .attempts---3iiSH {\n  margin-top: 5px; }\n  .attemptsContainer---xhGQQ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 15px; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD:hover .tooltip-wrapper---2HNMQ {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex; }\n  .tooltip-wrapper---2HNMQ .attemptsContainer---xhGQQ .wrapper---26ohD:hover .tooltip-wrapper---2HNMQ::before {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .circle---2iU39 {\n      width: 12px;\n      height: 12px;\n      border-radius: 50%;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .circle---2iU39.RED---2xsk_ {\n        background-color: #c53902; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .circle---2iU39.ORANGE---2RIRz {\n        background-color: #e06d3f; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .circle---2iU39.DARK_BLUE---1L_OR {\n        background-color: #e89e13; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .circle---2iU39.LIGHT_BLUE---3xUTa {\n        background-color: #81daab; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .circle---2iU39.GREEN---1fGao {\n        background-color: #37c97c; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .circle---2iU39:hover {\n        border: 1px solid #3b4e5e; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .connect-block---143FV {\n      background-color: #cfcfcf;\n      width: 5.5px;\n      height: 2.5px; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .is-focused-result---2IiKd {\n      margin-right: 1px;\n      width: 10px;\n      height: 10px;\n      border: 1px solid white;\n      -webkit-box-shadow: 0 0 0 1px #3b4e5e;\n              box-shadow: 0 0 0 1px #3b4e5e; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .is-focused-result---2IiKd:hover {\n        border: 1px solid white; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ {\n      display: none;\n      position: absolute;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      top: -30px;\n      left: -9px;\n      color: white;\n      font-size: 11px;\n      height: 23px; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ::before {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        bottom: -7px;\n        left: 15px;\n        content: '';\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n        border-left: 5px solid transparent;\n        border-right: 5px solid transparent;\n        border-top: 7px solid #3b4e5e;\n        margin-left: -5px; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ .assign-info---19FC7 {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        width: 130px;\n        height: 100%;\n        background-color: #3b4e5e;\n        color: white;\n        border-radius: 5px 0 0 5px; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ .accuracy-info---2ID_1 {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n        width: 30px;\n        height: 100%;\n        border-radius: 0 5px 5px 0;\n        color: white; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ .accuracy-info---2ID_1.RED---2xsk_ {\n          background-color: #c53902; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ .accuracy-info---2ID_1.ORANGE---2RIRz {\n          background-color: #e06d3f; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ .accuracy-info---2ID_1.DARK_BLUE---1L_OR {\n          background-color: #e89e13; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ .accuracy-info---2ID_1.LIGHT_BLUE---3xUTa {\n          background-color: #81daab; }\n  .attemptsContainer---xhGQQ .wrapper---26ohD .tooltip-wrapper---2HNMQ .accuracy-info---2ID_1.GREEN---1fGao {\n          background-color: #37c97c; }\n", ""]);

// exports
exports.locals = {
	"learning-journey-box": "learning-journey-box----G82I",
	"box-context-modal": "box-context-modal---3jXk5",
	"NOT_ASSIGNED": "NOT_ASSIGNED---2UU0Z",
	"ASSIGNED": "ASSIGNED---2vsMG",
	"IN_PROGRESS": "IN_PROGRESS---Mk0EZ",
	"RED": "RED---2xsk_",
	"ORANGE": "ORANGE---2RIRz",
	"DARK_BLUE": "DARK_BLUE---1L_OR",
	"LIGHT_BLUE": "LIGHT_BLUE---3xUTa",
	"GREEN": "GREEN---1fGao",
	"COMPLETED": "COMPLETED---31XDq",
	"attempts": "attempts---3iiSH",
	"attemptsContainer": "attemptsContainer---xhGQQ",
	"wrapper": "wrapper---26ohD",
	"tooltip-wrapper": "tooltip-wrapper---2HNMQ",
	"circle": "circle---2iU39",
	"connect-block": "connect-block---143FV",
	"is-focused-result": "is-focused-result---2IiKd",
	"assign-info": "assign-info---19FC7",
	"accuracy-info": "accuracy-info---2ID_1"
};

/***/ }),

/***/ "8wuy":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9C3n");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./activity-mastery.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./activity-mastery.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "95d/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("KsCg");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./student.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./student.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "95gl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _academicYearActions = __webpack_require__("mHLE");
var initialState = {
  startDate: null,
  endDate: null,
  year: null
};

/**
 * AcademicYear Reducer
 *
 * Consumes ACADEMIC_YEAR_RETRIEVED action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current start and end dates of academic year
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _academicYearActions.ACADEMIC_YEAR_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "98Ep":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STUDENT_TABLE_CONFIG = exports.STUDENT_FOOTER_DATA = exports.STUDENT_DISCLAIMER = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _student = _interopRequireDefault(__webpack_require__("iDSV"));
var _localeHelpers = __webpack_require__("rjLd");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var STUDENT_DISCLAIMER = exports.STUDENT_DISCLAIMER = 'Disclaimer Live Maths - Student';
var Q_PER_MIN = 'questionsPerMinute';
var TOTAL_CORRECT = 'totalCorrect';
var ACCURACY = 'accuracy';
var TOP_SCORE = 'topScore';
var generateColHeader = function generateColHeader(mainText, subText) {
  var i18n = window.i18n;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _student["default"]['col-header']
  }, /*#__PURE__*/_react["default"].createElement("span", null, i18n._(mainText)), subText && /*#__PURE__*/_react["default"].createElement("span", null, "(", i18n._(subText), ")"));
};
var STUDENT_TABLE_CONFIG = exports.STUDENT_TABLE_CONFIG = {
  cols: [{
    id: _filterConstants.LEVEL_LOWERCASE,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.LEVEL_LOWERCASE),
    doTranslation: true,
    classes: _student["default"].level
  }, {
    id: Q_PER_MIN,
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - QMin', 'Column Header - Avg');
    }
  }, {
    id: TOTAL_CORRECT,
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - Correct', 'Column Header - Total');
    }
  }, {
    id: ACCURACY,
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - Accuracy', 'Column Header - Avg');
    }
  }, {
    id: TOP_SCORE,
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - TopScore', 'Column Header - Lifetime');
    }
  }],
  footer: {
    cols: [{
      id: _filterConstants.LEVEL_LOWERCASE,
      footerDataId: _filterConstants.LEVEL_LOWERCASE
    }]
  },
  emptyDataMessage: 'Empty - LevelsWithResults'
};
var STUDENT_FOOTER_DATA = exports.STUDENT_FOOTER_DATA = 'Footer - MaxLevels';

/***/ }),

/***/ "9AQG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _downloadPicker = _interopRequireDefault(__webpack_require__("InLL"));
var _downloadPickerTranslation = __webpack_require__("3Nfy");
var _formatPickerActions = __webpack_require__("AzNC");
var _downloadReportActions = __webpack_require__("ylPA");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * DOWNLOAD PICKER
 * ----------------------------
 * Modal content on bulk classroom export click
 * @param reportTypes: Currently selected report types array
 * @param updateReportFormat: Action to manage report formats
 */
var DownloadPicker = /*#__PURE__*/function (_Component) {
  function DownloadPicker() {
    var _this;
    _classCallCheck(this, DownloadPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DownloadPicker, [].concat(args));
    _defineProperty(_this, "isInputSelected", function (type) {
      return _this.props.reportTypes.includes(type);
    });
    _defineProperty(_this, "renderCheckbox", function (reportType) {
      var key = "Download Picker - ".concat(reportType);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _downloadPicker["default"].selection
      }, /*#__PURE__*/_react["default"].createElement("input", {
        id: reportType,
        name: reportType,
        type: "checkbox",
        checked: _this.isInputSelected(reportType),
        onChange: function onChange() {
          return _this.props.updateReportSelection(reportType);
        }
      }), /*#__PURE__*/_react["default"].createElement("label", {
        htmlFor: reportType
      }, window.i18n._(key)));
    });
    return _this;
  }
  _inherits(DownloadPicker, _Component);
  return _createClass(DownloadPicker, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetReportSelections();
    }
  }, {
    key: "render",
    value: function render() {
      var _downloadPickerTransl = (0, _downloadPickerTranslation.downloadPickerTranslation)(),
        headerSelectText = _downloadPickerTransl.headerSelectText,
        headerWarningText = _downloadPickerTransl.headerWarningText,
        reportTypeHeaderText = _downloadPickerTransl.reportTypeHeaderText,
        reportFormatFooterText = _downloadPickerTransl.reportFormatFooterText;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _downloadPicker["default"]['download-modal-content']
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, headerSelectText), /*#__PURE__*/_react["default"].createElement("p", null, headerWarningText)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _downloadPicker["default"]['report-type']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _downloadPicker["default"].header
      }, reportTypeHeaderText), /*#__PURE__*/_react["default"].createElement("div", {
        className: _downloadPicker["default"]['selection-group']
      }, this.renderCheckbox(_filterConstants.PARTICIPATION), this.renderCheckbox(_filterConstants.ACTIVITY_MASTERY), this.renderCheckbox(_filterConstants.SKILL_QUESTS_MASTERY))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _downloadPicker["default"].footer
      }, reportFormatFooterText));
    }
  }]);
}(_react.Component);
_defineProperty(DownloadPicker, "propTypes", {
  reportTypes: _propTypes["default"].array,
  updateReportSelection: _propTypes["default"].func.isRequired,
  resetReportSelections: _propTypes["default"].func
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    reportFormats: state.formatReport.reportFormats,
    reportTypes: state.downloadReport.reportTypes
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    updateReportSelection: _downloadReportActions.updateReportSelection,
    updateReportFormat: _formatPickerActions.updateReportFormat,
    resetReportSelections: _downloadReportActions.resetReportSelections
  }, dispatch);
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_downloadPicker["default"])(DownloadPicker));

/***/ }),

/***/ "9C3n":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---2QikG {\n  height: 100%;\n  min-width: 1100px; }\n  .component---2QikG > div {\n    height: 100%; }\n  .component---2QikG .report-container---13JKm {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2QikG",
	"report-container": "report-container---13JKm"
};

/***/ }),

/***/ "9JZ4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _participation = _interopRequireDefault(__webpack_require__("0E9P"));
var _allClasses = _interopRequireDefault(__webpack_require__("Blrm"));
var _student = _interopRequireDefault(__webpack_require__("x/jf"));
var _subHeading = _interopRequireDefault(__webpack_require__("tecg"));
var _singleClass = _interopRequireDefault(__webpack_require__("pW+u"));
var _reportRoutes = _interopRequireDefault(__webpack_require__("lXLQ"));
var _emptyState = _interopRequireDefault(__webpack_require__("e7yh"));
var _emptyStateConstants = _interopRequireDefault(__webpack_require__("pYuN"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Participation = function Participation() {
  var routeComps = {
    allClasses: _allClasses["default"],
    singleClass: _singleClass["default"],
    student: _student["default"]
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _participation["default"].component
  }, /*#__PURE__*/_react["default"].createElement(_emptyState["default"], {
    variant: _emptyStateConstants["default"].NO_STUDENTS
  }, /*#__PURE__*/_react["default"].createElement(_reportRoutes["default"], {
    components: routeComps
  }, /*#__PURE__*/_react["default"].createElement(_subHeading["default"], {
    isExportEnabled: true,
    isParticipationReport: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _participation["default"]['report-container']
  }))));
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_participation["default"])(Participation);

/***/ }),

/***/ "9PoH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DatePicker = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _datePickerTrans = _interopRequireDefault(__webpack_require__("C6s8"));
var _localeHelpers = __webpack_require__("rjLd");
var _datePickerConstants = __webpack_require__("p2pT");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DatePicker = exports.DatePicker = /*#__PURE__*/function (_Component) {
  function DatePicker() {
    var _this;
    _classCallCheck(this, DatePicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DatePicker, [].concat(args));
    _defineProperty(_this, "getTranslatedOptions", function (options) {
      var i18n = window.i18n;
      if (i18n) {
        return options.map(function (item) {
          var label = i18n._("Date Filters - ".concat(item.value));
          item.label = label || item.value;
          return item;
        });
      }
      return options;
    });
    _defineProperty(_this, "calendarLocaleData", function () {
      var i18n = window.i18n;
      if (i18n) {
        return {
          'Label - StartDate': i18n._('Label - StartDate'),
          'Label - EndDate': i18n._('Label - EndDate'),
          'Label - Monday': i18n._('Label - Monday'),
          'Label - Sunday': i18n._('Label - Sunday')
        };
      }
      return {
        'Label - StartDate': 'Start Date',
        'Label - EndDate': 'End Date',
        'Label - Monday': 'Monday',
        'Label - Sunday': 'Sunday'
      };
    });
    return _this;
  }
  _inherits(DatePicker, _Component);
  return _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        academicYear = _this$props.academicYear,
        currentDate = _this$props.currentDate,
        onDateChange = _this$props.onDateChange,
        options = _this$props.options,
        initialDate = _this$props.initialDate;
      if (academicYear && currentDate && onDateChange) {
        return /*#__PURE__*/_react["default"].createElement(_datePickerTrans["default"], {
          currentDate: currentDate,
          options: this.getTranslatedOptions(options),
          academicYear: academicYear,
          onDateChange: onDateChange,
          locale: (0, _localeHelpers.localeCode)(),
          calendarLocaleData: this.calendarLocaleData(),
          initialDate: initialDate
        });
      }
      return null;
    }
  }]);
}(_react.Component);
_defineProperty(DatePicker, "contextTypes", {
  router: _propTypes["default"].object
});
_defineProperty(DatePicker, "propTypes", {
  academicYear: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }).isRequired,
  currentDate: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }).isRequired,
  onDateChange: _propTypes["default"].func.isRequired,
  initialDate: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }),
  /** Options to display in dropdown menu */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].oneOf(_datePickerConstants.DATE_OPTIONS)
  }).isRequired).isRequired
});
var _default = exports["default"] = DatePicker;

/***/ }),

/***/ "9XUN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".container---3sHdn {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%; }\n  .container---3sHdn .wrapper---1wzVf {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    height: 13px; }\n  .container---3sHdn .wrapper---1wzVf .button---3jUbB {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding: 4px 6px;\n      width: 34px;\n      border-radius: 20px;\n      background-color: #dcf4fd;\n      border: none;\n      height: 100%;\n      cursor: pointer; }\n  .container---3sHdn .wrapper---1wzVf .button---3jUbB .title---27OA6 {\n        min-width: 10px;\n        font-size: 11px;\n        font-weight: 500;\n        color: #0063a7;\n        line-height: 14px; }\n  .container---3sHdn .wrapper---1wzVf .button---3jUbB .icon---pu4v9 {\n        width: 12px;\n        -webkit-transform: translateY(1px);\n                transform: translateY(1px); }\n  .container---3sHdn .wrapper---1wzVf .dash---2sbCx {\n      width: 8px;\n      height: 2px;\n      background-color: #33475f; }\n", ""]);

// exports
exports.locals = {
	"container": "container---3sHdn",
	"wrapper": "wrapper---1wzVf",
	"button": "button---3jUbB",
	"title": "title---27OA6",
	"icon": "icon---pu4v9",
	"dash": "dash---2sbCx"
};

/***/ }),

/***/ "9gKn":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PYJo");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./all-classes.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./all-classes.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9vuV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SKILL_QUESTS_MASTERY_CLASS_RETRIEVED = exports.SKILL_QUESTS_MASTERY_CLASS_REQUEST = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _constants = __webpack_require__("1QGX");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SKILL_QUESTS_MASTERY_CLASS_RETRIEVED = exports.SKILL_QUESTS_MASTERY_CLASS_RETRIEVED = 'SKILL_QUESTS_MASTERY_CLASS_RETRIEVED';
var SKILL_QUESTS_MASTERY_CLASS_REQUEST = exports.SKILL_QUESTS_MASTERY_CLASS_REQUEST = 'SKILL_QUESTS_MASTERY_CLASS_REQUEST';
var manageGroupsData = function manageGroupsData(groupsData) {
  groupsData.groups.map(function (groupLevel) {
    groupLevel.id = groupLevel.groupId;
    groupLevel.students.map(function (studentLevel) {
      studentLevel.id = studentLevel.studentUserProfileId;
      return studentLevel;
    });
    return groupLevel;
  });
  return groupsData;
};
function getClassSkillQuestsMasteryData(classroomId, selectedDateFilter, assignmentResultType) {
  return function (dispatch) {
    dispatch({
      type: SKILL_QUESTS_MASTERY_CLASS_REQUEST
    });
    _resources["default"].singleClassReport.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_SKILL_QUESTS_MASTERY
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId
    })).withParams(_objectSpread(_objectSpread({}, _dateParamHelper["default"].getDateQueryParams(selectedDateFilter)), {}, {
      assignmentResultType: assignmentResultType
    })).send().then(function (payload) {
      if (payload.valid) {
        dispatch({
          type: SKILL_QUESTS_MASTERY_CLASS_RETRIEVED,
          payload: manageGroupsData(payload.data)
        });
      } else {
        dispatch(_errorsActions["default"].addError(SKILL_QUESTS_MASTERY_CLASS_RETRIEVED));
      }
    });
  };
}
var _default = exports["default"] = {
  getClassSkillQuestsMasteryData: getClassSkillQuestsMasteryData
};

/***/ }),

/***/ "AJmA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LIVE_MATHS_STUDENT_RETRIEVED = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _constants = __webpack_require__("1QGX");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LIVE_MATHS_STUDENT_RETRIEVED = exports.LIVE_MATHS_STUDENT_RETRIEVED = 'LIVE_MATHS_STUDENT_RETRIEVED';
function getLiveMathsData(studentId, classroomId, selectedDateFilter) {
  return function (dispatch) {
    return _resources["default"].studentReport.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_LIVE_MATHS
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId,
      userProfileId: studentId
    })).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDateFilter)).send().then(function (payload) {
      if (payload.valid) {
        dispatch({
          type: LIVE_MATHS_STUDENT_RETRIEVED,
          payload: mapLiveMathsData(payload.data)
        });
      } else {
        dispatch(_errorsActions["default"].addError(LIVE_MATHS_STUDENT_RETRIEVED));
      }
    });
  };
}
function mapLiveMathsData(data) {
  var mappedLiveMathsResults = data.liveMathsResults.map(function (result) {
    return {
      id: result.level,
      level: result.level,
      totalCorrect: mapLiveMathsScore(result.totalCorrect),
      topScore: mapLiveMathsScore(result.topScore),
      accuracy: mapLiveMathsScore(result.accuracy, '%'),
      questionsPerMinute: mapLiveMathsScore(result.questionsPerMinute)
    };
  });
  return _objectSpread(_objectSpread({}, data), {}, {
    liveMathsResults: mappedLiveMathsResults
  });
}
function mapLiveMathsScore(score, suffix) {
  if (score === -1) {
    return '-';
  } else if (suffix) {
    return "".concat(score).concat(suffix);
  }
  return score;
}
var _default = exports["default"] = {
  getLiveMathsData: getLiveMathsData
};

/***/ }),

/***/ "AJp4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _pageHeader = _interopRequireDefault(__webpack_require__("zmJ7"));
var _filterConstants = __webpack_require__("cdWI");
var _reportFilters = _interopRequireDefault(__webpack_require__("mLyz"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * PAGE HEADER
 * ------------------
 * Displayed at top section of page.
 * Connected with redux to manage the subtitle report name
 */
var PageHeader = /*#__PURE__*/function (_PureComponent) {
  function PageHeader(props) {
    var _this;
    _classCallCheck(this, PageHeader);
    _this = _callSuper(this, PageHeader, [props]);
    _defineProperty(_this, "getTitle", function () {
      var i18n = window.i18n;
      var _this$text = _this.text,
        headerTitle = _this$text.headerTitle,
        emptyString = _this$text.emptyString;
      if (i18n) return i18n._(headerTitle);
      return emptyString;
    });
    _defineProperty(_this, "getSubtitle", function () {
      var emptyString = _this.text.emptyString;
      if (_this.props.selectedReport.name) {
        var i18n = window.i18n;
        var key = "Report Filters - ".concat(_this.props.selectedReport.name);
        return i18n._(key);
      }
      return emptyString;
    });
    _defineProperty(_this, "getHeaderTitle", function () {
      var i18n = window.i18n;
      var _this$text2 = _this.text,
        headerTitle = _this$text2.headerTitle,
        emptyString = _this$text2.emptyString;
      if (i18n) {
        return i18n._(headerTitle);
      }
      return emptyString;
    });
    _this.text = {
      emptyString: '',
      headerTitle: 'Page Header - Reporting'
    };
    return _this;
  }
  _inherits(PageHeader, _PureComponent);
  return _createClass(PageHeader, [{
    key: "render",
    value: function render() {
      var showFilters = this.props.showFilters;
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.Header, {
        title: this.getTitle(),
        subtitle: this.getSubtitle(),
        className: _pageHeader["default"]['page-header']
      }, showFilters && /*#__PURE__*/_react["default"].createElement(_reportFilters["default"], null));
    }
  }]);
}(_react.PureComponent);
_defineProperty(PageHeader, "propTypes", {
  // Value for report filter
  selectedReport: _propTypes["default"].object,
  // Should show the connected filters
  showFilters: _propTypes["default"].bool
});
PageHeader.defaultProps = {
  showFilters: true
};
function mapStateToProps(state) {
  return {
    selectedReport: state.activeFilters[_filterConstants.SELECTED_REPORT]
  };
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)((0, _reactStyleable["default"])(_pageHeader["default"])(PageHeader));

/***/ }),

/***/ "AoEh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".certificates---3Jgg- {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  padding: 16px 0;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .certificates---3Jgg- .certificatesContainer---1rqKq {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 12px;\n    border: 1px solid #e4eaef;\n    -webkit-box-shadow: 0 4px 6px -1px rgba(0, 25, 55, .1), 0 2px 4px -1px rgba(0, 25, 55, .06);\n            box-shadow: 0 4px 6px -1px rgba(0, 25, 55, .1), 0 2px 4px -1px rgba(0, 25, 55, .06);\n    margin-right: 16px;\n    padding: 16px;\n    min-height: 198px;\n    width: 100%; }\n  .certificates---3Jgg- .certificatesContainer---1rqKq .heading---3KKEN {\n      color: #33475f;\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 27px; }\n  .certificates---3Jgg- .certificatesContainer---1rqKq .container---17PoN {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: horizontal;\n      -webkit-box-direction: normal;\n          -ms-flex-flow: row wrap;\n              flex-flow: row wrap;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      width: 100%;\n      margin-top: 16px; }\n  .certificates---3Jgg- .certificatesContainer---1rqKq .certificate---1AHOf {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      padding: 14px 10px;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      border-radius: 14px;\n      border: 1px solid #4dc4ef;\n      width: 84px;\n      height: 118px;\n      margin: 0 5px 10px; }\n  .certificates---3Jgg- .certificatesContainer---1rqKq .certificate---1AHOf .title---ILWFh {\n        margin: 8px 0; }\n  .certificates---3Jgg- .certificatesContainer---1rqKq .disabled---PRHMZ {\n      border: 1px solid #dbe0e6;\n      background-color: #fff;\n      opacity: 60%; }\n", ""]);

// exports
exports.locals = {
	"certificates": "certificates---3Jgg-",
	"certificatesContainer": "certificatesContainer---1rqKq",
	"heading": "heading---3KKEN",
	"container": "container---17PoN",
	"certificate": "certificate---1AHOf",
	"title": "title---ILWFh",
	"disabled": "disabled---PRHMZ"
};

/***/ }),

/***/ "AzNC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateReportFormat = exports.UPDATE_REPORT_FORMAT = void 0;
var UPDATE_REPORT_FORMAT = exports.UPDATE_REPORT_FORMAT = 'UPDATE_REPORT_FORMAT';
var updateReportFormat = exports.updateReportFormat = function updateReportFormat(format) {
  return {
    type: UPDATE_REPORT_FORMAT,
    payload: format
  };
};

/***/ }),

/***/ "B+Z1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _allClasses = _interopRequireDefault(__webpack_require__("9gKn"));
var _certificates = _interopRequireDefault(__webpack_require__("rrgl"));
var _certificatesConfig = __webpack_require__("K6Yf");
var _useTranslations2 = __webpack_require__("HJbm");
var _utils = __webpack_require__("v/Rl");
var _allClassesConstants = __webpack_require__("Wsmd");
var _constants = __webpack_require__("1QGX");
var _urlHelper = _interopRequireDefault(__webpack_require__("uOny"));
var _filterConstants = __webpack_require__("cdWI");
var _participationConstants = __webpack_require__("lWQf");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AllClassCertificates = function AllClassCertificates(_ref) {
  var participationData = _ref.participationData,
    newCertificatesDownloadByType = _ref.newCertificatesDownloadByType,
    pastCertificatesDownloadByType = _ref.pastCertificatesDownloadByType,
    activeFilters = _ref.activeFilters,
    academicYear = _ref.academicYear;
  var _useCertificatesConfi = (0, _certificatesConfig.useCertificatesConfig)(),
    newCertificatesConfig = _useCertificatesConfi.newCertificatesConfig,
    pastCertificatesConfig = _useCertificatesConfi.pastCertificatesConfig;
  var _useTranslations = (0, _useTranslations2.useTranslations)(),
    certificates = _useTranslations.certificates,
    oldCertificates = _useTranslations.oldCertificates,
    allClasses = _useTranslations.allClasses,
    allYearGroups = _useTranslations.allYearGroups;
  var isAdmin = (0, _reactRedux.useSelector)(function (state) {
    return state.isAdmin;
  });
  var selectedYearGroupId = activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id;
  var selectedTeacherId = activeFilters[_filterConstants.SELECTED_TEACHER].id;
  var certificateProps = _objectSpread(_objectSpread({
    classroomId: _allClassesConstants.ALL_CLASSES_ID,
    startDate: _urlHelper["default"].getQueryParamValue(_constants.START_DATE) || academicYear.startDate,
    endDate: _urlHelper["default"].getQueryParamValue(_constants.END_DATE) || academicYear.endDate,
    groupId: _allClassesConstants.ALL_GROUPS_ID,
    isForDownload: true
  }, selectedYearGroupId !== _filterConstants.ALL_YEARS && {
    yearGroupEnum: selectedYearGroupId
  }), {}, {
    teacherUserProfileId: selectedTeacherId === _filterConstants.ALL_TEACHERS ? _participationConstants.ALL_TEACHERS_ID : selectedTeacherId
  });
  var isAllYearGroupCertificate = isAdmin && selectedYearGroupId === _filterConstants.ALL_YEARS;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _allClasses["default"].certificates
  }, /*#__PURE__*/_react["default"].createElement(_certificates["default"], _extends({
    config: newCertificatesConfig,
    heading: certificates,
    certificates: participationData && participationData.newCertificate,
    handleCertificateDownloadClick: function handleCertificateDownloadClick(payload) {
      var certificatesCount = payload.certificatesCount,
        certificateTypeName = payload.certificateTypeName;
      newCertificatesDownloadByType(_objectSpread(_objectSpread({}, payload), {}, {
        fileNameOverride: (0, _utils.getCertificateFilename)({
          certificatesCount: certificatesCount,
          certificateTypeName: certificateTypeName,
          title: isAllYearGroupCertificate ? allYearGroups : allClasses,
          prefixCertificate: false
        })
      }));
    }
  }, certificateProps)), /*#__PURE__*/_react["default"].createElement(_certificates["default"], _extends({
    config: pastCertificatesConfig,
    heading: oldCertificates,
    isOldCertificates: true,
    certificates: participationData && participationData.certificates,
    handleCertificateDownloadClick: function handleCertificateDownloadClick(payload) {
      var certificatesCount = payload.certificatesCount,
        certificateTypeName = payload.certificateTypeName;
      pastCertificatesDownloadByType(_objectSpread(_objectSpread({}, payload), {}, {
        fileNameOverride: (0, _utils.getCertificateFilename)({
          certificatesCount: certificatesCount,
          certificateTypeName: certificateTypeName,
          title: isAllYearGroupCertificate ? allYearGroups : allClasses,
          prefixCertificate: false
        })
      }));
    }
  }, certificateProps)));
};
AllClassCertificates.propTypes = {
  participationData: _propTypes["default"].object || null,
  newCertificatesDownloadByType: _propTypes["default"].func,
  pastCertificatesDownloadByType: _propTypes["default"].func,
  academicYear: _propTypes["default"].object.isRequired,
  activeFilters: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_allClasses["default"])(AllClassCertificates);

/***/ }),

/***/ "B6As":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerSort = exports.getSingleClassParticipationTableConfig = exports.STUDENT_NAME = exports.PAST_CERTIFICATES_TOTAL = exports.NEW_CERTIFICATES_TOTAL = exports.GROUP_NAME = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _certificatesActions = _interopRequireDefault(__webpack_require__("PLdC"));
var _certificateDisplay = _interopRequireDefault(__webpack_require__("fXLW"));
var _constants = __webpack_require__("1QGX");
var _urlHelper = _interopRequireDefault(__webpack_require__("uOny"));
var _singleClass = _interopRequireDefault(__webpack_require__("MyZd"));
var _certificateConstants = __webpack_require__("tQue");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-unused-vars */
var STUDENT_NAME = exports.STUDENT_NAME = 'fullName';
var GROUP_NAME = exports.GROUP_NAME = 'name';
var PAST_CERTIFICATES_TOTAL = exports.PAST_CERTIFICATES_TOTAL = 'certificateDetails.total';
var NEW_CERTIFICATES_TOTAL = exports.NEW_CERTIFICATES_TOTAL = 'newCertificateDetails.total';
var ACTIVITY_POINTS = 'points.activityPoints';
var LIVE_POINTS = 'points.livePoints';
var TOTAL_POINTS = 'points.total';
var PAST_CERTIFICATES_BRONZE = 'certificateDetails.bronze';
var PAST_CERTIFICATES_SILVER = 'certificateDetails.silver';
var PAST_CERTIFICATES_GOLD = 'certificateDetails.gold';
var NEW_CERTIFICATES_BRONZE = 'newCertificateDetails.bronze';
var NEW_CERTIFICATES_DIAMOND = 'newCertificateDetails.diamond';
var NEW_CERTIFICATES_EMERALD = 'newCertificateDetails.emerald';
var NEW_CERTIFICATES_EPIC = 'newCertificateDetails.epic';
var NEW_CERTIFICATES_GOLD = 'newCertificateDetails.gold';
var NEW_CERTIFICATES_LEGEND = 'newCertificateDetails.legend';
var NEW_CERTIFICATES_PLATINUM = 'newCertificateDetails.platinum';
var NEW_CERTIFICATES_SILVER = 'newCertificateDetails.silver';
var headerSort = exports.headerSort = {
  sortAs: 'nested',
  sortDir: 'desc'
};
var nestedSort = {
  sortAs: 'number'
};
var getNestedValue = function getNestedValue(id, value) {
  // Split the id string by the delimiter ('.') as we want to avoid extending what is returned from the mapped service data.
  var path = id.split('.');
  return path.reduce(function (acc, part) {
    return acc && acc[part];
  }, value);
};
var getCertificateName = function getCertificateName(id, name) {
  var i18n = window.i18n;
  switch (id) {
    case NEW_CERTIFICATES_TOTAL:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - New Certificates - Student - {name}",
        values: {
          name: name
        }
      });
    case PAST_CERTIFICATES_TOTAL:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Past Certificates - Student - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_BRONZE:
    case PAST_CERTIFICATES_BRONZE:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Bronze - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_SILVER:
    case PAST_CERTIFICATES_SILVER:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Silver - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_GOLD:
    case PAST_CERTIFICATES_GOLD:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Gold - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_EMERALD:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Emerald - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_DIAMOND:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Diamond - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_EPIC:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Epic - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_LEGEND:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Legend - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_PLATINUM:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Platinum - {name}",
        values: {
          name: name
        }
      });
    default:
      return '';
  }
};
// TODO: Create a helper function to use in all class and single class
var getCertificateDisplayColumn = function getCertificateDisplayColumn(_ref) {
  var id = _ref.id,
    name = _ref.name,
    type = _ref.type,
    service = _ref.service,
    classroomId = _ref.classroomId,
    _ref$isOldCertificate = _ref.isOldCertificates,
    isOldCertificates = _ref$isOldCertificate === void 0 ? false : _ref$isOldCertificate;
  return {
    id: id,
    name: name,
    transform: function transform(value) {
      var requestParams = {
        classroomId: classroomId,
        startDate: _urlHelper["default"].getQueryParamValue(_constants.START_DATE) || null,
        endDate: _urlHelper["default"].getQueryParamValue(_constants.END_DATE) || null,
        groupId: value.groupId,
        isForDownload: true,
        type: type,
        userProfileId: value.id,
        userId: value.userId
      };
      var onSuccessParams = {
        certificateType: type,
        fileNameOverride: getCertificateName(id, value.fullName)
      };
      return /*#__PURE__*/_react["default"].createElement(_certificateDisplay["default"], {
        count: getNestedValue(id, value),
        requestParams: requestParams,
        service: service,
        onSuccessParams: onSuccessParams,
        isOldCertificates: isOldCertificates
      });
    }
  };
};
var getSingleClassParticipationPastCertificates = function getSingleClassParticipationPastCertificates(_ref2) {
  var isExpanded = _ref2.isExpanded,
    classroomId = _ref2.classroomId;
  var defaultExpandedParams = {
    service: _certificatesActions["default"].pastCertificatesDownloadStudentByType,
    classroomId: classroomId,
    isOldCertificates: true
  };
  if (isExpanded) {
    return {
      cols: [{
        id: 'Past Certificates - Bronze',
        name: 'Certificates - Bronze'
      }, {
        id: 'Past Certificates - Silver',
        name: 'Certificates - Silver'
      }, {
        id: 'Past Certificates - Gold',
        name: 'Certificates - Gold'
      }],
      colGroups: [[{
        colIds: [PAST_CERTIFICATES_BRONZE, PAST_CERTIFICATES_SILVER, PAST_CERTIFICATES_GOLD],
        name: 'Past Certificates - Total',
        classes: _singleClass["default"]['total-certificates'],
        id: PAST_CERTIFICATES_TOTAL
      }]],
      nestedData: [getCertificateDisplayColumn(_objectSpread({
        id: PAST_CERTIFICATES_BRONZE,
        name: 'Certificates - Bronze',
        type: _certificateConstants.BRONZE.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: PAST_CERTIFICATES_SILVER,
        name: 'Certificates - Silver',
        type: _certificateConstants.SILVER.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: PAST_CERTIFICATES_GOLD,
        name: 'Certificates - Gold',
        type: _certificateConstants.GOLD.type
      }, defaultExpandedParams))]
    };
  }
  return {
    cols: [{
      id: 'PAST CERTIFICATES TOTAL',
      name: ''
    }],
    colGroups: [[{
      id: PAST_CERTIFICATES_TOTAL,
      colIds: [PAST_CERTIFICATES_TOTAL],
      name: 'Past Certificates - Total',
      classes: _singleClass["default"]['total-certificates']
    }]],
    nestedData: [getCertificateDisplayColumn({
      id: PAST_CERTIFICATES_TOTAL,
      name: 'Past Certificates - Total',
      service: _certificatesActions["default"].pastCertificatesDownloadStudentByType,
      type: _certificateConstants.PAST_TOTAL.type,
      isOldCertificates: true,
      classroomId: classroomId
    })]
  };
};
var getSingleClassParticipationNewCertificates = function getSingleClassParticipationNewCertificates(_ref3) {
  var isExpanded = _ref3.isExpanded,
    classroomId = _ref3.classroomId;
  var defaultStyles = "\n        ".concat(_singleClass["default"]['total-certificates'], " \n        ").concat(_singleClass["default"]['new-certificates'], "\n    ");
  var defaultExpandedParams = {
    service: _certificatesActions["default"].newCertificatesDownloadStudentByType,
    classroomId: classroomId
  };
  var defaultHeaderClass = isExpanded ? "".concat(defaultStyles).concat(_singleClass["default"]['new-expanded']) : defaultStyles;
  if (isExpanded) {
    return {
      cols: [{
        id: 'New Certificates - Bronze',
        name: 'Certificates - Bronze',
        classes: defaultHeaderClass
      }, {
        id: 'New Certificates - Silver',
        name: 'Certificates - Silver',
        classes: defaultHeaderClass
      }, {
        id: 'New Certificates - Gold',
        name: 'Certificates - Gold',
        classes: defaultHeaderClass
      }, {
        id: 'New Certificates - Platinum',
        name: 'Certificates - Platinum',
        classes: defaultHeaderClass
      }, {
        id: 'New Certificates - Emerald',
        name: 'Certificates - Emerald',
        classes: defaultHeaderClass
      }, {
        id: 'New Certificates - Diamond',
        name: 'Certificates - Diamond',
        classes: defaultHeaderClass
      }, {
        id: 'New Certificates - Epic',
        name: 'Certificates - Epic',
        classes: defaultHeaderClass
      }, {
        id: 'New Certificates - Legend',
        name: 'Certificates - Legend',
        classes: defaultHeaderClass
      }],
      colGroups: [[{
        colIds: [NEW_CERTIFICATES_BRONZE, NEW_CERTIFICATES_SILVER, NEW_CERTIFICATES_GOLD, NEW_CERTIFICATES_PLATINUM, NEW_CERTIFICATES_EMERALD, NEW_CERTIFICATES_DIAMOND, NEW_CERTIFICATES_EPIC, NEW_CERTIFICATES_LEGEND],
        name: 'New Certificates - Total',
        classes: isExpanded ? "\n                                ".concat(defaultStyles, "\n                                ").concat(_singleClass["default"]['new-expanded']) : defaultStyles,
        id: NEW_CERTIFICATES_TOTAL
      }]],
      nestedData: [getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_BRONZE,
        name: 'Certificates - Bronze',
        type: _certificateConstants.BRONZE.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_SILVER,
        name: 'Certificates - Silver',
        type: _certificateConstants.SILVER.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_GOLD,
        name: 'Certificates - Gold',
        type: _certificateConstants.GOLD.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_PLATINUM,
        name: 'Certificates - Platinum',
        type: _certificateConstants.PLATINUM.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_EMERALD,
        name: 'Certificates - Emerald',
        type: _certificateConstants.EMERALD.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_DIAMOND,
        name: 'Certificates - Diamond',
        type: _certificateConstants.DIAMOND.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_EPIC,
        name: 'Certificates - Epic',
        type: _certificateConstants.EPIC.type
      }, defaultExpandedParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_LEGEND,
        name: 'Certificates - Legend',
        type: _certificateConstants.LEGEND.type
      }, defaultExpandedParams))]
    };
  }
  return {
    cols: [{
      id: 'NEW CERTIFICATES TOTAL',
      name: '',
      classes: defaultHeaderClass
    }],
    colGroups: [[{
      id: NEW_CERTIFICATES_TOTAL,
      colIds: [NEW_CERTIFICATES_TOTAL],
      name: 'New Certificates - Total',
      classes: defaultHeaderClass
    }]],
    nestedData: [getCertificateDisplayColumn({
      id: NEW_CERTIFICATES_TOTAL,
      name: 'New Certificates - Total',
      service: _certificatesActions["default"].newCertificatesDownloadStudentByType,
      type: _certificateConstants.NEW_TOTAL.type,
      classroomId: classroomId
    })]
  };
};
var getSingleClassParticipationTableConfig = exports.getSingleClassParticipationTableConfig = function getSingleClassParticipationTableConfig(_ref4) {
  var _ref4$isNewCertificat = _ref4.isNewCertificatesExpanded,
    isNewCertificatesExpanded = _ref4$isNewCertificat === void 0 ? false : _ref4$isNewCertificat,
    _ref4$isPastCertifica = _ref4.isPastCertificatesExpanded,
    isPastCertificatesExpanded = _ref4$isPastCertifica === void 0 ? false : _ref4$isPastCertifica,
    classroomId = _ref4.classroomId;
  var isExpanded = isNewCertificatesExpanded || isPastCertificatesExpanded;
  var pastCertificatesConfig = getSingleClassParticipationPastCertificates({
    isExpanded: isPastCertificatesExpanded,
    classroomId: classroomId
  });
  var newCertificatesConfig = getSingleClassParticipationNewCertificates({
    isExpanded: isNewCertificatesExpanded,
    classroomId: classroomId
  });
  var defaultColGroupStyles = isExpanded ? "".concat(_singleClass["default"]['total-points'], " ").concat(_singleClass["default"].small) : _singleClass["default"]['total-points'];
  var defaultColStyles = isExpanded ? "".concat(_singleClass["default"]['total-points'], " ").concat(_singleClass["default"]['col-group-sort-icon'], " ").concat(_singleClass["default"].small) : "".concat(_singleClass["default"]['total-points'], " ").concat(_singleClass["default"]['col-group-sort-icon']);
  return {
    colGroups: [[{
      colIds: [GROUP_NAME],
      name: 'Table Config - Groups',
      sort: null,
      id: GROUP_NAME,
      classes: _singleClass["default"]['class-name']
    }, {
      colIds: [LIVE_POINTS],
      name: isExpanded ? 'Points - Live - Small' : 'Points - Live',
      classes: defaultColGroupStyles
    }, {
      colIds: [ACTIVITY_POINTS],
      name: isExpanded ? 'Points - Curriculum - Small' : 'Points - Curriculum',
      classes: defaultColGroupStyles
    }, {
      colIds: [TOTAL_POINTS],
      name: isExpanded ? 'Points - Total - Small' : 'Points - Total',
      classes: defaultColGroupStyles
    }].concat(_toConsumableArray(newCertificatesConfig.colGroups[0]), _toConsumableArray(pastCertificatesConfig.colGroups[0]))],
    cols: [{
      id: GROUP_NAME,
      name: '',
      doTranslation: true,
      truncate: true,
      onClick: null
    }, {
      id: 'LIVE POINTS',
      name: '',
      classes: defaultColStyles,
      sort: headerSort
    }, {
      id: 'ACTIVITY POINTS',
      name: '',
      classes: defaultColStyles,
      sort: headerSort
    }, {
      id: 'TOTAL POINTS',
      name: '',
      classes: defaultColStyles,
      sort: headerSort
    }].concat(_toConsumableArray(newCertificatesConfig.cols), _toConsumableArray(pastCertificatesConfig.cols)),
    nestedData: {
      id: 'studentUsageDetails',
      cols: [{
        id: STUDENT_NAME,
        truncate: true,
        onClick: function onClick() {
          return null;
        },
        // this is set in the SingleClass component
        classes: _singleClass["default"]['student-name']
      }, {
        id: LIVE_POINTS,
        sort: nestedSort
      }, {
        id: ACTIVITY_POINTS,
        sort: nestedSort
      }, {
        id: TOTAL_POINTS,
        sort: nestedSort
      }].concat(_toConsumableArray(newCertificatesConfig.nestedData), _toConsumableArray(pastCertificatesConfig.nestedData))
    },
    defaultSort: null,
    emptyDataMessage: 'Empty - NoParticipationResults'
  };
};

/***/ }),

/***/ "B7He":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("awYd");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./entry-app.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./entry-app.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "BOI9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _activityMasteryPropType = __webpack_require__("+NxA");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var strengthWeaknessData = _propTypes["default"].shape({
  id: _propTypes["default"].number.isRequired,
  title: _propTypes["default"].string.isRequired,
  averageResult: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired
});
var activityMasteryData = _propTypes["default"].shape({
  name: _propTypes["default"].string.isRequired,
  teacherName: _propTypes["default"].string.isRequired,
  activityMastery: _propTypes["default"].shape(_objectSpread(_objectSpread({}, _activityMasteryPropType.activityMasteryPropTypeShape), {}, {
    groupActivityMastery: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired,
      name: _propTypes["default"].string.isRequired,
      courseName: _propTypes["default"].string.isRequired,
      totalActivities: _propTypes["default"].number.isRequired,
      students: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread(_objectSpread({}, _activityMasteryPropType.activityMasteryPropTypeShape), {}, {
        id: _propTypes["default"].number.isRequired,
        firstName: _propTypes["default"].string.isRequired,
        lastName: _propTypes["default"].string.isRequired
      }))),
      strengths: _propTypes["default"].shape({
        topics: _propTypes["default"].arrayOf(strengthWeaknessData),
        activities: _propTypes["default"].arrayOf(strengthWeaknessData)
      }).isRequired,
      weaknesses: _propTypes["default"].shape({
        topics: _propTypes["default"].arrayOf(strengthWeaknessData),
        activities: _propTypes["default"].arrayOf(strengthWeaknessData)
      }).isRequired
    }))
  })),
  strengths: _propTypes["default"].shape({
    topics: _propTypes["default"].arrayOf(strengthWeaknessData),
    activities: _propTypes["default"].arrayOf(strengthWeaknessData)
  }).isRequired,
  weaknesses: _propTypes["default"].shape({
    topics: _propTypes["default"].arrayOf(strengthWeaknessData),
    activities: _propTypes["default"].arrayOf(strengthWeaknessData)
  }).isRequired
});
var _default = exports["default"] = {
  activityMasteryData: activityMasteryData
};

/***/ }),

/***/ "BdcE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3gg40 .topic-table---3wvtp {\n  margin-bottom: 48px; }\n  .component---3gg40 .topic-table---3wvtp .topic-name---Vz8VF,\n  .component---3gg40 .topic-table---3wvtp .activity-name---1quPb {\n    width: 33%; }\n  .component---3gg40 .topic-table---3wvtp .num-attempts---2N5Xk {\n    width: 15%; }\n  .component---3gg40 .topic-table---3wvtp .result-attempt---GUwmd {\n    width: 10%;\n    padding: 4px 8px; }\n  .component---3gg40 .topic-table---3wvtp tr {\n    text-align: center; }\n  .component---3gg40 .topic-table---3wvtp tr td {\n      border-left: none;\n      border-right: none; }\n  .component---3gg40 .topic-table---3wvtp thead tr {\n    background: none;\n    color: #4e5c67; }\n  .component---3gg40 .topic-table---3wvtp thead tr th {\n      border: none;\n      border-top: 1px solid #e5e5e5;\n      padding: 4px 16px;\n      font-weight: normal; }\n  .component---3gg40 .topic-table---3wvtp thead tr th:first-of-type {\n        border-left: 1px solid #e5e5e5;\n        border-right: 1px solid #e5e5e5; }\n  .component---3gg40 .topic-table---3wvtp thead tr th:last-of-type {\n        border-right: 1px solid #e5e5e5; }\n  .component---3gg40 .topic-table---3wvtp tbody tr {\n    min-height: 48px; }\n  .component---3gg40 .topic-table---3wvtp tbody td:first-of-type {\n    border-left: 1px solid #e5e5e5;\n    border-right: 1px solid #e5e5e5; }\n  .component---3gg40 .topic-table---3wvtp tbody td:last-of-type {\n    border-right: 1px solid #e5e5e5; }\n  .component---3gg40 .topic-table---3wvtp tbody td ~ td {\n    font-weight: bold;\n    font-size: 16px; }\n  .component---3gg40 .topic-table---3wvtp tbody .topic-name---Vz8VF {\n    background-color: #415667;\n    color: #fff; }\n  .component---3gg40 .topic-table---3wvtp tbody .topic-name---Vz8VF svg path {\n      fill: currentColor !important; }\n  .component---3gg40 .topic-table---3wvtp tbody .topic-name---Vz8VF,\n  .component---3gg40 .topic-table---3wvtp tbody .activity-name---1quPb {\n    font-weight: normal;\n    font-size: 14px;\n    text-align: left; }\n  .component---3gg40 .topic-table---3wvtp tbody:first-of-type tr {\n    background-color: #e4eaef; }\n  .component---3gg40 .improvement---1Pps5 .improvement-dropdown---3x-Rf > div {\n  width: inherit;\n  margin: auto; }\n  .component---3gg40 .improvement---1Pps5 .improvement-dropdown---3x-Rf > div [role=\"button\"] {\n    padding: 4px 8px;\n    min-width: 140px;\n    max-width: 140px; }\n  .component---3gg40 .improvement---1Pps5 .improvement-dropdown---3x-Rf > div [role=\"button\"] > span {\n      white-space: normal; }\n  .component---3gg40 .topic-table-msg---1KNPY {\n  font-size: 12px;\n  margin-left: 8px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3gg40",
	"topic-table": "topic-table---3wvtp",
	"topic-name": "topic-name---Vz8VF",
	"activity-name": "activity-name---1quPb",
	"num-attempts": "num-attempts---2N5Xk",
	"result-attempt": "result-attempt---GUwmd",
	"improvement": "improvement---1Pps5",
	"improvement-dropdown": "improvement-dropdown---3x-Rf",
	"topic-table-msg": "topic-table-msg---1KNPY"
};

/***/ }),

/***/ "BiE+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(__webpack_require__("PJh5"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DateHelper = exports["default"] = /*#__PURE__*/function () {
  function DateHelper() {
    _classCallCheck(this, DateHelper);
  }
  return _createClass(DateHelper, null, [{
    key: "getPreviousMonday",
    value: function getPreviousMonday(date) {
      var prevMonday = date ? new Date(date) : new Date();
      prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);
      return prevMonday;
    }
  }, {
    key: "getThisWeekStartEnd",
    value: function getThisWeekStartEnd() {
      var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';
      var thisMonday = DateHelper.getPreviousMonday();
      var startDate = (0, _moment["default"])(thisMonday).format(formatString);
      var endDate = (0, _moment["default"])(thisMonday).add(6, 'days').format(formatString);
      return {
        startDate: startDate,
        endDate: endDate
      };
    }
  }, {
    key: "getLastWeekStartEnd",
    value: function getLastWeekStartEnd() {
      var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';
      var thisMonday = DateHelper.getPreviousMonday();
      var startDate = (0, _moment["default"])(thisMonday).subtract(7, 'days').format(formatString);
      var endDate = (0, _moment["default"])(thisMonday).subtract(1, 'days').format(formatString);
      return {
        startDate: startDate,
        endDate: endDate
      };
    }
  }]);
}();

/***/ }),

/***/ "Blrm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AllClasses = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _headerToggle = _interopRequireDefault(__webpack_require__("qvwF"));
var _allClassesActions = _interopRequireWildcard(__webpack_require__("FDbR"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _allClasses = _interopRequireDefault(__webpack_require__("9gKn"));
var _allClassesConstants = __webpack_require__("Wsmd");
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _allClassesPropTypes = _interopRequireDefault(__webpack_require__("nQji"));
var _routeHelper = _interopRequireDefault(__webpack_require__("H7F4"));
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _reportStateActions = __webpack_require__("ItvU");
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _usage = _interopRequireDefault(__webpack_require__("DtE0"));
var _useTranslations2 = __webpack_require__("HJbm");
var _certificatesActions = _interopRequireDefault(__webpack_require__("PLdC"));
var _allClassCertificates = _interopRequireDefault(__webpack_require__("B+Z1"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AllClasses component
 * Displays participation results table, certificates & usage for all classes
 */
var AllClasses = exports.AllClasses = /*#__PURE__*/function (_Component) {
  function AllClasses(_props) {
    var _this;
    _classCallCheck(this, AllClasses);
    _this = _callSuper(this, AllClasses, [_props]);
    _defineProperty(_this, "getAllClassesParticipationData", function (props) {
      var getParticipationData = props.getParticipationData,
        getTop10StudentsData = props.getTop10StudentsData,
        getByClassData = props.getByClassData,
        reportState = props.reportState,
        activeFilters = props.activeFilters;
      if (_this.isAllYearsRoute && reportState === _reportStateActions.REPORT_STATE_TOP_TEN) {
        getTop10StudentsData(activeFilters[_filterConstants.SELECTED_DATE]);
      } else if (_this.isAllYearsRoute && reportState === _reportStateActions.REPORT_STATE_ALL_CLASSES) {
        getByClassData(activeFilters[_filterConstants.SELECTED_DATE]);
      } else {
        getParticipationData(activeFilters[_filterConstants.SELECTED_DATE], activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id, activeFilters[_filterConstants.SELECTED_TEACHER].id);
      }
    });
    _defineProperty(_this, "getTableConfig", function (_ref) {
      var reportState = _ref.reportState;
      var isAllYearsRoute = _this.isAllYearsRoute && reportState !== _reportStateActions.REPORT_STATE_ALL_CLASSES;
      var defaultParams = {
        isPastCertificatesExpanded: _this.state.dataTable.isPastCertificatesExpanded,
        isNewCertificatesExpanded: _this.state.dataTable.isNewCertificatesExpanded
      };
      var participationTableConfig;
      var filterKey = _allClassesConstants.CLASS_NAME;
      if (reportState === _reportStateActions.REPORT_STATE_TOP_TEN) {
        participationTableConfig = (0, _allClassesConstants.getTop10ParticipationTableConfig)(defaultParams);
      } else if (isAllYearsRoute) {
        participationTableConfig = (0, _allClassesConstants.getAllYearsParticipationTableConfig)(defaultParams);
        filterKey = _allClassesConstants.CLASS_ID;
      } else {
        participationTableConfig = (0, _allClassesConstants.getAllClassesParticipationTableConfig)(defaultParams);
      }
      return {
        participationTableConfig: (0, _cloneDeep["default"])(participationTableConfig),
        filterKey: filterKey
      };
    });
    _defineProperty(_this, "updateTableConfig", function (_ref2) {
      var participationTableConfig = _ref2.participationTableConfig,
        filterKey = _ref2.filterKey;
      participationTableConfig.colGroups[0].map(function (col) {
        return col.name = window.i18n._(col.name);
      });
      participationTableConfig.cols.map(function (col) {
        return col.name = window.i18n._(col.name);
      });
      participationTableConfig.colGroups[0].map(function (item) {
        if (item.id === _allClassesConstants.PAST_CERTIFICATES_TOTAL) {
          item.headerTransform = function () {
            return /*#__PURE__*/_react["default"].createElement(_headerToggle["default"], {
              title: item.name,
              onClick: function onClick(value) {
                return _this.setState({
                  dataTable: _objectSpread(_objectSpread({}, _this.state.dataTable), {}, {
                    isPastCertificatesExpanded: value
                  })
                });
              },
              defaultExpanded: _this.state.isPastCertificatesExpanded
            });
          };
        }
        if (item.id === _allClassesConstants.NEW_CERTIFICATES_TOTAL) {
          item.headerTransform = function () {
            return /*#__PURE__*/_react["default"].createElement(_headerToggle["default"], {
              title: item.name,
              onClick: function onClick(value) {
                return _this.setState({
                  dataTable: _objectSpread(_objectSpread({}, _this.state.dataTable), {}, {
                    isNewCertificatesExpanded: value
                  })
                });
              },
              defaultExpanded: _this.state.isNewCertificatesExpanded
            });
          };
        }
        return item;
      });
      participationTableConfig.cols.find(function (col) {
        return col.id === filterKey;
      }).onClick = _this.loadItemPage;
      return {
        participationTableConfig: participationTableConfig
      };
    });
    _defineProperty(_this, "setTableConfig", function (props) {
      var config = _this.getTableConfig({
        reportState: props.reportState
      });
      var _this$updateTableConf = _this.updateTableConfig(config),
        participationTableConfig = _this$updateTableConf.participationTableConfig;
      _this.setState({
        participationTableConfig: participationTableConfig
      });
    });
    _defineProperty(_this, "setUsageTableConfig", function () {
      var allClassesUsageTableConfig = (0, _cloneDeep["default"])(_allClassesConstants.ALL_CLASSES_USAGE_TABLE_CONFIG);
      allClassesUsageTableConfig.cols.map(function (col) {
        return col.name = window.i18n._(col.name);
      });
      _this.setState({
        allClassesUsageTableConfig: allClassesUsageTableConfig
      });
    });
    _defineProperty(_this, "loadItemPage", function (selectedItem) {
      var _this$props = _this.props,
        reportState = _this$props.reportState,
        setActiveFilters = _this$props.setActiveFilters,
        updateActiveFilter = _this$props.updateActiveFilter,
        studentClasses = _this$props.studentClasses;
      if (reportState === _reportStateActions.REPORT_STATE_TOP_TEN) {
        setActiveFilters(_defineProperty(_defineProperty({}, _filterConstants.SELECTED_STUDENT, {
          id: selectedItem.id,
          name: selectedItem.classroomName
        }), _filterConstants.SELECTED_CLASS, {
          id: studentClasses[selectedItem.id]
        }));
        return;
      }
      var itemType = _this.isAllYearsRoute && reportState !== _reportStateActions.REPORT_STATE_ALL_CLASSES ? _filterConstants.SELECTED_YEAR_GROUP : _filterConstants.SELECTED_CLASS;
      updateActiveFilter(itemType, {
        id: selectedItem.id,
        name: selectedItem.classroomName
      });
    });
    _this.isLandingPage = true;
    _this.isAllYearsRoute = false;
    _this.state = {
      participationTableConfig: null,
      dataTable: {
        isPastCertificatesExpanded: false,
        isNewCertificatesExpanded: false
      }
    };
    _this.setRouteType(_props, true);
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(AllClasses, _Component);
  return _createClass(AllClasses, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeFilters = this.props.activeFilters;
      if (_filterHelper["default"].shouldLoadAllClasses(activeFilters)) {
        this.getAllClassesParticipationData(this.props);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.dataTable.isPastCertificatesExpanded !== this.state.dataTable.isPastCertificatesExpanded || prevState.dataTable.isNewCertificatesExpanded !== this.state.dataTable.isNewCertificatesExpanded) {
        this.setTableConfig(this.props);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props2 = this.props,
        activeFilters = _this$props2.activeFilters,
        invalidRequest = _this$props2.invalidRequest,
        updateActiveFilter = _this$props2.updateActiveFilter,
        isAdmin = _this$props2.isAdmin,
        participationData = _this$props2.participationData,
        reportState = _this$props2.reportState;
      var newInvalidRequest = newProps.invalidRequest,
        newActiveFilters = newProps.activeFilters,
        newIsAdmin = newProps.isAdmin,
        newParticipationData = newProps.participationData,
        newReportState = newProps.reportState;
      if (activeFilters !== newActiveFilters || isAdmin !== newIsAdmin) {
        this.setRouteType(newProps);
      }
      if (_filterHelper["default"].shouldReloadAllClasses(activeFilters, newActiveFilters)) {
        this.getAllClassesParticipationData(newProps);
      }
      if (participationData !== newParticipationData || reportState !== newReportState) {
        this.setTableConfig(newProps);
      }
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _allClassesActions.PARTICIPATION_ALL_CLASSES_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "setRouteType",
    value: function setRouteType(props, firstLoad) {
      var isAdmin = props.isAdmin,
        activeFilters = props.activeFilters;
      this.isLandingPage = _routeHelper["default"].isLandingPage(isAdmin, activeFilters);
      this.isAllYearsRoute = _routeHelper["default"].isAllYearsRoute(isAdmin, activeFilters);
      if (!firstLoad) {
        this.setTableConfig(props);
        this.setUsageTableConfig();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var participationTableConfig = this.state.participationTableConfig;
      var _this$props3 = this.props,
        participationData = _this$props3.participationData,
        newCertificatesDownloadByType = _this$props3.newCertificatesDownloadByType,
        pastCertificatesDownloadByType = _this$props3.pastCertificatesDownloadByType,
        academicYear = _this$props3.academicYear,
        activeFilters = _this$props3.activeFilters;
      var usageData = participationData && participationData.classroomUsage[0];
      var _useTranslations = (0, _useTranslations2.useTranslations)(),
        participation = _useTranslations.participation;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClasses["default"].component
      }, this.isLandingPage ? /*#__PURE__*/_react["default"].createElement("h3", null, participation) : /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: participation
      }), /*#__PURE__*/_react["default"].createElement(_usage["default"], usageData), /*#__PURE__*/_react["default"].createElement(_allClassCertificates["default"], {
        participationData: participationData,
        newCertificatesDownloadByType: newCertificatesDownloadByType,
        pastCertificatesDownloadByType: pastCertificatesDownloadByType,
        activeFilters: activeFilters,
        academicYear: academicYear
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClasses["default"]['participation-results-container']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClasses["default"]['participation-results']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: participationTableConfig,
        data: participationData && participationData.classroomParticipations
      }))));
    }
  }]);
}(_react.Component);
_defineProperty(AllClasses, "propTypes", {
  participationData: _allClassesPropTypes["default"].participationData,
  activeFilters: _filterPropTypes.activeFiltersPropType,
  isAdmin: _propTypes["default"].bool,
  updateActiveFilter: _propTypes["default"].func,
  setActiveFilters: _propTypes["default"].func,
  invalidRequest: _propTypes["default"].string,
  reportState: _propTypes["default"].oneOf([_reportStateActions.REPORT_STATE_ALL_YEARS, _reportStateActions.REPORT_STATE_ALL_CLASSES, _reportStateActions.REPORT_STATE_TOP_TEN]).isRequired,
  studentClasses: _propTypes["default"].object.isRequired,
  newCertificatesDownloadByType: _propTypes["default"].func,
  pastCertificatesDownloadByType: _propTypes["default"].func,
  academicYear: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }).isRequired,
  getParticipationData: _propTypes["default"].func,
  getTop10StudentsData: _propTypes["default"].func,
  getByClassData: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    academicYear: state.academicYear,
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    participationData: state.participationAllClasses,
    isAdmin: state.isAdmin,
    invalidRequest: state.invalidRequest,
    reportState: state.reportState,
    studentClasses: state.studentClasses
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getParticipationData: _allClassesActions["default"].getParticipationData,
    getTop10StudentsData: _allClassesActions["default"].getTop10StudentsData,
    getByClassData: _allClassesActions["default"].getByClassData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter,
    setActiveFilters: _activeFiltersActions["default"].setActiveFilters,
    newCertificatesDownloadByType: _certificatesActions["default"].newCertificatesDownloadByType,
    pastCertificatesDownloadByType: _certificatesActions["default"].pastCertificatesDownloadByType
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AllClasses);

/***/ }),

/***/ "BnJS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1ZGCL {\n  height: calc(100% - 90px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .component---1ZGCL .live-maths-results---2OR7s {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 1 60%;\n            flex: 0 1 60%; }\n  .component---1ZGCL .live-maths-results---2OR7s table {\n      margin: 16px 0; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead tr {\n        background-color: #e4eaef;\n        color: #278bcb; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead tr th {\n          padding: 6px 16px; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead tr th svg path {\n            fill: #788189 !important; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead .col-header---2ucfA {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        text-align: center;\n        font-size: 12px;\n        line-height: 14px; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead .col-header---2ucfA span:first-of-type {\n          font-weight: bold; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead .col-header---2ucfA span:nth-of-type(2) {\n          font-weight: normal; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead .class-name---3bbOG,\n      .component---1ZGCL .live-maths-results---2OR7s table thead .level---3dMl0 {\n        width: 40%;\n        text-align: left; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead .level---3dMl0 {\n        font-size: 14px; }\n  .component---1ZGCL .live-maths-results---2OR7s table tbody {\n        text-align: center; }\n  .component---1ZGCL .live-maths-results---2OR7s table tbody tr {\n          background: none; }\n  .component---1ZGCL .live-maths-results---2OR7s table tbody tr td {\n            padding: 8px 16px; }\n  .component---1ZGCL .live-maths-results---2OR7s table tbody .level---3dMl0,\n        .component---1ZGCL .live-maths-results---2OR7s table tbody .class-name---3bbOG,\n        .component---1ZGCL .live-maths-results---2OR7s table tbody .group-name---4h2hg,\n        .component---1ZGCL .live-maths-results---2OR7s table tbody .course-name---WOhz3,\n        .component---1ZGCL .live-maths-results---2OR7s table tbody .student-name---9oT0e {\n          text-align: left; }\n  .component---1ZGCL .live-maths-results---2OR7s table tbody .level---3dMl0 {\n          font-size: 12px; }\n  .component---1ZGCL .live-maths-results---2OR7s table tbody .level-picker---3ypKG {\n          padding: 0; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead tr:last-of-type {\n      background: none;\n      font-weight: normal; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead .group-name---4h2hg {\n      font-size: 12px;\n      font-weight: normal;\n      color: #4e5c67; }\n  .component---1ZGCL .live-maths-results---2OR7s table thead .course-name---WOhz3 {\n      padding: 0;\n      font-weight: normal; }\n  .component---1ZGCL .live-maths-results---2OR7s table tbody .group-name---4h2hg,\n    .component---1ZGCL .live-maths-results---2OR7s table tbody .course-name---WOhz3 {\n      background-color: #e4eaef; }\n  .component---1ZGCL .live-maths-results---2OR7s table tbody .group-name---4h2hg {\n      font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1ZGCL",
	"live-maths-results": "live-maths-results---2OR7s",
	"col-header": "col-header---2ucfA",
	"class-name": "class-name---3bbOG",
	"level": "level---3dMl0",
	"group-name": "group-name---4h2hg",
	"course-name": "course-name---WOhz3",
	"student-name": "student-name---9oT0e",
	"level-picker": "level-picker---3ypKG"
};

/***/ }),

/***/ "C3P3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GroupDropdown = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _dropdownHelpers = __webpack_require__("KmGe");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GroupDropdown = exports.GroupDropdown = /*#__PURE__*/function (_PureComponent) {
  function GroupDropdown() {
    var _this;
    _classCallCheck(this, GroupDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, GroupDropdown, [].concat(args));
    _defineProperty(_this, "optionSelected", function (selectedOption) {
      var _this$props = _this.props,
        setSelectedGroup = _this$props.setSelectedGroup,
        handleGroupChange = _this$props.handleGroupChange;
      setSelectedGroup(selectedOption);
      handleGroupChange();
    });
    return _this;
  }
  _inherits(GroupDropdown, _PureComponent);
  return _createClass(GroupDropdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        groupDropdownData = _this$props2.groupDropdownData,
        className = _this$props2.className;
      var data = groupDropdownData.data,
        selectedOption = groupDropdownData.selectedOption,
        disabled = groupDropdownData.disabled;
      var i18n = window.i18n;
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
        className: className,
        options: (0, _dropdownHelpers.getTranslatedOptions)(data, _filterConstants.ALL_GROUPS, i18n),
        selectedOption: (0, _dropdownHelpers.getTranslateSelectedOption)(selectedOption, _filterConstants.ALL_GROUPS, i18n),
        onSelectOption: this.optionSelected,
        disabled: disabled
      });
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(GroupDropdown, "propTypes", {
  groupDropdownData: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_filterPropTypes.dropdownItemPropType),
    selectedOption: _filterPropTypes.dropdownItemPropType,
    disabled: _propTypes["default"].bool
  }),
  className: _propTypes["default"].string,
  setSelectedGroup: _propTypes["default"].func,
  handleGroupChange: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    groupDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.GROUP_LIST)(state)
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setSelectedGroup: _dropdownDataActions["default"].setSelectedGroup
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GroupDropdown);

/***/ }),

/***/ "C6s8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _dayjs = _interopRequireDefault(__webpack_require__("oqQY"));
var _icon_calendar = _interopRequireDefault(__webpack_require__("ZaYO"));
var _reactComponents = __webpack_require__("fmgT");
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _moment = _interopRequireDefault(__webpack_require__("PJh5"));
var _calendar = _interopRequireDefault(__webpack_require__("KRbp"));
var _datePickerConstants = __webpack_require__("p2pT");
var _dateHelper = _interopRequireDefault(__webpack_require__("BiE+"));
var _datePickerTrans = _interopRequireDefault(__webpack_require__("7qIq"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * DatePicker component
 * Allows user to pick 'This week' 'Last week' 'This school year' or 'Custom date' from drop down.
 * Loads Calendar component if user chooses custom date range
 * Calls onDateChange callback prop when selection changes
 * User can pass in options list with translations
 */
/**
 * DatePickerTrans component
 * Allows user to pick 'This week' 'Last week' 'This school year' or 'Custom date' from drop down.
 * Loads Calendar component if user chooses custom date range
 * Calls onDateChange callback prop when selection changes
 */
var DatePickerTrans = /*#__PURE__*/function (_Component) {
  function DatePickerTrans(props) {
    var _this;
    _classCallCheck(this, DatePickerTrans);
    _this = _callSuper(this, DatePickerTrans, [props]);
    /**
     * Runs when user changes value in dropdown
     * Calls onDateChange prop with newly selected date range (unless user chose custom date)
     */
    _defineProperty(_this, "onDateChange", function (option) {
      _this.setState({
        selectedOption: option,
        useCustomDates: false,
        selectedTimeRange: false,
        dateTimeSubmitted: false
      });
      var startDate;
      var endDate;
      switch (option.value) {
        case _datePickerConstants.THIS_WEEK:
          var _DateHelper$getThisWe = _dateHelper["default"].getThisWeekStartEnd();
          startDate = _DateHelper$getThisWe.startDate;
          endDate = _DateHelper$getThisWe.endDate;
          break;
        case _datePickerConstants.LAST_WEEK:
          var _DateHelper$getLastWe = _dateHelper["default"].getLastWeekStartEnd();
          startDate = _DateHelper$getLastWe.startDate;
          endDate = _DateHelper$getLastWe.endDate;
          break;
        case _datePickerConstants.THIS_SCHOOL_YEAR:
        case _datePickerConstants.LIFETIME:
          var _this$props$academicY = _this.props.academicYear;
          startDate = _this$props$academicY.startDate;
          endDate = _this$props$academicY.endDate;
          break;
        case _datePickerConstants.CUSTOM_DATE:
          return;
        default:
          console.warn('Unhandled date type');
        // eslint-disable-line no-console
      }
      _this.props.onDateChange(option.value, startDate, endDate);
    });
    /**
     * Runs when user selects start & end dates in calendar component
     * Calls onDateChange prop with newly selected date range
     */
    _defineProperty(_this, "onCustomDateChange", function (startDate, endDate) {
      if (startDate && endDate) {
        var value = _this.state.selectedOption.value;
        _this.props.onDateChange(value, startDate, endDate);
        var label = _this.getSelectedLabel();
        _this.setState({
          selectedOption: {
            label: label,
            value: value
          },
          useCustomDates: true
        });
      }
    });
    /**
     * Reverts date to previous selection if user cancelled selecting custom dates in calendar
     */
    _defineProperty(_this, "onCustomDateClose", function () {
      // todo: i don't like this timeout but i couldn't get cancel functionality to
      // work without it
      setTimeout(function () {
        if (!_this.state.useCustomDates) {
          _this.setState({
            selectedOption: _this.getDefaultOption(),
            useCustomDates: true,
            hideSelectedTime: true
          });
        }
      });
    });
    /**
     * Generates the display text to show in the dropdown menu as the current selected option
     * Handles showing the date range if user chose custom date ie. 14 June 2018 - 28 June 2018
     */
    _defineProperty(_this, "getSelectedLabel", function () {
      var _this$state = _this.state,
        selectedOption = _this$state.selectedOption,
        localeCode = _this$state.localeCode;
      if (selectedOption.value === _datePickerConstants.CUSTOM_DATE) {
        var _this$props$currentDa = _this.props.currentDate,
          startDate = _this$props$currentDa.startDate,
          endDate = _this$props$currentDa.endDate;
        var formatString = 'DD MMM YYYY';
        _dayjs["default"].locale(localeCode);
        var formattedStartDate = (0, _dayjs["default"])(startDate).format(formatString);
        var formattedEndDate = (0, _dayjs["default"])(endDate).format(formatString);
        return "".concat(formattedStartDate, " - ").concat(formattedEndDate);
      }
      return selectedOption.label;
    });
    var currentDate = props.currentDate,
      locale = props.locale,
      academicYear = props.academicYear;
    /**
     * SET LOCALE
     * */
    var _localeCode = locale || 'en-AU';
    _dayjs["default"].locale(_localeCode.toLowerCase());
    _moment["default"].locale(locale);
    _this.state = {
      selectedOption: _this.getDefaultOption(),
      selectedDateType: currentDate.type,
      useCustomDates: currentDate.type === _datePickerConstants.CUSTOM_DATE,
      initialDate: academicYear
    };
    return _this;
  }
  _inherits(DatePickerTrans, _Component);
  return _createClass(DatePickerTrans, [{
    key: "getDefaultOption",
    value: function getDefaultOption() {
      var _this$props = this.props,
        options = _this$props.options,
        type = _this$props.currentDate.type;
      return options.find(function (option) {
        return option.value === type;
      }) || options[0];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state2 = this.state,
        selectedOption = _this$state2.selectedOption,
        useCustomDates = _this$state2.useCustomDates;
      var _this$props2 = this.props,
        academicYear = _this$props2.academicYear,
        options = _this$props2.options,
        calendarLocaleData = _this$props2.calendarLocaleData,
        initialDate = _this$props2.initialDate,
        locale = _this$props2.locale;
      var selectedDateType = selectedOption.value;
      /**
       * This boolean hides or shows the calendar component when required
       * for date range selection types for CustomDate or CustomDateTime
       * It is hidden again after selection of the range which may also include a time
       * @type {boolean}
       */
      var shouldDisplayCalendar = selectedDateType === _datePickerConstants.CUSTOM_DATE && !useCustomDates;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _datePickerTrans["default"]['date-picker-wrapper']
      }, shouldDisplayCalendar && /*#__PURE__*/_react["default"].createElement(_calendar["default"], {
        range: academicYear,
        onDatesPicked: this.onCustomDateChange,
        initialDate: initialDate,
        onClose: this.onCustomDateClose,
        localeData: calendarLocaleData,
        locale: locale
      }), !shouldDisplayCalendar && /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
        icon: _icon_calendar["default"],
        options: options,
        selectedOption: {
          label: this.getSelectedLabel(),
          value: selectedDateType
        },
        onSelectOption: function onSelectOption(option) {
          return _this2.onDateChange(option);
        }
      }));
    }
  }]);
}(_react.Component);
_defineProperty(DatePickerTrans, "propTypes", {
  /** Range to limit the date selection to */
  academicYear: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }).isRequired,
  /** Current selected date */
  currentDate: _propTypes["default"].shape({
    type: _propTypes["default"].oneOf(_datePickerConstants.DATE_OPTIONS),
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }).isRequired,
  initialDate: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }),
  /** locale code */
  locale: _propTypes["default"].string,
  /** Options to display in dropdown menu */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].oneOf(_datePickerConstants.DATE_OPTIONS)
  }).isRequired).isRequired,
  /** Callback when a date selection is made */
  onDateChange: _propTypes["default"].func.isRequired,
  /**
   * calendarLocaleData
   */
  calendarLocaleData: _propTypes["default"].object
});
_defineProperty(DatePickerTrans, "defaultProps", {
  options: _datePickerConstants.DEFAULT_DATE_OPTIONS_OBJ
});
var _default = exports["default"] = (0, _reactStyleable["default"])(_datePickerTrans["default"])(DatePickerTrans);

/***/ }),

/***/ "CPa0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".container---3U5jb {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: inherit;\n  min-height: 35px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  min-width: 33px; }\n\n.icon---q2Ygt {\n  width: 16px;\n  height: 17px;\n  margin-left: 3px; }\n\n.icon---q2Ygt svg path {\n    fill: #ffc90d !important; }\n\n.percentage---1lmJb {\n  margin-left: auto;\n  padding-right: 10px; }\n\n.mastered---1kCTo {\n  background: #37c97c; }\n\n.consolidating---Gnhsc {\n  background: #81daab; }\n\n.developing---21yER {\n  background: #f69e13; }\n\n.emerging---_-P7P {\n  background: #e06d3f; }\n\n.needsImproving---2rGVR {\n  background: #c53902; }\n\n.white---3AvIK {\n  color: #fff; }\n\n.gold-bars---1i7_c {\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500; }\n", ""]);

// exports
exports.locals = {
	"container": "container---3U5jb",
	"icon": "icon---q2Ygt",
	"percentage": "percentage---1lmJb",
	"mastered": "mastered---1kCTo",
	"consolidating": "consolidating---Gnhsc",
	"developing": "developing---21yER",
	"emerging": "emerging---_-P7P",
	"needsImproving": "needsImproving---2rGVR",
	"white": "white---3AvIK",
	"gold-bars": "gold-bars---1i7_c"
};

/***/ }),

/***/ "Cl2Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _allClassesActions = __webpack_require__("OZAO");
var initialState = null;

/**
 * Live Maths - All Classes Reducer
 *
 * Consumes LIVE_MATHS_ALL_CLASSES_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _allClassesActions.LIVE_MATHS_ALL_CLASSES_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "Cz3N":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1m-jB {\n  height: 100%;\n  min-width: 1100px; }\n  .component---1m-jB > div {\n    height: 100%; }\n  .component---1m-jB .report-container---1H7tf {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1m-jB",
	"report-container": "report-container---1H7tf"
};

/***/ }),

/***/ "D2yU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _certificates = _interopRequireDefault(__webpack_require__("rrgl"));
var _useTranslations2 = __webpack_require__("HJbm");
var _urlHelper = _interopRequireDefault(__webpack_require__("uOny"));
var _constants = __webpack_require__("1QGX");
var _certificatesConfig = __webpack_require__("K6Yf");
var _singleClass = _interopRequireDefault(__webpack_require__("MyZd"));
var _allClassesConstants = __webpack_require__("Wsmd");
var _filterConstants = __webpack_require__("cdWI");
var _participationConstants = __webpack_require__("lWQf");
var _utils = __webpack_require__("v/Rl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SingleClassCertificates = function SingleClassCertificates(_ref) {
  var participationData = _ref.participationData,
    selectedClassroomId = _ref.selectedClassroomId,
    selectedGroupId = _ref.selectedGroupId,
    newCertificatesDownloadByType = _ref.newCertificatesDownloadByType,
    pastCertificatesDownloadByType = _ref.pastCertificatesDownloadByType,
    selectedYearGroupId = _ref.selectedYearGroupId,
    selectedTeacherId = _ref.selectedTeacherId;
  var _useCertificatesConfi = (0, _certificatesConfig.useCertificatesConfig)(),
    newCertificatesConfig = _useCertificatesConfi.newCertificatesConfig,
    pastCertificatesConfig = _useCertificatesConfi.pastCertificatesConfig;
  var _useTranslations = (0, _useTranslations2.useTranslations)(),
    certificates = _useTranslations.certificates,
    oldCertificates = _useTranslations.oldCertificates;
  var certificateProps = _objectSpread(_objectSpread({
    classroomId: selectedClassroomId,
    startDate: _urlHelper["default"].getQueryParamValue(_constants.START_DATE) || null,
    endDate: _urlHelper["default"].getQueryParamValue(_constants.END_DATE) || null,
    groupId: selectedGroupId,
    isForDownload: true
  }, selectedYearGroupId !== _filterConstants.ALL_YEARS && {
    yearGroupEnum: selectedYearGroupId
  }), {}, {
    teacherUserProfileId: selectedTeacherId === _filterConstants.ALL_TEACHERS ? _participationConstants.ALL_TEACHERS_ID : selectedTeacherId
  });
  var getNewCertificateDetails = function getNewCertificateDetails() {
    if (participationData) {
      if (selectedGroupId === _allClassesConstants.ALL_GROUPS_ID) return participationData.newCertificateDetails;
      var currentGroup = participationData.classroomGroupParticipations.find(function (classroomGroupParticipation) {
        return classroomGroupParticipation.id === selectedGroupId;
      });
      return currentGroup && currentGroup.newCertificateDetails;
    }
    return null;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _singleClass["default"].certificates
  }, /*#__PURE__*/_react["default"].createElement(_certificates["default"], _extends({
    config: newCertificatesConfig,
    heading: certificates,
    certificates: getNewCertificateDetails(),
    handleCertificateDownloadClick: function handleCertificateDownloadClick(payload) {
      var certificatesCount = payload.certificatesCount,
        certificateTypeName = payload.certificateTypeName;
      newCertificatesDownloadByType(_objectSpread(_objectSpread({}, payload), {}, {
        fileNameOverride: (0, _utils.getCertificateFilename)({
          certificatesCount: certificatesCount,
          certificateTypeName: certificateTypeName,
          title: participationData.classroomName,
          prefixCertificate: false
        })
      }));
    }
  }, certificateProps)), /*#__PURE__*/_react["default"].createElement(_certificates["default"], _extends({
    config: pastCertificatesConfig,
    heading: oldCertificates,
    isOldCertificates: true,
    certificates: participationData && participationData.certificateDetails,
    handleCertificateDownloadClick: function handleCertificateDownloadClick(payload) {
      var certificatesCount = payload.certificatesCount,
        certificateTypeName = payload.certificateTypeName;
      pastCertificatesDownloadByType(_objectSpread(_objectSpread({}, payload), {}, {
        fileNameOverride: (0, _utils.getCertificateFilename)({
          certificatesCount: certificatesCount,
          certificateTypeName: certificateTypeName,
          title: participationData.classroomName,
          prefixCertificate: false
        })
      }));
    }
  }, certificateProps)));
};
SingleClassCertificates.propTypes = {
  participationData: _propTypes["default"].object || null,
  selectedClassroomId: _propTypes["default"].number,
  selectedGroupId: _propTypes["default"].number,
  newCertificatesDownloadByType: _propTypes["default"].func,
  pastCertificatesDownloadByType: _propTypes["default"].func,
  selectedYearGroupId: _propTypes["default"].number,
  selectedTeacherId: _propTypes["default"].number
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_singleClass["default"])(SingleClassCertificates);

/***/ }),

/***/ "DUt9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.participationInfoPropType = exports.logInInfoPropType = exports["default"] = exports.certificatesPropType = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var certificatesPropType = exports.certificatesPropType = _propTypes["default"].shape({
  gold: _propTypes["default"].number,
  silver: _propTypes["default"].number,
  bronze: _propTypes["default"].number,
  goldBars: _propTypes["default"].number,
  total: _propTypes["default"].number
});
var participationInfoPropType = exports.participationInfoPropType = _propTypes["default"].shape({
  activityPoints: _propTypes["default"].number,
  liveMathsPoints: _propTypes["default"].number,
  skillQuestsPoints: _propTypes["default"].number
});
var logInInfoPropType = exports.logInInfoPropType = _propTypes["default"].shape({
  signIns: _propTypes["default"].number,
  timeOnline: _propTypes["default"].shape({
    hours: _propTypes["default"].number,
    minutes: _propTypes["default"].number
  })
});
var participationData = _propTypes["default"].shape({
  userProfileId: _propTypes["default"].number,
  certificates: certificatesPropType,
  participationInfo: participationInfoPropType || undefined,
  logInInfo: logInInfoPropType,
  topicParticipations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    name: _propTypes["default"].string,
    totalFirstAttempt: _propTypes["default"].number,
    totalHighestAttempt: _propTypes["default"].number,
    totalLatestAttempt: _propTypes["default"].number,
    activityParticipations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number,
      name: _propTypes["default"].string,
      firstAttemptResult: _propTypes["default"].number,
      highestAttemptResult: _propTypes["default"].number,
      latestAttemptResult: _propTypes["default"].number,
      firstVsLatest: _propTypes["default"].number,
      highestVsLatest: _propTypes["default"].number,
      firstVsHighest: _propTypes["default"].number
    }))
  }))
});
var _default = exports["default"] = {
  participationData: participationData
};

/***/ }),

/***/ "DtE0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _usage = _interopRequireDefault(__webpack_require__("GNMg"));
var _usageBlock = __webpack_require__("kZYZ");
var _useTranslations2 = __webpack_require__("g1tj");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Usage = function Usage(_ref) {
  var totalSignIns = _ref.totalSignIns,
    totalTimeOnline = _ref.totalTimeOnline,
    totalCurriculumPoints = _ref.totalCurriculumPoints,
    totalLiveMathsPoints = _ref.totalLiveMathsPoints,
    showGoldBars = _ref.showGoldBars,
    totalGoldBars = _ref.totalGoldBars;
  var hours = totalTimeOnline.hours,
    minutes = totalTimeOnline.minutes;
  var _useTranslations = (0, _useTranslations2.useTranslations)(),
    signIns = _useTranslations.signIns,
    timeOnline = _useTranslations.timeOnline,
    curriculumPoints = _useTranslations.curriculumPoints,
    liveMathsPoints = _useTranslations.liveMathsPoints,
    goldBars = _useTranslations.goldBars;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _usage["default"].container
  }, showGoldBars && /*#__PURE__*/_react["default"].createElement(_usageBlock.UsageBlock, {
    info: totalGoldBars,
    title: goldBars,
    variant: 'goldBar'
  }), /*#__PURE__*/_react["default"].createElement(_usageBlock.UsageBlock, {
    info: totalLiveMathsPoints,
    title: liveMathsPoints
  }), /*#__PURE__*/_react["default"].createElement(_usageBlock.UsageBlock, {
    info: totalCurriculumPoints,
    title: curriculumPoints
  }), /*#__PURE__*/_react["default"].createElement(_usageBlock.UsageBlock, {
    info: totalSignIns,
    title: signIns
  }), /*#__PURE__*/_react["default"].createElement(_usageBlock.UsageBlock, {
    info: "".concat(hours, "h ").concat(minutes, "min"),
    title: timeOnline
  }));
};
Usage.propTypes = {
  totalSignIns: _propTypes["default"].number,
  totalTimeOnline: _propTypes["default"].shape({
    hours: _propTypes["default"].number,
    minutes: _propTypes["default"].number
  }),
  totalCurriculumPoints: _propTypes["default"].number,
  totalLiveMathsPoints: _propTypes["default"].number,
  showGoldBars: _propTypes["default"].bool,
  totalGoldBars: _propTypes["default"].number
};
Usage.defaultProps = {
  totalSignIns: 0,
  totalTimeOnline: {
    hours: 0,
    minutes: 0
  },
  totalCurriculumPoints: 0,
  totalLiveMathsPoints: 0,
  totalGoldBars: 0,
  showGoldBars: false
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_usage["default"])(Usage);

/***/ }),

/***/ "DuU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderPercentageLines = exports.renderDateRange = exports.renderChartPoints = exports.getWeeks = exports.getMonths = exports.getDays = exports.getDateRange = exports.generateChartDataForWeeks = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _moment = _interopRequireDefault(__webpack_require__("PJh5"));
var _accuracyOverviewGraph = _interopRequireDefault(__webpack_require__("JfNJ"));
var _contextModal = _interopRequireDefault(__webpack_require__("vuxJ"));
var _contextModalConstants = __webpack_require__("FCoq");
var _accuracyOverview = __webpack_require__("HAQU");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// generates the horizontal lines with percentage values
var renderPercentageLines = exports.renderPercentageLines = function renderPercentageLines() {
  var PercentageLines = [];
  for (var i = 0; i <= 100; i += 10) {
    PercentageLines.unshift(/*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyOverviewGraph["default"].percentageLine,
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyOverviewGraph["default"].percentage
    }, i, "%"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyOverviewGraph["default"].line
    })));
  }
  return PercentageLines;
};

// function to return days when dates selected have range of 14 days or less
var getDays = exports.getDays = function getDays() {
  var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var fromYear = arguments.length > 2 ? arguments[2] : undefined;
  var toYear = arguments.length > 3 ? arguments[3] : undefined;
  var daysToDisplay = [];
  if (fromDate === '' || toDate === '') return daysToDisplay;
  fromDate = (0, _moment["default"])(fromDate);
  toDate = (0, _moment["default"])(toDate);
  for (var date = fromDate; date <= toDate;) {
    if (date.date() === 1) {
      daysToDisplay.push("".concat(date.date(), " ").concat(_accuracyOverview.MONTH_NAMES[date.month() % 12]));
    } else if (date.isSame(fromDate)) {
      daysToDisplay.push("".concat(fromDate.date(), " ").concat(_accuracyOverview.MONTH_NAMES[date.month() % 12], " ").concat(fromYear));
    } else if (date.isSame(toDate)) {
      daysToDisplay.push("".concat(date.date(), " ").concat(_accuracyOverview.MONTH_NAMES[date.month() % 12], " ").concat(toYear));
    } else {
      daysToDisplay.push("".concat(date.date()));
    }
    date = (0, _moment["default"])(date).add(1, _accuracyOverview.DAYS);
  }
  return daysToDisplay;
};
var getWeeks = exports.getWeeks = function getWeeks() {
  var fromDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var toDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var weeksToDisplay = [];
  if (fromDate === '' || toDate === '') return weeksToDisplay;
  var currentDate;
  for (var date = fromDate; date <= toDate;) {
    if (date.format('D MMM YYYY') === fromDate.format('D MMM YYYY') || date.format('D MMM YYYY') === toDate.format('D MMM YYYY')) {
      weeksToDisplay.push(date.format('D MMM YYYY'));
    } else {
      weeksToDisplay.push(date.format('D MMM'));
    }
    currentDate = date;
    date = (0, _moment["default"])(date).add(7, _accuracyOverview.DAYS);
  }

  // format last date on x-axis to have year
  weeksToDisplay[weeksToDisplay.length - 1] = (0, _moment["default"])(currentDate).format('D MMM YYYY');
  return weeksToDisplay;
};

// function to return months when dates selected have range 3 months or more
var getMonths = exports.getMonths = function getMonths(fromDate, start, end, fromYear, diffYear) {
  var monthsToDisplay = [];
  if (!fromDate) {
    return monthsToDisplay;
  }
  start = (0, _moment["default"])(start);
  end = (0, _moment["default"])(end);
  for (var date = fromDate.month(); date <= diffYear; date++) {
    if (date === fromDate.month()) {
      monthsToDisplay.push(start.format('D MMM YYYY'));
    } else if (date === diffYear) {
      monthsToDisplay.push(end.format('D MMM YYYY'));
    } else {
      monthsToDisplay.push(_accuracyOverview.MONTH_NAMES[date % 12]);
    }
  }
  return monthsToDisplay;
};

// based on the date range selected, returns days or months
var getDateRange = exports.getDateRange = function getDateRange() {
  var dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var datesToDisplay = [];
  var unitToDisplay = '';
  if (!dates) {
    return datesToDisplay;
  }
  var _dates$split = dates.split('-'),
    _dates$split2 = _slicedToArray(_dates$split, 2),
    start = _dates$split2[0],
    end = _dates$split2[1];
  var fromDate = (0, _moment["default"])(start);
  var toDate = (0, _moment["default"])(end);
  var fromYear = fromDate.year();
  var toYear = toDate.year();
  var daysDifference = toDate.diff(fromDate, 'days');
  if (daysDifference <= 0) {
    return [datesToDisplay, unitToDisplay];
  } else if (daysDifference <= 90) {
    datesToDisplay = getWeeks(fromDate, toDate);
    unitToDisplay = _accuracyOverview.WEEKS;
  } else {
    var diffYear = 12 * (toYear - fromYear) + toDate.month();
    datesToDisplay = getMonths(fromDate, start, end, fromYear, diffYear);
    unitToDisplay = _accuracyOverview.MONTHS;
  }
  return [datesToDisplay, unitToDisplay];
};

// generates the data on the x-axis (months, weeks or days)
var renderDateRange = exports.renderDateRange = function renderDateRange() {
  var dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (dates === '') return null;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    widthPerItem = _useState2[0],
    setWidthPerItem = _useState2[1];
  var Months = [];
  var width;
  var _getDateRange = getDateRange(dates),
    _getDateRange2 = _slicedToArray(_getDateRange, 1),
    dateRange = _getDateRange2[0];
  (0, _react.useEffect)(function () {
    width = window.document.getElementById(_accuracyOverview.MONTHS) && window.document.getElementById(_accuracyOverview.MONTHS).offsetWidth;
    setWidthPerItem(width / dateRange.length);
  }, [window.document.getElementById('month'), widthPerItem]);
  dateRange.forEach(function (date) {
    Months.push(/*#__PURE__*/_react["default"].createElement("div", {
      key: date,
      style: {
        width: "".concat(widthPerItem, "px")
      }
    }, date));
  });
  return Months;
};
var generateChartDataForWeeks = exports.generateChartDataForWeeks = function generateChartDataForWeeks() {
  var dates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var averageAccuracies = arguments.length > 1 ? arguments[1] : undefined;
  var chartData = [];
  if (dates === '' || !averageAccuracies) return chartData;
  var _dates$split3 = dates.split('-'),
    _dates$split4 = _slicedToArray(_dates$split3, 2),
    startDate = _dates$split4[0],
    endDate = _dates$split4[1];
  startDate = (0, _moment["default"])(startDate);
  endDate = (0, _moment["default"])(endDate);
  for (var date = startDate; date <= endDate;) {
    chartData.push({
      date: date.format('D MMM YYYY'),
      accuracy: null
    });
    date = (0, _moment["default"])(date).add(7, _accuracyOverview.DAYS);
  }
  chartData.forEach(function (data) {
    averageAccuracies.forEach(function (_ref) {
      var weekStartDate = _ref.weekStartDate,
        accuracy = _ref.accuracy;
      if ((0, _moment["default"])(weekStartDate).isSame((0, _moment["default"])(data.date), 'week')) {
        data.accuracy = accuracy;
      }
    });
  });
  return chartData;
};

/*
    renders the point on the graph
    point should be plotted based on accuracy and month/week/day combination
*/
var renderChartPoints = exports.renderChartPoints = function renderChartPoints(dates, averageAccuracies) {
  // calculate the width of each column based on the date range
  var width;
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    widthPerItem = _useState4[0],
    setWidthPerItem = _useState4[1];
  var ChartPoints = [];
  var chartData = generateChartDataForWeeks(dates, averageAccuracies);
  (0, _react.useEffect)(function () {
    width = window.document.getElementById(_accuracyOverview.MONTHS) && window.document.getElementById(_accuracyOverview.MONTHS).offsetWidth;
    setWidthPerItem(width / chartData.length);
  }, [window.document.getElementById('month'), widthPerItem]);

  // for each date range calculate the position when chart point will be placed
  chartData.forEach(function (data, index) {
    var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isMouseOverChartPoint = _useState6[0],
      setMouseOverChartPoint = _useState6[1];
    var currentAveragePointPosition = data.accuracy === null ? null : _accuracyOverview.GRAPH_HEIGHT - _accuracyOverview.GRAPH_HEIGHT / 100 * data.accuracy;
    var nextAveragePointPosition = null;
    var indexDifference;
    for (var i = index + 1; i < chartData.length; i++) {
      nextAveragePointPosition = chartData[i].accuracy === null ? null : _accuracyOverview.GRAPH_HEIGHT - _accuracyOverview.GRAPH_HEIGHT / 100 * chartData[i].accuracy;
      if (nextAveragePointPosition !== null) {
        indexDifference = i - index;
        break;
      }
    }
    ChartPoints.push(/*#__PURE__*/_react["default"].createElement("div", {
      key: data.date,
      className: _accuracyOverviewGraph["default"].chartLine,
      style: {
        width: "".concat(widthPerItem, "px")
      }
    }, data.accuracy !== null && /*#__PURE__*/_react["default"].createElement("span", {
      className: _accuracyOverviewGraph["default"].chartPointContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyOverviewGraph["default"].chartPoint,
      style: {
        top: currentAveragePointPosition
      },
      onMouseOver: function onMouseOver() {
        return setMouseOverChartPoint(true);
      },
      onMouseOut: function onMouseOut() {
        return setMouseOverChartPoint(false);
      }
    }, /*#__PURE__*/_react["default"].createElement(_contextModal["default"], {
      show: isMouseOverChartPoint,
      className: _accuracyOverviewGraph["default"].contextModal,
      onClickOutsideHandler: function onClickOutsideHandler() {},
      position: _contextModalConstants.CONTEXT_MODAL_POSITION.MODAL_DOWN
    }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("div", null, data.date), /*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyOverviewGraph["default"].accuracy
    }, data.accuracy, "%")))), /*#__PURE__*/_react["default"].createElement("svg", {
      height: _accuracyOverview.GRAPH_HEIGHT,
      width: widthPerItem,
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("polyline", {
      points: "".concat(widthPerItem / 2, ", ").concat(currentAveragePointPosition, ", ").concat(indexDifference * widthPerItem + widthPerItem / 2, ", ").concat(nextAveragePointPosition),
      style: {
        fill: 'none',
        stroke: '#1981c4',
        strokeWidth: 2
      }
    })))));
  });
  return ChartPoints;
};

/***/ }),

/***/ "DvSR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _singleClassActions = __webpack_require__("tYGa");
var initialState = null;

/**
 * Live Maths - Single Class Reducer
 *
 * Consumes LIVE_MATHS_CLASS_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _singleClassActions.LIVE_MATHS_CLASS_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "E3Lx":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("hyqk");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./sub-heading.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./sub-heading.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "EMUv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.initialState = exports.defaultState = void 0;
var _filterConstants = __webpack_require__("cdWI");
var _activeFiltersActions = __webpack_require__("3PpY");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialDate = _dateParamHelper["default"].getInitialDate();
var defaultState = exports.defaultState = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _filterConstants.SELECTED_YEAR_GROUP, {
  id: _filterConstants.ALL_YEARS,
  name: _filterConstants.ALL_YEARS
}), _filterConstants.SELECTED_TEACHER, {
  id: _filterConstants.ALL_TEACHERS,
  name: _filterConstants.ALL_TEACHERS
}), _filterConstants.SELECTED_CLASS, {
  id: _filterConstants.ALL_CLASSES,
  name: _filterConstants.ALL_CLASSES
}), _filterConstants.SELECTED_GROUP, {
  id: _filterConstants.ALL_GROUPS,
  name: _filterConstants.ALL_GROUPS
}), _filterConstants.SELECTED_STUDENT, {
  id: _filterConstants.ALL_STUDENTS,
  name: _filterConstants.ALL_STUDENTS
}), _filterConstants.SELECTED_REPORT, {
  id: _filterConstants.ACTIVITY_MASTERY,
  name: _filterConstants.ACTIVITY_MASTERY
}), _filterConstants.SELECTED_DATE, initialDate);
var initialState = exports.initialState = function initialState() {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _filterConstants.SELECTED_YEAR_GROUP, {
    id: null,
    name: null
  }), _filterConstants.SELECTED_TEACHER, {
    id: null,
    name: null
  }), _filterConstants.SELECTED_CLASS, {
    id: null,
    name: null
  }), _filterConstants.SELECTED_GROUP, {
    id: null,
    name: null
  }), _filterConstants.SELECTED_STUDENT, {
    id: null,
    name: null
  }), _filterConstants.SELECTED_REPORT, {
    id: null,
    name: null
  }), _filterConstants.SELECTED_DATE, {
    type: null,
    startDate: null,
    endDate: null
  });
};

/**
 * Active Filters Reducer
 *
 * Consumes SET_ACTIVE_FILTERS action
 * Consumes UPDATE_ACTIVE_FILTER action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current active filters
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _activeFiltersActions.SET_ACTIVE_FILTERS:
      return _objectSpread(_objectSpread({}, state), action.payload);
    case _activeFiltersActions.UPDATE_ACTIVE_FILTER:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.filterName, action.payload.filterValue));
    default:
      return state;
  }
}

/***/ }),

/***/ "EWtM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1DBy");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./format-picker.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./format-picker.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "EWyL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _selectedImprovementsActions = __webpack_require__("ad0G");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {};

/**
 * Participation Student - Selected Improvements Reducer
 * Contains current state of what improvement calculation type user has selected per topic table
 *
 * Consumes CLEAR_SELECTED_IMPROVEMENTS action
 * Consumes SET_DEFAULT_SELECTED_IMPROVEMENTS action
 * Consumes UPDATE_SELECTED_IMPROVEMENT action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _selectedImprovementsActions.CLEAR_SELECTED_IMPROVEMENTS:
      return initialState;
    case _selectedImprovementsActions.SET_DEFAULT_SELECTED_IMPROVEMENTS:
      return action.payload;
    case _selectedImprovementsActions.UPDATE_SELECTED_IMPROVEMENT:
      {
        var _action$payload = action.payload,
          topicId = _action$payload.topicId,
          selectedImprovement = _action$payload.selectedImprovement;
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, topicId, selectedImprovement));
      }
    default:
      return state;
  }
}

/***/ }),

/***/ "EaW9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEAKNESS_TAB = exports.TOPICS_TABLE_CONFIG = exports.TITLE = exports.STRENGTH_TAB = exports.SCORE_BAND_COLOURS = exports.ALL_CLASSES_STRENGTH_WEAKNESSES_TABLE_CONFIG = exports.ACTIVITIES_TABLE_CONFIG = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _strengthWeaknessTopic = _interopRequireDefault(__webpack_require__("6FKu"));
var _localeHelpers = __webpack_require__("rjLd");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CLASS_NAME = 'classroomName';
var TITLE = exports.TITLE = 'title';
var STRENGTH_TAB = exports.STRENGTH_TAB = 0;
var WEAKNESS_TAB = exports.WEAKNESS_TAB = 1;
var SCORE_BAND_COLOURS = exports.SCORE_BAND_COLOURS = {
  MASTERED: '#37c97c',
  CONSOLIDATING: '#81daab',
  DEVELOPING: '#f69e13',
  EMERGING: '#e06d3f',
  POOR: '#c53902',
  DEFAULT: '#ffffff'
};
var ALL_CLASSES_STRENGTH_WEAKNESSES_TABLE_CONFIG = exports.ALL_CLASSES_STRENGTH_WEAKNESSES_TABLE_CONFIG = {
  cols: [{
    id: CLASS_NAME,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.ALL_CLASSES),
    doTranslation: true,
    truncate: true
  }, {
    id: TITLE,
    name: 'Relative strengths',
    doTranslation: true,
    transform: function transform(row) {
      return /*#__PURE__*/_react["default"].createElement(_strengthWeaknessTopic["default"], {
        topicName: row.title,
        result: row.averageResult
      });
    }
  }],
  colGroups: []
};
var TOPICS_TABLE_CONFIG = exports.TOPICS_TABLE_CONFIG = {
  cols: [{
    id: TITLE,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.TOPICS),
    doTranslation: true,
    transform: function transform(row) {
      return /*#__PURE__*/_react["default"].createElement(_strengthWeaknessTopic["default"], {
        topicName: row.title,
        result: row.averageResult
      });
    }
  }],
  colGroups: []
};
var ACTIVITIES_TABLE_CONFIG = exports.ACTIVITIES_TABLE_CONFIG = {
  cols: [{
    id: TITLE,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.ACTIVITIES),
    doTranslation: true,
    transform: function transform(row) {
      return /*#__PURE__*/_react["default"].createElement(_strengthWeaknessTopic["default"], {
        topicName: row.title,
        result: row.averageResult
      });
    }
  }],
  colGroups: []
};

/***/ }),

/***/ "EeH8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _strengthAndWeaknessesConstants = __webpack_require__("EaW9");
var _strengthWeaknessTab = _interopRequireDefault(__webpack_require__("/wMX"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays Strengths & Weaknesses tabs and tables for topics & activities
 * Used by Class, Group & Student views for Activity Mastery
 */
var TopicActivityStrengthWeakness = /*#__PURE__*/function (_PureComponent) {
  function TopicActivityStrengthWeakness(props) {
    var _this;
    _classCallCheck(this, TopicActivityStrengthWeakness);
    _this = _callSuper(this, TopicActivityStrengthWeakness, [props]);
    _defineProperty(_this, "tabClicked", function (tab) {
      _this.setState({
        currentTab: tab
      });
    });
    _defineProperty(_this, "getTableConfig", function (configData) {
      var config = (0, _cloneDeep["default"])(configData);
      var cols = config.cols;
      cols.map(function (col) {
        if (col.doTranslation && _this.i18n) {
          col.name = _this.i18n._(col.name);
        }
        return col;
      });
      return config;
    });
    _this.state = {
      currentTab: _strengthAndWeaknessesConstants.STRENGTH_TAB
    };
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(TopicActivityStrengthWeakness, _PureComponent);
  return _createClass(TopicActivityStrengthWeakness, [{
    key: "render",
    value: function render() {
      var currentTab = this.state.currentTab;
      var _this$props = this.props,
        strengths = _this$props.strengths,
        weaknesses = _this$props.weaknesses;
      var isStrengthTab = currentTab === _strengthAndWeaknessesConstants.STRENGTH_TAB;
      return /*#__PURE__*/_react["default"].createElement(_strengthWeaknessTab["default"], {
        onTabClick: this.tabClicked,
        isStrengthTab: isStrengthTab
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: this.getTableConfig(_strengthAndWeaknessesConstants.TOPICS_TABLE_CONFIG),
        data: isStrengthTab ? strengths.topics : weaknesses.topics
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: this.getTableConfig(_strengthAndWeaknessesConstants.ACTIVITIES_TABLE_CONFIG),
        data: isStrengthTab ? strengths.activities : weaknesses.activities
      }));
    }
  }]);
}(_react.PureComponent);
_defineProperty(TopicActivityStrengthWeakness, "propTypes", {
  strengths: _propTypes["default"].shape({
    activities: _propTypes["default"].array,
    topics: _propTypes["default"].array
  }),
  weaknesses: _propTypes["default"].shape({
    activities: _propTypes["default"].array,
    topics: _propTypes["default"].array
  })
});
var _default = exports["default"] = TopicActivityStrengthWeakness;

/***/ }),

/***/ "Etod":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scorePropType = exports.liveMathsResultPropType = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var scorePropType = exports.scorePropType = _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]);
var liveMathsResultPropType = exports.liveMathsResultPropType = _propTypes["default"].shape({
  id: _propTypes["default"].number,
  level: _propTypes["default"].number,
  topScore: scorePropType,
  questionsPerMinute: scorePropType,
  totalCorrect: scorePropType,
  accuracy: _propTypes["default"].string
});

/***/ }),

/***/ "Ey8b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liveMathsLevelPropType = exports.liveMathsClassPropType = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var liveMathsClassPropType = exports.liveMathsClassPropType = _propTypes["default"].shape({
  id: _propTypes["default"].number,
  name: _propTypes["default"].string,
  totalCorrect: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  topScore: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  accuracy: _propTypes["default"].string,
  questionsPerMinute: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
});
var liveMathsLevelPropType = exports.liveMathsLevelPropType = _propTypes["default"].shape({
  level: _propTypes["default"].string,
  classes: _propTypes["default"].arrayOf(liveMathsClassPropType)
});

/***/ }),

/***/ "F6Ua":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TopicTables = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _studentPropTypes = _interopRequireDefault(__webpack_require__("DUt9"));
var _topicTables = _interopRequireDefault(__webpack_require__("JmQc"));
var _studentConstants = __webpack_require__("OCle");
var _selectedImprovementsActions = _interopRequireDefault(__webpack_require__("ad0G"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays all topic tables for a student with their participation scores
 */
var TopicTables = exports.TopicTables = /*#__PURE__*/function (_PureComponent) {
  function TopicTables(props) {
    var _this;
    _classCallCheck(this, TopicTables);
    _this = _callSuper(this, TopicTables, [props]);
    _defineProperty(_this, "changeImprovementCol", function (topicId, option) {
      var baseConfig;
      switch (option.value) {
        case _studentConstants.FIRST_VS_LATEST:
          baseConfig = _studentConstants.FIRST_VS_LATEST_TABLE_CONFIG;
          break;
        case _studentConstants.FIRST_VS_HIGHEST:
          baseConfig = _studentConstants.FIRST_VS_HIGEST_TABLE_CONFIG;
          break;
        case _studentConstants.HIGHEST_VS_LATEST:
          baseConfig = _studentConstants.HIGHEST_VS_LATEST_TABLE_CONFIG;
          break;
        default:
      }
      var topicTableConfigs = _objectSpread(_objectSpread({}, _this.state.topicTableConfigs), {}, _defineProperty({}, topicId, _this.generateTopicTableConfig(baseConfig, topicId, true, option)));
      _this.setState({
        topicTableConfigs: topicTableConfigs
      });
      _this.props.updateSelectedImprovement({
        topicId: topicId,
        selectedImprovement: option.value
      });
    });
    _defineProperty(_this, "getColFromConfig", function (config, colId) {
      return config.cols.find(function (col) {
        return col.id === colId;
      });
    });
    _defineProperty(_this, "setColNameTranslations", function (tableConfig) {
      var _tableConfig$nestedDa = tableConfig.nestedData,
        emptyDataMessage = _tableConfig$nestedDa.emptyDataMessage,
        messageTopicTable = _tableConfig$nestedDa.messageTopicTable;
      var i18n = _this.i18n;
      tableConfig.nestedData.emptyDataMessage = i18n._(emptyDataMessage);
      tableConfig.nestedData.messageTopicTable = i18n._(messageTopicTable);
      tableConfig.cols.map(function (col) {
        if (col.name) {
          col.name = i18n._(col.name);
        }
        return col;
      });
      return tableConfig;
    });
    _this.i18n = window.i18n;
    _this.state = {
      // each topic table needs its own config to keep track of which improvement type is currently selected
      topicTableConfigs: {}
    };
    return _this;
  }
  _inherits(TopicTables, _PureComponent);
  return _createClass(TopicTables, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var participationData = this.props.participationData;
      var newParticipationData = newProps.participationData;
      if (newParticipationData !== participationData) {
        this.setTableConfigs(newParticipationData);
      }
    }

    /**
     * Sets the table config for each individual topic table
     */
  }, {
    key: "setTableConfigs",
    value: function setTableConfigs(participationData) {
      var _this2 = this;
      var topicTableConfigs = {};
      participationData.topicParticipations.forEach(function (topic, idx) {
        topicTableConfigs[topic.id] = _this2.generateTopicTableConfig(_studentConstants.FIRST_VS_LATEST_TABLE_CONFIG, topic.id, idx === 0);
      });
      this.setState({
        topicTableConfigs: topicTableConfigs
      });
    }
  }, {
    key: "generateTopicTableConfig",
    value: function generateTopicTableConfig(baseConfig, topicId, expand) {
      var _this3 = this;
      var option = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _studentConstants.IMPROVEMENT_OPTS[0];
      var selectedOption = _objectSpread({}, option);
      selectedOption.label = /*#__PURE__*/_react["default"].createElement("span", null, this.i18n._('Label - Improvement'), /*#__PURE__*/_react["default"].createElement("br", null), this.i18n._(selectedOption.label));
      var tableConfig = (0, _cloneDeep["default"])(baseConfig);
      tableConfig.nestedData.collapse.expandFirst = expand;
      var improvementCol = this.getColFromConfig(tableConfig, _studentConstants.IMPROVEMENT);
      var improvementOpts = _studentConstants.IMPROVEMENT_OPTS.map(function (optionOpt) {
        return _objectSpread(_objectSpread({}, optionOpt), {}, {
          label: _this3.i18n._(optionOpt.label)
        });
      });
      improvementCol.headerTransform = function () {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
          options: improvementOpts,
          selectedOption: selectedOption,
          onSelectOption: function onSelectOption(selected) {
            return _this3.changeImprovementCol(topicId, selected);
          },
          className: _topicTables["default"]['improvement-dropdown']
        }));
      };
      return tableConfig;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var topicTableConfigs = this.state.topicTableConfigs;
      var participationData = this.props.participationData;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _topicTables["default"].component
      }, participationData && participationData.topicParticipations.map(function (topic) {
        var tableConfig = topicTableConfigs[topic.id];
        if (!tableConfig) {
          return null;
        }
        tableConfig = _this4.setColNameTranslations(tableConfig);
        var messageTopicTable = tableConfig.nestedData.messageTopicTable;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _topicTables["default"]['topic-table'],
          key: topic.id
        }, /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
          config: tableConfig,
          data: [topic]
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: _topicTables["default"]['topic-table-msg']
        }, messageTopicTable));
      }));
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers
 */
_defineProperty(TopicTables, "propTypes", {
  participationData: _studentPropTypes["default"].participationData,
  updateSelectedImprovement: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    participationData: state.participationStudent
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    updateSelectedImprovement: _selectedImprovementsActions["default"].updateSelectedImprovement
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TopicTables);

/***/ }),

/***/ "FCoq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTEXT_MODAL_POSITION = void 0;
var CONTEXT_MODAL_POSITION = exports.CONTEXT_MODAL_POSITION = {
  MODAL_UP: 'MODAL_UP',
  MODAL_DOWN: 'MODAL_DOWN'
};

/***/ }),

/***/ "FDbR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PARTICIPATION_ALL_CLASSES_RETRIEVED = void 0;
var _orderBy = _interopRequireDefault(__webpack_require__("Ba3q"));
var _filterConstants = __webpack_require__("cdWI");
var _constants = __webpack_require__("1QGX");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _certificateConstants = __webpack_require__("tQue");
var _studentClassesActions = _interopRequireDefault(__webpack_require__("TEzo"));
var _allClassesConstants = __webpack_require__("Wsmd");
var _localeHelpers = __webpack_require__("rjLd");
var _utils = __webpack_require__("v/Rl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PARTICIPATION_ALL_CLASSES_RETRIEVED = exports.PARTICIPATION_ALL_CLASSES_RETRIEVED = 'PARTICIPATION_ALL_CLASSES_RETRIEVED';
function getParticipationData(selectedDate, selectedYearGroupId, selectedTeacherId) {
  return function (dispatch, getState) {
    var state = getState();
    if (state.isAdmin === true) {
      getAdminData(dispatch, selectedDate, selectedYearGroupId, selectedTeacherId);
    } else {
      getTeacherData(dispatch, selectedDate);
    }
  };
}
function getByClassData(selectedDate) {
  return function (dispatch) {
    return _resources["default"].byClassReport.get(_dateParamHelper["default"].getDateTypePath(selectedDate)).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDate)).send().then(function (payload) {
      if (payload.valid) {
        dispatch({
          type: PARTICIPATION_ALL_CLASSES_RETRIEVED,
          payload: mapParticipationData(payload.data)
        });
      } else {
        dispatch(_errorsActions["default"].addError(PARTICIPATION_ALL_CLASSES_RETRIEVED));
      }
    });
  };
}
function getTop10StudentsData(selectedDate) {
  return function (dispatch) {
    return _resources["default"].top10StudentsReport.get(_dateParamHelper["default"].getDateTypePath(selectedDate)).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDate)).send().then(function (payload) {
      if (payload.valid) {
        dispatch(_studentClassesActions["default"].setStudentClasses(payload.data.topStudentParticipations));
        dispatch({
          type: PARTICIPATION_ALL_CLASSES_RETRIEVED,
          payload: mapTop10StudentsData(payload.data)
        });
      } else {
        dispatch(_errorsActions["default"].addError(PARTICIPATION_ALL_CLASSES_RETRIEVED));
      }
    });
  };
}
function getAdminData(dispatch, selectedDate, selectedYearGroupId, selectedTeacherId) {
  var yearGroupId = _constants.ENDPOINT_PATH_ALL_YEARS;
  var teacherId = _constants.ENDPOINT_PATH_ALL_TEACHERS;
  var resource = 'yearGroupReport';
  if (selectedYearGroupId != null && selectedYearGroupId !== _filterConstants.ALL_YEARS) {
    yearGroupId = selectedYearGroupId;
  }
  if (selectedTeacherId != null && selectedTeacherId !== _filterConstants.ALL_TEACHERS) {
    teacherId = selectedTeacherId;
    resource = 'teacherReport';
  }
  var params = _objectSpread(_objectSpread({
    reportType: _constants.ENDPOINT_PATH_PARTICIPATION
  }, _dateParamHelper["default"].getDateTypePath(selectedDate)), {}, {
    yearGroupId: yearGroupId,
    teacherId: teacherId
  });
  getData(resource, dispatch, selectedDate, params);
}
function getTeacherData(dispatch, selectedDate) {
  getData('allClassesReport', dispatch, selectedDate);
}
function getData(resource, dispatch, selectedDate) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = (0, _localeHelpers.localeCode)();
  params = _objectSpread(_objectSpread({
    reportType: _constants.ENDPOINT_PATH_PARTICIPATION
  }, _dateParamHelper["default"].getDateTypePath(selectedDate)), params);
  _resources["default"][resource].get(params).withParams(_objectSpread(_objectSpread({}, _dateParamHelper["default"].getDateQueryParams(selectedDate)), {}, {
    locale: locale
  })).send().then(function (payload) {
    if (payload.valid) {
      dispatch({
        type: PARTICIPATION_ALL_CLASSES_RETRIEVED,
        payload: mapParticipationData(payload.data)
      });
    } else {
      dispatch(_errorsActions["default"].addError(PARTICIPATION_ALL_CLASSES_RETRIEVED));
    }
  });
}

// Helper function to map past certificates
function getPastCertificatesTableConfig(_ref) {
  var _ref$bronze = _ref.bronze,
    bronze = _ref$bronze === void 0 ? 0 : _ref$bronze,
    _ref$silver = _ref.silver,
    silver = _ref$silver === void 0 ? 0 : _ref$silver,
    _ref$gold = _ref.gold,
    gold = _ref$gold === void 0 ? 0 : _ref$gold;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _certificateConstants.BRONZE.id, bronze), _certificateConstants.SILVER.id, silver), _certificateConstants.GOLD.id, gold), _allClassesConstants.PAST_CERTIFICATES_TOTAL, bronze + silver + gold);
}

// Helper function to map new certificates
function getNewCertificatesTableConfig(_ref3) {
  var newCertificate = _ref3.newCertificate;
  var bronze = newCertificate.bronze,
    silver = newCertificate.silver,
    gold = newCertificate.gold,
    platinum = newCertificate.platinum,
    emerald = newCertificate.emerald,
    diamond = newCertificate.diamond,
    epic = newCertificate.epic,
    legend = newCertificate.legend,
    total = newCertificate.total;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _allClassesConstants.NEW_CERTIFICATES_BRONZE, bronze), _allClassesConstants.NEW_CERTIFICATES_SILVER, silver), _allClassesConstants.NEW_CERTIFICATES_GOLD, gold), _allClassesConstants.NEW_CERTIFICATES_PLATINUM, platinum), _allClassesConstants.NEW_CERTIFICATES_EMERALD, emerald), _allClassesConstants.NEW_CERTIFICATES_DIAMOND, diamond), _allClassesConstants.NEW_CERTIFICATES_EPIC, epic), _allClassesConstants.NEW_CERTIFICATES_LEGEND, legend), _allClassesConstants.NEW_CERTIFICATES_TOTAL, total);
}
function mapParticipationData(data) {
  var mappedParticipation = data.classroomParticipations.map(function (result) {
    var pastCertificates = getPastCertificatesTableConfig(result);
    var newCertificates = getNewCertificatesTableConfig(result);
    return _objectSpread(_objectSpread(_objectSpread({}, result), {}, {
      id: result.classroomId
    }, pastCertificates), newCertificates);
  });
  return {
    classroomParticipations: mappedParticipation,
    classroomUsage: mapUsage(data),
    certificates: mapCertificates(data),
    newCertificate: mapNewCertificates(data)
  };
}
function mapTop10StudentsData(data) {
  return {
    classroomParticipations: (0, _orderBy["default"])(data.topStudentParticipations.map(function (student) {
      var pastCertificates = getPastCertificatesTableConfig(student);
      var newCertificates = getNewCertificatesTableConfig(student);
      var mappedStudent = _objectSpread(_objectSpread(_objectSpread({}, student), {}, {
        id: student.userProfileId,
        classroomName: "".concat(student.firstName, " ").concat(student.lastName)
      }, pastCertificates), newCertificates);
      delete mappedStudent.userProfileId;
      delete mappedStudent.firstName;
      delete mappedStudent.lastName;
      delete mappedStudent.classroomId;
      return mappedStudent;
    }), ['totalPoints'], ['desc']),
    classroomUsage: mapUsage(_objectSpread(_objectSpread({}, data), {}, {
      classroomParticipations: data.topStudentParticipations
    })),
    certificates: mapCertificates(data),
    newCertificate: mapNewCertificates(data)
  };
}
function mapUsage(data) {
  var defaultTimeOnline = {
    hours: 0,
    minutes: 0
  };
  var _getTotalCurriculumAn = (0, _utils.getTotalCurriculumAndLivePoints)(data.classroomParticipations),
    totalCurriculumPoints = _getTotalCurriculumAn.totalCurriculumPoints,
    totalLiveMathsPoints = _getTotalCurriculumAn.totalLiveMathsPoints;
  return [{
    id: 0,
    totalSignIns: data.totalSignIns || 0,
    totalTimeOnline: data.totalTimeOnline || defaultTimeOnline,
    totalActivityPoints: data.totalActivityPoints || 0,
    totalLiveMathsPoints: totalLiveMathsPoints,
    totalCurriculumPoints: totalCurriculumPoints,
    totalSkillQuestsPoints: data.totalSkillQuestsPoints || 0,
    totalActivityTimeOnline: data.totalActivityTimeOnline || defaultTimeOnline,
    totalSkillQuestsTimeOnline: data.totalSkillQuestsTimeOnline || defaultTimeOnline
  }];
}
function mapCertificates(data) {
  var gold = data.totalGold || 0;
  var silver = data.totalSilver || 0;
  var bronze = data.totalBronze || 0;
  return {
    gold: gold,
    silver: silver,
    bronze: bronze,
    total: gold + silver + bronze
  };
}
function mapNewCertificates(_ref5) {
  var _ref5$newCertificate = _ref5.newCertificate,
    _ref5$newCertificate$ = _ref5$newCertificate.bronze,
    bronze = _ref5$newCertificate$ === void 0 ? 0 : _ref5$newCertificate$,
    _ref5$newCertificate$2 = _ref5$newCertificate.diamond,
    diamond = _ref5$newCertificate$2 === void 0 ? 0 : _ref5$newCertificate$2,
    _ref5$newCertificate$3 = _ref5$newCertificate.gold,
    gold = _ref5$newCertificate$3 === void 0 ? 0 : _ref5$newCertificate$3,
    _ref5$newCertificate$4 = _ref5$newCertificate.emerald,
    emerald = _ref5$newCertificate$4 === void 0 ? 0 : _ref5$newCertificate$4,
    _ref5$newCertificate$5 = _ref5$newCertificate.epic,
    epic = _ref5$newCertificate$5 === void 0 ? 0 : _ref5$newCertificate$5,
    _ref5$newCertificate$6 = _ref5$newCertificate.legend,
    legend = _ref5$newCertificate$6 === void 0 ? 0 : _ref5$newCertificate$6,
    _ref5$newCertificate$7 = _ref5$newCertificate.platinum,
    platinum = _ref5$newCertificate$7 === void 0 ? 0 : _ref5$newCertificate$7,
    _ref5$newCertificate$8 = _ref5$newCertificate.silver,
    silver = _ref5$newCertificate$8 === void 0 ? 0 : _ref5$newCertificate$8,
    _ref5$newCertificate$9 = _ref5$newCertificate.total,
    total = _ref5$newCertificate$9 === void 0 ? 0 : _ref5$newCertificate$9;
  return {
    gold: gold,
    silver: silver,
    bronze: bronze,
    diamond: diamond,
    emerald: emerald,
    epic: epic,
    legend: legend,
    platinum: platinum,
    total: total
  };
}
var _default = exports["default"] = {
  getParticipationData: getParticipationData,
  getByClassData: getByClassData,
  getTop10StudentsData: getTop10StudentsData
};

/***/ }),

/***/ "FGgR":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".badge-style---2EeWE {\n  height: 25px;\n  width: 50px;\n  border-radius: 15px;\n  text-align: center;\n  color: rgba(0, 0, 0, .7);\n  font-size: 14px;\n  font-weight: 600; }\n  .badge-style---2EeWE div {\n    padding-top: 3px; }\n", ""]);

// exports
exports.locals = {
	"badge-style": "badge-style---2EeWE"
};

/***/ }),

/***/ "FLtZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _invalidRequestActions = _interopRequireDefault(__webpack_require__("oHUn"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_MSG = 'Something went wrong...';

/**
 * Global error handling for 3p resources requests
 * Checks the HTTP status code of the response and logs error & displays error modal
 * if not a success code
 */
var ErrorHandling = /*#__PURE__*/function () {
  function ErrorHandling() {
    _classCallCheck(this, ErrorHandling);
  }
  return _createClass(ErrorHandling, null, [{
    key: "addResourceResponseErrorInterceptor",
    value: function addResourceResponseErrorInterceptor(dispatch) {
      var interceptor = ErrorHandling.handleErrors.bind(this, dispatch);
      _resources["default"].env.addResponseInterceptor(interceptor);
    }
  }, {
    key: "handleErrors",
    value: function handleErrors(dispatch, result) {
      var message;
      var valid = false;
      try {
        switch (result.status) {
          case 200:
          case 201:
          case 202:
          case 203:
          case 204:
            valid = true;
            break;
          default:
            message = this.getErrorMessage(result);
        }
      } catch (e) {
        var i18n = window.i18n;
        message = i18n._('Message - SomethingWrong');
      }
      if (valid === false) {
        console.error(message); // eslint-disable-line no-console
        var _i18n = window.i18n;
        dispatch(_modalActions["default"].openModal({
          content: message,
          buttons: [{
            text: _i18n._('Label - OK'),
            primary: true,
            handler: function handler() {
              dispatch(_invalidRequestActions["default"].invalidRequestMade());
              dispatch(_modalActions["default"].closeModal());
            }
          }]
        }));
      }

      // still want actions creators to have access to the response incase they need to do
      // anything special, so we add valid property they can access to check the status
      result.valid = valid;
      return result;
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(response) {
      if (response.data) {
        return this.getMessageString(response.data);
      } else if (response.message) {
        return this.getMessageString(response.message);
      }
      return DEFAULT_MSG;
    }
  }, {
    key: "getMessageString",
    value: function getMessageString(item) {
      if (item.message && typeof item.message === 'string') {
        return item.message;
      } else if (typeof item === 'string') {
        return item;
      }
      return DEFAULT_MSG;
    }
  }]);
}();
var _default = exports["default"] = ErrorHandling;

/***/ }),

/***/ "FOJt":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("FGgR");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./badge.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./badge.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "FkcL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UPDATE_DROPDOWN_DATA_ITEM = exports.SET_DROPDOWN_DATA = void 0;
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _filterConstants = __webpack_require__("cdWI");
var _studentsByGroupActions = _interopRequireDefault(__webpack_require__("dFjD"));
var _yearGroupsSelectors = _interopRequireDefault(__webpack_require__("Hi7O"));
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _studentsByGroupSelectors = _interopRequireDefault(__webpack_require__("gYwg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var SET_DROPDOWN_DATA = exports.SET_DROPDOWN_DATA = 'SET_DROPDOWN_DATA';
var UPDATE_DROPDOWN_DATA_ITEM = exports.UPDATE_DROPDOWN_DATA_ITEM = 'UPDATE_DROPDOWN_DATA_ITEM';

/**
 * Updates the dropdown data in the state for each list passed in
 * Merges data with the current state
 *
 * @param {object} lists - should have list type as key, with value of an object containing properties that need
 * to be overridden in the dropdown data (data, selectedOption, disabled), any properties not provided will keep
 * their current value
 *  {
 *      [CLASS_LIST]: { data: [...], selectedOption: {...} },
 *      [GROUP_LIST]: { selectedOption: {...} }
 *  }
 */
function setDropdownData(lists) {
  return function (dispatch, getState) {
    var _getState = getState(),
      prevDropdownData = _getState.dropdownData;
    var dropdownData = (0, _cloneDeep["default"])(prevDropdownData);
    var listTypes = [_filterConstants.YEAR_GROUP_LIST, _filterConstants.TEACHER_LIST, _filterConstants.CLASS_LIST, _filterConstants.GROUP_LIST, _filterConstants.STUDENT_LIST, _filterConstants.REPORT_LIST, _filterConstants.DATE_LIST];
    listTypes.forEach(function (listType) {
      var listItem = lists[listType];
      if (listItem) {
        var dropdown = dropdownData.find(function (dd) {
          return dd.type === listType;
        });
        if (dropdown) {
          var data;
          var selectedOption = listItem.selectedOption || _filterConstants.LIST_TO_ALL_OPTION[listType];
          var disabled = listItem.disabled;

          // if only one item in list we set as selected option and disable list
          // if more than one item we add in the all option as first in list
          if (listItem.data) {
            var allOption = _filterConstants.LIST_TO_ALL_OPTION[listType];
            if (listItem.data.length > 1) {
              if (allOption) {
                if (listItem.data[0].value === allOption.value) {
                  data = listItem.data;
                } else {
                  data = [allOption].concat(_toConsumableArray(listItem.data));
                }
              }
              disabled = false;
            } else {
              data = listItem.data;
              disabled = true;
              if (allOption && listItem.data[0] && listItem.data[0].value !== allOption.value) {
                data = [allOption].concat(_toConsumableArray(listItem.data));
                disabled = false;
              }
            }
          }
          dropdown.data = data || dropdown.data;
          dropdown.selectedOption = selectedOption || dropdown.selectedOption;
          dropdown.disabled = disabled != null ? disabled : dropdown.disabled;
        }
      }
    });
    dispatch({
      type: SET_DROPDOWN_DATA,
      payload: dropdownData
    });
  };
}

/**
 * Sets year group and teacher data in dropdowns
 */
function setYearGroups(yearGroupData) {
  return function (dispatch, getState) {
    var state = getState();
    var selectedYearId = _activeFiltersSelectors["default"].selectYearGroupId(state);
    var selectedTeacherId = _activeFiltersSelectors["default"].selectTeacherId(state);
    dispatch(setDropdownData(_defineProperty(_defineProperty(_defineProperty({}, _filterConstants.YEAR_GROUP_LIST, {
      data: yearGroupData.map(function (y) {
        return {
          value: y.id,
          label: y.year
        };
      })
    }), _filterConstants.TEACHER_LIST, {
      data: _yearGroupsSelectors["default"].selectTeachersByYear(selectedYearId)(state)
    }), _filterConstants.CLASS_LIST, {
      data: _yearGroupsSelectors["default"].selectClassesByYearAndTeacher(selectedYearId, selectedTeacherId)(state)
    })));
  };
}

/**
 * Sets properties of the class dropdown list using the passed in class list
 * Handles auto selecting class and disabling if teacher has only 1 class
 */
function setClassroomList(classData) {
  return function (dispatch) {
    dispatch(setDropdownData(_defineProperty({}, _filterConstants.CLASS_LIST, {
      data: classData.map(function (classRoom) {
        return {
          label: classRoom.name,
          value: classRoom.id,
          isClassEmpty: classRoom.isClassEmpty
        };
      })
    })));
  };
}

/**
 * Sets properties of group and student dropdown lists using group
 * data from backend
 */
function setGroupAndStudentLists(groups) {
  return function (dispatch) {
    dispatch(setDropdownData(_defineProperty(_defineProperty({}, _filterConstants.GROUP_LIST, {
      data: groups.map(function (group) {
        return {
          label: group.name,
          value: group.id
        };
      })
    }), _filterConstants.STUDENT_LIST, {
      data: groups.length > 0 ? groups[0].students : []
    })));
  };
}

/**
 * Sets the selected options of the drop down menus from the active filters
 */
function setSelectedOptionsFromFilters(activeFilters) {
  return function (dispatch, getState) {
    var state = getState();
    var lists = {};
    for (var key in activeFilters) {
      var dropdownType = _filterConstants.FILTER_TO_DROPDOWN_MAP[key];
      if (dropdownType) {
        var dropdownItem = {};
        var data = getDropdownDataFromFilters(dropdownType, activeFilters, state);
        if (data) {
          dropdownItem.data = data;
        }
        if (dropdownType === _filterConstants.STUDENT_LIST) {
          var selectedClassId = activeFilters[_filterConstants.SELECTED_CLASS].id;
          var selectedGroupId = activeFilters[_filterConstants.SELECTED_GROUP].id;
          var students = _studentsByGroupSelectors["default"].selectStudentsForGroup(selectedGroupId)(state);
          if (students && selectedGroupId !== _filterConstants.ALL_GROUPS && selectedClassId !== _filterConstants.ALL_CLASSES) {
            dropdownItem.data = students;
          }
        }
        if (dropdownType === _filterConstants.DATE_LIST) {
          dropdownItem.selectedOption = activeFilters[key];
        } else {
          dropdownItem.selectedOption = {
            value: activeFilters[key].id,
            label: activeFilters[key].name
          };
        }
        lists[dropdownType] = dropdownItem;
      }
    }
    dispatch(setDropdownData(lists));
  };
}
function getDropdownDataFromFilters(dropdownType, activeFilters, state) {
  var selectedYearGroup = activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id !== null ? activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id : _filterConstants.ALL_YEARS;
  var selectedTeacher = activeFilters[_filterConstants.SELECTED_TEACHER].id || _filterConstants.ALL_TEACHERS;
  var selectedGroup = activeFilters[_filterConstants.SELECTED_GROUP];
  switch (dropdownType) {
    case _filterConstants.TEACHER_LIST:
      {
        return _yearGroupsSelectors["default"].selectTeachersByYear(selectedYearGroup)(state);
      }
    case _filterConstants.CLASS_LIST:
      {
        return _yearGroupsSelectors["default"].selectClassesByYearAndTeacher(selectedYearGroup, selectedTeacher)(state);
      }
    case _filterConstants.STUDENT_LIST:
      {
        if (selectedGroup.id !== _filterConstants.ALL_GROUPS) {
          return _studentsByGroupSelectors["default"].selectStudentsForGroup(selectedGroup)(state);
        }
        return _dropdownDataSelectors["default"].selectDropdownDataDatalistByType(dropdownType)(state);
      }
    default:
      return _dropdownDataSelectors["default"].selectDropdownDataDatalistByType(dropdownType)(state);
  }
}

/**
 * Sets year group as selected option in dropdown data
 * Filters both teacher and class lists to only ones within the selected year
 * If selected teacher has classes within that year, keeps selected else selects All teachers
 * If selected class is within that year, keeps selected else selects All classes
 */
function setSelectedYearGroup(option) {
  return function (dispatch, getState) {
    var state = getState();
    var selectedYearGroup = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.YEAR_GROUP_LIST)(state);
    if (selectedYearGroup.value !== option.value) {
      var yearId = option.value;

      // If user has previously selected a teacher in dropdown, keep selection if teacher has
      // classes within the year group, else select All teachers
      var teachers = _yearGroupsSelectors["default"].selectTeachersByYear(yearId)(state);
      var selectedTeacher = _filterConstants.ALL_TEACHERS_OPTION;
      var ddTeacher = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.TEACHER_LIST)(state);
      if (teachers.find(function (t) {
        return t.value === ddTeacher.value;
      })) {
        selectedTeacher = ddTeacher;
      }
      var classes = _yearGroupsSelectors["default"].selectClassesByYearAndTeacher(yearId, selectedTeacher.value)(state);
      setDropdownDataForYearGroupTeacher(dispatch, state, classes, _defineProperty(_defineProperty({}, _filterConstants.YEAR_GROUP_LIST, {
        selectedOption: option
      }), _filterConstants.TEACHER_LIST, {
        data: teachers,
        selectedOption: selectedTeacher
      }));
    }
  };
}

/**
 * Sets teacher as selected option
 * Filters class list to only those classes that belong to the teacher, keeps
 * the year filter applied if user has selected a school year
 */
function setSelectedTeacher(option) {
  return function (dispatch, getState) {
    var state = getState();
    var selectedTeacher = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.TEACHER_LIST)(state);
    if (selectedTeacher.value !== option.value) {
      var selectedYear = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.YEAR_GROUP_LIST)(state);
      var classes = _yearGroupsSelectors["default"].selectClassesByYearAndTeacher(selectedYear.value, option.value)(state);
      setDropdownDataForYearGroupTeacher(dispatch, state, classes, _defineProperty({}, _filterConstants.TEACHER_LIST, {
        selectedOption: option
      }));
    }
  };
}

/**
 * Handles the shared logic between setting selected year group + teacher
 * Dispatches action to set dropdown data
 * Either retrieves group + student data if there is only one class in year/teacher combo, or clears
 * current group + student data in redux store
 */
function setDropdownDataForYearGroupTeacher(dispatch, state, classes, ddOptions) {
  // If user has previously selected a class in dropdown, keep selection if class is
  // for the selected year/teacher combo, else select All classes
  var ddClass = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.CLASS_LIST)(state);
  var selectedClass = _filterConstants.ALL_CLASSES_OPTION;
  var groupStudentOptions = _defineProperty(_defineProperty({}, _filterConstants.GROUP_LIST, {
    data: [_filterConstants.ALL_GROUPS_OPTION]
  }), _filterConstants.STUDENT_LIST, {
    data: [_filterConstants.ALL_STUDENTS_OPTION]
  });
  if (classes.find(function (c) {
    return c.value === ddClass.value;
  })) {
    selectedClass = ddClass;
    groupStudentOptions = {};
  }
  dispatch(setDropdownData(_objectSpread(_objectSpread(_defineProperty({}, _filterConstants.CLASS_LIST, {
    data: classes,
    selectedOption: selectedClass
  }), groupStudentOptions), ddOptions)));
  if (classes.length === 1) {
    dispatch(_studentsByGroupActions["default"].getStudentsByGroup(classes[0].value));
  } else {
    dispatch(_studentsByGroupActions["default"].resetStudentsByGroup());
  }
}

/**
 * Sets class as selected in dropdown data
 * If user selects All Classes, updates group & student list data and selected option
 * If user selects a particular class, loads the groups & students for the class
 */
function setSelectedClass(option) {
  return function (dispatch, getState) {
    var selectedClass = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.CLASS_LIST)(getState());
    if (selectedClass.value !== option.value) {
      if (option.value !== _filterConstants.ALL_CLASSES) {
        dispatch(_studentsByGroupActions["default"].getStudentsByGroup(option.value));
      }
      dispatch(setDropdownData(_defineProperty(_defineProperty(_defineProperty({}, _filterConstants.CLASS_LIST, {
        selectedOption: option
      }), _filterConstants.GROUP_LIST, {
        data: [_filterConstants.ALL_GROUPS_OPTION]
      }), _filterConstants.STUDENT_LIST, {
        data: [_filterConstants.ALL_STUDENTS_OPTION]
      })));
    }
  };
}

/**
 * Sets group as selected in dropdown data
 * If user selects All groups, updates student list data and selected option
 * If user selects particular group, filters student list to only those in the group
 */
function setSelectedGroup(option) {
  return function (dispatch, getState) {
    var state = getState();
    var selectedGroup = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.GROUP_LIST)(state);
    if (selectedGroup.value !== option.value) {
      var updatedDropdownData = _defineProperty({}, _filterConstants.GROUP_LIST, {
        selectedOption: option
      });
      var group = _studentsByGroupSelectors["default"].selectGroupById(option.value)(state);
      if (group) {
        updatedDropdownData[_filterConstants.STUDENT_LIST] = {
          data: group.students,
          selectedOption: _filterConstants.ALL_STUDENTS_OPTION
        };
      }
      dispatch(setDropdownData(updatedDropdownData));
    }
  };
}

/**
 * Sets student as selected in dropdown data
 * If user selects particular student, updates selected group to that student's group
 */
function setSelectedStudent(option) {
  return function (dispatch, getState) {
    var dropdownData;
    var state = getState();
    var selectedStudent = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.STUDENT_LIST)(state);
    if (selectedStudent.value !== option.value) {
      if (option.value === _filterConstants.ALL_STUDENTS) {
        dropdownData = _defineProperty({}, _filterConstants.STUDENT_LIST, {
          selectedOption: option
        });
      } else {
        var studentGroup = _studentsByGroupSelectors["default"].selectGroupForStudent(option.value)(getState());
        dropdownData = _defineProperty(_defineProperty({}, _filterConstants.GROUP_LIST, {
          selectedOption: {
            label: studentGroup.name,
            value: studentGroup.id
          }
        }), _filterConstants.STUDENT_LIST, {
          selectedOption: option
        });
      }
      dispatch(setDropdownData(dropdownData));
    }
  };
}
function setSelectedDate(option) {
  return function (dispatch, getState) {
    var dateOption = _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.DATE_LIST)(getState());
    dispatch({
      type: UPDATE_DROPDOWN_DATA_ITEM,
      payload: {
        type: _filterConstants.DATE_LIST,
        item: _objectSpread(_objectSpread({}, dateOption), {}, {
          selectedOption: option
        })
      }
    });
  };
}
var _default = exports["default"] = {
  setDropdownData: setDropdownData,
  setYearGroups: setYearGroups,
  setClassroomList: setClassroomList,
  setGroupAndStudentLists: setGroupAndStudentLists,
  setSelectedOptionsFromFilters: setSelectedOptionsFromFilters,
  setSelectedYearGroup: setSelectedYearGroup,
  setSelectedTeacher: setSelectedTeacher,
  setSelectedClass: setSelectedClass,
  setSelectedGroup: setSelectedGroup,
  setSelectedStudent: setSelectedStudent,
  setSelectedDate: setSelectedDate
};

/***/ }),

/***/ "FmmL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _modalActions = __webpack_require__("iUhG");
var _modalContainer = _interopRequireDefault(__webpack_require__("RzCX"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var defaultState = [];

/**
 * Modal Reducer
 *
 * Consumes OPEN_MODAL action
 * Consumes CLOSE_MODAL action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - current list of modals to display
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _modalActions.OPEN_MODAL:
      return [].concat(_toConsumableArray(state), [{
        id: state.length,
        title: action.payload.title,
        content: action.payload.content,
        buttons: action.payload.buttons,
        className: _modalContainer["default"].modal
      }]);
    case _modalActions.CLOSE_MODAL:
      return state.slice(0, state.length - 1);
    case _modalActions.UPDATE_MODAL:
      {
        if (!state.length) return state;
        var newState = _toConsumableArray(state);
        newState[newState.length - 1].buttons = action.payload.buttons;
        return newState;
      }
    default:
      return state;
  }
}

/***/ }),

/***/ "GLqN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1nVCu {\n  position: fixed;\n  z-index: 200;\n  -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, .2) inset;\n          box-shadow: 0 0 20px rgba(0, 0, 0, .2) inset;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, .2);\n  cursor: wait; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1nVCu"
};

/***/ }),

/***/ "GNMg":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6Iqk");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./usage.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./usage.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "GaDw":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".modal---3w9Tf {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"modal": "modal---3w9Tf"
};

/***/ }),

/***/ "GcYt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exportLiveMathsReport;
var _liveMathsDataConverter = _interopRequireDefault(__webpack_require__("HeCi"));
var _exportReportActions = __webpack_require__("oXgP");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Calculates the export parameters needed for the current live maths report
 */
function exportLiveMathsReport(getState, reportLevel) {
  var state = getState();
  var liveMathsLevel = state.liveMathsLevel,
    liveMathsAllClasses = state.liveMathsAllClasses,
    liveMathsSingleClass = state.liveMathsSingleClass;
  var selectedDate = _activeFiltersSelectors["default"].selectDate(state);
  var resourcesMethod = _exportReportActions.EXPORT_RESOURCE_METHODS[reportLevel];
  var params = {
    reportType: 'live-maths',
    fileFormat: _exportReportActions.FILE_FORMAT.PDF
  };
  var data;
  switch (reportLevel) {
    case _exportReportActions.REPORT_LEVEL_ALL_YEARS:
    case _exportReportActions.REPORT_LEVEL_ALL_CLASSES:
    case _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER:
      {
        data = _liveMathsDataConverter["default"].convertAllClasses(liveMathsAllClasses, selectedDate, liveMathsLevel, _activeFiltersSelectors["default"].selectExportReportHeading(state), reportLevel === _exportReportActions.REPORT_LEVEL_ALL_YEARS);
        if (reportLevel === _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER) {
          params.yearGroupId = _activeFiltersSelectors["default"].selectYearGroupIdForApi(state);
          params.teacherId = _activeFiltersSelectors["default"].selectTeacherIdForApi(state);
        }
        break;
      }
    case _exportReportActions.REPORT_LEVEL_SINGLE_CLASS:
    case _exportReportActions.REPORT_LEVEL_GROUP:
      data = _liveMathsDataConverter["default"].convertSingleClass(liveMathsSingleClass, selectedDate, liveMathsLevel, reportLevel === _exportReportActions.REPORT_LEVEL_GROUP ? _activeFiltersSelectors["default"].selectGroupId(state) : null);
      params.classroomId = _activeFiltersSelectors["default"].selectClassId(state);
      break;
    default:
      return null;
  }
  return {
    data: data,
    resourcesMethod: resourcesMethod,
    params: params
  };
}

/***/ }),

/***/ "Gczr":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/0199959ab3dc6e166d30f1d36bc77e0b.svg";

/***/ }),

/***/ "GejO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValidCourses = exports.getUpdatedStrandLevelState = exports.getUpdatedStandardLevelState = exports.getUpdatedCourseLevelState = exports.getStrandKey = exports.getStandardKey = exports.getInitialTableProperties = exports.getCourseKey = exports.TOGGLE_TYPES = exports.STUDENT_REPORT_LEVELS = exports.DEFAULT_VALUES = void 0;
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
/**
 * CONSTANTS
 */
var TOGGLE_TYPES = exports.TOGGLE_TYPES = {
  ACCURACY: 'Accuracy',
  PROGRESS: 'Progress'
};
var DEFAULT_VALUES = exports.DEFAULT_VALUES = {
  PUBLICATION: 'null-publication',
  COURSES: 'null-course'
};
var STUDENT_REPORT_LEVELS = exports.STUDENT_REPORT_LEVELS = {
  COURSE: 'COURSE',
  STRAND: 'STRAND',
  STANDARD: 'STANDARD',
  TOPIC: 'TOPIC'
};

/**
 * TABLE HELPERS
 */
var getCourseKey = exports.getCourseKey = function getCourseKey(course) {
  return "[".concat(STUDENT_REPORT_LEVELS.COURSE, "-").concat(course.courseId, "-").concat(course.courseVersion, "]");
};
var getStrandKey = exports.getStrandKey = function getStrandKey(strand) {
  return "[".concat(STUDENT_REPORT_LEVELS.STRAND, "-").concat(strand.name, "]");
};
var getStandardKey = exports.getStandardKey = function getStandardKey(standard) {
  return "[".concat(STUDENT_REPORT_LEVELS.STANDARD, "-").concat(standard.id, "]");
};
var manageStandardTableProperties = function manageStandardTableProperties(tableProperties, courseKey, strandId, isExpanded) {
  var returnedStandardProperties = {};
  Object.keys(tableProperties[courseKey].subLevel[strandId].subLevel).forEach(function (standardId) {
    returnedStandardProperties[standardId] = {
      isExpanded: isExpanded
    };
  });
  return returnedStandardProperties;
};
var manageStrandProperties = function manageStrandProperties(tableProperties, courseKey, isExpanded) {
  var updatedStrandId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var returnedStrandProperties = {};
  Object.keys(tableProperties[courseKey].subLevel).forEach(function (strandId) {
    if (!updatedStrandId || updatedStrandId === strandId) {
      returnedStrandProperties[strandId] = {
        isExpanded: isExpanded,
        subLevel: manageStandardTableProperties(tableProperties, courseKey, strandId, isExpanded)
      };
    }
  });
  return returnedStrandProperties;
};

/**
 * COLLAPSE/EXPAND STATE MANAGEMENT
 */
var getIsExpandedByStatus = function getIsExpandedByStatus(status) {
  var IN_PROGRESS = _skillQuestsMasteryConstants.ASSIGNMENT_STATUSES.IN_PROGRESS,
    COMPLETED = _skillQuestsMasteryConstants.ASSIGNMENT_STATUSES.COMPLETED;
  return status === IN_PROGRESS || status === COMPLETED;
};
var getIsExpandedByStandard = function getIsExpandedByStandard(standards) {
  var isExpanded = false;
  standards.every(function (item) {
    if (getIsExpandedByStatus(item.status)) {
      isExpanded = true;
      return false;
    }
    return true;
  });
  return isExpanded;
};
var getInitialTableProperties = exports.getInitialTableProperties = function getInitialTableProperties(data) {
  var updatedTableProperties = {};
  if (data && data.reportData) {
    data.reportData.courses.forEach(function (course) {
      var courseKey = getCourseKey(course);
      updatedTableProperties[courseKey] = {
        isExpanded: true,
        subLevel: {}
      };
      course.strands.forEach(function (strand) {
        var strandKey = getStrandKey(strand);
        updatedTableProperties[courseKey].subLevel[strandKey] = {
          isExpanded: getIsExpandedByStandard(strand.standards),
          subLevel: {}
        };
        strand.standards.forEach(function (standard) {
          var standardKey = getStandardKey(standard);
          updatedTableProperties[courseKey].subLevel[strandKey].subLevel[standardKey] = {
            isExpanded: getIsExpandedByStatus(standard.status)
          };
        });
      });
    });
  }
  return updatedTableProperties;
};
var getUpdatedCourseLevelState = exports.getUpdatedCourseLevelState = function getUpdatedCourseLevelState(tableProperties, courseKey) {
  var isCourseExpanded = !tableProperties[courseKey].isExpanded;
  return {
    isExpanded: isCourseExpanded,
    subLevel: manageStrandProperties(tableProperties, courseKey, isCourseExpanded)
  };
};
var getUpdatedStrandLevelState = exports.getUpdatedStrandLevelState = function getUpdatedStrandLevelState(tableProperties, courseKey, strandKey) {
  var isStrandExpanded = !tableProperties[courseKey].subLevel[strandKey].isExpanded;
  return {
    isExpanded: isStrandExpanded,
    subLevel: manageStandardTableProperties(tableProperties, courseKey, strandKey, isStrandExpanded)
  };
};
var getUpdatedStandardLevelState = exports.getUpdatedStandardLevelState = function getUpdatedStandardLevelState(tableProperties, courseKey, strandKey, standardKey) {
  var isStandardExpanded = !tableProperties[courseKey].subLevel[strandKey].subLevel[standardKey].isExpanded;
  return {
    isExpanded: isStandardExpanded
  };
};
var hasValidCourses = exports.hasValidCourses = function hasValidCourses(skillQuestsMasteryStudentData) {
  return skillQuestsMasteryStudentData && skillQuestsMasteryStudentData.reportData && skillQuestsMasteryStudentData.reportData.courses.length > 0;
};

/***/ }),

/***/ "GyLB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _studentActions = __webpack_require__("AJmA");
var initialState = null;

/**
 * Live Maths - Student Reducer
 *
 * Consumes LIVE_MATHS_STUDENT_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _studentActions.LIVE_MATHS_STUDENT_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "Gylf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = __webpack_require__("2KeS");
var _modalReducer = _interopRequireDefault(__webpack_require__("FmmL"));
var _activeFiltersReducer = _interopRequireDefault(__webpack_require__("EMUv"));
var _allClassesReducer = _interopRequireDefault(__webpack_require__("xDjh"));
var _singleClassReducer = _interopRequireDefault(__webpack_require__("HUdG"));
var _studentReducer = _interopRequireDefault(__webpack_require__("agHL"));
var _allClassesReducer2 = _interopRequireDefault(__webpack_require__("S5uW"));
var _singleClassReducer2 = _interopRequireDefault(__webpack_require__("jipn"));
var _studentReducer2 = _interopRequireDefault(__webpack_require__("NMd/"));
var _selectedImprovementsReducer = _interopRequireDefault(__webpack_require__("EWyL"));
var _allClassesReducer3 = _interopRequireDefault(__webpack_require__("Cl2Y"));
var _singleClassReducer3 = _interopRequireDefault(__webpack_require__("DvSR"));
var _studentReducer3 = _interopRequireDefault(__webpack_require__("GyLB"));
var _allClassesReducer4 = _interopRequireDefault(__webpack_require__("0gIa"));
var _singleClassReducer4 = _interopRequireDefault(__webpack_require__("3ZNE"));
var _studentReducer4 = _interopRequireDefault(__webpack_require__("aFLC"));
var _academicYearReducer = _interopRequireDefault(__webpack_require__("95gl"));
var _classListReducer = _interopRequireDefault(__webpack_require__("WlvJ"));
var _studentsByGroupReducer = _interopRequireDefault(__webpack_require__("oxam"));
var _busyIndicatorReducer = _interopRequireDefault(__webpack_require__("i0Ya"));
var _errorsReducer = _interopRequireDefault(__webpack_require__("cjTm"));
var _invalidRequestReducer = _interopRequireDefault(__webpack_require__("6MX9"));
var _exportReportReducer = _interopRequireDefault(__webpack_require__("x3lM"));
var _hasLifetimeDataReducer = _interopRequireDefault(__webpack_require__("NNJ+"));
var _sessionIdReducer = _interopRequireDefault(__webpack_require__("j4FC"));
var _liveMathsLevelReducer = _interopRequireDefault(__webpack_require__("dstU"));
var _isAdminReducer = _interopRequireDefault(__webpack_require__("pK1W"));
var _dropdownDataReducer = _interopRequireDefault(__webpack_require__("KcYX"));
var _yearGroupsReducer = _interopRequireDefault(__webpack_require__("LH15"));
var _reportStateReducer = _interopRequireDefault(__webpack_require__("rFgw"));
var _studentClassesReducer = _interopRequireDefault(__webpack_require__("+4pX"));
var _downloadReportReducer = _interopRequireDefault(__webpack_require__("0OCq"));
var _formatPickerReducer = _interopRequireDefault(__webpack_require__("q6Kz"));
var _assignmentResultReducer = _interopRequireDefault(__webpack_require__("llwb"));
var _gemsReducer = _interopRequireDefault(__webpack_require__("X3Xz"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CombinedReducers = (0, _redux.combineReducers)({
  /* activity mastery */
  activityMasteryAllClasses: _allClassesReducer["default"],
  activityMasterySingleClass: _singleClassReducer["default"],
  activityMasteryStudent: _studentReducer["default"],
  /* participation */
  participationAllClasses: _allClassesReducer2["default"],
  reportState: _reportStateReducer["default"],
  studentClasses: _studentClassesReducer["default"],
  participationSingleClass: _singleClassReducer2["default"],
  participationStudent: _studentReducer2["default"],
  selectedImprovements: _selectedImprovementsReducer["default"],
  /* live maths */
  liveMathsAllClasses: _allClassesReducer3["default"],
  liveMathsSingleClass: _singleClassReducer3["default"],
  liveMathsStudent: _studentReducer3["default"],
  liveMathsLevel: _liveMathsLevelReducer["default"],
  /* skill quests mastery */
  skillQuestsMasteryAllClasses: _allClassesReducer4["default"],
  skillQuestsMasterySingleClass: _singleClassReducer4["default"],
  skillQuestsMasteryStudent: _studentReducer4["default"],
  /* filters */
  activeFilters: _activeFiltersReducer["default"],
  academicYear: _academicYearReducer["default"],
  yearGroups: _yearGroupsReducer["default"],
  allClasses: _classListReducer["default"],
  studentsByGroup: _studentsByGroupReducer["default"],
  hasLifetimeData: _hasLifetimeDataReducer["default"],
  isAdmin: _isAdminReducer["default"],
  dropdownData: _dropdownDataReducer["default"],
  assignmentResultType: _assignmentResultReducer["default"],
  gemsDetails: _gemsReducer["default"],
  /* export */
  exportedReport: _exportReportReducer["default"],
  downloadReport: _downloadReportReducer["default"],
  formatReport: _formatPickerReducer["default"],
  /* fundamentals */
  modalMessages: _modalReducer["default"],
  busyIndicatorCount: _busyIndicatorReducer["default"],
  errors: _errorsReducer["default"],
  invalidRequest: _invalidRequestReducer["default"],
  sessionId: _sessionIdReducer["default"]
});
var _default = exports["default"] = CombinedReducers;

/***/ }),

/***/ "H7F4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
var _urlHelper = _interopRequireDefault(__webpack_require__("uOny"));
var _constants = __webpack_require__("1QGX");
var _activeFiltersReducer = __webpack_require__("EMUv");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for managing the relationship between the route & query params and the
 * active filters in the app
 */
var RouteHelper = exports["default"] = /*#__PURE__*/function () {
  function RouteHelper() {
    _classCallCheck(this, RouteHelper);
  }
  return _createClass(RouteHelper, null, [{
    key: "calculateRouteFromFilters",
    value:
    /**
     * Calculates the route we need to load according to the user's selected filters
     * @param {object} activeFilters - corresponds to activeFilters object in redux store
     */
    function calculateRouteFromFilters(activeFilters) {
      var route = this.getBasePath(activeFilters[_filterConstants.SELECTED_REPORT].id);
      var yearGroupId = this.getFilterId(activeFilters, _filterConstants.SELECTED_YEAR_GROUP);
      var teacherId = this.getFilterId(activeFilters, _filterConstants.SELECTED_TEACHER);
      var classId = this.getFilterId(activeFilters, _filterConstants.SELECTED_CLASS);
      var groupId = this.getFilterId(activeFilters, _filterConstants.SELECTED_GROUP);
      var studentId = this.getFilterId(activeFilters, _filterConstants.SELECTED_STUDENT);
      if (studentId != null && studentId !== _filterConstants.ALL_STUDENTS) {
        route += "/".concat(_constants.CLASS_PATH, "/").concat(classId, "/").concat(_constants.STUDENT_PATH, "/").concat(studentId);
      } else if (groupId != null && groupId !== _filterConstants.ALL_GROUPS) {
        route += "/".concat(_constants.CLASS_PATH, "/").concat(classId, "/").concat(_constants.GROUP_PATH, "/").concat(groupId);
      } else if (classId != null && classId !== _filterConstants.ALL_CLASSES) {
        route += "/".concat(_constants.CLASS_PATH, "/").concat(classId);
      } else if (teacherId != null && teacherId !== _filterConstants.ALL_TEACHERS) {
        if (yearGroupId != null && yearGroupId !== _filterConstants.ALL_YEARS) {
          route += "/".concat(_constants.YEAR_GROUP_PATH, "/").concat(yearGroupId);
        }
        route += "/".concat(_constants.TEACHER_PATH, "/").concat(teacherId);
      } else if (yearGroupId != null && yearGroupId !== _filterConstants.ALL_YEARS) {
        route += "/".concat(_constants.YEAR_GROUP_PATH, "/").concat(yearGroupId);
      }
      return route;
    }

    /**
     * Calculates the date query params from the active filters
     */
  }, {
    key: "calculateParamsFromFilters",
    value: function calculateParamsFromFilters(activeFilters) {
      var selectedDate = activeFilters[_filterConstants.SELECTED_DATE];
      var startDate = selectedDate.startDate,
        endDate = selectedDate.endDate;
      var params = "dateType=".concat(_constants.DATE_TYPE_MAP[selectedDate.type]);
      if (startDate) {
        params += "&startDate=".concat(startDate);
      }
      if (endDate) {
        params += "&endDate=".concat(endDate);
      }
      return params;
    }

    /**
     * Calculates the user's active filters based on their route
     * Route should be in one of 7 formats:
     *  base (all classes or all years): /activity-mastery
     *  year group: /activity-mastery/year/4
     *  teacher: /activity-mastery/teacher/5678
     *  teacher within year group: /activity-mastery/year/4/teacher/5678
     *  single class: /activity-mastery/class/21
     *  group: /activity-mastery/class/21/group/1
     *  student: /activity-mastery/class/21/student/1234
     *
     * Selected date type and start/end date come as query params
     */
  }, {
    key: "calculateFiltersFromRoute",
    value: function calculateFiltersFromRoute(route, params, allClasses, studentsByGroup, yearGroups, teachers, currentActiveFilters) {
      var activeFilters = _objectSpread({}, _activeFiltersReducer.defaultState);
      var segments = route.split('/').filter(function (segment) {
        return segment;
      });
      var reportType = this.getReportType("/".concat(segments[0]));
      activeFilters[_filterConstants.SELECTED_REPORT] = {
        id: reportType,
        name: reportType
      };
      if (segments.length > 2) {
        activeFilters = _objectSpread(_objectSpread({}, activeFilters), this.getFiltersFromPageType(segments, allClasses, studentsByGroup, yearGroups, teachers, currentActiveFilters));
      }
      activeFilters[_filterConstants.SELECTED_DATE] = this.calculateDateFiltersFromParams(params);
      return activeFilters;
    }

    /**
     * Calculates the filters from the route when it has a page type eg. activity-mastery/class/34
     * Applies to year group, teacher and any class routes (class, group, student)
     */
  }, {
    key: "getFiltersFromPageType",
    value: function getFiltersFromPageType(segments, allClasses, studentsByGroup, yearGroups, teachers, currentActiveFilters) {
      var pageType = segments[1];
      var itemId = +segments[2];
      switch (pageType) {
        case _constants.CLASS_PATH:
          {
            var childPageType = _constants.CLASS_PATH;
            var childPageItemId;
            if (segments.length > 3) {
              childPageType = segments[3];
              childPageItemId = +segments[4];
            }
            return this.getFiltersForChildPage(itemId, childPageType, childPageItemId, allClasses, studentsByGroup, currentActiveFilters);
          }
        case _constants.YEAR_GROUP_PATH:
          {
            var filters = {};
            if (segments.length > 3) {
              var teacherId = +segments[4];
              var teacher = teachers.find(function (t) {
                return t.value === teacherId;
              });
              var _name = teacher.label;
              filters[_filterConstants.SELECTED_TEACHER] = {
                id: teacherId,
                name: _name
              };
            }
            var yearGroup = yearGroups.find(function (y) {
              return y.id === itemId;
            });
            var name = yearGroup.year;
            filters[_filterConstants.SELECTED_YEAR_GROUP] = {
              id: itemId,
              name: name
            };
            return filters;
          }
        case _constants.TEACHER_PATH:
          {
            var _teacher = teachers.find(function (t) {
              return t.value === itemId;
            });
            var _name2 = _teacher.label;
            return _defineProperty({}, _filterConstants.SELECTED_TEACHER, {
              id: itemId,
              name: _name2
            });
          }
        default:
          console.warn('Unhandled path segment', pageType); // eslint-disable-line no-console
          return {};
      }
    }
  }, {
    key: "calculateDateFiltersFromParams",
    value: function calculateDateFiltersFromParams(params) {
      var dateTypeParam = _urlHelper["default"].getQueryParamValue(_constants.DATE_TYPE, params);
      if (dateTypeParam != null) {
        var dateType = _constants.DATE_PARAM_MAP[dateTypeParam];
        if (dateType) {
          return {
            type: dateType,
            startDate: _urlHelper["default"].getQueryParamValue(_constants.START_DATE, params) || null,
            endDate: _urlHelper["default"].getQueryParamValue(_constants.END_DATE, params) || null
          };
        }
      }
      return {
        type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR,
        startDate: null,
        endDate: null
      };
    }

    /**
     * Checks value of each date param in the params string provided
     * Returns true if any of them are different
     */
  }, {
    key: "getFilterId",
    value: function getFilterId(activeFilters, filterName) {
      return _activeFiltersSelectors["default"].selectItemId(filterName)({
        activeFilters: activeFilters
      });
    }
  }, {
    key: "calculateSelectedClassFromRoute",
    value: function calculateSelectedClassFromRoute(route, allClasses) {
      var segments = route.split('/').filter(function (segment) {
        return segment;
      });
      if (segments.length > 2 && segments[1] === _constants.CLASS_PATH) {
        var classId = +segments[2];
        return allClasses.find(function (classItem) {
          return classItem.id === classId;
        });
      }
      return null;
    }
  }, {
    key: "getBasePath",
    value: function getBasePath(reportType) {
      return _constants.REPORT_TYPE_TO_PATH_MAP[reportType] || _constants.ACTIVITY_MASTERY_PATH;
    }
  }, {
    key: "getReportType",
    value: function getReportType(basePath) {
      for (var reportType in _constants.REPORT_TYPE_TO_PATH_MAP) {
        if (_constants.REPORT_TYPE_TO_PATH_MAP[reportType] === basePath) {
          return reportType;
        }
      }
      return null;
    }
  }, {
    key: "getFiltersForChildPage",
    value: function getFiltersForChildPage(classId, childPageType, childPageItemId, allClasses, studentsByGroup, currentActiveFilters) {
      var selectedClass = allClasses.find(function (c) {
        return c.id === classId;
      });
      if (!selectedClass) {
        return {};
      }
      var selectedYearGroup = currentActiveFilters[_filterConstants.SELECTED_YEAR_GROUP];
      if (selectedYearGroup.id === null) {
        selectedYearGroup = _activeFiltersReducer.defaultState[_filterConstants.SELECTED_YEAR_GROUP];
      }
      var selectedTeacher = currentActiveFilters[_filterConstants.SELECTED_TEACHER];
      if (selectedTeacher.id === null) {
        selectedTeacher = _activeFiltersReducer.defaultState[_filterConstants.SELECTED_TEACHER];
      }
      var filters = _defineProperty(_defineProperty(_defineProperty({}, _filterConstants.SELECTED_CLASS, {
        id: classId,
        name: selectedClass.name
      }), _filterConstants.SELECTED_YEAR_GROUP, selectedYearGroup), _filterConstants.SELECTED_TEACHER, selectedTeacher);
      switch (childPageType) {
        case _constants.GROUP_PATH:
          {
            var selectedGroup = studentsByGroup.find(function (group) {
              return group.id === childPageItemId;
            });
            if (selectedGroup) {
              filters[_filterConstants.SELECTED_GROUP] = {
                id: childPageItemId,
                name: selectedGroup.name
              };
            }
            break;
          }
        case _constants.STUDENT_PATH:
          {
            var _selectedGroup = studentsByGroup.find(function (group) {
              return group.id !== _filterConstants.ALL_GROUPS && group.students.find(function (student) {
                return student.value === childPageItemId;
              });
            });
            if (_selectedGroup) {
              var selectedStudent = _selectedGroup.students.find(function (student) {
                return student.value === childPageItemId;
              });
              filters[_filterConstants.SELECTED_GROUP] = {
                id: _selectedGroup.id,
                name: _selectedGroup.name
              };
              filters[_filterConstants.SELECTED_STUDENT] = {
                id: childPageItemId,
                name: selectedStudent.label
              };
            }
            break;
          }
        default:
      }
      return filters;
    }
  }]);
}();
_defineProperty(RouteHelper, "areDateParamsDifferent", function (params, prevParams) {
  return _constants.DATE_PARAMS.some(function (dateParam) {
    var paramValue = _urlHelper["default"].getQueryParamValue(dateParam, params);
    var prevParamValue = _urlHelper["default"].getQueryParamValue(dateParam, prevParams);
    // handle special case where no dateType param is the same as dateType=2
    if (dateParam === _constants.DATE_TYPE) {
      var thisSchoolYearType = "".concat(_constants.DATE_TYPE_MAP[_reactComponents.DatePicker.THIS_SCHOOL_YEAR]);
      if (paramValue === thisSchoolYearType && prevParamValue == null || paramValue == null && prevParamValue === thisSchoolYearType) {
        return false;
      }
    }
    return paramValue !== prevParamValue;
  });
});
_defineProperty(RouteHelper, "isAllYearsRoute", function (isAdmin, activeFilters) {
  var selectedYearGroupId = activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id;
  var selectedTeacherId = activeFilters[_filterConstants.SELECTED_TEACHER].id;
  return isAdmin === true && (selectedYearGroupId == null || selectedYearGroupId === _filterConstants.ALL_YEARS) && (selectedTeacherId == null || selectedTeacherId === _filterConstants.ALL_TEACHERS);
});
_defineProperty(RouteHelper, "isLandingPage", function (isAdmin, activeFilters) {
  if (isAdmin === true) {
    return activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id === _filterConstants.ALL_YEARS && activeFilters[_filterConstants.SELECTED_TEACHER].id === _filterConstants.ALL_TEACHERS && activeFilters[_filterConstants.SELECTED_CLASS].id === _filterConstants.ALL_CLASSES;
  }
  return activeFilters[_filterConstants.SELECTED_CLASS].id === _filterConstants.ALL_CLASSES;
});

/***/ }),

/***/ "HAQU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEEKS = exports.MONTH_NAMES = exports.MONTHS = exports.GRAPH_HEIGHT = exports.DAYS = void 0;
var GRAPH_HEIGHT = exports.GRAPH_HEIGHT = 185;
var MONTH_NAMES = exports.MONTH_NAMES = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'August', 'Sep', 'Oct', 'Nov', 'Dec'];
var DAYS = exports.DAYS = 'days';
var WEEKS = exports.WEEKS = 'weeks';
var MONTHS = exports.MONTHS = 'months';

/***/ }),

/***/ "HDbG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STUDENT_NAME = exports.SINGLE_CLASS_TABLE_CONFIG = exports.GROUP_NAME = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _singleClass = _interopRequireDefault(__webpack_require__("59Pb"));
var _liveMathsLevelPicker = _interopRequireDefault(__webpack_require__("kQVy"));
var _localeHelpers = __webpack_require__("rjLd");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var GROUP_NAME = exports.GROUP_NAME = 'name';
var COURSE_NAME = 'courseName';
var Q_PER_MIN = 'questionsPerMinute';
var TOTAL_CORRECT = 'totalCorrect';
var ACCURACY = 'accuracy';
var TOP_SCORE = 'topScore';
var STUDENT_NAME = exports.STUDENT_NAME = 'studentName';
var generateColHeader = function generateColHeader(mainText, subText) {
  var i18n = window.i18n;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _singleClass["default"]['col-header']
  }, /*#__PURE__*/_react["default"].createElement("span", null, i18n._(mainText)), subText && /*#__PURE__*/_react["default"].createElement("span", null, "(", i18n._(subText), ")"));
};
var SINGLE_CLASS_TABLE_CONFIG = exports.SINGLE_CLASS_TABLE_CONFIG = {
  colGroups: [[{
    name: '',
    // this is set to class name in SingleClass component
    colIds: [GROUP_NAME],
    classes: _singleClass["default"]['class-name'],
    truncate: true,
    headerTruncate: true
  }, {
    name: Q_PER_MIN,
    headerTransform: function headerTransform() {
      return generateColHeader('Q/MIN', 'Column Header - Avg');
    },
    colIds: []
  }, {
    name: TOTAL_CORRECT,
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - Correct', 'Column Header - Total');
    },
    colIds: []
  }, {
    name: ACCURACY,
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - Accuracy', 'Column Header - Avg');
    },
    colIds: []
  }, {
    name: TOP_SCORE,
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - TopScore', 'Column Header - Lifetime');
    },
    colIds: []
  }]],
  cols: [{
    id: GROUP_NAME,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.LEVEL),
    doTranslation: true,
    classes: _singleClass["default"]['group-name'],
    truncate: true,
    onClick: null // this is set to load group view in the SingleClass component
  }, {
    id: COURSE_NAME,
    headerTransform: function headerTransform() {
      return /*#__PURE__*/_react["default"].createElement(_liveMathsLevelPicker["default"], null);
    },
    headerColSpan: 4,
    colSpan: 4,
    classes: _singleClass["default"]['course-name']
  }],
  nestedData: {
    id: 'studentLiveMathsResults',
    cols: [{
      id: STUDENT_NAME,
      truncate: true,
      classes: _singleClass["default"]['student-name'],
      onClick: null // this is set to load student view in the SingleClass component
    }, {
      id: Q_PER_MIN
    }, {
      id: TOTAL_CORRECT
    }, {
      id: ACCURACY
    }, {
      id: TOP_SCORE
    }],
    emptyDataMessage: 'No Live Maths results found for this level'
  },
  emptyDataMessage: 'No Live Maths results found'
};

/***/ }),

/***/ "HJbm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslations = void 0;
var _linguiCdn = __webpack_require__("siuH");
var useTranslations = exports.useTranslations = function useTranslations() {
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  return {
    participation: i18n._("Table Header - Participation"),
    certificates: i18n._("Certificates - Certificates"),
    oldCertificates: i18n._("Certificates - Old Certificates"),
    bronze: i18n._("Certificates - Bronze"),
    silver: i18n._("Certificates - Silver"),
    gold: i18n._("Certificates - Gold"),
    platinum: i18n._("Certificates - Platinum"),
    emerald: i18n._("Certificates - Emerald"),
    diamond: i18n._("Certificates - Diamond"),
    epic: i18n._("Certificates - Epic"),
    legend: i18n._("Certificates - Legend"),
    allClasses: i18n._("Certificates - All Classes"),
    allYearGroups: i18n._("Certificates - All Year Groups")
  };
};

/***/ }),

/***/ "HM4R":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".container---3AVsj {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  border-radius: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-weight: 400;\n  max-width: 600px; }\n  .container---3AVsj .heading---2o7Ko {\n    color: #001937;\n    font-size: 32px;\n    line-height: 37px; }\n  .container---3AVsj .info---2pKBL {\n    color: #33475f;\n    font-size: 18px;\n    line-height: 37px; }\n  .container---3AVsj .rank-dropdown-container---27PoZ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 115px;\n    min-width: 80%;\n    -ms-flex-item-align: center;\n        align-self: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n        align-items: center;\n    margin: 20px;\n    padding: 20px 40px;\n    -webkit-box-shadow: rgba(0, 25, 55, .05) 0 1px 8px 0;\n            box-shadow: rgba(0, 25, 55, .05) 0 1px 8px 0;\n    border-radius: 15px;\n    font-size: 18px; }\n  .container---3AVsj .buttonsContainer---3meOD {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    margin-top: 48px; }\n", ""]);

// exports
exports.locals = {
	"container": "container---3AVsj",
	"heading": "heading---2o7Ko",
	"info": "info---2pKBL",
	"rank-dropdown-container": "rank-dropdown-container---27PoZ",
	"buttonsContainer": "buttonsContainer---3meOD"
};

/***/ }),

/***/ "HUdG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _singleClassActions = __webpack_require__("km3k");
var initialState = null;

/**
 * Activity Mastery - Class Reducer
 *
 * Consumes ACTIVITY_MASTERY_CLASS_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _singleClassActions.ACTIVITY_MASTERY_CLASS_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "HeCi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uiHelper = _interopRequireDefault(__webpack_require__("Vhb/"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for converting live maths report data from redux store into format
 * needed for export endpoints
 */
var LiveMathsDataConverter = exports["default"] = /*#__PURE__*/function () {
  function LiveMathsDataConverter() {
    _classCallCheck(this, LiveMathsDataConverter);
  }
  return _createClass(LiveMathsDataConverter, null, [{
    key: "convertAllClasses",
    value: function convertAllClasses(data, selectedDate, liveMathsLevel, reportTitle, isAllYears) {
      var _this = this;
      var classes = data.find(function (d) {
        return +d.level === liveMathsLevel;
      }).classes.map(function (c) {
        return _objectSpread({
          name: c.name
        }, _this.addScores(c));
      }, this);
      return {
        dateRange: _uiHelper["default"].formatDateRange(selectedDate),
        reportLevelHeader: reportTitle,
        liveMathsTableHeader: isAllYears ? 'All years' : 'All classes',
        classroomsLiveMathsData: {
          liveMathsLevelResult: _defineProperty({}, liveMathsLevel, classes)
        }
      };
    }
  }, {
    key: "convertSingleClass",
    value: function convertSingleClass(data, selectedDate, liveMathsLevel, groupId) {
      var _this2 = this;
      var classroomName = data.classroomName,
        groupLiveMathsLevelResult = data.groupLiveMathsLevelResult;
      var selectedLevelResult = groupLiveMathsLevelResult.find(function (d) {
        return +d.level === liveMathsLevel;
      }).groups;
      if (groupId) {
        selectedLevelResult = selectedLevelResult.filter(function (g) {
          return g.id === groupId;
        });
      }
      var groups = selectedLevelResult.map(function (g) {
        return {
          id: g.id,
          name: g.name,
          courseName: g.courseName,
          studentLiveMathsResults: g.studentLiveMathsResults.map(function (s) {
            return _objectSpread({
              id: s.id,
              firstName: s.studentName.split(',')[1],
              lastName: s.studentName.split(',')[0]
            }, _this2.addScores(s));
          }, _this2)
        };
      }, this);
      return {
        dateRange: _uiHelper["default"].formatDateRange(selectedDate),
        classroomLiveMathsData: {
          classroomName: classroomName,
          groupLiveMathsLevelResult: _defineProperty({}, liveMathsLevel, groups)
        }
      };
    }
  }, {
    key: "addScores",
    value: function addScores(data) {
      return {
        totalCorrect: this.mapScore(data.totalCorrect),
        topScore: this.mapScore(data.topScore),
        accuracy: this.mapScore(data.accuracy),
        questionsPerMinute: this.mapScore(data.questionsPerMinute)
      };
    }
  }, {
    key: "mapScore",
    value: function mapScore(score) {
      if (score === '-') {
        return -1;
      }
      return parseInt(score, 10);
    }
  }]);
}();

/***/ }),

/***/ "Hi7O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reselect = __webpack_require__("bndy");
var _uniqBy = _interopRequireDefault(__webpack_require__("VXg5"));
var _sortBy = _interopRequireDefault(__webpack_require__("KBYM"));
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Redux selectors for year group data
 */

var selectYearGroups = function selectYearGroups(state) {
  return state.yearGroups;
};
var selectAllClasses = function selectAllClasses(state) {
  return state.allClasses;
};
var mapClasses = function mapClasses(classes) {
  return classes.map(function (c) {
    return {
      value: c.id,
      label: c.name
    };
  });
};
var mapTeachers = function mapTeachers(teachers) {
  return teachers.map(function (t) {
    return {
      value: t.teacherProfileId,
      label: t.teacherName
    };
  });
};
var findClassIdsForTeacher = function findClassIdsForTeacher(classTeachers, teacherId) {
  var teacher = classTeachers.find(function (t) {
    return t.teacherProfileId === teacherId;
  });
  if (teacher) {
    return teacher.classIds;
  }
  return [];
};
function filterSortTeachers(teachers) {
  teachers = _toConsumableArray(teachers);
  teachers = (0, _uniqBy["default"])(teachers, 'value');
  teachers = (0, _sortBy["default"])(teachers, function (t) {
    var names = t.label.split(' ');
    return names[names.length - 1];
  });
  return teachers;
}
var selectAllTeachers = (0, _reselect.createSelector)([selectYearGroups], function (yearGroups) {
  if (!yearGroups) {
    return [];
  }
  return filterSortTeachers(yearGroups.reduce(function (prev, curr) {
    return [].concat(_toConsumableArray(prev), _toConsumableArray(mapTeachers(curr.classTeachers)));
  }, []));
});
var selectTeachersByYear = function selectTeachersByYear(yearId) {
  return (0, _reselect.createSelector)([selectYearGroups, selectAllTeachers], function (yearGroups, allTeachers) {
    if (yearId === _filterConstants.ALL_YEARS) {
      return allTeachers;
    }
    var year = yearGroups.find(function (y) {
      return y.id === yearId;
    });
    return filterSortTeachers(mapTeachers(year.classTeachers));
  });
};
var selectClassesByYear = function selectClassesByYear(yearId) {
  return (0, _reselect.createSelector)([selectYearGroups, selectAllClasses], function (yearGroups, allClasses) {
    if (yearId === _filterConstants.ALL_YEARS) {
      return mapClasses(allClasses);
    }
    var year = yearGroups.find(function (y) {
      return y.id === yearId;
    });
    var classIds = year.classTeachers.reduce(function (prev, curr) {
      return [].concat(_toConsumableArray(prev), _toConsumableArray(curr.classIds));
    }, []);
    var yearClasses = allClasses.filter(function (c) {
      return classIds.indexOf(c.id) !== -1;
    });
    return mapClasses(yearClasses);
  });
};
var selectClassesByYearAndTeacher = function selectClassesByYearAndTeacher(yearId, teacherId) {
  return (0, _reselect.createSelector)([selectYearGroups, selectAllClasses, selectClassesByYear(yearId)], function (yearGroups, allClasses, classesByYear) {
    if (yearId === _filterConstants.ALL_YEARS && teacherId === _filterConstants.ALL_TEACHERS) {
      // all classes for all years & teachers
      return mapClasses(allClasses);
    } else if (yearId !== _filterConstants.ALL_YEARS && teacherId === _filterConstants.ALL_TEACHERS) {
      // classes for all teachers in a year
      return classesByYear;
    } else if (yearId === _filterConstants.ALL_YEARS && teacherId !== _filterConstants.ALL_TEACHERS) {
      // classes for a teacher in all years
      var classIds = yearGroups.reduce(function (prev, curr) {
        return [].concat(_toConsumableArray(prev), _toConsumableArray(findClassIdsForTeacher(curr.classTeachers, teacherId)));
      }, []);
      var teacherClasses = allClasses.filter(function (c) {
        return classIds.indexOf(c.id) !== -1;
      });
      return mapClasses(teacherClasses);
    } else if (yearId !== _filterConstants.ALL_YEARS && teacherId !== _filterConstants.ALL_TEACHERS) {
      // classes for a teacher in a year
      var year = yearGroups.find(function (y) {
        return y.id === yearId;
      });
      var teacher = year.classTeachers.find(function (t) {
        return t.teacherProfileId === teacherId;
      });
      if (teacher) {
        var _classIds = teacher.classIds;
        var _teacherClasses = allClasses.filter(function (c) {
          return _classIds.indexOf(c.id) !== -1;
        });
        return mapClasses(_teacherClasses);
      }
    }
    return [];
  });
};
var _default = exports["default"] = {
  selectYearGroups: selectYearGroups,
  selectAllTeachers: selectAllTeachers,
  selectTeachersByYear: selectTeachersByYear,
  selectClassesByYear: selectClassesByYear,
  selectClassesByYearAndTeacher: selectClassesByYearAndTeacher
};

/***/ }),

/***/ "Hyew":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _progressBar = _interopRequireDefault(__webpack_require__("4doL"));
var _progressBarHelpers = __webpack_require__("25Ai");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ProgressBar = function ProgressBar(_ref) {
  var accuracyBadRangeCount = _ref.accuracyBadRangeCount,
    accuracyBestRangeCount = _ref.accuracyBestRangeCount,
    accuracyGoodRangeCount = _ref.accuracyGoodRangeCount,
    accuracyMiddleRangeCount = _ref.accuracyMiddleRangeCount,
    accuracyWorstRangeCount = _ref.accuracyWorstRangeCount,
    accuracyTotalAvailableRangeCount = _ref.accuracyTotalAvailableRangeCount,
    _ref$progressBarWidth = _ref.progressBarWidth,
    progressBarWidth = _ref$progressBarWidth === void 0 ? 300 : _ref$progressBarWidth;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    chartData = _useState2[0],
    setChartData = _useState2[1];
  var ref = (0, _react.useRef)();
  var isAllAssigned = accuracyTotalAvailableRangeCount === accuracyBestRangeCount + accuracyGoodRangeCount + accuracyMiddleRangeCount + accuracyBadRangeCount + accuracyWorstRangeCount;
  (0, _react.useEffect)(function () {
    var barWidth = ref.current.offsetWidth || progressBarWidth;
    var unitLength = accuracyTotalAvailableRangeCount === 0 ? 0 : barWidth / accuracyTotalAvailableRangeCount;
    var data = [{
      style: 'green',
      width: accuracyBestRangeCount * unitLength
    }, {
      style: 'light-green',
      width: accuracyGoodRangeCount * unitLength
    }, {
      style: 'light-orange',
      width: accuracyMiddleRangeCount * unitLength
    }, {
      style: 'orange',
      width: accuracyBadRangeCount * unitLength
    }, {
      style: 'red',
      width: accuracyWorstRangeCount * unitLength
    }, {
      style: isAllAssigned ? 'hidden' : 'white',
      width: 0
    }];
    setChartData(data);
  }, [ref.current]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    id: "progress-bar",
    className: _progressBar["default"]['progress-wrapper']
  }, chartData.map(function (_ref2) {
    var style = _ref2.style,
      width = _ref2.width;
    return /*#__PURE__*/_react["default"].createElement(_progressBarHelpers.Progress, {
      style: style,
      width: width,
      key: style
    });
  }));
};
ProgressBar.propTypes = {
  accuracyBadRangeCount: _propTypes["default"].number.isRequired,
  accuracyBestRangeCount: _propTypes["default"].number.isRequired,
  accuracyGoodRangeCount: _propTypes["default"].number.isRequired,
  accuracyMiddleRangeCount: _propTypes["default"].number.isRequired,
  accuracyWorstRangeCount: _propTypes["default"].number.isRequired,
  accuracyTotalAvailableRangeCount: _propTypes["default"].number.isRequired,
  progressBarWidth: _propTypes["default"].number
};
var _default = exports["default"] = ProgressBar;

/***/ }),

/***/ "IJBn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactComponents = __webpack_require__("fmgT");
var _isEqual = _interopRequireDefault(__webpack_require__("hygk"));
var _constants = __webpack_require__("1QGX");
var _urlHelper = _interopRequireDefault(__webpack_require__("uOny"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Helps to generate the request URL when making requests for activity mastery, participation
 * or live maths data
 */
var DateParamHelper = exports["default"] = /*#__PURE__*/function () {
  function DateParamHelper() {
    _classCallCheck(this, DateParamHelper);
  }
  return _createClass(DateParamHelper, null, [{
    key: "getDateQueryParams",
    value: function getDateQueryParams(selectedDate) {
      var params = {
        productId: _constants.MATHLETICS_ID
      };
      if (selectedDate.type === _reactComponents.DatePicker.CUSTOM_DATE) {
        params.startDate = selectedDate.startDate;
        params.endDate = selectedDate.endDate;
      }
      return params;
    }
  }, {
    key: "getDateTypePath",
    value: function getDateTypePath(selectedDate) {
      return {
        dateType: _constants.DATE_OPTION_TO_PATH_MAP[selectedDate.type]
      };
    }
  }, {
    key: "areDatesEqual",
    value: function areDatesEqual(firstDate, secondDate) {
      if ((0, _isEqual["default"])(firstDate, secondDate)) {
        return true;
      }
      var firstType = firstDate.type;
      var secondType = secondDate.type;
      return firstType === secondType && firstType !== _reactComponents.DatePicker.CUSTOM_DATE;
    }
  }, {
    key: "getInitialDate",
    value: function getInitialDate() {
      return {
        type: _constants.DATE_PARAM_MAP[_urlHelper["default"].getQueryParamValue(_constants.DATE_TYPE)] || _reactComponents.DatePicker.THIS_SCHOOL_YEAR,
        startDate: _urlHelper["default"].getQueryParamValue(_constants.START_DATE) || null,
        endDate: _urlHelper["default"].getQueryParamValue(_constants.END_DATE) || null
      };
    }
  }]);
}();

/***/ }),

/***/ "InLL":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("hwkD");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./download-picker.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./download-picker.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ItvU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SET_REPORT_STATE = exports.REPORT_STATE_TOP_TEN = exports.REPORT_STATE_ALL_YEARS = exports.REPORT_STATE_ALL_CLASSES = void 0;
var _reduxActions = __webpack_require__("sTbe");
var REPORT_STATE_ALL_YEARS = exports.REPORT_STATE_ALL_YEARS = 'REPORT_STATE_ALL_YEARS';
var REPORT_STATE_TOP_TEN = exports.REPORT_STATE_TOP_TEN = 'REPORT_STATE_TOP_TEN';
var REPORT_STATE_ALL_CLASSES = exports.REPORT_STATE_ALL_CLASSES = 'REPORT_STATE_ALL_CLASSES';
var SET_REPORT_STATE = exports.SET_REPORT_STATE = 'SET_REPORT_STATE';
var setReportState = (0, _reduxActions.createAction)(SET_REPORT_STATE);
var _default = exports["default"] = {
  setReportState: setReportState
};

/***/ }),

/***/ "IuTT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOTAL_ACTIVITIES = exports.STUDENT_NAME = exports.SINGLE_CLASS_TABLE_CONFIG = exports.GROUP_NAME = exports.COURSE_NAME = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _activityStatusBar = _interopRequireDefault(__webpack_require__("jJ7R"));
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _singleClass = _interopRequireDefault(__webpack_require__("tBEy"));
var _localeHelpers = __webpack_require__("rjLd");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var GROUP_NAME = exports.GROUP_NAME = 'name';
var COURSE_NAME = exports.COURSE_NAME = 'courseName';
var TOTAL_ACTIVITIES = exports.TOTAL_ACTIVITIES = 'totalActivities';
var STUDENT_NAME = exports.STUDENT_NAME = 'fullName';
var ACTIVITY_RESULTS = 'activityResults';
var SINGLE_CLASS_TABLE_CONFIG = exports.SINGLE_CLASS_TABLE_CONFIG = {
  cols: [{
    id: GROUP_NAME,
    name: '',
    // this is set to teacher name in the SingleClass component
    truncate: true,
    headerTruncate: true,
    onClick: null,
    // this is set to load group view for class view only in SingleClass component
    classes: _singleClass["default"]['group-name'],
    sort: null // this is set to sort for class view only in SingleClass component
  }, {
    id: COURSE_NAME,
    name: 'Course',
    truncate: true,
    classes: _singleClass["default"]['course-name'],
    headerTransform: function headerTransform() {
      return null;
    } // this is set in the SingleClass component
  }, {
    id: TOTAL_ACTIVITIES,
    name: '' // this is set to class total in the SingleClass component
  }],
  colGroups: [[{
    name: 'Activity Mastery',
    headerTransform: function headerTransform() {
      return /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: 'Table Header - Activity Mastery',
        translate: true
      });
    },
    colIds: [GROUP_NAME, COURSE_NAME]
  }, {
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.NUM_ACTIVITIES),
    doTranslation: true,
    colIds: [TOTAL_ACTIVITIES],
    classes: "text-center ".concat(_singleClass["default"]['total-activities'])
  }]],
  nestedData: {
    id: 'students',
    cols: [{
      id: STUDENT_NAME,
      truncate: true,
      classes: _singleClass["default"]['student-name'],
      onClick: function onClick() {
        return null;
      } // this is set in the SingleClass component
    }, {
      id: ACTIVITY_RESULTS,
      classes: _singleClass["default"]['activity-results'],
      transform: function transform(row) {
        var activityMastery = {
          scoreBand: row.scoreBand,
          goldBars: row.goldBars,
          totalActivities: row.totalActivities
        };
        return /*#__PURE__*/_react["default"].createElement(_activityStatusBar["default"], {
          activityMastery: activityMastery
        });
      }
    }]
  }
};

/***/ }),

/***/ "J8ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DateDropdown = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _datePicker = __webpack_require__("9PoH");
var _filterConstants = __webpack_require__("cdWI");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _filterPropTypes = __webpack_require__("1g86");
var _datePickerConstants = __webpack_require__("p2pT");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DateDropdown = exports.DateDropdown = /*#__PURE__*/function (_PureComponent) {
  function DateDropdown(_props) {
    var _this;
    _classCallCheck(this, DateDropdown);
    _this = _callSuper(this, DateDropdown, [_props]);
    _defineProperty(_this, "manageSelectedReportType", function (newProps) {
      var newReportDropdownData = newProps.reportDropdownData;
      var selectedReportType = _this.state.selectedReportType;
      if (selectedReportType !== newReportDropdownData.selectedOption) {
        _this.setState({
          selectedReportType: newReportDropdownData.selectedOption
        });
      }
    });
    /**
     * Skill quests mastery report type only has 2 options compared to all other report types which have
     * 4. This function helps manage those options and overrides current selection if it doesnt exist
     * in SQM options list searching from other report type.
     */
    _defineProperty(_this, "manageOptions", function (props, newProps) {
      var prevReportDropdownData = props.reportDropdownData;
      var reportDropdownData = newProps.reportDropdownData,
        dateDropdownData = newProps.dateDropdownData,
        academicYear = newProps.academicYear,
        hasLifetimeData = newProps.hasLifetimeData;
      var prevSelectedOption = prevReportDropdownData.selectedOption.value;
      var currentSelectedOption = reportDropdownData.selectedOption.value;

      // We don't need to change anything if we stay within the SQM report
      if (prevSelectedOption === currentSelectedOption) return;
      switch (reportDropdownData.selectedOption.value) {
        case _filterConstants.SKILL_QUESTS_MASTERY:
          {
            var selectedDateType = dateDropdownData.selectedOption.type;
            _this.manageSkillQuestMasterOverride(selectedDateType, academicYear, hasLifetimeData, currentSelectedOption);
            break;
          }
        default:
          {
            var options = _this.manageLifetimeDate(_datePickerConstants.DEFAULT_DATE_OPTIONS_OBJ, hasLifetimeData, currentSelectedOption);
            _this.setState({
              options: options
            });
          }
      }
    });
    _defineProperty(_this, "manageSkillQuestMasterOverride", function (selectedDateType, academicYear, hasLifetimeData, currentSelectedOption) {
      var options = [_datePickerConstants.THIS_SCHOOL_YEAR_OBJ, _datePickerConstants.CUSTOM_DATE_OBJ];
      options = _this.manageLifetimeDate(options, hasLifetimeData, currentSelectedOption);
      var containsValidOption = options.includes(selectedDateType);
      if (!containsValidOption) {
        _this.props.setSelectedDate({
          type: _datePickerConstants.THIS_SCHOOL_YEAR_OBJ.value,
          startDate: academicYear.startDate,
          endDate: academicYear.endDate
        });
      }
      _this.setState({
        options: options
      });
    });
    _defineProperty(_this, "manageLifetimeDate", function (options, hasLifeTimeData, currentSelectedOption) {
      if (hasLifeTimeData && currentSelectedOption === _filterConstants.ACTIVITY_MASTERY) {
        return [].concat(_toConsumableArray(options), [_datePickerConstants.LIFETIME_OBJ]);
      }
      return options;
    });
    _defineProperty(_this, "dateChanged", function (type, startDate, endDate) {
      _this.props.setSelectedDate({
        type: type,
        startDate: startDate,
        endDate: endDate
      });
      _this.props.handleApplyFilters();
    });
    /**
     * ON REPORT TYPE: Skills Quest Mastery
     * When custom date option is selected, the start date is pre-populated with the first day of
     * the academic year and the end date can be chosen by the teacher, meaning the results will
     * be shown from the first day of the academic year up until the end date.
     */
    _defineProperty(_this, "getInitialDateProp", function () {
      var academicYear = _this.props.academicYear;
      var selectedReportType = _this.state.selectedReportType;
      if (selectedReportType && selectedReportType.value === _filterConstants.SKILL_QUESTS_MASTERY) {
        return {
          startDate: academicYear.startDate,
          endDate: academicYear.endDate
        };
      }
      return null;
    });
    _this.state = {
      options: _datePickerConstants.DEFAULT_DATE_OPTIONS_OBJ,
      selectedReportType: null
    };
    return _this;
  }
  _inherits(DateDropdown, _PureComponent);
  return _createClass(DateDropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this.manageSelectedReportType(newProps);
      this.manageOptions(this.props, newProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        dateDropdownData = _this$props.dateDropdownData,
        className = _this$props.className,
        academicYear = _this$props.academicYear;
      var selectedOption = dateDropdownData.selectedOption;
      var options = this.state.options;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_datePicker.DatePicker, {
        academicYear: academicYear,
        currentDate: selectedOption,
        initialDate: this.getInitialDateProp(),
        onDateChange: this.dateChanged,
        options: options
      }));
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(DateDropdown, "propTypes", {
  dateDropdownData: _propTypes["default"].shape({
    selectedOption: _filterPropTypes.dateFilterPropType
  }),
  reportDropdownData: _propTypes["default"].shape({
    selectedOption: _filterPropTypes.filterPropType
  }),
  className: _propTypes["default"].string,
  academicYear: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }),
  setSelectedDate: _propTypes["default"].func,
  handleApplyFilters: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    dateDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.DATE_LIST)(state),
    reportDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.REPORT_LIST)(state),
    academicYear: state.academicYear,
    hasLifetimeData: state.hasLifetimeData
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setSelectedDate: _dropdownDataActions["default"].setSelectedDate
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DateDropdown);

/***/ }),

/***/ "JCVm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("K6xr");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./attempt-item.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./attempt-item.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JZdf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".sub-heading-buttons-container---13DG1 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-left: 14px; }\n  .sub-heading-buttons-container---13DG1 .sub-heading-btn---BtAAG {\n    margin-left: 5px;\n    font-size: 14px; }\n  .sub-heading-buttons-container---13DG1 .sub-heading-btn---BtAAG .download-btn---1FHWj,\n    .sub-heading-buttons-container---13DG1 .sub-heading-btn---BtAAG .export-btn---2QJkF {\n      height: 28px; }\n", ""]);

// exports
exports.locals = {
	"sub-heading-buttons-container": "sub-heading-buttons-container---13DG1",
	"sub-heading-btn": "sub-heading-btn---BtAAG",
	"download-btn": "download-btn---1FHWj",
	"export-btn": "export-btn---2QJkF"
};

/***/ }),

/***/ "JbS1":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---2dVte {\n  min-height: 500px;\n  font-size: 14px;\n  min-width: 1324px;\n  height: 100%; }\n  .component---2dVte .header---7UucM {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding-bottom: 16px; }\n  .component---2dVte .header---7UucM h2 {\n      color: #415667;\n      font-size: 25px;\n      max-width: calc(100% - 16px);\n      font-weight: 500;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n  .component---2dVte .header---7UucM .date-range---1c5ZR {\n      display: block;\n      float: left;\n      clear: both;\n      font-size: 16px;\n      color: #1981c4; }\n  .component---2dVte .report-container---2IuYG {\n    border-top: 1px solid #e1e1e1;\n    margin-bottom: 16px; }\n  .component---2dVte .sub-header---_W_qN {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2dVte",
	"header": "header---7UucM",
	"date-range": "date-range---1c5ZR",
	"report-container": "report-container---2IuYG",
	"sub-header": "sub-header---_W_qN"
};

/***/ }),

/***/ "JfNJ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("pqZ/");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./accuracy-overview-graph.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./accuracy-overview-graph.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JmQc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BdcE");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./topic-tables.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./topic-tables.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Jv+Z":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0brY");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./activity-mastery-key-legends.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./activity-mastery-key-legends.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "K6Yf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCertificatesConfig = void 0;
var _bronze = _interopRequireDefault(__webpack_require__("sJxe"));
var _silver = _interopRequireDefault(__webpack_require__("OIPS"));
var _gold = _interopRequireDefault(__webpack_require__("Ho0q"));
var _bronze2 = _interopRequireDefault(__webpack_require__("md6y"));
var _silver2 = _interopRequireDefault(__webpack_require__("RiHm"));
var _gold2 = _interopRequireDefault(__webpack_require__("LL8+"));
var _platinum = _interopRequireDefault(__webpack_require__("5QYw"));
var _emerald = _interopRequireDefault(__webpack_require__("5DKS"));
var _diamond = _interopRequireDefault(__webpack_require__("Evsd"));
var _epic = _interopRequireDefault(__webpack_require__("yzOm"));
var _legend = _interopRequireDefault(__webpack_require__("S3ak"));
var CertificateConstants = _interopRequireWildcard(__webpack_require__("tQue"));
var _useTranslations2 = __webpack_require__("HJbm");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useCertificatesConfig = exports.useCertificatesConfig = function useCertificatesConfig() {
  var _useTranslations = (0, _useTranslations2.useTranslations)(),
    bronze = _useTranslations.bronze,
    silver = _useTranslations.silver,
    gold = _useTranslations.gold,
    platinum = _useTranslations.platinum,
    emerald = _useTranslations.emerald,
    diamond = _useTranslations.diamond,
    epic = _useTranslations.epic,
    legend = _useTranslations.legend;
  var BRONZE = CertificateConstants.BRONZE,
    SILVER = CertificateConstants.SILVER,
    GOLD = CertificateConstants.GOLD,
    PLATINUM = CertificateConstants.PLATINUM,
    EMERALD = CertificateConstants.EMERALD,
    DIAMOND = CertificateConstants.DIAMOND,
    EPIC = CertificateConstants.EPIC,
    LEGEND = CertificateConstants.LEGEND;
  var newCertificatesConfig = [_objectSpread(_objectSpread({}, BRONZE), {}, {
    icon: _bronze2["default"],
    title: bronze
  }), _objectSpread(_objectSpread({}, SILVER), {}, {
    icon: _silver2["default"],
    title: silver
  }), _objectSpread(_objectSpread({}, GOLD), {}, {
    icon: _gold2["default"],
    title: gold
  }), _objectSpread(_objectSpread({}, PLATINUM), {}, {
    icon: _platinum["default"],
    title: platinum
  }), _objectSpread(_objectSpread({}, EMERALD), {}, {
    icon: _emerald["default"],
    title: emerald
  }), _objectSpread(_objectSpread({}, DIAMOND), {}, {
    icon: _diamond["default"],
    title: diamond
  }), _objectSpread(_objectSpread({}, EPIC), {}, {
    icon: _epic["default"],
    title: epic
  }), _objectSpread(_objectSpread({}, LEGEND), {}, {
    icon: _legend["default"],
    title: legend
  })];
  var pastCertificatesConfig = [_objectSpread(_objectSpread({}, BRONZE), {}, {
    icon: _bronze["default"],
    title: bronze
  }), _objectSpread(_objectSpread({}, SILVER), {}, {
    icon: _silver["default"],
    title: silver
  }), _objectSpread(_objectSpread({}, GOLD), {}, {
    icon: _gold["default"],
    title: gold
  })];
  return {
    newCertificatesConfig: newCertificatesConfig,
    pastCertificatesConfig: pastCertificatesConfig
  };
};

/***/ }),

/***/ "K6xr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".attempt-item---2zWxG {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  margin-bottom: 10px; }\n  .attempt-item---2zWxG .attempt-button---CWG_Z {\n    width: 80%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    border: 1px solid #278bcb;\n    border-radius: 24px;\n    padding: 5px;\n    cursor: pointer; }\n  .attempt-item---2zWxG .attempt-button---CWG_Z.active---33oWW {\n      background-color: #278bcb;\n      color: white; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 {\n    position: relative; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .attempt-info-button---2rpys {\n      width: 20px;\n      height: 20px;\n      background: url(" + __webpack_require__("N4Yu") + ") no-repeat;\n      background-size: contain;\n      cursor: pointer; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .tooltip---2c6Mh {\n      visibility: hidden;\n      opacity: 0;\n      -webkit-transition: visibility 0.2s ease 0s, opacity 0.2s ease 0s;\n      transition: visibility 0.2s ease 0s, opacity 0.2s ease 0s;\n      position: absolute;\n      left: 44px;\n      background: white;\n      width: 110px;\n      border: 1px solid grey;\n      border-radius: 5px;\n      padding: 4px; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .tooltip---2c6Mh.type-0---3yXlQ {\n        top: -54px; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .tooltip---2c6Mh.type-1---qHr9Q {\n        top: -33px; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .tooltip---2c6Mh.type-2---2wTQ7 {\n        top: -54px; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .tooltip---2c6Mh::before, .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .tooltip---2c6Mh::after {\n        bottom: 100%;\n        border: solid transparent;\n        content: \" \";\n        height: 0;\n        width: 0;\n        position: absolute;\n        pointer-events: none;\n        -webkit-transform: rotate(-90deg) translate(50%, 0);\n                transform: rotate(-90deg) translate(50%, 0); }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .tooltip---2c6Mh::before {\n        border-color: rgba(194, 194, 194, 0);\n        border-bottom-color: grey;\n        border-width: 12px;\n        right: 118px;\n        top: 50%; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1 .tooltip---2c6Mh::after {\n        top: 50%;\n        right: 117px;\n        border-color: rgba(255, 255, 255, 0);\n        border-bottom-color: white;\n        border-width: 11px; }\n  .attempt-item---2zWxG .attempt-info-button-container---1KOK1:hover .tooltip---2c6Mh {\n      visibility: visible;\n      opacity: 1; }\n", ""]);

// exports
exports.locals = {
	"attempt-item": "attempt-item---2zWxG",
	"attempt-button": "attempt-button---CWG_Z",
	"active": "active---33oWW",
	"attempt-info-button-container": "attempt-info-button-container---1KOK1",
	"attempt-info-button": "attempt-info-button---2rpys",
	"tooltip": "tooltip---2c6Mh",
	"type-0": "type-0---3yXlQ",
	"type-1": "type-1---qHr9Q",
	"type-2": "type-2---2wTQ7"
};

/***/ }),

/***/ "KRbp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePropDateFormat = exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
__webpack_require__("lj70");
var _dayjs = _interopRequireDefault(__webpack_require__("oqQY"));
var _DateRangePicker = _interopRequireDefault(__webpack_require__("32hK"));
var _constants = __webpack_require__("QoJ3");
var _momentWithLocales = _interopRequireDefault(__webpack_require__("e7tE"));
var _calendarConstants = __webpack_require__("o+QR");
var _dateHelper = _interopRequireDefault(__webpack_require__("BiE+"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** This validation is for Safari and Firefox browsers
 *  When you supplied '2020-1-1' as local format
 *  It will cause invalid date on moment when users are using Safari and Firefox
 */
var validatePropDateFormat = exports.validatePropDateFormat = function validatePropDateFormat(props, propName, componentName) {
  var field = props[propName];
  var validDateFormatRegex = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
  if (!validDateFormatRegex.test(field)) {
    throw new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Validation failed."));
  }
};

/**
 * Calendar component
 * Renders a calendar using react-dates library https://github.com/airbnb/react-dates
 * Limits what dates a user can select to meet business rules
 * Calls onDatesPicked prop when user selects both a start and end date, calls onClose prop
 * when the react-dates calendar component is closed for any reason
 */
var Calendar = /*#__PURE__*/function (_Component) {
  function Calendar(props) {
    var _this;
    _classCallCheck(this, Calendar);
    _this = _callSuper(this, Calendar, [props]);
    /**
     * Limit what days users can select in the calendar
     * Start date has to be a Monday and end date a Sunday, both dates have to be within
     * the range provided via props
     * @param date - moment date object
     */
    _defineProperty(_this, "isOutsideRange", function (date) {
      var _this$state = _this.state,
        focusedInput = _this$state.focusedInput,
        range = _this$state.range;
      var localeData = _this.props.localeData;
      if (date.isAfter(range.startDate) && date.isBefore(range.endDate)) {
        var allowedDay;
        if (focusedInput === _calendarConstants.START_DATE) {
          allowedDay = localeData['Label - Monday'];
        } else {
          allowedDay = localeData['Label - Sunday'];
        }
        var calendarDay = (0, _dayjs["default"])(date).format('dddd');
        return calendarDay !== allowedDay;
      }
      return true;
    });
    _defineProperty(_this, "onDatesChange", function (_ref) {
      var startDate = _ref.startDate,
        endDate = _ref.endDate;
      if (_this.state.focusedInput === _calendarConstants.END_DATE && !endDate) {
        // user has selected an end date earlier than the start date,
        // auto select the prev Monday as the start date and set the end date as
        // they chose
        endDate = startDate;
        startDate = (0, _momentWithLocales["default"])(_dateHelper["default"].getPreviousMonday(startDate));
      }
      _this.setState({
        startDate: startDate,
        endDate: endDate
      });
      if (startDate && endDate) {
        _this.props.onDatesPicked(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'));
      }
    });
    _defineProperty(_this, "onFocusChange", function (elementId) {
      _this.setState({
        focusedInput: elementId
      });
    });
    var initialDate = props.initialDate,
      locale = props.locale,
      _range = props.range;
    /**
     * SET LOCALE
     * */
    var localeCode = locale || 'en-AU';
    _dayjs["default"].locale(localeCode.toLowerCase());
    _momentWithLocales["default"].locale(locale);
    _this.state = {
      focusedInput: _calendarConstants.START_DATE,
      startDate: props.initialDate && initialDate.startDate ? (0, _momentWithLocales["default"])(initialDate.startDate) : (0, _momentWithLocales["default"])(),
      endDate: null,
      range: {
        startDate: (0, _momentWithLocales["default"])(_range.startDate),
        endDate: (0, _momentWithLocales["default"])(_range.endDate).add(1, 'day')
      }
    };
    return _this;
  }
  _inherits(Calendar, _Component);
  return _createClass(Calendar, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        startDate = _this$state2.startDate,
        endDate = _this$state2.endDate,
        focusedInput = _this$state2.focusedInput;
      var localeData = this.props.localeData;
      var startDateLabel = localeData['Label - StartDate'];
      var endDateLabel = localeData['Label - EndDate'];
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_DateRangePicker["default"], {
        displayFormat: "DD MMM YYYY",
        isOutsideRange: this.isOutsideRange,
        startDate: startDate,
        startDateId: _calendarConstants.START_DATE,
        startDatePlaceholderText: startDateLabel,
        endDate: endDate,
        endDateId: _calendarConstants.END_DATE,
        endDatePlaceholderText: endDateLabel,
        onDatesChange: this.onDatesChange,
        focusedInput: focusedInput,
        onFocusChange: this.onFocusChange,
        firstDayOfWeek: 1,
        hideKeyboardShortcutsPanel: true,
        minimumNights: 0,
        anchorDirection: _constants.ANCHOR_RIGHT,
        onClose: this.props.onClose,
        readOnly: true
      }));
    }
  }]);
}(_react.Component);
_defineProperty(Calendar, "propTypes", {
  /** Range to limit the date selection to */
  range: _propTypes["default"].shape({
    startDate: validatePropDateFormat,
    endDate: validatePropDateFormat
  }).isRequired,
  /** Callback prop when dates are selected */
  onDatesPicked: _propTypes["default"].func.isRequired,
  /** Callback prop when calendar is closed, either from selecting dates or cancelling date selection */
  onClose: _propTypes["default"].func.isRequired,
  /** Selected date to initialize */
  initialDate: _propTypes["default"].object,
  /**
   * Locale Data
   */
  localeData: _propTypes["default"].object,
  /** locale code */
  locale: _propTypes["default"].string
});
Calendar.START_DATE = _calendarConstants.START_DATE;
Calendar.END_DATE = _calendarConstants.END_DATE;
var _default = exports["default"] = Calendar;

/***/ }),

/***/ "KYjY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SET_SESSION_ID = void 0;
var _reduxActions = __webpack_require__("sTbe");
var SET_SESSION_ID = exports.SET_SESSION_ID = 'SET_SESSION_ID';
var setSessionId = (0, _reduxActions.createAction)(SET_SESSION_ID);
var _default = exports["default"] = {
  setSessionId: setSessionId
};

/***/ }),

/***/ "KcYX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.initialState = void 0;
var _isEqual = _interopRequireDefault(__webpack_require__("hygk"));
var _filterConstants = __webpack_require__("cdWI");
var _dropdownDataActions = __webpack_require__("FkcL");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var initialDate = _dateParamHelper["default"].getInitialDate();
var initialState = exports.initialState = function initialState() {
  return [{
    type: _filterConstants.YEAR_GROUP_LIST,
    data: [_filterConstants.ALL_YEARS_OPTION],
    selectedOption: _filterConstants.ALL_YEARS_OPTION,
    disabled: false
  }, {
    type: _filterConstants.TEACHER_LIST,
    data: [_filterConstants.ALL_TEACHERS_OPTION],
    selectedOption: _filterConstants.ALL_TEACHERS_OPTION,
    disabled: false
  }, {
    type: _filterConstants.CLASS_LIST,
    data: [_filterConstants.ALL_CLASSES_OPTION],
    selectedOption: _filterConstants.ALL_CLASSES_OPTION,
    disabled: false
  }, {
    type: _filterConstants.GROUP_LIST,
    data: [_filterConstants.ALL_GROUPS_OPTION],
    selectedOption: _filterConstants.ALL_GROUPS_OPTION,
    disabled: true
  }, {
    type: _filterConstants.STUDENT_LIST,
    data: [_filterConstants.ALL_STUDENTS_OPTION],
    selectedOption: _filterConstants.ALL_STUDENTS_OPTION,
    disabled: true
  }, {
    type: _filterConstants.REPORT_LIST,
    data: _filterConstants.REPORT_OPTIONS,
    selectedOption: _filterConstants.PARTICIPATION_OPTION
  },
  // date is a bit different to the others and uses DatePicker rather than DropdownMenu component
  {
    type: _filterConstants.DATE_LIST,
    data: null,
    selectedOption: initialDate
  }];
};

/**
 * Dropdown Data Reducer
 *
 * @param {boolean} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - filter dropdowns to display, with their selected option, data & disabled status
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _dropdownDataActions.SET_DROPDOWN_DATA:
      {
        // only update the items which have actually changed
        var newState = action.payload.map(function (newItem) {
          var prevItem = state.find(function (item) {
            return item.type === newItem.type;
          });
          if (!(0, _isEqual["default"])(newItem, prevItem)) {
            return newItem;
          }
          return prevItem;
        });
        return newState;
      }
    case _dropdownDataActions.UPDATE_DROPDOWN_DATA_ITEM:
      {
        var _newState = _toConsumableArray(state);
        var itemIdx = _newState.findIndex(function (item) {
          return item.type === action.payload.type;
        });
        _newState[itemIdx] = action.payload.item;
        return _newState;
      }
    default:
      return state;
  }
}

/***/ }),

/***/ "Kl0G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProgressBoxClassName = exports["default"] = exports.ASSIGNMENT_TYPE = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireWildcard(__webpack_require__("KSGD"));
var _linguiCdn = __webpack_require__("siuH");
var _topicBox = _interopRequireDefault(__webpack_require__("5tmF"));
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _contextModal = _interopRequireDefault(__webpack_require__("vuxJ"));
var _contextModalConstants = __webpack_require__("FCoq");
var _attempt = __webpack_require__("MoQg");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ASSIGNMENT_TYPE = exports.ASSIGNMENT_TYPE = {
  ASSIGN_REVIEW_UPF: 0,
  ASSIGN_REVIEW_ASSESSMENT: 1,
  VOLUNTARY: 2
};
var getProgressBoxClassName = exports.getProgressBoxClassName = function getProgressBoxClassName(accuracy) {
  var progressClass = '';
  if (accuracy <= 20) {
    progressClass = _topicBox["default"].RED;
  } else if (accuracy > 20 && accuracy <= 40) {
    progressClass = _topicBox["default"].ORANGE;
  } else if (accuracy > 40 && accuracy <= 60) {
    progressClass = _topicBox["default"].DARK_BLUE;
  } else if (accuracy > 60 && accuracy <= 80) {
    progressClass = _topicBox["default"].LIGHT_BLUE;
  } else if (accuracy > 80 && accuracy <= 100) {
    progressClass = _topicBox["default"].GREEN;
  }
  return progressClass;
};
var TopicBox = function TopicBox(_ref) {
  var journey = _ref.journey;
  var MODAL_DOWN = _contextModalConstants.CONTEXT_MODAL_POSITION.MODAL_DOWN;
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var text = {
    boxAccuracyText: function boxAccuracyText(accuracy) {
      return i18n._("Topic Box - Accuracy - {accuracy}", {
        accuracy: accuracy
      });
    },
    boxStepsCompletedText: function boxStepsCompletedText(completedStepsCount, totalStepsCount) {
      return i18n._("Topic Box - Completed - {completedStepsCount} - {totalStepsCount}", {
        completedStepsCount: completedStepsCount,
        totalStepsCount: totalStepsCount
      });
    },
    assignReviewUpfText: i18n._("Assignment Type - Assign Review Upf"),
    assignReviewAssessmentText: i18n._("Assignment Type - Assign Review Assessment"),
    voluntaryText: i18n._("Assignment Type - Voluntary"),
    attempts: i18n._("Attempts")
  };

  /**
   * CLASSNAMES
   */

  var getLearningJourneyBoxClassName = function getLearningJourneyBoxClassName() {
    var baseClass = "".concat(_topicBox["default"]['learning-journey-box'], " ");
    switch (journey.status) {
      case _skillQuestsMasteryConstants.ASSIGNMENT_STATUSES.NOT_ASSIGNED:
        {
          return "".concat(baseClass, " ").concat(_topicBox["default"].NOT_ASSIGNED);
        }
      case _skillQuestsMasteryConstants.ASSIGNMENT_STATUSES.IN_PROGRESS:
        {
          var progressClass = getProgressBoxClassName(journey.accuracy);
          return "".concat(baseClass, " ").concat(_topicBox["default"].IN_PROGRESS, " ").concat(progressClass);
        }
      case _skillQuestsMasteryConstants.ASSIGNMENT_STATUSES.ASSIGNED:
        {
          return "".concat(baseClass, " ").concat(_topicBox["default"].ASSIGNED);
        }
      case _skillQuestsMasteryConstants.ASSIGNMENT_STATUSES.COMPLETED:
        {
          var _progressClass = getProgressBoxClassName(journey.accuracy);
          return "".concat(baseClass, " ").concat(_topicBox["default"].COMPLETED, " ").concat(_progressClass);
        }
      default:
        {
          return "".concat(baseClass);
        }
    }
  };

  /**
   * RENDERS
   */
  var renderAccuracyText = function renderAccuracyText(accuracy) {
    if (accuracy) return /*#__PURE__*/_react["default"].createElement("p", null, text.boxAccuracyText(journey.accuracy));
    return null;
  };
  var rendersAssignmentTypeText = function rendersAssignmentTypeText(assignmentType) {
    var ASSIGN_REVIEW_UPF = ASSIGNMENT_TYPE.ASSIGN_REVIEW_UPF,
      ASSIGN_REVIEW_ASSESSMENT = ASSIGNMENT_TYPE.ASSIGN_REVIEW_ASSESSMENT,
      VOLUNTARY = ASSIGNMENT_TYPE.VOLUNTARY;
    var assignReviewUpfText = text.assignReviewUpfText,
      assignReviewAssessmentText = text.assignReviewAssessmentText,
      voluntaryText = text.voluntaryText;
    var returnedText = null;
    switch (assignmentType) {
      case ASSIGN_REVIEW_UPF:
        returnedText = assignReviewUpfText;
        break;
      case ASSIGN_REVIEW_ASSESSMENT:
        returnedText = assignReviewAssessmentText;
        break;
      case VOLUNTARY:
        returnedText = voluntaryText;
        break;
      default:
        break;
    }
    return /*#__PURE__*/_react["default"].createElement("p", null, returnedText);
  };
  var renderAttempts = function renderAttempts(learningjourney) {
    var assignmentsHistory = learningjourney.assignmentsHistory,
      assignmentType = learningjourney.assignmentType;
    var assignmentTypeText = rendersAssignmentTypeText(assignmentType);
    var attempts = text.attempts;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _topicBox["default"].attempts
    }, /*#__PURE__*/_react["default"].createElement("h3", null, attempts, ":"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _topicBox["default"].attemptsContainer
    }, assignmentsHistory && assignmentsHistory.map(function (assignments) {
      return /*#__PURE__*/_react["default"].createElement(_attempt.Attempt, _extends({
        key: assignmentTypeText,
        assignmentTypeText: assignmentTypeText
      }, assignments));
    })));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: getLearningJourneyBoxClassName()
  }, /*#__PURE__*/_react["default"].createElement(_contextModal["default"], {
    className: _topicBox["default"]['box-context-modal'],
    show: true,
    position: MODAL_DOWN,
    onClickOutsideHandler: function onClickOutsideHandler() {}
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, journey.name), renderAccuracyText(journey.accuracy), /*#__PURE__*/_react["default"].createElement("p", null, text.boxStepsCompletedText(journey.completedStepsCount, journey.totalStepsCount)), rendersAssignmentTypeText(journey.assignmentType), journey.assignmentsHistory && journey.assignmentsHistory.length > 0 && renderAttempts(journey))));
};
TopicBox.propTypes = {
  journey: _propTypes["default"].shape({
    name: _propTypes.string,
    status: _propTypes.number,
    accuracy: _propTypes.number,
    completedStepsCount: _propTypes.number,
    totalStepsCount: _propTypes.number,
    assignmentsHistory: _propTypes["default"].shape({
      assignmentType: _propTypes.number,
      assignmentStartDate: _propTypes.string,
      isFocusedResult: _propTypes.bool,
      resultAccuracy: _propTypes.number
    })
  })
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_topicBox["default"])(TopicBox);

/***/ }),

/***/ "KmGe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslatedOptions = exports.getTranslateSelectedOption = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * TRANSLATIONS
 */
var getTranslateSelectedOption = exports.getTranslateSelectedOption = function getTranslateSelectedOption(selectedOption, type, i18n) {
  if (i18n && selectedOption.value === type) {
    var updatedLabel = "Report Filters - ".concat(type);
    return _objectSpread(_objectSpread({}, selectedOption), {}, {
      label: i18n._(updatedLabel)
    });
  }
  return selectedOption;
};
var getTranslatedOptions = exports.getTranslatedOptions = function getTranslatedOptions(options, type, i18n) {
  if (i18n) {
    return options.map(function (item) {
      if (item.value === type) {
        var updatedLabel = "Report Filters - ".concat(type);
        return _objectSpread(_objectSpread({}, item), {}, {
          label: i18n._(updatedLabel)
        });
      }
      return item;
    });
  }
  return options;
};

/***/ }),

/***/ "KsCg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1R9EI {\n  height: calc(100% - 90px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-top: 6px; }\n  .component---1R9EI .certificates---20GWZ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .component---1R9EI > div:first-of-type {\n    padding: 16px 0; }\n  .component---1R9EI .student-info---3fILG {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 16px 0 32px; }\n  .component---1R9EI .student-info---3fILG > div {\n      margin: 0 8px; }\n  .component---1R9EI .student-info---3fILG > div:first-of-type {\n        margin-left: 0; }\n  .component---1R9EI .student-info---3fILG > div:last-of-type {\n        margin-right: 0; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1R9EI",
	"certificates": "certificates---20GWZ",
	"student-info": "student-info---3fILG"
};

/***/ }),

/***/ "KtCJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---6gaCW {\n  height: 100%;\n  min-width: 1100px; }\n  .component---6gaCW > div {\n    height: 100%; }\n  .component---6gaCW .report-container---3GDg_ {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n  .manage-students-button---DnkpO {\n  background: none;\n  color: #278bcb;\n  text-decoration: underline;\n  border: none;\n  padding: 0;\n  cursor: pointer; }\n", ""]);

// exports
exports.locals = {
	"component": "component---6gaCW",
	"report-container": "report-container---3GDg_",
	"manage-students-button": "manage-students-button---DnkpO"
};

/***/ }),

/***/ "L7wl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _activityMasteryPropType = __webpack_require__("+NxA");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var strengthWeaknessData = _propTypes["default"].shape({
  id: _propTypes["default"].number.isRequired,
  title: _propTypes["default"].string.isRequired,
  averageResult: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired
});
var activityMasteryData = _propTypes["default"].shape({
  className: _propTypes["default"].string,
  courseInfo: _propTypes["default"].shape(_objectSpread(_objectSpread({}, _activityMasteryPropType.activityMasteryPropTypeShape), {}, {
    id: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string.isRequired,
    totalTests: _propTypes["default"].number.isRequired
  })).isRequired,
  topicActivityResults: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread(_objectSpread({}, _activityMasteryPropType.activityMasteryPropTypeShape), {}, {
    id: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string.isRequired,
    totalAssignedActivities: _propTypes["default"].number.isRequired,
    activityResultDetails: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired,
      name: _propTypes["default"].string.isRequired,
      result: _propTypes["default"].number.isRequired,
      attempts: _propTypes["default"].number.isRequired,
      hasGoldBar: _propTypes["default"].bool.isRequired,
      isAssigned: _propTypes["default"].bool.isRequired
    })).isRequired
  }))).isRequired,
  testResults: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired,
    name: _propTypes["default"].string.isRequired,
    result: _propTypes["default"].number.isRequired,
    attempts: _propTypes["default"].number.isRequired
  })).isRequired,
  strengths: _propTypes["default"].shape({
    topics: _propTypes["default"].arrayOf(strengthWeaknessData),
    activities: _propTypes["default"].arrayOf(strengthWeaknessData)
  }).isRequired,
  weaknesses: _propTypes["default"].shape({
    topics: _propTypes["default"].arrayOf(strengthWeaknessData),
    activities: _propTypes["default"].arrayOf(strengthWeaknessData)
  }).isRequired
});
var _default = exports["default"] = {
  activityMasteryData: activityMasteryData
};

/***/ }),

/***/ "LH15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _yearGroupsActions = __webpack_require__("SRTg");
var initialState = [];

/**
 * Year Groups Reducer
 *
 * Consumes YEAR_GROUPS_RETRIEVED action
 *
 * @param {boolean} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - school year groups with their teachers and classes
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _yearGroupsActions.YEAR_GROUPS_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "LiCV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _filterPropTypes = __webpack_require__("1g86");
var _filterConstants = __webpack_require__("cdWI");
var _studentHelpers = __webpack_require__("GejO");
var _studentDataTable = _interopRequireDefault(__webpack_require__("iUu1"));
var _courseEmptyState = _interopRequireDefault(__webpack_require__("WaVk"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * TABLE DISPLAY
 * ----------------------
 * Acts as conditional table rendering to optimise performance.
 */
var TableDisplay = /*#__PURE__*/function (_React$Component) {
  function TableDisplay() {
    _classCallCheck(this, TableDisplay);
    return _callSuper(this, TableDisplay, arguments);
  }
  _inherits(TableDisplay, _React$Component);
  return _createClass(TableDisplay, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var skillQuestsMasteryStudentData = JSON.stringify(this.props.skillQuestsMasteryStudentData);
      var newSkillQuestsMasteryStudentData = JSON.stringify(nextProps.skillQuestsMasteryStudentData);
      return skillQuestsMasteryStudentData !== newSkillQuestsMasteryStudentData;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        skillQuestsMasteryStudentData = _this$props.skillQuestsMasteryStudentData,
        activeFilters = _this$props.activeFilters,
        isLoading = _this$props.isLoading,
        onCompletedTextClickHandler = _this$props.onCompletedTextClickHandler,
        assignmentResultType = _this$props.assignmentResultType;
      var checkValidCourses = (0, _studentHelpers.hasValidCourses)(skillQuestsMasteryStudentData);
      var shouldRenderTable = !isLoading && checkValidCourses;
      var shouldRenderEmptyState = !isLoading && !checkValidCourses;
      if (!skillQuestsMasteryStudentData) {
        return null;
      }
      if (shouldRenderTable) {
        return /*#__PURE__*/_react["default"].createElement(_studentDataTable["default"], {
          skillQuestsMasteryStudentData: skillQuestsMasteryStudentData,
          selectedClassId: activeFilters[_filterConstants.SELECTED_CLASS].id,
          onCompletedTextClickHandler: onCompletedTextClickHandler,
          assignmentResultType: assignmentResultType
        });
      }
      if (shouldRenderEmptyState) {
        return /*#__PURE__*/_react["default"].createElement(_courseEmptyState["default"], {
          onClickHandler: onCompletedTextClickHandler
        });
      }
      return null;
    }
  }]);
}(_react["default"].Component);
_defineProperty(TableDisplay, "propTypes", {
  activeFilters: _filterPropTypes.activeFiltersPropType,
  isLoading: _propTypes["default"].bool,
  skillQuestsMasteryStudentData: _propTypes["default"].object,
  onCompletedTextClickHandler: _propTypes["default"].func,
  assignmentResultType: _propTypes["default"].number
});
var _default = exports["default"] = TableDisplay;

/***/ }),

/***/ "Lxao":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".barsContainer---Rohpb {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-height: 50px;\n  max-height: 50px;\n  width: 125px;\n  cursor: pointer;\n  position: relative; }\n\n.graphContainer---3plOy {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  min-height: 50px;\n  max-height: 50px;\n  width: 104px;\n  cursor: pointer;\n  position: absolute;\n  margin-left: 18px; }\n\n.graphPoint---3Mmha {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  background-color: #00b4eb;\n  border-radius: 50%;\n  margin-top: -3px; }\n\n.row---2uGG6 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%;\n  position: relative; }\n\n.barline---17nhR {\n  border-bottom: 1px solid #bacac2;\n  width: 85%; }\n\n.graphline---3dD_M {\n  min-height: 100%;\n  overflow: hidden; }\n\n.percentage---1_uUT {\n  color: #484848;\n  font-size: 8px;\n  position: absolute;\n  left: 0; }\n", ""]);

// exports
exports.locals = {
	"barsContainer": "barsContainer---Rohpb",
	"graphContainer": "graphContainer---3plOy",
	"graphPoint": "graphPoint---3Mmha",
	"row": "row---2uGG6",
	"barline": "barline---17nhR",
	"graphline": "graphline---3dD_M",
	"percentage": "percentage---1_uUT"
};

/***/ }),

/***/ "MKpC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactRedux = __webpack_require__("RH2O");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _certificateConfirmationModal = _interopRequireDefault(__webpack_require__("lyol"));
var _downloadIcon = _interopRequireDefault(__webpack_require__("cQtF"));
var _downloadButton = _interopRequireDefault(__webpack_require__("Tpjw"));
var _useTranslations2 = __webpack_require__("T2Mb");
var _subHeadingHeader = _interopRequireDefault(__webpack_require__("X5f6"));
var _rankDropdown = _interopRequireDefault(__webpack_require__("ivll"));
var _constants = __webpack_require__("1QGX");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CertificateConfirmationModal = function CertificateConfirmationModal(_ref) {
  var certificatesCount = _ref.certificatesCount,
    certificateType = _ref.certificateType,
    handleDownloadClick = _ref.handleDownloadClick;
  var _useTranslations = (0, _useTranslations2.useTranslations)(),
    certificates = _useTranslations.certificates,
    selectVersion = _useTranslations.selectVersion,
    fullColour = _useTranslations.fullColour,
    printerFriendly = _useTranslations.printerFriendly,
    selectRanksAndVersion = _useTranslations.selectRanksAndVersion;
  var downloadingHeadings = (0, _useTranslations2.useCertificateDownloadTranslations)();
  var downloadHeadingByType = downloadingHeadings[certificateType] || '';
  var gemsDetails = (0, _reactRedux.useSelector)(function (state) {
    return state.gemsDetails;
  });
  var showRankDropdown = gemsDetails.length > 0 && certificateType !== _constants.TOTAL_CERTIFICATES_TYPE;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedGems = _useState2[0],
    setSelectedGems = _useState2[1];
  (0, _react.useEffect)(function () {
    setSelectedGems(gemsDetails);
  }, [gemsDetails]);
  var gemTypes = selectedGems.map(function (item) {
    return item.gem;
  });
  var gemCount = showRankDropdown ? selectedGems.reduce(function (acc, item) {
    return acc + item.count;
  }, 0) : certificatesCount;
  var getGemDetails = function getGemDetails() {
    return {
      gemTypes: gemTypes,
      gemCount: gemCount
    };
  };
  var isDownloadDisabled = showRankDropdown && gemCount === 0;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateConfirmationModal["default"].container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateConfirmationModal["default"].heading
  }, certificateType ? "".concat(downloadHeadingByType) : "".concat(certificatesCount, " ").concat(certificates)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateConfirmationModal["default"].info
  }, showRankDropdown ? selectRanksAndVersion : selectVersion), showRankDropdown && /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateConfirmationModal["default"]['rank-dropdown-container']
  }, /*#__PURE__*/_react["default"].createElement(_subHeadingHeader["default"], {
    isModal: true
  }), /*#__PURE__*/_react["default"].createElement(_rankDropdown["default"], {
    certificatesCount: certificatesCount,
    options: gemsDetails,
    setSelectedGems: setSelectedGems
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateConfirmationModal["default"].buttonsContainer
  }, /*#__PURE__*/_react["default"].createElement(_downloadButton["default"], {
    title: "".concat(fullColour, " (").concat(gemCount, ")"),
    icon: _downloadIcon["default"],
    onClick: function onClick() {
      if (!isDownloadDisabled) {
        handleDownloadClick(_objectSpread({
          fullColor: true
        }, getGemDetails()));
      }
    },
    disabled: isDownloadDisabled
  }), /*#__PURE__*/_react["default"].createElement(_downloadButton["default"], {
    title: "".concat(printerFriendly, " (").concat(gemCount, ")"),
    icon: _downloadIcon["default"],
    onClick: function onClick() {
      if (!isDownloadDisabled) {
        handleDownloadClick(_objectSpread({
          fullColor: false
        }, getGemDetails()));
      }
    },
    disabled: isDownloadDisabled
  })));
};
CertificateConfirmationModal.propTypes = {
  certificatesCount: _propTypes["default"].number.isRequired,
  certificateType: _propTypes["default"].number,
  handleDownloadClick: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_certificateConfirmationModal["default"])(CertificateConfirmationModal);

/***/ }),

/***/ "MjMp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STUDENT_NAME = exports.SINGLE_CLASS_USAGE_TABLE_CONFIG = exports.SINGLE_CLASS_PARTICIPATION_TABLE_CONFIG = exports.GROUP_NAME = exports.COURSE_NAME = void 0;
var _singleClass = _interopRequireDefault(__webpack_require__("MyZd"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var GROUP_NAME = exports.GROUP_NAME = 'name';
var COURSE_NAME = exports.COURSE_NAME = 'courseName';
var STUDENT_NAME = exports.STUDENT_NAME = 'fullName';
var ACTIVITY_POINTS = 'points.activityPoints';
var SKILL_POINTS = 'points.skillQuestsPoints';
var LIVE_POINTS = 'points.livePoints';
var TOTAL_POINTS = 'points.total';
var BRONZE = 'certificateDetails.bronze';
var SILVER = 'certificateDetails.silver';
var GOLD = 'certificateDetails.gold';
var SIGN_INS = 'signIns';
var TIME_ONLINE = 'timeOnline';
var TOTAL_ACTIVITY_POINTS = 'activityPoints';
var TOTAL_SKILL_POINTS = 'skillQuestsPoints';
var TOTAL_LIVE_POINTS = 'livePoints';
var headerSort = {
  sortAs: 'nested',
  sortDir: 'desc'
};
var nestedSort = {
  sortAs: 'number'
};
var SINGLE_CLASS_PARTICIPATION_TABLE_CONFIG = exports.SINGLE_CLASS_PARTICIPATION_TABLE_CONFIG = {
  cols: [{
    id: GROUP_NAME,
    name: '',
    // this is set to teacher name in SingleClass component
    truncate: true,
    onClick: null,
    // this is set to load group view for class view only in SingleClass component
    classes: _singleClass["default"]['group-name'],
    sort: null // this is set to sort for class view only in SingleClass component
  }, {
    id: COURSE_NAME,
    name: 'Points - Activity',
    trucate: true,
    colSpan: 7,
    classes: _singleClass["default"]['course-name'],
    sort: {
      sortAs: 'nested'
    }
  }, {
    id: 'SKILL QUESTS POINTS',
    name: 'Points - Skill',
    headerOnly: true,
    sort: headerSort
  },
  /*
   * These cols will show only in the header
   * The nested data config will handle displaying these values for each group
   */
  {
    id: 'LIVE POINTS',
    name: 'Header - LivePoints',
    headerOnly: true,
    sort: headerSort
  }, {
    id: 'TOTAL POINTS',
    name: 'Points - Total',
    headerOnly: true,
    sort: headerSort
  }, {
    id: 'BRONZE',
    name: 'Label - Bronze',
    headerOnly: true,
    sort: headerSort
  }, {
    id: 'SILVER',
    name: 'Label - Silver',
    headerOnly: true,
    sort: headerSort
  }, {
    id: 'GOLD',
    name: 'Label - Gold',
    headerOnly: true,
    sort: headerSort
  }],
  nestedData: {
    id: 'studentUsageDetails',
    cols: [{
      id: STUDENT_NAME,
      truncate: true,
      onClick: function onClick() {
        return null;
      },
      // this is set to load student view in SingleClass component
      classes: _singleClass["default"]['student-name']
    }, {
      id: ACTIVITY_POINTS,
      sort: nestedSort
    }, {
      id: SKILL_POINTS,
      sort: nestedSort
    }, {
      id: LIVE_POINTS,
      sort: nestedSort
    }, {
      id: TOTAL_POINTS,
      sort: nestedSort
    }, {
      id: BRONZE,
      sort: nestedSort
    }, {
      id: SILVER,
      sort: nestedSort
    }, {
      id: GOLD,
      sort: nestedSort
    }]
  },
  emptyDataMessage: 'No participation results found',
  defaultSort: null
};
var SINGLE_CLASS_USAGE_TABLE_CONFIG = exports.SINGLE_CLASS_USAGE_TABLE_CONFIG = {
  cols: [{
    id: SIGN_INS,
    name: 'Header - Sign-ins'
  }, {
    id: TIME_ONLINE,
    name: 'Header - TimeOnline',
    transform: function transform(row) {
      var _row$timeOnline = row.timeOnline,
        hours = _row$timeOnline.hours,
        minutes = _row$timeOnline.minutes;
      return "".concat(hours, "h ").concat(minutes, "min");
    }
  }, {
    id: TOTAL_ACTIVITY_POINTS,
    name: 'Points - Activity'
  }, {
    id: TOTAL_SKILL_POINTS,
    name: 'Points - Skill'
  }, {
    id: TOTAL_LIVE_POINTS,
    name: 'Header - LivePoints'
  }]
};

/***/ }),

/***/ "MoQg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attempt = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _moment = _interopRequireDefault(__webpack_require__("PJh5"));
var _linguiCdn = __webpack_require__("siuH");
var _topicBox = _interopRequireDefault(__webpack_require__("5tmF"));
var _topicBox2 = __webpack_require__("Kl0G");
var _assignmentResultReducer = __webpack_require__("llwb");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var VOLUNTARY = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.VOLUNTARY;
var Attempt = exports.Attempt = function Attempt(assignments) {
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var resultAccuracy = assignments.resultAccuracy,
    assignmentStartDate = assignments.assignmentStartDate,
    assignmentType = assignments.assignmentType;
  var ASSIGNMENT_ITEM_TEXT = {
    Assigned: i18n._(
    /*i18n*/
    {
      id: "Assignment Item - Assigned - Label"
    }),
    Voluntary: i18n._(
    /*i18n*/
    {
      id: "Assignment Item - Voluntary - Label"
    })
  };
  var getIsFocusedResultClass = function getIsFocusedResultClass(isFocusedResult) {
    return isFocusedResult ? _topicBox["default"]['is-focused-result'] : '';
  };
  var progressColor = (0, _topicBox2.getProgressBoxClassName)(resultAccuracy);
  var assignmentTypeText = assignmentType === VOLUNTARY ? ASSIGNMENT_ITEM_TEXT.Voluntary : ASSIGNMENT_ITEM_TEXT.Assigned;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _topicBox["default"].wrapper,
    key: assignmentStartDate
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_topicBox["default"].circle, " ").concat(progressColor, " ").concat(getIsFocusedResultClass(assignments.isFocusedResult))
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _topicBox["default"]['connect-block']
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _topicBox["default"]['tooltip-wrapper']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _topicBox["default"]['assign-info']
  }, assignmentTypeText, ":", ' ', (0, _moment["default"])(assignmentStartDate).format('DD/MM/YY')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_topicBox["default"]['accuracy-info'], " ").concat(progressColor)
  }, resultAccuracy, "%")));
};

/***/ }),

/***/ "Mre5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ALL_CLASSES_RETRIEVED = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _constants = __webpack_require__("1QGX");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ALL_CLASSES_RETRIEVED = exports.ALL_CLASSES_RETRIEVED = 'ALL_CLASSES_RETRIEVED';
function getClassesData() {
  return function (dispatch) {
    return _resources["default"].allClassrooms.get().withParams({
      productId: _constants.MATHLETICS_ID
    }).send().then(function (payload) {
      if (payload.data && Array.isArray(payload.data)) {
        var classes = mapClassesData(payload.data);
        dispatch({
          type: ALL_CLASSES_RETRIEVED,
          payload: classes
        });
        dispatch(_dropdownDataActions["default"].setClassroomList(classes));
      } else {
        dispatch(_modalActions["default"].openModal({
          content: 'Failed to load class list'
        }));
      }
    });
  };
}
function mapClassesData(data) {
  return data.map(function (item) {
    return {
      id: item.id,
      name: item.name,
      isClassEmpty: item.isClassEmpty
    };
  });
}
var _default = exports["default"] = {
  getClassesData: getClassesData
};

/***/ }),

/***/ "Mxz8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("nYQu");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./course-empty-state.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./course-empty-state.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "MyZd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("nKx8");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./single-class.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./single-class.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "N5/L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  // The application name, to be used when asking the configuration system for settings
  appName: 'StudentReportsHost',
  // These applications are referenced by the project in an unbuilt state, and require babel to also be run over them
  childApplications: []
};

/***/ }),

/***/ "NMd/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _studentActions = __webpack_require__("vDBE");
var initialState = null;

/**
 * Participation - Student Reducer
 *
 * Consumes PARTICIPATION_STUDENT_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _studentActions.PARTICIPATION_STUDENT_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "NNJ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _hasLifetimeDataActions = __webpack_require__("ZBNL");
var initialState = false;

/**
 * Has Lifetime Data Reducer
 *
 * Consumes SCHOOL_HAS_LIFETIME_DATA action
 *
 * @access public
 * @param {boolean} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {boolean} - whether school has extended results
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _hasLifetimeDataActions.SCHOOL_HAS_LIFETIME_DATA:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "NVCm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ParticipationFooter = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _reactComponents = __webpack_require__("fmgT");
var _exportReportActions = __webpack_require__("oXgP");
var _filterConstants = __webpack_require__("cdWI");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _reportStateActions = _interopRequireWildcard(__webpack_require__("ItvU"));
var _allClassesActions = _interopRequireDefault(__webpack_require__("FDbR"));
var _filterPropTypes = __webpack_require__("1g86");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays Footer component for Participation All Years report
 * NOTE: Discovered this footer is not visible in any scenario. The Container pushes it out of view
 * but all functionality still works fine.
 */
var ParticipationFooter = exports.ParticipationFooter = /*#__PURE__*/function (_PureComponent) {
  function ParticipationFooter(props) {
    var _this;
    _classCallCheck(this, ParticipationFooter);
    _this = _callSuper(this, ParticipationFooter, [props]);
    _defineProperty(_this, "shouldDisplayFooter", function (reportLevel, reportType) {
      return reportLevel === _exportReportActions.REPORT_LEVEL_ALL_YEARS && reportType === _filterConstants.PARTICIPATION;
    });
    _defineProperty(_this, "loadByYear", function () {
      _this.loadReport('getAllYearsData', _reportStateActions.REPORT_STATE_ALL_YEARS);
    });
    _defineProperty(_this, "loadByClass", function () {
      _this.loadReport('getByClassData', _reportStateActions.REPORT_STATE_ALL_CLASSES);
    });
    _defineProperty(_this, "loadTopTen", function () {
      _this.loadReport('getTop10StudentsData', _reportStateActions.REPORT_STATE_TOP_TEN);
    });
    var _reportLevel = props.reportLevel,
      _reportType = props.reportType;
    _this.i18n = window.i18n;
    _this.state = {
      display: _this.shouldDisplayFooter(_reportLevel, _reportType)
    };
    return _this;
  }
  _inherits(ParticipationFooter, _PureComponent);
  return _createClass(ParticipationFooter, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props = this.props,
        reportLevel = _this$props.reportLevel,
        reportType = _this$props.reportType;
      var newReportLevel = newProps.reportLevel,
        newReportType = newProps.reportType;
      if (reportLevel !== newReportLevel || reportType !== newReportType) {
        this.setState({
          display: this.shouldDisplayFooter(newReportLevel, newReportType)
        });
      }
    }
  }, {
    key: "loadReport",
    value: function loadReport(actionCreator, reportState) {
      var _this$props2 = this.props,
        selectedDate = _this$props2.selectedDate,
        setReportState = _this$props2.setReportState;
      setReportState(reportState);
      this.props[actionCreator](selectedDate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        className = _this$props3.className,
        reportState = _this$props3.reportState;
      this.i18n = window.i18n;
      var display = this.state.display;
      if (!display || !this.i18n) {
        return null;
      }
      var byYear = this.i18n._('Button Label - ByYear');
      var byClass = this.i18n._('Button Label - ByClass');
      var topTwenty = this.i18n._('Button Label - TopTwentyStudents');
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.Footer, {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        text: byYear,
        primary: true,
        type: _reactComponents.Button.LOZENGE,
        disabled: reportState === _reportStateActions.REPORT_STATE_ALL_YEARS,
        onClick: this.loadByYear
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        text: byClass,
        primary: true,
        type: _reactComponents.Button.LOZENGE,
        disabled: reportState === _reportStateActions.REPORT_STATE_ALL_CLASSES,
        onClick: this.loadByClass
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        text: topTwenty,
        primary: true,
        type: _reactComponents.Button.LOZENGE,
        disabled: reportState === _reportStateActions.REPORT_STATE_TOP_TEN,
        onClick: this.loadTopTen
      }));
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component props using redux state
 */
_defineProperty(ParticipationFooter, "propTypes", {
  className: _propTypes["default"].string,
  reportLevel: _propTypes["default"].oneOf(_exportReportActions.REPORT_LEVELS).isRequired,
  reportType: _propTypes["default"].oneOf([_filterConstants.ACTIVITY_MASTERY, _filterConstants.PARTICIPATION, _filterConstants.LIVE_MATHS, _filterConstants.SKILL_QUESTS_MASTERY]).isRequired,
  reportState: _propTypes["default"].oneOf([_reportStateActions.REPORT_STATE_ALL_YEARS, _reportStateActions.REPORT_STATE_ALL_CLASSES, _reportStateActions.REPORT_STATE_TOP_TEN]).isRequired,
  selectedDate: _filterPropTypes.dateFilterPropType,
  setReportState: _propTypes["default"].func.isRequired
});
function mapStateToProps(state) {
  return {
    reportLevel: _activeFiltersSelectors["default"].selectReportLevel(state),
    reportType: _activeFiltersSelectors["default"].selectReportId(state),
    reportState: state.reportState,
    selectedDate: _activeFiltersSelectors["default"].selectDate(state)
  };
}

/*
 * mapDispatchToProps - set component props, wrapping redux action creators in a dispatch call
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getAllYearsData: _allClassesActions["default"].getParticipationData,
    getByClassData: _allClassesActions["default"].getByClassData,
    getTop10StudentsData: _allClassesActions["default"].getTop10StudentsData,
    setReportState: _reportStateActions["default"].setReportState
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ParticipationFooter);

/***/ }),

/***/ "NtCD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _icon_star = _interopRequireDefault(__webpack_require__("IJC2"));
var _activityPercentageBar = _interopRequireDefault(__webpack_require__("RT+T"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * ActivityPercentageBar component - displays activity percentage bar
 */
var ActivityPercentageBar = /*#__PURE__*/function (_Component) {
  function ActivityPercentageBar() {
    var _this;
    _classCallCheck(this, ActivityPercentageBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ActivityPercentageBar, [].concat(args));
    _defineProperty(_this, "getClassName", function (percentage) {
      if (percentage >= 86 && percentage <= 100) {
        return _activityPercentageBar["default"].mastered;
      } else if (percentage >= 66 && percentage <= 85) {
        return _activityPercentageBar["default"].consolidating;
      } else if (percentage >= 50 && percentage <= 65) {
        return _activityPercentageBar["default"].developing;
      } else if (percentage >= 26 && percentage <= 49) {
        return _activityPercentageBar["default"].emerging;
      } else if (percentage >= 0 && percentage <= 25) {
        return _activityPercentageBar["default"].needsImproving;
      }
      return null;
    });
    _defineProperty(_this, "renderPercentage", function (percentage) {
      var percentageText;
      var fontColor;
      if (percentage > 100 || percentage < 0) {
        percentageText = '- %';
      } else {
        percentageText = "".concat(percentage, "%");
        fontColor = _activityPercentageBar["default"].white;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_activityPercentageBar["default"].percentage, " ").concat(fontColor)
      }, percentageText);
    });
    _defineProperty(_this, "renderStar", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _activityPercentageBar["default"].icon
      }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
        src: _icon_star["default"],
        cacheGetRequests: true
      }));
    });
    return _this;
  }
  _inherits(ActivityPercentageBar, _Component);
  return _createClass(ActivityPercentageBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        percentage = _this$props.percentage,
        hasGoldBar = _this$props.hasGoldBar;
      var className = this.getClassName(percentage);
      var width = !className ? '33px' : "".concat(percentage, "%");
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_activityPercentageBar["default"].container, " ").concat(className),
        style: {
          width: width
        },
        key: className
      }, hasGoldBar && this.renderStar(), this.renderPercentage(percentage));
    }
  }]);
}(_react.Component);
ActivityPercentageBar.propTypes = {
  percentage: _propTypes["default"].number,
  hasGoldBar: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_activityPercentageBar["default"])(ActivityPercentageBar);

/***/ }),

/***/ "OCle":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOPIC_TABLE_MESSAGE = exports.SELECTION_AS_IS = exports.IMPROVEMENT_OPTS = exports.IMPROVEMENT = exports.HIGHEST_VS_LATEST_TABLE_CONFIG = exports.HIGHEST_VS_LATEST = exports.FIRST_VS_LATEST_TABLE_CONFIG = exports.FIRST_VS_LATEST = exports.FIRST_VS_HIGHEST = exports.FIRST_VS_HIGEST_TABLE_CONFIG = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _topicTables = _interopRequireDefault(__webpack_require__("JmQc"));
var _participationResult = _interopRequireDefault(__webpack_require__("8/AG"));
var _participationImprovement = _interopRequireDefault(__webpack_require__("5ceo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TOPIC_NAME = 'name';
var AVG_FIRST = 'totalFirstAttempt';
var AVG_HIGHEST = 'totalHighestAttempt';
var AVG_LATEST = 'totalLatestAttempt';
var ACTIVITY_NAME = 'name';
var NUM_ATTEMPTS = 'noOfAttempts';
var FIRST_ATTEMPT = 'firstAttemptResult';
var HIGHEST_ATTEMPT = 'highestAttemptResult';
var LATEST_ATTEMPT = 'latestAttemptResult';
var FIRST_VS_LATEST = exports.FIRST_VS_LATEST = 'firstVsLatest';
var HIGHEST_VS_LATEST = exports.HIGHEST_VS_LATEST = 'highestVsLatest';
var FIRST_VS_HIGHEST = exports.FIRST_VS_HIGHEST = 'firstVsHighest';
var SELECTION_AS_IS = exports.SELECTION_AS_IS = 'selectionAsIs';
var IMPROVEMENT = exports.IMPROVEMENT = 'Improvement';
var TOPIC_TABLE_MESSAGE = exports.TOPIC_TABLE_MESSAGE = 'Message - TopicTable';
var IMPROVEMENT_OPTS = exports.IMPROVEMENT_OPTS = [{
  label: 'Label - FirstVsLatest',
  value: FIRST_VS_LATEST
}, {
  label: 'Label - HighestVsLatest',
  value: HIGHEST_VS_LATEST
}, {
  label: 'Label - FirstVsHighest',
  value: FIRST_VS_HIGHEST
}];
var TOPIC_TABLE_CONFIG = {
  cols: [{
    id: TOPIC_NAME,
    classes: _topicTables["default"]['topic-name']
  }, {
    id: NUM_ATTEMPTS,
    name: 'Header - Attempts',
    transform: function transform() {
      return '';
    },
    classes: _topicTables["default"]['num-attempts']
  }, {
    // this is set properly in the improvement specific configs below
    id: IMPROVEMENT,
    name: IMPROVEMENT,
    transform: function transform() {
      return '';
    },
    classes: _topicTables["default"].improvement
  }, generateAverageResultCol(AVG_FIRST, 'Header - First'), generateAverageResultCol(AVG_HIGHEST, 'Header - Highest'), generateAverageResultCol(AVG_LATEST, 'Header - Latest')],
  nestedData: {
    id: 'activityParticipations',
    collapse: {
      enable: true
    },
    emptyDataMessage: 'Empty - NoActivities',
    messageTopicTable: 'Message - TopicTable',
    cols: [{
      id: ACTIVITY_NAME,
      classes: _topicTables["default"]['activity-name'],
      truncate: true
    }, {
      id: NUM_ATTEMPTS,
      classes: _topicTables["default"]['num-attempts']
    }, {
      name: IMPROVEMENT,
      classes: _topicTables["default"].improvement
    },
    // this is set properly in the improvement specific configs below
    generateResultCol(FIRST_ATTEMPT), generateResultCol(HIGHEST_ATTEMPT), generateResultCol(LATEST_ATTEMPT)]
  }
};
var FIRST_VS_LATEST_TABLE_CONFIG = exports.FIRST_VS_LATEST_TABLE_CONFIG = generateImprovementConfig(FIRST_VS_LATEST);
var HIGHEST_VS_LATEST_TABLE_CONFIG = exports.HIGHEST_VS_LATEST_TABLE_CONFIG = generateImprovementConfig(HIGHEST_VS_LATEST);
var FIRST_VS_HIGEST_TABLE_CONFIG = exports.FIRST_VS_HIGEST_TABLE_CONFIG = generateImprovementConfig(FIRST_VS_HIGHEST);

/**
 * Generates the improvement-type specific config from the base topic table config, adding the correct col and
 * nested data col into the config for improvement type (first vs latest, latest vs highest, first vs highest)
 */
function generateImprovementConfig(improvementType) {
  var improvementConfig = (0, _cloneDeep["default"])(TOPIC_TABLE_CONFIG);
  var topicImprovementCol = improvementConfig.cols.find(function (col) {
    return col.name === IMPROVEMENT;
  });
  var activityImprovementCol = improvementConfig.nestedData.cols.find(function (col) {
    return col.name === IMPROVEMENT;
  });
  topicImprovementCol.name = improvementType;
  activityImprovementCol.id = improvementType;
  activityImprovementCol.transform = function (row) {
    return /*#__PURE__*/_react["default"].createElement(_participationImprovement["default"], {
      improvement: row[improvementType]
    });
  };
  return improvementConfig;
}

/**
 * Generates col config for a topic average result col
 */
function generateAverageResultCol(id, name) {
  return {
    id: id,
    name: name,
    classes: _topicTables["default"]['result-attempt'],
    transform: function transform(row) {
      return /*#__PURE__*/_react["default"].createElement(_participationResult["default"], {
        result: row[id],
        isAverage: true
      });
    }
  };
}

/**
 * Generates col config for an activity result col
 */
function generateResultCol(id) {
  return {
    id: id,
    classes: _topicTables["default"]['result-attempt'],
    transform: function transform(row) {
      return /*#__PURE__*/_react["default"].createElement(_participationResult["default"], {
        result: row[id]
      });
    }
  };
}

/***/ }),

/***/ "OZAO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LIVE_MATHS_ALL_CLASSES_RETRIEVED = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _constants = __webpack_require__("1QGX");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _liveMathsLevelPickerActions = _interopRequireDefault(__webpack_require__("7NtK"));
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LIVE_MATHS_ALL_CLASSES_RETRIEVED = exports.LIVE_MATHS_ALL_CLASSES_RETRIEVED = 'LIVE_MATHS_ALL_CLASSES_RETRIEVED';
function getLiveMathsData(selectedDate, selectedYearGroupId, selectedTeacherId) {
  return function (dispatch, getState) {
    var state = getState();
    if (state.isAdmin === true) {
      getAdminData(dispatch, selectedDate, selectedYearGroupId, selectedTeacherId);
    } else {
      getTeacherData(dispatch, selectedDate);
    }
  };
}
function getAdminData(dispatch, selectedDate, selectedYearGroupId, selectedTeacherId) {
  var yearGroupId = _constants.ENDPOINT_PATH_ALL_YEARS;
  var teacherId = _constants.ENDPOINT_PATH_ALL_TEACHERS;
  var resource = 'yearGroupReport';
  if (selectedYearGroupId != null && selectedYearGroupId !== _filterConstants.ALL_YEARS) {
    yearGroupId = selectedYearGroupId;
  }
  if (selectedTeacherId != null && selectedTeacherId !== _filterConstants.ALL_TEACHERS) {
    teacherId = selectedTeacherId;
    resource = 'teacherReport';
  }
  var params = {
    yearGroupId: yearGroupId,
    teacherId: teacherId
  };
  getData(resource, dispatch, selectedDate, params);
}
function getTeacherData(dispatch, selectedDate) {
  getData('allClassesReport', dispatch, selectedDate);
}
function getData(resource, dispatch, selectedDate) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  params = _objectSpread(_objectSpread({
    reportType: _constants.ENDPOINT_PATH_LIVE_MATHS
  }, _dateParamHelper["default"].getDateTypePath(selectedDate)), params);
  _resources["default"][resource].get(params).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDate)).send().then(function (payload) {
    if (payload.valid) {
      dispatch(_liveMathsLevelPickerActions["default"].resetLevel());
      dispatch({
        type: LIVE_MATHS_ALL_CLASSES_RETRIEVED,
        payload: mapParticipationData(payload.data)
      });
    } else {
      dispatch(_errorsActions["default"].addError(LIVE_MATHS_ALL_CLASSES_RETRIEVED));
    }
  });
}
function mapParticipationData(data) {
  if (!data.liveMathsLevelResult) {
    return null;
  }
  var levels = [];
  for (var level in data.liveMathsLevelResult) {
    levels.push({
      id: +level,
      level: level,
      classes: data.liveMathsLevelResult[level].map(function (classData) {
        return {
          id: classData.id,
          name: classData.name,
          totalCorrect: mapLiveMathsScore(classData.totalCorrect),
          topScore: mapLiveMathsScore(classData.topScore),
          accuracy: mapLiveMathsScore(classData.accuracy, '%'),
          questionsPerMinute: mapLiveMathsScore(classData.questionsPerMinute)
        };
      })
    });
  }
  return levels;
}
function mapLiveMathsScore(score, suffix) {
  if (score === -1) {
    return '-';
  } else if (suffix) {
    return "".concat(score).concat(suffix);
  }
  return score;
}
var _default = exports["default"] = {
  getLiveMathsData: getLiveMathsData
};

/***/ }),

/***/ "Oi3E":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/7c39a9c1f746b3ce5b2f4f31bdec3ca2.svg";

/***/ }),

/***/ "PLdC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GEM_COUNTS_RETRIEVED = exports.CERTIFICATES_DOWNLOAD_REQUESTED = exports.CERTIFICATES_DOWNLOAD_COMPLETED = void 0;
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _certificateConstants = __webpack_require__("tQue");
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var CERTIFICATES_DOWNLOAD_REQUESTED = exports.CERTIFICATES_DOWNLOAD_REQUESTED = 'CERTIFICATES_DOWNLOAD_REQUESTED';
var CERTIFICATES_DOWNLOAD_COMPLETED = exports.CERTIFICATES_DOWNLOAD_COMPLETED = 'CERTIFICATES_DOWNLOAD_COMPLETED';
var GEM_COUNTS_RETRIEVED = exports.GEM_COUNTS_RETRIEVED = 'GEM_COUNTS_RETRIEVED';
var certificatesDownloadRequested = function certificatesDownloadRequested() {
  return {
    type: CERTIFICATES_DOWNLOAD_REQUESTED
  };
};
var certificatesDownloadCompleted = function certificatesDownloadCompleted() {
  return {
    type: CERTIFICATES_DOWNLOAD_COMPLETED
  };
};
function getCertificateFilename(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$certificatesCoun = _ref.certificatesCount,
    certificatesCount = _ref$certificatesCoun === void 0 ? '' : _ref$certificatesCoun,
    _ref$certificateType = _ref.certificateType,
    certificateType = _ref$certificateType === void 0 ? '' : _ref$certificateType;
  var i18n = window.i18n;
  var name = "".concat(className, "_").concat(certificatesCount, "_").concat(certificateType);
  return i18n._(
  /*i18n*/
  {
    id: "Filename - Certificates - {name}",
    values: {
      name: name
    }
  });
}
function onSuccess(_x) {
  return _onSuccess.apply(this, arguments);
}
function _onSuccess() {
  _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref2) {
    var dispatch, url, certificateType, certificatesCount, className, fileNameOverride, authToken, downloadUrl, response, blob, a, objectUrl, certificateFileName;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          dispatch = _ref2.dispatch, url = _ref2.url, certificateType = _ref2.certificateType, certificatesCount = _ref2.certificatesCount, className = _ref2.className, fileNameOverride = _ref2.fileNameOverride;
          dispatch(certificatesDownloadCompleted());
          authToken = _resources["default"].env.authToken;
          downloadUrl = "".concat(url, "&authToken=").concat(authToken);
          _context.n = 1;
          return window.fetch(downloadUrl);
        case 1:
          response = _context.v;
          _context.n = 2;
          return response.blob();
        case 2:
          blob = _context.v;
          a = window.document.createElement('a');
          objectUrl = window.URL.createObjectURL(blob);
          a.href = objectUrl;
          certificateFileName = fileNameOverride || getCertificateFilename({
            className: className,
            certificatesCount: certificatesCount,
            certificateType: certificateType
          });
          certificateFileName = certificateFileName.replace(/\./g, '-');
          a.download = certificateFileName;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
          URL.revokeObjectURL(objectUrl);
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _onSuccess.apply(this, arguments);
}
function newCertificatesDownload(payload) {
  return function (dispatch) {
    dispatch(certificatesDownloadRequested());
    dispatch(_modalActions["default"].closeModal());
    return _resources["default"].downloadNewCertificates.get().withParams(payload).raw().send().then(function (response) {
      if (response.status === 200) {
        onSuccess(_objectSpread({
          dispatch: dispatch,
          url: response.verb.url
        }, payload));
      }
    });
  };
}
function pastCertificatesDownload(payload) {
  return function (dispatch) {
    dispatch(certificatesDownloadRequested());
    dispatch(_modalActions["default"].closeModal());
    return _resources["default"].downloadPastCertificates.get().withParams(payload).raw().send().then(function (response) {
      if (response.status === 200) {
        onSuccess(_objectSpread({
          dispatch: dispatch,
          url: response.verb.url
        }, payload));
      }
    });
  };
}
function newCertificatesDownloadByType(payload) {
  return function (dispatch) {
    dispatch(certificatesDownloadRequested());
    dispatch(_modalActions["default"].closeModal());
    var certificatesCount = payload.certificatesCount,
      certificateTypeName = payload.certificateTypeName,
      className = payload.className,
      fileNameOverride = payload.fileNameOverride;
    return _resources["default"].downloadNewCertificatesByType.get({
      type: payload.type
    }).withParams(payload).raw().send().then(function (response) {
      if (response.status === 200) {
        onSuccess({
          dispatch: dispatch,
          url: response.verb.url,
          certificatesCount: certificatesCount,
          certificateType: certificateTypeName,
          className: className,
          fileNameOverride: fileNameOverride
        });
      }
    });
  };
}
function pastCertificatesDownloadByType(payload) {
  return function (dispatch) {
    dispatch(certificatesDownloadRequested());
    dispatch(_modalActions["default"].closeModal());
    var certificatesCount = payload.certificatesCount,
      certificateTypeName = payload.certificateTypeName,
      className = payload.className,
      fileNameOverride = payload.fileNameOverride;
    return _resources["default"].downloadPastCertificatesByType.get({
      type: payload.type
    }).withParams(payload).raw().send().then(function (response) {
      if (response.status === 200) {
        onSuccess({
          dispatch: dispatch,
          url: response.verb.url,
          certificatesCount: certificatesCount,
          certificateType: certificateTypeName,
          className: className,
          fileNameOverride: fileNameOverride
        });
      }
    });
  };
}
function pastCertificatesDownloadStudentByType(payload) {
  return function (dispatch) {
    dispatch(certificatesDownloadRequested());
    dispatch(_modalActions["default"].closeModal());
    var userProfileId = payload.userProfileId,
      fileNameOverride = payload.fileNameOverride;
    return _resources["default"].downloadPastCertificatesStudentByType.get({
      userProfileId: userProfileId
    }).withParams(payload).raw().send().then(function (response) {
      if (response.status === 200) {
        onSuccess({
          dispatch: dispatch,
          url: response.verb.url,
          fileNameOverride: fileNameOverride
        });
      }
    });
  };
}
function newCertificatesDownloadStudentByType(payload) {
  return function (dispatch) {
    dispatch(certificatesDownloadRequested());
    dispatch(_modalActions["default"].closeModal());
    var userId = payload.userId,
      type = payload.type,
      fileNameOverride = payload.fileNameOverride,
      certificateTypeName = payload.certificateTypeName,
      certificatesCount = payload.certificatesCount,
      className = payload.className,
      gemTypes = payload.gemTypes;
    if (type === _certificateConstants.NEW_TOTAL.type) {
      return _resources["default"].downloadNewCertificatesStudent.get({
        userId: userId
      }).withParams(payload).raw().send().then(function (response) {
        if (response.status === 200) {
          onSuccess({
            dispatch: dispatch,
            url: response.verb.url,
            certificateType: certificateTypeName,
            className: className,
            certificatesCount: certificatesCount,
            fileNameOverride: fileNameOverride
          });
        }
      });
    }
    return _resources["default"].downloadNewCertificatesStudentByType.get({
      userId: userId,
      type: type,
      gemTypes: gemTypes
    }).withParams(payload).raw().send().then(function (response) {
      if (response.status === 200) {
        onSuccess({
          dispatch: dispatch,
          url: response.verb.url,
          fileNameOverride: fileNameOverride,
          certificateType: certificateTypeName,
          certificatesCount: certificatesCount,
          className: className
        });
      }
    });
  };
}
function getGemCountsByType(payload) {
  return function (dispatch) {
    return _resources["default"].getGemCounts.get().withParams(payload).send().then(function (response) {
      if (response.data) {
        dispatch({
          type: GEM_COUNTS_RETRIEVED,
          payload: response.data
        });
      }
    });
  };
}
var _default = exports["default"] = {
  newCertificatesDownload: newCertificatesDownload,
  pastCertificatesDownload: pastCertificatesDownload,
  newCertificatesDownloadByType: newCertificatesDownloadByType,
  pastCertificatesDownloadByType: pastCertificatesDownloadByType,
  pastCertificatesDownloadStudentByType: pastCertificatesDownloadStudentByType,
  newCertificatesDownloadStudentByType: newCertificatesDownloadStudentByType,
  getGemCountsByType: getGemCountsByType
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "PYJo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---Ht_Ji {\n  height: calc(100% - 90px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  overflow: auto; }\n  .component---Ht_Ji .certificates---3g93C {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .component---Ht_Ji > div {\n    margin: 0 8px; }\n  .component---Ht_Ji > div:first-of-type {\n      margin-left: 0; }\n  .component---Ht_Ji > div:last-of-type {\n      margin-right: 0; }\n  .component---Ht_Ji .participation-results-container---301Wu {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex; }\n  .component---Ht_Ji .participation-results---3AQ5- {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 100%;\n            flex: 1 1 100%;\n    max-width: 100%;\n    min-width: 1200px;\n    padding: 0 8px; }\n  .component---Ht_Ji .participation-results---3AQ5- h3 {\n      font-size: 18px;\n      font-weight: normal;\n      margin: 8px; }\n  .component---Ht_Ji .participation-results---3AQ5- h4 {\n      color: #278bcb;\n      font-size: 12px;\n      font-weight: normal;\n      margin: 20px 0 4px; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead,\n    .component---Ht_Ji .participation-results---3AQ5- table tbody {\n      text-align: center; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th,\n      .component---Ht_Ji .participation-results---3AQ5- table thead td,\n      .component---Ht_Ji .participation-results---3AQ5- table tbody th,\n      .component---Ht_Ji .participation-results---3AQ5- table tbody td {\n        padding: 8px; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th svg path,\n        .component---Ht_Ji .participation-results---3AQ5- table thead td svg path,\n        .component---Ht_Ji .participation-results---3AQ5- table tbody th svg path,\n        .component---Ht_Ji .participation-results---3AQ5- table tbody td svg path {\n          fill: #838f9e; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead {\n      height: 77px; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th {\n        vertical-align: unset;\n        font-size: 11px;\n        font-weight: 500;\n        line-height: 20px;\n        border-color: #adb9c7;\n        border-bottom: none;\n        border-top: none; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.col-group-sort-icon---3uscb div {\n          position: relative; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.col-group-sort-icon---3uscb div span:nth-child(2) {\n            position: absolute;\n            top: -48px;\n            right: -5px; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.class-name---3uLP6, .component---Ht_Ji .participation-results---3AQ5- table thead th.group-name---2wka0, .component---Ht_Ji .participation-results---3AQ5- table thead th.student-name---2hA8K {\n          text-align: left;\n          width: 30%;\n          padding: 13px 5px 0 12px;\n          background-color: #d4dce2;\n          color: #33475f;\n          font-weight: 600;\n          border-right-color: #adb9c7; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.year-group---2JMMM, .component---Ht_Ji .participation-results---3AQ5- table thead th.total-points---ApJXk {\n          background-color: #d4dce2;\n          color: #33475f;\n          width: 12%; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.year-group---2JMMM.small---nlCA8, .component---Ht_Ji .participation-results---3AQ5- table thead th.total-points---ApJXk.small---nlCA8 {\n            text-align: left;\n            width: 4%;\n            padding: 8px 5px; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.total-certificates---1VQrL {\n          width: 17%;\n          color: white;\n          border-color: #cbd3dc; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.total-certificates---1VQrL.new-certificates---1RKuD {\n            background-color: #0063a7;\n            border-right-color: rgba(255, 255, 255, .16); }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.total-certificates---1VQrL.past-certificates---UkfH3 {\n            background-color: #007acc; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.total-certificates---1VQrL.header---2iJGW {\n            border-top: 1px solid;\n            border-color: #adb9c7; }\n  .component---Ht_Ji .participation-results---3AQ5- table thead th.total-certificates---1VQrL.new-expanded---1FP-L {\n            width: 40%;\n            padding: 0; }\n  .component---Ht_Ji .participation-results---3AQ5- table tbody td {\n      border-color: #cbd3dc; }\n  .component---Ht_Ji .participation-results---3AQ5- table tbody .class-name---3uLP6,\n    .component---Ht_Ji .participation-results---3AQ5- table tbody .group-name---2wka0,\n    .component---Ht_Ji .participation-results---3AQ5- table tbody .student-name---2hA8K {\n      text-align: left;\n      border-right-color: #adb9c7; }\n", ""]);

// exports
exports.locals = {
	"component": "component---Ht_Ji",
	"certificates": "certificates---3g93C",
	"participation-results-container": "participation-results-container---301Wu",
	"participation-results": "participation-results---3AQ5-",
	"col-group-sort-icon": "col-group-sort-icon---3uscb",
	"class-name": "class-name---3uLP6",
	"group-name": "group-name---2wka0",
	"student-name": "student-name---2hA8K",
	"year-group": "year-group---2JMMM",
	"total-points": "total-points---ApJXk",
	"small": "small---nlCA8",
	"total-certificates": "total-certificates---1VQrL",
	"new-certificates": "new-certificates---1RKuD",
	"past-certificates": "past-certificates---UkfH3",
	"header": "header---2iJGW",
	"new-expanded": "new-expanded---1FP-L"
};

/***/ }),

/***/ "QHOw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TX9B");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./live-maths-level-picker.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./live-maths-level-picker.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "QHRj":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Cz3N");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./live-maths.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./live-maths.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Qaas":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uiHelper = _interopRequireDefault(__webpack_require__("Vhb/"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for converting activity mastery report data from redux store into
 * format needed for export endpoints
 */
var ActivityMasteryDataConverter = exports["default"] = /*#__PURE__*/function () {
  function ActivityMasteryDataConverter() {
    _classCallCheck(this, ActivityMasteryDataConverter);
  }
  return _createClass(ActivityMasteryDataConverter, null, [{
    key: "convertAllClasses",
    value: function convertAllClasses(data, selectedDate, reportTitle, isAllYears) {
      var allClassesActivityMastery = data.allClassesActivityMastery,
        classroomActivityMasterys = data.classroomActivityMasterys,
        courseStrengths = data.courseStrengths,
        courseWeaknesses = data.courseWeaknesses;
      var goldBars = allClassesActivityMastery.goldBars,
        scoreBand = allClassesActivityMastery.scoreBand,
        totalActivities = allClassesActivityMastery.totalActivities;
      var mastered = scoreBand.mastered,
        consolidating = scoreBand.consolidating,
        developing = scoreBand.developing,
        emerging = scoreBand.emerging,
        needsImproving = scoreBand.needsImproving;
      var i18n = window.i18n;
      return {
        dateRange: _uiHelper["default"].formatDateRange(selectedDate),
        activityMasteryTableHeader: isAllYears ? i18n._('Export - All years') : i18n._('Export - All classes'),
        reportLevelHeader: reportTitle,
        courseInsightsTableHeader: isAllYears ? i18n._('Label - Year') : i18n._('Label - Class'),
        classroomsActivityMasteryData: {
          allClassroomActivityMasterys: {
            allGoldbars: goldBars,
            allMasteredScores: mastered,
            allConsolidatingScores: consolidating,
            allDevelopingScores: developing,
            allEmergingScores: emerging,
            allNeedsImprovingScores: needsImproving,
            allTotalActivities: totalActivities,
            classroomActivityMasterys: classroomActivityMasterys
          },
          courseStrengths: this.mapStrengthWeakness(courseStrengths),
          courseWeaknesses: this.mapStrengthWeakness(courseWeaknesses)
        }
      };
    }
  }, {
    key: "convertSingleClass",
    value: function convertSingleClass(data, selectedDate, groupId) {
      var _this = this;
      var groupActivityMastery = _toConsumableArray(data.activityMastery.groupActivityMastery);
      if (groupId) {
        groupActivityMastery = groupActivityMastery.filter(function (group) {
          return group.id === groupId;
        });
      }
      groupActivityMastery = groupActivityMastery.map(function (group) {
        return _objectSpread({
          id: group.id,
          name: group.name,
          courseName: group.courseName,
          totalActivities: group.totalActivities,
          students: group.students
        }, _this.getTopicActivityStrengthWeakness(group));
      }, this);
      return {
        dateRange: _uiHelper["default"].formatDateRange(selectedDate),
        selectedGroupId: groupId || 0,
        classroomActivityMasteryData: _objectSpread({
          name: data.name,
          teachers: [{
            teacherName: data.teacherName
          }],
          totalGoldBars: data.activityMastery.goldBars,
          totalActivities: data.activityMastery.totalActivities,
          classScoreBand: data.activityMastery.scoreBand,
          groupActivityMastery: groupActivityMastery
        }, this.getTopicActivityStrengthWeakness(data))
      };
    }
  }, {
    key: "convertStudent",
    value: function convertStudent(data, selectedDate, student) {
      var topicActivityResults = data.topicActivityResults.map(function (topic) {
        return _objectSpread(_objectSpread({}, topic), {}, {
          activityResultDetails: topic.activityResultDetails.map(function (activity) {
            return _objectSpread(_objectSpread({}, activity), {}, {
              result: activity.result === -1 ? 0 : activity.result
            });
          })
        });
      }, this);
      return {
        dateRange: _uiHelper["default"].formatDateRange(selectedDate),
        studentActivityMasteryData: _objectSpread({
          className: data.className,
          courseInfo: data.courseInfo,
          topicActivityResults: topicActivityResults,
          userProfileId: student.id,
          firstName: student.name,
          lastName: ''
        }, this.getTopicActivityStrengthWeakness(data))
      };
    }
  }, {
    key: "getTopicActivityStrengthWeakness",
    value: function getTopicActivityStrengthWeakness(data) {
      return {
        topicStrengths: this.mapStrengthWeakness(data.strengths.topics),
        topicWeaknesses: this.mapStrengthWeakness(data.weaknesses.topics),
        activityStrengths: this.mapStrengthWeakness(data.strengths.activities),
        activityWeaknesses: this.mapStrengthWeakness(data.weaknesses.activities)
      };
    }
  }, {
    key: "mapStrengthWeakness",
    value: function mapStrengthWeakness(data) {
      if (data.length === 1 && data[0].title === '-') {
        return [];
      }
      return data;
    }
  }]);
}();

/***/ }),

/***/ "Qf7c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("KtCJ");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./skill-quests-mastery.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./skill-quests-mastery.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Qy98":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/e6f704237fad58d55a84c0ef7b05876c.svg";

/***/ }),

/***/ "R+dW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".popup-menu---TeFnJ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 255px;\n  right: 30px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 240px;\n  border-radius: 16px;\n  -webkit-box-shadow: 0 10px 10px -5px rgba(0, 0, 0, .04), 0 20px 25px -5px rgba(0, 0, 0, .1);\n          box-shadow: 0 10px 10px -5px rgba(0, 0, 0, .04), 0 20px 25px -5px rgba(0, 0, 0, .1);\n  border: 1px solid #edf1f4;\n  z-index: 1; }\n  .popup-menu---TeFnJ .popup-menu-item---WwvNF {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    color: #001937;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    padding: 20px 32px;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    border: none;\n    background: #fff; }\n  .popup-menu---TeFnJ .popup-menu-item---WwvNF:first-child {\n      border-bottom: 1px solid #dbe0e6;\n      border-radius: 16px 16px 0 0; }\n  .popup-menu---TeFnJ .popup-menu-item---WwvNF:last-child {\n      border-radius: 0 0 16px 16px; }\n  .popup-menu---TeFnJ .popup-menu-item---WwvNF:hover {\n      color: #007acc;\n      background-color: #f8fbfc;\n      cursor: pointer; }\n  .popup-menu---TeFnJ .popup-menu-item---WwvNF .icon---2tJzJ > svg {\n      display: block;\n      margin-right: 10px;\n      width: 20px;\n      height: 20px; }\n", ""]);

// exports
exports.locals = {
	"popup-menu": "popup-menu---TeFnJ",
	"popup-menu-item": "popup-menu-item---WwvNF",
	"icon": "icon---2tJzJ"
};

/***/ }),

/***/ "RT+T":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("CPa0");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./activity-percentage-bar.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./activity-percentage-bar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Rv4c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TeacherDropdown = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _dropdownHelpers = __webpack_require__("KmGe");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TeacherDropdown = exports.TeacherDropdown = /*#__PURE__*/function (_PureComponent) {
  function TeacherDropdown() {
    _classCallCheck(this, TeacherDropdown);
    return _callSuper(this, TeacherDropdown, arguments);
  }
  _inherits(TeacherDropdown, _PureComponent);
  return _createClass(TeacherDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        teacherDropdownData = _this$props.teacherDropdownData,
        className = _this$props.className,
        setSelectedTeacher = _this$props.setSelectedTeacher,
        applyFilters = _this$props.applyFilters;
      var data = teacherDropdownData.data,
        selectedOption = teacherDropdownData.selectedOption,
        disabled = teacherDropdownData.disabled;
      var i18n = window.i18n;
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
        className: className,
        options: (0, _dropdownHelpers.getTranslatedOptions)(data, _filterConstants.ALL_TEACHERS, i18n),
        selectedOption: (0, _dropdownHelpers.getTranslateSelectedOption)(selectedOption, _filterConstants.ALL_TEACHERS, i18n),
        onSelectOption: function onSelectOption(e) {
          setSelectedTeacher(e);
          applyFilters();
        },
        disabled: disabled
      });
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(TeacherDropdown, "propTypes", {
  teacherDropdownData: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_filterPropTypes.dropdownItemPropType),
    selectedOption: _filterPropTypes.dropdownItemPropType,
    disabled: _propTypes["default"].bool
  }),
  className: _propTypes["default"].string,
  setSelectedTeacher: _propTypes["default"].func,
  applyFilters: _propTypes["default"].func.isRequired
});
function mapStateToProps(state) {
  return {
    teacherDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.TEACHER_LIST)(state)
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setSelectedTeacher: _dropdownDataActions["default"].setSelectedTeacher
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TeacherDropdown);

/***/ }),

/***/ "RzCX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GaDw");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./modal-container.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./modal-container.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "S5uW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _allClassesActions = __webpack_require__("FDbR");
var initialState = null;

/**
 * Participation - All Classes Reducer
 *
 * Consumes PARTICIPATION_ALL_CLASSES_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _allClassesActions.PARTICIPATION_ALL_CLASSES_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "S6Bi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _activityMasteryLegends = _interopRequireDefault(__webpack_require__("ygMb"));
var _activityMasteryKeyLegends = _interopRequireDefault(__webpack_require__("kZjJ"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ActivityMasteryLegends = function ActivityMasteryLegends() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _activityMasteryLegends["default"]['report-container']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _activityMasteryLegends["default"].legends
  }, /*#__PURE__*/_react["default"].createElement(_activityMasteryKeyLegends["default"], null)));
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_activityMasteryLegends["default"])(ActivityMasteryLegends);

/***/ }),

/***/ "SRTg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.YEAR_GROUPS_RETRIEVED = void 0;
var _constants = __webpack_require__("1QGX");
var _localeHelpers = __webpack_require__("rjLd");
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var YEAR_GROUPS_RETRIEVED = exports.YEAR_GROUPS_RETRIEVED = 'YEAR_GROUPS_RETRIEVED';
function getYearGroups() {
  var locale = (0, _localeHelpers.localeCode)();
  return function (dispatch) {
    return _resources["default"].yearGroups.get().withParams({
      productId: _constants.MATHLETICS_ID,
      locale: locale
    }).send().then(function (payload) {
      dispatch({
        type: YEAR_GROUPS_RETRIEVED,
        payload: payload.data
      });
      dispatch(_dropdownDataActions["default"].setYearGroups(payload.data));
    });
  };
}
var _default = exports["default"] = {
  getYearGroups: getYearGroups
};

/***/ }),

/***/ "SgkA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactDom = _interopRequireDefault(__webpack_require__("O27J"));
var _reduxThunk = _interopRequireDefault(__webpack_require__("bEzl"));
var _reduxPromise = _interopRequireDefault(__webpack_require__("po9w"));
var _querystring = _interopRequireDefault(__webpack_require__("1nuA"));
var _redux = __webpack_require__("2KeS");
var _localeHelpers = __webpack_require__("rjLd");
var _utils = __webpack_require__("6QRH");
var _combinedReducers = _interopRequireDefault(__webpack_require__("Gylf"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _urlHelper = _interopRequireDefault(__webpack_require__("uOny"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* global window document */ /* eslint-disable no-console */
var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk["default"], _reduxPromise["default"])(_redux.createStore);
var BasicApp = exports["default"] = /*#__PURE__*/function () {
  function BasicApp(element, dynamicOptions) {
    _classCallCheck(this, BasicApp);
    BasicApp.configure();
    this.element = element;
    this.options = (0, _utils.handleDefaults)({}, dynamicOptions);
    this.renderElement();
  }
  return _createClass(BasicApp, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("h1", null, "You should define a render() method for your subclass of BasicApp");
    }

    // Implementation details.  You should not need to change any code past this point.
  }, {
    key: "renderElement",
    value: function renderElement() {
      var _this = this;
      var store = createStoreWithMiddleware(_combinedReducers["default"], window.devToolsExtension ? window.devToolsExtension() : function (f) {
        return f;
      });
      (0, _localeHelpers.getLocallyAcquiredI18N)(function (i18n) {
        _reactDom["default"].render(_this.render(store, i18n), document.querySelector(_this.element));
      });
      _reactDom["default"].render(this.render(store), document.querySelector(this.element));
    }
  }], [{
    key: "configure",
    value: function configure() {
      // How we want to configure things depends on where this app is running,
      // and where the services we want to access live.
      //
      // 1. When running on a developer's machine, using a mock server, we want
      //    to use a hard-coded config from
      //
      //       helpers/local-resource-config.js
      //
      // 2. When running on a developer's machine, but we want to use back-end
      //    services on demo, QA or live, we want to get the configuration from
      //    the configuration of the host app.
      //
      // 3. When running on demo, QA or live, the configuration will be injected
      //    based on the host app's configuration, but can be overridden by query
      //    parameters.
      //
      // We determine which situation we have by looking at the window location
      // URL and the query parameters, and whether there is a pppAppConfig property
      // on the window object.

      var location = window.location;
      var runningOnDeveloperMachine = _urlHelper["default"].isRunningOnDeveloperMachine();
      var queryParams = location.search;
      var query = queryParams.replace('?', '');
      var params = _querystring["default"].parse(query);
      if (runningOnDeveloperMachine) {
        BasicApp.configureForDeveloperMachine(params);
      } else {
        BasicApp.configureForRemoteHost(params);
      }
    }
  }, {
    key: "configureForDeveloperMachine",
    value: function configureForDeveloperMachine(params) {
      var envName = params.env;
      if (!envName) {
        console.log('BasicApp.configureForDeveloperMachine() - you did not provide an "env" query' + ' parameter, so I am assuming you want to talk to live.');
        envName = 'live';
      }
      var credentials = BasicApp.getCredentials(params);
      if (envName === 'local' || BasicApp.weHaveUsableCredentials(credentials)) {
        _resources["default"].initialise(envName, credentials);
      }
    }
  }, {
    key: "configureForRemoteHost",
    value: function configureForRemoteHost(params) {
      // eslint-disable-next-line no-underscore-dangle
      var config = window._env_;
      var envName = config.env || 'live';
      var credentials = BasicApp.getCredentials(params);
      if (!config.BaseName) {
        console.log('BasicApp.configureForRemoteHost() - your pppAppConfig does not' + ' include a BaseName item; we will assume it should be blank.');
        config.BaseName = '';
      }
      if (BasicApp.weHaveUsableCredentials(credentials)) {
        _resources["default"].initialise(envName, credentials);
        _resources["default"].env.setConfiguration(config);
      }
    }
  }, {
    key: "getCredentials",
    value: function getCredentials(params) {
      var credentials = {};
      var items = ['authToken', 'username', 'password'];
      for (var paramName in params) {
        var value = params[paramName];
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (paramName.toLowerCase() === item.toLowerCase()) {
              credentials[item] = value;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return credentials;
    }
  }, {
    key: "weHaveUsableCredentials",
    value: function weHaveUsableCredentials(credentials) {
      var usableCredentials = false;
      if (credentials.authToken) {
        usableCredentials = true;
      } else if (credentials.username && credentials.password) {
        usableCredentials = true;
      }
      if (!usableCredentials) {
        console.error('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' + ' a username/password pair.  After combining data from window.pppAppConfig and the query' + ' parameters, I still do not have what I need. The app will probably not function correctly if' + ' it requires any 3P resources.');
      }
      return usableCredentials;
    }
  }]);
}();

/***/ }),

/***/ "T2Mb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslations = exports.useCertificateDownloadTranslations = void 0;
var _linguiCdn = __webpack_require__("siuH");
var _certificateConstants = __webpack_require__("tQue");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useTranslations = exports.useTranslations = function useTranslations() {
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  return {
    certificates: i18n._("CertificatesModal - Certificates"),
    selectVersion: i18n._("CertificatesModal - SelectVersion"),
    fullColour: i18n._("CertificatesModal - FullColour"),
    printerFriendly: i18n._("CertificatesModal - PrinterFriendly"),
    selectRanksAndVersion: i18n._("CertificatesModal - SelectRankAndVersion")
  };
};
var useCertificateDownloadTranslations = exports.useCertificateDownloadTranslations = function useCertificateDownloadTranslations() {
  var _useLocalisation2 = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation2.i18n;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _certificateConstants.BRONZE.type, i18n._("Download - Certificates - Bronze")), _certificateConstants.SILVER.type, i18n._("Download - Certificates - Silver")), _certificateConstants.GOLD.type, i18n._("Download - Certificates - Gold")), _certificateConstants.PLATINUM.type, i18n._("Download - Certificates - Platinum")), _certificateConstants.EMERALD.type, i18n._("Download - Certificates - Emerald")), _certificateConstants.DIAMOND.type, i18n._("Download - Certificates - Diamond")), _certificateConstants.EPIC.type, i18n._("Download - Certificates - Epic")), _certificateConstants.LEGEND.type, i18n._("Download - Certificates - Legend"));
};

/***/ }),

/***/ "TEzo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SET_STUDENT_CLASSES = void 0;
var SET_STUDENT_CLASSES = exports.SET_STUDENT_CLASSES = 'SET_STUDENT_CLASSES';
function setStudentClasses(students) {
  var studentClasses = {};
  students.forEach(function (student) {
    studentClasses[student.userProfileId] = student.classroomId;
  });
  return {
    type: SET_STUDENT_CLASSES,
    payload: studentClasses
  };
}
var _default = exports["default"] = {
  setStudentClasses: setStudentClasses
};

/***/ }),

/***/ "TT5+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccuracyGraph = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _accuracyGraph = _interopRequireDefault(__webpack_require__("akO4"));
var _accuracyGraph2 = __webpack_require__("jzbV");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AccuracyGraph = exports.AccuracyGraph = function AccuracyGraph(_ref) {
  var averageAccuracies = _ref.averageAccuracies;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _accuracyGraph["default"].barsContainer
  }, (0, _accuracyGraph2.drawHorizontalBarLines)(averageAccuracies), /*#__PURE__*/_react["default"].createElement("div", {
    className: _accuracyGraph["default"].graphContainer
  }, (0, _accuracyGraph2.renderGraph)(averageAccuracies)));
};
AccuracyGraph.propTypes = {
  averageAccuracies: _propTypes["default"].array
};
AccuracyGraph.defaultProps = {
  averageAccuracies: []
};

/***/ }),

/***/ "TWXG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ylJo");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./assignment-result.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./assignment-result.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "TX9B":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---2J0MV {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly; }\n  .component---2J0MV .level---27xXF {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 10%;\n            flex: 1 1 10%;\n    background-color: #fff;\n    border-radius: 0;\n    border: none;\n    border-right: 1px solid #e1e1e1;\n    padding: 8px 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .component---2J0MV .level---27xXF:last-of-type {\n      border-right: none; }\n  .component---2J0MV .level---27xXF:hover {\n      -webkit-transition: background-color 0.2s;\n      transition: background-color 0.2s;\n      background-color: #eef2f5;\n      -webkit-filter: none;\n              filter: none; }\n  .component---2J0MV .level---27xXF.active---pf7Qa, .component---2J0MV .level---27xXF.active---pf7Qa:hover {\n      -webkit-transition: none;\n      transition: none;\n      background-color: #1981c4;\n      color: #fff; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2J0MV",
	"level": "level---27xXF",
	"active": "active---pf7Qa"
};

/***/ }),

/***/ "Ticr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".container---POahp {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0; }\n  .container---POahp .toast---2yvXl {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    position: absolute;\n    width: 700px;\n    top: 50px;\n    height: 64px;\n    border-radius: 12px;\n    border: 2px solid white;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-animation-name: toastAnimation---1dmeH;\n            animation-name: toastAnimation---1dmeH;\n    -webkit-animation-duration: 0.7s;\n            animation-duration: 0.7s; }\n  .container---POahp .toast---2yvXl .message---3YPQ8 {\n      margin: 0 32px 0 12px;\n      font-size: 18px;\n      font-weight: 400;\n      line-height: 140%;\n      color: #430006; }\n  .container---POahp .toast---2yvXl .close---3wv78 {\n      cursor: pointer; }\n  .container---POahp .success---oZWHC {\n    background-color: #37c97c; }\n  .container---POahp .error---20zNv {\n    background-color: #f0939b; }\n  @-webkit-keyframes toastAnimation---1dmeH {\n  from {\n    top: -100px; }\n  to {\n    top: 50px; } }\n  @keyframes toastAnimation---1dmeH {\n  from {\n    top: -100px; }\n  to {\n    top: 50px; } }\n", ""]);

// exports
exports.locals = {
	"container": "container---POahp",
	"toast": "toast---2yvXl",
	"toastAnimation": "toastAnimation---1dmeH",
	"message": "message---3YPQ8",
	"close": "close---3wv78",
	"success": "success---oZWHC",
	"error": "error---20zNv"
};

/***/ }),

/***/ "Tiy6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _localeHelpers = __webpack_require__("rjLd");
var _subHeadingButtons = _interopRequireDefault(__webpack_require__("aadW"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * SUB HEADING BUTTONS
 * UX required for Skill Quests Mastery requires right hand export & download buttons
 * at level lower. Abstract and use in both places.
 * @param isDownloadEnabled: Show Bulk classroom reports button
 * @param isExportEnabled: Show Export button
 * @param isProcessingDownload: Show loading state for download button
 * @param onDownloadReport: Download button click handler
 * @param onExportReportL Export button click handler
 */
var SubHeadingButtons = function SubHeadingButtons(_ref) {
  var isDownloadEnabled = _ref.isDownloadEnabled,
    isExportEnabled = _ref.isExportEnabled,
    isProcessingDownload = _ref.isProcessingDownload,
    onDownloadReport = _ref.onDownloadReport,
    onExportReport = _ref.onExportReport,
    forwardedRef = _ref.forwardedRef;
  var text = {
    downloadPrepare: (0, _localeHelpers.translate)('Sub Heading Buttons - Prepare Download'),
    bulkExport: (0, _localeHelpers.translate)('Sub Heading Buttons - Bulk Export'),
    exportButton: (0, _localeHelpers.translate)('Sub Heading Buttons - Export Button')
  };
  var getDownloadButtonText = function getDownloadButtonText() {
    return isProcessingDownload ? text.downloadPrepare : text.bulkExport;
  };
  var renderButton = function renderButton(buttonText, clickHandler, isDisabled, className) {
    return /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
      text: buttonText,
      primary: true,
      type: _reactComponents.Button.LOZENGE,
      onClick: clickHandler,
      disabled: isDisabled,
      className: className
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _subHeadingButtons["default"]['sub-heading-buttons-container'],
    ref: forwardedRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _subHeadingButtons["default"]['sub-heading-btn']
  }, isDownloadEnabled && renderButton(getDownloadButtonText(), onDownloadReport, isProcessingDownload, _subHeadingButtons["default"]['download-btn'])), /*#__PURE__*/_react["default"].createElement("div", {
    className: _subHeadingButtons["default"]['sub-heading-btn']
  }, isExportEnabled && renderButton(text.exportButton, onExportReport, false, _subHeadingButtons["default"]['export-btn'])));
};
SubHeadingButtons.propTypes = {
  isDownloadEnabled: _propTypes["default"].bool,
  isProcessingDownload: _propTypes["default"].bool,
  isExportEnabled: _propTypes["default"].bool,
  onDownloadReport: _propTypes["default"].func,
  onExportReport: _propTypes["default"].func,
  forwardedRef: _propTypes["default"].any
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_subHeadingButtons["default"])(SubHeadingButtons);

/***/ }),

/***/ "Tj2k":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "/* React Core CSS */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: inherit; }\nb,\nstrong {\n  font-weight: bolder; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background-color: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\nbutton:-moz-focusring,\ninput:-moz-focusring {\n  outline: 1px dotted ButtonText; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block; }\nol,\nul {\n  list-style: none; }\nblockquote,\nq {\n  quotes: none; }\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: '';\n  content: none; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\nbody {\n  font-family: poppins, Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.42857143;\n  color: #484848;\n  background-color: #eef2f5;\n  margin: 0;\n  padding: 0;\n  overflow: hidden; }\nbutton:focus,\n[role=\"button\"]:focus {\n  outline: 0; }\n.text-center {\n  text-align: center; }\nh1 {\n  font-size: 30px;\n  font-weight: 500; }\n.DateRangePicker_picker__directionRight {\n  z-index: 50; }\n.DayPicker_weekHeaders__horizontal {\n  z-index: 52; }\n/*\n// Enable use bootstrap\n// npm install bootstrap-sass --save\n$icon-font-path: '~bootstrap-sass/assets/fonts/bootstrap/';\n@import '~bootstrap-sass/assets/stylesheets/bootstrap';\n@import '~bootstrap-sass/assets/stylesheets/bootstrap/theme';\n*/\n/*\n// Enable use fontawesome\n// npm install font-awesome-sass --save\n$fa-font-path: \"~font-awesome-sass/assets/fonts/font-awesome/\";\n@import \"~font-awesome-sass/assets/stylesheets/font-awesome\";\n*/\n", ""]);

// exports


/***/ }),

/***/ "Tpjw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _downloadButton = _interopRequireDefault(__webpack_require__("zJFk"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DownloadButton = function DownloadButton(_ref) {
  var onClick = _ref.onClick,
    title = _ref.title,
    icon = _ref.icon,
    disabled = _ref.disabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _downloadButton["default"].button,
    onClick: onClick,
    tabIndex: 0,
    role: "button",
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    className: _downloadButton["default"].icon,
    src: icon,
    cacheGetRequests: true
  }), ' ', /*#__PURE__*/_react["default"].createElement("span", null, title));
};
DownloadButton.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  title: _propTypes["default"].string.isRequired,
  icon: _propTypes["default"].string,
  disabled: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_downloadButton["default"])(DownloadButton);

/***/ }),

/***/ "U2Uw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AllClasses = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _allClassesActions = _interopRequireWildcard(__webpack_require__("OZAO"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _allClasses = _interopRequireDefault(__webpack_require__("vIzN"));
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _allClassesConstants = __webpack_require__("hb1i");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _allClassesPropTypes = __webpack_require__("Ey8b");
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _routeHelper = _interopRequireDefault(__webpack_require__("H7F4"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays live maths results for all classes
 */
var AllClasses = exports.AllClasses = /*#__PURE__*/function (_Component) {
  function AllClasses(_props) {
    var _this;
    _classCallCheck(this, AllClasses);
    _this = _callSuper(this, AllClasses, [_props]);
    _defineProperty(_this, "getAllClassesLiveMathsData", function (props) {
      var getLiveMathsData = props.getLiveMathsData,
        activeFilters = props.activeFilters;
      _this.setRouteType(props);
      getLiveMathsData(activeFilters[_filterConstants.SELECTED_DATE], activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id, activeFilters[_filterConstants.SELECTED_TEACHER].id);
    });
    _defineProperty(_this, "setTableConfig", function () {
      var liveMathsTableConfig;
      if (_this.isAllYearsRoute) {
        liveMathsTableConfig = (0, _cloneDeep["default"])(_allClassesConstants.ALL_YEARS_TABLE_CONFIG);
      } else {
        liveMathsTableConfig = (0, _cloneDeep["default"])(_allClassesConstants.ALL_CLASSES_TABLE_CONFIG);
      }
      var filterKey = _this.isAllYearsRoute ? _allClassesConstants.CLASS_ID : _allClassesConstants.CLASS_NAME;
      liveMathsTableConfig.nestedData.cols.find(function (col) {
        return col.id === filterKey;
      }).onClick = _this.loadClassPage;
      var translateTransform = true;
      liveMathsTableConfig = (0, _localeHelpers.translateTableLabels)(liveMathsTableConfig, translateTransform);
      _this.setState({
        liveMathsTableConfig: liveMathsTableConfig
      });
    });
    _defineProperty(_this, "loadClassPage", function (selectedClass) {
      var itemType = _this.isAllYearsRoute ? _filterConstants.SELECTED_YEAR_GROUP : _filterConstants.SELECTED_CLASS;
      _this.props.updateActiveFilter(itemType, {
        id: selectedClass.id,
        name: selectedClass.name
      });
    });
    var _liveMathsTableConfig = (0, _cloneDeep["default"])(_allClassesConstants.ALL_CLASSES_TABLE_CONFIG);
    _this.isLandingPage = true;
    _this.isAllYearsRoute = false;
    _this.state = {
      liveMathsTableConfig: _liveMathsTableConfig,
      liveMathsLevelData: null
    };
    _this.setRouteType(_props, true);
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(AllClasses, _Component);
  return _createClass(AllClasses, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        liveMathsData = _this$props.liveMathsData,
        liveMathsLevel = _this$props.liveMathsLevel,
        activeFilters = _this$props.activeFilters;
      if (_filterHelper["default"].shouldLoadAllClasses(activeFilters)) {
        this.getAllClassesLiveMathsData(this.props);
        this.setLiveMathsData(liveMathsData, liveMathsLevel);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props2 = this.props,
        activeFilters = _this$props2.activeFilters,
        isAdmin = _this$props2.isAdmin,
        invalidRequest = _this$props2.invalidRequest,
        updateActiveFilter = _this$props2.updateActiveFilter,
        liveMathsData = _this$props2.liveMathsData,
        liveMathsLevel = _this$props2.liveMathsLevel;
      var newActiveFilters = newProps.activeFilters,
        newIsAdmin = newProps.isAdmin,
        newInvalidRequest = newProps.invalidRequest,
        newLiveMathsData = newProps.liveMathsData,
        newLiveMathsLevel = newProps.liveMathsLevel;
      if (_filterHelper["default"].shouldReloadAllClasses(activeFilters, newActiveFilters)) {
        this.getAllClassesLiveMathsData(newProps);
      }
      if (liveMathsData !== newLiveMathsData || liveMathsLevel !== newLiveMathsLevel) {
        this.setLiveMathsData(newLiveMathsData, newLiveMathsLevel);
      }
      if (activeFilters !== newActiveFilters || isAdmin !== newIsAdmin) {
        this.setRouteType(newProps);
      }
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _allClassesActions.LIVE_MATHS_ALL_CLASSES_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "setLiveMathsData",
    value: function setLiveMathsData(allLevelsLiveMathsData, liveMathsLevel) {
      if (allLevelsLiveMathsData) {
        this.setState({
          liveMathsLevelData: [allLevelsLiveMathsData[liveMathsLevel - 1]]
        });
      }
    }
  }, {
    key: "setRouteType",
    value: function setRouteType(props, firstLoad) {
      var isAdmin = props.isAdmin,
        activeFilters = props.activeFilters;
      this.isLandingPage = _routeHelper["default"].isLandingPage(isAdmin, activeFilters);
      this.isAllYearsRoute = _routeHelper["default"].isAllYearsRoute(isAdmin, activeFilters);
      if (!firstLoad) {
        this.setTableConfig();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        liveMathsTableConfig = _this$state.liveMathsTableConfig,
        liveMathsLevelData = _this$state.liveMathsLevelData;
      var i18n = window.i18n;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClasses["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClasses["default"]['live-maths-results']
      }, this.isLandingPage ? /*#__PURE__*/_react["default"].createElement("h3", null, i18n._('Table Header - Live Mathletics')) : /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: i18n._('Table Header - Live Mathletics')
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        data: liveMathsLevelData,
        config: liveMathsTableConfig
      })));
    }
  }]);
}(_react.Component);
_defineProperty(AllClasses, "propTypes", {
  liveMathsData: _propTypes["default"].arrayOf(_allClassesPropTypes.liveMathsLevelPropType),
  activeFilters: _filterPropTypes.activeFiltersPropType,
  isAdmin: _propTypes["default"].bool,
  updateActiveFilter: _propTypes["default"].func,
  invalidRequest: _propTypes["default"].string,
  liveMathsLevel: _propTypes["default"].number,
  getLiveMathsData: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    liveMathsData: state.liveMathsAllClasses,
    invalidRequest: state.invalidRequest,
    liveMathsLevel: state.liveMathsLevel,
    isAdmin: state.isAdmin
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getLiveMathsData: _allClassesActions["default"].getLiveMathsData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AllClasses);

/***/ }),

/***/ "U87u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AllClasses = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _allClassess = _interopRequireDefault(__webpack_require__("1dJ6"));
var _filterConstants = __webpack_require__("cdWI");
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _allClassesConstants = _interopRequireDefault(__webpack_require__("3VuW"));
var _skillQuestsMasteryHelpers = __webpack_require__("sO+K");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _filterPropTypes = __webpack_require__("1g86");
var _allClassesActions = _interopRequireWildcard(__webpack_require__("54Df"));
var _exportReportActions = _interopRequireDefault(__webpack_require__("oXgP"));
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _skillQuestsMasteryLegends = _interopRequireDefault(__webpack_require__("n/+0"));
var _subHeadingButtons = _interopRequireDefault(__webpack_require__("Tiy6"));
var _assignmentResult = _interopRequireDefault(__webpack_require__("kQOT"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Skill Quests Mastery All Classes
 * Displays class level report
 */
var AllClasses = exports.AllClasses = /*#__PURE__*/function (_Component) {
  function AllClasses(_props) {
    var _this;
    _classCallCheck(this, AllClasses);
    _this = _callSuper(this, AllClasses, [_props]);
    /**
     * ON PROPS CHANGE HANDLERS
     */
    _defineProperty(_this, "onDataChange", function (props, newProps) {
      var skillQuestsMasteryData = props.skillQuestsMasteryData;
      var newSkillQuestsMasteryData = newProps.skillQuestsMasteryData;
      if (skillQuestsMasteryData !== newSkillQuestsMasteryData) {
        _this.setTableConfig(newProps);
      }
    });
    _defineProperty(_this, "onParamChange", function (props, newProps) {
      var activeFilters = props.activeFilters,
        assignmentResultType = props.assignmentResultType;
      var newActiveFilters = newProps.activeFilters,
        newAssignmentResultType = newProps.assignmentResultType;
      var shouldReload = _filterHelper["default"].shouldReloadAllClasses(activeFilters, newActiveFilters) || assignmentResultType !== newAssignmentResultType;
      if (shouldReload) {
        _this.getAllClassesSkillQuestsMasteryData(newProps);
      }
    });
    _defineProperty(_this, "getAllClassesSkillQuestsMasteryData", function (props) {
      var activeFilters = props.activeFilters,
        getSkillQuestsMasteryData = props.getSkillQuestsMasteryData,
        assignmentResultType = props.assignmentResultType;
      getSkillQuestsMasteryData(activeFilters[_filterConstants.SELECTED_DATE], activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id, activeFilters[_filterConstants.SELECTED_TEACHER].id, assignmentResultType);
    });
    /**
     * SETUP TABLE CONFIG
     */
    _defineProperty(_this, "navigateToGroupLevel", function (selectedItem) {
      _this.props.updateActiveFilter(_filterConstants.SELECTED_CLASS, {
        id: selectedItem.classId,
        name: selectedItem.className
      });
    });
    _defineProperty(_this, "tableConfigTranslations", function (updatedTableConfig) {
      var i18n = window.i18n;
      updatedTableConfig.cols.find(function (col) {
        return col.id === _skillQuestsMasteryConstants.CLASS_NAME.id;
      }).name = (0, _skillQuestsMasteryHelpers.manageTranslation)(_skillQuestsMasteryConstants.CLASS_NAME, i18n);
      (0, _skillQuestsMasteryHelpers.translateTableContent)(i18n, updatedTableConfig);
      return updatedTableConfig;
    });
    _defineProperty(_this, "setTableConfig", function (props) {
      var skillQuestsMasteryData = props.skillQuestsMasteryData;
      var i18n = window.i18n;
      var updatedTableConfig = (0, _cloneDeep["default"])(_allClassesConstants["default"]);
      if (skillQuestsMasteryData) {
        updatedTableConfig = (0, _skillQuestsMasteryHelpers.alignTableConfigHeader)(skillQuestsMasteryData, updatedTableConfig);
        updatedTableConfig = (0, _skillQuestsMasteryHelpers.alignAllClassesTableConfigBody)(updatedTableConfig, i18n);
        updatedTableConfig.cols.find(function (col) {
          return col.id === _skillQuestsMasteryConstants.CLASS_NAME.id;
        }).onClick = _this.navigateToGroupLevel;
        updatedTableConfig = _this.tableConfigTranslations(updatedTableConfig);
      }
      _this.setState({
        tableConfig: updatedTableConfig
      });
    });
    /**
     * SUB HEADING BUTTONS HANDLERS
     */
    _defineProperty(_this, "getIsDownloadEnabled", function () {
      var classFilter = _this.props.classFilter;
      var classFilterName = classFilter.name;
      return classFilterName !== '' && classFilterName !== _filterConstants.ALL_CLASSES;
    });
    _this.state = {
      tableConfig: _allClassesConstants["default"]
    };
    return _this;
  }
  _inherits(AllClasses, _Component);
  return _createClass(AllClasses, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeFilters = this.props.activeFilters;
      if (_filterHelper["default"].shouldLoadAllClasses(activeFilters)) {
        this.getAllClassesSkillQuestsMasteryData(this.props);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this.onParamChange(this.props, newProps);
      this.onDataChange(this.props, newProps);
      (0, _skillQuestsMasteryHelpers.onInvalidRequest)(this.props, newProps, _allClassesActions.SKILL_QUESTS_MASTERY_ALL_CLASSES_RETRIEVED);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        downloadStudentReport = _this$props.downloadStudentReport,
        exportReport = _this$props.exportReport,
        isProcessingDownload = _this$props.isProcessingDownload,
        skillQuestsMasteryData = _this$props.skillQuestsMasteryData;
      var tableConfig = this.state.tableConfig;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClassess["default"]['sqm-all-classes']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClassess["default"]['sub-heading']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClassess["default"]['right-side']
      }, /*#__PURE__*/_react["default"].createElement(_skillQuestsMasteryLegends["default"], {
        variant: _skillQuestsMasteryConstants.SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS.CLASS_GROUP_LEVEL
      }), /*#__PURE__*/_react["default"].createElement(_assignmentResult["default"], null), /*#__PURE__*/_react["default"].createElement(_subHeadingButtons["default"], {
        isDownloadEnabled: this.getIsDownloadEnabled(),
        isExportEnabled: true,
        isProcessingDownload: isProcessingDownload,
        onExportReport: exportReport,
        onDownloadReport: downloadStudentReport
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _allClassess["default"]['data-table']
      }, skillQuestsMasteryData && /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: tableConfig,
        data: skillQuestsMasteryData.classes
      })));
    }
  }]);
}(_react.Component);
_defineProperty(AllClasses, "propTypes", {
  // redux filter values
  activeFilters: _filterPropTypes.activeFiltersPropType,
  // Values for class filter
  classFilter: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  // Download report handler
  downloadStudentReport: _propTypes["default"].func,
  // Export report handler
  exportReport: _propTypes["default"].func,
  // Is requesting download report
  isProcessingDownload: _propTypes["default"].bool,
  // Manages active filter redux values
  updateActiveFilter: _propTypes["default"].func,
  // BE Data for skill quests mastery all classes
  skillQuestsMasteryData: _propTypes["default"].object,
  assignmentResultType: _propTypes["default"].number,
  getSkillQuestsMasteryData: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    classFilter: _activeFiltersSelectors["default"].selectFilter(_filterConstants.SELECTED_CLASS),
    invalidRequest: state.invalidRequest,
    isProcessingDownload: state.downloadReport.isProcessingDownload,
    skillQuestsMasteryData: state.skillQuestsMasteryAllClasses.data,
    assignmentResultType: state.assignmentResultType
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    downloadStudentReport: _exportReportActions["default"].downloadStudentReport,
    exportReport: _exportReportActions["default"].exportReport,
    getSkillQuestsMasteryData: _allClassesActions["default"].getSkillQuestsMasteryData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_allClassess["default"])(AllClasses));

/***/ }),

/***/ "ULxP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _certificates = _interopRequireDefault(__webpack_require__("rrgl"));
var _urlHelper = _interopRequireDefault(__webpack_require__("uOny"));
var _constants = __webpack_require__("1QGX");
var _certificatesConfig = __webpack_require__("K6Yf");
var _useTranslations2 = __webpack_require__("HJbm");
var _student = _interopRequireDefault(__webpack_require__("95d/"));
var _filterConstants = __webpack_require__("cdWI");
var _participationConstants = __webpack_require__("lWQf");
var _utils = __webpack_require__("v/Rl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StudentCertificates = function StudentCertificates(_ref) {
  var participationData = _ref.participationData,
    selectedClassroomId = _ref.selectedClassroomId,
    selectedGroupId = _ref.selectedGroupId,
    selectedStudentId = _ref.selectedStudentId,
    newCertificatesDownloadStudentByType = _ref.newCertificatesDownloadStudentByType,
    pastCertificatesDownloadByType = _ref.pastCertificatesDownloadByType,
    selectedYearGroupId = _ref.selectedYearGroupId,
    selectedTeacherId = _ref.selectedTeacherId;
  var _useCertificatesConfi = (0, _certificatesConfig.useCertificatesConfig)(),
    newCertificatesConfig = _useCertificatesConfi.newCertificatesConfig,
    pastCertificatesConfig = _useCertificatesConfi.pastCertificatesConfig;
  var _useTranslations = (0, _useTranslations2.useTranslations)(),
    certificates = _useTranslations.certificates,
    oldCertificates = _useTranslations.oldCertificates;
  var certificateProps = _objectSpread(_objectSpread({
    classroomId: selectedClassroomId,
    startDate: _urlHelper["default"].getQueryParamValue(_constants.START_DATE) || null,
    endDate: _urlHelper["default"].getQueryParamValue(_constants.END_DATE) || null,
    groupId: selectedGroupId,
    isForDownload: true
  }, selectedYearGroupId !== _filterConstants.ALL_YEARS && {
    yearGroupEnum: selectedYearGroupId
  }), {}, {
    userProfileId: participationData && participationData.userProfileId,
    teacherUserProfileId: selectedTeacherId === _filterConstants.ALL_TEACHERS ? _participationConstants.ALL_TEACHERS_ID : selectedTeacherId
  });
  var getStudentName = function getStudentName() {
    if (participationData) {
      return "".concat(participationData.firstName, "_").concat(participationData.lastName);
    }
    return null;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _student["default"].certificates
  }, /*#__PURE__*/_react["default"].createElement(_certificates["default"], _extends({
    config: newCertificatesConfig,
    heading: certificates,
    certificates: participationData && participationData.newCertificates,
    handleCertificateDownloadClick: function handleCertificateDownloadClick(payload) {
      var certificatesCount = payload.certificatesCount,
        certificateTypeName = payload.certificateTypeName;
      newCertificatesDownloadStudentByType(_objectSpread(_objectSpread({}, payload), {}, {
        userId: selectedStudentId,
        fileNameOverride: (0, _utils.getCertificateFilename)({
          title: getStudentName(),
          certificatesCount: certificatesCount,
          certificateTypeName: certificateTypeName,
          prefixCertificate: false
        })
      }));
    }
  }, certificateProps)), /*#__PURE__*/_react["default"].createElement(_certificates["default"], _extends({
    config: pastCertificatesConfig,
    heading: oldCertificates,
    isOldCertificates: true,
    certificates: participationData && participationData.certificates,
    handleCertificateDownloadClick: function handleCertificateDownloadClick(payload) {
      var certificatesCount = payload.certificatesCount,
        certificateTypeName = payload.certificateTypeName;
      pastCertificatesDownloadByType(_objectSpread(_objectSpread({}, payload), {}, {
        fileNameOverride: (0, _utils.getCertificateFilename)({
          title: getStudentName(),
          certificatesCount: certificatesCount,
          certificateTypeName: certificateTypeName,
          prefixCertificate: false
        })
      }));
    }
  }, certificateProps)));
};
StudentCertificates.propTypes = {
  participationData: _propTypes["default"].object || null,
  selectedClassroomId: _propTypes["default"].number,
  selectedGroupId: _propTypes["default"].number,
  selectedStudentId: _propTypes["default"].number,
  newCertificatesDownloadStudentByType: _propTypes["default"].func,
  pastCertificatesDownloadByType: _propTypes["default"].func,
  selectedYearGroupId: _propTypes["default"].number,
  selectedTeacherId: _propTypes["default"].number
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_student["default"])(StudentCertificates);

/***/ }),

/***/ "UQU2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Student = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _student = _interopRequireDefault(__webpack_require__("iDSV"));
var _studentActions = _interopRequireWildcard(__webpack_require__("AJmA"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _studentConstants = __webpack_require__("98Ep");
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _studentPropTypes = __webpack_require__("Etod");
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays live maths results for an individual student
 */
var Student = exports.Student = /*#__PURE__*/function (_Component) {
  function Student(props) {
    var _this;
    _classCallCheck(this, Student);
    _this = _callSuper(this, Student, [props]);
    _this.i18n = window.i18n;
    _this.state = {
      studentTableConfig: null
    };
    return _this;
  }
  _inherits(Student, _Component);
  return _createClass(Student, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeFilters = this.props.activeFilters;
      if (_filterHelper["default"].shouldLoadStudent(activeFilters)) {
        this.getStudentLiveMathsData(activeFilters[_filterConstants.SELECTED_STUDENT].id, activeFilters[_filterConstants.SELECTED_CLASS].id, activeFilters[_filterConstants.SELECTED_DATE]);
        this.setStudentDataConfig();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props = this.props,
        activeFilters = _this$props.activeFilters,
        invalidRequest = _this$props.invalidRequest,
        updateActiveFilter = _this$props.updateActiveFilter;
      var newActiveFilters = newProps.activeFilters,
        newInvalidRequest = newProps.invalidRequest;

      // user's selection has changed (date or student), need to request data from backend
      if (_filterHelper["default"].shouldReloadStudent(activeFilters, newActiveFilters)) {
        this.getStudentLiveMathsData(newActiveFilters[_filterConstants.SELECTED_STUDENT].id, newActiveFilters[_filterConstants.SELECTED_CLASS].id, newActiveFilters[_filterConstants.SELECTED_DATE]);
      }

      // request to backend failed, attempt to load page using default values
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _studentActions.LIVE_MATHS_STUDENT_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "getStudentLiveMathsData",
    value: function getStudentLiveMathsData(studentId, classId, selectedDateFilter) {
      this.props.getLiveMathsData(studentId, classId, selectedDateFilter);
    }
  }, {
    key: "setStudentDataConfig",
    value: function setStudentDataConfig() {
      var studentTableConfig = (0, _cloneDeep["default"])(_studentConstants.STUDENT_TABLE_CONFIG);
      studentTableConfig = (0, _localeHelpers.translateTableLabels)(studentTableConfig);
      this.setState({
        studentTableConfig: studentTableConfig
      });
    }
  }, {
    key: "render",
    value: function render() {
      var liveMathsData = this.props.liveMathsData;
      var studentTableConfig = this.state.studentTableConfig;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"]['live-maths-results']
      }, /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: 'Label - LiveMathleticsReport',
        translate: true
      }), studentTableConfig && /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: studentTableConfig,
        data: liveMathsData && liveMathsData.liveMathsResults,
        footerData: this.i18n._(_studentConstants.STUDENT_FOOTER_DATA)
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _student["default"].disclaimer
      }, this.i18n._(_studentConstants.STUDENT_DISCLAIMER))));
    }
  }]);
}(_react.Component);
_defineProperty(Student, "propTypes", {
  liveMathsData: _propTypes["default"].shape({
    liveMathsResults: _propTypes["default"].arrayOf(_studentPropTypes.liveMathsResultPropType)
  }),
  activeFilters: _filterPropTypes.activeFiltersPropType,
  getLiveMathsData: _propTypes["default"].func,
  updateActiveFilter: _propTypes["default"].func,
  invalidRequest: _propTypes["default"].string
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    liveMathsData: state.liveMathsStudent,
    invalidRequest: state.invalidRequest
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getLiveMathsData: _studentActions["default"].getLiveMathsData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_student["default"])(Student));

/***/ }),

/***/ "UZ2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _icon_back = _interopRequireDefault(__webpack_require__("0dCu"));
var _linguiCdn = __webpack_require__("siuH");
var _topLevelInfo = _interopRequireDefault(__webpack_require__("vLJg"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * SKILL QUESTS MASTERY TOP LEVEL INFO
 * -----------------------------------------
 * Manages all left hand side functionality of student skill quests
 */
var TopLevelInfo = function TopLevelInfo(_ref) {
  var academicYear = _ref.academicYear,
    activeFilters = _ref.activeFilters,
    getDateLabel = _ref.getDateLabel,
    history = _ref.history,
    isAdmin = _ref.isAdmin;
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var text = {
    headingLabelText: function headingLabelText(name) {
      return i18n._("Top Level Info - {name}", {
        name: name
      });
    }
  };
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    headingLabel = _useState2[0],
    setHeadingLabel = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    dateLabel = _useState4[0],
    setDateLabel = _useState4[1];
  var manageHeadingLabels = function manageHeadingLabels() {
    var headingLabelText = text.headingLabelText;
    var studentName = activeFilters[_filterConstants.SELECTED_STUDENT].name;
    setHeadingLabel(studentName ? headingLabelText(studentName) : '');
    setDateLabel(getDateLabel());
  };
  var manageFilterValueChange = function manageFilterValueChange() {
    if (isAdmin !== null) {
      manageHeadingLabels();
    }
  };
  var onBackNavigation = function onBackNavigation() {
    return history.goBack();
  };
  (0, _react.useEffect)(function () {
    manageFilterValueChange();
  }, [activeFilters, academicYear, isAdmin]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _topLevelInfo["default"]['top-level-info-container']
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
    className: _topLevelInfo["default"]['top-level-info-button'],
    icon: _icon_back["default"],
    onClick: onBackNavigation
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _topLevelInfo["default"]['header-container']
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    title: headingLabel
  }, headingLabel), /*#__PURE__*/_react["default"].createElement("div", {
    className: _topLevelInfo["default"]['date-range']
  }, dateLabel)));
};
TopLevelInfo.propTypes = {
  academicYear: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }),
  activeFilters: _filterPropTypes.activeFiltersPropType,
  getDateLabel: _propTypes["default"].func,
  history: _propTypes["default"].any,
  isAdmin: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_topLevelInfo["default"])(TopLevelInfo);

/***/ }),

/***/ "UaZf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _icon_moveVertical = _interopRequireDefault(__webpack_require__("qn+m"));
var _localeHelpers = __webpack_require__("rjLd");
var _progressDisplay = _interopRequireDefault(__webpack_require__("of6S"));
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _accuracyGraph = __webpack_require__("TT5+");
var _skillQuestsMasteryHelpers = __webpack_require__("sO+K");
var _accuracyOverviewGraph = __webpack_require__("+iOP");
var _useShowAccuracyGraph = __webpack_require__("dDs9");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable indent */
var ProgressDisplay = function ProgressDisplay(_ref) {
  var skillQuestsMasteryStudentData = _ref.skillQuestsMasteryStudentData,
    openModal = _ref.openModal,
    getDateLabel = _ref.getDateLabel;
  var text = {
    standardsInProgressLabel: (0, _localeHelpers.translate)('Progress Display - Standards in progress'),
    standardsCompletedLabel: (0, _localeHelpers.translate)('Progress Display - Standards completed'),
    learningJourneysInProgressLabel: (0, _localeHelpers.translate)('Progress Display - Skill Quests in progress'),
    learningJourneysCompletedLabel: (0, _localeHelpers.translate)('Progress Display - Skill Quests completed'),
    averageAccuracyLabel: (0, _localeHelpers.translate)('Progress Display - Average overview'),
    highestAccuracyLabel: (0, _localeHelpers.translate)('Progress Display - Highest accuracy'),
    lowestAccuracyLabel: (0, _localeHelpers.translate)('Progress Display - Lowest accuracy'),
    accuracyOverviewLabel: (0, _localeHelpers.translate)('Progress Display - Accuracy overview'),
    dashLabel: (0, _localeHelpers.translate)('Progress Display - Dash Label'),
    percentageLabel: function percentageLabel(accuracy) {
      return "".concat(accuracy, "%");
    }
  };
  var getProgressCompletedValue = function getProgressCompletedValue(progressCount, availableCount) {
    var dashLabel = text.dashLabel;
    if (availableCount !== 0) {
      return "".concat(progressCount, "/").concat(availableCount);
    }
    return dashLabel;
  };
  var getAccuracyValue = function getAccuracyValue(accuracy) {
    var percentageLabel = text.percentageLabel,
      dashLabel = text.dashLabel;
    if (accuracy) {
      return percentageLabel(accuracy);
    }
    return dashLabel;
  };
  var getContentBoxValues = function getContentBoxValues() {
    var _skillQuestsMasterySt = skillQuestsMasteryStudentData.reportData,
      learningJourneysInProgressCount = _skillQuestsMasterySt.learningJourneysInProgressCount,
      learningJourneysCompletedCount = _skillQuestsMasterySt.learningJourneysCompletedCount,
      learningJourneysAvailableCount = _skillQuestsMasterySt.learningJourneysAvailableCount,
      standardsInProgressCount = _skillQuestsMasterySt.standardsInProgressCount,
      standardsCompletedCount = _skillQuestsMasterySt.standardsCompletedCount,
      standardsAvailableCount = _skillQuestsMasterySt.standardsAvailableCount,
      averageAccuracy = _skillQuestsMasterySt.averageAccuracy,
      highestAccuracies = _skillQuestsMasterySt.highestAccuracies,
      lowestAccuracies = _skillQuestsMasterySt.lowestAccuracies;
    var highestAccuracyValue = highestAccuracies && highestAccuracies[0].accuracies && highestAccuracies[0].accuracies[0] && highestAccuracies[0].accuracies[0].accuracy;
    var lowestAccuracyValue = lowestAccuracies && lowestAccuracies[0].accuracies && lowestAccuracies[0].accuracies[0] && lowestAccuracies[0].accuracies[0].accuracy;
    return {
      standardsInProgressValue: getProgressCompletedValue(standardsInProgressCount, standardsAvailableCount),
      standardsCompletedValue: getProgressCompletedValue(standardsCompletedCount, standardsAvailableCount),
      learningJourneysInProgressValue: getProgressCompletedValue(learningJourneysInProgressCount, learningJourneysAvailableCount),
      learningJourneysCompletedValue: getProgressCompletedValue(learningJourneysCompletedCount, learningJourneysAvailableCount),
      averageAccuracyValue: getAccuracyValue(averageAccuracy),
      highestAccuracyValue: getAccuracyValue(highestAccuracyValue),
      lowestAccuracyValue: getAccuracyValue(lowestAccuracyValue)
    };
  };
  var getAccuracyGraphContent = function getAccuracyGraphContent() {
    var averageAccuracies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var dashLabel = text.dashLabel;
    if (averageAccuracies.length) {
      return /*#__PURE__*/_react["default"].createElement(_accuracyGraph.AccuracyGraph, {
        averageAccuracies: averageAccuracies
      });
    }
    return /*#__PURE__*/_react["default"].createElement("div", null, dashLabel);
  };
  var getAccuracyModalContent = function getAccuracyModalContent(accuracyArray, title) {
    var reportData = skillQuestsMasteryStudentData.reportData;
    openModal({
      title: null,
      content: /*#__PURE__*/_react["default"].createElement("div", {
        className: _progressDisplay["default"]['accuracy-modal']
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        className: _progressDisplay["default"]['accuracy-modal-header']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _progressDisplay["default"]['header-text']
      }, (0, _skillQuestsMasteryHelpers.getStudentFullname)(reportData)), /*#__PURE__*/_react["default"].createElement("span", {
        className: _progressDisplay["default"]['header-separator']
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _progressDisplay["default"]['header-text']
      }, title)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _progressDisplay["default"]['date-range']
      }, getDateLabel()), /*#__PURE__*/_react["default"].createElement("ul", {
        className: _progressDisplay["default"]['accuracy-list']
      }, accuracyArray.map(function (result) {
        var accuracies = result.accuracies,
          standardTopicName = result.standardTopicName;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _progressDisplay["default"]['accuracy-item-container']
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _progressDisplay["default"].topicName
        }, standardTopicName), accuracies.map(function (_ref2) {
          var accuracy = _ref2.accuracy,
            learningJourneyName = _ref2.learningJourneyName;
          return /*#__PURE__*/_react["default"].createElement("li", {
            className: _progressDisplay["default"]['accuracy-item'],
            key: "".concat(learningJourneyName, "-").concat(accuracy)
          }, /*#__PURE__*/_react["default"].createElement("p", null, learningJourneyName), /*#__PURE__*/_react["default"].createElement("p", null, accuracy, "%"));
        }));
      }))),
      buttons: []
    });
  };
  var getAccuracyGraphModalContent = function getAccuracyGraphModalContent(averageAccuraciesHistory) {
    var reportData = skillQuestsMasteryStudentData.reportData;
    var accuracyOverviewLabel = text.accuracyOverviewLabel;
    openModal({
      title: null,
      content: /*#__PURE__*/_react["default"].createElement("div", {
        className: _progressDisplay["default"]['accuracy-modal']
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        className: _progressDisplay["default"]['accuracy-modal-header']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _progressDisplay["default"]['header-text']
      }, (0, _skillQuestsMasteryHelpers.getStudentFullname)(reportData)), /*#__PURE__*/_react["default"].createElement("span", {
        className: _progressDisplay["default"]['header-separator']
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _progressDisplay["default"]['header-text']
      }, accuracyOverviewLabel)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _progressDisplay["default"]['date-range']
      }, getDateLabel()), /*#__PURE__*/_react["default"].createElement(_accuracyOverviewGraph.AccuracyOverviewGraph, {
        dateRange: getDateLabel(),
        averageAccuracies: averageAccuraciesHistory
      })),
      buttons: []
    });
  };
  var _useIsGraphClickable = (0, _useShowAccuracyGraph.useIsGraphClickable)(skillQuestsMasteryStudentData),
    _useIsGraphClickable2 = _slicedToArray(_useIsGraphClickable, 1),
    showAccuracyOverviewGraph = _useIsGraphClickable2[0];
  var renderBox = function renderBox(label, value) {
    var modalCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (label && value) {
      var boxClassName = "".concat(_progressDisplay["default"].box, " ").concat(modalCallback && _progressDisplay["default"]['box-button']);
      return /*#__PURE__*/_react["default"].createElement("button", {
        className: boxClassName,
        onClick: function onClick() {
          return modalCallback();
        }
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _progressDisplay["default"].label
      }, label), /*#__PURE__*/_react["default"].createElement("div", {
        className: _progressDisplay["default"].value
      }, value), modalCallback && /*#__PURE__*/_react["default"].createElement("div", {
        className: _progressDisplay["default"]['modal-button-container']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        onClick: function onClick() {},
        icon: _icon_moveVertical["default"],
        className: _progressDisplay["default"]['modal-button']
      })));
    }
    return null;
  };
  var renderContentBox = function renderContentBox(leftLabel, leftValue, leftModalCallback, rightLabel, rightValue, rightModalCallback, type) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_progressDisplay["default"]['content-box'], " ").concat(_progressDisplay["default"][type])
    }, renderBox(leftLabel, leftValue, leftModalCallback), renderBox(rightLabel, rightValue, rightModalCallback));
  };
  if (skillQuestsMasteryStudentData && skillQuestsMasteryStudentData.reportData) {
    var _skillQuestsMasterySt2 = skillQuestsMasteryStudentData.reportData,
      highestAccuracies = _skillQuestsMasterySt2.highestAccuracies,
      lowestAccuracies = _skillQuestsMasterySt2.lowestAccuracies,
      averageAccuraciesHistory = _skillQuestsMasterySt2.averageAccuraciesHistory;
    var standardsInProgressLabel = text.standardsInProgressLabel,
      standardsCompletedLabel = text.standardsCompletedLabel,
      learningJourneysInProgressLabel = text.learningJourneysInProgressLabel,
      learningJourneysCompletedLabel = text.learningJourneysCompletedLabel,
      averageAccuracyLabel = text.averageAccuracyLabel,
      highestAccuracyLabel = text.highestAccuracyLabel,
      lowestAccuracyLabel = text.lowestAccuracyLabel,
      accuracyOverviewLabel = text.accuracyOverviewLabel;
    var _getContentBoxValues = getContentBoxValues(),
      standardsInProgressValue = _getContentBoxValues.standardsInProgressValue,
      standardsCompletedValue = _getContentBoxValues.standardsCompletedValue,
      learningJourneysInProgressValue = _getContentBoxValues.learningJourneysInProgressValue,
      learningJourneysCompletedValue = _getContentBoxValues.learningJourneysCompletedValue,
      averageAccuracyValue = _getContentBoxValues.averageAccuracyValue,
      highestAccuracyValue = _getContentBoxValues.highestAccuracyValue,
      lowestAccuracyValue = _getContentBoxValues.lowestAccuracyValue;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _progressDisplay["default"]['sq-standards-count-container']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _progressDisplay["default"]['sq-standards-count-wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _progressDisplay["default"]['content-box-container']
    }, renderContentBox(standardsInProgressLabel, standardsInProgressValue, null, standardsCompletedLabel, standardsCompletedValue, null, _skillQuestsMasteryConstants.SQ_STANDARDS_COUNT_BOX_TYPES.STANDARDS), renderContentBox(learningJourneysInProgressLabel, learningJourneysInProgressValue, null, learningJourneysCompletedLabel, learningJourneysCompletedValue, null, _skillQuestsMasteryConstants.SQ_STANDARDS_COUNT_BOX_TYPES.SKILL_QUESTS), renderContentBox(averageAccuracyLabel, averageAccuracyValue, null, accuracyOverviewLabel, getAccuracyGraphContent(averageAccuraciesHistory), showAccuracyOverviewGraph ? function () {
      return getAccuracyGraphModalContent(averageAccuraciesHistory);
    } : null, _skillQuestsMasteryConstants.SQ_STANDARDS_COUNT_BOX_TYPES.AVERAGE_ACCURACY), renderContentBox(highestAccuracyLabel, highestAccuracyValue, function () {
      return getAccuracyModalContent(highestAccuracies, highestAccuracyLabel);
    }, lowestAccuracyLabel, lowestAccuracyValue, function () {
      return getAccuracyModalContent(lowestAccuracies, lowestAccuracyLabel);
    }, _skillQuestsMasteryConstants.SQ_STANDARDS_COUNT_BOX_TYPES.HIGHEST_ACCURACY))));
  }
  return null;
};
ProgressDisplay.propTypes = {
  openModal: _propTypes["default"].func,
  skillQuestsMasteryStudentData: _propTypes["default"].object,
  getDateLabel: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_progressDisplay["default"])(ProgressDisplay);

/***/ }),

/***/ "Uk2F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uiHelper = _interopRequireDefault(__webpack_require__("Vhb/"));
var _studentConstants = __webpack_require__("OCle");
var _utils = __webpack_require__("v/Rl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for converting participation report data from redux store into format
 * needed for export endpoints
 */
var ParticipationDataConverter = exports["default"] = /*#__PURE__*/function () {
  function ParticipationDataConverter() {
    _classCallCheck(this, ParticipationDataConverter);
  }
  return _createClass(ParticipationDataConverter, null, [{
    key: "convertAllClasses",
    value: function convertAllClasses(data, selectedDate, reportTitle, participationKey, tableTitle, sessionId) {
      var classroomParticipations = data.classroomParticipations,
        certificates = data.certificates,
        classroomUsage = data.classroomUsage,
        newCertificate = data.newCertificate;
      var gold = certificates.gold,
        silver = certificates.silver,
        bronze = certificates.bronze;
      var usage = classroomUsage[0];
      var _getTotalCurriculumAn = (0, _utils.getTotalCurriculumAndLivePoints)(classroomParticipations),
        totalCurriculumPoints = _getTotalCurriculumAn.totalCurriculumPoints;
      return _defineProperty({
        dateRange: _uiHelper["default"].formatDateRange(selectedDate),
        reportLevelHeader: reportTitle,
        participationTableTitle: tableTitle
      }, participationKey, {
        classroomParticipations: classroomParticipations,
        totalGold: gold,
        totalSilver: silver,
        totalBronze: bronze,
        newCertificate: newCertificate,
        totalSignIns: usage.totalSignIns,
        totalTimeOnline: usage.totalTimeOnline,
        totalActivityPoints: totalCurriculumPoints,
        totalLivePoints: usage.totalLiveMathsPoints,
        sessionId: sessionId
      });
    }
  }, {
    key: "convertSingleClass",
    value: function convertSingleClass(data, selectedDate, groupId, tableTitle) {
      var classroomName = data.classroomName;
      var classroomGroupParticipations = data.classroomGroupParticipations,
        usage = data.usage,
        certificateDetails = data.certificateDetails;
      if (groupId) {
        classroomGroupParticipations = classroomGroupParticipations.filter(function (g) {
          return g.id === groupId;
        });
        var _classroomGroupPartic = classroomGroupParticipations[0];
        certificateDetails = _classroomGroupPartic.certificateDetails;
        usage = _classroomGroupPartic.usage;
      }
      return {
        dateRange: _uiHelper["default"].formatDateRange(selectedDate),
        participationTableTitle: tableTitle,
        classroomParticipationData: {
          classroomName: classroomName,
          accessDetails: usage[0],
          certificateDetails: certificateDetails,
          classroomGroupParticipations: classroomGroupParticipations
        }
      };
    }
  }, {
    key: "convertStudent",
    value: function convertStudent(data, selectedDate, improvement, selectedImprovements) {
      var _this = this;
      var topicParticipations;
      if (improvement === _studentConstants.SELECTION_AS_IS) {
        topicParticipations = data.topicParticipations.map(function (topic) {
          return _objectSpread(_objectSpread({}, topic), {}, {
            improvementType: _this.IMPROVEMENT_MAP[selectedImprovements[topic.id]]
          });
        }, this);
      } else {
        var improvementType = this.IMPROVEMENT_MAP[improvement];
        topicParticipations = data.topicParticipations.map(function (topic) {
          return _objectSpread(_objectSpread({}, topic), {}, {
            improvementType: improvementType
          });
        }, this);
      }
      return {
        dateRange: _uiHelper["default"].formatDateRange(selectedDate),
        studentParticipationData: _objectSpread(_objectSpread({}, data), {}, {
          topicParticipations: topicParticipations
        })
      };
    }
  }]);
}();
_defineProperty(ParticipationDataConverter, "IMPROVEMENT_MAP", _defineProperty(_defineProperty(_defineProperty({}, _studentConstants.FIRST_VS_LATEST, 0), _studentConstants.HIGHEST_VS_LATEST, 1), _studentConstants.FIRST_VS_HIGHEST, 2));

/***/ }),

/***/ "UtIO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.YearGroupDropdown = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _dropdownHelpers = __webpack_require__("KmGe");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var YearGroupDropdown = exports.YearGroupDropdown = /*#__PURE__*/function (_PureComponent) {
  function YearGroupDropdown() {
    _classCallCheck(this, YearGroupDropdown);
    return _callSuper(this, YearGroupDropdown, arguments);
  }
  _inherits(YearGroupDropdown, _PureComponent);
  return _createClass(YearGroupDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        yearGroupDropdownData = _this$props.yearGroupDropdownData,
        className = _this$props.className,
        setSelectedYearGroup = _this$props.setSelectedYearGroup,
        applyFilters = _this$props.applyFilters;
      var data = yearGroupDropdownData.data,
        selectedOption = yearGroupDropdownData.selectedOption,
        disabled = yearGroupDropdownData.disabled;
      var i18n = window.i18n;
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
        className: className,
        options: (0, _dropdownHelpers.getTranslatedOptions)(data, _filterConstants.ALL_YEARS, i18n),
        selectedOption: (0, _dropdownHelpers.getTranslateSelectedOption)(selectedOption, _filterConstants.ALL_YEARS, i18n),
        onSelectOption: function onSelectOption(e) {
          setSelectedYearGroup(e);
          applyFilters();
        },
        disabled: disabled
      });
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(YearGroupDropdown, "propTypes", {
  yearGroupDropdownData: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_filterPropTypes.dropdownItemPropType),
    selectedOption: _filterPropTypes.dropdownItemPropType,
    disabled: _propTypes["default"].bool
  }),
  className: _propTypes["default"].string,
  setSelectedYearGroup: _propTypes["default"].func,
  applyFilters: _propTypes["default"].func.isRequired
});
function mapStateToProps(state) {
  return {
    yearGroupDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.YEAR_GROUP_LIST)(state)
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setSelectedYearGroup: _dropdownDataActions["default"].setSelectedYearGroup
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(YearGroupDropdown);

/***/ }),

/***/ "V289":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1kTuc {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .component---1kTuc h3 {\n    margin-left: 8px;\n    font-weight: 500;\n    font-size: 18px; }\n  .component---1kTuc .back-button---2_FbP {\n    border-radius: 20px;\n    background-color: #278bcb;\n    width: 30px;\n    height: 30px; }\n  .component---1kTuc .back-button---2_FbP svg {\n      margin-right: 2px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1kTuc",
	"back-button": "back-button---2_FbP"
};

/***/ }),

/***/ "Vhb/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactComponents = __webpack_require__("fmgT");
var _dayjs = _interopRequireDefault(__webpack_require__("oqQY"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
__webpack_require__("Xf3+");
var UIHelper = exports["default"] = /*#__PURE__*/function () {
  function UIHelper() {
    _classCallCheck(this, UIHelper);
  }
  return _createClass(UIHelper, null, [{
    key: "formatDateRange",
    value: function formatDateRange(selectedDate) {
      if (selectedDate.startDate === null || selectedDate.endDate === null) {
        return '';
      }
      var formattedDate = UIHelper.formatDate(selectedDate);
      var formattedStartDate = formattedDate.startDate;
      var formattedEndDate = formattedDate.endDate;
      var isLifetime = selectedDate.type === _reactComponents.DatePicker.LIFETIME;
      return isLifetime ? "+Prior ".concat(formattedStartDate, " - ").concat(formattedEndDate) : "".concat(formattedStartDate, " - ").concat(formattedEndDate);
    }
  }]);
}();
_defineProperty(UIHelper, "formatDate", function (selectedDate) {
  var formatString = 'DD MMMM YYYY';
  var locale = (0, _localeHelpers.localeCode)().toLowerCase();
  _dayjs["default"].locale(locale);
  var startDate = (0, _dayjs["default"])(selectedDate.startDate).format(formatString);
  var endDate = (0, _dayjs["default"])(selectedDate.endDate).format(formatString);
  return {
    startDate: startDate,
    endDate: endDate
  };
});

/***/ }),

/***/ "Vnjy":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Ticr");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./toast.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./toast.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Vx94":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3hh53 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  .component---3hh53 .attempt---2MIM4 {\n    font-weight: bold; }\n  .component---3hh53 .attempt---2MIM4 .percent---2Brh1 {\n      font-size: 12px; }\n  .component---3hh53 .null-attempt---3v4M0 {\n    color: #999b9d; }\n  .component---3hh53 .avg---2hsdB {\n    padding: 0 8px;\n    background: #cfd2d4;\n    border-radius: 10px;\n    font-size: 12px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3hh53",
	"attempt": "attempt---2MIM4",
	"percent": "percent---2Brh1",
	"null-attempt": "null-attempt---3v4M0",
	"avg": "avg---2hsdB"
};

/***/ }),

/***/ "W4j+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3MffS {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  font-weight: bold; }\n  .component---3MffS .null-improvement---3AAIM {\n    color: #999b9d; }\n  .component---3MffS .equal---JD0Iz,\n  .component---3MffS .negative---2MmPp,\n  .component---3MffS .positive---1HWAP {\n    font-size: 16px;\n    line-height: 32px;\n    width: 60px;\n    border-radius: 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .component---3MffS .equal---JD0Iz .arrow-icon---2OHPK,\n    .component---3MffS .negative---2MmPp .arrow-icon---2OHPK,\n    .component---3MffS .positive---1HWAP .arrow-icon---2OHPK {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      margin-right: 4px;\n      -ms-flex-preferred-size: 16px;\n          flex-basis: 16px; }\n  .component---3MffS .equal---JD0Iz .arrow-icon---2OHPK svg,\n      .component---3MffS .negative---2MmPp .arrow-icon---2OHPK svg,\n      .component---3MffS .positive---1HWAP .arrow-icon---2OHPK svg {\n        height: 16px;\n        width: 16px; }\n  .component---3MffS .equal---JD0Iz .arrow-icon---2OHPK svg path,\n        .component---3MffS .negative---2MmPp .arrow-icon---2OHPK svg path,\n        .component---3MffS .positive---1HWAP .arrow-icon---2OHPK svg path {\n          fill: currentColor !important; }\n  .component---3MffS .equal---JD0Iz {\n    background-color: #e1e1e1;\n    color: #808080; }\n  .component---3MffS .negative---2MmPp {\n    background-color: #f0dfd7;\n    color: #c53902; }\n  .component---3MffS .positive---1HWAP {\n    background-color: #dff2e7;\n    color: #2ab28a; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3MffS",
	"null-improvement": "null-improvement---3AAIM",
	"equal": "equal---JD0Iz",
	"negative": "negative---2MmPp",
	"positive": "positive---1HWAP",
	"arrow-icon": "arrow-icon---2OHPK"
};

/***/ }),

/***/ "WBph":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("W4j+");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./participation-improvement.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./participation-improvement.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WKZP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PARTICIPATION_CLASS_RETRIEVED = void 0;
var _sortBy = _interopRequireDefault(__webpack_require__("KBYM"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _constants = __webpack_require__("1QGX");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PARTICIPATION_CLASS_RETRIEVED = exports.PARTICIPATION_CLASS_RETRIEVED = 'PARTICIPATION_CLASS_RETRIEVED';
function getParticipationData(classroomId, selectedDateFilter) {
  return function (dispatch) {
    return _resources["default"].singleClassReport.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_PARTICIPATION
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId
    })).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDateFilter)).send().then(function (payload) {
      if (payload.valid) {
        dispatch({
          type: PARTICIPATION_CLASS_RETRIEVED,
          payload: mapParticipationData(payload.data)
        });
      } else {
        dispatch(_errorsActions["default"].addError(PARTICIPATION_CLASS_RETRIEVED));
      }
    });
  };
}
function mapParticipationData(data) {
  var classroomName = data.classroomName,
    teachers = data.teachers,
    certificateDetails = data.certificateDetails,
    newCertificateDetails = data.newCertificateDetails,
    classroomGroupParticipations = data.classroomGroupParticipations;
  var teacherName = '';
  if (teachers.length > 0) {
    if (teachers.length > 1) {
      teacherName = "".concat(teachers.length, " Teachers");
    } else {
      var teacher = teachers[0];
      teacherName = "".concat(teacher.title, " ").concat(teacher.firstName, " ").concat(teacher.lastName);
    }
  }
  var mappedGroupData = classroomGroupParticipations.map(function (groupData) {
    return {
      id: groupData.id,
      name: groupData.name,
      courseName: groupData.courseName,
      certificateDetails: groupData.certificateDetails,
      newCertificateDetails: groupData.newCertificateDetails,
      usage: mapUsage(groupData),
      studentUsageDetails: mapStudentsUsage(groupData),
      upfCourseId: groupData.upfCourseId,
      upfCourseName: groupData.upfCourseName,
      upfCoursePublicationName: groupData.upfCoursePublicationName,
      upfFullName: "".concat(groupData.upfCoursePublicationName, " - ").concat(groupData.upfCourseName),
      encryptedUserProfileId: groupData.encryptedUserProfileId,
      userProfileId: groupData.userProfileId
    };
  });
  mappedGroupData = (0, _sortBy["default"])(mappedGroupData, [function (group) {
    return group.name === 'Default Group' ? 0 : 1;
  }, 'name']);
  return {
    classroomName: classroomName,
    teacherName: teacherName,
    certificateDetails: certificateDetails,
    newCertificateDetails: newCertificateDetails,
    usage: mapUsage(data),
    classroomGroupParticipations: mappedGroupData
  };
}
function mapUsage(data) {
  var usage = _objectSpread(_objectSpread(_objectSpread({
    id: 0
  }, data.points), data.accessDetails), {}, {
    totalPoints: data.points.total
  });
  delete usage.total;
  return [usage];
}
function mapStudentsUsage(groupData) {
  var studentsUsage = groupData.studentUsageDetails.map(function (student) {
    var mappedStudent = _objectSpread({}, student);
    mappedStudent.id = student.userProfileId;
    mappedStudent.fullName = "".concat(student.lastName, ", ").concat(student.firstName);
    mappedStudent.groupId = groupData.id;
    delete mappedStudent.userProfileId;
    return mappedStudent;
  });
  return (0, _sortBy["default"])(studentsUsage, ['lastName', 'firstName']);
}
var _default = exports["default"] = {
  getParticipationData: getParticipationData
};

/***/ }),

/***/ "WRki":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".context-modal---3yrcU {\n  position: absolute;\n  border: 1px #e5e5e5 solid;\n  background-color: #fff;\n  border-radius: 5px;\n  height: auto;\n  padding: 10px;\n  z-index: 100; }\n  .context-modal---3yrcU .modal-container---2WNXp {\n    position: relative; }\n  .context-modal---3yrcU .modal-container---2WNXp.MODAL_UP---1hW2t::before {\n      top: -21px; }\n  .context-modal---3yrcU .modal-container---2WNXp.MODAL_UP---1hW2t::after {\n      top: -19px; }\n  .context-modal---3yrcU .modal-container---2WNXp.MODAL_DOWN---39OaX::before {\n      top: calc(100% + 10px);\n      -webkit-transform: rotateX(180deg) translate(-50%, 0);\n              transform: rotateX(180deg) translate(-50%, 0); }\n  .context-modal---3yrcU .modal-container---2WNXp.MODAL_DOWN---39OaX::after {\n      top: calc(100% + 9px);\n      -webkit-transform: rotateX(180deg) translate(-50%, 0);\n              transform: rotateX(180deg) translate(-50%, 0); }\n  .context-modal---3yrcU .modal-container---2WNXp::before {\n      border-left: 8px solid transparent;\n      border-right: 8px solid transparent;\n      border-bottom: 11px solid #e5e5e5;\n      position: absolute;\n      left: 50%;\n      -webkit-transform: translate(-50%, 0);\n              transform: translate(-50%, 0);\n      content: \" \"; }\n  .context-modal---3yrcU .modal-container---2WNXp::after {\n      border-left: 7px solid transparent;\n      border-right: 7px solid transparent;\n      border-bottom: 10px solid #fff;\n      position: absolute;\n      left: 50%;\n      -webkit-transform: translate(-50%, 0);\n              transform: translate(-50%, 0);\n      content: \" \"; }\n", ""]);

// exports
exports.locals = {
	"context-modal": "context-modal---3yrcU",
	"modal-container": "modal-container---2WNXp",
	"MODAL_UP": "MODAL_UP---1hW2t",
	"MODAL_DOWN": "MODAL_DOWN---39OaX"
};

/***/ }),

/***/ "WXir":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---EQlnm {\n  height: 100%;\n  min-width: 1100px; }\n  .component---EQlnm > div {\n    height: 100%; }\n  .component---EQlnm .report-container---1090O {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n  .manage-students-button---3f0go {\n  background: none;\n  color: #278bcb;\n  text-decoration: underline;\n  border: none;\n  padding: 0;\n  cursor: pointer; }\n  .sqm-all-classes---HbPxa {\n  height: calc(100% - 135px);\n  padding: 0 8px; }\n  .sqm-all-classes---HbPxa .sub-heading---xjK8I {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    margin-bottom: 12px; }\n  .sqm-all-classes---HbPxa .sub-heading---xjK8I .right-side---31u2Q {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 100%;\n            flex: 1 1 100%;\n    height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 0 8px;\n    padding: 0; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC table {\n      width: calc(100% - 2px); }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 0;\n      background-color: white;\n      font-weight: 500;\n      color: #4e5c67;\n      height: 47px; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type th {\n        border: none;\n        background: none;\n        font-weight: normal;\n        font-size: 12px;\n        white-space: nowrap; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type th::after, .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type th::before {\n          content: '';\n          position: absolute;\n          left: 0;\n          width: 100%; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type th::before {\n          top: -1px;\n          border-top: 1px solid #e5e5e5;\n          pointer-events: none; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type th::after {\n          bottom: -1px;\n          border-bottom: 2px solid #e5e5e5;\n          pointer-events: none; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type th::before {\n          left: -1px;\n          height: 46px;\n          border-left: 1px solid white;\n          border-right: 1px solid white; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type th::after {\n          height: 46px;\n          border-left: 1px solid white;\n          right: 1px; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:first-of-type th:first-of-type {\n          font-size: 18px;\n          text-align: left; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:last-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 47px;\n      background-color: #e4eaef;\n      color: #278bcb;\n      font-weight: 600; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:last-of-type th::after, .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:last-of-type th::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        width: 100%; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:last-of-type th::before {\n        top: -1px;\n        border-top: 1px solid #e5e5e5;\n        pointer-events: none; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC thead tr:last-of-type th::after {\n        bottom: -1px;\n        border-bottom: 2px solid #e5e5e5;\n        pointer-events: none; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC table {\n      table-layout: auto; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC th.class-name---1ylfQ {\n      width: 16%; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC th.completed-quests---2oTHq {\n      width: 30%; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC th.dark-header---23t7s {\n      background-color: #e4eaef;\n      border-color: #dadfe3; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC th.dark-header---23t7s div {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC th.dark-header---23t7s div span:first-child {\n          text-align: left; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC th.light-header---1USUS {\n      background-color: #eef4f9;\n      text-align: center; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC td.class-name---1ylfQ div {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC td.class-name---1ylfQ div p {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: calc(100% - 25px); }\n  .sqm-all-classes---HbPxa .data-table---3pYHC td.completed-quests---2oTHq {\n      width: 30%; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC td.light-header---1USUS {\n      text-align: center; }\n  .sqm-all-classes---HbPxa .data-table---3pYHC td .no-students---2UzEO {\n      opacity: 0.65;\n      cursor: not-allowed;\n      pointer-events: none; }\n  .accuracy-worst---1ootE {\n  background-color: red; }\n  .accuracy-middle---1l2D2 {\n  background-color: blue; }\n  .accuracy-best---3mjzi {\n  background-color: green; }\n", ""]);

// exports
exports.locals = {
	"component": "component---EQlnm",
	"report-container": "report-container---1090O",
	"manage-students-button": "manage-students-button---3f0go",
	"sqm-all-classes": "sqm-all-classes---HbPxa",
	"sub-heading": "sub-heading---xjK8I",
	"right-side": "right-side---31u2Q",
	"data-table": "data-table---3pYHC",
	"class-name": "class-name---1ylfQ",
	"completed-quests": "completed-quests---2oTHq",
	"dark-header": "dark-header---23t7s",
	"light-header": "light-header---1USUS",
	"no-students": "no-students---2UzEO",
	"accuracy-worst": "accuracy-worst---1ootE",
	"accuracy-middle": "accuracy-middle---1l2D2",
	"accuracy-best": "accuracy-best---3mjzi"
};

/***/ }),

/***/ "WaVk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _linguiCdn = __webpack_require__("siuH");
var _courseEmptyState = _interopRequireDefault(__webpack_require__("Mxz8"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CourseEmptyState = function CourseEmptyState(_ref) {
  var onClickHandler = _ref.onClickHandler;
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var text = {
    headerText: i18n._(
    /*i18n*/
    {
      id: "Course Empty State - No skill quests assigned",
      defaults: "No skill quests assigned"
    }),
    contentOneText: i18n._(
    /*i18n*/
    {
      id: "Course Empty State - Please go to",
      defaults: "Please go to"
    }),
    contentTwoText: i18n._(
    /*i18n*/
    {
      id: "Course Empty State - Skill Quests",
      defaults: "Skill Quests"
    }),
    contentThreeText: i18n._(
    /*i18n*/
    {
      id: "Course Empty State - to start assigning",
      defaults: "to start assigning"
    })
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _courseEmptyState["default"]['course-empty-state']
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: _courseEmptyState["default"].header
  }, text.headerText), /*#__PURE__*/_react["default"].createElement("div", {
    className: _courseEmptyState["default"].content
  }, /*#__PURE__*/_react["default"].createElement("p", null, text.contentOneText), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return onClickHandler();
    }
  }, text.contentTwoText), /*#__PURE__*/_react["default"].createElement("p", null, text.contentThreeText)));
};
CourseEmptyState.propTypes = {
  onClickHandler: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_courseEmptyState["default"])(CourseEmptyState);

/***/ }),

/***/ "WjkK":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lZfO");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./sub-heading-header.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./sub-heading-header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WlvJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _classListActions = __webpack_require__("Mre5");
var initialState = [];

/**
 * Class List Reducer
 *
 * Consumes ALL_CLASSES_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _classListActions.ALL_CLASSES_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "Wr1R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_ASSIGNMENT_RESULTS_TYPE = void 0;
exports.setAssignmentResultsType = setAssignmentResultsType;
var SET_ASSIGNMENT_RESULTS_TYPE = exports.SET_ASSIGNMENT_RESULTS_TYPE = 'SET_ASSIGNMENT_RESULTS_TYPE';
function setAssignmentResultsType(updatedAssignmentResultType) {
  return function (dispatch) {
    dispatch({
      type: SET_ASSIGNMENT_RESULTS_TYPE,
      payload: updatedAssignmentResultType
    });
  };
}

/***/ }),

/***/ "Wsmd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTop10ParticipationTableConfig = exports.getAllYearsParticipationTableConfig = exports.getAllClassesParticipationTableConfig = exports.YEAR_GROUP = exports.PAST_CERTIFICATES_TOTAL = exports.PAST_CERTIFICATES_SILVER = exports.PAST_CERTIFICATES_GOLD = exports.PAST_CERTIFICATES_BRONZE = exports.NEW_CERTIFICATES_TOTAL = exports.NEW_CERTIFICATES_SILVER = exports.NEW_CERTIFICATES_PLATINUM = exports.NEW_CERTIFICATES_LEGEND = exports.NEW_CERTIFICATES_GOLD = exports.NEW_CERTIFICATES_EPIC = exports.NEW_CERTIFICATES_EMERALD = exports.NEW_CERTIFICATES_DIAMOND = exports.NEW_CERTIFICATES_BRONZE = exports.CLASS_NAME = exports.CLASS_ID = exports.ALL_GROUPS_ID = exports.ALL_CLASSES_USAGE_TABLE_CONFIG = exports.ALL_CLASSES_ID = void 0;
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _certificatesActions = _interopRequireDefault(__webpack_require__("PLdC"));
var _certificateDisplay = _interopRequireDefault(__webpack_require__("fXLW"));
var _constants = __webpack_require__("1QGX");
var _urlHelper = _interopRequireDefault(__webpack_require__("uOny"));
var _certificateConstants = __webpack_require__("tQue");
var _allClasses = _interopRequireDefault(__webpack_require__("9gKn"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CLASS_ID = exports.CLASS_ID = 'id';
var CLASS_NAME = exports.CLASS_NAME = 'classroomName';
var ALL_CLASSES_ID = exports.ALL_CLASSES_ID = 0;
var ALL_GROUPS_ID = exports.ALL_GROUPS_ID = 0;
var NEW_CERTIFICATES_TOTAL = exports.NEW_CERTIFICATES_TOTAL = 'newCertificatesTotal';
var PAST_CERTIFICATES_TOTAL = exports.PAST_CERTIFICATES_TOTAL = 'pastCertificatesTotal';
var NEW_CERTIFICATES_BRONZE = exports.NEW_CERTIFICATES_BRONZE = 'newCertificatesBronze';
var NEW_CERTIFICATES_SILVER = exports.NEW_CERTIFICATES_SILVER = 'newCertificatesSilver';
var NEW_CERTIFICATES_GOLD = exports.NEW_CERTIFICATES_GOLD = 'newCertificatesGold';
var NEW_CERTIFICATES_PLATINUM = exports.NEW_CERTIFICATES_PLATINUM = 'newCertificatesPlatinum';
var NEW_CERTIFICATES_EMERALD = exports.NEW_CERTIFICATES_EMERALD = 'newCertificatesEmerald';
var NEW_CERTIFICATES_DIAMOND = exports.NEW_CERTIFICATES_DIAMOND = 'newCertificatesDiamond';
var NEW_CERTIFICATES_EPIC = exports.NEW_CERTIFICATES_EPIC = 'newCertificatesEpic';
var NEW_CERTIFICATES_LEGEND = exports.NEW_CERTIFICATES_LEGEND = 'newCertificatesLegend';
var PAST_CERTIFICATES_BRONZE = exports.PAST_CERTIFICATES_BRONZE = 'bronze';
var PAST_CERTIFICATES_SILVER = exports.PAST_CERTIFICATES_SILVER = 'silver';
var PAST_CERTIFICATES_GOLD = exports.PAST_CERTIFICATES_GOLD = 'gold';
var YEAR_GROUP = exports.YEAR_GROUP = 'yearGroup';
var ACTIVITY_POINTS = 'activityPoints';
var LIVE_POINTS = 'livePoints';
var TOTAL_POINTS = 'totalPoints';
var SIGN_INS = 'totalSignIns';
var TIME_ONLINE = 'totalTimeOnline';
var TOTAL_ACTIVITY_POINTS = 'totalActivityPoints';
var TOTAL_SKILL_QUESTS_POINTS = 'totalSkillQuestsPoints';
var TOTAL_LIVE_POINTS = 'totalLivePoints';
var sort = {
  sortAs: 'number',
  sortDir: 'desc'
};
var getCertificateName = function getCertificateName(id, name) {
  var i18n = window.i18n;
  switch (id) {
    case NEW_CERTIFICATES_TOTAL:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - New Certificates - {name}",
        values: {
          name: name
        }
      });
    case PAST_CERTIFICATES_TOTAL:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Past Certificates - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_BRONZE:
    case PAST_CERTIFICATES_BRONZE:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Bronze - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_SILVER:
    case PAST_CERTIFICATES_SILVER:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Silver - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_GOLD:
    case PAST_CERTIFICATES_GOLD:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Gold - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_EMERALD:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Emerald - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_DIAMOND:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Diamond - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_EPIC:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Epic - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_LEGEND:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Legend - {name}",
        values: {
          name: name
        }
      });
    case NEW_CERTIFICATES_PLATINUM:
      return i18n._(
      /*i18n*/
      {
        id: "Filename - Platinum - {name}",
        values: {
          name: name
        }
      });
    default:
      return '';
  }
};
var getCertificateDisplayColumn = function getCertificateDisplayColumn(_ref) {
  var id = _ref.id,
    name = _ref.name,
    type = _ref.type,
    service = _ref.service,
    isAllYears = _ref.isAllYears,
    isTopTen = _ref.isTopTen,
    _ref$isOldCertificate = _ref.isOldCertificates,
    isOldCertificates = _ref$isOldCertificate === void 0 ? false : _ref$isOldCertificate;
  return {
    id: id,
    name: name,
    transform: function transform(value) {
      var classroomId = isAllYears ? ALL_CLASSES_ID : value.classroomId || ALL_CLASSES_ID;
      var yearGroupEnum = isAllYears ? value.classroomId : null;
      var userProfileId = isTopTen ? value.id : 0;
      var requestParams = _objectSpread(_objectSpread({
        classroomId: classroomId,
        startDate: _urlHelper["default"].getQueryParamValue(_constants.START_DATE) || null,
        endDate: _urlHelper["default"].getQueryParamValue(_constants.END_DATE) || null,
        groupId: ALL_GROUPS_ID,
        isForDownload: true,
        type: type
      }, userProfileId && {
        userProfileId: userProfileId
      }), yearGroupEnum !== null && {
        yearGroupEnum: yearGroupEnum
      });
      var onSuccessParams = {
        certificateType: type,
        certificatesCount: value[id],
        fileNameOverride: getCertificateName(id, value.classroomName)
      };
      return /*#__PURE__*/_react["default"].createElement(_certificateDisplay["default"], {
        count: value[id],
        requestParams: requestParams,
        service: service,
        onSuccessParams: onSuccessParams,
        isOldCertificates: isOldCertificates
      });
    }
  };
};

/**
 * New version of participation reports requires dynamic table config for new and past certificates.
 * Separating the constants files that manage these configs to promote a smooth transition between old and new.
 * Consider that reports will still have other areas that need to remain the same.
 */
var getAllClassesParticipationPastCertificates = function getAllClassesParticipationPastCertificates(isExpanded, isAllYears) {
  if (isExpanded) {
    var defaultParams = {
      service: _certificatesActions["default"].pastCertificatesDownloadByType,
      isAllYears: isAllYears,
      isOldCertificates: true
    };
    return {
      cols: [getCertificateDisplayColumn(_objectSpread({
        id: PAST_CERTIFICATES_BRONZE,
        name: 'Certificates - Bronze',
        type: _certificateConstants.BRONZE.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: PAST_CERTIFICATES_SILVER,
        name: 'Certificates - Silver',
        type: _certificateConstants.SILVER.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: PAST_CERTIFICATES_GOLD,
        name: 'Certificates - Gold',
        type: _certificateConstants.GOLD.type
      }, defaultParams))],
      colGroups: [[{
        colIds: [PAST_CERTIFICATES_BRONZE, PAST_CERTIFICATES_SILVER, PAST_CERTIFICATES_GOLD],
        name: 'Past Certificates - Total',
        classes: _allClasses["default"]['total-certificates'],
        id: PAST_CERTIFICATES_TOTAL
      }]]
    };
  }
  return {
    cols: [getCertificateDisplayColumn({
      id: PAST_CERTIFICATES_TOTAL,
      name: '',
      service: _certificatesActions["default"].pastCertificatesDownload,
      type: _certificateConstants.PAST_TOTAL.type,
      isOldCertificates: true,
      isAllYears: isAllYears
    })],
    colGroups: [[{
      id: PAST_CERTIFICATES_TOTAL,
      colIds: [PAST_CERTIFICATES_TOTAL],
      name: 'Past Certificates - Total',
      classes: _allClasses["default"]['total-certificates']
    }]]
  };
};
var getAllClassesParticipationNewCertificates = function getAllClassesParticipationNewCertificates(isExpanded, isAllYears, isTopTen) {
  var defaultStyles = "\n        ".concat(_allClasses["default"]['total-certificates'], " \n        ").concat(_allClasses["default"]['new-certificates'], "\n    ");
  if (isExpanded) {
    var defaultParams = {
      service: _certificatesActions["default"].newCertificatesDownloadByType,
      isAllYears: isAllYears,
      isTopTen: isTopTen
    };
    return {
      cols: [getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_BRONZE,
        name: 'Certificates - Bronze',
        type: _certificateConstants.BRONZE.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_SILVER,
        name: 'Certificates - Silver',
        type: _certificateConstants.SILVER.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_GOLD,
        name: 'Certificates - Gold',
        type: _certificateConstants.GOLD.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_PLATINUM,
        name: 'Certificates - Platinum',
        type: _certificateConstants.PLATINUM.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_EMERALD,
        name: 'Certificates - Emerald',
        type: _certificateConstants.EMERALD.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_DIAMOND,
        name: 'Certificates - Diamond',
        type: _certificateConstants.DIAMOND.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_EPIC,
        name: 'Certificates - Epic',
        type: _certificateConstants.EPIC.type
      }, defaultParams)), getCertificateDisplayColumn(_objectSpread({
        id: NEW_CERTIFICATES_LEGEND,
        name: 'Certificates - Legend',
        type: _certificateConstants.LEGEND.type
      }, defaultParams))],
      colGroups: [[{
        colIds: [NEW_CERTIFICATES_BRONZE, NEW_CERTIFICATES_SILVER, NEW_CERTIFICATES_GOLD, NEW_CERTIFICATES_PLATINUM, NEW_CERTIFICATES_EMERALD, NEW_CERTIFICATES_DIAMOND, NEW_CERTIFICATES_EPIC, NEW_CERTIFICATES_LEGEND],
        name: 'New Certificates - Total',
        classes: isExpanded ? "\n                                ".concat(defaultStyles, "\n                                ").concat(_allClasses["default"]['new-expanded']) : defaultStyles,
        id: NEW_CERTIFICATES_TOTAL
      }]]
    };
  }
  return {
    cols: [getCertificateDisplayColumn({
      id: NEW_CERTIFICATES_TOTAL,
      name: '',
      service: _certificatesActions["default"].newCertificatesDownload,
      type: _certificateConstants.NEW_TOTAL.type,
      isAllYears: isAllYears,
      isTopTen: isTopTen
    })],
    colGroups: [[{
      id: NEW_CERTIFICATES_TOTAL,
      colIds: [NEW_CERTIFICATES_TOTAL],
      name: 'New Certificates - Total',
      classes: defaultStyles
    }]]
  };
};
var getAllClassesParticipationTableConfig = exports.getAllClassesParticipationTableConfig = function getAllClassesParticipationTableConfig(_ref2) {
  var _ref2$isNewCertificat = _ref2.isNewCertificatesExpanded,
    isNewCertificatesExpanded = _ref2$isNewCertificat === void 0 ? false : _ref2$isNewCertificat,
    _ref2$isPastCertifica = _ref2.isPastCertificatesExpanded,
    isPastCertificatesExpanded = _ref2$isPastCertifica === void 0 ? false : _ref2$isPastCertifica,
    _ref2$isAllYears = _ref2.isAllYears,
    isAllYears = _ref2$isAllYears === void 0 ? false : _ref2$isAllYears,
    _ref2$isTopTen = _ref2.isTopTen,
    isTopTen = _ref2$isTopTen === void 0 ? false : _ref2$isTopTen;
  var isExpanded = isNewCertificatesExpanded || isPastCertificatesExpanded;
  var pastCertificatesConfig = getAllClassesParticipationPastCertificates(isPastCertificatesExpanded, isAllYears, isTopTen);
  var newCertificatesConfig = getAllClassesParticipationNewCertificates(isNewCertificatesExpanded, isAllYears, isTopTen);
  return {
    colGroups: [[{
      colIds: [CLASS_NAME],
      name: 'Table Config - All classes',
      sort: {
        colId: CLASS_NAME,
        sortAs: 'string'
      },
      classes: _allClasses["default"]['class-name']
    }, {
      colIds: [LIVE_POINTS],
      name: isExpanded ? 'Points - Live - Small' : 'Points - Live',
      sort: _objectSpread({
        colId: LIVE_POINTS
      }, sort),
      classes: isExpanded ? "".concat(_allClasses["default"]['total-points'], " ").concat(_allClasses["default"].small) : _allClasses["default"]['total-points']
    }, {
      colIds: [ACTIVITY_POINTS],
      name: isExpanded ? 'Points - Curriculum - Small' : 'Points - Curriculum',
      sort: _objectSpread({
        colId: ACTIVITY_POINTS
      }, sort),
      classes: isExpanded ? "".concat(_allClasses["default"]['total-points'], " ").concat(_allClasses["default"].small) : _allClasses["default"]['total-points']
    }, {
      colIds: [TOTAL_POINTS],
      name: isExpanded ? 'Points - Total - Small' : 'Points - Total',
      sort: _objectSpread({
        colId: TOTAL_POINTS
      }, sort),
      classes: isExpanded ? "".concat(_allClasses["default"]['total-points'], " ").concat(_allClasses["default"].small) : _allClasses["default"]['total-points']
    }].concat(_toConsumableArray(newCertificatesConfig.colGroups[0]), _toConsumableArray(pastCertificatesConfig.colGroups[0]))],
    cols: [{
      id: CLASS_NAME,
      name: '',
      doTranslation: true,
      truncate: true,
      onClick: function onClick() {
        return null;
      } // this is set in the AllClasses component
    }, {
      id: LIVE_POINTS,
      name: ''
    }, {
      id: ACTIVITY_POINTS,
      name: ''
    }, {
      id: TOTAL_POINTS,
      name: ''
    }].concat(_toConsumableArray(newCertificatesConfig.cols), _toConsumableArray(pastCertificatesConfig.cols)),
    defaultSort: CLASS_NAME,
    emptyDataMessage: 'Empty - NoParticipationResults'
  };
};
var getAllYearsParticipationTableConfig = exports.getAllYearsParticipationTableConfig = function getAllYearsParticipationTableConfig(_ref3) {
  var _ref3$isNewCertificat = _ref3.isNewCertificatesExpanded,
    isNewCertificatesExpanded = _ref3$isNewCertificat === void 0 ? false : _ref3$isNewCertificat,
    _ref3$isPastCertifica = _ref3.isPastCertificatesExpanded,
    isPastCertificatesExpanded = _ref3$isPastCertifica === void 0 ? false : _ref3$isPastCertifica;
  var ALL_YEARS_PARTICIPATION_TABLE_CONFIG = (0, _cloneDeep["default"])(_objectSpread(_objectSpread({}, getAllClassesParticipationTableConfig({
    isNewCertificatesExpanded: isNewCertificatesExpanded,
    isPastCertificatesExpanded: isPastCertificatesExpanded,
    isAllYears: true
  })), {}, {
    defaultSort: CLASS_ID
  }));
  ALL_YEARS_PARTICIPATION_TABLE_CONFIG.colGroups[0][0] = {
    colIds: [CLASS_ID],
    name: 'Export - All years',
    sort: _objectSpread({
      colId: CLASS_ID
    }, sort),
    classes: _allClasses["default"]['class-name']
  };
  ALL_YEARS_PARTICIPATION_TABLE_CONFIG.cols[0] = {
    name: '',
    id: CLASS_ID,
    transform: function transform(row) {
      return row[CLASS_NAME];
    }
  };
  return ALL_YEARS_PARTICIPATION_TABLE_CONFIG;
};
var getTop10ParticipationTableConfig = exports.getTop10ParticipationTableConfig = function getTop10ParticipationTableConfig(_ref4) {
  var _ref4$isNewCertificat = _ref4.isNewCertificatesExpanded,
    isNewCertificatesExpanded = _ref4$isNewCertificat === void 0 ? false : _ref4$isNewCertificat,
    _ref4$isPastCertifica = _ref4.isPastCertificatesExpanded,
    isPastCertificatesExpanded = _ref4$isPastCertifica === void 0 ? false : _ref4$isPastCertifica;
  var TOP_TEN_PARTICIPATION_TABLE_CONFIG = (0, _cloneDeep["default"])(_objectSpread(_objectSpread({}, getAllClassesParticipationTableConfig({
    isNewCertificatesExpanded: isNewCertificatesExpanded,
    isPastCertificatesExpanded: isPastCertificatesExpanded,
    isTopTen: true
  })), {}, {
    defaultSort: TOTAL_POINTS
  }));
  TOP_TEN_PARTICIPATION_TABLE_CONFIG.colGroups[0][0] = _objectSpread(_objectSpread({}, TOP_TEN_PARTICIPATION_TABLE_CONFIG.colGroups[0][0]), {}, {
    name: 'Export - Top Students'
  });
  var yearColGroup = {
    colIds: [YEAR_GROUP],
    name: 'Label - Year',
    sort: _objectSpread({
      colId: YEAR_GROUP
    }, sort),
    classes: "".concat(_allClasses["default"]['year-group'], " ").concat(_allClasses["default"].small)
  };
  var yearCol = {
    id: YEAR_GROUP,
    name: ''
  };
  TOP_TEN_PARTICIPATION_TABLE_CONFIG.colGroups[0].splice(1, 0, yearColGroup);
  TOP_TEN_PARTICIPATION_TABLE_CONFIG.cols.splice(1, 0, yearCol);
  return TOP_TEN_PARTICIPATION_TABLE_CONFIG;
};
var ALL_CLASSES_USAGE_TABLE_CONFIG = exports.ALL_CLASSES_USAGE_TABLE_CONFIG = {
  cols: [{
    id: SIGN_INS,
    name: 'Header - Sign-ins'
  }, {
    id: TIME_ONLINE,
    name: 'Header - TimeOnline',
    transform: function transform(row) {
      var _row$totalTimeOnline = row.totalTimeOnline,
        hours = _row$totalTimeOnline.hours,
        minutes = _row$totalTimeOnline.minutes;
      return "".concat(hours, "h ").concat(minutes, "min");
    }
  }, {
    id: TOTAL_ACTIVITY_POINTS,
    name: 'Points - Activity'
  }, {
    id: TOTAL_SKILL_QUESTS_POINTS,
    name: 'Points - Skill'
  }, {
    id: TOTAL_LIVE_POINTS,
    name: 'Header - LivePoints'
  }]
};

/***/ }),

/***/ "X3Xz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _certificatesActions = __webpack_require__("PLdC");
var initialState = [];

/**
 * Class List Reducer
 *
 * Consumes GEM_COUNTS_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _certificatesActions.GEM_COUNTS_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "X5f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _subHeadingHeader = _interopRequireDefault(__webpack_require__("WjkK"));
var _filterConstants = __webpack_require__("cdWI");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _subHeadingHelpers = __webpack_require__("bHq3");
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable prettier/prettier */
var SubHeadingHeader = function SubHeadingHeader(_ref) {
  var isModal = _ref.isModal;
  var _window = window,
    i18n = _window.i18n;
  var activeFilters = (0, _reactRedux.useSelector)(function (state) {
    return _activeFiltersSelectors["default"].selectActiveFilters(state);
  });
  var academicYear = (0, _reactRedux.useSelector)(function (state) {
    return state.academicYear;
  });
  var isAdmin = (0, _reactRedux.useSelector)(function (state) {
    return state.isAdmin;
  });
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    label = _useState2[0],
    setLabel = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    dateRange = _useState4[0],
    setDateRange = _useState4[1];
  var getTitleNames = function getTitleNames() {
    return {
      className: activeFilters[_filterConstants.SELECTED_CLASS].name,
      groupName: activeFilters[_filterConstants.SELECTED_GROUP].name,
      studentName: activeFilters[_filterConstants.SELECTED_STUDENT].name,
      yearGroup: activeFilters[_filterConstants.SELECTED_YEAR_GROUP].name,
      teacherName: activeFilters[_filterConstants.SELECTED_TEACHER].name
    };
  };
  var getLabelText = function getLabelText() {
    var _getTitleNames = getTitleNames(),
      className = _getTitleNames.className,
      groupName = _getTitleNames.groupName,
      studentName = _getTitleNames.studentName,
      yearGroup = _getTitleNames.yearGroup,
      teacherName = _getTitleNames.teacherName;
    var updatedLabel = '';
    if (isAdmin) {
      if (yearGroup === _filterConstants.ALL_YEARS && teacherName === _filterConstants.ALL_TEACHERS) {
        updatedLabel = "".concat((0, _localeHelpers.translate)(_filterConstants.ALL_YEARS_TRANS), " | ").concat((0, _localeHelpers.translate)(_filterConstants.ALL_TEACHERS_TRANS));
      } else if (yearGroup === _filterConstants.ALL_YEARS && teacherName !== _filterConstants.ALL_TEACHERS) {
        updatedLabel = "".concat((0, _localeHelpers.translate)(_filterConstants.ALL_YEARS_TRANS), " | ").concat(teacherName);
      } else if (yearGroup !== _filterConstants.ALL_YEARS && teacherName === _filterConstants.ALL_TEACHERS) {
        updatedLabel = "".concat(yearGroup, " | ").concat((0, _localeHelpers.translate)(_filterConstants.ALL_TEACHERS_TRANS));
      } else {
        updatedLabel = "".concat(yearGroup, " | ").concat(teacherName);
      }
    }
    updatedLabel = updatedLabel || _filterConstants.ALL_CLASSES;
    if (className && className !== _filterConstants.ALL_CLASSES) {
      updatedLabel = className;
    }
    if (groupName && groupName !== _filterConstants.ALL_GROUPS) {
      updatedLabel = "".concat(updatedLabel, " | ").concat(groupName);
    }
    if (studentName && studentName !== _filterConstants.ALL_STUDENTS) {
      updatedLabel = studentName;
    }
    return updatedLabel;
  };
  var getTranslatedLabel = function getTranslatedLabel(translatedLabel) {
    if (translatedLabel === _filterConstants.ALL_CLASSES) {
      var key = "Report Filters - ".concat(translatedLabel);
      return i18n._(key);
    }
    return translatedLabel;
  };
  (0, _react.useEffect)(function () {
    if (isAdmin !== null) {
      var updatedLabel = getLabelText();
      var updatedDateRange = (0, _subHeadingHelpers.getDateRange)(activeFilters[_filterConstants.SELECTED_DATE], academicYear);
      setLabel(getTranslatedLabel(updatedLabel));
      setDateRange(updatedDateRange);
    }
  }, [activeFilters, isAdmin, academicYear]);
  return isModal ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _subHeadingHeader["default"].subheader
  }, /*#__PURE__*/_react["default"].createElement("div", null, label, " | ", dateRange)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _subHeadingHeader["default"].header
  }, /*#__PURE__*/_react["default"].createElement("h2", null, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: _subHeadingHeader["default"]['date-range']
  }, dateRange));
};
SubHeadingHeader.propTypes = {
  isModal: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_subHeadingHeader["default"])(SubHeadingHeader);

/***/ }),

/***/ "XKLp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOTAL_ACTIVITIES = exports.TOPIC_RESULTS = exports.TOPIC_NAME = exports.TEST_RESULTS_TABLE_CONFIG = exports.TEST_RESULTS_TAB = exports.TEST_ATTEMPTS = exports.TABLE_TABS = exports.CLASS_NAME = exports.ALL_RESULTS_TABLE_CONFIG = exports.ALL_RESULTS_TAB = exports.ACTIVITY_RESULTS = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _pick = _interopRequireDefault(__webpack_require__("w9Mt"));
var _activityStatusBar = _interopRequireDefault(__webpack_require__("jJ7R"));
var _activityPercentageBar = _interopRequireDefault(__webpack_require__("NtCD"));
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _student = _interopRequireDefault(__webpack_require__("itiU"));
var _localeHelpers = __webpack_require__("rjLd");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ALL_RESULTS_TAB = exports.ALL_RESULTS_TAB = 0;
var TEST_RESULTS_TAB = exports.TEST_RESULTS_TAB = 1;
var TOPIC_NAME = exports.TOPIC_NAME = 'name';
var TOPIC_RESULTS = exports.TOPIC_RESULTS = 'topicActivityResults';
var TOTAL_ACTIVITIES = exports.TOTAL_ACTIVITIES = 'totalActivities';
var ACTIVITY_NAME = 'name';
var ACTIVITY_RESULTS = exports.ACTIVITY_RESULTS = 'result';
var ACTIVITY_ATTEMPTS = 'attempts';
var NUM_ACTIVITIES_ID = 'numActivities';
var TABLE_TABS = exports.TABLE_TABS = 'tableTabs';
var NUM_ATTEMPTS_ID = 'numAttempts';
var TEST_ATTEMPTS = exports.TEST_ATTEMPTS = 'attempts';
var TEST_RESULTS = 'result';
var TABLE_TITLE = 'tableTitle';
var CLASS_NAME = exports.CLASS_NAME = 'className';

/**
 * Config for the 'All results' tab of the student activity mastery table
 */
var ALL_RESULTS_TABLE_CONFIG = exports.ALL_RESULTS_TABLE_CONFIG = {
  colGroups: generateColGroups([TOPIC_NAME, TOPIC_RESULTS, TOTAL_ACTIVITIES], {
    id: NUM_ACTIVITIES_ID,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.NUM_ACTIVITIES),
    doTranslation: true
  }),
  cols: [{
    id: TOPIC_NAME,
    name: '',
    // this is set to course name in Student component
    truncate: true,
    headerTruncate: true,
    classes: _student["default"]['topic-name']
  }, {
    id: TOPIC_RESULTS,
    name: _filterConstants.RESULTS,
    classes: _student["default"]['activity-results'],
    headerTransform: function headerTransform() {
      return null;
    },
    // this is set to use ActivityStatusBar in the Student component
    transform: function transform(row) {
      var activityMastery = (0, _pick["default"])(row, ['scoreBand', 'goldBars', 'totalActivities']);
      return /*#__PURE__*/_react["default"].createElement(_activityStatusBar["default"], {
        activityMastery: activityMastery
      });
    }
  }, {
    id: TOTAL_ACTIVITIES,
    name: '',
    // this is set to total number of activities in the course in Student component
    transform: function transform(row) {
      var totalActivities = row.totalActivities;
      if (row.totalAssignedActivities) {
        totalActivities += " (".concat(row.totalAssignedActivities, ")");
      }
      return totalActivities;
    }
  }],
  nestedData: {
    id: 'activityResultDetails',
    showHeaders: true,
    collapse: {
      enable: true,
      expandedClass: _student["default"].expanded
    },
    cols: [{
      name: (0, _localeHelpers.getTranslationKey)(_filterConstants.ACTIVITY),
      doTranslation: true,
      id: ACTIVITY_NAME,
      classes: _student["default"]['activity-name'],
      truncate: true
    }, {
      name: (0, _localeHelpers.getTranslationKey)(_filterConstants.RESULTS),
      doTranslation: true,
      id: ACTIVITY_RESULTS,
      classes: _student["default"]['activity-results'],
      transform: function transform(row) {
        return /*#__PURE__*/_react["default"].createElement(_activityPercentageBar["default"], {
          hasGoldBar: row.hasGoldBar,
          percentage: row.result
        });
      }
    }, {
      name: (0, _localeHelpers.getTranslationKey)(_filterConstants.ATTEMPTS),
      doTranslation: true,
      id: ACTIVITY_ATTEMPTS,
      classes: _student["default"].attempts
    }]
  },
  emptyDataMessage: 'No results found'
};

/**
 * Config for the 'Test results' tab of the student activity mastery table
 */
var TEST_RESULTS_TABLE_CONFIG = exports.TEST_RESULTS_TABLE_CONFIG = {
  colGroups: generateColGroups([TOPIC_NAME, TEST_RESULTS, TEST_ATTEMPTS], {
    id: NUM_ATTEMPTS_ID,
    name: 'NO. OF ATTEMPTS',
    doTranslation: true
  }),
  cols: [{
    id: TOPIC_NAME,
    name: '',
    // this is set to course name in Student component
    truncate: true,
    headerTruncate: true,
    classes: _student["default"]['test-topic-name']
  }, {
    id: TEST_RESULTS,
    classes: _student["default"]['test-results'],
    transform: function transform(row) {
      return /*#__PURE__*/_react["default"].createElement(_activityPercentageBar["default"], {
        hasGoldBar: row.hasGoldBar,
        percentage: row.result
      });
    }
  }, {
    id: TEST_ATTEMPTS,
    name: '',
    // this is set to total number of attempts in Student component
    classes: _student["default"]['total-activities']
  }],
  nestedData: {
    collapse: {
      enable: true
    }
  },
  emptyDataMessage: 'No test results found'
};

/**
 * Generates the colGroup config for the All results/Test results table config
 * Uses provided cols to assign cols to a col group and adds the totalColGroup as the last col group
 * in the first col group row
 */
function generateColGroups(cols, totalColGroup) {
  return [[{
    id: TABLE_TITLE,
    name: 'Activity Mastery',
    headerTransform: function headerTransform() {
      return /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: "Table Header - Activity Mastery",
        translate: true
      });
    },
    colIds: [cols[0], cols[1]]
  }, _objectSpread(_objectSpread({}, totalColGroup), {}, {
    colIds: [cols[2]],
    classes: _student["default"]['total-activities']
  })], [{
    id: CLASS_NAME,
    name: '',
    // this is set to the class name in Student component
    truncate: true,
    headerTruncate: true,
    classes: _student["default"]['class-name'],
    colIds: [cols[0]]
  }, {
    id: TABLE_TABS,
    name: 'Table Tabs',
    classes: _student["default"]['table-tabs'],
    colIds: [cols[1], cols[2]],
    headerTransform: function headerTransform() {
      return null;
    } // this is set in Student component
  }]];
}

/***/ }),

/***/ "Xepm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOTAL_ACTIVITIES = exports.CLASS_NAME = exports.CLASS_ID = exports.ALL_YEARS_TABLE_CONFIG = exports.ALL_CLASSES_TABLE_CONFIG = exports.ACTIVITY_RESULTS = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _allClasses = _interopRequireDefault(__webpack_require__("jf7A"));
var _activityStatusBar = _interopRequireDefault(__webpack_require__("jJ7R"));
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _localeHelpers = __webpack_require__("rjLd");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CLASS_ID = exports.CLASS_ID = 'id';
var CLASS_NAME = exports.CLASS_NAME = 'name';
var ACTIVITY_RESULTS = exports.ACTIVITY_RESULTS = 'activityMastery';
var TOTAL_ACTIVITIES = exports.TOTAL_ACTIVITIES = 'activityMastery.totalActivities';
var ALL_CLASSES_TABLE_CONFIG = exports.ALL_CLASSES_TABLE_CONFIG = {
  cols: [{
    id: CLASS_NAME,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.ALL_CLASSES),
    doTranslation: true,
    sort: {
      sortAs: 'string'
    },
    classes: _allClasses["default"]['class-name'],
    truncate: true,
    onClick: function onClick() {
      return null;
    } // this is set in the AllClasses component
  }, {
    id: ACTIVITY_RESULTS,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.RESULTS),
    doTranslation: true,
    classes: _allClasses["default"].results,
    headerTransform: function headerTransform() {
      return null;
    },
    // this is set in the AllClasses component
    transform: function transform(row) {
      return /*#__PURE__*/_react["default"].createElement(_activityStatusBar["default"], {
        activityMastery: row.activityMastery
      });
    }
  }, {
    id: TOTAL_ACTIVITIES,
    name: '' // this is set in the AllClasses component
  }],
  colGroups: [[{
    name: _filterConstants.ACTIVITY_MASTERY,
    headerTransform: function headerTransform() {
      return /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: (0, _localeHelpers.getTranslationKey)(_filterConstants.ACTIVITY_MASTERY),
        translate: true
      });
    },
    colIds: [CLASS_NAME, ACTIVITY_RESULTS]
  }, {
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.NUM_ACTIVITIES),
    colIds: [TOTAL_ACTIVITIES],
    doTranslation: true,
    classes: "text-center ".concat(_allClasses["default"]['total-activities'])
  }]],
  defaultSort: CLASS_NAME
};
var ALL_YEARS_TABLE_CONFIG = exports.ALL_YEARS_TABLE_CONFIG = (0, _cloneDeep["default"])(_objectSpread(_objectSpread({}, ALL_CLASSES_TABLE_CONFIG), {}, {
  defaultSort: CLASS_ID
}));
ALL_YEARS_TABLE_CONFIG.cols[0] = _objectSpread(_objectSpread({}, ALL_YEARS_TABLE_CONFIG.cols[0]), {}, {
  name: (0, _localeHelpers.getTranslationKey)(_filterConstants.ALL_YEARS),
  doTranslation: true,
  id: CLASS_ID,
  transform: function transform(row) {
    return row[CLASS_NAME];
  },
  sort: {
    sortAs: 'number'
  }
});

/***/ }),

/***/ "XiXD":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bGE9");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./single-class.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./single-class.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XvdY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1ug1F {\n  height: calc(100% - 135px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .component---1ug1F .data-table---3jjE6 {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 70%;\n            flex: 1 1 70%; }\n  .component---1ug1F .data-table---3jjE6 table {\n      width: calc(100% - 2px); }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 0;\n      background-color: white;\n      font-weight: 500;\n      color: #4e5c67;\n      height: 47px; }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th {\n        border: none;\n        background: none;\n        font-weight: normal;\n        font-size: 12px;\n        white-space: nowrap; }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th::after, .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th::before {\n          content: '';\n          position: absolute;\n          left: 0;\n          width: 100%; }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th::before {\n          top: -1px;\n          border-top: 1px solid #e5e5e5;\n          pointer-events: none; }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th::after {\n          bottom: -1px;\n          border-bottom: 2px solid #e5e5e5;\n          pointer-events: none; }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th::before {\n          left: -1px;\n          height: 46px;\n          border-left: 1px solid white;\n          border-right: 1px solid white; }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th::after {\n          height: 46px;\n          border-left: 1px solid white;\n          right: 1px; }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th:first-of-type {\n          font-size: 18px;\n          text-align: left; }\n  .component---1ug1F .data-table---3jjE6 thead tr:last-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 47px;\n      background-color: #e4eaef;\n      color: #278bcb;\n      font-weight: 600; }\n  .component---1ug1F .data-table---3jjE6 thead tr:last-of-type th::after, .component---1ug1F .data-table---3jjE6 thead tr:last-of-type th::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        width: 100%; }\n  .component---1ug1F .data-table---3jjE6 thead tr:last-of-type th::before {\n        top: -1px;\n        border-top: 1px solid #e5e5e5;\n        pointer-events: none; }\n  .component---1ug1F .data-table---3jjE6 thead tr:last-of-type th::after {\n        bottom: -1px;\n        border-bottom: 2px solid #e5e5e5;\n        pointer-events: none; }\n  .component---1ug1F .data-table---3jjE6 thead tr:first-of-type th:last-of-type {\n      font-size: 12px; }\n  .component---1ug1F .data-table---3jjE6 .class-name---3tZYt svg path,\n    .component---1ug1F .data-table---3jjE6 .group-name---3-roI svg path {\n      fill: #788189 !important; }\n  .component---1ug1F .data-table---3jjE6 .group-name---3-roI,\n    .component---1ug1F .data-table---3jjE6 .student-name---3laYT {\n      width: 30%;\n      max-width: 150px;\n      text-align: left; }\n  .component---1ug1F .data-table---3jjE6 .course-name---3SY5e {\n      width: 55%; }\n  .component---1ug1F .data-table---3jjE6 .total-activities---2DD_u {\n      width: 15%;\n      font-size: 16px; }\n  .component---1ug1F .data-table---3jjE6 .activity-results---3p_wu {\n      width: 70%;\n      padding: 0; }\n  .component---1ug1F .data-table---3jjE6 thead .course-name---3SY5e {\n      padding: 0; }\n  .component---1ug1F .data-table---3jjE6 tbody .group-name---3-roI,\n    .component---1ug1F .data-table---3jjE6 tbody .course-name---3SY5e,\n    .component---1ug1F .data-table---3jjE6 tbody .total-activities---2DD_u {\n      background-color: #eef2f5; }\n  .component---1ug1F .data-table---3jjE6 tbody .group-name---3-roI {\n      font-weight: 600; }\n  .component---1ug1F .strength-weakness---2J708 {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 30%;\n            flex: 1 1 30%;\n    padding-left: 20px;\n    text-align: left; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1ug1F",
	"data-table": "data-table---3jjE6",
	"class-name": "class-name---3tZYt",
	"group-name": "group-name---3-roI",
	"student-name": "student-name---3laYT",
	"course-name": "course-name---3SY5e",
	"total-activities": "total-activities---2DD_u",
	"activity-results": "activity-results---3p_wu",
	"strength-weakness": "strength-weakness---2J708"
};

/***/ }),

/***/ "YPw6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SingleClass = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _singleClass = _interopRequireDefault(__webpack_require__("XiXD"));
var _exportReportActions = _interopRequireDefault(__webpack_require__("oXgP"));
var _singleClassActions = _interopRequireWildcard(__webpack_require__("9vuV"));
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _singleClassConstants = _interopRequireDefault(__webpack_require__("kS0t"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _skillQuestsMasteryHelpers = __webpack_require__("sO+K");
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _subHeadingButtons = _interopRequireDefault(__webpack_require__("Tiy6"));
var _skillQuestsMasteryLegends = _interopRequireDefault(__webpack_require__("n/+0"));
var _assignmentResult = _interopRequireDefault(__webpack_require__("kQOT"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SingleClass = exports.SingleClass = /*#__PURE__*/function (_Component) {
  function SingleClass(_props) {
    var _this;
    _classCallCheck(this, SingleClass);
    _this = _callSuper(this, SingleClass, [_props]);
    /**
     * ON PROPS CHANGE HANDLERS
     */
    _defineProperty(_this, "onParamChange", function (props, newProps) {
      var activeFilters = props.activeFilters,
        assignmentResultType = props.assignmentResultType;
      var newActiveFilters = newProps.activeFilters,
        newAssignmentResultType = newProps.assignmentResultType;
      var shouldReload = _filterHelper["default"].shouldReloadSingleClass(activeFilters, newActiveFilters) || assignmentResultType !== newAssignmentResultType;
      if (shouldReload) {
        _this.props.getClassSkillQuestsMasteryData(newActiveFilters[_filterConstants.SELECTED_CLASS].id, newActiveFilters[_filterConstants.SELECTED_DATE], newAssignmentResultType);
      }
    });
    _defineProperty(_this, "onDataChange", function (props, newProps) {
      var skillQuestsMasterySingleClass = props.skillQuestsMasterySingleClass;
      var newSkillQuestsMasterySingleClass = newProps.skillQuestsMasterySingleClass;
      if (skillQuestsMasterySingleClass !== newSkillQuestsMasterySingleClass) {
        _this.setTableConfig(newProps);
      }
    });
    /**
     * SETUP TABLE CONFIG
     */
    _defineProperty(_this, "navigateToStudentLevel", function (filterName, selectedItem) {
      _this.props.updateActiveFilter(filterName, {
        id: selectedItem.id,
        name: selectedItem.name
      });
    });
    _defineProperty(_this, "tableConfigTranslations", function (updatedTableConfig) {
      var i18n = window.i18n;
      updatedTableConfig.cols.find(function (col) {
        return col.id === _skillQuestsMasteryConstants.GROUP_NAME.id;
      }).name = (0, _skillQuestsMasteryHelpers.manageTranslation)(_skillQuestsMasteryConstants.GROUP_NAME, i18n);
      (0, _skillQuestsMasteryHelpers.translateTableContent)(i18n, updatedTableConfig);
      return updatedTableConfig;
    });
    _defineProperty(_this, "updateTableConfigBody", function (updatedTableConfig) {
      var selectedClassId = _this.props.selectedClassId;
      var i18n = window.i18n;
      updatedTableConfig = (0, _skillQuestsMasteryHelpers.alignSingleClassTableConfigBody)(updatedTableConfig);
      updatedTableConfig = (0, _skillQuestsMasteryHelpers.updateTableConfigTransformById)(_skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id, function (row) {
        return (0, _skillQuestsMasteryHelpers.renderCompletedQuestsGroupLevel)(row, selectedClassId, i18n);
      }, updatedTableConfig);
      updatedTableConfig = (0, _skillQuestsMasteryHelpers.updateTableConfigTransformById)(_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id, function (row) {
        return (0, _skillQuestsMasteryHelpers.manageEmptyGroup)(row, (0, _skillQuestsMasteryHelpers.manageHeaderValue)(row[_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id]));
      }, updatedTableConfig);
      updatedTableConfig = (0, _skillQuestsMasteryHelpers.updateTableConfigTransformById)(_skillQuestsMasteryConstants.COMPLETED_QUESTS.id, function (row) {
        return (0, _skillQuestsMasteryHelpers.manageEmptyGroup)(row, (0, _skillQuestsMasteryHelpers.manageHeaderValue)(row[_skillQuestsMasteryConstants.COMPLETED_QUESTS.id]));
      }, updatedTableConfig);
      updatedTableConfig = _this.tableConfigTranslations(updatedTableConfig);
      return updatedTableConfig;
    });
    _defineProperty(_this, "updateTableConfigNested", function (updatedTableConfig) {
      updatedTableConfig = (0, _skillQuestsMasteryHelpers.alignTableConfigNested)(updatedTableConfig);
      updatedTableConfig.nestedData.cols.find(function (col) {
        return col.id === _skillQuestsMasteryConstants.STUDENT_FULL_NAME.id;
      }).onClick = function (selectedStudent) {
        return _this.navigateToStudentLevel(_filterConstants.SELECTED_STUDENT, selectedStudent);
      };
      return updatedTableConfig;
    });
    _defineProperty(_this, "setTableConfig", function (props) {
      var skillQuestsMasterySingleClass = props.skillQuestsMasterySingleClass;
      var updatedTableConfig = (0, _cloneDeep["default"])(_singleClassConstants["default"]);
      if (skillQuestsMasterySingleClass) {
        updatedTableConfig = (0, _skillQuestsMasteryHelpers.alignTableConfigHeader)(skillQuestsMasterySingleClass, updatedTableConfig);
        updatedTableConfig = _this.updateTableConfigBody(updatedTableConfig);
        updatedTableConfig = _this.updateTableConfigNested(updatedTableConfig);
      }
      _this.setState({
        tableConfig: updatedTableConfig
      });
    });
    _defineProperty(_this, "getTableData", function () {
      var _this$props = _this.props,
        activeFilters = _this$props.activeFilters,
        skillQuestsMasterySingleClass = _this$props.skillQuestsMasterySingleClass;
      var selectedGroupId = activeFilters[_filterConstants.SELECTED_GROUP].id;
      if (selectedGroupId !== _filterConstants.ALL_GROUPS) {
        return skillQuestsMasterySingleClass.groups.filter(function (group) {
          return group.id === selectedGroupId;
        });
      }
      return skillQuestsMasterySingleClass.groups;
    });
    _this.state = {
      tableConfig: _singleClassConstants["default"]
    };
    return _this;
  }
  _inherits(SingleClass, _Component);
  return _createClass(SingleClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        activeFilters = _this$props2.activeFilters,
        assignmentResultType = _this$props2.assignmentResultType;
      if (_filterHelper["default"].shouldLoadSingleClass(activeFilters)) {
        this.props.getClassSkillQuestsMasteryData(activeFilters[_filterConstants.SELECTED_CLASS].id, activeFilters[_filterConstants.SELECTED_DATE], assignmentResultType);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this.onParamChange(this.props, newProps);
      this.onDataChange(this.props, newProps);
      (0, _skillQuestsMasteryHelpers.onInvalidRequest)(this.props, newProps, _singleClassActions.SKILL_QUESTS_MASTERY_CLASS_RETRIEVED);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        downloadStudentReport = _this$props3.downloadStudentReport,
        exportReport = _this$props3.exportReport,
        isProcessingDownload = _this$props3.isProcessingDownload,
        skillQuestsMasterySingleClass = _this$props3.skillQuestsMasterySingleClass;
      var tableConfig = this.state.tableConfig;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"]['sqm-single-class']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"]['sub-heading']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"]['right-side']
      }, /*#__PURE__*/_react["default"].createElement(_skillQuestsMasteryLegends["default"], {
        variant: _skillQuestsMasteryConstants.SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS.CLASS_GROUP_LEVEL
      }), /*#__PURE__*/_react["default"].createElement(_assignmentResult["default"], null), /*#__PURE__*/_react["default"].createElement(_subHeadingButtons["default"], {
        isDownloadEnabled: true,
        isExportEnabled: true,
        isProcessingDownload: isProcessingDownload,
        onExportReport: exportReport,
        onDownloadReport: downloadStudentReport
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"]['data-table']
      }, skillQuestsMasterySingleClass && /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: tableConfig,
        data: this.getTableData()
      })));
    }
  }]);
}(_react.Component);
_defineProperty(SingleClass, "propTypes", {
  // redux filter values
  activeFilters: _filterPropTypes.activeFiltersPropType,
  // Download report handler
  downloadStudentReport: _propTypes["default"].func,
  // Export report handler
  exportReport: _propTypes["default"].func,
  // Init data service request
  getClassSkillQuestsMasteryData: _propTypes["default"].func,
  // Is requesting download report
  isProcessingDownload: _propTypes["default"].bool,
  // Manages active filter redux values
  updateActiveFilter: _propTypes["default"].func,
  // Active filters selected class id
  selectedClassId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  // BE Data for skill quests mastery classes
  skillQuestsMasterySingleClass: _propTypes["default"].object,
  // Assignment result filter
  assignmentResultType: _propTypes["default"].number
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    selectedClassId: _activeFiltersSelectors["default"].selectClassId(state),
    invalidRequest: state.invalidRequest,
    isProcessingDownload: state.downloadReport.isProcessingDownload,
    skillQuestsMasterySingleClass: state.skillQuestsMasterySingleClass.data,
    assignmentResultType: state.assignmentResultType
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    exportReport: _exportReportActions["default"].exportReport,
    downloadStudentReport: _exportReportActions["default"].downloadStudentReport,
    getClassSkillQuestsMasteryData: _singleClassActions["default"].getClassSkillQuestsMasteryData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_singleClass["default"])(SingleClass));

/***/ }),

/***/ "Z9lH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM = exports.SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE = exports.SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED = exports.SKILL_QUESTS_MASTERY_STUDENT_RESET = exports.SKILL_QUESTS_MASTERY_STUDENT_REQUEST = exports.SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED = exports.SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST = exports.SKILL_QUESTS_MASTERY_IS_FILTERED = void 0;
exports.getStudentSkillQuestsMasteryData = getStudentSkillQuestsMasteryData;
exports.getStudentSkillQuestsMasteryDataCourse = getStudentSkillQuestsMasteryDataCourse;
exports.manageStudentData = manageStudentData;
exports.resetStudentData = resetStudentData;
exports.setSelectedCourse = setSelectedCourse;
exports.setSelectedPublication = setSelectedPublication;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _constants = __webpack_require__("1QGX");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _utils = __webpack_require__("6QRH");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * ACTION TYPES
 */
var SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED = exports.SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED = 'SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED';
var SKILL_QUESTS_MASTERY_STUDENT_REQUEST = exports.SKILL_QUESTS_MASTERY_STUDENT_REQUEST = 'SKILL_QUESTS_MASTERY_STUDENT_REQUEST';
var SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED = exports.SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED = 'SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED';
var SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST = exports.SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST = 'SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST';
var SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM = exports.SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM = 'SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM';
var SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE = exports.SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE = 'SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE';
var SKILL_QUESTS_MASTERY_STUDENT_RESET = exports.SKILL_QUESTS_MASTERY_STUDENT_RESET = 'SKILL_QUESTS_MASTERY_STUDENT_RESET';
var SKILL_QUESTS_MASTERY_IS_FILTERED = exports.SKILL_QUESTS_MASTERY_IS_FILTERED = 'SKILL_QUESTS_MASTERY_IS_FILTERED';

/**
 * CONSTANTS
 */
var ID_SELECTOR = 'id';

/**
 * SERVICE REQUESTS
 */
function getStudentSkillQuestsMasteryData(classroomId, studentProfileId, selectedDateFilter, assignmentResultType) {
  return function (dispatch) {
    dispatch({
      type: SKILL_QUESTS_MASTERY_STUDENT_REQUEST
    });
    _resources["default"].studentReport.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_SKILL_QUESTS_MASTERY
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId,
      userProfileId: studentProfileId
    })).withParams(_objectSpread(_objectSpread({}, _dateParamHelper["default"].getDateQueryParams(selectedDateFilter)), {}, {
      courseId: null,
      assignmentResultType: assignmentResultType
    })).send().then(function (payload) {
      if (payload.valid) {
        var _payload$data = payload.data,
          selectedCourseId = _payload$data.selectedCourseId,
          selectedPublicationCourseId = _payload$data.selectedPublicationCourseId;
        dispatch({
          type: SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED,
          payload: manageStudentData(payload.data, dispatch)
        });
        dispatch(setIsFiltered(selectedCourseId, selectedPublicationCourseId));
      } else {
        dispatch(_errorsActions["default"].addError(SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED));
      }
    });
  };
}
function getStudentSkillQuestsMasteryDataCourse(classroomId, studentProfileId, selectedDateFilter, courseId, courseVersion, assignmentResultType) {
  return function (dispatch) {
    dispatch({
      type: SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST
    });
    _resources["default"].studentReportCourse.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_SKILL_QUESTS_MASTERY
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId,
      userProfileId: studentProfileId
    })).withParams(_objectSpread(_objectSpread({}, _dateParamHelper["default"].getDateQueryParams(selectedDateFilter)), {}, {
      courseId: courseId,
      courseVersion: courseVersion,
      assignmentResultType: assignmentResultType
    })).send().then(function (payload) {
      if (payload.valid) {
        dispatch({
          type: SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED,
          payload: payload.data
        });
        dispatch(setIsFiltered(courseId, courseVersion));
      } else {
        dispatch(_errorsActions["default"].addError(SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED));
      }
    });
  };
}

/**
 * ACTIONS
 */
function setIsFiltered(courseId, courseVersion) {
  var updatedIsFiltered = courseId !== null && courseVersion !== null;
  return function (dispatch) {
    dispatch({
      type: SKILL_QUESTS_MASTERY_IS_FILTERED,
      payload: updatedIsFiltered
    });
  };
}
function setSelectedPublication(data, selectedId) {
  return function (dispatch) {
    var selected = data.find(function (value) {
      return value.id === selectedId;
    });
    if (!selected) {
      selected = data[0];
    }
    dispatch({
      type: SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM,
      payload: {
        data: data,
        selected: selected
      }
    });
  };
}
function setSelectedCourse(data, selectedId) {
  return function (dispatch) {
    var selected = data.find(function (value) {
      return value.id === selectedId;
    });
    if (!selected) {
      selected = data[0];
    }
    dispatch({
      type: SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE,
      payload: {
        data: data,
        selected: selected
      }
    });
  };
}
function resetStudentData() {
  return function (dispatch) {
    dispatch({
      type: SKILL_QUESTS_MASTERY_STUDENT_RESET
    });
  };
}

/**
 * ACTION HELPERS
 */
function manageDropdownDefaultValues(data) {
  data.publicationCourses.map(function (publication) {
    publication.value = publication.id;
    publication.label = publication.name;
    publication.courses.map(function (course) {
      course.value = course.id;
      course.label = course.name;
      return course;
    });
    return publication;
  });
  return data;
}
function managePublication(data, selectedPublicationCourseId) {
  data = manageDropdownDefaultValues(data);
  data.publicationCourses = (0, _utils.moveItemToFrontArray)(data.publicationCourses, ID_SELECTOR, selectedPublicationCourseId);
  return data;
}
function manageCourse(data, selectedPublicationCourseId, selectedCourseId) {
  if (selectedPublicationCourseId && selectedCourseId) {
    data.publicationCourses = (0, _utils.moveItemToFrontArray)(data.publicationCourses, ID_SELECTOR, selectedPublicationCourseId);
    var selectedCourseIndex = data.publicationCourses.findIndex(function (course) {
      return course.id === selectedPublicationCourseId;
    });
    data.publicationCourses[selectedCourseIndex].courses = (0, _utils.moveItemToFrontArray)(data.publicationCourses[selectedCourseIndex].courses, ID_SELECTOR, selectedCourseId);
  }
  return data;
}
function manageStudentData(data, dispatch) {
  var selectedCourseId = data.selectedCourseId,
    selectedPublicationCourseId = data.selectedPublicationCourseId;
  var updatedData = _objectSpread({}, data);
  updatedData = managePublication(updatedData, selectedPublicationCourseId);
  updatedData = manageCourse(updatedData, selectedPublicationCourseId, selectedCourseId);
  dispatch(setSelectedPublication(data.publicationCourses, selectedPublicationCourseId));
  dispatch(setSelectedCourse(data.publicationCourses[0].courses, selectedCourseId));
  return updatedData;
}

/***/ }),

/***/ "ZBNL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SCHOOL_HAS_LIFETIME_DATA = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SCHOOL_HAS_LIFETIME_DATA = exports.SCHOOL_HAS_LIFETIME_DATA = 'SCHOOL_HAS_LIFETIME_DATA';
function getHasLifetimeData() {
  return function (dispatch) {
    return _resources["default"].hasLifetimeData.get().send().then(function (payload) {
      if (payload.data === true) {
        dispatch({
          type: SCHOOL_HAS_LIFETIME_DATA,
          payload: true
        });
      } else {
        dispatch({
          type: SCHOOL_HAS_LIFETIME_DATA,
          payload: false
        });
      }
    });
  };
}
var _default = exports["default"] = {
  getHasLifetimeData: getHasLifetimeData
};

/***/ }),

/***/ "ZeRC":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("uN3G");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./header-toggle.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./header-toggle.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "a+f/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9XUN");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./certificate-display.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./certificate-display.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "aCEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _strengthAndWeaknessesConstants = __webpack_require__("EaW9");
var _strengthWeaknessTab = _interopRequireDefault(__webpack_require__("/wMX"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays Strengths & Weaknesses tabs and tables for classes or year groups
 * Used in All Classes view and in all admin views (All Years, One Year All Teachers, etc.)
 */
var AllClassesStrengthWeakness = /*#__PURE__*/function (_PureComponent) {
  function AllClassesStrengthWeakness(props) {
    var _this;
    _classCallCheck(this, AllClassesStrengthWeakness);
    _this = _callSuper(this, AllClassesStrengthWeakness, [props]);
    _defineProperty(_this, "getTableConfig", function (selectedTab, tableConfig) {
      var config = (0, _cloneDeep["default"])(tableConfig);
      config.cols.find(function (col) {
        return col.id === _strengthAndWeaknessesConstants.TITLE;
      }).name = selectedTab === _strengthAndWeaknessesConstants.STRENGTH_TAB ? (0, _localeHelpers.translate)('Label - RelativeStrengths') : (0, _localeHelpers.translate)('Label - RelativeWeaknesses');
      return config;
    });
    _defineProperty(_this, "tabClicked", function (tab) {
      _this.setState({
        currentTab: tab,
        tableConfig: _this.getTableConfig(tab, _this.props.tableConfig)
      });
    });
    _this.state = {
      currentTab: _strengthAndWeaknessesConstants.STRENGTH_TAB,
      tableConfig: _this.getTableConfig(_strengthAndWeaknessesConstants.STRENGTH_TAB, _this.props.tableConfig)
    };
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(AllClassesStrengthWeakness, _PureComponent);
  return _createClass(AllClassesStrengthWeakness, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;
      if (this.props.tableConfig !== newProps.tableConfig) {
        this.setState(function (prevState) {
          return {
            tableConfig: _this2.getTableConfig(prevState.currentTab, newProps.tableConfig)
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        currentTab = _this$state.currentTab,
        tableConfig = _this$state.tableConfig;
      var _this$props = this.props,
        strengths = _this$props.strengths,
        weaknesses = _this$props.weaknesses;
      var isStrengthTab = currentTab === _strengthAndWeaknessesConstants.STRENGTH_TAB;
      return /*#__PURE__*/_react["default"].createElement(_strengthWeaknessTab["default"], {
        isStrengthTab: isStrengthTab,
        onTabClick: this.tabClicked
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: tableConfig,
        data: isStrengthTab ? strengths : weaknesses
      }));
    }
  }]);
}(_react.PureComponent);
_defineProperty(AllClassesStrengthWeakness, "propTypes", {
  tableConfig: _propTypes["default"].object,
  strengths: _propTypes["default"].array,
  weaknesses: _propTypes["default"].array
});
var _default = exports["default"] = AllClassesStrengthWeakness;

/***/ }),

/***/ "aFLC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _studentActions = __webpack_require__("Z9lH");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  isLoading: false,
  data: null,
  selectedCurriculum: null,
  selectedCourse: null,
  isFiltered: false
};

/**
 * Skill Quests Mastery - Student Reducer
 *
 * Consumes SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _studentActions.SKILL_QUESTS_MASTERY_STUDENT_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true,
          data: null
        });
      }
    case _studentActions.SKILL_QUESTS_MASTERY_STUDENT_RETRIEVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        data: action.payload
      });
    case _studentActions.SKILL_QUESTS_MASTERY_STUDENT_COURSE_REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true,
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            reportData: null
          })
        });
      }
    case _studentActions.SKILL_QUESTS_MASTERY_STUDENT_COURSE_RETRIEVED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            reportData: action.payload
          })
        });
      }
    case _studentActions.SKILL_QUESTS_MASTERY_STUDENT_SELECTED_CURRICULUM:
      {
        var _action$payload = action.payload,
          data = _action$payload.data,
          selected = _action$payload.selected;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedPublication: {
            data: data,
            selected: selected
          }
        });
      }
    case _studentActions.SKILL_QUESTS_MASTERY_STUDENT_SELECTED_COURSE:
      {
        var _action$payload2 = action.payload,
          _data = _action$payload2.data,
          _selected = _action$payload2.selected;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedCourse: {
            data: _data,
            selected: _selected
          }
        });
      }
    case _studentActions.SKILL_QUESTS_MASTERY_IS_FILTERED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isFiltered: action.payload
        });
      }
    case _studentActions.SKILL_QUESTS_MASTERY_STUDENT_RESET:
      {
        return initialState;
      }
    default:
      return state;
  }
}

/***/ }),

/***/ "aadW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JZdf");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./sub-heading-buttons.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./sub-heading-buttons.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ad0G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UPDATE_SELECTED_IMPROVEMENT = exports.SET_DEFAULT_SELECTED_IMPROVEMENTS = exports.CLEAR_SELECTED_IMPROVEMENTS = void 0;
var _reduxActions = __webpack_require__("sTbe");
var _studentConstants = __webpack_require__("OCle");
var CLEAR_SELECTED_IMPROVEMENTS = exports.CLEAR_SELECTED_IMPROVEMENTS = 'CLEAR_SELECTED_IMPROVEMENTS';
var SET_DEFAULT_SELECTED_IMPROVEMENTS = exports.SET_DEFAULT_SELECTED_IMPROVEMENTS = 'SET_DEFAULT_SELECTED_IMPROVEMENTS';
var UPDATE_SELECTED_IMPROVEMENT = exports.UPDATE_SELECTED_IMPROVEMENT = 'UPDATE_SELECTED_IMPROVEMENT';
var clearSelectedImprovements = (0, _reduxActions.createAction)(CLEAR_SELECTED_IMPROVEMENTS);
var updateSelectedImprovement = (0, _reduxActions.createAction)(UPDATE_SELECTED_IMPROVEMENT);
function setDefaultSelectedImprovements(topics) {
  var selectedImprovements = {};
  topics.forEach(function (topic) {
    selectedImprovements[topic.id] = _studentConstants.FIRST_VS_LATEST;
  });
  return {
    type: SET_DEFAULT_SELECTED_IMPROVEMENTS,
    payload: selectedImprovements
  };
}
var _default = exports["default"] = {
  clearSelectedImprovements: clearSelectedImprovements,
  updateSelectedImprovement: updateSelectedImprovement,
  setDefaultSelectedImprovements: setDefaultSelectedImprovements
};

/***/ }),

/***/ "agHL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _studentActions = __webpack_require__("gUpq");
var initialState = null;

/**
 * Activity Mastery - Student Reducer
 *
 * Consumes ACTIVITY_MASTERY_STUDENT_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _studentActions.ACTIVITY_MASTERY_STUDENT_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "akO4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Lxao");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./accuracy-graph.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./accuracy-graph.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "awYd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".app---3vTSy {\n  height: 100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.header---3WHby,\n.footer---NcHZ2 {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0; }\n\n.footer---NcHZ2 > * {\n  margin: 0 8px; }\n", ""]);

// exports
exports.locals = {
	"app": "app---3vTSy",
	"header": "header---3WHby",
	"footer": "footer---NcHZ2"
};

/***/ }),

/***/ "bCch":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _icon_tick = _interopRequireDefault(__webpack_require__("r5UY"));
var _icon_up_solid = _interopRequireDefault(__webpack_require__("kPzT"));
var _topLevelFilter = _interopRequireDefault(__webpack_require__("hvkE"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _studentHelpers = __webpack_require__("GejO");
var _contextModal = _interopRequireDefault(__webpack_require__("vuxJ"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * SKILL QUESTS MASTERY TOP LEVEL FILTER
 * -----------------------------------------
 * Manages all right hand side functionality of student skill quests
 */
var TopLevelFilter = /*#__PURE__*/function (_Component) {
  function TopLevelFilter(props) {
    var _this;
    _classCallCheck(this, TopLevelFilter);
    _this = _callSuper(this, TopLevelFilter, [props]);
    _defineProperty(_this, "manageNullDefaultCourse", function (nextProps) {
      var skillQuestsMasteryStudentData = nextProps.skillQuestsMasteryStudentData;
      var hasSetInitialShowAllWorkToggle = _this.state.hasSetInitialShowAllWorkToggle;
      if (skillQuestsMasteryStudentData) {
        var selectedPublicationCourseId = skillQuestsMasteryStudentData.selectedPublicationCourseId,
          selectedCourseId = skillQuestsMasteryStudentData.selectedCourseId;
        var hasDefaultCourse = selectedCourseId && selectedPublicationCourseId;
        if (!hasDefaultCourse && !hasSetInitialShowAllWorkToggle) {
          _this.setState({
            showAllWorkToggle: true,
            hasSetInitialShowAllWorkToggle: true
          });
        }
      }
    });
    /**
     * SHOW ALL WORK
     */
    _defineProperty(_this, "onShowAllWorkClick", function () {
      var showAllWorkToggle = _this.state.showAllWorkToggle;
      var _this$props = _this.props,
        activeFilters = _this$props.activeFilters,
        getStudentSkillQuestsMasteryDataCourse = _this$props.getStudentSkillQuestsMasteryDataCourse,
        assignmentResultType = _this$props.assignmentResultType;
      var updatedShowAllWorkToggle = !showAllWorkToggle;
      _this.setState({
        showAllWorkToggle: updatedShowAllWorkToggle,
        showContextModal: false
      });
      getStudentSkillQuestsMasteryDataCourse(activeFilters[_filterConstants.SELECTED_CLASS].id, activeFilters[_filterConstants.SELECTED_STUDENT].id, activeFilters[_filterConstants.SELECTED_DATE], null, null, assignmentResultType);
    });
    _defineProperty(_this, "getShowAllWorkButtonProps", function () {
      var showAllWorkToggle = _this.state.showAllWorkToggle;
      var selectedState = {
        className: "".concat(_topLevelFilter["default"]['work-button'], " ").concat(_topLevelFilter["default"].selected),
        icon: _icon_tick["default"]
      };
      var unselectedState = {
        className: "".concat(_topLevelFilter["default"]['work-button'])
      };
      return showAllWorkToggle ? selectedState : unselectedState;
    });
    /**
     * GRADE FILTER
     */
    _defineProperty(_this, "getGradeFilterLabel", function () {
      var showAllWorkToggle = _this.state.showAllWorkToggle;
      var selectedCourse = _this.props.selectedCourse;
      var filterDropdownText = _this.text.filterDropdownText;
      var shouldUpdatedFilterLabel = selectedCourse && selectedCourse.selected && !showAllWorkToggle;
      var updatedGradeFilterLabel = filterDropdownText;
      if (shouldUpdatedFilterLabel) {
        updatedGradeFilterLabel = selectedCourse.selected.name;
      }
      return updatedGradeFilterLabel;
    });
    _defineProperty(_this, "getGradeFilterButtonText", function () {
      var gradeFilterLabel = _this.getGradeFilterLabel();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _topLevelFilter["default"].text,
        key: "grade-filter-button",
        title: gradeFilterLabel
      }, gradeFilterLabel);
    });
    _defineProperty(_this, "onGradeFilterClickHandler", function () {
      var _this$props2 = _this.props,
        selectedPublication = _this$props2.selectedPublication,
        selectedCourse = _this$props2.selectedCourse;
      _this.setState({
        showContextModal: !_this.state.showContextModal
      });
      _this.setState({
        tempFilterValues: {
          curriculum: selectedPublication,
          course: selectedCourse
        }
      });
    });
    /**
     * CONTEXT MODAL
     */
    _defineProperty(_this, "renderContextModalDropdown", function (title, options, selectedOption, _onSelectOption, isDisabled) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _topLevelFilter["default"]['dropdown-container']
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _topLevelFilter["default"]['dropdown-header']
      }, title), /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
        className: _topLevelFilter["default"]['context-dropdown'],
        options: options,
        selectedOption: selectedOption,
        onSelectOption: function onSelectOption(e) {
          return _onSelectOption(e);
        },
        disabled: isDisabled
      }));
    });
    _defineProperty(_this, "onClickOutsideHandler", function () {
      var _this$props3 = _this.props,
        setSelectedPublication = _this$props3.setSelectedPublication,
        setSelectedCourse = _this$props3.setSelectedCourse;
      var _this$state$tempFilte = _this.state.tempFilterValues,
        course = _this$state$tempFilte.course,
        curriculum = _this$state$tempFilte.curriculum;
      _this.setState({
        showContextModal: false
      });
      setSelectedPublication(curriculum.data, curriculum.selected.id);
      setSelectedCourse(course.data, course.selected.id);
    });
    _defineProperty(_this, "onSelectCurriculum", function (e) {
      var _this$props4 = _this.props,
        setSelectedPublication = _this$props4.setSelectedPublication,
        setSelectedCourse = _this$props4.setSelectedCourse,
        selectedPublication = _this$props4.selectedPublication;
      setSelectedPublication(selectedPublication.data, e.id);
      setSelectedCourse(e.courses, e.courses[0].id);
    });
    _defineProperty(_this, "onSelectCourse", function (e) {
      var _this$props5 = _this.props,
        setSelectedCourse = _this$props5.setSelectedCourse,
        selectedCourse = _this$props5.selectedCourse;
      setSelectedCourse(selectedCourse.data, e.id);
    });
    _defineProperty(_this, "onContextModalShowClick", function () {
      var _this$props6 = _this.props,
        activeFilters = _this$props6.activeFilters,
        selectedCourse = _this$props6.selectedCourse,
        getStudentSkillQuestsMasteryDataCourse = _this$props6.getStudentSkillQuestsMasteryDataCourse,
        assignmentResultType = _this$props6.assignmentResultType;
      var updatedShowAllWorkToggle = false;
      _this.setState({
        showContextModal: false,
        showAllWorkToggle: updatedShowAllWorkToggle,
        tempFilterValues: null
      });
      getStudentSkillQuestsMasteryDataCourse(activeFilters[_filterConstants.SELECTED_CLASS].id, activeFilters[_filterConstants.SELECTED_STUDENT].id, activeFilters[_filterConstants.SELECTED_DATE], selectedCourse.selected.id, selectedCourse.selected.version, assignmentResultType);
    });
    _defineProperty(_this, "isContextModalShowDisabled", function () {
      var selectedCourse = _this.props.selectedCourse;
      return selectedCourse.selected.value === _studentHelpers.DEFAULT_VALUES.COURSES;
    });
    var i18n = window.i18n;
    _this.text = {
      filterSeparatorText: i18n._('Top Level Filter - or'),
      filterDropdownText: i18n._('Top Level Filter - Filter by grade/course'),
      showAllWorkButtonText: i18n._('Top Level Filter - Show all work'),
      contextCurriculumText: i18n._('Top Level Filter - Curriculum'),
      contextGradeCourseText: i18n._('Top Level Filter - Grade/Course'),
      contextShowText: i18n._('Top Level Filter - Show')
    };
    _this.state = {
      showAllWorkToggle: false,
      hasSetInitialShowAllWorkToggle: false,
      showContextModal: false,
      tempFilterValues: null
    };
    return _this;
  }
  _inherits(TopLevelFilter, _Component);
  return _createClass(TopLevelFilter, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.manageNullDefaultCourse(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        selectedPublication = _this$props7.selectedPublication,
        selectedCourse = _this$props7.selectedCourse,
        skillQuestsMasteryStudentData = _this$props7.skillQuestsMasteryStudentData;
      var _this$text = this.text,
        filterSeparatorText = _this$text.filterSeparatorText,
        showAllWorkButtonText = _this$text.showAllWorkButtonText,
        contextCurriculumText = _this$text.contextCurriculumText,
        contextGradeCourseText = _this$text.contextGradeCourseText,
        contextShowText = _this$text.contextShowText;
      var showContextModal = this.state.showContextModal;
      var hasDefaultCourse = selectedPublication && selectedCourse;
      var isGradeFilterEnabled = (0, _studentHelpers.hasValidCourses)(skillQuestsMasteryStudentData) && hasDefaultCourse;
      var shouldShowContextModal = showContextModal && hasDefaultCourse;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _topLevelFilter["default"]['filter-container']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, _extends({
        text: showAllWorkButtonText,
        onClick: this.onShowAllWorkClick
      }, this.getShowAllWorkButtonProps())), /*#__PURE__*/_react["default"].createElement("p", {
        className: _topLevelFilter["default"].separator
      }, filterSeparatorText), /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        text: this.getGradeFilterButtonText(),
        className: _topLevelFilter["default"]['filter-button'],
        onClick: this.onGradeFilterClickHandler,
        icon: _icon_up_solid["default"],
        alignIcon: 'RIGHT',
        disabled: !isGradeFilterEnabled
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _topLevelFilter["default"].border
      }), /*#__PURE__*/_react["default"].createElement(_contextModal["default"], {
        className: _topLevelFilter["default"]['filter-context-modal'],
        show: showContextModal,
        onClickOutsideHandler: this.onClickOutsideHandler
      }, shouldShowContextModal && /*#__PURE__*/_react["default"].createElement("div", {
        className: _topLevelFilter["default"]['filters-modal']
      }, this.renderContextModalDropdown(contextCurriculumText, selectedPublication.data, selectedPublication.selected, this.onSelectCurriculum, false), this.renderContextModalDropdown(contextGradeCourseText, selectedCourse.data, selectedCourse.selected, this.onSelectCourse, selectedPublication.selected.id === _studentHelpers.DEFAULT_VALUES.PUBLICATION), /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        className: _topLevelFilter["default"]['dropdown-button'],
        text: contextShowText,
        onClick: this.onContextModalShowClick,
        disabled: this.isContextModalShowDisabled()
      }))));
    }
  }]);
}(_react.Component);
_defineProperty(TopLevelFilter, "propTypes", {
  activeFilters: _filterPropTypes.activeFiltersPropType,
  assignmentResultType: _propTypes["default"].number,
  getStudentSkillQuestsMasteryDataCourse: _propTypes["default"].func,
  skillQuestsMasteryStudentData: _propTypes["default"].object,
  setSelectedPublication: _propTypes["default"].func,
  selectedPublication: _propTypes["default"].shape({
    data: _propTypes["default"].array,
    selected: _propTypes["default"].object
  }),
  setSelectedCourse: _propTypes["default"].func,
  selectedCourse: _propTypes["default"].shape({
    data: _propTypes["default"].array,
    selected: _propTypes["default"].object
  })
});
var _default = exports["default"] = (0, _reactStyleable["default"])(_topLevelFilter["default"])(TopLevelFilter);

/***/ }),

/***/ "bDco":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3D3Q2 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .component---3D3Q2 .title---ZqjVG {\n    width: 90%;\n    padding-top: 3px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3D3Q2",
	"title": "title---ZqjVG"
};

/***/ }),

/***/ "bGE9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---NPXjH {\n  height: 100%;\n  min-width: 1100px; }\n  .component---NPXjH > div {\n    height: 100%; }\n  .component---NPXjH .report-container---1PpaY {\n    border-top: 1px solid #e1e1e1;\n    padding-top: 16px; }\n  .manage-students-button---1S7I6 {\n  background: none;\n  color: #278bcb;\n  text-decoration: underline;\n  border: none;\n  padding: 0;\n  cursor: pointer; }\n  .sqm-single-class---3b4f0 {\n  height: calc(100% - 135px);\n  padding: 0 8px; }\n  .sqm-single-class---3b4f0 .sub-heading---2H0Ex {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    margin-bottom: 12px; }\n  .sqm-single-class---3b4f0 .sub-heading---2H0Ex .right-side---nKrk3 {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 100%;\n            flex: 1 1 100%;\n    height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 0 8px; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa table {\n      width: calc(100% - 2px); }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 0;\n      background-color: white;\n      font-weight: 500;\n      color: #4e5c67;\n      height: 47px; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type th {\n        border: none;\n        background: none;\n        font-weight: normal;\n        font-size: 12px;\n        white-space: nowrap; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type th::after, .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type th::before {\n          content: '';\n          position: absolute;\n          left: 0;\n          width: 100%; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type th::before {\n          top: -1px;\n          border-top: 1px solid #e5e5e5;\n          pointer-events: none; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type th::after {\n          bottom: -1px;\n          border-bottom: 2px solid #e5e5e5;\n          pointer-events: none; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type th::before {\n          left: -1px;\n          height: 46px;\n          border-left: 1px solid white;\n          border-right: 1px solid white; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type th::after {\n          height: 46px;\n          border-left: 1px solid white;\n          right: 1px; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:first-of-type th:first-of-type {\n          font-size: 18px;\n          text-align: left; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:last-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 47px;\n      background-color: #e4eaef;\n      color: #278bcb;\n      font-weight: 600; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:last-of-type th::after, .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:last-of-type th::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        width: 100%; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:last-of-type th::before {\n        top: -1px;\n        border-top: 1px solid #e5e5e5;\n        pointer-events: none; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa thead tr:last-of-type th::after {\n        bottom: -1px;\n        border-bottom: 2px solid #e5e5e5;\n        pointer-events: none; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa tbody tr td.dark-header---2F2TS:first-child {\n      font-weight: bold;\n      cursor: default; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa tbody tr td.dark-header---2F2TS:first-child svg {\n        visibility: hidden; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa th.dark-header---2F2TS {\n      background-color: #e4eaef;\n      border-color: #dadfe3; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa th.dark-header---2F2TS div {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa th.dark-header---2F2TS div span:first-child {\n          text-align: left; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa th.light-header---29NAj {\n      background-color: #eef4f9;\n      text-align: center; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa td.dark-header---2F2TS {\n      background-color: #eef4f9; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa td.completed-quests---3yaxH {\n      width: 30%; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa td.light-header---29NAj {\n      background-color: #eef4f9;\n      text-align: center; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa td.basic-cell---1oybR {\n      text-align: center; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa td.student-full-name-wrapper---3F0hb {\n      width: 16%;\n      max-width: 150px;\n      text-align: left; }\n  .sqm-single-class---3b4f0 .data-table---QUxHa td.student-full-name-wrapper---3F0hb .student-full-name---3VkA2 {\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        display: inline-block;\n        max-width: calc(100% - 25px); }\n  .sqm-single-class---3b4f0 .data-table---QUxHa table {\n      table-layout: auto; }\n  .accuracy-worst---ZDK3M {\n  background-color: red; }\n  .accuracy-middle---2wlTK {\n  background-color: blue; }\n  .accuracy-best---1MbXF {\n  background-color: green; }\n", ""]);

// exports
exports.locals = {
	"component": "component---NPXjH",
	"report-container": "report-container---1PpaY",
	"manage-students-button": "manage-students-button---1S7I6",
	"sqm-single-class": "sqm-single-class---3b4f0",
	"sub-heading": "sub-heading---2H0Ex",
	"right-side": "right-side---nKrk3",
	"data-table": "data-table---QUxHa",
	"dark-header": "dark-header---2F2TS",
	"light-header": "light-header---29NAj",
	"completed-quests": "completed-quests---3yaxH",
	"basic-cell": "basic-cell---1oybR",
	"student-full-name-wrapper": "student-full-name-wrapper---3F0hb",
	"student-full-name": "student-full-name---3VkA2",
	"accuracy-worst": "accuracy-worst---ZDK3M",
	"accuracy-middle": "accuracy-middle---2wlTK",
	"accuracy-best": "accuracy-best---1MbXF"
};

/***/ }),

/***/ "bHq3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateRange = void 0;
var _reactComponents = __webpack_require__("fmgT");
var _uiHelper = _interopRequireDefault(__webpack_require__("Vhb/"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getDateRange = exports.getDateRange = function getDateRange(selectedDate, academicYear) {
  var dateRange;
  if (selectedDate.startDate === null) {
    dateRange = {
      startDate: academicYear.startDate,
      endDate: academicYear.endDate
    };
  } else {
    dateRange = {
      startDate: selectedDate.startDate,
      endDate: selectedDate.endDate
    };
  }
  dateRange = _uiHelper["default"].formatDateRange(dateRange);
  if (selectedDate.type === _reactComponents.DatePicker.LIFETIME) {
    dateRange = "+Prior ".concat(dateRange);
  }
  return dateRange;
};

/***/ }),

/***/ "bXN9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("qEGd");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./empty-state.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./empty-state.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "c/2N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _downloadButton = _interopRequireDefault(__webpack_require__("27qy"));
var _downloadIcon = _interopRequireDefault(__webpack_require__("w1s4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DownloadButton = function DownloadButton(props) {
  var disabled = props.disabled,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    isDownloading = props.isDownloading,
    onClick = props.onClick;
  if (disabled || isDownloading) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _downloadButton["default"].buttonDisabled
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _downloadButton["default"].dash
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _downloadButton["default"].button,
    onClick: onClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _downloadButton["default"].title
  }, title), /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    width: '12px',
    src: _downloadIcon["default"],
    cacheGetRequests: true
  }));
};
DownloadButton.propTypes = {
  disabled: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  isDownloading: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_downloadButton["default"])(DownloadButton);

/***/ }),

/***/ "cEic":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _warningIcon = _interopRequireDefault(__webpack_require__("Oi3E"));
var _closeIcon = _interopRequireDefault(__webpack_require__("Qy98"));
var _toast = _interopRequireDefault(__webpack_require__("Vnjy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Toast = function Toast(_ref) {
  var message = _ref.message,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? _warningIcon["default"] : _ref$icon,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'error' : _ref$variant,
    _ref$showToast = _ref.showToast,
    showToast = _ref$showToast === void 0 ? false : _ref$showToast,
    onClose = _ref.onClose,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 4000 : _ref$duration;
  if (showToast) {
    setTimeout(onClose, duration);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _toast["default"].container
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_toast["default"].toast, " ").concat(_toast["default"][variant])
    }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
      src: icon,
      width: '32px',
      height: '32px'
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _toast["default"].message
    }, message), /*#__PURE__*/_react["default"].createElement("div", {
      onClick: onClose,
      role: "button",
      tabIndex: 0,
      className: _toast["default"].close
    }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
      src: _closeIcon["default"],
      width: '20px',
      height: '20px'
    }))));
  }
  return null;
};
Toast.propTypes = {
  message: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  variant: _propTypes["default"].oneOfType(['success', 'error']),
  showToast: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  duration: _propTypes["default"].number
};
Toast.defaultProps = {
  onClose: function onClose() {}
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_toast["default"])(Toast);

/***/ }),

/***/ "cQ73":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dRRz");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./improvement-type-picker.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./improvement-type-picker.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "cQtF":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/3974705b1bbc9dd3ac21653b4002d73f.svg";

/***/ }),

/***/ "cVtY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---2QoCp {\n  height: calc(100% - 90px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  .component---2QoCp .live-maths-results---3KWk8 table {\n    margin: 16px 0; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead tr {\n      background-color: #e4eaef;\n      color: #278bcb; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead tr th {\n        padding: 6px 16px; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead tr th svg path {\n          fill: #788189 !important; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead .col-header---2l3kv {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      text-align: center;\n      font-size: 12px;\n      line-height: 14px; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead .col-header---2l3kv span:first-of-type {\n        font-weight: bold; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead .col-header---2l3kv span:nth-of-type(2) {\n        font-weight: normal; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead .class-name---2XDcb,\n    .component---2QoCp .live-maths-results---3KWk8 table thead .level---2ptLq {\n      width: 40%;\n      text-align: left; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead .level---2ptLq {\n      font-size: 14px; }\n  .component---2QoCp .live-maths-results---3KWk8 table tbody {\n      text-align: center; }\n  .component---2QoCp .live-maths-results---3KWk8 table tbody tr {\n        background: none; }\n  .component---2QoCp .live-maths-results---3KWk8 table tbody tr td {\n          padding: 8px 16px; }\n  .component---2QoCp .live-maths-results---3KWk8 table tbody .level---2ptLq,\n      .component---2QoCp .live-maths-results---3KWk8 table tbody .class-name---2XDcb,\n      .component---2QoCp .live-maths-results---3KWk8 table tbody .group-name---38YvS,\n      .component---2QoCp .live-maths-results---3KWk8 table tbody .course-name---2cz62,\n      .component---2QoCp .live-maths-results---3KWk8 table tbody .student-name---1UMso {\n        text-align: left; }\n  .component---2QoCp .live-maths-results---3KWk8 table tbody .level---2ptLq {\n        font-size: 12px; }\n  .component---2QoCp .live-maths-results---3KWk8 table tbody .level-picker---2pRG0 {\n        padding: 0; }\n  .component---2QoCp .live-maths-results---3KWk8 table {\n    margin-top: 16px; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead tr {\n      color: #4e5c67; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead tr th {\n        padding: 12px 16px;\n        font-weight: normal; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead tr th.level---2ptLq {\n          width: 30%; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead tr th .col-header---2l3kv span:first-of-type {\n          font-size: 14px;\n          line-height: 16px;\n          font-weight: normal; }\n  .component---2QoCp .live-maths-results---3KWk8 table thead tr th .col-header---2l3kv span:last-of-type {\n          font-size: 12px; }\n  .component---2QoCp .live-maths-results---3KWk8 table tbody tr td {\n      padding: 12px 16px; }\n  .component---2QoCp .live-maths-results---3KWk8 table tbody tr td.level---2ptLq {\n        text-align: left;\n        font-size: 14px; }\n  .component---2QoCp .live-maths-results---3KWk8 table tfoot {\n      background-color: #415667;\n      color: #fff; }\n  .component---2QoCp .live-maths-results---3KWk8 table tfoot td {\n        border: none;\n        padding: 16px; }\n  .component---2QoCp .live-maths-results---3KWk8 .disclaimer---156Ai {\n    font-size: 12px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---2QoCp",
	"live-maths-results": "live-maths-results---3KWk8",
	"col-header": "col-header---2l3kv",
	"class-name": "class-name---2XDcb",
	"level": "level---2ptLq",
	"group-name": "group-name---38YvS",
	"course-name": "course-name---2cz62",
	"student-name": "student-name---1UMso",
	"level-picker": "level-picker---2pRG0",
	"disclaimer": "disclaimer---156Ai"
};

/***/ }),

/***/ "cdWI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YEAR_GROUP_LIST = exports.TOPICS = exports.TEACHER_LIST = exports.TEACHERS = exports.STUDENT_LIST = exports.SKILL_QUESTS_MASTERY_OPTION = exports.SKILL_QUESTS_MASTERY = exports.SELECTED_YEAR_GROUP = exports.SELECTED_TEACHER = exports.SELECTED_STUDENT = exports.SELECTED_REPORT = exports.SELECTED_GROUP = exports.SELECTED_DATE = exports.SELECTED_CLASS = exports.RESULTS = exports.REPORT_OPTIONS = exports.REPORT_LIST = exports.PARTICIPATION_OPTION = exports.PARTICIPATION = exports.NUM_ACTIVITIES = exports.MIN_GROUP_LENGTH = exports.LIVE_MATHS_OPTION = exports.LIVE_MATHS = exports.LIST_TO_ALL_OPTION = exports.LEVEL_LOWERCASE = exports.LEVEL = exports.GROUP_LIST = exports.FILTER_TO_DROPDOWN_MAP = exports.DROPDOWN_TO_FILTER_MAP = exports.DATE_RANGE_OPTIONS = exports.DATE_LIST = exports.CLASS_LIST = exports.ATTEMPTS = exports.ALL_YEARS_TRANS = exports.ALL_YEARS_OPTION = exports.ALL_YEARS = exports.ALL_TEACHERS_TRANS = exports.ALL_TEACHERS_OPTION = exports.ALL_TEACHERS = exports.ALL_STUDENTS_OPTION = exports.ALL_STUDENTS = exports.ALL_GROUPS_OPTION = exports.ALL_GROUPS = exports.ALL_CLASSES_OPTION = exports.ALL_CLASSES = exports.ACTIVITY_MASTERY_OPTION = exports.ACTIVITY_MASTERY = exports.ACTIVITY = exports.ACTIVITIES = void 0;
var _reactComponents = __webpack_require__("fmgT");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ALL_CLASSES = exports.ALL_CLASSES = 'All classes';
var ALL_GROUPS = exports.ALL_GROUPS = 'All groups';
var ALL_STUDENTS = exports.ALL_STUDENTS = 'All students';
var ALL_YEARS = exports.ALL_YEARS = 'All years';
var ALL_TEACHERS = exports.ALL_TEACHERS = 'All teachers';
var ALL_YEARS_TRANS = exports.ALL_YEARS_TRANS = 'Report Filters - All years';
var ALL_TEACHERS_TRANS = exports.ALL_TEACHERS_TRANS = 'Report Filters - All teachers';
var ACTIVITY_MASTERY = exports.ACTIVITY_MASTERY = 'Activity Mastery';
var PARTICIPATION = exports.PARTICIPATION = 'Participation';
var LIVE_MATHS = exports.LIVE_MATHS = 'Live Mathletics';
var SKILL_QUESTS_MASTERY = exports.SKILL_QUESTS_MASTERY = 'Skill Quests Mastery';
var YEAR_GROUP_LIST = exports.YEAR_GROUP_LIST = 'yearGroupList';
var TEACHER_LIST = exports.TEACHER_LIST = 'teacherList';
var CLASS_LIST = exports.CLASS_LIST = 'classList';
var GROUP_LIST = exports.GROUP_LIST = 'groupList';
var STUDENT_LIST = exports.STUDENT_LIST = 'studentList';
var REPORT_LIST = exports.REPORT_LIST = 'reportList';
var DATE_LIST = exports.DATE_LIST = 'dateList';
var SELECTED_CLASS = exports.SELECTED_CLASS = 'selectedClass';
var SELECTED_GROUP = exports.SELECTED_GROUP = 'selectedGroup';
var SELECTED_STUDENT = exports.SELECTED_STUDENT = 'selectedStudent';
var SELECTED_REPORT = exports.SELECTED_REPORT = 'selectedReport';
var SELECTED_DATE = exports.SELECTED_DATE = 'selectedDate';
var SELECTED_YEAR_GROUP = exports.SELECTED_YEAR_GROUP = 'selectedYearGroup';
var SELECTED_TEACHER = exports.SELECTED_TEACHER = 'selectedTeacher';
var ACTIVITY = exports.ACTIVITY = 'Activity';
var RESULTS = exports.RESULTS = 'Results';
var ATTEMPTS = exports.ATTEMPTS = 'Attempts';
var NUM_ACTIVITIES = exports.NUM_ACTIVITIES = 'Num Activities';
var TEACHERS = exports.TEACHERS = 'Teachers';
var TOPICS = exports.TOPICS = 'Topics';
var ACTIVITIES = exports.ACTIVITIES = 'Activities';
var LEVEL = exports.LEVEL = 'LEVEL';
var LEVEL_LOWERCASE = exports.LEVEL_LOWERCASE = 'level';
var FILTER_TO_DROPDOWN_MAP = exports.FILTER_TO_DROPDOWN_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SELECTED_YEAR_GROUP, YEAR_GROUP_LIST), SELECTED_TEACHER, TEACHER_LIST), SELECTED_CLASS, CLASS_LIST), SELECTED_GROUP, GROUP_LIST), SELECTED_STUDENT, STUDENT_LIST), SELECTED_REPORT, REPORT_LIST), SELECTED_DATE, DATE_LIST);
var DROPDOWN_TO_FILTER_MAP = exports.DROPDOWN_TO_FILTER_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, YEAR_GROUP_LIST, SELECTED_YEAR_GROUP), TEACHER_LIST, SELECTED_TEACHER), CLASS_LIST, SELECTED_CLASS), GROUP_LIST, SELECTED_GROUP), STUDENT_LIST, SELECTED_STUDENT), REPORT_LIST, SELECTED_REPORT), DATE_LIST, SELECTED_DATE);
var ALL_YEARS_OPTION = exports.ALL_YEARS_OPTION = {
  label: ALL_YEARS,
  value: ALL_YEARS
};
var ALL_TEACHERS_OPTION = exports.ALL_TEACHERS_OPTION = {
  label: ALL_TEACHERS,
  value: ALL_TEACHERS
};
var ALL_CLASSES_OPTION = exports.ALL_CLASSES_OPTION = {
  label: ALL_CLASSES,
  value: ALL_CLASSES
};
var ALL_GROUPS_OPTION = exports.ALL_GROUPS_OPTION = {
  label: ALL_GROUPS,
  value: ALL_GROUPS
};
var ALL_STUDENTS_OPTION = exports.ALL_STUDENTS_OPTION = {
  label: ALL_STUDENTS,
  value: ALL_STUDENTS
};
var ACTIVITY_MASTERY_OPTION = exports.ACTIVITY_MASTERY_OPTION = {
  label: ACTIVITY_MASTERY,
  value: ACTIVITY_MASTERY
};
var PARTICIPATION_OPTION = exports.PARTICIPATION_OPTION = {
  label: PARTICIPATION,
  value: PARTICIPATION
};
var LIVE_MATHS_OPTION = exports.LIVE_MATHS_OPTION = {
  label: LIVE_MATHS,
  value: LIVE_MATHS
};
var SKILL_QUESTS_MASTERY_OPTION = exports.SKILL_QUESTS_MASTERY_OPTION = {
  label: SKILL_QUESTS_MASTERY,
  value: SKILL_QUESTS_MASTERY
};
var REPORT_OPTIONS = exports.REPORT_OPTIONS = [PARTICIPATION_OPTION, ACTIVITY_MASTERY_OPTION, SKILL_QUESTS_MASTERY_OPTION, LIVE_MATHS_OPTION];
var LIST_TO_ALL_OPTION = exports.LIST_TO_ALL_OPTION = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, YEAR_GROUP_LIST, ALL_YEARS_OPTION), TEACHER_LIST, ALL_TEACHERS_OPTION), CLASS_LIST, ALL_CLASSES_OPTION), GROUP_LIST, ALL_GROUPS_OPTION), STUDENT_LIST, ALL_STUDENTS_OPTION);
var MIN_GROUP_LENGTH = exports.MIN_GROUP_LENGTH = 2;
var DATE_RANGE_OPTIONS = exports.DATE_RANGE_OPTIONS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _reactComponents.DatePicker.THIS_SCHOOL_YEAR, 0), _reactComponents.DatePicker.THIS_WEEK, 1), _reactComponents.DatePicker.LAST_WEEK, 2), _reactComponents.DatePicker.CUSTOM_DATE, 3), _reactComponents.DatePicker.LIFETIME, 4);

/***/ }),

/***/ "cjTm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _errorsActions = __webpack_require__("egHy");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var initialState = [];

/**
 * Errors Reducer
 *
 * Consumes ADD_ERROR action
 * Consumes REMOVE_ERROR action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - the new state
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _errorsActions.ADD_ERROR:
      return [].concat(_toConsumableArray(state), [action.payload]);
    case _errorsActions.REMOVE_ERROR:
      return state.slice(0, state.length - 1);
    default:
      return state;
  }
}

/***/ }),

/***/ "ct0i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslations = void 0;
var _linguiCdn = __webpack_require__("siuH");
var useTranslations = exports.useTranslations = function useTranslations() {
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  return {
    tooManyCertificates: i18n._("Certificates - tooManyCertificates")
  };
};

/***/ }),

/***/ "czp5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Student = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _pick = _interopRequireDefault(__webpack_require__("w9Mt"));
var _student = _interopRequireDefault(__webpack_require__("itiU"));
var _studentActions = _interopRequireWildcard(__webpack_require__("gUpq"));
var _studentConstants = __webpack_require__("XKLp");
var _topicActivityStrengthWeakness = _interopRequireDefault(__webpack_require__("EeH8"));
var _filterConstants = __webpack_require__("cdWI");
var _activityStatusBar = _interopRequireDefault(__webpack_require__("jJ7R"));
var _filterPropTypes = __webpack_require__("1g86");
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _studentPropTypes = _interopRequireDefault(__webpack_require__("L7wl"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _activityMasteryLegends = _interopRequireDefault(__webpack_require__("S6Bi"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Student component
 * Displays Activity Mastery table and strengths & weaknesses tabs for a student
 */
var Student = exports.Student = /*#__PURE__*/function (_Component) {
  function Student(props) {
    var _this;
    _classCallCheck(this, Student);
    _this = _callSuper(this, Student, [props]);
    _defineProperty(_this, "setTableTab", function (tab) {
      _this.setState(function (prevState) {
        if (prevState.tableTab !== tab) {
          setTimeout(function () {
            var activityMasteryData = _this.props.activityMasteryData;
            _this.configureTable(activityMasteryData);
          }, 1);
          return {
            tableTab: tab
          };
        }
        return null;
      });
    });
    /**
     * Sets table config and data values to use according to the current selected tab (All results or Test results)
     */
    _defineProperty(_this, "configureTable", function (activityMasteryData) {
      _this.setState(function (prevState) {
        var allResultsConfig = _this.generateAllResultsConfig(activityMasteryData);
        var testResultsConfig = _this.generateTestResultsConfig(activityMasteryData);
        var tableConfig;
        var studentData;
        if (prevState.tableTab === _studentConstants.ALL_RESULTS_TAB) {
          tableConfig = allResultsConfig;
          studentData = activityMasteryData.topicActivityResults;
        } else {
          tableConfig = testResultsConfig;
          studentData = activityMasteryData.testResults;
        }
        return {
          tableConfig: tableConfig,
          studentData: studentData,
          strengthData: activityMasteryData.strengths,
          weaknessData: activityMasteryData.weaknesses,
          allResultsConfig: allResultsConfig,
          testResultsConfig: testResultsConfig
        };
      });
    });
    _defineProperty(_this, "getColFromConfig", function (config, colId) {
      return config.cols.find(function (col) {
        return col.id === colId;
      });
    });
    _defineProperty(_this, "getColGroupFromConfig", function (config, colGroupId) {
      var colGroup;
      config.colGroups.forEach(function (colGroupRow) {
        if (!colGroup) {
          colGroup = colGroupRow.find(function (c) {
            return c.id === colGroupId;
          });
        }
      });
      return colGroup;
    });
    _defineProperty(_this, "renderTableTabs", function () {
      var tableTab = _this.state.tableTab;
      var buttons = [{
        tab: _studentConstants.ALL_RESULTS_TAB,
        text: _this.i18n._('Label - AllResults')
      }, {
        tab: _studentConstants.TEST_RESULTS_TAB,
        text: _this.i18n._('Label - TestResults')
      }];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"]['table-tab-container']
      }, buttons.map(function (button) {
        var isActive = tableTab === button.tab;
        var className = _student["default"]['table-tab-btn'];
        if (isActive) {
          className += " ".concat(_student["default"].active);
        }
        return /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
          key: button.tab,
          text: button.text,
          className: className,
          onClick: function onClick() {
            return _this.setTableTab(button.tab);
          }
        });
      }));
    });
    _this.state = {
      tableConfig: null,
      studentData: [],
      tableTab: _studentConstants.ALL_RESULTS_TAB,
      strengthData: {
        topics: [],
        activties: []
      },
      weaknessData: {
        topics: [],
        activities: []
      },
      allResultsConfig: _studentConstants.ALL_RESULTS_TABLE_CONFIG,
      testResultsConfig: _studentConstants.TEST_RESULTS_TABLE_CONFIG
    };
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(Student, _Component);
  return _createClass(Student, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeFilters = this.props.activeFilters;
      if (_filterHelper["default"].shouldLoadStudent(activeFilters)) {
        this.getStudentActivityMasteryData(activeFilters[_filterConstants.SELECTED_STUDENT].id, activeFilters[_filterConstants.SELECTED_CLASS].id, activeFilters[_filterConstants.SELECTED_DATE]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props = this.props,
        activityMasteryData = _this$props.activityMasteryData,
        activeFilters = _this$props.activeFilters,
        invalidRequest = _this$props.invalidRequest,
        updateActiveFilter = _this$props.updateActiveFilter;
      var newActivityMasteryData = newProps.activityMasteryData,
        newActiveFilters = newProps.activeFilters,
        newInvalidRequest = newProps.invalidRequest;
      if (_filterHelper["default"].shouldReloadStudent(activeFilters, newActiveFilters)) {
        this.getStudentActivityMasteryData(newActiveFilters[_filterConstants.SELECTED_STUDENT].id, newActiveFilters[_filterConstants.SELECTED_CLASS].id, newActiveFilters[_filterConstants.SELECTED_DATE]);
      }
      if (activityMasteryData !== newActivityMasteryData) {
        this.configureTable(newActivityMasteryData);
      }
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _studentActions.ACTIVITY_MASTERY_STUDENT_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps, newState) {
      var _this2 = this;
      var stateToTriggerRender = ['tableConfig', 'tableTab', 'studentData', 'strengthData', 'weaknessData'];
      return !!stateToTriggerRender.find(function (key) {
        return newState[key] !== _this2.state[key];
      });
    }
  }, {
    key: "getStudentActivityMasteryData",
    value: function getStudentActivityMasteryData(studentId, classId, selectedDateFilter) {
      this.props.getActivityMasteryData(classId, studentId, selectedDateFilter);
    }
  }, {
    key: "generateAllResultsConfig",
    value:
    /**
     * Generates the table config for the All results tab using the student activity mastery data
     * Some of the config is dynamic and requires data from the backend
     */
    function generateAllResultsConfig(activityMasteryData) {
      var tableConfig = this.generateBaseConfig((0, _cloneDeep["default"])(_studentConstants.ALL_RESULTS_TABLE_CONFIG), activityMasteryData);
      var courseActivityMastery = (0, _pick["default"])(activityMasteryData.courseInfo, ['scoreBand', 'goldBars', 'totalActivities']);
      this.getColFromConfig(tableConfig, _studentConstants.TOPIC_RESULTS).headerTransform = function () {
        return /*#__PURE__*/_react["default"].createElement(_activityStatusBar["default"], {
          activityMastery: courseActivityMastery
        });
      };
      this.getColFromConfig(tableConfig, _studentConstants.TOTAL_ACTIVITIES).name = "".concat(activityMasteryData.courseInfo.totalActivities);
      tableConfig = (0, _localeHelpers.translateTableLabels)(tableConfig);
      return tableConfig;
    }

    /**
     * Generates the table config for the Test results tab using the student activity mastery data
     * Some of the config is dynamic and requires data from the backend
     */
  }, {
    key: "generateTestResultsConfig",
    value: function generateTestResultsConfig(activityMasteryData) {
      var tableConfig = this.generateBaseConfig((0, _cloneDeep["default"])(_studentConstants.TEST_RESULTS_TABLE_CONFIG), activityMasteryData);
      this.getColFromConfig(tableConfig, _studentConstants.TEST_ATTEMPTS).name = "".concat(activityMasteryData.courseInfo.totalTests);
      return tableConfig;
    }

    /**
     * Generates the table config common between All results and Test results tabs
     */
  }, {
    key: "generateBaseConfig",
    value: function generateBaseConfig(baseConfig, activityMasteryData) {
      this.getColGroupFromConfig(baseConfig, _studentConstants.CLASS_NAME).name = activityMasteryData.className;
      this.getColGroupFromConfig(baseConfig, _studentConstants.TABLE_TABS).headerTransform = this.renderTableTabs;
      this.getColFromConfig(baseConfig, _studentConstants.TOPIC_NAME).name = activityMasteryData.courseInfo.name;
      return baseConfig;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        tableConfig = _this$state.tableConfig,
        studentData = _this$state.studentData,
        strengthData = _this$state.strengthData,
        weaknessData = _this$state.weaknessData;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_activityMasteryLegends["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"]['data-table']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: tableConfig,
        data: studentData
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"]['strength-weakness']
      }, /*#__PURE__*/_react["default"].createElement(_topicActivityStrengthWeakness["default"], {
        strengths: strengthData,
        weaknesses: weaknessData
      }))));
    }
  }]);
}(_react.Component);
_defineProperty(Student, "propTypes", {
  activityMasteryData: _studentPropTypes["default"].activityMasteryData,
  getActivityMasteryData: _propTypes["default"].func,
  activeFilters: _filterPropTypes.activeFiltersPropType,
  invalidRequest: _propTypes["default"].string,
  updateActiveFilter: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    activityMasteryData: state.activityMasteryStudent,
    invalidRequest: state.invalidRequest
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getActivityMasteryData: _studentActions["default"].getActivityMasteryData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_student["default"])(Student));

/***/ }),

/***/ "d0+Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise, fetch) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exportParticipationReport;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactComponents = __webpack_require__("fmgT");
var _constants = __webpack_require__("1QGX");
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _improvementTypePicker = _interopRequireDefault(__webpack_require__("2jmR"));
var _studentConstants = __webpack_require__("OCle");
var _participationDataConverter = _interopRequireDefault(__webpack_require__("Uk2F"));
var _filterConstants = __webpack_require__("cdWI");
var _exportReportActions = __webpack_require__("oXgP");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _reportStateActions = __webpack_require__("ItvU");
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Calculates the export parameters needed for the current participation report
 * Handles displaying a modal to the user asking them which improvement type they would
 * like to use when exporting student report
 */
function exportParticipationReport(_x, _x2, _x3, _x4, _x5) {
  return _exportParticipationReport.apply(this, arguments);
}
/**
 * Opens modal for user to choose their improvement calculation for the exported student
 * participation report
 */
function _exportParticipationReport() {
  _exportParticipationReport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(getState, reportLevel, dispatch, i18n, fileFormat) {
    var state, participationAllClasses, participationSingleClass, selectedDate, resourcesMethod, path, sessionId, data, title, _getParticipationAllC, tableTitle, reportTitle, participationKey, _tableTitle, selectedGroupId, groupId, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          state = getState();
          participationAllClasses = state.participationAllClasses, participationSingleClass = state.participationSingleClass;
          selectedDate = _activeFiltersSelectors["default"].selectDate(state);
          resourcesMethod = _exportReportActions.EXPORT_RESOURCE_METHODS[reportLevel];
          path = {
            reportType: _constants.ENDPOINT_PATH_PARTICIPATION,
            fileFormat: fileFormat === 0 ? _exportReportActions.FILE_FORMAT.PDF : _exportReportActions.FILE_FORMAT.EXCEL
          };
          sessionId = state.sessionId;
          title = '';
          _t = reportLevel;
          _context.n = _t === _exportReportActions.REPORT_LEVEL_ALL_YEARS ? 1 : _t === _exportReportActions.REPORT_LEVEL_ALL_CLASSES ? 1 : _t === _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER ? 1 : _t === _exportReportActions.REPORT_LEVEL_SINGLE_CLASS ? 3 : _t === _exportReportActions.REPORT_LEVEL_GROUP ? 3 : _t === _exportReportActions.REPORT_LEVEL_STUDENT ? 5 : 7;
          break;
        case 1:
          _getParticipationAllC = getParticipationAllClassesTableTitle({
            i18n: i18n,
            reportLevel: reportLevel,
            reportState: state.reportState
          }), tableTitle = _getParticipationAllC.tableTitle, reportTitle = _getParticipationAllC.reportTitle;
          participationKey = getParticipationAllClassesParticipationKey({
            reportLevel: reportLevel
          });
          title = reportTitle;
          data = _participationDataConverter["default"].convertAllClasses(participationAllClasses, selectedDate, _activeFiltersSelectors["default"].selectExportReportHeading(state), participationKey, tableTitle, sessionId);
          if (reportLevel === _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER) {
            path.yearGroupId = _activeFiltersSelectors["default"].selectYearGroupIdForApi(state);
            path.teacherId = _activeFiltersSelectors["default"].selectTeacherIdForApi(state);
          }
          _context.n = 2;
          return downloadParticipationReport({
            resourcesMethod: resourcesMethod,
            data: data,
            path: path,
            title: title
          });
        case 2:
          return _context.a(3, 8);
        case 3:
          _tableTitle = i18n._(
          /*i18n*/
          {
            id: "Export - All groups"
          });
          selectedGroupId = _activeFiltersSelectors["default"].selectGroupId(state);
          groupId = reportLevel === _exportReportActions.REPORT_LEVEL_GROUP ? _activeFiltersSelectors["default"].selectGroupId(state) : null;
          data = _participationDataConverter["default"].convertSingleClass(participationSingleClass, selectedDate, groupId, _tableTitle);
          title = getParticipationGroupsTableTitle({
            classroomName: data.classroomParticipationData.classroomName,
            dateRange: data.dateRange,
            classroomGroupParticipations: data.classroomParticipationData.classroomGroupParticipations,
            i18n: i18n,
            selectedGroupId: selectedGroupId
          });
          path.classroomId = _activeFiltersSelectors["default"].selectClassId(state);
          _context.n = 4;
          return downloadParticipationReport({
            resourcesMethod: resourcesMethod,
            data: data,
            path: path,
            title: title,
            params: {
              isForAllGroups: selectedGroupId === _filterConstants.ALL_GROUPS
            }
          });
        case 4:
          return _context.a(3, 8);
        case 5:
          _context.n = 6;
          return openImprovementTypeModal(getState, dispatch, i18n);
        case 6:
          return _context.a(3, 8);
        case 7:
          return _context.a(3, 8);
        case 8:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _exportParticipationReport.apply(this, arguments);
}
function openImprovementTypeModal(_x6, _x7, _x8) {
  return _openImprovementTypeModal.apply(this, arguments);
}
/**
 * Exports student participation report following user selecting improvement type
 */
function _openImprovementTypeModal() {
  _openImprovementTypeModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(getState, dispatch, i18n) {
    var improvementType;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          improvementType = _studentConstants.SELECTION_AS_IS;
          dispatch(_modalActions["default"].openModal({
            title: 'Select improvement calculation',
            content: /*#__PURE__*/_react["default"].createElement(_improvementTypePicker["default"], {
              initialSelection: improvementType,
              pickImprovementType: function pickImprovementType(type) {
                improvementType = type;
              }
            }),
            buttons: [{
              text: 'Cancel',
              danger: true
            }, {
              text: 'Export',
              primary: true,
              type: _reactComponents.Button.LOZENGE,
              handler: function handler() {
                exportStudentParticipation(improvementType, getState, dispatch, i18n);
              }
            }]
          }));
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _openImprovementTypeModal.apply(this, arguments);
}
function exportStudentParticipation(_x9, _x0, _x1, _x10) {
  return _exportStudentParticipation.apply(this, arguments);
}
function _exportStudentParticipation() {
  _exportStudentParticipation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(selectedImprovement, getState, dispatch, i18n) {
    var state, participationStudent, selectedImprovements, data, reportTitleSuffix;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          state = getState();
          participationStudent = state.participationStudent, selectedImprovements = state.selectedImprovements;
          data = _participationDataConverter["default"].convertStudent(participationStudent, _activeFiltersSelectors["default"].selectDate(state), selectedImprovement, selectedImprovements);
          reportTitleSuffix = i18n._('Export - Student');
          _context3.n = 1;
          return downloadParticipationReport({
            resourcesMethod: 'studentExport',
            path: {
              reportType: _constants.ENDPOINT_PATH_PARTICIPATION,
              classroomId: _activeFiltersSelectors["default"].selectClassId(state),
              userProfileId: _activeFiltersSelectors["default"].selectStudentId(state)
            },
            data: data,
            title: "".concat(data.studentParticipationData.firstName).concat(data.studentParticipationData.lastName, "_").concat(reportTitleSuffix)
          });
        case 1:
          dispatch(_modalActions["default"].closeModal());
        case 2:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _exportStudentParticipation.apply(this, arguments);
}
function getParticipationAllClassesParticipationKey(_ref) {
  var reportLevel = _ref.reportLevel;
  var participationKey = 'classroomsParticipationData';
  if (reportLevel === _exportReportActions.REPORT_LEVEL_ALL_YEARS) participationKey = 'yearGroupParticipationData';
  return participationKey;
}
function getParticipationGroupsTableTitle(_ref2) {
  var classroomName = _ref2.classroomName,
    dateRange = _ref2.dateRange,
    classroomGroupParticipations = _ref2.classroomGroupParticipations,
    i18n = _ref2.i18n,
    selectedGroupId = _ref2.selectedGroupId;
  var groupName = i18n._('Export - All groups');
  if (selectedGroupId !== _filterConstants.ALL_GROUPS) {
    classroomGroupParticipations.forEach(function (group) {
      if (group.id === selectedGroupId) groupName = group.name;
    });
  }
  var localisedFileName = i18n._(
  /*i18n*/
  {
    id: "Filename - Export - Groups - {classroomName} - {groupName} - {dateRange}",
    values: {
      classroomName: classroomName,
      groupName: groupName,
      dateRange: dateRange
    }
  });
  return localisedFileName.replace(/\./g, '-');
}
function getParticipationAllClassesTableTitle(_ref3) {
  var i18n = _ref3.i18n,
    reportLevel = _ref3.reportLevel,
    reportState = _ref3.reportState;
  var TEXT_KEYS = {
    DEFAULT: 'Export - Mathletics Classes',
    DEFAULT_REPORT: 'Export - All classes - ParticipationReport',
    TOP_STUDENTS: 'Export - Top Students',
    TOP_STUDENTS_REPORT: 'Export - Top Students - ParticipationReport',
    ALL_YEARS: 'Export - All years',
    ALL_YEARS_REPORT: 'Export - All years - ParticipationReport',
    ALL_CLASSES: 'Export - All classes',
    ALL_CLASSES_REPORT: 'Export - All classes - ParticipationReport'
  };
  var key = 'DEFAULT';
  if (reportLevel === _exportReportActions.REPORT_LEVEL_ALL_YEARS) {
    if (reportState === _reportStateActions.REPORT_STATE_TOP_TEN) {
      key = 'TOP_STUDENTS';
    } else if (reportState !== _reportStateActions.REPORT_STATE_ALL_CLASSES) {
      key = 'ALL_YEARS';
    } else {
      key = 'ALL_CLASSES';
    }
  } else if (reportLevel === _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER) {
    if (reportState === _reportStateActions.REPORT_STATE_ALL_YEARS) {
      key = 'ALL_CLASSES';
    }
  }
  return {
    tableTitle: i18n._(TEXT_KEYS[key]),
    reportTitle: i18n._(TEXT_KEYS["".concat(key, "_REPORT")]),
    reportLevelHeader: 'Test'
  };
}
function generateDownloadableFile(_x11) {
  return _generateDownloadableFile.apply(this, arguments);
}
function _generateDownloadableFile() {
  _generateDownloadableFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref4) {
    var response, title, blob, url, link;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          response = _ref4.response, title = _ref4.title;
          _context4.n = 1;
          return response.blob();
        case 1:
          blob = _context4.v;
          url = window.URL.createObjectURL(blob);
          link = window.document.createElement('a');
          link.href = url;
          link.setAttribute('download', title);
          window.document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        case 2:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _generateDownloadableFile.apply(this, arguments);
}
function downloadParticipationReport(_x12) {
  return _downloadParticipationReport.apply(this, arguments);
}
function _downloadParticipationReport() {
  _downloadParticipationReport = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref5) {
    var resourcesMethod, path, data, title, _ref5$params, params, locale, _yield$Resources$reso, valid, downloadKey, appendResourceMethod, urlResponse, response, _t2;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          resourcesMethod = _ref5.resourcesMethod, path = _ref5.path, data = _ref5.data, title = _ref5.title, _ref5$params = _ref5.params, params = _ref5$params === void 0 ? {} : _ref5$params;
          locale = (0, _localeHelpers.localeCode)();
          _context5.p = 1;
          _context5.n = 2;
          return _resources["default"][resourcesMethod].post(path).withBody(data).withParams(_objectSpread(_objectSpread({}, params), {}, {
            locale: locale
          })).send();
        case 2:
          _yield$Resources$reso = _context5.v;
          valid = _yield$Resources$reso.valid;
          downloadKey = _yield$Resources$reso.data;
          if (valid) {
            _context5.n = 3;
            break;
          }
          throw new Error('Invalid download key response');
        case 3:
          appendResourceMethod = "".concat(resourcesMethod, "Key");
          _context5.n = 4;
          return _resources["default"][appendResourceMethod].get(_objectSpread(_objectSpread({}, path), {}, {
            downloadKey: downloadKey
          })).raw().send();
        case 4:
          urlResponse = _context5.v;
          _context5.n = 5;
          return fetch(urlResponse.verb.url);
        case 5:
          response = _context5.v;
          if (response.ok) {
            _context5.n = 6;
            break;
          }
          throw new Error('Network error');
        case 6:
          _context5.n = 7;
          return generateDownloadableFile({
            response: response,
            title: title
          });
        case 7:
          _context5.n = 9;
          break;
        case 8:
          _context5.p = 8;
          _t2 = _context5.v;
          console.error('Error downloading participation report:', _t2);
        case 9:
          return _context5.a(2);
      }
    }, _callee5, null, [[1, 8]]);
  }));
  return _downloadParticipationReport.apply(this, arguments);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q"), __webpack_require__("rp8n")))

/***/ }),

/***/ "dDs9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsGraphClickable = void 0;
var _react = __webpack_require__("GiK3");
var _constants = __webpack_require__("1QGX");
var _utils = __webpack_require__("6QRH");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var shouldShowAccuracyOverviewGraph = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var SHOW_ACCURACY_OVERVIEW_GRAPH, isAcuracyOverviewGraphVisible;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          SHOW_ACCURACY_OVERVIEW_GRAPH = _constants.CONFIGURATION_KEYS.SHOW_ACCURACY_OVERVIEW_GRAPH;
          _context.n = 1;
          return (0, _utils.getConfiguration)(SHOW_ACCURACY_OVERVIEW_GRAPH);
        case 1:
          isAcuracyOverviewGraphVisible = _context.v;
          return _context.a(2, isAcuracyOverviewGraphVisible);
      }
    }, _callee);
  }));
  return function shouldShowAccuracyOverviewGraph() {
    return _ref.apply(this, arguments);
  };
}();
var useIsGraphClickable = exports.useIsGraphClickable = function useIsGraphClickable(_ref2) {
  var averageAccuraciesHistory = _ref2.averageAccuraciesHistory;
  var _useState = (0, _react.useState)(shouldShowAccuracyOverviewGraph(averageAccuraciesHistory).then(function (response) {
      return setShowAccuracyOverviewGraph(JSON.parse(response));
    })),
    _useState2 = _slicedToArray(_useState, 2),
    showAccuracyOverviewGraph = _useState2[0],
    setShowAccuracyOverviewGraph = _useState2[1];
  return [showAccuracyOverviewGraph];
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "dFjD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.STUDENTS_BY_GROUP_RETRIEVED = exports.RESET_STUDENTS_BY_GROUP = void 0;
var _uniq = _interopRequireDefault(__webpack_require__("WIDu"));
var _reduxActions = __webpack_require__("sTbe");
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _filterConstants = __webpack_require__("cdWI");
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var STUDENTS_BY_GROUP_RETRIEVED = exports.STUDENTS_BY_GROUP_RETRIEVED = 'STUDENTS_BY_GROUP_RETRIEVED';
var RESET_STUDENTS_BY_GROUP = exports.RESET_STUDENTS_BY_GROUP = 'RESET_STUDENTS_BY_GROUP';
function getStudentsByGroup(classId) {
  return function (dispatch, getState) {
    var currentClassId = _dropdownDataSelectors["default"].selectSelectedOptionByType(_filterConstants.CLASS_LIST)(getState()).value;
    if (classId !== currentClassId) {
      return _resources["default"].studentsByGroup.get({
        classId: classId
      }).send().then(function (payload) {
        var studentsByGroup = mapGroupData(payload.data);
        dispatch({
          type: STUDENTS_BY_GROUP_RETRIEVED,
          payload: studentsByGroup
        });
        dispatch(_dropdownDataActions["default"].setGroupAndStudentLists(studentsByGroup.groups));
      });
    }
    return null;
  };
}
var resetStudentsByGroup = (0, _reduxActions.createAction)(RESET_STUDENTS_BY_GROUP);
function mapGroupData(data) {
  var allStudents = [];
  var groups = data.groups.map(function (group) {
    var mappedGroup = _objectSpread({}, group);
    mappedGroup.students = mappedGroup.students.map(function (student) {
      return {
        value: student.userProfileId,
        label: "".concat(student.firstName, " ").concat(student.lastName),
        userId: student.userId
      };
    });
    allStudents = [].concat(_toConsumableArray(allStudents), _toConsumableArray(mappedGroup.students.filter(function (student) {
      return !allStudents.find(function (s) {
        return s.value === student.value;
      });
    })));
    return mappedGroup;
  });

  // add 'All groups' option which contains all students if more than one group
  allStudents = (0, _uniq["default"])(allStudents);
  if (groups.length > 1) {
    groups.unshift({
      id: _filterConstants.ALL_GROUPS,
      name: _filterConstants.ALL_GROUPS,
      students: allStudents
    });
  }
  return {
    id: data.id,
    groups: groups
  };
}
var _default = exports["default"] = {
  getStudentsByGroup: getStudentsByGroup,
  resetStudentsByGroup: resetStudentsByGroup
};

/***/ }),

/***/ "dRRz":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---LdIvj .option-container---1nCS6 {\n  display: inline-block;\n  margin: auto;\n  text-align: left; }\n\n.component---LdIvj .option---3FPQV {\n  margin: 16px 0; }\n\n.component---LdIvj .option---3FPQV label {\n    margin-left: 24px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---LdIvj",
	"option-container": "option-container---1nCS6",
	"option": "option---3FPQV"
};

/***/ }),

/***/ "dpkF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _icon_back = _interopRequireDefault(__webpack_require__("0dCu"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _tableHeader = _interopRequireDefault(__webpack_require__("rVQD"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays table title and back button
 * Back button goes to previous state in history, ReportFilters component handles updating the
 * active filters
 */
var TableHeader = /*#__PURE__*/function (_PureComponent) {
  function TableHeader(props) {
    var _this;
    _classCallCheck(this, TableHeader);
    _this = _callSuper(this, TableHeader, [props]);
    var i18n = window.i18n;
    var title = props.title,
      translate = props.translate;
    if (translate && i18n) {
      _this.title = i18n._(title);
    } else {
      _this.title = title;
    }
    return _this;
  }
  _inherits(TableHeader, _PureComponent);
  return _createClass(TableHeader, [{
    key: "render",
    value: function render() {
      var history = this.context.router.history;
      var showButton = this.props.showButton;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _tableHeader["default"].component
      }, showButton && /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        primary: true,
        icon: _icon_back["default"],
        onClick: history.goBack,
        className: _tableHeader["default"]['back-button']
      }), /*#__PURE__*/_react["default"].createElement("h3", null, this.title));
    }
  }]);
}(_react.PureComponent);
_defineProperty(TableHeader, "propTypes", {
  title: _propTypes["default"].string,
  showButton: _propTypes["default"].bool,
  translate: _propTypes["default"].bool
});
_defineProperty(TableHeader, "contextTypes", {
  router: _propTypes["default"].object
});
TableHeader.defaultProps = {
  showButton: true
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_tableHeader["default"])(TableHeader);

/***/ }),

/***/ "dppr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _liveMaths = _interopRequireDefault(__webpack_require__("QHRj"));
var _subHeading = _interopRequireDefault(__webpack_require__("tecg"));
var _allClasses = _interopRequireDefault(__webpack_require__("U2Uw"));
var _singleClass = _interopRequireDefault(__webpack_require__("kpcp"));
var _student = _interopRequireDefault(__webpack_require__("UQU2"));
var _reportRoutes = _interopRequireDefault(__webpack_require__("lXLQ"));
var _filterConstants = __webpack_require__("cdWI");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _emptyState = _interopRequireDefault(__webpack_require__("e7yh"));
var _emptyStateConstants = _interopRequireDefault(__webpack_require__("pYuN"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Base container for all Live Maths reports
 */
var LiveMaths = function LiveMaths(_ref) {
  var selectedStudentId = _ref.selectedStudentId;
  var routeComps = {
    allClasses: _allClasses["default"],
    singleClass: _singleClass["default"],
    student: _student["default"]
  };

  // export is not available for live maths student report
  var isExportEnabled = selectedStudentId === _filterConstants.ALL_STUDENTS;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _liveMaths["default"].component
  }, /*#__PURE__*/_react["default"].createElement(_emptyState["default"], {
    variant: _emptyStateConstants["default"].NO_STUDENTS
  }, /*#__PURE__*/_react["default"].createElement(_reportRoutes["default"], {
    components: routeComps
  }, /*#__PURE__*/_react["default"].createElement(_subHeading["default"], {
    isExportEnabled: isExportEnabled
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _liveMaths["default"]['report-container']
  }))));
};
LiveMaths.propTypes = {
  selectedStudentId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
};
function mapStateToProps(state) {
  return {
    selectedStudentId: _activeFiltersSelectors["default"].selectStudentId(state)
  };
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)((0, _reactStyleable["default"])(_liveMaths["default"])(LiveMaths));

/***/ }),

/***/ "dstU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _liveMathsLevelPickerActions = __webpack_require__("7NtK");
var defaultState = 1;

/**
 * Live Maths Level Reducer
 *
 * Consumes PICK_LIVE_MATHS_LEVEL action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {number} - current Live Maths level
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _liveMathsLevelPickerActions.PICK_LIVE_MATHS_LEVEL:
      return action.payload;
    case _liveMathsLevelPickerActions.RESET_LIVE_MATHS_LEVEL:
      return defaultState;
    default:
      return state;
  }
}

/***/ }),

/***/ "e7yh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _reactRouterDom = __webpack_require__("F8kA");
var _mathleticsPortalCommunicationService = _interopRequireDefault(__webpack_require__("UTT2"));
var _emptyState = _interopRequireDefault(__webpack_require__("bXN9"));
var _emptyStateConstants = _interopRequireDefault(__webpack_require__("pYuN"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _localeHelpers = __webpack_require__("rjLd");
var _utils = __webpack_require__("6QRH");
var _constants = __webpack_require__("1QGX");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _pageHeader = _interopRequireDefault(__webpack_require__("AJp4"));
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _subHeadingHeader = _interopRequireDefault(__webpack_require__("X5f6"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * EMPTY STATE
 * --------------------
 * HOC which manages empty state of variants. Currently one use case but can be extended to fit multiple
 */
var EmptyState = /*#__PURE__*/function (_Component) {
  function EmptyState(_props) {
    var _this;
    _classCallCheck(this, EmptyState);
    _this = _callSuper(this, EmptyState, [_props]);
    _defineProperty(_this, "getHasNoStudents", function (props) {
      var variant = props.variant;
      if (variant === _emptyStateConstants["default"].NO_STUDENTS) {
        return (0, _utils.getHasNoStudents)(props.activeFilters, props.allClasses);
      }
      return false;
    });
    _defineProperty(_this, "getEmptyState", function () {
      var variant = _this.props.variant;
      var i18n = window.i18n;
      switch (variant) {
        case _emptyStateConstants["default"].NO_CLASSES:
          {
            var _this$text = _this.text,
              noClassesHeader = _this$text.noClassesHeader,
              noClassesContent = _this$text.noClassesContent;
            var _this$props = _this.props,
              children = _this$props.children,
              classDropdownData = _this$props.classDropdownData,
              busyIndicatorCount = _this$props.busyIndicatorCount;
            var showEmptyState = classDropdownData && (0, _utils.isEmptyArray)(classDropdownData.data) && busyIndicatorCount === 0;
            if (showEmptyState) {
              return /*#__PURE__*/_react["default"].createElement("div", {
                className: _emptyState["default"]['empty-state']
              }, /*#__PURE__*/_react["default"].createElement(_pageHeader["default"], {
                showFilters: false
              }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Container, {
                className: _emptyState["default"]['container-wrapper']
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: _emptyState["default"]['no-classes']
              }, /*#__PURE__*/_react["default"].createElement("h3", {
                className: _emptyState["default"]['no-classes-header']
              }, i18n._(noClassesHeader)), /*#__PURE__*/_react["default"].createElement("span", {
                className: _emptyState["default"]['no-classes-content']
              }, i18n._(noClassesContent)))));
            }
            return /*#__PURE__*/_react["default"].createElement("div", null, children);
          }
        case _emptyStateConstants["default"].NO_STUDENTS:
          {
            var _this$props2 = _this.props,
              activeFilters = _this$props2.activeFilters,
              _children = _this$props2.children;
            var hasNoStudents = _this.getHasNoStudents(_this.props);
            var _this$text2 = _this.text,
              noStudentsContent1 = _this$text2.noStudentsContent1,
              noStudentsContent2 = _this$text2.noStudentsContent2,
              noStudentsContent3 = _this$text2.noStudentsContent3;
            var tableHeaderTitle = activeFilters[_filterConstants.SELECTED_REPORT].name;
            tableHeaderTitle = (0, _localeHelpers.getTranslationKey)(tableHeaderTitle);
            var classId = activeFilters[_filterConstants.SELECTED_CLASS].id;
            if (hasNoStudents) {
              return /*#__PURE__*/_react["default"].createElement("div", {
                className: _emptyState["default"]['empty-state']
              }, /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
                title: tableHeaderTitle,
                showButton: true,
                translate: true
              }), /*#__PURE__*/_react["default"].createElement(_subHeadingHeader["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
                className: _emptyState["default"]['no-students-content']
              }, /*#__PURE__*/_react["default"].createElement("div", {
                className: _emptyState["default"].text
              }, i18n._(noStudentsContent1)), /*#__PURE__*/_react["default"].createElement("div", {
                className: _emptyState["default"].text
              }, i18n._(noStudentsContent2)), /*#__PURE__*/_react["default"].createElement("button", {
                className: _emptyState["default"]['manage-students-button'],
                onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                  var moduleId;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _context.n = 1;
                        return (0, _utils.getConfiguration)(_constants.PORTAL_MODULE.MANAGE_STUDENTS);
                      case 1:
                        moduleId = _context.v;
                        _mathleticsPortalCommunicationService["default"].requestModuleChange(moduleId, {
                          classId: classId
                        });
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }))
              }, i18n._(noStudentsContent3))));
            }
            return _children;
          }
        default:
          {
            var _children2 = _this.props.children;
            return _children2;
          }
      }
    });
    _this.state = {
      hasNoStudents: false
    };
    _this.text = {
      noClassesHeader: 'Empty State - No classes assigned',
      noClassesContent: 'Empty State - Please contact your school administration',
      noStudentsContent1: 'Table Empty - No students in this class',
      noStudentsContent2: 'Progress Display - Dash Label',
      noStudentsContent3: 'Table Empty - Go to Manage Students'
    };
    return _this;
  }
  _inherits(EmptyState, _Component);
  return _createClass(EmptyState, [{
    key: "render",
    value: function render() {
      return this.getEmptyState();
    }
  }]);
}(_react.Component);
_defineProperty(EmptyState, "propTypes", {
  // redux filter values
  activeFilters: _filterPropTypes.activeFiltersPropType,
  // Manages loading state
  busyIndicatorCount: _propTypes["default"].number,
  // Class data used to manage No Classes variant
  classDropdownData: _propTypes["default"].object,
  // Children node
  children: _propTypes["default"].node,
  // Variant types
  variant: _propTypes["default"].oneOf([_emptyStateConstants["default"].DEFAULT, _emptyStateConstants["default"].NO_CLASSES, _emptyStateConstants["default"].NO_STUDENTS])
});
function mapStateToProps(state) {
  return {
    allClasses: state.allClasses,
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    busyIndicatorCount: state.busyIndicatorCount,
    classDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.CLASS_LIST)(state)
  };
}
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)((0, _reactStyleable["default"])(_emptyState["default"])(EmptyState)));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "egHy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REMOVE_ERROR = exports.ADD_ERROR = void 0;
var _reduxActions = __webpack_require__("sTbe");
var ADD_ERROR = exports.ADD_ERROR = 'ADD_ERROR';
var REMOVE_ERROR = exports.REMOVE_ERROR = 'REMOVE_ERROR';
var addError = (0, _reduxActions.createAction)(ADD_ERROR);
var removeError = (0, _reduxActions.createAction)(REMOVE_ERROR);
var _default = exports["default"] = {
  addError: addError,
  removeError: removeError
};

/***/ }),

/***/ "ez0K":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---shBV4 {\n  height: calc(100% - 90px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .component---shBV4 .live-maths-results---21Rdw {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 1 60%;\n            flex: 0 1 60%; }\n  .component---shBV4 .live-maths-results---21Rdw h3 {\n      font-size: 18px;\n      font-weight: normal;\n      margin: 8px; }\n  .component---shBV4 .live-maths-results---21Rdw table {\n      margin: 16px 0; }\n  .component---shBV4 .live-maths-results---21Rdw table thead tr {\n        background-color: #e4eaef;\n        color: #278bcb; }\n  .component---shBV4 .live-maths-results---21Rdw table thead tr th {\n          padding: 6px 16px; }\n  .component---shBV4 .live-maths-results---21Rdw table thead tr th svg path {\n            fill: #788189 !important; }\n  .component---shBV4 .live-maths-results---21Rdw table thead .col-header---3Go5l {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n            -ms-flex-direction: column;\n                flex-direction: column;\n        text-align: center;\n        font-size: 12px;\n        line-height: 14px; }\n  .component---shBV4 .live-maths-results---21Rdw table thead .col-header---3Go5l span:first-of-type {\n          font-weight: bold; }\n  .component---shBV4 .live-maths-results---21Rdw table thead .col-header---3Go5l span:nth-of-type(2) {\n          font-weight: normal; }\n  .component---shBV4 .live-maths-results---21Rdw table thead .class-name---3-VeZ,\n      .component---shBV4 .live-maths-results---21Rdw table thead .level---1ENob {\n        width: 40%;\n        text-align: left; }\n  .component---shBV4 .live-maths-results---21Rdw table thead .level---1ENob {\n        font-size: 14px; }\n  .component---shBV4 .live-maths-results---21Rdw table tbody {\n        text-align: center; }\n  .component---shBV4 .live-maths-results---21Rdw table tbody tr {\n          background: none; }\n  .component---shBV4 .live-maths-results---21Rdw table tbody tr td {\n            padding: 8px 16px; }\n  .component---shBV4 .live-maths-results---21Rdw table tbody .level---1ENob,\n        .component---shBV4 .live-maths-results---21Rdw table tbody .class-name---3-VeZ,\n        .component---shBV4 .live-maths-results---21Rdw table tbody .group-name---1xIfd,\n        .component---shBV4 .live-maths-results---21Rdw table tbody .course-name---1i_ZM,\n        .component---shBV4 .live-maths-results---21Rdw table tbody .student-name---pp1Fq {\n          text-align: left; }\n  .component---shBV4 .live-maths-results---21Rdw table tbody .level---1ENob {\n          font-size: 12px; }\n  .component---shBV4 .live-maths-results---21Rdw table tbody .level-picker---3BSon {\n          padding: 0; }\n", ""]);

// exports
exports.locals = {
	"component": "component---shBV4",
	"live-maths-results": "live-maths-results---21Rdw",
	"col-header": "col-header---3Go5l",
	"class-name": "class-name---3-VeZ",
	"level": "level---1ENob",
	"group-name": "group-name---1xIfd",
	"course-name": "course-name---1i_ZM",
	"student-name": "student-name---pp1Fq",
	"level-picker": "level-picker---3BSon"
};

/***/ }),

/***/ "f1U6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _popupMenu = _interopRequireDefault(__webpack_require__("vMaD"));
var _downloadIcon = _interopRequireDefault(__webpack_require__("Gczr"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PopUpMenu = function PopUpMenu(_ref) {
  var options = _ref.options,
    downloadReports = _ref.downloadReports,
    onClickHandler = _ref.onClickHandler;
  var closeDropdown = function closeDropdown(index) {
    onClickHandler();
    downloadReports(index);
  };
  var menu = options.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      key: item.label,
      id: index,
      "aria-hidden": 'true',
      className: _popupMenu["default"]['popup-menu-item'],
      onClick: function onClick() {
        return closeDropdown(index);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
      className: _popupMenu["default"].icon,
      src: _downloadIcon["default"],
      cacheGetRequests: true
    })), item.label);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _popupMenu["default"]['popup-menu']
  }, menu);
};
PopUpMenu.propTypes = {
  options: _propTypes["default"].array,
  downloadReports: _propTypes["default"].func,
  onClickHandler: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_popupMenu["default"])(PopUpMenu);

/***/ }),

/***/ "fXC1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("rR7D");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./rank-dropdown.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./rank-dropdown.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "fXLW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(__webpack_require__("PJh5"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _reactRedux = __webpack_require__("RH2O");
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _constants = __webpack_require__("1QGX");
var _utils = __webpack_require__("6QRH");
var _certificateConfirmationModal = _interopRequireDefault(__webpack_require__("MKpC"));
var _useCertificatesToast2 = __webpack_require__("vS7R");
var _downloadIcon = _interopRequireDefault(__webpack_require__("Gczr"));
var _certificateDisplay = _interopRequireDefault(__webpack_require__("a+f/"));
var _certificatesActions = _interopRequireDefault(__webpack_require__("PLdC"));
var _excluded = ["startDate", "endDate"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CertificateDisplay = function CertificateDisplay(_ref) {
  var count = _ref.count,
    requestParams = _ref.requestParams,
    service = _ref.service,
    onSuccessParams = _ref.onSuccessParams,
    isOldCertificates = _ref.isOldCertificates;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useCertificatesToast = (0, _useCertificatesToast2.useCertificatesToast)(),
    renderedToast = _useCertificatesToast.renderedToast,
    onOpenToast = _useCertificatesToast.onOpenToast;
  var handleDownloadClick = function handleDownloadClick(_ref2) {
    var _ref2$fullColor = _ref2.fullColor,
      fullColor = _ref2$fullColor === void 0 ? false : _ref2$fullColor,
      _ref2$gemTypes = _ref2.gemTypes,
      gemTypes = _ref2$gemTypes === void 0 ? [] : _ref2$gemTypes,
      gemCount = _ref2.gemCount;
    var startDate = requestParams.startDate,
      endDate = requestParams.endDate,
      params = _objectWithoutProperties(requestParams, _excluded);
    var requestPayload = _objectSpread(_objectSpread(_objectSpread({
      startDate: (0, _moment["default"])(startDate).format('DD-MM-YYYY'),
      endDate: (0, _moment["default"])(endDate).format('DD-MM-YYYY'),
      productId: _constants.MATHLETICS_ID
    }, params), {}, {
      certificatesCount: gemCount
    }, onSuccessParams), !isOldCertificates && {
      gemTypes: gemTypes,
      fullColor: fullColor
    });
    dispatch(service(requestPayload));
  };
  var onClickHandler = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var maxCertificatesCanDownload, type, startDate, endDate, classroomId, groupId, userProfileId, yearGroupEnum, dispatchModal, requestPayload, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return (0, _utils.getConfiguration)(_constants.CONFIGURATION_KEYS.MAX_CERTIFICATES_CAN_DOWNLOAD);
          case 1:
            _t = _context.v;
            if (_t) {
              _context.n = 2;
              break;
            }
            _t = 200;
          case 2:
            maxCertificatesCanDownload = _t;
            if (count > maxCertificatesCanDownload) {
              onOpenToast();
            } else if (!isOldCertificates) {
              type = requestParams.type, startDate = requestParams.startDate, endDate = requestParams.endDate, classroomId = requestParams.classroomId, groupId = requestParams.groupId, userProfileId = requestParams.userProfileId, yearGroupEnum = requestParams.yearGroupEnum;
              dispatchModal = function dispatchModal() {
                dispatch(_modalActions["default"].openModal({
                  content: /*#__PURE__*/_react["default"].createElement(_certificateConfirmationModal["default"], {
                    certificatesCount: count,
                    certificateType: requestParams.type,
                    handleDownloadClick: handleDownloadClick
                  }),
                  buttons: []
                }));
              };
              if (type !== _constants.TOTAL_CERTIFICATES_TYPE) {
                requestPayload = {
                  type: type,
                  startDate: (0, _moment["default"])(startDate).format('DD-MM-YYYY'),
                  endDate: (0, _moment["default"])(endDate).format('DD-MM-YYYY'),
                  classroomId: classroomId,
                  groupId: groupId,
                  studentUserProfileId: userProfileId,
                  yearGroupEnum: yearGroupEnum
                };
                dispatch(_certificatesActions["default"].getGemCountsByType(requestPayload)).then(dispatchModal());
              } else {
                dispatchModal();
              }
            } else {
              // download old certificates without showing modal
              handleDownloadClick({
                gemCount: count
              });
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onClickHandler() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateDisplay["default"].container
  }, renderedToast, /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateDisplay["default"].wrapper
  }, count === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateDisplay["default"].dash
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificateDisplay["default"].button,
    onClick: onClickHandler,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _certificateDisplay["default"].title
  }, count), /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    className: _certificateDisplay["default"].icon,
    src: _downloadIcon["default"],
    cacheGetRequests: true
  }))));
};
CertificateDisplay.propTypes = {
  count: _propTypes["default"].number.isRequired,
  requestParams: _propTypes["default"].shape({
    classroomId: _propTypes["default"].number,
    startDate: _propTypes["default"].string || null,
    endDate: _propTypes["default"].string || null,
    groupId: _propTypes["default"].number,
    isForDownload: _propTypes["default"].bool,
    userProfileId: _propTypes["default"].string || null
  }),
  service: _propTypes["default"].func,
  onSuccessParams: _propTypes["default"].shape({
    certificateType: _propTypes["default"].number,
    certificatesCount: _propTypes["default"].number,
    className: _propTypes["default"].string
  }),
  isOldCertificates: _propTypes["default"].bool
};
CertificateDisplay.defaultProps = {
  count: 0
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_certificateDisplay["default"])(CertificateDisplay);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "ffxo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".activity-mastery-container---2j8Oc {\n  height: inherit;\n  text-align: left; }\n  .activity-mastery-container---2j8Oc .activity-mastery---1hmcy {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: inherit;\n    min-height: 35px; }\n  .activity-mastery-container---2j8Oc .icon---25BED {\n    width: 16px;\n    height: 20px; }\n  .activity-mastery-container---2j8Oc .icon---25BED svg path {\n      fill: #ffc90d !important; }\n  .activity-mastery-container---2j8Oc .mastered---xlho6 {\n    background: #37c97c;\n    padding-left: 3px;\n    padding-right: 3px; }\n  .activity-mastery-container---2j8Oc .mastered---xlho6 .gold-bars---3rx-w {\n      color: #fff;\n      font-size: 13px;\n      line-height: 13px;\n      font-weight: 500; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq {\n    min-width: 5px; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq.consolidating---2anfU {\n      background: #81daab; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq.developing---29Z6S {\n      background: #f69e13; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq.emerging---3J7Ty {\n      background: #e06d3f; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq.needsImproving---SNOIa {\n      background: #c53902; }\n", ""]);

// exports
exports.locals = {
	"activity-mastery-container": "activity-mastery-container---2j8Oc",
	"activity-mastery": "activity-mastery---1hmcy",
	"icon": "icon---25BED",
	"mastered": "mastered---xlho6",
	"gold-bars": "gold-bars---3rx-w",
	"score-band": "score-band---2urQq",
	"consolidating": "consolidating---2anfU",
	"developing": "developing---29Z6S",
	"emerging": "emerging---3J7Ty",
	"needsImproving": "needsImproving---SNOIa"
};

/***/ }),

/***/ "fwiS":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bDco");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./strength-weakness-topic.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./strength-weakness-topic.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "g1tj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslations = void 0;
var _linguiCdn = __webpack_require__("siuH");
var useTranslations = exports.useTranslations = function useTranslations() {
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  return {
    signIns: i18n._("Usage - SignIns"),
    timeOnline: i18n._("Usage - TimeOnline"),
    curriculumPoints: i18n._("Usage - CurriculumPoints"),
    liveMathsPoints: i18n._("Usage - LiveMathsPoints"),
    goldBars: i18n._("Usage - GoldBars")
  };
};

/***/ }),

/***/ "gN84":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReportDropdown = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ReportDropdown = exports.ReportDropdown = /*#__PURE__*/function (_PureComponent) {
  function ReportDropdown() {
    var _this;
    _classCallCheck(this, ReportDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ReportDropdown, [].concat(args));
    _defineProperty(_this, "optionSelected", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(selectedOption) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.props.setDropdownData(_defineProperty({}, _filterConstants.REPORT_LIST, {
                selectedOption: selectedOption
              }));
            case 1:
              _this.props.handleApplyFilters();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "getReportOptions", function (options) {
      var isAdmin = _this.props.isAdmin;
      if (isAdmin) {
        return options.filter(function (option) {
          return option.value !== _filterConstants.SKILL_QUESTS_MASTERY_OPTION.value;
        });
      }
      return options;
    });
    _defineProperty(_this, "getTranslatedOptions", function (options) {
      var i18n = window.i18n;
      if (i18n) {
        return options.map(function (item) {
          var updatedLabel = "Report Filters - ".concat(item.label);
          return _objectSpread(_objectSpread({}, item), {}, {
            label: i18n._(updatedLabel)
          });
        });
      }
      return options;
    });
    _defineProperty(_this, "getTranslatedSelectedOption", function (selectedOption) {
      var i18n = window.i18n;
      if (i18n) {
        var updatedLabel = "Report Filters - ".concat(selectedOption.value);
        return _objectSpread(_objectSpread({}, selectedOption), {}, {
          label: i18n._(updatedLabel)
        });
      }
      return selectedOption;
    });
    return _this;
  }
  _inherits(ReportDropdown, _PureComponent);
  return _createClass(ReportDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        reportDropdownData = _this$props.reportDropdownData,
        className = _this$props.className;
      var data = reportDropdownData.data,
        selectedOption = reportDropdownData.selectedOption,
        disabled = reportDropdownData.disabled;
      var updatedReportOptions = this.getReportOptions(data);
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
        className: className,
        options: this.getTranslatedOptions(updatedReportOptions),
        selectedOption: this.getTranslatedSelectedOption(selectedOption),
        onSelectOption: this.optionSelected,
        disabled: disabled
      });
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(ReportDropdown, "propTypes", {
  reportDropdownData: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_filterPropTypes.dropdownItemPropType),
    selectedOption: _filterPropTypes.dropdownItemPropType,
    disabled: _propTypes["default"].bool
  }),
  className: _propTypes["default"].string,
  isAdmin: _propTypes["default"].bool,
  handleApplyFilters: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    reportDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.REPORT_LIST)(state),
    isAdmin: state.isAdmin
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setDropdownData: _dropdownDataActions["default"].setDropdownData
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReportDropdown);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "gUpq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ACTIVITY_MASTERY_STUDENT_RETRIEVED = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _student = _interopRequireDefault(__webpack_require__("itiU"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _constants = __webpack_require__("1QGX");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ACTIVITY_MASTERY_STUDENT_RETRIEVED = exports.ACTIVITY_MASTERY_STUDENT_RETRIEVED = 'ACTIVITY_MASTERY_STUDENT_RETRIEVED';
function getActivityMasteryData(classroomId, studentProfileId, selectedDateFilter) {
  return function (dispatch) {
    return _resources["default"].studentReport.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_ACTIVITY_MASTERY
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId,
      userProfileId: studentProfileId
    })).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDateFilter)).send().then(function (payload) {
      if (payload.valid) {
        dispatch({
          type: ACTIVITY_MASTERY_STUDENT_RETRIEVED,
          payload: mapActivityMasteryData(payload.data)
        });
      } else {
        dispatch(_errorsActions["default"].addError(ACTIVITY_MASTERY_STUDENT_RETRIEVED));
      }
    });
  };
}
function mapActivityMasteryData(data) {
  var topicActivityResults = data.topicActivityResults.map(function (result, index) {
    result.id = index;
    result.activityResultDetails = result.activityResultDetails.map(function (detail, i) {
      detail = mapResult(detail, i);
      if (detail.isAssigned) {
        detail.className = _student["default"].assigned;
      }
      return detail;
    });
    return result;
  });
  var strengths = {
    topics: mapStrengthWeakness(data.topicStrengths),
    activities: mapStrengthWeakness(data.activityStrengths)
  };
  var weaknesses = {
    topics: mapStrengthWeakness(data.topicWeaknesses, false),
    activities: mapStrengthWeakness(data.activityWeaknesses, false)
  };
  return {
    className: data.className,
    courseInfo: data.courseInfo,
    topicActivityResults: topicActivityResults,
    testResults: data.testResults.map(mapResult),
    strengths: strengths,
    weaknesses: weaknesses
  };
}
function mapStrengthWeakness(strengthWeakness) {
  var descending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defaultData = {
    id: 0,
    title: '-',
    averageResult: '- '
  };
  if (!strengthWeakness.length) {
    return [defaultData];
  }
  var sorted;
  if (descending) {
    sorted = strengthWeakness.sort(function (a, b) {
      return a.averageResult < b.averageResult;
    });
  } else {
    sorted = strengthWeakness.sort(function (a, b) {
      return a.averageResult > b.averageResult;
    });
  }
  return sorted.map(function (data, idx) {
    return _objectSpread(_objectSpread({}, data), {}, {
      id: idx
    });
  });
}
function mapResult(result, idx) {
  result.id = idx;
  if (result.result === 0 && result.attempts === 0) {
    result.result = -1;
  }
  return result;
}
var _default = exports["default"] = {
  getActivityMasteryData: getActivityMasteryData
};

/***/ }),

/***/ "gYwg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reselect = __webpack_require__("bndy");
var _filterConstants = __webpack_require__("cdWI");
/**
 * Redux selectors for group + student data
 */

var selectStudentsByGroup = function selectStudentsByGroup(state) {
  return state.studentsByGroup;
};
var selectClassId = (0, _reselect.createSelector)([selectStudentsByGroup], function (studentsByGroup) {
  return studentsByGroup && studentsByGroup.id;
});
var selectGroupsAndStudents = (0, _reselect.createSelector)([selectStudentsByGroup], function (studentsByGroup) {
  return studentsByGroup && studentsByGroup.groups;
});
var selectGroupById = function selectGroupById(groupId) {
  return (0, _reselect.createSelector)([selectGroupsAndStudents], function (groups) {
    return groups && groups.find(function (group) {
      return group.id === groupId;
    });
  });
};
var selectStudentsForGroup = function selectStudentsForGroup(groupId) {
  return (0, _reselect.createSelector)([selectGroupById(groupId)], function (group) {
    return group && group.students;
  });
};
var selectGroupForStudent = function selectGroupForStudent(studentId) {
  return (0, _reselect.createSelector)([selectGroupsAndStudents], function (groups) {
    return groups && groups.find(function (group) {
      return group.id !== _filterConstants.ALL_GROUPS && group.students.find(function (student) {
        return student.value === studentId;
      });
    });
  });
};
var _default = exports["default"] = {
  selectStudentsByGroup: selectStudentsByGroup,
  selectClassId: selectClassId,
  selectGroupsAndStudents: selectGroupsAndStudents,
  selectGroupById: selectGroupById,
  selectStudentsForGroup: selectStudentsForGroup,
  selectGroupForStudent: selectGroupForStudent
};

/***/ }),

/***/ "gahV":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".sq-standards-count-container---3Vkym {\n  height: 200px;\n  position: relative;\n  margin-bottom: 15px; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    position: absolute;\n    left: -20px;\n    min-height: 200px;\n    background-color: #ccdcea;\n    width: calc(100% + 40px); }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        max-width: 300px;\n        height: 122px;\n        margin: 0 18px; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf:first-child {\n          margin-left: 0; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf:last-child {\n          margin-right: 0; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between;\n          padding: 10px;\n          position: relative;\n          border: none;\n          pointer-events: none; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G.box-button---19dxY {\n            pointer-events: all; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G .label---3Es-W {\n            width: 80%;\n            font-weight: 600; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G .value---2o1qu {\n            color: #278bcb;\n            text-align: right;\n            font-size: 24px; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G .modal-button-container---3SeMn {\n            position: absolute;\n            width: 15px;\n            height: 15px;\n            top: 0;\n            right: 0;\n            background-color: #278bcb; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G .modal-button-container---3SeMn .modal-button---AjWab {\n              background-color: transparent;\n              border: 0; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G .modal-button-container---3SeMn .modal-button---AjWab div {\n                width: 100%;\n                height: auto;\n                -webkit-transform: rotate(45deg);\n                        transform: rotate(45deg);\n                padding: 1px 0 0;\n                -webkit-box-pack: center;\n                    -ms-flex-pack: center;\n                        justify-content: center; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G .modal-button-container---3SeMn .modal-button---AjWab div svg {\n                  width: 12px;\n                  height: 12px; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G .modal-button-container---3SeMn .modal-button---AjWab div svg path {\n                    fill: #fff !important; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G:first-child {\n            width: 50%;\n            border-top-left-radius: 10px;\n            border-bottom-left-radius: 10px; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf .box---1eR8G:nth-child(2) {\n            width: 50%;\n            border-top-right-radius: 10px;\n            border-bottom-right-radius: 10px; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf.STANDARDS---Srl4s .box---1eR8G:first-child {\n          background-color: #dceeff; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf.STANDARDS---Srl4s .box---1eR8G:last-child {\n          background-color: #ecf6ff; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf.SKILL_QUESTS---1ztsG .box---1eR8G:first-child {\n          background-color: #fff2ac; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf.SKILL_QUESTS---1ztsG .box---1eR8G:last-child {\n          background-color: #ffface; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf.AVERAGE_ACCURACY---3vKDR .box---1eR8G:first-child {\n          background-color: #ccf3e0; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf.AVERAGE_ACCURACY---3vKDR .box---1eR8G:last-child {\n          background-color: #e8fcf1; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf.HIGHEST_ACCURACY---2OCuj .box---1eR8G:first-child {\n          background-color: #dde4ff; }\n  .sq-standards-count-container---3Vkym .sq-standards-count-wrapper---1zKQp .content-box-container---Z6hzx .content-box---3v6Pf.HIGHEST_ACCURACY---2OCuj .box---1eR8G:last-child {\n          background-color: #eaeeff; }\n  .accuracy-modal---2PVD5 .accuracy-modal-header---yRPsK {\n  margin-bottom: 5px; }\n  .accuracy-modal---2PVD5 .accuracy-modal-header---yRPsK .header-text---3hKnF {\n    margin: 0 10px;\n    font-size: 22px;\n    font-weight: 500; }\n  .accuracy-modal---2PVD5 .accuracy-modal-header---yRPsK .header-separator---iOMfn {\n    border-right: 2px solid #dde4ff; }\n  .accuracy-modal---2PVD5 .date-range---krnNQ {\n  display: block;\n  float: left;\n  clear: both;\n  font-size: 16px;\n  color: #1981c4;\n  float: none;\n  margin-bottom: 8px; }\n  .accuracy-modal---2PVD5 .accuracy-list---3k4ce {\n  max-height: 400px;\n  overflow: auto; }\n  .accuracy-modal---2PVD5 .accuracy-list---3k4ce .topicName---2kzvs {\n    font-weight: bold;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding-bottom: 3px; }\n  .accuracy-modal---2PVD5 .accuracy-list---3k4ce .accuracy-item-container---n6wNi {\n    border-bottom: 1px #278bcb solid;\n    margin-bottom: 10px; }\n  .accuracy-modal---2PVD5 .accuracy-list---3k4ce .accuracy-item-container---n6wNi .accuracy-item---pOfbU {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      padding: 3px 0; }\n  .accuracy-modal---2PVD5 .accuracy-list---3k4ce .accuracy-item-container---n6wNi:last-child {\n      border-bottom: none;\n      margin-bottom: 0; }\n", ""]);

// exports
exports.locals = {
	"sq-standards-count-container": "sq-standards-count-container---3Vkym",
	"sq-standards-count-wrapper": "sq-standards-count-wrapper---1zKQp",
	"content-box-container": "content-box-container---Z6hzx",
	"content-box": "content-box---3v6Pf",
	"box": "box---1eR8G",
	"box-button": "box-button---19dxY",
	"label": "label---3Es-W",
	"value": "value---2o1qu",
	"modal-button-container": "modal-button-container---3SeMn",
	"modal-button": "modal-button---AjWab",
	"STANDARDS": "STANDARDS---Srl4s",
	"SKILL_QUESTS": "SKILL_QUESTS---1ztsG",
	"AVERAGE_ACCURACY": "AVERAGE_ACCURACY---3vKDR",
	"HIGHEST_ACCURACY": "HIGHEST_ACCURACY---2OCuj",
	"accuracy-modal": "accuracy-modal---2PVD5",
	"accuracy-modal-header": "accuracy-modal-header---yRPsK",
	"header-text": "header-text---3hKnF",
	"header-separator": "header-separator---iOMfn",
	"date-range": "date-range---krnNQ",
	"accuracy-list": "accuracy-list---3k4ce",
	"topicName": "topicName---2kzvs",
	"accuracy-item-container": "accuracy-item-container---n6wNi",
	"accuracy-item": "accuracy-item---pOfbU"
};

/***/ }),

/***/ "gnit":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".filter-container---1fd2s {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: relative;\n  margin-left: 14px; }\n  .filter-container---1fd2s .border---PIYGK {\n    border-right: 1px solid #e4eaef;\n    height: 36px;\n    margin-left: 14px; }\n  .filter-container---1fd2s .separator---2R6d3 {\n    margin: 0 4px; }\n  .filter-container---1fd2s .work-button---7Tv2_ {\n    background-color: #dae4eb;\n    color: #000;\n    border-radius: 24px;\n    min-width: 154px;\n    height: 30px;\n    padding: 0 5px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    font-weight: 500; }\n  .filter-container---1fd2s .work-button---7Tv2_.selected---x02c0 {\n      background-color: #00b4eb;\n      color: #fff;\n      -webkit-box-pack: start;\n          -ms-flex-pack: start;\n              justify-content: flex-start;\n      pointer-events: none; }\n  .filter-container---1fd2s .work-button---7Tv2_ div {\n      background-color: white;\n      border-radius: 24px;\n      height: 20px;\n      width: 20px;\n      margin-right: 10px;\n      padding: 0; }\n  .filter-container---1fd2s .work-button---7Tv2_ div svg {\n        width: 20px;\n        height: 14px; }\n  .filter-container---1fd2s .work-button---7Tv2_ div svg path {\n          fill: #00b4eb !important; }\n  .filter-container---1fd2s .filter-button---2DuNE {\n    background-color: #278bcb;\n    color: #fff;\n    border-radius: 24px;\n    width: 200px;\n    height: 30px;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between; }\n  .filter-container---1fd2s .filter-button---2DuNE .text---ovvYs {\n      width: 140px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      text-align: left; }\n  .filter-container---1fd2s .filter-button---2DuNE svg {\n      -webkit-transform: rotate(180deg);\n              transform: rotate(180deg);\n      height: 14px; }\n  .filter-container---1fd2s .filter-context-modal---IkdHl {\n    top: 60px;\n    right: -16px; }\n  .filter-container---1fd2s .filter-context-modal---IkdHl .filters-modal---2_Guf {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      -webkit-box-align: end;\n          -ms-flex-align: end;\n              align-items: end;\n      width: 588px;\n      height: 63px; }\n  .filter-container---1fd2s .filter-context-modal---IkdHl .filters-modal---2_Guf .dropdown-container---178er {\n        width: 240px; }\n  .filter-container---1fd2s .filter-context-modal---IkdHl .filters-modal---2_Guf .dropdown-container---178er .dropdown-header---1Q2NY {\n          color: #4e5c67;\n          font-weight: 600; }\n  .filter-container---1fd2s .filter-context-modal---IkdHl .filters-modal---2_Guf .dropdown-button---3aRh3 {\n        background-color: #278bcb;\n        color: #fff;\n        width: 80px;\n        height: 40px;\n        border-radius: 24px; }\n", ""]);

// exports
exports.locals = {
	"filter-container": "filter-container---1fd2s",
	"border": "border---PIYGK",
	"separator": "separator---2R6d3",
	"work-button": "work-button---7Tv2_",
	"selected": "selected---x02c0",
	"filter-button": "filter-button---2DuNE",
	"text": "text---ovvYs",
	"filter-context-modal": "filter-context-modal---IkdHl",
	"filters-modal": "filters-modal---2_Guf",
	"dropdown-container": "dropdown-container---178er",
	"dropdown-header": "dropdown-header---1Q2NY",
	"dropdown-button": "dropdown-button---3aRh3"
};

/***/ }),

/***/ "gxHR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GLqN");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./busy-indicator.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./busy-indicator.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hb1i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Q_PER_MIN = exports.CLASS_NAME = exports.CLASS_ID = exports.ALL_YEARS_TABLE_CONFIG = exports.ALL_CLASSES_TABLE_CONFIG = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _allClasses = _interopRequireDefault(__webpack_require__("vIzN"));
var _liveMathsLevelPicker = _interopRequireDefault(__webpack_require__("kQVy"));
var _filterConstants = __webpack_require__("cdWI");
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CLASS_ID = exports.CLASS_ID = 'id';
var CLASS_NAME = exports.CLASS_NAME = 'name';
var Q_PER_MIN = exports.Q_PER_MIN = 'questionsPerMinute';
var TOTAL_CORRECT = 'totalCorrect';
var ACCURACY = 'accuracy';
var TOP_SCORE = 'topScore';
var generateColHeader = function generateColHeader(mainText, subText) {
  var i18n = window.i18n;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _allClasses["default"]['col-header']
  }, /*#__PURE__*/_react["default"].createElement("span", null, i18n._(mainText)), subText && /*#__PURE__*/_react["default"].createElement("span", null, "(", i18n._(subText), ")"));
};
var ALL_CLASSES_TABLE_CONFIG = exports.ALL_CLASSES_TABLE_CONFIG = {
  cols: [{
    id: CLASS_NAME,
    doTranslation: true,
    name: (0, _localeHelpers.getTranslationKey)(_filterConstants.ALL_CLASSES),
    transform: function transform() {
      return (0, _localeHelpers.getTranslationKey)(_filterConstants.LEVEL);
    },
    sort: {
      sortAs: 'string'
    },
    classes: _allClasses["default"].level
  }, {
    id: Q_PER_MIN,
    headerTransform: function headerTransform() {
      return generateColHeader('Q/MIN', 'Column Header - Avg');
    },
    transform: function transform() {
      return /*#__PURE__*/_react["default"].createElement(_liveMathsLevelPicker["default"], null);
    },
    colSpan: 4,
    classes: _allClasses["default"]['level-picker']
  }, {
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - Correct', 'Column Header - Total');
    }
  }, {
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - Accuracy', 'Column Header - Avg');
    }
  }, {
    headerTransform: function headerTransform() {
      return generateColHeader('Column Header - TopScore', 'Column Header - Lifetime');
    }
  }],
  nestedData: {
    id: 'classes',
    cols: [{
      id: CLASS_NAME,
      truncate: true,
      classes: _allClasses["default"]['class-name'],
      sort: {
        sortAs: 'string'
      },
      onClick: function onClick() {
        return null;
      } // this is set in the AllClasses component
    }, {
      id: Q_PER_MIN
    }, {
      id: TOTAL_CORRECT
    }, {
      id: ACCURACY
    }, {
      id: TOP_SCORE
    }],
    emptyDataMessage: 'Empty - NoLiveResultsForLevel'
  },
  emptyDataMessage: 'Empty - NoLiveResults',
  defaultSort: CLASS_NAME
};
var ALL_YEARS_TABLE_CONFIG = exports.ALL_YEARS_TABLE_CONFIG = (0, _cloneDeep["default"])(_objectSpread(_objectSpread({}, ALL_CLASSES_TABLE_CONFIG), {}, {
  defaultSort: CLASS_ID
}));
ALL_YEARS_TABLE_CONFIG.cols[0].name = (0, _localeHelpers.getTranslationKey)(_filterConstants.ALL_YEARS);
ALL_YEARS_TABLE_CONFIG.cols[0].doTranslation = true;
ALL_YEARS_TABLE_CONFIG.nestedData.cols[0] = _objectSpread(_objectSpread({}, ALL_YEARS_TABLE_CONFIG.nestedData.cols[0]), {}, {
  id: CLASS_ID,
  sort: {
    sortAs: 'number'
  },
  transform: function transform(row) {
    return row[CLASS_NAME];
  }
});

/***/ }),

/***/ "hfIg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _formatPicker = _interopRequireDefault(__webpack_require__("EWtM"));
var _formatPickerActions = __webpack_require__("AzNC");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * FORMAT PICKER
 * Content in skills quests mastery modal that determines the report format.
 * @param updateReportFormat: Action to manage report formats
 * @param reportFormats: Currently selected report formats array
 */
var FormatPicker = /*#__PURE__*/function (_Component) {
  function FormatPicker(props) {
    var _this;
    _classCallCheck(this, FormatPicker);
    _this = _callSuper(this, FormatPicker, [props]);
    _this.i18n = window.i18n;
    _this.text = {
      contentTop: _this.i18n._('Format Picker - Your report will download in Excel format.'),
      contentBottom: _this.i18n._('Format Picker - Please note that large reports may take several minutes to download.'),
      radioGroup: _this.i18n._('Format Picker - format-picker'),
      reportFormatHeader: _this.i18n._('Format Picker - Report Format *'),
      reportFormatFooter: _this.i18n._('Format Picker - * Required Selection')
    };
    return _this;
  }
  _inherits(FormatPicker, _Component);
  return _createClass(FormatPicker, [{
    key: "render",
    value: function render() {
      var _this$text = this.text,
        contentTop = _this$text.contentTop,
        contentBottom = _this$text.contentBottom;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _formatPicker["default"]['format-picker']
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: _formatPicker["default"].content
      }, contentTop), /*#__PURE__*/_react["default"].createElement("p", {
        className: _formatPicker["default"].content
      }, contentBottom));
    }
  }]);
}(_react.Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    reportFormats: state.formatReport.reportFormats
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    updateReportFormat: _formatPickerActions.updateReportFormat
  }, dispatch);
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_formatPicker["default"])(FormatPicker));

/***/ }),

/***/ "hvkE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("gnit");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./top-level-filter.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./top-level-filter.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hwkD":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".download-modal-content---2wF_P {\n  text-align: left; }\n  .download-modal-content---2wF_P .report-type---3fEsA {\n    margin-top: 20px; }\n  .download-modal-content---2wF_P .report-type---3fEsA .header---2ABN5 {\n      font-weight: bold; }\n  .download-modal-content---2wF_P .selection-group---2-Fpu {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border: 1px #a2c4e3 solid;\n    height: 40px; }\n  .download-modal-content---2wF_P .selection-group---2-Fpu .selection---1yI2K {\n      padding: 0 10px; }\n  .download-modal-content---2wF_P .selection-group---2-Fpu .selection---1yI2K label {\n        padding-left: 10px; }\n  .download-modal-content---2wF_P .footer---2p8vs {\n    margin-top: 10px;\n    text-align: right; }\n", ""]);

// exports
exports.locals = {
	"download-modal-content": "download-modal-content---2wF_P",
	"report-type": "report-type---3fEsA",
	"header": "header---2ABN5",
	"selection-group": "selection-group---2-Fpu",
	"selection": "selection---1yI2K",
	"footer": "footer---2p8vs"
};

/***/ }),

/***/ "hxFo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ConnectedClassDropdown", {
  enumerable: true,
  get: function get() {
    return _classDropdown["default"];
  }
});
Object.defineProperty(exports, "ConnectedDateDropdown", {
  enumerable: true,
  get: function get() {
    return _dateDropdown["default"];
  }
});
Object.defineProperty(exports, "ConnectedGroupDropdown", {
  enumerable: true,
  get: function get() {
    return _groupDropdown["default"];
  }
});
Object.defineProperty(exports, "ConnectedReportDropdown", {
  enumerable: true,
  get: function get() {
    return _reportDropdown["default"];
  }
});
Object.defineProperty(exports, "ConnectedStudentDropdown", {
  enumerable: true,
  get: function get() {
    return _studentDropdown["default"];
  }
});
Object.defineProperty(exports, "ConnectedTeacherDropdown", {
  enumerable: true,
  get: function get() {
    return _teacherDropdown["default"];
  }
});
Object.defineProperty(exports, "ConnectedYearGroupDropdown", {
  enumerable: true,
  get: function get() {
    return _yearGroupDropdown["default"];
  }
});
var _yearGroupDropdown = _interopRequireDefault(__webpack_require__("UtIO"));
var _teacherDropdown = _interopRequireDefault(__webpack_require__("Rv4c"));
var _classDropdown = _interopRequireDefault(__webpack_require__("rQyF"));
var _groupDropdown = _interopRequireDefault(__webpack_require__("C3P3"));
var _studentDropdown = _interopRequireDefault(__webpack_require__("yC/G"));
var _reportDropdown = _interopRequireDefault(__webpack_require__("gN84"));
var _dateDropdown = _interopRequireDefault(__webpack_require__("J8ts"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }

/***/ }),

/***/ "hyqk":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---RbsQm {\n  background-color: #fff;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 16px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end; }\n  .component---RbsQm .export-btn---2ZY-u {\n    margin-left: 5px;\n    font-size: 14px;\n    padding: 6px 20px; }\n  .component---RbsQm .download-btn---3tNR- {\n    margin-left: 5px;\n    font-size: 14px;\n    padding: 6px 20px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---RbsQm",
	"export-btn": "export-btn---2ZY-u",
	"download-btn": "download-btn---3tNR-"
};

/***/ }),

/***/ "i0Ya":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _busyIndicatorActions = __webpack_require__("qS76");
var defaultState = 0;

/**
 * BusyIndicator Reducer
 *
 * Consumes HIDE_BUSY action
 * Consumes SHOW_BUSY action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type
 * @returns {number} the new state
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _busyIndicatorActions.SHOW_BUSY:
      return state + 1;
    case _busyIndicatorActions.HIDE_BUSY:
      return state > 0 ? state - 1 : 0;
    default:
      return state;
  }
}

/***/ }),

/***/ "iDSV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("cVtY");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./student.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./student.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "iUhG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UPDATE_MODAL = exports.OPEN_MODAL = exports.CLOSE_MODAL = void 0;
var _reduxActions = __webpack_require__("sTbe");
var OPEN_MODAL = exports.OPEN_MODAL = 'OPEN_MODAL';
var CLOSE_MODAL = exports.CLOSE_MODAL = 'CLOSE_MODAL';
var UPDATE_MODAL = exports.UPDATE_MODAL = 'UPDATE_MODAL';
var openModal = (0, _reduxActions.createAction)(OPEN_MODAL);
var closeModal = (0, _reduxActions.createAction)(CLOSE_MODAL);
var updateModal = (0, _reduxActions.createAction)(UPDATE_MODAL);
var _default = exports["default"] = {
  openModal: openModal,
  closeModal: closeModal,
  updateModal: updateModal
};

/***/ }),

/***/ "iUu1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _icon_back = _interopRequireDefault(__webpack_require__("0dCu"));
var _icon_information = _interopRequireDefault(__webpack_require__("SsAK"));
var _studentDataTable = _interopRequireDefault(__webpack_require__("060x"));
var _assignmentResultReducer = __webpack_require__("llwb");
var _studentDataTranslations = __webpack_require__("t/wp");
var _studentHelpers = __webpack_require__("GejO");
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _topicBox = _interopRequireDefault(__webpack_require__("Kl0G"));
var _contextModal = _interopRequireDefault(__webpack_require__("vuxJ"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StudentDataTable = /*#__PURE__*/function (_Component) {
  function StudentDataTable(props) {
    var _this;
    _classCallCheck(this, StudentDataTable);
    _this = _callSuper(this, StudentDataTable, [props]);
    /**
     * DATA MANAGEMENT
     */
    _defineProperty(_this, "manageSkillQuestsMasteryStudentData", function (nextProps) {
      var updatedSkillQuestsMasteryStudentData = nextProps.skillQuestsMasteryStudentData;
      var tableProperties = _this.state.tableProperties;
      if (updatedSkillQuestsMasteryStudentData && updatedSkillQuestsMasteryStudentData.reportData === null && tableProperties !== null) {
        _this.resetTableProperties();
      }
      if (updatedSkillQuestsMasteryStudentData && updatedSkillQuestsMasteryStudentData.reportData && tableProperties === null) {
        _this.setupTableProperties(updatedSkillQuestsMasteryStudentData);
      }
    });
    /**
     * TABLE PROPERTIES
     */
    _defineProperty(_this, "resetTableProperties", function () {
      _this.setState({
        tableProperties: null
      });
    });
    _defineProperty(_this, "setupTableProperties", function (data) {
      _this.setState({
        tableProperties: (0, _studentHelpers.getInitialTableProperties)(data)
      });
    });
    /**
     * ERROR HANDLING
     */
    _defineProperty(_this, "hasLoadedInitData", function () {
      var skillQuestsMasteryStudentData = _this.props.skillQuestsMasteryStudentData;
      var tableProperties = _this.state.tableProperties;
      return skillQuestsMasteryStudentData && skillQuestsMasteryStudentData.reportData && tableProperties !== null;
    });
    /**
     * CLICK HANDLERS
     */
    _defineProperty(_this, "onCourseClickHandler", function (courseKey) {
      _this.setState({
        tableProperties: _objectSpread(_objectSpread({}, _this.state.tableProperties), {}, _defineProperty({}, courseKey, (0, _studentHelpers.getUpdatedCourseLevelState)(_this.state.tableProperties, courseKey)))
      });
    });
    _defineProperty(_this, "onStrandClickHandler", function (courseKey, strandKey) {
      _this.setState({
        tableProperties: _objectSpread(_objectSpread({}, _this.state.tableProperties), {}, _defineProperty({}, courseKey, _objectSpread(_objectSpread({}, _this.state.tableProperties[courseKey]), {}, {
          subLevel: _objectSpread(_objectSpread({}, _this.state.tableProperties[courseKey].subLevel), {}, _defineProperty({}, strandKey, (0, _studentHelpers.getUpdatedStrandLevelState)(_this.state.tableProperties, courseKey, strandKey)))
        })))
      });
    });
    _defineProperty(_this, "onStandardClickHandler", function (courseKey, strandKey, standardKey) {
      _this.setState({
        tableProperties: _objectSpread(_objectSpread({}, _this.state.tableProperties), {}, _defineProperty({}, courseKey, _objectSpread(_objectSpread({}, _this.state.tableProperties[courseKey]), {}, {
          subLevel: _objectSpread(_objectSpread({}, _this.state.tableProperties[courseKey].subLevel), {}, _defineProperty({}, strandKey, _objectSpread(_objectSpread({}, _this.state.tableProperties[courseKey].subLevel[strandKey]), {}, {
            subLevel: _objectSpread(_objectSpread({}, _this.state.tableProperties[courseKey].subLevel[strandKey].subLevel), {}, _defineProperty({}, standardKey, (0, _studentHelpers.getUpdatedStandardLevelState)(_this.state.tableProperties, courseKey, strandKey, standardKey)))
          })))
        })))
      });
    });
    /**
     * CLASSNAMES
     */
    _defineProperty(_this, "getCourseLevelClassName", function (courseKey) {
      var tableProperties = _this.state.tableProperties;
      var baseClass = _studentDataTable["default"]['course-holder'];
      if (tableProperties[courseKey].isExpanded) {
        baseClass = "".concat(baseClass, " ").concat(_studentDataTable["default"].expanded);
      }
      return baseClass;
    });
    _defineProperty(_this, "getStrandLevelClassName", function (courseKey, strandKey) {
      var tableProperties = _this.state.tableProperties;
      var baseClass = _studentDataTable["default"]['strand-content'];
      if (tableProperties[courseKey].subLevel[strandKey].isExpanded) {
        baseClass = "".concat(baseClass, " ").concat(_studentDataTable["default"].expanded);
      }
      return baseClass;
    });
    _defineProperty(_this, "getStandardLevelClassName", function (courseKey, strandKey, standardKey) {
      var tableProperties = _this.state.tableProperties;
      var baseClass = _studentDataTable["default"]['standard-wrapper'];
      if (tableProperties[courseKey].subLevel[strandKey].subLevel[standardKey].isExpanded) {
        baseClass = "".concat(baseClass, " ").concat(_studentDataTable["default"].expanded);
      }
      return baseClass;
    });
    _defineProperty(_this, "getColorBandClassName", function (hasStarted, accuracy) {
      if (!hasStarted) return _studentDataTable["default"].NOT_ASSIGNED;
      if (accuracy <= 20) {
        return _studentDataTable["default"].RED;
      } else if (accuracy > 20 && accuracy <= 40) {
        return _studentDataTable["default"].ORANGE;
      } else if (accuracy > 40 && accuracy <= 60) {
        return _studentDataTable["default"].DARK_BLUE;
      } else if (accuracy > 60 && accuracy <= 80) {
        return _studentDataTable["default"].LIGHT_BLUE;
      } else if (accuracy > 80 && accuracy <= 100) {
        return _studentDataTable["default"].GREEN;
      }
      return '';
    });
    /**
     * RENDER
     */
    _defineProperty(_this, "renderTableCourse", function (publicationName, courseName, courseKey) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['course-wrapper']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['course-button-wrapper']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        className: _studentDataTable["default"]['course-button'],
        icon: _icon_back["default"],
        onClick: function onClick() {
          return _this.onCourseClickHandler(courseKey);
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['course-name']
      }, "".concat(publicationName, " - ").concat(courseName)));
    });
    _defineProperty(_this, "renderTableStrandHeader", function (strand, strandKey, courseKey) {
      var name = strand.name,
        averageAccuracy = strand.averageAccuracy;
      var hasStarted = averageAccuracy !== null;
      var colorBandClassname = "".concat(_studentDataTable["default"]['color-band'], " ").concat(_this.getColorBandClassName(hasStarted, averageAccuracy));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['strand-header']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: colorBandClassname
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['strand-title']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        className: _studentDataTable["default"]['strand-button'],
        icon: _icon_back["default"],
        onClick: function onClick() {
          return _this.onStrandClickHandler(courseKey, strandKey);
        }
      }), name));
    });
    _defineProperty(_this, "renderTableHeaderInfoButton", function (text) {
      var modalClassNameOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['info-button-wrapper']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        className: _studentDataTable["default"]['info-button'],
        icon: _icon_information["default"],
        onClick: function onClick() {}
      }), /*#__PURE__*/_react["default"].createElement(_contextModal["default"], {
        className: "".concat(_studentDataTable["default"]['info-context-modal'], " ").concat(modalClassNameOverride),
        show: true,
        onClickOutsideHandler: function onClickOutsideHandler() {}
      }, text));
    });
    _defineProperty(_this, "getCompletedTextDiv", function () {
      var _studentDataTranslati = (0, _studentDataTranslations.studentDataTranslations)(),
        infoCompletedTextOne = _studentDataTranslati.infoCompletedTextOne,
        infoCompletedTextTwo = _studentDataTranslati.infoCompletedTextTwo,
        infoCompletedTextThree = _studentDataTranslati.infoCompletedTextThree;
      var onCompletedTextClickHandler = _this.props.onCompletedTextClickHandler;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, infoCompletedTextOne), /*#__PURE__*/_react["default"].createElement("button", {
        className: _studentDataTable["default"]['completed-info-button'],
        onClick: function onClick() {
          return onCompletedTextClickHandler();
        }
      }, infoCompletedTextTwo), /*#__PURE__*/_react["default"].createElement("p", null, infoCompletedTextThree));
    });
    _defineProperty(_this, "renderTableStandardTitle", function (assignmentResultType) {
      var _studentDataTranslati2 = (0, _studentDataTranslations.studentDataTranslations)(),
        standardText = _studentDataTranslati2.standardText,
        completedText = _studentDataTranslati2.completedText,
        allHighestInfoText = _studentDataTranslati2.allHighestInfoText,
        teacherAssignedInfoText = _studentDataTranslati2.teacherAssignedInfoText,
        voluntaryInfoText = _studentDataTranslati2.voluntaryInfoText,
        standardProgressText = _studentDataTranslati2.standardProgressText;
      var HIGHEST = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.HIGHEST,
        TEACHER_ASSIGNED = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.TEACHER_ASSIGNED,
        VOLUNTARY = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.VOLUNTARY;
      var infoText;
      switch (assignmentResultType) {
        case HIGHEST:
          infoText = allHighestInfoText;
          break;
        case TEACHER_ASSIGNED:
          infoText = teacherAssignedInfoText;
          break;
        case VOLUNTARY:
          infoText = voluntaryInfoText;
          break;
        default:
          infoText = '';
          break;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['standard-title']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]["long"]
      }, standardText), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]["long"]
      }, standardProgressText, _this.renderTableHeaderInfoButton(infoText)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]["short"]
      }, completedText, _this.renderTableHeaderInfoButton(_this.getCompletedTextDiv(), _studentDataTable["default"]['right-edge-override'])));
    });
    _defineProperty(_this, "getStandardHeaderText", function (standard) {
      if (standard.externalKey) return "".concat(standard.externalKey, " ").concat(standard.description);
      return standard.description;
    });
    _defineProperty(_this, "renderTableStandardContent", function (standard, standardKey, strandKey, courseKey) {
      var NOT_ASSIGNED = _skillQuestsMasteryConstants.ASSIGNMENT_STATUSES.NOT_ASSIGNED,
        ASSIGNED = _skillQuestsMasteryConstants.ASSIGNMENT_STATUSES.ASSIGNED;
      var averageAccuracy = standard.averageAccuracy,
        status = standard.status,
        learningJourneysCount = standard.learningJourneysCount,
        completedLearningJourneysCount = standard.completedLearningJourneysCount;
      var completedText = "".concat(completedLearningJourneysCount, "/").concat(learningJourneysCount);
      var hasStarted = !(status === NOT_ASSIGNED || status === ASSIGNED);
      var colorBandClass = "".concat(_studentDataTable["default"]['color-band'], " ").concat(_this.getColorBandClassName(hasStarted, averageAccuracy));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['standard-content-border']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: colorBandClass
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['standard-content']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
        className: _studentDataTable["default"]['standard-button'],
        icon: _icon_back["default"],
        onClick: function onClick() {
          return _this.onStandardClickHandler(courseKey, strandKey, standardKey);
        }
      }), /*#__PURE__*/_react["default"].createElement("span", null, _this.getStandardHeaderText(standard))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['standard-separator']
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['standard-completed']
      }, completedText));
    });
    _defineProperty(_this, "renderTableTopic", function (topic) {
      var name = topic.name,
        id = topic.id,
        learningJourneys = topic.learningJourneys,
        learningJourneysCount = topic.learningJourneysCount,
        completedLearningJourneysCount = topic.completedLearningJourneysCount;
      var topicKey = "topic-".concat(name, "-").concat(id);
      var completedText = "".concat(completedLearningJourneysCount, "/").concat(learningJourneysCount);
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "topic-".concat(name, "-").concat(id),
        className: _studentDataTable["default"]['topic-wrapper']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['color-band']
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['topic-content']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['topic-name']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['topic-text']
      }, name)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['topic-status']
      }, learningJourneys.map(function (journey) {
        return /*#__PURE__*/_react["default"].createElement(_topicBox["default"], {
          journey: journey,
          key: "".concat(topicKey, "-").concat(journey.id)
        });
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _studentDataTable["default"]['topic-completed']
      }, completedText)));
    });
    _this.state = {
      tableProperties: null
    };
    return _this;
  }
  _inherits(StudentDataTable, _Component);
  return _createClass(StudentDataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupTableProperties(this.props.skillQuestsMasteryStudentData);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.manageSkillQuestsMasteryStudentData(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        skillQuestsMasteryStudentData = _this$props.skillQuestsMasteryStudentData,
        assignmentResultType = _this$props.assignmentResultType;
      if (this.hasLoadedInitData()) {
        if ((0, _studentHelpers.hasValidCourses)(skillQuestsMasteryStudentData)) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _studentDataTable["default"]['data-table']
          }, skillQuestsMasteryStudentData.reportData.courses.map(function (course) {
            var courseKey = (0, _studentHelpers.getCourseKey)(course);
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: courseKey,
              className: _this2.getCourseLevelClassName(courseKey)
            }, _this2.renderTableCourse(course.publicationName, course.courseName, courseKey), /*#__PURE__*/_react["default"].createElement("div", {
              className: _studentDataTable["default"].strands
            }, course.strands.map(function (strand) {
              var strandKey = (0, _studentHelpers.getStrandKey)(strand);
              return /*#__PURE__*/_react["default"].createElement("div", {
                key: strandKey,
                className: _this2.getStrandLevelClassName(courseKey, strandKey)
              }, _this2.renderTableStrandHeader(strand, strandKey, courseKey), /*#__PURE__*/_react["default"].createElement("div", {
                className: _studentDataTable["default"]['strand-wrapper']
              }, _this2.renderTableStandardTitle(assignmentResultType), strand.standards.map(function (standard) {
                var standardKey = (0, _studentHelpers.getStandardKey)(standard);
                return /*#__PURE__*/_react["default"].createElement("div", {
                  className: _this2.getStandardLevelClassName(courseKey, strandKey, standardKey),
                  key: standardKey
                }, _this2.renderTableStandardContent(standard, standardKey, strandKey, courseKey), standard.topics.map(function (topic) {
                  return _this2.renderTableTopic(topic);
                }));
              })));
            })));
          }));
        }
      }
      return null;
    }
  }]);
}(_react.Component);
_defineProperty(StudentDataTable, "propTypes", {
  skillQuestsMasteryStudentData: _propTypes["default"].object,
  onCompletedTextClickHandler: _propTypes["default"].func,
  assignmentResultType: _propTypes["default"].number
});
var _default = exports["default"] = (0, _reactStyleable["default"])(_studentDataTable["default"])(StudentDataTable);

/***/ }),

/***/ "iV3T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _resource = _interopRequireDefault(__webpack_require__("P7H2"));
var _localResourceConfig = _interopRequireDefault(__webpack_require__("2z6x"));
var _appConfig = __webpack_require__("N5/L");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-console */
var BasicResources = /*#__PURE__*/function () {
  function BasicResources() {
    _classCallCheck(this, BasicResources);
  }
  return _createClass(BasicResources, null, [{
    key: "initialise",
    value: function initialise(envName, credentials) {
      var env = (0, _resource["default"])(envName, _appConfig.appName);
      var location = window.location;
      var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
      if (runningOnDeveloperMachine) {
        if (envName === 'local') {
          // This implies we'll be hitting the mock REST server,
          // which does not require authentication.

          env.bypassAuthentication();
          env.setConfiguration(_localResourceConfig["default"]);
        } else if (credentials.authToken) {
          env.authToken = credentials.authToken;
        } else {
          env.setCredentials(credentials.username, credentials.password);
        }
      } else if (credentials.authToken) {
        env.authToken = credentials.authToken;
      } else if (credentials.username && credentials.password) {
        env.username = credentials.username;
        env.password = credentials.password;
      } else {
        // The caller should have provided a valid set of credentials, so
        // hopefully this will never happen.

        console.log('BasicResources.initialise() - to execute, we need either an authToken or' + ' a username/password pair.  The credentials object that was provided does not' + ' contain either.  So, expect things to fail badly :-(.');
      }
      return env;
    }
  }]);
}();
var _default = exports["default"] = BasicResources;

/***/ }),

/***/ "itiU":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("l2ek");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./student.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./student.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ivll":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _linguiCdn = __webpack_require__("siuH");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _dropdownUp = _interopRequireDefault(__webpack_require__("j6ze"));
var _dropdownDown = _interopRequireDefault(__webpack_require__("ruIP"));
var _rankDropdown = _interopRequireDefault(__webpack_require__("fXC1"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable no-undef */
var RankDropdown = function RankDropdown(_ref) {
  var certificatesCount = _ref.certificatesCount,
    options = _ref.options,
    setSelectedGems = _ref.setSelectedGems;
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var all = i18n._("Label - All");
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isAllSelected = _useState4[0],
    setIsAllSelected = _useState4[1];
  var _useState5 = (0, _react.useState)(options.map(function () {
      return true;
    })),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedOptions = _useState6[0],
    setSelectedOptions = _useState6[1];
  var _useState7 = (0, _react.useState)(all),
    _useState8 = _slicedToArray(_useState7, 2),
    title = _useState8[0],
    setTitle = _useState8[1];
  var _useState9 = (0, _react.useState)(certificatesCount),
    _useState0 = _slicedToArray(_useState9, 2),
    downloadCount = _useState0[0],
    setDownloadCount = _useState0[1];
  var dropdownRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var handleOutsideClick = function handleOutsideClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (show) {
          setShow(false);
          event.stopPropagation();
        } else {
          setShow(true);
        }
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return function () {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [show]);
  var handleToggle = function handleToggle() {
    setShow(!show);
  };
  var getButtonText = function getButtonText() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _rankDropdown["default"].text,
      key: "rank-button",
      title: title
    }, title, " (", downloadCount, ")");
  };
  var toggleSelectAll = function toggleSelectAll() {
    var updatedSelect = !isAllSelected;
    setIsAllSelected(updatedSelect);
    if (updatedSelect) {
      setSelectedOptions(options.map(function () {
        return true;
      }));
      setDownloadCount(certificatesCount);
      setSelectedGems(options);
      setTitle(all);
    } else {
      setSelectedOptions(options.map(function () {
        return false;
      }));
      setDownloadCount(0);
      setSelectedGems([]);
      setTitle('');
    }
  };
  var convertToRoman = function convertToRoman(num) {
    if (num === 16) {
      return '∞';
    }
    var numberArr = [10, 9, 5, 4, 1];
    var RomanArr = ['X', 'IX', 'V', 'IV', 'I'];
    var result = [];
    var findElement = function findElement(e) {
      return e <= num;
    };
    while (num > 0) {
      var nextHighest = numberArr.find(findElement);
      if (nextHighest) {
        result.push(RomanArr[numberArr.indexOf(nextHighest)]);
        num -= nextHighest;
      }
    }
    return result.join('');
  };
  var selectOption = function selectOption(isChecked, index) {
    var updatedOptions = [].concat(_toConsumableArray(selectedOptions.slice(0, index)), [isChecked], _toConsumableArray(selectedOptions.slice(index + 1)));
    setSelectedOptions(updatedOptions);
    if (!isChecked) {
      setIsAllSelected(false);
    } else {
      setIsAllSelected(updatedOptions.every(function (value) {
        return value;
      }));
    }
    var newArray = options.filter(function (opt, optIndex) {
      return updatedOptions[optIndex] && opt.count > 0;
    });
    var gemsTypes = newArray.map(function (item) {
      return item.gem;
    });
    setSelectedGems(newArray);
    setDownloadCount(newArray.reduce(function (acc, item) {
      return acc + item.count;
    }, 0));
    setTitle(updatedOptions.every(function (value) {
      return value;
    }) ? all : gemsTypes.map(function (item) {
      return convertToRoman(item);
    }).join(', '));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _rankDropdown["default"]['dropdown-container']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    className: _rankDropdown["default"]['dropdown-trigger'],
    tabIndex: 0,
    onClick: handleToggle
  }, getButtonText(), /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: show ? _dropdownUp["default"] : _dropdownDown["default"]
  })), show && /*#__PURE__*/_react["default"].createElement("div", {
    ref: dropdownRef,
    className: _rankDropdown["default"]['dropdown-options-container']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _rankDropdown["default"]['dropdown-option']
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
    className: _rankDropdown["default"]['check-box'],
    id: all,
    name: all,
    type: "checkbox",
    checked: isAllSelected,
    onChange: function onChange() {
      return toggleSelectAll();
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: all
  }, all)), /*#__PURE__*/_react["default"].createElement("div", null, certificatesCount)), options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _rankDropdown["default"]['dropdown-option'],
      key: option.gem
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("input", {
      className: _rankDropdown["default"]['check-box'],
      id: option.gem,
      name: option.gem,
      type: "checkbox",
      checked: selectedOptions[option.gem - 1],
      disabled: option.count === 0,
      onChange: function onChange(e) {
        return selectOption(e.target.checked, index);
      }
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: option.gem
    }, convertToRoman(option.gem))), /*#__PURE__*/_react["default"].createElement("div", null, option.count));
  })));
};
RankDropdown.propTypes = {
  certificatesCount: _propTypes["default"].number.isRequired,
  options: _propTypes["default"].array,
  setSelectedGems: _propTypes["default"].func
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_rankDropdown["default"])(RankDropdown);

/***/ }),

/***/ "j4FC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _sessionIdActions = __webpack_require__("KYjY");
var defaultState = null;

/**
 * Session ID Reducer
 *
 * Consumes SET_SESSION_ID action
 *
 * @param {number} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {number} - current session id to send in backend requests
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _sessionIdActions.SET_SESSION_ID:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "j6ze":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/27fc07ebfd45adc967ea6c0662e345f2.svg";

/***/ }),

/***/ "jJ7R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _icon_star = _interopRequireDefault(__webpack_require__("IJC2"));
var _activityStatusBar = _interopRequireDefault(__webpack_require__("tAK5"));
var _activityMasteryPropType = __webpack_require__("+NxA");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MIN_WIDTH = 15;
var INCREMENT_WIDTH_ABOVE_NUM_DIGITS = 2;
var WIDTH_INCREMENT = 8;

/**
 * ActivityStatusBar component - displays activity status bar
 * Takes activityMastery param to draw the horizontal score band
 */
var ActivityStatusBar = /*#__PURE__*/function (_Component) {
  function ActivityStatusBar(props) {
    var _this;
    _classCallCheck(this, ActivityStatusBar);
    _this = _callSuper(this, ActivityStatusBar, [props]);
    _defineProperty(_this, "calculateWidth", function (bandScore) {
      var activityMastery = _this.props.activityMastery;
      return Math.round(bandScore / activityMastery.totalActivities * 100);
    });
    _defineProperty(_this, "renderMasteredBand", function () {
      var _this$props$activityM = _this.props.activityMastery,
        goldBars = _this$props$activityM.goldBars,
        scoreBand = _this$props$activityM.scoreBand;
      var minMasteredBandWidth = _this.state.minMasteredBandWidth;
      if (scoreBand.mastered > 0) {
        var width = _this.calculateWidth(scoreBand.mastered);
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _activityStatusBar["default"].mastered,
          style: {
            width: "".concat(width, "%"),
            minWidth: "".concat(minMasteredBandWidth, "px")
          }
        }, goldBars > 0 && _this.renderGold());
      }
      return null;
    });
    _defineProperty(_this, "renderGold", function () {
      var goldBars = _this.props.activityMastery.goldBars;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _activityStatusBar["default"].icon
      }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
        src: _icon_star["default"],
        cacheGetRequests: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _activityStatusBar["default"]['gold-bars']
      }, goldBars));
    });
    _defineProperty(_this, "renderScorebands", function () {
      var activityMastery = _this.props.activityMastery;
      var scoreBands = ['consolidating', 'developing', 'emerging', 'needsImproving'];
      return scoreBands.map(function (val) {
        var scoreBandVal = activityMastery.scoreBand[val];
        if (scoreBandVal > 0) {
          var width = _this.calculateWidth(scoreBandVal);
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(_activityStatusBar["default"][val], " ").concat(_activityStatusBar["default"]['score-band']),
            style: {
              width: "".concat(width, "%")
            },
            key: val
          });
        }
        return null;
      });
    });
    _this.state = {
      minMasteredBandWidth: null
    };
    return _this;
  }
  _inherits(ActivityStatusBar, _Component);
  return _createClass(ActivityStatusBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculateMinWidth(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this.calculateMinWidth(newProps);
    }
  }, {
    key: "calculateMinWidth",
    value: function calculateMinWidth(props) {
      var numDigits = "".concat(props.activityMastery.goldBars).length;
      var minMasteredBandWidth = MIN_WIDTH;
      if (numDigits > INCREMENT_WIDTH_ABOVE_NUM_DIGITS) {
        minMasteredBandWidth += (numDigits - 2) * WIDTH_INCREMENT;
      }
      this.setState({
        minMasteredBandWidth: minMasteredBandWidth
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.activityMastery.scoreBand) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _activityStatusBar["default"]['activity-mastery-container']
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _activityStatusBar["default"]['activity-mastery']
      }, this.renderMasteredBand(), this.renderScorebands()));
    }
  }]);
}(_react.Component);
ActivityStatusBar.propTypes = {
  activityMastery: _activityMasteryPropType.activityMasteryPropType
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_activityStatusBar["default"])(ActivityStatusBar);

/***/ }),

/***/ "jSO5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _constants = __webpack_require__("1QGX");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED = exports.ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED = 'ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED';
function getActivityMasteryData(selectedDate, selectedYearGroupId, selectedTeacherId) {
  return function (dispatch, getState) {
    var state = getState();
    if (state.isAdmin === true) {
      getAdminData(dispatch, selectedDate, selectedYearGroupId, selectedTeacherId);
    } else {
      getTeacherData(dispatch, selectedDate);
    }
  };
}
function getAdminData(dispatch, selectedDate, selectedYearGroupId, selectedTeacherId) {
  var yearGroupId = _constants.ENDPOINT_PATH_ALL_YEARS;
  var teacherId = _constants.ENDPOINT_PATH_ALL_TEACHERS;
  var resource = 'yearGroupReport';
  if (selectedYearGroupId != null && selectedYearGroupId !== _filterConstants.ALL_YEARS) {
    yearGroupId = selectedYearGroupId;
  }
  if (selectedTeacherId != null && selectedTeacherId !== _filterConstants.ALL_TEACHERS) {
    teacherId = selectedTeacherId;
    resource = 'teacherReport';
  }
  var params = _objectSpread(_objectSpread({
    reportType: _constants.ENDPOINT_PATH_ACTIVITY_MASTERY
  }, _dateParamHelper["default"].getDateTypePath(selectedDate)), {}, {
    yearGroupId: yearGroupId,
    teacherId: teacherId
  });
  getData(resource, dispatch, selectedDate, params);
}
function getTeacherData(dispatch, selectedDate) {
  getData('allClassesReport', dispatch, selectedDate);
}
function getData(resource, dispatch, selectedDate) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  params = _objectSpread(_objectSpread({
    reportType: _constants.ENDPOINT_PATH_ACTIVITY_MASTERY
  }, _dateParamHelper["default"].getDateTypePath(selectedDate)), params);
  _resources["default"][resource].get(params).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDate)).send().then(function (payload) {
    if (payload.valid) {
      dispatch({
        type: ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED,
        payload: mapActivityMasteryData(payload.data)
      });
    } else {
      dispatch(_errorsActions["default"].addError(ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED));
    }
  });
}
function mapActivityMasteryData(data) {
  var allClassesData = data.allClassroomActivityMasterys;
  var allClassesActivityMastery;
  var classroomActivityMasterys;
  if (allClassesData) {
    allClassesActivityMastery = {
      scoreBand: {
        mastered: allClassesData.allMasteredScores,
        consolidating: allClassesData.allConsolidatingScores,
        developing: allClassesData.allDevelopingScores,
        emerging: allClassesData.allEmergingScores,
        needsImproving: allClassesData.allNeedsImprovingScores
      },
      goldBars: allClassesData.allGoldbars,
      totalActivities: allClassesData.allTotalActivities
    };
    classroomActivityMasterys = allClassesData.classroomActivityMasterys;
  } else {
    allClassesActivityMastery = {};
    classroomActivityMasterys = [];
  }
  return {
    allClassesActivityMastery: allClassesActivityMastery,
    classroomActivityMasterys: classroomActivityMasterys,
    courseStrengths: mapStrengthWeakness(data.courseStrengths),
    courseWeaknesses: mapStrengthWeakness(data.courseWeaknesses, false)
  };
}
function mapStrengthWeakness(strengthWeakness) {
  var descending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defaultData = {
    id: 0,
    classroomName: '-',
    title: '-',
    averageResult: '- '
  };
  if (!strengthWeakness || strengthWeakness.length === 0) {
    return [defaultData];
  }
  if (descending) {
    strengthWeakness = strengthWeakness.sort(function (a, b) {
      return a.averageResult < b.averageResult;
    });
  } else {
    strengthWeakness = strengthWeakness.sort(function (a, b) {
      return a.averageResult > b.averageResult;
    });
  }
  return strengthWeakness.map(function (item, idx) {
    return _objectSpread(_objectSpread({}, item), {}, {
      id: idx
    });
  });
}
var _default = exports["default"] = {
  getActivityMasteryData: getActivityMasteryData
};

/***/ }),

/***/ "jf7A":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("09qS");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./all-classes.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./all-classes.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jipn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _singleClassActions = __webpack_require__("WKZP");
var initialState = null;

/**
 * Participation - Single Class Reducer
 *
 * Consumes PARTICIPATION_CLASS_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _singleClassActions.PARTICIPATION_CLASS_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "jq2L":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".PresetDateRangePicker_panel---u7gSi {\n  padding: 0 22px 11px; }\n\n.PresetDateRangePicker_button---2whY2 {\n  position: relative;\n  height: 100%;\n  text-align: center;\n  background: 0 0;\n  border: 2px solid #00a699;\n  color: #00a699;\n  padding: 4px 12px;\n  margin-right: 8px;\n  font: inherit;\n  font-weight: 700;\n  line-height: normal;\n  overflow: visible;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  cursor: pointer; }\n\n.PresetDateRangePicker_button---2whY2:active {\n  outline: 0; }\n\n.PresetDateRangePicker_button__selected---2o9Nw {\n  color: #fff;\n  background: #00a699; }\n\n.SingleDatePickerInput---3wdF8 {\n  display: inline-block;\n  background-color: #fff; }\n\n.SingleDatePickerInput__withBorder---2ltVn {\n  border: 1px solid #dbdbdb; }\n\n.SingleDatePickerInput__rtl---Cub4E {\n  direction: rtl; }\n\n.SingleDatePickerInput__disabled---940zk {\n  background-color: #f2f2f2; }\n\n.SingleDatePickerInput__block---1FztY {\n  display: block; }\n\n.SingleDatePickerInput__showClearDate---3gO76 {\n  padding-right: 30px; }\n\n.SingleDatePickerInput_clearDate---Z1myQ {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%); }\n\n.SingleDatePickerInput_clearDate__default---hQEBR:focus,\n.SingleDatePickerInput_clearDate__default---hQEBR:hover {\n  background: #dbdbdb;\n  border-radius: 50%; }\n\n.SingleDatePickerInput_clearDate__small---3oqj8 {\n  padding: 6px; }\n\n.SingleDatePickerInput_clearDate__hide---DY5Fr {\n  visibility: hidden; }\n\n.SingleDatePickerInput_clearDate_svg---2XNHi {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle; }\n\n.SingleDatePickerInput_clearDate_svg__small---3u1rD {\n  height: 9px; }\n\n.SingleDatePickerInput_calendarIcon---289I- {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px; }\n\n.SingleDatePickerInput_calendarIcon_svg---2YHDY {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle; }\n\n.SingleDatePicker---2c2_j {\n  position: relative;\n  display: inline-block; }\n\n.SingleDatePicker__block---1SN3b {\n  display: block; }\n\n.SingleDatePicker_picker---jUB1o {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute; }\n\n.SingleDatePicker_picker__rtl---32QoG {\n  direction: rtl; }\n\n.SingleDatePicker_picker__directionLeft---qJLcx {\n  left: 0; }\n\n.SingleDatePicker_picker__directionRight---LMWo6 {\n  right: 0; }\n\n.SingleDatePicker_picker__portal---1CA4m {\n  background-color: rgba(0, 0, 0, .3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%; }\n\n.SingleDatePicker_picker__fullScreenPortal---1vT-B {\n  background-color: #fff; }\n\n.SingleDatePicker_closeButton---MUqGI {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2; }\n\n.SingleDatePicker_closeButton---MUqGI:focus,\n.SingleDatePicker_closeButton---MUqGI:hover {\n  color: #b0b3b4;\n  text-decoration: none; }\n\n.SingleDatePicker_closeButton_svg---1dJEe {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd; }\n\n.DayPickerKeyboardShortcuts_buttonReset---1y-U1 {\n  background: 0 0;\n  border: 0;\n  border-radius: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  font-size: 14px; }\n\n.DayPickerKeyboardShortcuts_buttonReset---1y-U1:active {\n  outline: 0; }\n\n.DayPickerKeyboardShortcuts_show---IBzFB {\n  width: 22px;\n  position: absolute;\n  z-index: 2; }\n\n.DayPickerKeyboardShortcuts_show__bottomRight---1FuB4 {\n  border-top: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  bottom: 0;\n  right: 0; }\n\n.DayPickerKeyboardShortcuts_show__bottomRight---1FuB4:hover {\n  border-right: 33px solid #008489; }\n\n.DayPickerKeyboardShortcuts_show__topRight---3cL1- {\n  border-bottom: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  top: 0;\n  right: 0; }\n\n.DayPickerKeyboardShortcuts_show__topRight---3cL1-:hover {\n  border-right: 33px solid #008489; }\n\n.DayPickerKeyboardShortcuts_show__topLeft---3wB6B {\n  border-bottom: 26px solid transparent;\n  border-left: 33px solid #00a699;\n  top: 0;\n  left: 0; }\n\n.DayPickerKeyboardShortcuts_show__topLeft---3wB6B:hover {\n  border-left: 33px solid #008489; }\n\n.DayPickerKeyboardShortcuts_showSpan---17FNR {\n  color: #fff;\n  position: absolute; }\n\n.DayPickerKeyboardShortcuts_showSpan__bottomRight---3se8P {\n  bottom: 0;\n  right: -28px; }\n\n.DayPickerKeyboardShortcuts_showSpan__topRight---30vTB {\n  top: 1px;\n  right: -28px; }\n\n.DayPickerKeyboardShortcuts_showSpan__topLeft---PWaPo {\n  top: 1px;\n  left: -28px; }\n\n.DayPickerKeyboardShortcuts_panel---TS9T0 {\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  padding: 22px;\n  margin: 33px; }\n\n.DayPickerKeyboardShortcuts_title---2Au3g {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0; }\n\n.DayPickerKeyboardShortcuts_list---3o02L {\n  list-style: none;\n  padding: 0;\n  font-size: 14px; }\n\n.DayPickerKeyboardShortcuts_close---1QW1o {\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 2; }\n\n.DayPickerKeyboardShortcuts_close---1QW1o:active {\n  outline: 0; }\n\n.DayPickerKeyboardShortcuts_closeSvg---11faX {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd; }\n\n.DayPickerKeyboardShortcuts_closeSvg---11faX:focus,\n.DayPickerKeyboardShortcuts_closeSvg---11faX:hover {\n  fill: #82888a; }\n\n.CalendarDay---3GA6Y {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center; }\n\n.CalendarDay---3GA6Y:active {\n  outline: 0; }\n\n.CalendarDay__defaultCursor---cIQRC {\n  cursor: default; }\n\n.CalendarDay__default---31AgS {\n  border: 1px solid #e4e7e7;\n  color: #484848;\n  background: #fff; }\n\n.CalendarDay__default---31AgS:hover {\n  background: #e4e7e7;\n  border: 1px double #e4e7e7;\n  color: inherit; }\n\n.CalendarDay__hovered_offset---3VPdL {\n  background: #f4f5f5;\n  border: 1px double #e4e7e7;\n  color: inherit; }\n\n.CalendarDay__outside---17YVa {\n  border: 0;\n  background: #fff;\n  color: #484848; }\n\n.CalendarDay__blocked_minimum_nights---aJC-w {\n  background: #fff;\n  border: 1px solid #eceeee;\n  color: #cacccd; }\n\n.CalendarDay__blocked_minimum_nights---aJC-w:active,\n.CalendarDay__blocked_minimum_nights---aJC-w:hover {\n  background: #fff;\n  color: #cacccd; }\n\n.CalendarDay__highlighted_calendar---3J_Ow {\n  background: #ffe8bc;\n  color: #484848; }\n\n.CalendarDay__highlighted_calendar---3J_Ow:active,\n.CalendarDay__highlighted_calendar---3J_Ow:hover {\n  background: #ffce71;\n  color: #484848; }\n\n.CalendarDay__selected_span----Jy3S {\n  background: #66e2da;\n  border: 1px solid #33dacd;\n  color: #fff; }\n\n.CalendarDay__selected_span----Jy3S:active,\n.CalendarDay__selected_span----Jy3S:hover {\n  background: #33dacd;\n  border: 1px solid #33dacd;\n  color: #fff; }\n\n.CalendarDay__last_in_range---3r60c {\n  border-right: #00a699; }\n\n.CalendarDay__selected---38GVR,\n.CalendarDay__selected---38GVR:active,\n.CalendarDay__selected---38GVR:hover {\n  background: #00a699;\n  border: 1px solid #00a699;\n  color: #fff; }\n\n.CalendarDay__hovered_span---1pTi8,\n.CalendarDay__hovered_span---1pTi8:hover {\n  background: #b2f1ec;\n  border: 1px solid #80e8e0;\n  color: #007a87; }\n\n.CalendarDay__hovered_span---1pTi8:active {\n  background: #80e8e0;\n  border: 1px solid #80e8e0;\n  color: #007a87; }\n\n.CalendarDay__blocked_calendar---1Bh2l,\n.CalendarDay__blocked_calendar---1Bh2l:active,\n.CalendarDay__blocked_calendar---1Bh2l:hover {\n  background: #cacccd;\n  border: 1px solid #cacccd;\n  color: #82888a; }\n\n.CalendarDay__blocked_out_of_range---2X5gS,\n.CalendarDay__blocked_out_of_range---2X5gS:active,\n.CalendarDay__blocked_out_of_range---2X5gS:hover {\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  color: #cacccd; }\n\n.CalendarMonth---39dEL {\n  background: #fff;\n  text-align: center;\n  padding: 0 13px;\n  vertical-align: top;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.CalendarMonth_table---s04AZ {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\n.CalendarMonth_verticalSpacing---194h3 {\n  border-collapse: separate; }\n\n.CalendarMonth_caption---3XAMN {\n  color: #484848;\n  font-size: 18px;\n  text-align: center;\n  padding-top: 22px;\n  padding-bottom: 37px;\n  caption-side: top;\n  caption-side: initial; }\n\n.CalendarMonth_caption__verticalScrollable---1oKJA {\n  padding-top: 12px;\n  padding-bottom: 7px; }\n\n.CalendarMonthGrid---P-rrB {\n  background: #fff;\n  text-align: left;\n  z-index: 0; }\n\n.CalendarMonthGrid__animating---3hIHa {\n  z-index: 1; }\n\n.CalendarMonthGrid__horizontal---2QVSE {\n  position: absolute;\n  left: 9px; }\n\n.CalendarMonthGrid__vertical---2hc6Z {\n  margin: 0 auto; }\n\n.CalendarMonthGrid__vertical_scrollable---3c9Kg {\n  margin: 0 auto;\n  overflow-y: scroll; }\n\n.CalendarMonthGrid_month__horizontal---3r7-p {\n  display: inline-block;\n  vertical-align: top;\n  min-height: 100%; }\n\n.CalendarMonthGrid_month__hideForAnimation---1fgvY {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none; }\n\n.CalendarMonthGrid_month__hidden---CIjNV {\n  visibility: hidden; }\n\n.DayPickerNavigation_container---3GCub {\n  position: relative;\n  z-index: 2; }\n\n.DayPickerNavigation_container__vertical---2H-ZV {\n  background: #fff;\n  -webkit-box-shadow: 0 0 5px 2px rgba(0, 0, 0, .1);\n          box-shadow: 0 0 5px 2px rgba(0, 0, 0, .1);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 52px;\n  width: 100%; }\n\n.DayPickerNavigation_container__verticalScrollable---dd1Op {\n  position: relative; }\n\n.DayPickerNavigation_button---V8lxy {\n  cursor: pointer;\n  line-height: 0.78;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.DayPickerNavigation_button__default---3H_f8 {\n  border: 1px solid #e4e7e7;\n  background-color: #fff;\n  color: #757575; }\n\n.DayPickerNavigation_button__default---3H_f8:focus,\n.DayPickerNavigation_button__default---3H_f8:hover {\n  border: 1px solid #c4c4c4; }\n\n.DayPickerNavigation_button__default---3H_f8:active {\n  background: #f2f2f2; }\n\n.DayPickerNavigation_button__horizontal---3hMsu {\n  border-radius: 3px;\n  padding: 6px 9px;\n  top: 18px;\n  position: absolute; }\n\n.DayPickerNavigation_leftButton__horizontal---3DoPb {\n  left: 22px; }\n\n.DayPickerNavigation_rightButton__horizontal---3rjxO {\n  right: 22px; }\n\n.DayPickerNavigation_button__vertical---2MXL1 {\n  display: inline-block;\n  position: relative;\n  height: 100%;\n  width: 50%; }\n\n.DayPickerNavigation_button__vertical__default---39rH3 {\n  padding: 5px; }\n\n.DayPickerNavigation_nextButton__vertical__default---1MR4l {\n  border-left: 0; }\n\n.DayPickerNavigation_nextButton__verticalScrollable---1pGwq {\n  width: 100%; }\n\n.DayPickerNavigation_svg__horizontal---3Z9Zy {\n  height: 19px;\n  width: 19px;\n  fill: #82888a; }\n\n.DayPickerNavigation_svg__vertical---3zynz {\n  height: 42px;\n  width: 42px;\n  fill: #484848; }\n\n.DayPicker---2GFse {\n  background: #fff;\n  position: relative;\n  text-align: left; }\n\n.DayPicker__horizontal---3hEIr {\n  background: #fff; }\n\n.DayPicker__verticalScrollable---3_fzF {\n  height: 100%; }\n\n.DayPicker__hidden---5bzf9 {\n  visibility: hidden; }\n\n.DayPicker__withBorder---1LsLG {\n  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, .05), 0 0 0 1px rgba(0, 0, 0, .07);\n          box-shadow: 0 2px 6px rgba(0, 0, 0, .05), 0 0 0 1px rgba(0, 0, 0, .07);\n  border-radius: 3px; }\n\n.DayPicker_portal__horizontal---uC_5p {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  position: absolute;\n  left: 50%;\n  top: 50%; }\n\n.DayPicker_portal__vertical---2Whrv {\n  position: static;\n  position: initial; }\n\n.DayPicker_focusRegion---3DgEv {\n  outline: 0; }\n\n.DayPicker_calendarInfo__horizontal---1zREP,\n.DayPicker_wrapper__horizontal---1eth3 {\n  display: inline-block;\n  vertical-align: top; }\n\n.DayPicker_weekHeaders---6Alqp {\n  position: relative; }\n\n.DayPicker_weekHeaders__horizontal---27vzR {\n  margin-left: 9px; }\n\n.DayPicker_weekHeader---33tHV {\n  color: #757575;\n  position: absolute;\n  top: 62px;\n  z-index: 2;\n  padding: 0 13px;\n  text-align: left; }\n\n.DayPicker_weekHeader__vertical---2HRrE {\n  left: 50%; }\n\n.DayPicker_weekHeader__verticalScrollable---2stnX {\n  top: 0;\n  display: table-row;\n  border-bottom: 1px solid #dbdbdb;\n  background: #fff;\n  margin-left: 0;\n  left: 0;\n  width: 100%;\n  text-align: center; }\n\n.DayPicker_weekHeader_ul---AKnCu {\n  list-style: none;\n  margin: 1px 0;\n  padding-left: 0;\n  padding-right: 0;\n  font-size: 14px; }\n\n.DayPicker_weekHeader_li---2e1Yc {\n  display: inline-block;\n  text-align: center; }\n\n.DayPicker_transitionContainer---A-sRo {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px; }\n\n.DayPicker_transitionContainer__horizontal---2qQ0m {\n  -webkit-transition: height 0.2s ease-in-out;\n  transition: height 0.2s ease-in-out; }\n\n.DayPicker_transitionContainer__vertical---3SX1m {\n  width: 100%; }\n\n.DayPicker_transitionContainer__verticalScrollable----mnwk {\n  padding-top: 20px;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  overflow-y: scroll; }\n\n.DateInput---3yt5Z {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: inline-block;\n  width: 130px;\n  vertical-align: middle; }\n\n.DateInput__small---1A_55 {\n  width: 97px; }\n\n.DateInput__block---2hOz9 {\n  width: 100%; }\n\n.DateInput__disabled---C-nLp {\n  background: #f2f2f2;\n  color: #dbdbdb; }\n\n.DateInput_input---74GxT {\n  font-weight: 200;\n  font-size: 19px;\n  line-height: 24px;\n  color: #484848;\n  background-color: #fff;\n  width: 100%;\n  padding: 11px 11px 9px;\n  border-top-width: 0;\n  border-right-width: 0;\n  border-bottom: 2px solid transparent;\n  border-left-width: 0;\n  border-radius: 0; }\n\n.DateInput_input__small---1lTct {\n  font-size: 15px;\n  line-height: 18px;\n  letter-spacing: 0.2px;\n  padding: 7px 7px 5px; }\n\n.DateInput_input__regular---2FOAM {\n  font-weight: inherit; }\n\n.DateInput_input__readOnly---1xhiB {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n\n.DateInput_input__focused---HKLd8 {\n  outline: 0;\n  background: #fff;\n  border-top-width: 0;\n  border-right-width: 0;\n  border-bottom: 2px solid #008489;\n  border-left-width: 0; }\n\n.DateInput_input__disabled---tgWjK {\n  background: #f2f2f2;\n  font-style: italic; }\n\n.DateInput_screenReaderMessage---1MCff {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.DateInput_fang---2Shg8 {\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  left: 22px;\n  z-index: 2; }\n\n.DateInput_fangShape---2Eghu {\n  fill: #fff; }\n\n.DateInput_fangStroke---2CNk7 {\n  stroke: #dbdbdb;\n  fill: transparent; }\n\n.DateRangePickerInput---3M_j7 {\n  background-color: #fff;\n  display: inline-block; }\n\n.DateRangePickerInput__disabled---3hldm {\n  background: #f2f2f2; }\n\n.DateRangePickerInput__withBorder---1OzIv {\n  border: 1px solid #dbdbdb;\n  border-radius: 2px; }\n\n.DateRangePickerInput__rtl---2VDo_ {\n  direction: rtl; }\n\n.DateRangePickerInput__block---1k2PF {\n  display: block; }\n\n.DateRangePickerInput__showClearDates---1jqnt {\n  padding-right: 30px; }\n\n.DateRangePickerInput_arrow---1FWnd {\n  display: inline-block;\n  vertical-align: middle;\n  color: #484848; }\n\n.DateRangePickerInput_arrow_svg---2olFE {\n  vertical-align: middle;\n  fill: #484848;\n  height: 24px;\n  width: 24px; }\n\n.DateRangePickerInput_clearDates---t3DK4 {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  padding: 10px;\n  margin: 0 10px 0 5px;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%); }\n\n.DateRangePickerInput_clearDates__small---1IZ3q {\n  padding: 6px; }\n\n.DateRangePickerInput_clearDates_default---25hOI:focus,\n.DateRangePickerInput_clearDates_default---25hOI:hover {\n  background: #dbdbdb;\n  border-radius: 50%; }\n\n.DateRangePickerInput_clearDates__hide---31WAj {\n  visibility: hidden; }\n\n.DateRangePickerInput_clearDates_svg---3Zo8S {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle; }\n\n.DateRangePickerInput_clearDates_svg__small---3ZJik {\n  height: 9px; }\n\n.DateRangePickerInput_calendarIcon---2lrfS {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px; }\n\n.DateRangePickerInput_calendarIcon_svg----4l1j {\n  fill: #82888a;\n  height: 15px;\n  width: 14px;\n  vertical-align: middle; }\n\n.DateRangePicker---2BePN {\n  position: relative;\n  display: inline-block; }\n\n.DateRangePicker__block---1mEOO {\n  display: block; }\n\n.DateRangePicker_picker---1ZCDU {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute; }\n\n.DateRangePicker_picker__rtl---1SqBh {\n  direction: rtl; }\n\n.DateRangePicker_picker__directionLeft---a7ZrM {\n  left: 0; }\n\n.DateRangePicker_picker__directionRight---2dmYK {\n  right: 0; }\n\n.DateRangePicker_picker__portal---1nOqq {\n  background-color: rgba(0, 0, 0, .3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%; }\n\n.DateRangePicker_picker__fullScreenPortal---2y4gl {\n  background-color: #fff; }\n\n.DateRangePicker_closeButton---fON14 {\n  background: 0 0;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2; }\n\n.DateRangePicker_closeButton---fON14:focus,\n.DateRangePicker_closeButton---fON14:hover {\n  color: #b0b3b4;\n  text-decoration: none; }\n\n.DateRangePicker_closeButton_svg---2ocQY {\n  height: 15px;\n  width: 15px;\n  fill: #cacccd; }\n\n.date-picker-wrapper---1Jy4H {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 16px; }\n\n.DateRangePicker_picker {\n  top: 34px !important;\n  left: -379px !important; }\n\n.DayPicker {\n  border: 1px solid #d6d6d6 !important;\n  -webkit-box-shadow: 3px 3px rgba(72, 72, 72, .5) !important;\n          box-shadow: 3px 3px rgba(72, 72, 72, .5) !important;\n  font-family: poppins, Arial, sans-serif !important;\n  color: #4e5c67 !important;\n  background-color: #fff;\n  border-radius: 3px; }\n\n.DateRangePickerInput {\n  border-color: #a2bdd3 !important;\n  border-top-left-radius: 3px !important;\n  border-bottom-left-radius: 3px !important;\n  height: inherit !important; }\n\n.DateInput {\n  width: 85px !important;\n  margin: 4px 15px 3px 8px !important; }\n\n.DateInput_input {\n  font-size: 14px !important;\n  font-family: poppins, Arial, sans-serif !important;\n  line-height: normal;\n  padding: 5px 0 !important;\n  text-align: center !important;\n  -webkit-box-sizing: border-box !important;\n          box-sizing: border-box !important;\n  border: 0 !important; }\n\n.DateInput_input__focused {\n  border: 1px solid #1981c4 !important; }\n\n.DateInput_fang {\n  display: none !important; }\n\n.CalendarMonth,\n.CalendarMonthGrid {\n  background-color: #fff; }\n\n.DayPickerNavigation_button__default {\n  background-color: #fff !important;\n  color: #4e5c67 !important;\n  border-color: #d6d6d6 !important; }\n\n.DayPickerNavigation_button__default svg path {\n    fill: currentColor !important; }\n\n.DayPickerNavigation_button__default:hover {\n    border-color: #4e5c67 !important; }\n\n.CalendarMonth_caption,\n.DayPicker_weekHeader {\n  color: #4e5c67 !important; }\n\n.CalendarDay {\n  -webkit-box-sizing: border-box !important;\n          box-sizing: border-box !important;\n  border: 1px solid #e7e9ea !important;\n  vertical-align: middle;\n  color: #757575; }\n\n.CalendarDay:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected) {\n    background-color: #cfd2d4 !important;\n    color: inherit !important; }\n\n.CalendarDay:not(.CalendarDay__blocked_out_of_range):not(.CalendarDay__selected):hover {\n      background-color: #999b9d !important;\n      color: #fff !important; }\n\n.CalendarDay__selected.CalendarDay__today {\n  background: none !important;\n  color: #757575 !important;\n  text-decoration: underline !important; }\n\n.CalendarDay__blocked_out_of_range,\n.CalendarDay__blocked_out_of_range:active,\n.CalendarDay__blocked_out_of_range:focus,\n.CalendarDay__blocked_out_of_range:hover {\n  color: #cacccd !important;\n  outline: 0;\n  border-color: #e7e9ea !important; }\n\n.CalendarDay__selected,\n.CalendarDay__selected:hover,\n.CalendarDay__selected:focus,\n.CalendarDay__selected.CalendarDay__blocked_out_of_range {\n  background: #4e5c67;\n  color: #fff;\n  outline: none; }\n\n.CalendarDay__selected_span,\n.CalendarDay__selected_span:hover,\n.CalendarDay__selected_span.CalendarDay__blocked_out_of_range {\n  background: #dae5ed;\n  color: #fff;\n  text-decoration: none; }\n\n.CalendarDay__selected_start,\n.CalendarDay__selected_end {\n  background: #4e5c67 !important;\n  color: #fff !important;\n  text-decoration: none; }\n\n.CalendarDay__hovered_span,\n.CalendarDay__hovered_span:hover,\n.CalendarDay__hovered_span.CalendarDay__blocked_out_of_range {\n  background-color: #dae5ed !important;\n  color: #4e5c67 !important; }\n\n.CalendarDay__selected_span:not(.CalendarDay__blocked_out_of_range:hover) {\n  background-color: #1981c4 !important;\n  color: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"PresetDateRangePicker_panel": "PresetDateRangePicker_panel---u7gSi",
	"PresetDateRangePicker_button": "PresetDateRangePicker_button---2whY2",
	"PresetDateRangePicker_button__selected": "PresetDateRangePicker_button__selected---2o9Nw",
	"SingleDatePickerInput": "SingleDatePickerInput---3wdF8",
	"SingleDatePickerInput__withBorder": "SingleDatePickerInput__withBorder---2ltVn",
	"SingleDatePickerInput__rtl": "SingleDatePickerInput__rtl---Cub4E",
	"SingleDatePickerInput__disabled": "SingleDatePickerInput__disabled---940zk",
	"SingleDatePickerInput__block": "SingleDatePickerInput__block---1FztY",
	"SingleDatePickerInput__showClearDate": "SingleDatePickerInput__showClearDate---3gO76",
	"SingleDatePickerInput_clearDate": "SingleDatePickerInput_clearDate---Z1myQ",
	"SingleDatePickerInput_clearDate__default": "SingleDatePickerInput_clearDate__default---hQEBR",
	"SingleDatePickerInput_clearDate__small": "SingleDatePickerInput_clearDate__small---3oqj8",
	"SingleDatePickerInput_clearDate__hide": "SingleDatePickerInput_clearDate__hide---DY5Fr",
	"SingleDatePickerInput_clearDate_svg": "SingleDatePickerInput_clearDate_svg---2XNHi",
	"SingleDatePickerInput_clearDate_svg__small": "SingleDatePickerInput_clearDate_svg__small---3u1rD",
	"SingleDatePickerInput_calendarIcon": "SingleDatePickerInput_calendarIcon---289I-",
	"SingleDatePickerInput_calendarIcon_svg": "SingleDatePickerInput_calendarIcon_svg---2YHDY",
	"SingleDatePicker": "SingleDatePicker---2c2_j",
	"SingleDatePicker__block": "SingleDatePicker__block---1SN3b",
	"SingleDatePicker_picker": "SingleDatePicker_picker---jUB1o",
	"SingleDatePicker_picker__rtl": "SingleDatePicker_picker__rtl---32QoG",
	"SingleDatePicker_picker__directionLeft": "SingleDatePicker_picker__directionLeft---qJLcx",
	"SingleDatePicker_picker__directionRight": "SingleDatePicker_picker__directionRight---LMWo6",
	"SingleDatePicker_picker__portal": "SingleDatePicker_picker__portal---1CA4m",
	"SingleDatePicker_picker__fullScreenPortal": "SingleDatePicker_picker__fullScreenPortal---1vT-B",
	"SingleDatePicker_closeButton": "SingleDatePicker_closeButton---MUqGI",
	"SingleDatePicker_closeButton_svg": "SingleDatePicker_closeButton_svg---1dJEe",
	"DayPickerKeyboardShortcuts_buttonReset": "DayPickerKeyboardShortcuts_buttonReset---1y-U1",
	"DayPickerKeyboardShortcuts_show": "DayPickerKeyboardShortcuts_show---IBzFB",
	"DayPickerKeyboardShortcuts_show__bottomRight": "DayPickerKeyboardShortcuts_show__bottomRight---1FuB4",
	"DayPickerKeyboardShortcuts_show__topRight": "DayPickerKeyboardShortcuts_show__topRight---3cL1-",
	"DayPickerKeyboardShortcuts_show__topLeft": "DayPickerKeyboardShortcuts_show__topLeft---3wB6B",
	"DayPickerKeyboardShortcuts_showSpan": "DayPickerKeyboardShortcuts_showSpan---17FNR",
	"DayPickerKeyboardShortcuts_showSpan__bottomRight": "DayPickerKeyboardShortcuts_showSpan__bottomRight---3se8P",
	"DayPickerKeyboardShortcuts_showSpan__topRight": "DayPickerKeyboardShortcuts_showSpan__topRight---30vTB",
	"DayPickerKeyboardShortcuts_showSpan__topLeft": "DayPickerKeyboardShortcuts_showSpan__topLeft---PWaPo",
	"DayPickerKeyboardShortcuts_panel": "DayPickerKeyboardShortcuts_panel---TS9T0",
	"DayPickerKeyboardShortcuts_title": "DayPickerKeyboardShortcuts_title---2Au3g",
	"DayPickerKeyboardShortcuts_list": "DayPickerKeyboardShortcuts_list---3o02L",
	"DayPickerKeyboardShortcuts_close": "DayPickerKeyboardShortcuts_close---1QW1o",
	"DayPickerKeyboardShortcuts_closeSvg": "DayPickerKeyboardShortcuts_closeSvg---11faX",
	"CalendarDay": "CalendarDay---3GA6Y",
	"CalendarDay__defaultCursor": "CalendarDay__defaultCursor---cIQRC",
	"CalendarDay__default": "CalendarDay__default---31AgS",
	"CalendarDay__hovered_offset": "CalendarDay__hovered_offset---3VPdL",
	"CalendarDay__outside": "CalendarDay__outside---17YVa",
	"CalendarDay__blocked_minimum_nights": "CalendarDay__blocked_minimum_nights---aJC-w",
	"CalendarDay__highlighted_calendar": "CalendarDay__highlighted_calendar---3J_Ow",
	"CalendarDay__selected_span": "CalendarDay__selected_span----Jy3S",
	"CalendarDay__last_in_range": "CalendarDay__last_in_range---3r60c",
	"CalendarDay__selected": "CalendarDay__selected---38GVR",
	"CalendarDay__hovered_span": "CalendarDay__hovered_span---1pTi8",
	"CalendarDay__blocked_calendar": "CalendarDay__blocked_calendar---1Bh2l",
	"CalendarDay__blocked_out_of_range": "CalendarDay__blocked_out_of_range---2X5gS",
	"CalendarMonth": "CalendarMonth---39dEL",
	"CalendarMonth_table": "CalendarMonth_table---s04AZ",
	"CalendarMonth_verticalSpacing": "CalendarMonth_verticalSpacing---194h3",
	"CalendarMonth_caption": "CalendarMonth_caption---3XAMN",
	"CalendarMonth_caption__verticalScrollable": "CalendarMonth_caption__verticalScrollable---1oKJA",
	"CalendarMonthGrid": "CalendarMonthGrid---P-rrB",
	"CalendarMonthGrid__animating": "CalendarMonthGrid__animating---3hIHa",
	"CalendarMonthGrid__horizontal": "CalendarMonthGrid__horizontal---2QVSE",
	"CalendarMonthGrid__vertical": "CalendarMonthGrid__vertical---2hc6Z",
	"CalendarMonthGrid__vertical_scrollable": "CalendarMonthGrid__vertical_scrollable---3c9Kg",
	"CalendarMonthGrid_month__horizontal": "CalendarMonthGrid_month__horizontal---3r7-p",
	"CalendarMonthGrid_month__hideForAnimation": "CalendarMonthGrid_month__hideForAnimation---1fgvY",
	"CalendarMonthGrid_month__hidden": "CalendarMonthGrid_month__hidden---CIjNV",
	"DayPickerNavigation_container": "DayPickerNavigation_container---3GCub",
	"DayPickerNavigation_container__vertical": "DayPickerNavigation_container__vertical---2H-ZV",
	"DayPickerNavigation_container__verticalScrollable": "DayPickerNavigation_container__verticalScrollable---dd1Op",
	"DayPickerNavigation_button": "DayPickerNavigation_button---V8lxy",
	"DayPickerNavigation_button__default": "DayPickerNavigation_button__default---3H_f8",
	"DayPickerNavigation_button__horizontal": "DayPickerNavigation_button__horizontal---3hMsu",
	"DayPickerNavigation_leftButton__horizontal": "DayPickerNavigation_leftButton__horizontal---3DoPb",
	"DayPickerNavigation_rightButton__horizontal": "DayPickerNavigation_rightButton__horizontal---3rjxO",
	"DayPickerNavigation_button__vertical": "DayPickerNavigation_button__vertical---2MXL1",
	"DayPickerNavigation_button__vertical__default": "DayPickerNavigation_button__vertical__default---39rH3",
	"DayPickerNavigation_nextButton__vertical__default": "DayPickerNavigation_nextButton__vertical__default---1MR4l",
	"DayPickerNavigation_nextButton__verticalScrollable": "DayPickerNavigation_nextButton__verticalScrollable---1pGwq",
	"DayPickerNavigation_svg__horizontal": "DayPickerNavigation_svg__horizontal---3Z9Zy",
	"DayPickerNavigation_svg__vertical": "DayPickerNavigation_svg__vertical---3zynz",
	"DayPicker": "DayPicker---2GFse",
	"DayPicker__horizontal": "DayPicker__horizontal---3hEIr",
	"DayPicker__verticalScrollable": "DayPicker__verticalScrollable---3_fzF",
	"DayPicker__hidden": "DayPicker__hidden---5bzf9",
	"DayPicker__withBorder": "DayPicker__withBorder---1LsLG",
	"DayPicker_portal__horizontal": "DayPicker_portal__horizontal---uC_5p",
	"DayPicker_portal__vertical": "DayPicker_portal__vertical---2Whrv",
	"DayPicker_focusRegion": "DayPicker_focusRegion---3DgEv",
	"DayPicker_calendarInfo__horizontal": "DayPicker_calendarInfo__horizontal---1zREP",
	"DayPicker_wrapper__horizontal": "DayPicker_wrapper__horizontal---1eth3",
	"DayPicker_weekHeaders": "DayPicker_weekHeaders---6Alqp",
	"DayPicker_weekHeaders__horizontal": "DayPicker_weekHeaders__horizontal---27vzR",
	"DayPicker_weekHeader": "DayPicker_weekHeader---33tHV",
	"DayPicker_weekHeader__vertical": "DayPicker_weekHeader__vertical---2HRrE",
	"DayPicker_weekHeader__verticalScrollable": "DayPicker_weekHeader__verticalScrollable---2stnX",
	"DayPicker_weekHeader_ul": "DayPicker_weekHeader_ul---AKnCu",
	"DayPicker_weekHeader_li": "DayPicker_weekHeader_li---2e1Yc",
	"DayPicker_transitionContainer": "DayPicker_transitionContainer---A-sRo",
	"DayPicker_transitionContainer__horizontal": "DayPicker_transitionContainer__horizontal---2qQ0m",
	"DayPicker_transitionContainer__vertical": "DayPicker_transitionContainer__vertical---3SX1m",
	"DayPicker_transitionContainer__verticalScrollable": "DayPicker_transitionContainer__verticalScrollable----mnwk",
	"DateInput": "DateInput---3yt5Z",
	"DateInput__small": "DateInput__small---1A_55",
	"DateInput__block": "DateInput__block---2hOz9",
	"DateInput__disabled": "DateInput__disabled---C-nLp",
	"DateInput_input": "DateInput_input---74GxT",
	"DateInput_input__small": "DateInput_input__small---1lTct",
	"DateInput_input__regular": "DateInput_input__regular---2FOAM",
	"DateInput_input__readOnly": "DateInput_input__readOnly---1xhiB",
	"DateInput_input__focused": "DateInput_input__focused---HKLd8",
	"DateInput_input__disabled": "DateInput_input__disabled---tgWjK",
	"DateInput_screenReaderMessage": "DateInput_screenReaderMessage---1MCff",
	"DateInput_fang": "DateInput_fang---2Shg8",
	"DateInput_fangShape": "DateInput_fangShape---2Eghu",
	"DateInput_fangStroke": "DateInput_fangStroke---2CNk7",
	"DateRangePickerInput": "DateRangePickerInput---3M_j7",
	"DateRangePickerInput__disabled": "DateRangePickerInput__disabled---3hldm",
	"DateRangePickerInput__withBorder": "DateRangePickerInput__withBorder---1OzIv",
	"DateRangePickerInput__rtl": "DateRangePickerInput__rtl---2VDo_",
	"DateRangePickerInput__block": "DateRangePickerInput__block---1k2PF",
	"DateRangePickerInput__showClearDates": "DateRangePickerInput__showClearDates---1jqnt",
	"DateRangePickerInput_arrow": "DateRangePickerInput_arrow---1FWnd",
	"DateRangePickerInput_arrow_svg": "DateRangePickerInput_arrow_svg---2olFE",
	"DateRangePickerInput_clearDates": "DateRangePickerInput_clearDates---t3DK4",
	"DateRangePickerInput_clearDates__small": "DateRangePickerInput_clearDates__small---1IZ3q",
	"DateRangePickerInput_clearDates_default": "DateRangePickerInput_clearDates_default---25hOI",
	"DateRangePickerInput_clearDates__hide": "DateRangePickerInput_clearDates__hide---31WAj",
	"DateRangePickerInput_clearDates_svg": "DateRangePickerInput_clearDates_svg---3Zo8S",
	"DateRangePickerInput_clearDates_svg__small": "DateRangePickerInput_clearDates_svg__small---3ZJik",
	"DateRangePickerInput_calendarIcon": "DateRangePickerInput_calendarIcon---2lrfS",
	"DateRangePickerInput_calendarIcon_svg": "DateRangePickerInput_calendarIcon_svg----4l1j",
	"DateRangePicker": "DateRangePicker---2BePN",
	"DateRangePicker__block": "DateRangePicker__block---1mEOO",
	"DateRangePicker_picker": "DateRangePicker_picker---1ZCDU",
	"DateRangePicker_picker__rtl": "DateRangePicker_picker__rtl---1SqBh",
	"DateRangePicker_picker__directionLeft": "DateRangePicker_picker__directionLeft---a7ZrM",
	"DateRangePicker_picker__directionRight": "DateRangePicker_picker__directionRight---2dmYK",
	"DateRangePicker_picker__portal": "DateRangePicker_picker__portal---1nOqq",
	"DateRangePicker_picker__fullScreenPortal": "DateRangePicker_picker__fullScreenPortal---2y4gl",
	"DateRangePicker_closeButton": "DateRangePicker_closeButton---fON14",
	"DateRangePicker_closeButton_svg": "DateRangePicker_closeButton_svg---2ocQY",
	"date-picker-wrapper": "date-picker-wrapper---1Jy4H"
};

/***/ }),

/***/ "jzbV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderGraph = exports.drawHorizontalBarLines = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _accuracyGraph = _interopRequireDefault(__webpack_require__("akO4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var GRAPH_PROPERTIES = {
  HEIGHT: 50,
  WIDTH: 104
};
var drawHorizontalBarLines = exports.drawHorizontalBarLines = function drawHorizontalBarLines(averageAccuracies) {
  if (averageAccuracies.length === 0) return null;
  var Bars = [];
  var minAccuracy = Math.floor(averageAccuracies.reduce(function (a, b) {
    return a.accuracy < b.accuracy ? a : b;
  }).accuracy / 10) * 10;
  var maxAccuracy = Math.ceil(averageAccuracies.reduce(function (a, b) {
    return a.accuracy > b.accuracy ? a : b;
  }).accuracy / 10) * 10;
  if (minAccuracy === maxAccuracy) {
    minAccuracy = minAccuracy !== 0 ? minAccuracy -= 10 : minAccuracy;
    maxAccuracy = maxAccuracy !== 100 ? maxAccuracy += 10 : maxAccuracy;
  }
  for (var i = minAccuracy; i <= maxAccuracy; i += 10) {
    Bars.unshift(/*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyGraph["default"].row,
      key: i,
      "data-testid": "graph-bar"
    }, (i === minAccuracy || i === maxAccuracy) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyGraph["default"].percentage
    }, i, "%"), /*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyGraph["default"].barline
    })));
  }
  return Bars;
};
var renderGraph = exports.renderGraph = function renderGraph(averageAccuracies) {
  if (averageAccuracies.length === 0) return null;
  var Graph = [];
  if (averageAccuracies.length === 1) {
    var pointPosition = GRAPH_PROPERTIES.HEIGHT - GRAPH_PROPERTIES.HEIGHT / (averageAccuracies[0].accuracy * 2) * averageAccuracies[0].accuracy;
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: _accuracyGraph["default"].graphline
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _accuracyGraph["default"].graphPoint,
      style: {
        top: "".concat(pointPosition, "px")
      }
    }));
  }
  var COLUMN_WIDTH = GRAPH_PROPERTIES.WIDTH / (averageAccuracies.length - 1);
  for (var i = 0; i < averageAccuracies.length - 1; i++) {
    var minAccuracy = Math.floor(averageAccuracies.reduce(function (a, b) {
      return a.accuracy < b.accuracy ? a : b;
    }).accuracy / 10) * 10;
    var maxAccuracy = Math.ceil(averageAccuracies.reduce(function (a, b) {
      return a.accuracy > b.accuracy ? a : b;
    }).accuracy / 10) * 10;
    var y1 = GRAPH_PROPERTIES.HEIGHT - GRAPH_PROPERTIES.HEIGHT / (maxAccuracy - minAccuracy) * (averageAccuracies[i].accuracy - minAccuracy);
    var y2 = GRAPH_PROPERTIES.HEIGHT - GRAPH_PROPERTIES.HEIGHT / (maxAccuracy - minAccuracy) * (averageAccuracies[i + 1].accuracy - minAccuracy);
    Graph.push(/*#__PURE__*/_react["default"].createElement("span", {
      style: {
        width: "".concat(COLUMN_WIDTH, "px")
      },
      className: _accuracyGraph["default"].graphline,
      key: i
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      height: GRAPH_PROPERTIES.HEIGHT,
      width: COLUMN_WIDTH,
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("polyline", {
      points: "0, ".concat(y1, ", ").concat(COLUMN_WIDTH, ", ").concat(y2),
      style: {
        fill: 'none',
        stroke: '#00b4eb',
        strokeWidth: 1
      }
    }))));
  }
  return Graph;
};

/***/ }),

/***/ "kQOT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactComponents = __webpack_require__("fmgT");
var _icon_up_solid = _interopRequireDefault(__webpack_require__("kPzT"));
var _linguiCdn = __webpack_require__("siuH");
var _reactRedux = __webpack_require__("RH2O");
var _assignmentResult = _interopRequireDefault(__webpack_require__("TWXG"));
var _assignmentResultReducer = __webpack_require__("llwb");
var _contextModal = _interopRequireDefault(__webpack_require__("vuxJ"));
var _attemptItem = _interopRequireDefault(__webpack_require__("pg8O"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AssignmentResult = function AssignmentResult() {
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var assignmentResultType = (0, _reactRedux.useSelector)(function (state) {
    return state.assignmentResultType;
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showContextModal = _useState2[0],
    setShowContextModal = _useState2[1];
  var HIGHEST = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.HIGHEST,
    TEACHER_ASSIGNED = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.TEACHER_ASSIGNED,
    VOLUNTARY = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.VOLUNTARY;
  var getButtonText = function getButtonText() {
    var text = '';
    switch (assignmentResultType) {
      case HIGHEST:
        text = i18n._(
        /*i18n*/
        {
          id: "Assignment Item - showing all highest attempts"
        });
        break;
      case TEACHER_ASSIGNED:
        text = i18n._(
        /*i18n*/
        {
          id: "Assignment Item - showing teacher assigned attempts"
        });
        break;
      case VOLUNTARY:
        text = i18n._(
        /*i18n*/
        {
          id: "Assignment Item - showing voluntary attempts"
        });
        break;
      default:
        return '';
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _assignmentResult["default"].text,
      key: "assignment-button",
      title: text
    }, text);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _assignmentResult["default"]['assignment-results-container']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _assignmentResult["default"]['assignment-results-wrapper']
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
    text: getButtonText(),
    className: _assignmentResult["default"]['assignment-button'],
    onClick: function onClick() {
      return setShowContextModal(!showContextModal);
    },
    icon: _icon_up_solid["default"],
    alignIcon: 'RIGHT'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _assignmentResult["default"].border
  }), /*#__PURE__*/_react["default"].createElement(_contextModal["default"], {
    className: _assignmentResult["default"]['assignment-results-context-modal'],
    show: showContextModal,
    onClickOutsideHandler: function onClickOutsideHandler() {
      return setShowContextModal(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _assignmentResult["default"]['assigned-attempts-container']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _assignmentResult["default"]['assigned-attempts-wrapper']
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _assignmentResult["default"]['header-text']
  }, i18n._(
  /*i18n*/
  {
    id: "Assignment Item - FilterByStudentAttempts"
  })), /*#__PURE__*/_react["default"].createElement(_attemptItem["default"], {
    type: HIGHEST
  }), /*#__PURE__*/_react["default"].createElement(_attemptItem["default"], {
    type: TEACHER_ASSIGNED
  }), /*#__PURE__*/_react["default"].createElement(_attemptItem["default"], {
    type: VOLUNTARY
  }))))));
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_assignmentResult["default"])(AssignmentResult);

/***/ }),

/***/ "kQP1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WRki");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./context-modal.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./context-modal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kQVy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LiveMathsLevelPicker = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _reactComponents = __webpack_require__("fmgT");
var _liveMathsLevelPicker = _interopRequireDefault(__webpack_require__("QHOw"));
var _liveMathsLevelPickerActions = _interopRequireDefault(__webpack_require__("7NtK"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NUM_LEVELS = 10;

/**
 * Component to pick the Live Maths level to show in the results table
 * Displays levels 1-10 with current selection highlighted, updates value in redux store when new level picked
 */
var LiveMathsLevelPicker = exports.LiveMathsLevelPicker = /*#__PURE__*/function (_Component) {
  function LiveMathsLevelPicker(props) {
    var _this;
    _classCallCheck(this, LiveMathsLevelPicker);
    _this = _callSuper(this, LiveMathsLevelPicker, [props]);
    _this.levels = Array(NUM_LEVELS).fill(null);
    return _this;
  }
  _inherits(LiveMathsLevelPicker, _Component);
  return _createClass(LiveMathsLevelPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        pickLevel = _this$props.pickLevel,
        liveMathsLevel = _this$props.liveMathsLevel;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _liveMathsLevelPicker["default"].component
      }, this.levels.map(function (item, idx) {
        var level = idx + 1;
        return /*#__PURE__*/_react["default"].createElement(_reactComponents.Button, {
          key: level,
          text: "".concat(level),
          className: "".concat(_liveMathsLevelPicker["default"].level, " ").concat(liveMathsLevel === level ? _liveMathsLevelPicker["default"].active : ''),
          onClick: function onClick() {
            return pickLevel(level);
          }
        });
      }));
    }
  }]);
}(_react.Component);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(LiveMathsLevelPicker, "propTypes", {
  pickLevel: _propTypes["default"].func,
  liveMathsLevel: _propTypes["default"].number
});
function mapStateToProps(state) {
  return {
    liveMathsLevel: state.liveMathsLevel
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    pickLevel: _liveMathsLevelPickerActions["default"].pickLevel
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_liveMathsLevelPicker["default"])(LiveMathsLevelPicker));

/***/ }),

/***/ "kS0t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _singleClass = _interopRequireDefault(__webpack_require__("XiXD"));
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _localeHelpers = __webpack_require__("rjLd");
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SINGLE_CLASS_SKILL_QUESTS_MASTERY_TABLE_CONFIG = {
  cols: [{
    id: _skillQuestsMasteryConstants.GROUP_NAME.id,
    name: _skillQuestsMasteryConstants.GROUP_NAME.name,
    sort: {
      sortAs: 'string'
    },
    truncate: true,
    onClick: function onClick() {
      return null;
    },
    // this is set in the SingleClass component
    classes: null
  }, {
    id: _skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id,
    name: _skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.name,
    classes: _singleClass["default"]['completed-quests']
  }, {
    id: _skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id,
    name: ''
  }, {
    id: _skillQuestsMasteryConstants.STANDARDS_COMPLETED.id,
    name: ''
  }, {
    id: _skillQuestsMasteryConstants.ASSIGNED_QUESTS.id,
    name: ''
  }, {
    id: _skillQuestsMasteryConstants.COMPLETED_QUESTS.id,
    name: ''
  }],
  colGroups: [[{
    colIds: [_skillQuestsMasteryConstants.GROUP_NAME.id, _skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id],
    classes: _singleClass["default"]['dark-header'],
    name: _skillQuestsMasteryConstants.GROUP_NAME.name,
    truncate: true,
    headerTransform: function headerTransform() {
      return /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: (0, _localeHelpers.getTranslationKey)(_filterConstants.SKILL_QUESTS_MASTERY),
        translate: true
      });
    }
  }, {
    name: _skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.name,
    colIds: [_skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id],
    classes: _singleClass["default"]['light-header']
  }, {
    name: _skillQuestsMasteryConstants.STANDARDS_COMPLETED.name,
    colIds: [_skillQuestsMasteryConstants.STANDARDS_COMPLETED.id],
    classes: _singleClass["default"]['light-header']
  }, {
    name: _skillQuestsMasteryConstants.ASSIGNED_QUESTS.name,
    colIds: [_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id],
    classes: _singleClass["default"]['light-header']
  }, {
    name: _skillQuestsMasteryConstants.COMPLETED_QUESTS.name,
    colIds: [_skillQuestsMasteryConstants.COMPLETED_QUESTS.id],
    classes: _singleClass["default"]['light-header']
  }]],
  nestedData: {
    id: 'students',
    cols: [{
      id: _skillQuestsMasteryConstants.STUDENT_FULL_NAME.id,
      classes: _singleClass["default"]['student-full-name-wrapper'],
      onClick: function onClick() {
        return null;
      }
    }, {
      id: _skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id
    }, {
      id: _skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id,
      classes: _singleClass["default"]['basic-cell']
    }, {
      id: _skillQuestsMasteryConstants.STANDARDS_COMPLETED.id,
      classes: _singleClass["default"]['basic-cell']
    }, {
      id: _skillQuestsMasteryConstants.ASSIGNED_QUESTS.id,
      classes: _singleClass["default"]['basic-cell']
    }, {
      id: _skillQuestsMasteryConstants.COMPLETED_QUESTS.id,
      classes: _singleClass["default"]['basic-cell']
    }]
  },
  emptyDataMessage: 'No Skill Quests Mastery results found'
};
var _default = exports["default"] = SINGLE_CLASS_SKILL_QUESTS_MASTERY_TABLE_CONFIG;

/***/ }),

/***/ "kZYZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UsageBlock = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _usage = _interopRequireDefault(__webpack_require__("GNMg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UsageBlock = exports.UsageBlock = function UsageBlock(_ref) {
  var info = _ref.info,
    title = _ref.title,
    variant = _ref.variant;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _usage["default"][variant]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _usage["default"].info
  }, info), /*#__PURE__*/_react["default"].createElement("div", {
    className: _usage["default"].title
  }, title));
};
UsageBlock.propTypes = {
  info: _propTypes["default"].oneOfType(_propTypes["default"].string, _propTypes["default"].number),
  title: _propTypes["default"].string.isRequired,
  variant: _propTypes["default"].oneOf('block', 'goldBar')
};
UsageBlock.defaultProps = {
  isGoldBarBlock: false,
  variant: 'block'
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_usage["default"])(UsageBlock);

/***/ }),

/***/ "kZjJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _icon_star = _interopRequireDefault(__webpack_require__("IJC2"));
var _activityMasteryKeyLegends = _interopRequireDefault(__webpack_require__("Jv+Z"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Key Legends Component
 * Displays Static Gold bars and score bands
 */
var ActivityMasteryKeyLegends = function ActivityMasteryKeyLegends() {
  var legends = [{
    text: '86-100%',
    className: _activityMasteryKeyLegends["default"]['mastered-box']
  }, {
    text: '66-85%',
    className: _activityMasteryKeyLegends["default"]['consolidating-box']
  }, {
    text: '50-65%',
    className: _activityMasteryKeyLegends["default"]['developing-box']
  }, {
    text: '26-49%',
    className: _activityMasteryKeyLegends["default"]['emerging-box']
  }, {
    text: '0-25%',
    className: _activityMasteryKeyLegends["default"]['needsImproving-box']
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _activityMasteryKeyLegends["default"].component
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _activityMasteryKeyLegends["default"]['gold-bars']
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: _icon_star["default"],
    cacheGetRequests: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _activityMasteryKeyLegends["default"].text
  }, (0, _localeHelpers.translate)('Label - GoldBars'))), legends.map(function (legend) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _activityMasteryKeyLegends["default"].legend,
      key: legend.className
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: legend.className
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _activityMasteryKeyLegends["default"].text
    }, legend.text));
  }));
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_activityMasteryKeyLegends["default"])(ActivityMasteryKeyLegends);

/***/ }),

/***/ "km3k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ACTIVITY_MASTERY_CLASS_RETRIEVED = void 0;
var _sortBy = _interopRequireDefault(__webpack_require__("KBYM"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _constants = __webpack_require__("1QGX");
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ACTIVITY_MASTERY_CLASS_RETRIEVED = exports.ACTIVITY_MASTERY_CLASS_RETRIEVED = 'ACTIVITY_MASTERY_CLASS_RETRIEVED';
function getActivityMasteryData(classroomId, selectedDateFilter) {
  return function (dispatch) {
    return _resources["default"].singleClassReport.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_ACTIVITY_MASTERY
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId
    })).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDateFilter)).send().then(function (payload) {
      if (payload.valid) {
        dispatch({
          type: ACTIVITY_MASTERY_CLASS_RETRIEVED,
          payload: mapActivityMasteryData(payload.data)
        });
      } else {
        dispatch(_errorsActions["default"].addError(ACTIVITY_MASTERY_CLASS_RETRIEVED));
      }
    });
  };
}
function mapActivityMasteryData(data) {
  var name = data.name,
    teachers = data.teachers,
    goldBars = data.totalGoldBars,
    totalActivities = data.totalActivities,
    scoreBand = data.classScoreBand,
    groupActivityMastery = data.groupActivityMastery;
  var teacherName = '';
  var _useLokalise = (0, _localeHelpers.useLokalise)(),
    teacherNumTitle = _useLokalise.teacherNumTitle;
  if (teachers) {
    if (teachers.length > 1) {
      teacherName = teacherNumTitle(teachers.length);
    } else {
      teacherName = teachers[0].teacherName;
    }
  }
  var activityMastery = {
    goldBars: goldBars,
    totalActivities: totalActivities,
    scoreBand: scoreBand,
    groupActivityMastery: groupActivityMastery.map(function (group) {
      return {
        id: group.id,
        name: group.name,
        courseName: group.courseName,
        totalActivities: group.totalActivities,
        scoreBand: group.scoreBand,
        goldBars: group.goldBars,
        students: (0, _sortBy["default"])(group.students.map(function (student) {
          return _objectSpread(_objectSpread({}, student), {}, {
            id: student.userProfileId,
            fullName: "".concat(student.lastName, ", ").concat(student.firstName)
          });
        }), ['lastName', 'firstName']),
        strengths: {
          topics: mapStrengthWeakness(group.topicStrengths),
          activities: mapStrengthWeakness(group.activityStrengths)
        },
        weaknesses: {
          topics: mapStrengthWeakness(group.topicWeaknesses, false),
          activities: mapStrengthWeakness(group.activityWeaknesses, false)
        }
      };
    })
  };
  var strengths = {
    topics: mapStrengthWeakness(data.topicStrengths),
    activities: mapStrengthWeakness(data.activityStrengths)
  };
  var weaknesses = {
    topics: mapStrengthWeakness(data.topicWeaknesses, false),
    activities: mapStrengthWeakness(data.activityWeaknesses, false)
  };
  return {
    name: name,
    teacherName: teacherName,
    activityMastery: activityMastery,
    strengths: strengths,
    weaknesses: weaknesses
  };
}
function mapStrengthWeakness(strengthWeakness) {
  var descending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defaultData = {
    id: 0,
    title: '-',
    averageResult: '- '
  };
  if (!strengthWeakness.length) {
    return [defaultData];
  }
  var sorted;
  if (descending) {
    sorted = strengthWeakness.sort(function (a, b) {
      return a.averageResult < b.averageResult;
    });
  } else {
    sorted = strengthWeakness.sort(function (a, b) {
      return a.averageResult > b.averageResult;
    });
  }
  return sorted.map(function (data, idx) {
    return _objectSpread(_objectSpread({}, data), {}, {
      id: idx
    });
  });
}
var _default = exports["default"] = {
  getActivityMasteryData: getActivityMasteryData
};

/***/ }),

/***/ "kpcp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SingleClass = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _filterPropTypes = __webpack_require__("1g86");
var _filterConstants = __webpack_require__("cdWI");
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _singleClass = _interopRequireDefault(__webpack_require__("59Pb"));
var _singleClassActions = _interopRequireWildcard(__webpack_require__("tYGa"));
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _singleClassConstants = __webpack_require__("HDbG");
var _singleClassPropTypes = _interopRequireDefault(__webpack_require__("tATg"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Displays live maths results for a single class
 */
var SingleClass = exports.SingleClass = /*#__PURE__*/function (_Component) {
  function SingleClass(props) {
    var _this;
    _classCallCheck(this, SingleClass);
    _this = _callSuper(this, SingleClass, [props]);
    _defineProperty(_this, "getColFromConfig", function (config, colId) {
      return config.cols.find(function (col) {
        return col.id === colId;
      });
    });
    /**
     * Loads the group or student page when user clicks on item in table
     */
    _defineProperty(_this, "loadNewPage", function (filterName, selectedItem) {
      _this.props.updateActiveFilter(filterName, {
        id: selectedItem.id,
        name: selectedItem.name
      });
    });
    _this.state = {
      singleClassTableConfig: null,
      liveMathsLevelData: null
    };
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(SingleClass, _Component);
  return _createClass(SingleClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        activeFilters = _this$props.activeFilters,
        liveMathsData = _this$props.liveMathsData,
        liveMathsLevel = _this$props.liveMathsLevel;
      if (_filterHelper["default"].shouldLoadSingleClass(activeFilters)) {
        this.getClassLiveMathsData(activeFilters[_filterConstants.SELECTED_CLASS].id, activeFilters[_filterConstants.SELECTED_DATE]);
        this.setLiveMathsData(liveMathsData, liveMathsLevel, activeFilters[_filterConstants.SELECTED_GROUP].id);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props2 = this.props,
        activeFilters = _this$props2.activeFilters,
        liveMathsData = _this$props2.liveMathsData,
        liveMathsLevel = _this$props2.liveMathsLevel,
        invalidRequest = _this$props2.invalidRequest,
        updateActiveFilter = _this$props2.updateActiveFilter;
      var newActiveFilters = newProps.activeFilters,
        newLiveMathsData = newProps.liveMathsData,
        newLiveMathsLevel = newProps.liveMathsLevel,
        newInvalidRequest = newProps.invalidRequest;

      // user's selection has changed (date, class or group), need to request data from backend
      if (_filterHelper["default"].shouldReloadSingleClass(activeFilters, newActiveFilters)) {
        this.getClassLiveMathsData(newActiveFilters[_filterConstants.SELECTED_CLASS].id, newActiveFilters[_filterConstants.SELECTED_DATE]);
      }

      // we have received live maths data from backend or user has selected new level
      if (newLiveMathsData && (liveMathsData !== newLiveMathsData || liveMathsLevel !== newLiveMathsLevel)) {
        this.setLiveMathsData(newLiveMathsData, newLiveMathsLevel, newActiveFilters[_filterConstants.SELECTED_GROUP].id);
        this.setLiveMathsConfig(newLiveMathsData.classroomName, newActiveFilters[_filterConstants.SELECTED_GROUP].id);
      }

      // request to backend failed, attempt to load page using default values
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _singleClassActions.LIVE_MATHS_CLASS_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "getClassLiveMathsData",
    value: function getClassLiveMathsData(classroomId, selectedDate) {
      this.props.getLiveMathsData(classroomId, selectedDate);
    }
  }, {
    key: "setLiveMathsData",
    value: function setLiveMathsData(allLevelsLiveMathsData, liveMathsLevel, groupId) {
      if (allLevelsLiveMathsData && allLevelsLiveMathsData.groupLiveMathsLevelResult) {
        groupId = +groupId || 0;
        var liveMathsLevelData = allLevelsLiveMathsData.groupLiveMathsLevelResult[liveMathsLevel - 1].groups;
        if (groupId) {
          liveMathsLevelData = liveMathsLevelData.filter(function (group) {
            return group.id === +groupId;
          });
        }
        this.setState({
          liveMathsLevelData: liveMathsLevelData
        });
      }
    }
  }, {
    key: "setLiveMathsConfig",
    value: function setLiveMathsConfig(className, groupId) {
      var _this2 = this;
      groupId = +groupId || 0;
      var singleClassTableConfig = (0, _cloneDeep["default"])(_singleClassConstants.SINGLE_CLASS_TABLE_CONFIG);
      var classNameColHeader = singleClassTableConfig.colGroups[0][0];
      var groupCol = this.getColFromConfig(singleClassTableConfig, _singleClassConstants.GROUP_NAME);
      var studentCol = this.getColFromConfig(singleClassTableConfig.nestedData, _singleClassConstants.STUDENT_NAME);
      classNameColHeader.name = className;
      if (!groupId) {
        classNameColHeader.sort = {
          colId: _singleClassConstants.GROUP_NAME,
          sortDir: 'desc'
        };
        groupCol.onClick = function (selectedGroup) {
          return _this2.loadNewPage(_filterConstants.SELECTED_GROUP, selectedGroup);
        };
      }
      studentCol.onClick = function (selectedStudent) {
        return _this2.loadNewPage(_filterConstants.SELECTED_STUDENT, selectedStudent);
      };
      singleClassTableConfig = (0, _localeHelpers.translateTableLabels)(singleClassTableConfig);
      this.setState({
        singleClassTableConfig: singleClassTableConfig
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        liveMathsLevelData = _this$state.liveMathsLevelData,
        singleClassTableConfig = _this$state.singleClassTableConfig;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"]['live-maths-results']
      }, /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: 'Table Header - Live Mathletics',
        translate: true
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: singleClassTableConfig,
        data: liveMathsLevelData
      })));
    }
  }]);
}(_react.Component);
_defineProperty(SingleClass, "propTypes", {
  liveMathsData: _singleClassPropTypes["default"].liveMathsDataPropType,
  liveMathsLevel: _propTypes["default"].number,
  activeFilters: _filterPropTypes.activeFiltersPropType,
  getLiveMathsData: _propTypes["default"].func,
  updateActiveFilter: _propTypes["default"].func,
  invalidRequest: _propTypes["default"].string
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    liveMathsData: state.liveMathsSingleClass,
    liveMathsLevel: state.liveMathsLevel,
    invalidRequest: state.invalidRequest
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getLiveMathsData: _singleClassActions["default"].getLiveMathsData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_singleClass["default"])(SingleClass));

/***/ }),

/***/ "kv6M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reselect = __webpack_require__("bndy");
var selectCourse = function selectCourse(state) {
  return state.skillQuestsMasteryStudent.selectedCourse;
};
var selectIsFiltered = function selectIsFiltered(state) {
  return state.skillQuestsMasteryStudent.isFiltered;
};
var selectCourseData = (0, _reselect.createSelector)([selectCourse, selectIsFiltered], function (selectedCourse, isFiltered) {
  var courseId = null;
  var courseVersion = null;
  if (isFiltered) {
    courseId = selectedCourse.selected.id;
    courseVersion = selectedCourse.selected.version;
  }
  return {
    courseId: courseId,
    courseVersion: courseVersion
  };
});
var _default = exports["default"] = {
  selectCourseData: selectCourseData
};

/***/ }),

/***/ "l2ek":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1lNT4 {\n  height: calc(100% - 135px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .component---1lNT4 .data-table---3koEY {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 70%;\n            flex: 1 1 70%; }\n  .component---1lNT4 .data-table---3koEY table {\n      width: calc(100% - 2px); }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 0;\n      background-color: white;\n      font-weight: 500;\n      color: #4e5c67;\n      height: 47px; }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type th {\n        border: none;\n        background: none;\n        font-weight: normal;\n        font-size: 12px;\n        white-space: nowrap; }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type th::after, .component---1lNT4 .data-table---3koEY thead tr:first-of-type th::before {\n          content: '';\n          position: absolute;\n          left: 0;\n          width: 100%; }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type th::before {\n          top: -1px;\n          border-top: 1px solid #e5e5e5;\n          pointer-events: none; }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type th::after {\n          bottom: -1px;\n          border-bottom: 2px solid #e5e5e5;\n          pointer-events: none; }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type th::before {\n          left: -1px;\n          height: 46px;\n          border-left: 1px solid white;\n          border-right: 1px solid white; }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type th::after {\n          height: 46px;\n          border-left: 1px solid white;\n          right: 1px; }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type th:first-of-type {\n          font-size: 18px;\n          text-align: left; }\n  .component---1lNT4 .data-table---3koEY thead tr:last-of-type {\n      position: sticky;\n      z-index: 2;\n      top: 47px;\n      background-color: #e4eaef;\n      color: #278bcb;\n      font-weight: 600; }\n  .component---1lNT4 .data-table---3koEY thead tr:last-of-type th::after, .component---1lNT4 .data-table---3koEY thead tr:last-of-type th::before {\n        content: '';\n        position: absolute;\n        left: 0;\n        width: 100%; }\n  .component---1lNT4 .data-table---3koEY thead tr:last-of-type th::before {\n        top: -1px;\n        border-top: 1px solid #e5e5e5;\n        pointer-events: none; }\n  .component---1lNT4 .data-table---3koEY thead tr:last-of-type th::after {\n        bottom: -1px;\n        border-bottom: 2px solid #e5e5e5;\n        pointer-events: none; }\n  .component---1lNT4 .data-table---3koEY thead tr:first-of-type th:last-of-type {\n      font-size: 12px; }\n  .component---1lNT4 .data-table---3koEY .class-name---27sel svg path,\n    .component---1lNT4 .data-table---3koEY .group-name---P5AZ2 svg path {\n      fill: #788189 !important; }\n  .component---1lNT4 .data-table---3koEY .class-name---27sel,\n    .component---1lNT4 .data-table---3koEY .topic-name---V32h1,\n    .component---1lNT4 .data-table---3koEY .activity-name---ZhsuA {\n      width: 30%;\n      text-align: left; }\n  .component---1lNT4 .data-table---3koEY .activity-results---10beB,\n    .component---1lNT4 .data-table---3koEY .test-results---3C1xr {\n      width: 55%;\n      padding: 2px 0; }\n  .component---1lNT4 .data-table---3koEY .total-activities---5fE9q,\n    .component---1lNT4 .data-table---3koEY .attempts---3xthX {\n      width: 15%;\n      text-align: center;\n      font-size: 16px; }\n  .component---1lNT4 .data-table---3koEY thead .table-tabs---24ffq {\n      background-color: #fff;\n      padding: 0; }\n  .component---1lNT4 .data-table---3koEY thead .table-tabs---24ffq .table-tab-container---1hR3U {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex; }\n  .component---1lNT4 .data-table---3koEY thead .table-tabs---24ffq .table-tab-container---1hR3U .table-tab-btn---39kL5 {\n          border-radius: 0;\n          border: none;\n          padding: 12px 48px;\n          font-size: 12px;\n          font-weight: 500;\n          background-color: #fff; }\n  .component---1lNT4 .data-table---3koEY thead .table-tabs---24ffq .table-tab-container---1hR3U .table-tab-btn---39kL5:hover {\n            -webkit-transition: background-color 0.2s;\n            transition: background-color 0.2s;\n            background-color: #eef2f5;\n            -webkit-filter: none;\n                    filter: none; }\n  .component---1lNT4 .data-table---3koEY thead .table-tabs---24ffq .table-tab-container---1hR3U .table-tab-btn---39kL5.active---lvXMZ, .component---1lNT4 .data-table---3koEY thead .table-tabs---24ffq .table-tab-container---1hR3U .table-tab-btn---39kL5.active---lvXMZ:hover {\n            -webkit-transition: none;\n            transition: none;\n            background-color: #1981c4;\n            color: #fff; }\n  .component---1lNT4 .data-table---3koEY thead .class-name---27sel {\n      background-color: #e4eaef;\n      color: #278bcb; }\n  .component---1lNT4 .data-table---3koEY thead .topic-name---V32h1,\n    .component---1lNT4 .data-table---3koEY thead .test-topic-name---2x4Fz,\n    .component---1lNT4 .data-table---3koEY thead .total-activities---5fE9q,\n    .component---1lNT4 .data-table---3koEY thead .test-results---3C1xr,\n    .component---1lNT4 .data-table---3koEY thead .activity-results---10beB {\n      background: none;\n      color: #4e5c67;\n      font-weight: 500; }\n  .component---1lNT4 .data-table---3koEY thead .topic-name---V32h1,\n    .component---1lNT4 .data-table---3koEY thead .test-topic-name---2x4Fz {\n      padding: 10px 16px; }\n  .component---1lNT4 .data-table---3koEY tbody.expanded---12ym3 {\n      -webkit-transition-duration: 0.2s;\n              transition-duration: 0.2s;\n      -webkit-transition-property: color, background-color;\n      transition-property: color, background-color;\n      background-color: #a2bdd3;\n      color: #fff; }\n  .component---1lNT4 .data-table---3koEY tbody.expanded---12ym3 tr {\n        border-left: 6px solid #1981c4; }\n  .component---1lNT4 .data-table---3koEY tbody.expanded---12ym3 td {\n        border: none; }\n  .component---1lNT4 .data-table---3koEY tbody.expanded---12ym3 td:first-of-type {\n          padding-left: 10px; }\n  .component---1lNT4 .data-table---3koEY tbody.expanded---12ym3 td:first-of-type svg path {\n            fill: #1981c4 !important; }\n  .component---1lNT4 .data-table---3koEY tbody.expanded---12ym3 + tbody tr {\n        border-left: 6px solid #1981c4; }\n  .component---1lNT4 .data-table---3koEY tbody .assigned---38nFO td:first-of-type {\n      background-color: #fcf3ca; }\n  .component---1lNT4 .data-table---3koEY tbody .activity-name---ZhsuA,\n    .component---1lNT4 .data-table---3koEY tbody .attempts---3xthX {\n      color: #1981c4;\n      font-weight: 600; }\n  .component---1lNT4 .data-table---3koEY tbody tr {\n      background: none; }\n  .component---1lNT4 .data-table---3koEY tbody th.activity-name---ZhsuA, .component---1lNT4 .data-table---3koEY tbody th.activity-results---10beB, .component---1lNT4 .data-table---3koEY tbody th.attempts---3xthX {\n      color: #4e5c67;\n      font-weight: 500;\n      text-align: left;\n      padding: 4px 16px;\n      font-size: 12px; }\n  .component---1lNT4 .data-table---3koEY tbody th.attempts---3xthX {\n      text-align: center; }\n  .component---1lNT4 .strength-weakness---1Pq5h {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 30%;\n            flex: 1 1 30%;\n    padding-left: 20px;\n    text-align: left;\n    color: #278bcb; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1lNT4",
	"data-table": "data-table---3koEY",
	"class-name": "class-name---27sel",
	"group-name": "group-name---P5AZ2",
	"topic-name": "topic-name---V32h1",
	"activity-name": "activity-name---ZhsuA",
	"activity-results": "activity-results---10beB",
	"test-results": "test-results---3C1xr",
	"total-activities": "total-activities---5fE9q",
	"attempts": "attempts---3xthX",
	"table-tabs": "table-tabs---24ffq",
	"table-tab-container": "table-tab-container---1hR3U",
	"table-tab-btn": "table-tab-btn---39kL5",
	"active": "active---lvXMZ",
	"test-topic-name": "test-topic-name---2x4Fz",
	"expanded": "expanded---12ym3",
	"assigned": "assigned---38nFO",
	"strength-weakness": "strength-weakness---1Pq5h"
};

/***/ }),

/***/ "lWQf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_TEACHERS_ID = void 0;
var ALL_TEACHERS_ID = exports.ALL_TEACHERS_ID = 0;

/***/ }),

/***/ "lXLQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReportRoutes = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRouterDom = __webpack_require__("F8kA");
var _reactRedux = __webpack_require__("RH2O");
var _constants = __webpack_require__("1QGX");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Generates the react router <Route> components for each report level (all classes, single class, etc.)
 * and the <Redirect> component to go to default path if route does not fully match any report level
 * These are child routes for a report type (activity mastery, etc.) - this component is used in
 * a report type's base container component
 * Handles generating the different routes for admins vs teachers
 */
var ReportRoutes = exports.ReportRoutes = /*#__PURE__*/function (_Component) {
  function ReportRoutes(props) {
    var _this;
    _classCallCheck(this, ReportRoutes);
    _this = _callSuper(this, ReportRoutes, [props]);
    _defineProperty(_this, "renderRoutes", function () {
      var _this$props = _this.props,
        children = _this$props.children,
        isAdmin = _this$props.isAdmin;
      return /*#__PURE__*/_react["default"].createElement("div", null, children, isAdmin === true ? _this.renderAdminRoutes() : _this.renderTeacherRoutes());
    });
    _defineProperty(_this, "renderAdminRoutes", function () {
      var allClasses = _this.props.components.allClasses;
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        strict: true,
        path: _this.defaultPath,
        component: allClasses
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: _this.yearGroupPath,
        component: allClasses
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: _this.yearGroupTeacherPath,
        component: allClasses
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        path: _this.teacherPath,
        component: allClasses
      }), _this.getSharedRoutes());
    });
    _defineProperty(_this, "renderTeacherRoutes", function () {
      var allClasses = _this.props.components.allClasses;
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        exact: true,
        strict: true,
        path: _this.defaultPath,
        component: allClasses
      }), _this.getSharedRoutes());
    });
    var match = props.match;
    _this.defaultPath = match.url;
    if (_this.defaultPath.charAt(_this.defaultPath.length - 1) === '/') {
      _this.defaultPath = _this.defaultPath.substring(0, _this.defaultPath.length - 1);
    }
    _this.yearGroupPath = "".concat(_this.defaultPath, "/").concat(_constants.YEAR_GROUP_PATH, "/:yearGroupId");
    _this.yearGroupTeacherPath = "".concat(_this.defaultPath, "/").concat(_constants.YEAR_GROUP_PATH, "/:yearGroupId/").concat(_constants.TEACHER_PATH, "/:teacherId");
    _this.teacherPath = "".concat(_this.defaultPath, "/").concat(_constants.TEACHER_PATH, "/:teacherId");
    _this.classPath = "".concat(_this.defaultPath, "/").concat(_constants.CLASS_PATH, "/:classId");
    _this.groupPath = "".concat(_this.classPath, "/").concat(_constants.GROUP_PATH, "/:groupId");
    _this.studentPath = "".concat(_this.classPath, "/").concat(_constants.STUDENT_PATH, "/:studentId");
    return _this;
  }

  /** Routes shared by both admins & teachers */
  _inherits(ReportRoutes, _Component);
  return _createClass(ReportRoutes, [{
    key: "getSharedRoutes",
    value: function getSharedRoutes() {
      var _this$props$component = this.props.components,
        singleClass = _this$props$component.singleClass,
        student = _this$props$component.student;
      return [/*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        key: 0,
        exact: true,
        path: this.classPath,
        component: singleClass
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        key: 1,
        exact: true,
        path: this.groupPath,
        component: singleClass
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        key: 2,
        exact: true,
        path: this.studentPath,
        component: student
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        key: 3,
        from: "*",
        to: this.defaultPath
      })];
    }
  }, {
    key: "render",
    value: function render() {
      var isAdmin = this.props.isAdmin;
      // isAdmin will equal null until the backend returns a value for the is admin request
      if (isAdmin === null) {
        return null;
      }
      return this.renderRoutes();
    }
  }]);
}(_react.Component);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers
 */
_defineProperty(ReportRoutes, "propTypes", {
  isAdmin: _propTypes["default"].bool,
  match: _propTypes["default"].shape({
    url: _propTypes["default"].string
  }),
  children: _propTypes["default"].node,
  components: _propTypes["default"].shape({
    allClasses: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
    singleClass: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
    student: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
  }).isRequired
});
function mapStateToProps(state) {
  return {
    isAdmin: state.isAdmin
  };
}
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(ReportRoutes));

/***/ }),

/***/ "lXNV":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".top-level-info-container---2DV9s {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: calc(100% - 380px); }\n  .top-level-info-container---2DV9s .header-container---1uZf0 {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    min-width: 0; }\n  .top-level-info-container---2DV9s .header-container---1uZf0 h2 {\n      color: #415667;\n      font-size: 25px;\n      max-width: calc(100% - 16px);\n      font-weight: 500;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n  .top-level-info-container---2DV9s .header-container---1uZf0 .date-range---lr4BF {\n      display: block;\n      float: left;\n      clear: both;\n      font-size: 16px;\n      color: #1981c4; }\n  .top-level-info-container---2DV9s .top-level-info-button---RhnYV {\n    border-radius: 20px;\n    background-color: #278bcb;\n    width: 30px;\n    height: 30px;\n    margin-right: 10px; }\n  .top-level-info-container---2DV9s .top-level-info-button---RhnYV svg {\n      margin-right: 2px; }\n  .top-level-info-container---2DV9s .top-level-info-button---RhnYV span {\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center; }\n  .top-level-info-container---2DV9s .top-level-info-button---RhnYV svg {\n      width: 18px;\n      height: 18px;\n      margin-right: 2px; }\n  .top-level-info-container---2DV9s .top-level-info-button---RhnYV svg path {\n        fill: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"top-level-info-container": "top-level-info-container---2DV9s",
	"header-container": "header-container---1uZf0",
	"date-range": "date-range---lr4BF",
	"top-level-info-button": "top-level-info-button---RhnYV"
};

/***/ }),

/***/ "lYPc":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".data-table---1sH4X {\n  margin-top: 20px;\n  border-radius: 5px;\n  padding-bottom: 20px;\n  min-height: 440px; }\n  .data-table---1sH4X .course-holder---I13oq {\n    border: 2px #cae7ff solid;\n    border-radius: 5px;\n    margin-bottom: 20px; }\n  .data-table---1sH4X .course-holder---I13oq.expanded---2BI8f .course-wrapper---1IEiq .course-button---1HEi3 {\n      background-color: transparent;\n      border: none; }\n  .data-table---1sH4X .course-holder---I13oq.expanded---2BI8f .course-wrapper---1IEiq .course-button---1HEi3 svg {\n        width: 14px;\n        height: 14px; }\n  .data-table---1sH4X .course-holder---I13oq.expanded---2BI8f .course-wrapper---1IEiq .course-button---1HEi3 svg {\n        -webkit-transform: rotate(-90deg);\n                transform: rotate(-90deg); }\n  .data-table---1sH4X .course-holder---I13oq.expanded---2BI8f .strands---MwOj8 {\n      max-height: 100%;\n      padding: 23px 16px;\n      overflow: visible; }\n  .data-table---1sH4X .course-wrapper---1IEiq {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    background-color: #cae7ff;\n    padding: 0 10px; }\n  .data-table---1sH4X .course-wrapper---1IEiq .course-name---3b7_m {\n      width: 100%;\n      height: 20px;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      font-weight: 600; }\n  .data-table---1sH4X .course-wrapper---1IEiq .course-button---1HEi3 {\n      background-color: transparent;\n      border: none;\n      -webkit-transform-origin: 40% 50%;\n              transform-origin: 40% 50%; }\n  .data-table---1sH4X .course-wrapper---1IEiq .course-button---1HEi3 svg {\n        width: 14px;\n        height: 14px; }\n  .data-table---1sH4X .course-wrapper---1IEiq .course-button---1HEi3 svg {\n        -webkit-transform: rotate(-270deg);\n                transform: rotate(-270deg); }\n  .data-table---1sH4X .strands---MwOj8 {\n    max-height: 0;\n    overflow: hidden;\n    padding: 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV:first-child .strand-header---2EECG {\n      margin-top: 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV:last-child .strand-header---2EECG {\n      margin-bottom: 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      color: #278bcb;\n      background-color: #eff7fd;\n      border-radius: 5px;\n      font-weight: 600;\n      font-size: 15px;\n      min-height: 40px;\n      margin: 16px 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .color-band---2ft3b {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 6px;\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 5px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .color-band---2ft3b.RED---29Lhs {\n          background-color: #c53902; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .color-band---2ft3b.ORANGE---3yNOc {\n          background-color: #e06d3f; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .color-band---2ft3b.DARK_BLUE---3_C1_ {\n          background-color: #e89e13; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .color-band---2ft3b.LIGHT_BLUE---3KJsh {\n          background-color: #81daab; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .color-band---2ft3b.GREEN---w4XMJ {\n          background-color: #37c97c; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .color-band---2ft3b.NOT_ASSIGNED---2j4T9 {\n          background-color: #dde4ff; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .strand-title---2g9VP {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .strand-title---2g9VP .strand-button---370iw {\n          background-color: transparent;\n          border: none;\n          margin-left: 11px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .strand-title---2g9VP .strand-button---370iw svg {\n            width: 14px;\n            height: 14px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-header---2EECG .strand-title---2g9VP .strand-button---370iw svg {\n            -webkit-transform: rotate(-270deg);\n                    transform: rotate(-270deg); }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN {\n      max-height: 0;\n      overflow: hidden;\n      padding: 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq {\n        overflow: hidden; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          border-bottom: 1px solid #00b4eb;\n          color: #278bcb;\n          font-weight: 600; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .color-band---2ft3b {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            width: 6px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .color-band---2ft3b.RED---29Lhs {\n              background-color: #c53902; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .color-band---2ft3b.ORANGE---3yNOc {\n              background-color: #e06d3f; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .color-band---2ft3b.DARK_BLUE---3_C1_ {\n              background-color: #e89e13; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .color-band---2ft3b.LIGHT_BLUE---3KJsh {\n              background-color: #81daab; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .color-band---2ft3b.GREEN---w4XMJ {\n              background-color: #37c97c; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .color-band---2ft3b.NOT_ASSIGNED---2j4T9 {\n              background-color: #dde4ff; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .standard-content---3w25k {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n            width: 47%;\n            padding: 9px 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .standard-content---3w25k span {\n              padding-right: 16px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .standard-separator---3dhL7 {\n            width: 47%; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .standard-content-border---3dOsz .standard-completed---3YwBX {\n            width: 6%;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n            -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                    justify-content: center;\n            min-width: 100px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .topic-wrapper---4lmm- {\n          max-height: 0;\n          overflow: hidden;\n          padding: 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .topic-wrapper---4lmm- .topic-content---3F_rM {\n            width: 100%; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .topic-wrapper---4lmm- .topic-content---3F_rM .topic-name---2gH1k {\n              width: 47%; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .topic-wrapper---4lmm- .topic-content---3F_rM .topic-name---2gH1k .topic-text---3tKqj {\n                margin-left: 50px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .topic-wrapper---4lmm- .topic-content---3F_rM .topic-status---l3KJ4 {\n              width: 47%;\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -ms-flex-wrap: wrap;\n                  flex-wrap: wrap;\n              -webkit-box-pack: start;\n                  -ms-flex-pack: start;\n                      justify-content: start; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .topic-wrapper---4lmm- .topic-content---3F_rM .topic-completed---5Ly0C {\n              width: 6%;\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-align: center;\n                  -ms-flex-align: center;\n                      align-items: center;\n              -webkit-box-pack: center;\n                  -ms-flex-pack: center;\n                      justify-content: center;\n              min-width: 100px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq .topic-wrapper---4lmm- .color-band---2ft3b {\n            background-color: #dde4ff;\n            width: 6px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq.expanded---2BI8f .standard-button---3120a {\n          background-color: transparent;\n          border: none; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq.expanded---2BI8f .standard-button---3120a svg {\n            width: 14px;\n            height: 14px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq.expanded---2BI8f .standard-button---3120a svg {\n            -webkit-transform: rotate(-90deg);\n                    transform: rotate(-90deg); }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq.expanded---2BI8f .topic-wrapper---4lmm- {\n          max-height: none;\n          overflow: visible;\n          min-height: 32px;\n          border-bottom: 1px solid #00b4eb;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-wrapper---3YGoq.expanded---2BI8f .topic-wrapper---4lmm- .topic-content---3F_rM {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center;\n            padding: 5px 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-button---3120a {\n        background-color: transparent;\n        border: none;\n        margin-left: 9px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-button---3120a svg {\n          width: 14px;\n          height: 14px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-button---3120a svg {\n          -webkit-transform: rotate(-270deg);\n                  transform: rotate(-270deg); }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n        background-color: #e4eaef;\n        height: 24px;\n        padding: 5px 10px 5px 16px;\n        font-weight: 600;\n        font-size: 14px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD {\n          position: relative; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD .info-context-modal---xE1Dh {\n            visibility: hidden;\n            opacity: 0;\n            top: 30px;\n            -webkit-transform: translate(-46%, 0%);\n                    transform: translate(-46%, 0%);\n            width: 200px;\n            font-weight: normal; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD .info-context-modal---xE1Dh.right-edge-override---FMJ2A {\n              left: -75px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD .info-context-modal---xE1Dh.right-edge-override---FMJ2A div::before, .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD .info-context-modal---xE1Dh.right-edge-override---FMJ2A div::after {\n                left: 88%; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD .info-context-modal---xE1Dh:hover {\n              visibility: visible;\n              opacity: 1;\n              -webkit-transition: visibility 0s, opacity 0.2s linear;\n              transition: visibility 0s, opacity 0.2s linear; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD .info-button---teczx {\n            background-color: transparent;\n            border: 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD .info-button---teczx div {\n              width: 14px;\n              height: 14px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .info-button-wrapper---3KgYD .info-button---teczx:hover + .info-context-modal---xE1Dh {\n              visibility: visible;\n              opacity: 1;\n              -webkit-transition: visibility 0s, opacity 0.2s linear;\n              transition: visibility 0s, opacity 0.2s linear; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .long----q5dZ,\n        .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .short---3t5Dm {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .long----q5dZ {\n          width: 47%; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .short---3t5Dm {\n          width: 6%;\n          min-width: 100px;\n          -webkit-box-pack: end;\n              -ms-flex-pack: end;\n                  justify-content: flex-end; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .short---3t5Dm .completed-info-button---1d_GN {\n            border: none;\n            background-color: transparent;\n            color: #4e5c67;\n            font-weight: bold;\n            padding: 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV .strand-wrapper---m7VVN .standard-title---2xS6G .short---3t5Dm .completed-info-button---1d_GN:hover {\n              text-decoration: underline; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG {\n      margin-bottom: 0;\n      border-radius: 5px 5px 0 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .color-band---2ft3b {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        width: 6px;\n        border-top-left-radius: 5px;\n        border-bottom-left-radius: 0; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .color-band---2ft3b.RED---29Lhs {\n          background-color: #c53902; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .color-band---2ft3b.ORANGE---3yNOc {\n          background-color: #e06d3f; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .color-band---2ft3b.DARK_BLUE---3_C1_ {\n          background-color: #e89e13; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .color-band---2ft3b.LIGHT_BLUE---3KJsh {\n          background-color: #81daab; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .color-band---2ft3b.GREEN---w4XMJ {\n          background-color: #37c97c; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .color-band---2ft3b.NOT_ASSIGNED---2j4T9 {\n          background-color: #dde4ff; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .strand-button---370iw {\n        background-color: transparent;\n        border: none; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .strand-button---370iw svg {\n          width: 14px;\n          height: 14px; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-header---2EECG .strand-button---370iw svg {\n          -webkit-transform: rotate(-90deg);\n                  transform: rotate(-90deg); }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-wrapper---m7VVN {\n      max-height: 100%;\n      padding-bottom: 10px;\n      overflow: visible;\n      border-bottom-left-radius: 5px;\n      border-bottom-right-radius: 5px;\n      border-right: 1px solid #e4eaef;\n      border-left: 1px solid #e4eaef;\n      border-bottom: 1px solid #e4eaef; }\n  .data-table---1sH4X .strands---MwOj8 .strand-content---1vSrV.expanded---2BI8f .strand-wrapper---m7VVN .standard-wrapper---3YGoq {\n        overflow: visible; }\n", ""]);

// exports
exports.locals = {
	"data-table": "data-table---1sH4X",
	"course-holder": "course-holder---I13oq",
	"expanded": "expanded---2BI8f",
	"course-wrapper": "course-wrapper---1IEiq",
	"course-button": "course-button---1HEi3",
	"strands": "strands---MwOj8",
	"course-name": "course-name---3b7_m",
	"strand-content": "strand-content---1vSrV",
	"strand-header": "strand-header---2EECG",
	"color-band": "color-band---2ft3b",
	"RED": "RED---29Lhs",
	"ORANGE": "ORANGE---3yNOc",
	"DARK_BLUE": "DARK_BLUE---3_C1_",
	"LIGHT_BLUE": "LIGHT_BLUE---3KJsh",
	"GREEN": "GREEN---w4XMJ",
	"NOT_ASSIGNED": "NOT_ASSIGNED---2j4T9",
	"strand-title": "strand-title---2g9VP",
	"strand-button": "strand-button---370iw",
	"strand-wrapper": "strand-wrapper---m7VVN",
	"standard-wrapper": "standard-wrapper---3YGoq",
	"standard-content-border": "standard-content-border---3dOsz",
	"standard-content": "standard-content---3w25k",
	"standard-separator": "standard-separator---3dhL7",
	"standard-completed": "standard-completed---3YwBX",
	"topic-wrapper": "topic-wrapper---4lmm-",
	"topic-content": "topic-content---3F_rM",
	"topic-name": "topic-name---2gH1k",
	"topic-text": "topic-text---3tKqj",
	"topic-status": "topic-status---l3KJ4",
	"topic-completed": "topic-completed---5Ly0C",
	"standard-button": "standard-button---3120a",
	"standard-title": "standard-title---2xS6G",
	"info-button-wrapper": "info-button-wrapper---3KgYD",
	"info-context-modal": "info-context-modal---xE1Dh",
	"right-edge-override": "right-edge-override---FMJ2A",
	"info-button": "info-button---teczx",
	"long": "long----q5dZ",
	"short": "short---3t5Dm",
	"completed-info-button": "completed-info-button---1d_GN"
};

/***/ }),

/***/ "lZfO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".header---1XkWH {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  min-width: 0; }\n  .header---1XkWH h2 {\n    color: #415667;\n    font-size: 25px;\n    max-width: calc(100% - 16px);\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .header---1XkWH .date-range---3Fvt_ {\n    display: block;\n    float: left;\n    clear: both;\n    font-size: 16px;\n    color: #1981c4; }\n  .subheader---1kVbr {\n  text-wrap: wrap; }\n", ""]);

// exports
exports.locals = {
	"header": "header---1XkWH",
	"date-range": "date-range---3Fvt_",
	"subheader": "subheader---1kVbr"
};

/***/ }),

/***/ "llwb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSIGNMENT_RESULT_TYPES = void 0;
exports["default"] = _default;
var _assignmentResultActions = __webpack_require__("Wr1R");
var ASSIGNMENT_RESULT_TYPES = exports.ASSIGNMENT_RESULT_TYPES = {
  HIGHEST: 0,
  TEACHER_ASSIGNED: 1,
  VOLUNTARY: 2
};
var defaultState = ASSIGNMENT_RESULT_TYPES.TEACHER_ASSIGNED;

/**
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type
 * @returns {number} the new state
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _assignmentResultActions.SET_ASSIGNMENT_RESULTS_TYPE:
      {
        return action.payload;
      }
    default:
      return state;
  }
}

/***/ }),

/***/ "lyol":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HM4R");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./certificate-confirmation-modal.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./certificate-confirmation-modal.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "mHLE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ACADEMIC_YEAR_RETRIEVED = void 0;
var _dayjs = _interopRequireDefault(__webpack_require__("oqQY"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ACADEMIC_YEAR_RETRIEVED = exports.ACADEMIC_YEAR_RETRIEVED = 'ACADEMIC_YEAR_RETRIEVED';
function getAcademicYear() {
  return function (dispatch) {
    return _resources["default"].academicYear.get().send().then(function (payload) {
      return dispatch({
        type: ACADEMIC_YEAR_RETRIEVED,
        payload: getFormattedAcademicYear(payload)
      });
    });
  };
}
function getFormattedAcademicYear(payload) {
  var _payload$data = payload.data,
    year = _payload$data.year,
    startDateDateTime = _payload$data.startDateDateTime,
    endDateDateTime = _payload$data.endDateDateTime;
  var formatString = 'YYYY-MM-DD';
  return {
    year: year,
    startDate: (0, _dayjs["default"])(stripTime(startDateDateTime)).format(formatString),
    endDate: (0, _dayjs["default"])(stripTime(endDateDateTime)).format(formatString)
  };
}
function stripTime(isoString) {
  return isoString.split('T')[0];
}
var _default = exports["default"] = {
  getAcademicYear: getAcademicYear
};

/***/ }),

/***/ "mLyz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReportFilters = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _isEqual = _interopRequireDefault(__webpack_require__("hygk"));
var _reportFilters = _interopRequireDefault(__webpack_require__("u5Zj"));
var _filterConstants = __webpack_require__("cdWI");
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _routeHelper = _interopRequireDefault(__webpack_require__("H7F4"));
var _filterPropTypes = __webpack_require__("1g86");
var _academicYearActions = _interopRequireDefault(__webpack_require__("mHLE"));
var _classListActions = _interopRequireDefault(__webpack_require__("Mre5"));
var _studentsByGroupActions = _interopRequireDefault(__webpack_require__("dFjD"));
var _hasLifetimeDataActions = _interopRequireDefault(__webpack_require__("ZBNL"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _yearGroupsActions = _interopRequireDefault(__webpack_require__("SRTg"));
var _studentsByGroupSelectors = _interopRequireDefault(__webpack_require__("gYwg"));
var _yearGroupsSelectors = _interopRequireDefault(__webpack_require__("Hi7O"));
var _isAdminActions = _interopRequireDefault(__webpack_require__("xR72"));
var _dropdownMenus = __webpack_require__("hxFo");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * ReportFilters component - displays various dropdowns for filtering purposes
 * After selecting filters user clicks on Search button
 *
 * Filters have complex logic related to things like auto-selecting based on page route,
 * disabling if only one option, etc.
 */
var ReportFilters = exports.ReportFilters = /*#__PURE__*/function (_Component) {
  function ReportFilters(props, context) {
    var _this;
    _classCallCheck(this, ReportFilters);
    _this = _callSuper(this, ReportFilters, [props, context]);
    _defineProperty(_this, "applyFilters", function () {
      _this.setState({
        hasLoaded: false
      });
      _this.manageFilterOverride();
      _this.props.setFiltersFromSelectedOptions();
    });
    /**
     * Business rule for Skill Quests Mastery report that custom date start date needs to be start of
     * academic year... edge case exists when navigating from any report type to Skill Quests Mastery
     * that pre selected custom date will conflict with this rule... hence we create override function to default
     * Skills Quests Mastery report to 'This school year' everytime :(
     */
    _defineProperty(_this, "manageFilterOverride", function () {
      var _this$props = _this.props,
        selectedReportId = _this$props.activeFilters[_filterConstants.SELECTED_REPORT].id,
        dropdownReportId = _this$props.reportDropdownData.selectedOption.value,
        academicYear = _this$props.academicYear;
      if (dropdownReportId === _filterConstants.SKILL_QUESTS_MASTERY && dropdownReportId !== selectedReportId) {
        _this.props.setSelectedDate({
          type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR,
          startDate: academicYear.startDate,
          endDate: academicYear.endDate
        });
      }
    });
    var history = context.router.history;
    _this.state = {
      route: history.location.pathname,
      params: history.location.search,
      hasLoaded: false
    };
    return _this;
  }
  _inherits(ReportFilters, _Component);
  return _createClass(ReportFilters, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        getAcademicYear = _this$props2.getAcademicYear,
        getAllClassesData = _this$props2.getAllClassesData,
        getHasLifetimeData = _this$props2.getHasLifetimeData,
        getIsAdmin = _this$props2.getIsAdmin;
      getIsAdmin();
      getAcademicYear();
      getHasLifetimeData();
      getAllClassesData();
      this.listenForBrowserBack();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props3 = this.props,
        academicYear = _this$props3.academicYear,
        activeFilters = _this$props3.activeFilters,
        isAdmin = _this$props3.isAdmin,
        studentsByGroup = _this$props3.studentsByGroup,
        allClasses = _this$props3.allClasses,
        teachers = _this$props3.teachers,
        yearGroups = _this$props3.yearGroups,
        getStudentsByGroup = _this$props3.getStudentsByGroup,
        getYearGroups = _this$props3.getYearGroups;
      var newAcademicYear = newProps.academicYear,
        newActiveFilters = newProps.activeFilters,
        newIsAdmin = newProps.isAdmin,
        newStudentsByGroup = newProps.studentsByGroup,
        newAllClasses = newProps.allClasses,
        newTeachers = newProps.teachers,
        newYearGroups = newProps.yearGroups;
      var _this$state = this.state,
        prevRoute = _this$state.route,
        prevParams = _this$state.params;
      var location = this.context.router.history.location;
      var route = _routeHelper["default"].calculateRouteFromFilters(newActiveFilters);
      var params = _routeHelper["default"].calculateParamsFromFilters(newActiveFilters);
      var selectedClass = _routeHelper["default"].calculateSelectedClassFromRoute(location.pathname, newAllClasses);
      var hasActiveFiltersSelectedDateAvailable = activeFilters && activeFilters.selectedDate && activeFilters.selectedDate.startDate === null && activeFilters.selectedDate.endDate === null && newActiveFilters && newActiveFilters.selectedDate && newActiveFilters.selectedDate.startDate !== null && newActiveFilters.selectedDate.endDate !== null;
      var hasAcademicYearAvailable = academicYear && academicYear.startDate === null && academicYear.endDate === null && newAcademicYear && newAcademicYear.startDate !== null && newAcademicYear.endDate !== null;
      if (hasActiveFiltersSelectedDateAvailable) {
        this.appendAcademicYear(params);
      }
      if (hasAcademicYearAvailable) {
        var overrideParams = _routeHelper["default"].calculateParamsFromFilters(_defineProperty({}, _filterConstants.SELECTED_DATE, newAcademicYear));
        this.appendAcademicYear(overrideParams);
      }

      /** Loads the new route when the active filters change */
      if (activeFilters !== newActiveFilters && (route !== prevRoute || _routeHelper["default"].areDateParamsDifferent(params, prevParams))) {
        this.loadNewRoute(route, params, newActiveFilters);
      }

      /** Load admin dropdown data */
      if (isAdmin !== newIsAdmin && newIsAdmin === true) {
        getYearGroups();
      }

      /** Loads groups + students for selected class on first load */
      if (allClasses !== newAllClasses) {
        if (selectedClass) {
          getStudentsByGroup(selectedClass.id);
        } else {
          this.filterDataLoaded(newProps, selectedClass);
        }
      }
      if (allClasses !== newAllClasses || studentsByGroup !== newStudentsByGroup || yearGroups !== newYearGroups || teachers !== newTeachers || isAdmin !== newIsAdmin) {
        this.filterDataLoaded(newProps, selectedClass);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unlisten) {
        this.unlisten();
      }
    }
  }, {
    key: "filterDataLoaded",
    value: function filterDataLoaded(props, selectedClass) {
      var _this2 = this;
      if (!this.state.hasLoaded) {
        var yearGroups = props.yearGroups,
          teachers = props.teachers,
          allClasses = props.allClasses,
          studentsByGroup = props.studentsByGroup,
          isAdmin = props.isAdmin;
        var allFiltersLoaded;
        var isClassEmpty = studentsByGroup.length === 0;
        if (isAdmin === true) {
          allFiltersLoaded = teachers.length > 0 && yearGroups.length > 0 && allClasses.length > 0 && (!selectedClass || studentsByGroup.length > 0);
        } else if (isAdmin === false) {
          allFiltersLoaded = allClasses.length > 0 && (!selectedClass || studentsByGroup.length > 0);
        }
        if (allFiltersLoaded || isClassEmpty) {
          var location = this.context.router.history.location;
          setTimeout(function () {
            _this2.setFiltersFromRoute(location.pathname, location.search, props);
          }, 0);
        }
      }
    }

    /**
     * Updates the filters when user clicks on browser's back button
     */
  }, {
    key: "listenForBrowserBack",
    value: function listenForBrowserBack() {
      var _this3 = this;
      var history = this.context.router.history;
      var setDropdownData = this.props.setDropdownData;
      this.unlisten = history.listen(function (location, action) {
        if (location.pathname !== _this3.state.route || location.search !== _this3.state.params) {
          _this3.setState({
            hasLoaded: false
          });
        }
        if (action === 'POP') {
          var _this3$props = _this3.props,
            activeFilters = _this3$props.activeFilters,
            allClasses = _this3$props.allClasses;

          // clear group/student dropdowns if returning to all classes view
          var selectedClass = _routeHelper["default"].calculateSelectedClassFromRoute(location.pathname, allClasses);
          if (!selectedClass) {
            setDropdownData(_defineProperty(_defineProperty({}, _filterConstants.GROUP_LIST, {
              data: []
            }), _filterConstants.STUDENT_LIST, {
              data: []
            }));
            _this3.filterDataLoaded(_this3.props);
          } else {
            _this3.loadGroupsAndStudentsFromRoute(location.pathname, location.search, activeFilters);
          }
        }
      });
    }

    /**
     * Runs when active filters have changed and we need to load a new page in the app
     * Pushes new route into history, and sets the new state of the dropdown menus - disabled,
     * selected options, loading group/student data, etc.
     */
  }, {
    key: "loadNewRoute",
    value: function loadNewRoute(route, params) {
      var history = this.context.router.history;
      history.push({
        pathname: route,
        search: params
      });
      this.loadGroupsAndStudentsFromRoute(route, params);
    }
  }, {
    key: "appendAcademicYear",
    value: function appendAcademicYear(params) {
      var history = this.context.router.history;
      history.push({
        search: params
      });
    }

    /**
     * Loads the groups and students for the class in the route
     * If there is no class in the route, will just proceed to setting the filters using the route
     */
  }, {
    key: "loadGroupsAndStudentsFromRoute",
    value: function loadGroupsAndStudentsFromRoute(route, params) {
      var _this$props4 = this.props,
        allClasses = _this$props4.allClasses,
        getStudentsByGroup = _this$props4.getStudentsByGroup;
      var selectedClass = _routeHelper["default"].calculateSelectedClassFromRoute(route, allClasses);
      if (selectedClass) {
        var madeRequest = getStudentsByGroup(selectedClass.id);
        // if the class id has not changed, we will not make a new request
        // for group + student data so need to set the filters here
        if (madeRequest) {
          this.setState({
            hasLoaded: false
          });
        } else {
          this.setFiltersFromRoute(route, params, this.props);
        }
      } else {
        this.setFiltersFromRoute(route, params, this.props);
      }
    }

    /**
     * Sets the active filters by checking the route
     * Used on initial app load if user loads a child route ie. activity-mastery/class/187
     * and if user navigates by clicking on items in the table ie. a class in all classes table
     */
  }, {
    key: "setFiltersFromRoute",
    value: function setFiltersFromRoute(route, params, props) {
      var activeFilters = props.activeFilters,
        yearGroups = props.yearGroups,
        teachers = props.teachers,
        allClasses = props.allClasses,
        studentsByGroup = props.studentsByGroup;
      var _this$props5 = this.props,
        setSelectedOptionsFromFilters = _this$props5.setSelectedOptionsFromFilters,
        setActiveFilters = _this$props5.setActiveFilters;
      var filtersFromRoute = _routeHelper["default"].calculateFiltersFromRoute(route, params, allClasses, studentsByGroup, yearGroups, teachers, activeFilters);
      this.setState({
        route: route,
        params: params,
        hasLoaded: true
      });
      setSelectedOptionsFromFilters(filtersFromRoute);
      if (!(0, _isEqual["default"])(activeFilters, filtersFromRoute)) {
        setActiveFilters(filtersFromRoute);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isAdmin = this.props.isAdmin;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _reportFilters["default"]['report-filter-container']
      }, isAdmin && [/*#__PURE__*/_react["default"].createElement(_dropdownMenus.ConnectedYearGroupDropdown, {
        key: 0,
        className: _reportFilters["default"].dropdown,
        applyFilters: this.applyFilters
      }), /*#__PURE__*/_react["default"].createElement(_dropdownMenus.ConnectedTeacherDropdown, {
        key: 1,
        className: _reportFilters["default"].dropdown,
        applyFilters: this.applyFilters
      })], /*#__PURE__*/_react["default"].createElement(_dropdownMenus.ConnectedClassDropdown, {
        className: _reportFilters["default"].dropdown,
        handleClassChange: this.applyFilters
      }), /*#__PURE__*/_react["default"].createElement(_dropdownMenus.ConnectedGroupDropdown, {
        className: _reportFilters["default"].dropdown,
        handleGroupChange: this.applyFilters
      }), /*#__PURE__*/_react["default"].createElement(_dropdownMenus.ConnectedStudentDropdown, {
        className: _reportFilters["default"].dropdown,
        handleStudentChange: this.applyFilters
      }), /*#__PURE__*/_react["default"].createElement(_dropdownMenus.ConnectedReportDropdown, {
        className: _reportFilters["default"].dropdown,
        handleApplyFilters: this.applyFilters
      }), /*#__PURE__*/_react["default"].createElement(_dropdownMenus.ConnectedDateDropdown, {
        className: _reportFilters["default"]['report-date-filter'],
        handleApplyFilters: this.applyFilters
      }));
    }
  }]);
}(_react.Component);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(ReportFilters, "contextTypes", {
  router: _propTypes["default"].object
});
_defineProperty(ReportFilters, "propTypes", {
  activeFilters: _filterPropTypes.activeFiltersPropType,
  reportDropdownData: _propTypes["default"].shape({
    selectedOption: _filterPropTypes.filterPropType
  }),
  academicYear: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }),
  allClasses: _propTypes["default"].arrayOf(_filterPropTypes.classPropType),
  yearGroups: _propTypes["default"].arrayOf(_filterPropTypes.yearGroupPropType),
  teachers: _propTypes["default"].arrayOf(_filterPropTypes.teacherPropType),
  studentsByGroup: _propTypes["default"].arrayOf(_filterPropTypes.studentsByGroupPropType),
  isAdmin: _propTypes["default"].bool,
  setActiveFilters: _propTypes["default"].func,
  setFiltersFromSelectedOptions: _propTypes["default"].func,
  setSelectedOptionsFromFilters: _propTypes["default"].func,
  getIsAdmin: _propTypes["default"].func,
  getAcademicYear: _propTypes["default"].func,
  getAllClassesData: _propTypes["default"].func,
  getStudentsByGroup: _propTypes["default"].func,
  getHasLifetimeData: _propTypes["default"].func,
  setDropdownData: _propTypes["default"].func,
  getYearGroups: _propTypes["default"].func,
  setSelectedDate: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    academicYear: state.academicYear,
    activeFilters: state.activeFilters,
    reportDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.REPORT_LIST)(state),
    yearGroups: _yearGroupsSelectors["default"].selectYearGroups(state),
    teachers: _yearGroupsSelectors["default"].selectAllTeachers(state),
    allClasses: state.allClasses,
    studentsByGroup: _studentsByGroupSelectors["default"].selectGroupsAndStudents(state),
    isAdmin: state.isAdmin
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setActiveFilters: _activeFiltersActions["default"].setActiveFilters,
    setFiltersFromSelectedOptions: _activeFiltersActions["default"].setFiltersFromSelectedOptions,
    getAcademicYear: _academicYearActions["default"].getAcademicYear,
    getAllClassesData: _classListActions["default"].getClassesData,
    getStudentsByGroup: _studentsByGroupActions["default"].getStudentsByGroup,
    getHasLifetimeData: _hasLifetimeDataActions["default"].getHasLifetimeData,
    setDropdownData: _dropdownDataActions["default"].setDropdownData,
    setSelectedOptionsFromFilters: _dropdownDataActions["default"].setSelectedOptionsFromFilters,
    getYearGroups: _yearGroupsActions["default"].getYearGroups,
    getIsAdmin: _isAdminActions["default"].getIsSchoolAdmin,
    setSelectedDate: _dropdownDataActions["default"].setSelectedDate
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReportFilters);

/***/ }),

/***/ "mXER":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filterConstants = __webpack_require__("cdWI");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterHelper = exports["default"] = /*#__PURE__*/function () {
  function FilterHelper() {
    _classCallCheck(this, FilterHelper);
  }
  return _createClass(FilterHelper, null, [{
    key: "shouldLoadAllClasses",
    value: function shouldLoadAllClasses(activeFilters) {
      return activeFilters[_filterConstants.SELECTED_DATE].type !== null && activeFilters[_filterConstants.SELECTED_CLASS].id && activeFilters[_filterConstants.SELECTED_CLASS].id === _filterConstants.ALL_CLASSES && activeFilters[_filterConstants.SELECTED_STUDENT].id && activeFilters[_filterConstants.SELECTED_STUDENT].id === _filterConstants.ALL_STUDENTS;
    }
  }, {
    key: "shouldReloadAllClasses",
    value: function shouldReloadAllClasses(activeFilters, newActiveFilters) {
      return (activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id !== newActiveFilters[_filterConstants.SELECTED_YEAR_GROUP].id || activeFilters[_filterConstants.SELECTED_TEACHER].id !== newActiveFilters[_filterConstants.SELECTED_TEACHER].id || activeFilters[_filterConstants.SELECTED_CLASS].id !== newActiveFilters[_filterConstants.SELECTED_CLASS].id || !_dateParamHelper["default"].areDatesEqual(activeFilters[_filterConstants.SELECTED_DATE], newActiveFilters[_filterConstants.SELECTED_DATE])) && newActiveFilters[_filterConstants.SELECTED_STUDENT].id === _filterConstants.ALL_STUDENTS && newActiveFilters[_filterConstants.SELECTED_CLASS].id === _filterConstants.ALL_CLASSES;
    }
  }, {
    key: "shouldLoadSingleClass",
    value: function shouldLoadSingleClass(activeFilters) {
      return activeFilters[_filterConstants.SELECTED_DATE].type !== null && activeFilters[_filterConstants.SELECTED_CLASS].id && activeFilters[_filterConstants.SELECTED_CLASS].id !== _filterConstants.ALL_CLASSES && activeFilters[_filterConstants.SELECTED_STUDENT].id && activeFilters[_filterConstants.SELECTED_STUDENT].id === _filterConstants.ALL_STUDENTS;
    }
  }, {
    key: "shouldReloadSingleClass",
    value: function shouldReloadSingleClass(activeFilters, newActiveFilters) {
      var hasSelectedClassChanged = activeFilters[_filterConstants.SELECTED_CLASS].id !== newActiveFilters[_filterConstants.SELECTED_CLASS].id;
      var hasSelectedStudentChanged = activeFilters[_filterConstants.SELECTED_STUDENT].id !== newActiveFilters[_filterConstants.SELECTED_STUDENT].id;
      var hasSelectedDateChanged = !_dateParamHelper["default"].areDatesEqual(activeFilters[_filterConstants.SELECTED_DATE], newActiveFilters[_filterConstants.SELECTED_DATE]);
      var hasSelectedGroupChanged = activeFilters[_filterConstants.SELECTED_GROUP].id !== newActiveFilters[_filterConstants.SELECTED_GROUP].id;
      var hasActiveFiltersIdChanged = hasSelectedClassChanged || hasSelectedStudentChanged || hasSelectedDateChanged || hasSelectedGroupChanged;
      return hasActiveFiltersIdChanged && newActiveFilters[_filterConstants.SELECTED_CLASS].id !== _filterConstants.ALL_CLASSES && newActiveFilters[_filterConstants.SELECTED_STUDENT].id === _filterConstants.ALL_STUDENTS;
    }
  }, {
    key: "shouldLoadStudent",
    value: function shouldLoadStudent(activeFilters) {
      return activeFilters[_filterConstants.SELECTED_DATE].type !== null && activeFilters[_filterConstants.SELECTED_CLASS].id && activeFilters[_filterConstants.SELECTED_CLASS].id !== _filterConstants.ALL_CLASSES && activeFilters[_filterConstants.SELECTED_STUDENT].id && activeFilters[_filterConstants.SELECTED_STUDENT].id !== _filterConstants.ALL_STUDENTS;
    }
  }, {
    key: "shouldReloadStudent",
    value: function shouldReloadStudent(activeFilters, newActiveFilters) {
      return (activeFilters[_filterConstants.SELECTED_CLASS].id !== newActiveFilters[_filterConstants.SELECTED_CLASS].id || activeFilters[_filterConstants.SELECTED_STUDENT].id !== newActiveFilters[_filterConstants.SELECTED_STUDENT].id || !_dateParamHelper["default"].areDatesEqual(activeFilters[_filterConstants.SELECTED_DATE], newActiveFilters[_filterConstants.SELECTED_DATE])) && newActiveFilters[_filterConstants.SELECTED_CLASS].id !== _filterConstants.ALL_CLASSES && newActiveFilters[_filterConstants.SELECTED_STUDENT].id !== _filterConstants.ALL_STUDENTS;
    }
  }]);
}();

/***/ }),

/***/ "n/+0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _linguiCdn = __webpack_require__("siuH");
var _skillQuestsMasteryLegendsTranslations = _interopRequireDefault(__webpack_require__("7jvZ"));
var _skillQuestsMasteryLegends = _interopRequireDefault(__webpack_require__("5YJm"));
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SkillQuestsMasteryLegends = function SkillQuestsMasteryLegends(_ref) {
  var variant = _ref.variant;
  var legends;
  var CLASS_GROUP_LEVEL = _skillQuestsMasteryConstants.SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS.CLASS_GROUP_LEVEL,
    STUDENT_ACCURACY = _skillQuestsMasteryConstants.SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS.STUDENT_ACCURACY,
    STUDENT_PROGRESS = _skillQuestsMasteryConstants.SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS.STUDENT_PROGRESS;
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var _useTranslations = (0, _skillQuestsMasteryLegendsTranslations["default"])({
      i18n: i18n
    }),
    CLASS_GROUP_81_TO_100_TEXT = _useTranslations.CLASS_GROUP_81_TO_100_TEXT,
    CLASS_GROUP_61_TO_80_TEXT = _useTranslations.CLASS_GROUP_61_TO_80_TEXT,
    CLASS_GROUP_41_TO_60_TEXT = _useTranslations.CLASS_GROUP_41_TO_60_TEXT,
    CLASS_GROUP_21_TO_40_TEXT = _useTranslations.CLASS_GROUP_21_TO_40_TEXT,
    CLASS_GROUP_1_TO_20_TEXT = _useTranslations.CLASS_GROUP_1_TO_20_TEXT,
    STUDENT_PROGRESS_100_TEXT = _useTranslations.STUDENT_PROGRESS_100_TEXT,
    STUDENT_PROGRESS_81_TO_99_TEXT = _useTranslations.STUDENT_PROGRESS_81_TO_99_TEXT,
    STUDENT_PROGRESS_61_TO_80_TEXT = _useTranslations.STUDENT_PROGRESS_61_TO_80_TEXT,
    STUDENT_PROGRESS_41_TO_60_TEXT = _useTranslations.STUDENT_PROGRESS_41_TO_60_TEXT,
    STUDENT_PROGRESS_21_TO_40_TEXT = _useTranslations.STUDENT_PROGRESS_21_TO_40_TEXT,
    STUDENT_PROGRESS_1_TO_20_TEXT = _useTranslations.STUDENT_PROGRESS_1_TO_20_TEXT,
    STUDENT_ACCURACY_COMPLETE_TEXT = _useTranslations.STUDENT_ACCURACY_COMPLETE_TEXT,
    STUDENT_ACCURACY_81_TO_100_TEXT = _useTranslations.STUDENT_ACCURACY_81_TO_100_TEXT,
    STUDENT_ACCURACY_61_TO_80_TEXT = _useTranslations.STUDENT_ACCURACY_61_TO_80_TEXT,
    STUDENT_ACCURACY_41_TO_60_TEXT = _useTranslations.STUDENT_ACCURACY_41_TO_60_TEXT,
    STUDENT_ACCURACY_21_TO_40_TEXT = _useTranslations.STUDENT_ACCURACY_21_TO_40_TEXT,
    STUDENT_ACCURACY_1_TO_20_TEXT = _useTranslations.STUDENT_ACCURACY_1_TO_20_TEXT;
  switch (variant) {
    case CLASS_GROUP_LEVEL:
      legends = [{
        text: CLASS_GROUP_81_TO_100_TEXT,
        className: _skillQuestsMasteryLegends["default"].green
      }, {
        text: CLASS_GROUP_61_TO_80_TEXT,
        className: _skillQuestsMasteryLegends["default"]['light-blue']
      }, {
        text: CLASS_GROUP_41_TO_60_TEXT,
        className: _skillQuestsMasteryLegends["default"]['dark-blue']
      }, {
        text: CLASS_GROUP_21_TO_40_TEXT,
        className: _skillQuestsMasteryLegends["default"].orange
      }, {
        text: CLASS_GROUP_1_TO_20_TEXT,
        className: _skillQuestsMasteryLegends["default"].red
      }];
      break;
    case STUDENT_PROGRESS:
      legends = [{
        text: STUDENT_PROGRESS_100_TEXT,
        className: _skillQuestsMasteryLegends["default"]['progress-complete']
      }, {
        text: STUDENT_PROGRESS_81_TO_99_TEXT,
        className: _skillQuestsMasteryLegends["default"].green
      }, {
        text: STUDENT_PROGRESS_61_TO_80_TEXT,
        className: _skillQuestsMasteryLegends["default"]['light-blue']
      }, {
        text: STUDENT_PROGRESS_41_TO_60_TEXT,
        className: _skillQuestsMasteryLegends["default"]['dark-blue']
      }, {
        text: STUDENT_PROGRESS_21_TO_40_TEXT,
        className: _skillQuestsMasteryLegends["default"].orange
      }, {
        text: STUDENT_PROGRESS_1_TO_20_TEXT,
        className: _skillQuestsMasteryLegends["default"].red
      }];
      break;
    case STUDENT_ACCURACY:
      legends = [{
        text: STUDENT_ACCURACY_COMPLETE_TEXT,
        className: _skillQuestsMasteryLegends["default"]['accuracy-complete']
      }, {
        text: STUDENT_ACCURACY_81_TO_100_TEXT,
        className: _skillQuestsMasteryLegends["default"].green
      }, {
        text: STUDENT_ACCURACY_61_TO_80_TEXT,
        className: _skillQuestsMasteryLegends["default"]['light-blue']
      }, {
        text: STUDENT_ACCURACY_41_TO_60_TEXT,
        className: _skillQuestsMasteryLegends["default"]['dark-blue']
      }, {
        text: STUDENT_ACCURACY_21_TO_40_TEXT,
        className: _skillQuestsMasteryLegends["default"].orange
      }, {
        text: STUDENT_ACCURACY_1_TO_20_TEXT,
        className: _skillQuestsMasteryLegends["default"].red
      }];
      break;
    default:
      break;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _skillQuestsMasteryLegends["default"]['skill-quests-mastery-legend']
  }, legends.map(function (legend) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _skillQuestsMasteryLegends["default"].legend,
      key: legend.className
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: legend.className
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _skillQuestsMasteryLegends["default"].text
    }, legend.text));
  }));
};
SkillQuestsMasteryLegends.propTypes = {
  variant: _propTypes["default"].number
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_skillQuestsMasteryLegends["default"])(SkillQuestsMasteryLegends);

/***/ }),

/***/ "nIya":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Tj2k");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./core.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./core.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nKx8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---EZxWA {\n  height: calc(100% - 90px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  overflow: auto; }\n  .component---EZxWA .certificates---1uddj {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .component---EZxWA > div {\n    margin: 0 8px; }\n  .component---EZxWA > div:first-of-type {\n      margin-left: 0; }\n  .component---EZxWA > div:last-of-type {\n      margin-right: 0; }\n  .component---EZxWA .participation-results---3FLKV {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 100%;\n            flex: 1 1 100%;\n    max-width: 100%;\n    min-width: 1200px;\n    padding: 0 8px; }\n  .component---EZxWA .participation-results---3FLKV h3 {\n      font-size: 18px;\n      font-weight: normal;\n      margin: 8px; }\n  .component---EZxWA .participation-results---3FLKV h4 {\n      color: #278bcb;\n      font-size: 12px;\n      font-weight: normal;\n      margin: 20px 0 4px; }\n  .component---EZxWA .participation-results---3FLKV table thead,\n    .component---EZxWA .participation-results---3FLKV table tbody {\n      text-align: center; }\n  .component---EZxWA .participation-results---3FLKV table thead th,\n      .component---EZxWA .participation-results---3FLKV table thead td,\n      .component---EZxWA .participation-results---3FLKV table tbody th,\n      .component---EZxWA .participation-results---3FLKV table tbody td {\n        padding: 8px; }\n  .component---EZxWA .participation-results---3FLKV table thead th svg path,\n        .component---EZxWA .participation-results---3FLKV table thead td svg path,\n        .component---EZxWA .participation-results---3FLKV table tbody th svg path,\n        .component---EZxWA .participation-results---3FLKV table tbody td svg path {\n          fill: #838f9e; }\n  .component---EZxWA .participation-results---3FLKV table thead {\n      height: 77px; }\n  .component---EZxWA .participation-results---3FLKV table thead th {\n        vertical-align: unset;\n        font-size: 11px;\n        font-weight: 500;\n        line-height: 20px;\n        border-color: #adb9c7;\n        border-bottom: none;\n        border-top: none; }\n  .component---EZxWA .participation-results---3FLKV table thead th.col-group-sort-icon---1G1VY div {\n          position: relative; }\n  .component---EZxWA .participation-results---3FLKV table thead th.col-group-sort-icon---1G1VY div span:nth-child(2) {\n            position: absolute;\n            top: -48px;\n            right: -5px; }\n  .component---EZxWA .participation-results---3FLKV table thead th.class-name---vlEzN, .component---EZxWA .participation-results---3FLKV table thead th.group-name---2EJtH, .component---EZxWA .participation-results---3FLKV table thead th.student-name---3rllJ {\n          text-align: left;\n          width: 30%;\n          padding: 13px 5px 0 12px;\n          background-color: #d4dce2;\n          color: #33475f;\n          font-weight: 600;\n          border-right-color: #adb9c7; }\n  .component---EZxWA .participation-results---3FLKV table thead th.year-group---5KIXX, .component---EZxWA .participation-results---3FLKV table thead th.total-points---1q_mf {\n          background-color: #d4dce2;\n          color: #33475f;\n          width: 12%; }\n  .component---EZxWA .participation-results---3FLKV table thead th.year-group---5KIXX.small---2Bwcr, .component---EZxWA .participation-results---3FLKV table thead th.total-points---1q_mf.small---2Bwcr {\n            text-align: left;\n            width: 4%;\n            padding: 8px 5px; }\n  .component---EZxWA .participation-results---3FLKV table thead th.total-certificates---3v81B {\n          width: 17%;\n          color: white;\n          border-color: #cbd3dc; }\n  .component---EZxWA .participation-results---3FLKV table thead th.total-certificates---3v81B.new-certificates---1x9Hc {\n            background-color: #0063a7;\n            border-right-color: rgba(255, 255, 255, .16); }\n  .component---EZxWA .participation-results---3FLKV table thead th.total-certificates---3v81B.past-certificates---wmhjN {\n            background-color: #007acc; }\n  .component---EZxWA .participation-results---3FLKV table thead th.total-certificates---3v81B.header---2CRaR {\n            border-top: 1px solid;\n            border-color: #adb9c7; }\n  .component---EZxWA .participation-results---3FLKV table thead th.total-certificates---3v81B.new-expanded---3TaKC {\n            width: 40%;\n            padding: 0; }\n  .component---EZxWA .participation-results---3FLKV table tbody td {\n      border-color: #cbd3dc; }\n  .component---EZxWA .participation-results---3FLKV table tbody .class-name---vlEzN,\n    .component---EZxWA .participation-results---3FLKV table tbody .group-name---2EJtH,\n    .component---EZxWA .participation-results---3FLKV table tbody .student-name---3rllJ {\n      text-align: left;\n      border-right-color: #adb9c7; }\n", ""]);

// exports
exports.locals = {
	"component": "component---EZxWA",
	"certificates": "certificates---1uddj",
	"participation-results": "participation-results---3FLKV",
	"col-group-sort-icon": "col-group-sort-icon---1G1VY",
	"class-name": "class-name---vlEzN",
	"group-name": "group-name---2EJtH",
	"student-name": "student-name---3rllJ",
	"year-group": "year-group---5KIXX",
	"total-points": "total-points---1q_mf",
	"small": "small---2Bwcr",
	"total-certificates": "total-certificates---3v81B",
	"new-certificates": "new-certificates---1x9Hc",
	"past-certificates": "past-certificates---wmhjN",
	"header": "header---2CRaR",
	"new-expanded": "new-expanded---3TaKC"
};

/***/ }),

/***/ "nQji":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var participationData = _propTypes["default"].shape({
  classroomParticipations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    classroomName: _propTypes["default"].string,
    activityPoints: _propTypes["default"].number,
    livePoints: _propTypes["default"].number,
    totalPoints: _propTypes["default"].number,
    gold: _propTypes["default"].number,
    silver: _propTypes["default"].number,
    bronze: _propTypes["default"].number
  })),
  classroomUsage: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    totalSignIns: _propTypes["default"].number,
    totalTimeOnline: _propTypes["default"].shape({
      hours: _propTypes["default"].number,
      minutes: _propTypes["default"].number
    }),
    totalActivityPoints: _propTypes["default"].number,
    totalLivePoints: _propTypes["default"].number
  })),
  certificates: _propTypes["default"].shape({
    gold: _propTypes["default"].number,
    silver: _propTypes["default"].number,
    bronze: _propTypes["default"].number
  })
});
var _default = exports["default"] = {
  participationData: participationData
};

/***/ }),

/***/ "nYQu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".course-empty-state---1B9wE {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 50vh; }\n  .course-empty-state---1B9wE .header---o-oqP {\n    font-size: 25px;\n    font-weight: bold; }\n  .course-empty-state---1B9wE .content---TuAy_ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 18px;\n    margin-top: 16px; }\n  .course-empty-state---1B9wE .content---TuAy_ button {\n      background-color: transparent;\n      border: 0;\n      text-decoration: underline;\n      color: #278bcb; }\n", ""]);

// exports
exports.locals = {
	"course-empty-state": "course-empty-state---1B9wE",
	"header": "header---o-oqP",
	"content": "content---TuAy_"
};

/***/ }),

/***/ "ndXM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ogNr");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./strength-weakness-tab.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./strength-weakness-tab.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nfN5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".progress-wrapper---3ebxc {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 15px; }\n\n.green---21GEv {\n  background-color: #37c97c; }\n\n.light-green---imHiD {\n  background-color: #81daab; }\n\n.light-orange---12xpo {\n  background-color: #e89e13; }\n\n.orange---28DdE {\n  background-color: #e06d3f; }\n\n.red---eavAG {\n  background-color: #c53902; }\n\n.white---1E0nG {\n  border: 1px solid #9a9a9a;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n.hidden---1qE7Z {\n  display: none; }\n", ""]);

// exports
exports.locals = {
	"progress-wrapper": "progress-wrapper---3ebxc",
	"green": "green---21GEv",
	"light-green": "light-green---imHiD",
	"light-orange": "light-orange---12xpo",
	"orange": "orange---28DdE",
	"red": "red---eavAG",
	"white": "white---1E0nG",
	"hidden": "hidden---1qE7Z"
};

/***/ }),

/***/ "ntjf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STUDENT_FULL_NAME = exports.STANDARDS_IN_PROGRESS = exports.STANDARDS_COMPLETED = exports.SQ_STANDARDS_COUNT_BOX_TYPES = exports.SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS = exports.GROUP_NAME = exports.EMPTY_CELL = exports.COMPLETED_QUESTS_SUMMARY = exports.COMPLETED_QUESTS = exports.CLASS_NAME = exports.ASSIGNMENT_STATUSES = exports.ASSIGNED_QUESTS = void 0;
var CLASS_NAME = exports.CLASS_NAME = {
  id: 'className',
  name: 'All classes'
};
var GROUP_NAME = exports.GROUP_NAME = {
  id: 'groupName',
  name: 'Groups'
};
var COMPLETED_QUESTS_SUMMARY = exports.COMPLETED_QUESTS_SUMMARY = {
  id: 'completedQuestsSummary',
  name: 'Progress through Standards'
};
var ASSIGNED_QUESTS = exports.ASSIGNED_QUESTS = {
  id: 'learningJourneysAssignedOrInProgressCount',
  name: 'ASSIGNED QUESTS'
};
var COMPLETED_QUESTS = exports.COMPLETED_QUESTS = {
  id: 'learningJourneysCompletedCount',
  name: 'COMPLETED QUESTS'
};
var STANDARDS_IN_PROGRESS = exports.STANDARDS_IN_PROGRESS = {
  id: 'standardsInProgressCount',
  name: 'STANDARDS IN PROGRESS'
};
var STANDARDS_COMPLETED = exports.STANDARDS_COMPLETED = {
  id: 'standardsCompletedCount',
  name: 'STANDARDS COMPLETED'
};
var STUDENT_FULL_NAME = exports.STUDENT_FULL_NAME = {
  id: 'fullName'
};
var SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS = exports.SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS = {
  CLASS_GROUP_LEVEL: 1,
  STUDENT_PROGRESS: 2,
  STUDENT_ACCURACY: 3
};
var ASSIGNMENT_STATUSES = exports.ASSIGNMENT_STATUSES = {
  NOT_ASSIGNED: 0,
  ASSIGNED: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3
};
var SQ_STANDARDS_COUNT_BOX_TYPES = exports.SQ_STANDARDS_COUNT_BOX_TYPES = {
  STANDARDS: 'STANDARDS',
  SKILL_QUESTS: 'SKILL_QUESTS',
  AVERAGE_ACCURACY: 'AVERAGE_ACCURACY',
  HIGHEST_ACCURACY: 'HIGHEST_ACCURACY'
};
var EMPTY_CELL = exports.EMPTY_CELL = '-';

/***/ }),

/***/ "o+QR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_DATE = exports.END_DATE = void 0;
var START_DATE = exports.START_DATE = 'startDate';
var END_DATE = exports.END_DATE = 'endDate';

/***/ }),

/***/ "oHUn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.INVALID_REQUEST_MADE = void 0;
var _errorsActions = __webpack_require__("egHy");
var INVALID_REQUEST_MADE = exports.INVALID_REQUEST_MADE = 'INVALID_REQUEST_MADE';
function invalidRequestMade() {
  return function (dispatch, getState) {
    var _getState = getState(),
      errors = _getState.errors;
    var payload = null;
    if (errors.length > 0) {
      payload = errors[errors.length - 1];
    }
    dispatch({
      type: INVALID_REQUEST_MADE,
      payload: payload
    });
    dispatch({
      type: _errorsActions.REMOVE_ERROR
    });
  };
}
var _default = exports["default"] = {
  invalidRequestMade: invalidRequestMade
};

/***/ }),

/***/ "oMuz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Student = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _mathleticsPortalCommunicationService = _interopRequireDefault(__webpack_require__("UTT2"));
var _student = _interopRequireDefault(__webpack_require__("xKme"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _filterPropTypes = __webpack_require__("1g86");
var _filterConstants = __webpack_require__("cdWI");
var _studentActions = __webpack_require__("Z9lH");
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _subHeadingHelpers = __webpack_require__("bHq3");
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _studentHelpers = __webpack_require__("GejO");
var _constants = __webpack_require__("1QGX");
var _utils = __webpack_require__("6QRH");
var _topLevelInfo = _interopRequireDefault(__webpack_require__("UZ2b"));
var _topLevelFilter = _interopRequireDefault(__webpack_require__("bCch"));
var _subHeadingButtons = _interopRequireDefault(__webpack_require__("Tiy6"));
var _exportReportActions = _interopRequireDefault(__webpack_require__("oXgP"));
var _skillQuestsMasteryLegends = _interopRequireDefault(__webpack_require__("n/+0"));
var _progressDisplay = _interopRequireDefault(__webpack_require__("UaZf"));
var _tableDisplay = _interopRequireDefault(__webpack_require__("LiCV"));
var _assignmentResult = _interopRequireDefault(__webpack_require__("kQOT"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Student = exports.Student = /*#__PURE__*/function (_Component) {
  function Student(_props) {
    var _this;
    _classCallCheck(this, Student);
    _this = _callSuper(this, Student, [_props]);
    /**
     * DATA MANAGEMENT
     */
    _defineProperty(_this, "manageInitialData", function (newProps) {
      var newActiveFilters = newProps.activeFilters,
        skillQuestsMasteryStudentData = newProps.skillQuestsMasteryStudentData,
        isLoading = newProps.isLoading,
        assignmentResultType = newProps.assignmentResultType;
      var shouldLoadStudent = !isLoading && !skillQuestsMasteryStudentData && _filterHelper["default"].shouldLoadStudent(newActiveFilters);
      if (shouldLoadStudent) {
        _this.props.getStudentSkillQuestsMasteryData(newActiveFilters[_filterConstants.SELECTED_CLASS].id, newActiveFilters[_filterConstants.SELECTED_STUDENT].id, newActiveFilters[_filterConstants.SELECTED_DATE], assignmentResultType);
      }
    });
    _defineProperty(_this, "manageReloadData", function (props, newProps) {
      var _this$props = _this.props,
        activeFilters = _this$props.activeFilters,
        assignmentResultType = _this$props.assignmentResultType;
      var newActiveFilters = newProps.activeFilters,
        newSelectedCourse = newProps.selectedCourse,
        newSkillQuestsMasteryStudentData = newProps.skillQuestsMasteryStudentData,
        newIsLoading = newProps.isLoading,
        newIsFiltered = newProps.isFiltered,
        newAssignmentResultType = newProps.assignmentResultType;
      _this.setState({
        newAssignmentResultType: newAssignmentResultType
      });
      var shouldReloadStudent = !newIsLoading && newSkillQuestsMasteryStudentData && _filterHelper["default"].shouldReloadStudent(activeFilters, newActiveFilters) || assignmentResultType !== newAssignmentResultType;
      if (shouldReloadStudent) {
        var _this$getCourseValues = _this.getCourseValues(newSelectedCourse, newIsFiltered),
          selectedCourseId = _this$getCourseValues.selectedCourseId,
          selectedCourseVersion = _this$getCourseValues.selectedCourseVersion;
        _this.props.getStudentSkillQuestsMasteryDataCourse(newActiveFilters[_filterConstants.SELECTED_CLASS].id, newActiveFilters[_filterConstants.SELECTED_STUDENT].id, newActiveFilters[_filterConstants.SELECTED_DATE], selectedCourseId, selectedCourseVersion, newAssignmentResultType);
      }
    });
    _defineProperty(_this, "manageExportedReport", function (props, newProps) {
      var exportedReport = props.exportedReport;
      var newExportedReport = newProps.exportedReport;
      if (exportedReport !== newExportedReport) {
        window.open(newExportedReport.downloadUrl, '_blank');
      }
    });
    _defineProperty(_this, "getCourseValues", function (newSelectedCourse, newIsFiltered) {
      var selectedCourseId = null;
      var selectedCourseVersion = null;
      if (newSelectedCourse && newIsFiltered) {
        selectedCourseId = newSelectedCourse.selected.id;
        selectedCourseVersion = newSelectedCourse.selected.version;
      }
      return {
        selectedCourseId: selectedCourseId,
        selectedCourseVersion: selectedCourseVersion
      };
    });
    /**
     * HELPERS
     */
    _defineProperty(_this, "getDateLabel", function () {
      var _this$props2 = _this.props,
        academicYear = _this$props2.academicYear,
        activeFilters = _this$props2.activeFilters;
      return (0, _subHeadingHelpers.getDateRange)(activeFilters[_filterConstants.SELECTED_DATE], academicYear);
    });
    _defineProperty(_this, "onCompletedTextClickHandler", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var activeFilters, classId, moduleId;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            activeFilters = _this.props.activeFilters;
            classId = activeFilters[_filterConstants.SELECTED_CLASS].id;
            _context.n = 1;
            return (0, _utils.getConfiguration)(_constants.PORTAL_MODULE.ASSIGN_REVIEW);
          case 1:
            moduleId = _context.v;
            _mathleticsPortalCommunicationService["default"].requestModuleChange(moduleId, {
              classId: classId
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _this.state = {
      newAssignmentResultType: _props.assignmentResultType
    };
    return _this;
  }
  _inherits(Student, _Component);
  return _createClass(Student, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.manageInitialData(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.resetStudentData();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      this.manageInitialData(newProps);
      this.manageReloadData(this.props, newProps);
      this.manageExportedReport(this.props, newProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        academicYear = _this$props3.academicYear,
        activeFilters = _this$props3.activeFilters,
        assignmentResultType = _this$props3.assignmentResultType,
        downloadStudentReport = _this$props3.downloadStudentReport,
        exportReport = _this$props3.exportReport,
        history = _this$props3.history,
        isAdmin = _this$props3.isAdmin,
        isLoading = _this$props3.isLoading,
        isProcessingDownload = _this$props3.isProcessingDownload,
        openModal = _this$props3.openModal,
        selectedCourse = _this$props3.selectedCourse,
        selectedPublication = _this$props3.selectedPublication,
        skillQuestsMasteryStudentData = _this$props3.skillQuestsMasteryStudentData;
      var STUDENT_ACCURACY = _skillQuestsMasteryConstants.SKILL_QUESTS_MASTERY_LEGENDS_VARIANTS.STUDENT_ACCURACY;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"].header
      }, /*#__PURE__*/_react["default"].createElement(_topLevelInfo["default"], {
        academicYear: academicYear,
        activeFilters: activeFilters,
        history: history,
        isAdmin: isAdmin,
        getDateLabel: this.getDateLabel
      }), /*#__PURE__*/_react["default"].createElement(_assignmentResult["default"], null), /*#__PURE__*/_react["default"].createElement(_topLevelFilter["default"], {
        activeFilters: activeFilters,
        skillQuestsMasteryStudentData: skillQuestsMasteryStudentData,
        assignmentResultType: assignmentResultType,
        selectedCourse: selectedCourse,
        selectedPublication: selectedPublication,
        setSelectedPublication: this.props.setSelectedPublication,
        setSelectedCourse: this.props.setSelectedCourse,
        getStudentSkillQuestsMasteryDataCourse: this.props.getStudentSkillQuestsMasteryDataCourse
      }), /*#__PURE__*/_react["default"].createElement(_subHeadingButtons["default"], {
        isDownloadEnabled: false,
        isExportEnabled: true,
        isProcessingDownload: isProcessingDownload,
        onExportReport: exportReport,
        onDownloadReport: downloadStudentReport
      })), (0, _studentHelpers.hasValidCourses)(skillQuestsMasteryStudentData) && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_progressDisplay["default"], {
        getDateLabel: this.getDateLabel,
        openModal: openModal,
        skillQuestsMasteryStudentData: skillQuestsMasteryStudentData,
        selectedCourse: selectedCourse
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"]['sub-header']
      }, /*#__PURE__*/_react["default"].createElement(_skillQuestsMasteryLegends["default"], {
        variant: STUDENT_ACCURACY
      }))), /*#__PURE__*/_react["default"].createElement(_tableDisplay["default"], {
        activeFilters: activeFilters,
        isLoading: isLoading,
        skillQuestsMasteryStudentData: skillQuestsMasteryStudentData,
        onCompletedTextClickHandler: this.onCompletedTextClickHandler,
        assignmentResultType: this.state.newAssignmentResultType
      }));
    }
  }]);
}(_react.Component);
_defineProperty(Student, "propTypes", {
  academicYear: _propTypes["default"].shape({
    startDate: _propTypes["default"].string,
    endDate: _propTypes["default"].string
  }),
  activeFilters: _filterPropTypes.activeFiltersPropType,
  downloadStudentReport: _propTypes["default"].func,
  exportReport: _propTypes["default"].func,
  exportedReport: _propTypes["default"].shape({
    key: _propTypes["default"].string,
    resourcesMethod: _propTypes["default"].string
  }),
  getStudentSkillQuestsMasteryData: _propTypes["default"].func,
  getStudentSkillQuestsMasteryDataCourse: _propTypes["default"].func,
  history: _propTypes["default"].any,
  isAdmin: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  isProcessingDownload: _propTypes["default"].bool,
  openModal: _propTypes["default"].func,
  resetStudentData: _propTypes["default"].func,
  selectedCourse: _propTypes["default"].object,
  selectedPublication: _propTypes["default"].object,
  setSelectedCourse: _propTypes["default"].func,
  setSelectedPublication: _propTypes["default"].func,
  skillQuestsMasteryStudentData: _propTypes["default"].object,
  assignmentResultType: _propTypes["default"].number
});
function mapStateToProps(state) {
  return {
    academicYear: state.academicYear,
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    exportedReport: state.exportedReport,
    isAdmin: state.isAdmin,
    isLoading: state.skillQuestsMasteryStudent.isLoading,
    isFiltered: state.skillQuestsMasteryStudent.isFiltered,
    isProcessingDownload: state.downloadReport.isProcessingDownload,
    selectedCourse: state.skillQuestsMasteryStudent.selectedCourse,
    selectedPublication: state.skillQuestsMasteryStudent.selectedPublication,
    skillQuestsMasteryStudentData: state.skillQuestsMasteryStudent.data,
    assignmentResultType: state.assignmentResultType
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    downloadStudentReport: _exportReportActions["default"].downloadStudentReport,
    exportReport: _exportReportActions["default"].exportReport,
    getStudentSkillQuestsMasteryData: _studentActions.getStudentSkillQuestsMasteryData,
    getStudentSkillQuestsMasteryDataCourse: _studentActions.getStudentSkillQuestsMasteryDataCourse,
    openModal: _modalActions["default"].openModal,
    resetStudentData: _studentActions.resetStudentData,
    setSelectedCourse: _studentActions.setSelectedCourse,
    setSelectedPublication: _studentActions.setSelectedPublication
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_student["default"])(Student));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "oXgP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SKILL_QUESTS_EXPORT_RESOURCE_METHODS = exports.REPORT_LEVEL_YEAR_GROUP_TEACHER = exports.REPORT_LEVEL_STUDENT = exports.REPORT_LEVEL_SINGLE_CLASS = exports.REPORT_LEVEL_GROUP = exports.REPORT_LEVEL_ALL_YEARS = exports.REPORT_LEVEL_ALL_CLASSES = exports.REPORT_LEVELS = exports.REPORT_EXPORTED = exports.FILE_FORMAT = exports.EXPORT_RESOURCE_METHODS = void 0;
exports.exportReportData = exportReportData;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _filterConstants = __webpack_require__("cdWI");
var _exportActivityMasteryReport = _interopRequireDefault(__webpack_require__("2y4p"));
var _exportLiveMathsReport = _interopRequireDefault(__webpack_require__("GcYt"));
var _exportParticipationReport = _interopRequireDefault(__webpack_require__("d0+Z"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _downloadReportActions = _interopRequireDefault(__webpack_require__("ylPA"));
var _exportSkillQuestsMasteryReport = __webpack_require__("5Jg6");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var REPORT_EXPORTED = exports.REPORT_EXPORTED = 'REPORT_EXPORTED';
var REPORT_LEVEL_ALL_YEARS = exports.REPORT_LEVEL_ALL_YEARS = 'REPORT_LEVEL_ALL_YEARS';
var REPORT_LEVEL_YEAR_GROUP_TEACHER = exports.REPORT_LEVEL_YEAR_GROUP_TEACHER = 'REPORT_LEVEL_YEAR_GROUP_TEACHER';
var REPORT_LEVEL_ALL_CLASSES = exports.REPORT_LEVEL_ALL_CLASSES = 'REPORT_LEVEL_ALL_CLASSES';
var REPORT_LEVEL_SINGLE_CLASS = exports.REPORT_LEVEL_SINGLE_CLASS = 'REPORT_LEVEL_SINGLE_CLASS';
var REPORT_LEVEL_GROUP = exports.REPORT_LEVEL_GROUP = 'REPORT_LEVEL_GROUP';
var REPORT_LEVEL_STUDENT = exports.REPORT_LEVEL_STUDENT = 'REPORT_LEVEL_STUDENT';
var REPORT_LEVELS = exports.REPORT_LEVELS = [REPORT_LEVEL_ALL_YEARS, REPORT_LEVEL_YEAR_GROUP_TEACHER, REPORT_LEVEL_ALL_CLASSES, REPORT_LEVEL_SINGLE_CLASS, REPORT_LEVEL_GROUP, REPORT_LEVEL_STUDENT];
var EXPORT_RESOURCE_METHODS = exports.EXPORT_RESOURCE_METHODS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, REPORT_LEVEL_ALL_YEARS, 'allYearsExport'), REPORT_LEVEL_YEAR_GROUP_TEACHER, 'yearGroupTeacherExport'), REPORT_LEVEL_ALL_CLASSES, 'allClassesExport'), REPORT_LEVEL_SINGLE_CLASS, 'singleClassExport'), REPORT_LEVEL_GROUP, 'singleClassExport'), REPORT_LEVEL_STUDENT, 'studentExport');
var SKILL_QUESTS_EXPORT_RESOURCE_METHODS = exports.SKILL_QUESTS_EXPORT_RESOURCE_METHODS = {
  CLASSROOM: 'skillQuestsMasteryClassroomExport',
  CLASSROOM_CUSTOM_DATE: 'skillQuestsMasteryClassroomExportCustomDate',
  GROUP: 'skillQuestsMasteryGroupExport',
  GROUP_CUSTOM_DATE: 'skillQuestsMasteryGroupExportCustomDate',
  STUDENT: 'skillQuestsMasteryStudentExport',
  STUDENT_CUSTOM_DATE: 'skillQuestsMasteryStudentExportCustomDate'
};
var FILE_FORMAT = exports.FILE_FORMAT = {
  PDF: 'pdf',
  EXCEL: 'excel'
};
function exportReport(fileFormat) {
  return function (dispatch, getState) {
    var state = getState();
    var reportId = _activeFiltersSelectors["default"].selectReportId(state);
    var reportLevel = _activeFiltersSelectors["default"].selectReportLevel(state);
    var i18n = window.i18n;
    var exportParams;
    switch (reportId) {
      case _filterConstants.PARTICIPATION:
        (0, _exportParticipationReport["default"])(getState, reportLevel, dispatch, i18n, fileFormat);
        break;
      case _filterConstants.LIVE_MATHS:
        exportParams = (0, _exportLiveMathsReport["default"])(getState, reportLevel);
        break;
      case _filterConstants.SKILL_QUESTS_MASTERY:
        /*
        Skills quest mastery was created well after all previous report types. BE decided
        to not follow existing structure so we treat this case differently to the others.
         */
        (0, _exportSkillQuestsMasteryReport.exportSkillQuestsMasteryReport)(reportLevel, dispatch, state, i18n);
        break;
      default:
        exportParams = (0, _exportActivityMasteryReport["default"])(getState, reportLevel, i18n);
        break;
    }
    if (exportParams) {
      var _exportParams = exportParams,
        data = _exportParams.data,
        resourcesMethod = _exportParams.resourcesMethod,
        params = _exportParams.params;
      var action = exportReportData(data, resourcesMethod, params);
      if (action) {
        dispatch(action);
      }
    }
  };
}
function exportReportData(data, resourcesMethod) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return _resources["default"][resourcesMethod].post(params).withBody(data).send().then(function (payload) {
    if (payload.valid) {
      var paramIdx = payload.verb.url.indexOf('?');
      if (paramIdx !== -1) {
        payload.verb.url = payload.verb.url.substring(0, paramIdx);
      }
      return {
        type: REPORT_EXPORTED,
        payload: {
          downloadUrl: "".concat(payload.verb.url, "/").concat(payload.data)
        }
      };
    }
    return null;
  });
}
function downloadStudentReport() {
  return function (dispatch) {
    var action = (0, _downloadReportActions["default"])();
    if (action) {
      dispatch(action);
    }
  };
}
var _default = exports["default"] = {
  exportReport: exportReport,
  downloadStudentReport: downloadStudentReport
};

/***/ }),

/***/ "of6S":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("gahV");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./progress-display.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./progress-display.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ogNr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---1dQio {\n  padding-left: 8px; }\n  .component---1dQio .tab-container---23oCZ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    height: 38px;\n    width: calc(100% - 2px); }\n  .component---1dQio .tab---3_T0V, .component---1dQio .active---4rHDj, .component---1dQio .inactive---3UW9F {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 50%;\n            flex: 1 1 50%;\n    border-radius: 7px 7px 0.1px 0.1px;\n    border: 1px solid #e5e5e5;\n    border-bottom: none;\n    text-align: center;\n    font-size: 15px;\n    cursor: pointer;\n    -webkit-transition: all 0.2s;\n    transition: all 0.2s; }\n  .component---1dQio .tab---3_T0V:first-of-type, .component---1dQio .active---4rHDj:first-of-type, .component---1dQio .inactive---3UW9F:first-of-type {\n      margin-right: 3px; }\n  .component---1dQio .tab---3_T0V:last-of-type, .component---1dQio .active---4rHDj:last-of-type, .component---1dQio .inactive---3UW9F:last-of-type {\n      margin-left: 3px; }\n  .component---1dQio .active---4rHDj {\n    color: #1981c4;\n    font-weight: 600;\n    background-color: #f6f8f9; }\n  .component---1dQio .active---4rHDj:hover {\n      -webkit-filter: none;\n              filter: none; }\n  .component---1dQio .inactive---3UW9F {\n    padding: 4px 16px;\n    background-color: #e5e5e5; }\n  .component---1dQio .inactive---3UW9F:hover {\n      filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feComponentTransfer color-interpolation-filters=\"sRGB\"><feFuncR type=\"linear\" slope=\"1.05\" /><feFuncG type=\"linear\" slope=\"1.05\" /><feFuncB type=\"linear\" slope=\"1.05\" /></feComponentTransfer></filter></svg>#filter');\n      -webkit-filter: brightness(1.05);\n              filter: brightness(1.05); }\n", ""]);

// exports
exports.locals = {
	"component": "component---1dQio",
	"tab-container": "tab-container---23oCZ",
	"tab": "tab---3_T0V",
	"active": "active---4rHDj",
	"inactive": "inactive---3UW9F"
};

/***/ }),

/***/ "oxam":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _studentsByGroupActions = __webpack_require__("dFjD");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  id: null,
  groups: []
};

/**
 * Students by Group Reducer
 *
 * Consumes STUDENTS_BY_GROUP_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - all groups with their respective students
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _studentsByGroupActions.STUDENTS_BY_GROUP_RETRIEVED:
      return action.payload;
    case _studentsByGroupActions.RESET_STUDENTS_BY_GROUP:
      return _objectSpread({}, initialState);
    default:
      return state;
  }
}

/***/ }),

/***/ "p2pT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THIS_WEEK_OBJ = exports.THIS_WEEK = exports.THIS_SCHOOL_YEAR_OBJ = exports.THIS_SCHOOL_YEAR = exports.LIFETIME_OBJ = exports.LIFETIME = exports.LAST_WEEK_OBJ = exports.LAST_WEEK = exports.DEFAULT_DATE_OPTIONS_OBJ = exports.DEFAULT_DATE_OPTIONS = exports.DATE_OPTIONS = exports.CUSTOM_DATE_TIME_OBJ = exports.CUSTOM_DATE_TIME = exports.CUSTOM_DATE_OBJ = exports.CUSTOM_DATE = void 0;
var THIS_WEEK = exports.THIS_WEEK = 'This week';
var LAST_WEEK = exports.LAST_WEEK = 'Last week';
var THIS_SCHOOL_YEAR = exports.THIS_SCHOOL_YEAR = 'This school year';
var CUSTOM_DATE = exports.CUSTOM_DATE = 'Custom date';
var CUSTOM_DATE_TIME = exports.CUSTOM_DATE_TIME = 'Date and Time';
var LIFETIME = exports.LIFETIME = 'Lifetime';
var THIS_WEEK_OBJ = exports.THIS_WEEK_OBJ = {
  label: THIS_WEEK,
  value: THIS_WEEK
};
var LAST_WEEK_OBJ = exports.LAST_WEEK_OBJ = {
  label: LAST_WEEK,
  value: LAST_WEEK
};
var THIS_SCHOOL_YEAR_OBJ = exports.THIS_SCHOOL_YEAR_OBJ = {
  label: THIS_SCHOOL_YEAR,
  value: THIS_SCHOOL_YEAR
};
var CUSTOM_DATE_OBJ = exports.CUSTOM_DATE_OBJ = {
  label: CUSTOM_DATE,
  value: CUSTOM_DATE
};
var CUSTOM_DATE_TIME_OBJ = exports.CUSTOM_DATE_TIME_OBJ = {
  label: CUSTOM_DATE_TIME,
  value: CUSTOM_DATE_TIME
};
var LIFETIME_OBJ = exports.LIFETIME_OBJ = {
  label: LIFETIME,
  value: LIFETIME
};
var DEFAULT_DATE_OPTIONS_OBJ = exports.DEFAULT_DATE_OPTIONS_OBJ = [THIS_WEEK_OBJ, LAST_WEEK_OBJ, THIS_SCHOOL_YEAR_OBJ, CUSTOM_DATE_OBJ];
var DEFAULT_DATE_OPTIONS = exports.DEFAULT_DATE_OPTIONS = [THIS_WEEK, LAST_WEEK, THIS_SCHOOL_YEAR, CUSTOM_DATE];
var DATE_OPTIONS = exports.DATE_OPTIONS = [].concat(DEFAULT_DATE_OPTIONS, [CUSTOM_DATE_TIME, LIFETIME]);

/***/ }),

/***/ "pFGU":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pFGU";

/***/ }),

/***/ "pK1W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _isAdminActions = __webpack_require__("xR72");
var initialState = null;

/**
 * Is Admin Reducer
 *
 * Consumes IS_SCHOOL_ADMIN action
 *
 * @param {boolean} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {boolean} - whether user is a school admin
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _isAdminActions.IS_SCHOOL_ADMIN:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "pW+u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SingleClass = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _headerToggle = _interopRequireDefault(__webpack_require__("qvwF"));
var _singleClass = _interopRequireDefault(__webpack_require__("MyZd"));
var _filterPropTypes = __webpack_require__("1g86");
var _singleClassPropTypes = _interopRequireDefault(__webpack_require__("rvRX"));
var _filterConstants = __webpack_require__("cdWI");
var _singleClassConstants = __webpack_require__("MjMp");
var _singleClassConstantsUpdate = __webpack_require__("B6As");
var _certificatesActions = _interopRequireDefault(__webpack_require__("PLdC"));
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _singleClassActions = _interopRequireWildcard(__webpack_require__("WKZP"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _singleClassCertificates = _interopRequireDefault(__webpack_require__("D2yU"));
var _usage = _interopRequireDefault(__webpack_require__("DtE0"));
var _allClassesConstants = __webpack_require__("Wsmd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * SingleClass component
 * Displays participation results table, certificates & usage for a single class or group
 */
var SingleClass = exports.SingleClass = /*#__PURE__*/function (_Component) {
  function SingleClass(props) {
    var _this;
    _classCallCheck(this, SingleClass);
    _this = _callSuper(this, SingleClass, [props]);
    _defineProperty(_this, "getDefaultParticipationData", function () {
      return {
        classroomGroupParticipations: [],
        certificateDetails: {
          gold: 0,
          silver: 0,
          bronze: 0
        },
        usage: [{
          id: 0,
          activityPoints: 0,
          livePoints: 0,
          totalPoints: 0,
          signIns: 0,
          timeOnline: {
            hours: 0,
            minutes: 0
          }
        }]
      };
    });
    /**
     * Loads the group or student page when user clicks on item in table
     */
    _defineProperty(_this, "loadNewPage", function (filterName, selectedItem) {
      _this.props.updateActiveFilter(filterName, {
        id: selectedItem.id,
        name: selectedItem.name
      });
    });
    _defineProperty(_this, "setUsageTableConfig", function () {
      var singleClassUsageTableConfig = (0, _cloneDeep["default"])(_singleClassConstants.SINGLE_CLASS_USAGE_TABLE_CONFIG);
      singleClassUsageTableConfig.cols.map(function (col) {
        return col.name = window.i18n._(col.name);
      });
      _this.setState({
        singleClassUsageTableConfig: singleClassUsageTableConfig
      });
    });
    _defineProperty(_this, "getUsageData", function (participationData) {
      var usageData = participationData && participationData.usage[0];
      if (usageData) {
        var signIns = usageData.signIns,
          timeOnline = usageData.timeOnline,
          livePoints = usageData.livePoints,
          activityPoints = usageData.activityPoints;
        return {
          totalSignIns: signIns,
          totalTimeOnline: timeOnline,
          totalLiveMathsPoints: livePoints,
          totalCurriculumPoints: activityPoints
        };
      }
      return null;
    });
    _this.state = {
      participationData: null,
      participationTableConfig: null,
      dataTable: {
        isPastCertificatesExpanded: false,
        isNewCertificatesExpanded: false
      }
    };
    _this.i18n = window.i18n;
    _this.text = {
      activityCourseText: "".concat(_this.i18n._('Label - ActivityCourse'), ":"),
      skillQuestsText: "".concat(_this.i18n._('Time - Skill Quests'), ":"),
      skillQuestsEmptyText: _this.i18n._('Table Empty - Skill Quests course not set'),
      groups: _this.i18n._('Table Config - Groups')
    };
    return _this;
  }
  _inherits(SingleClass, _Component);
  return _createClass(SingleClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeFilters = this.props.activeFilters;
      if (_filterHelper["default"].shouldLoadSingleClass(activeFilters)) {
        this.getClassParticipationData(activeFilters[_filterConstants.SELECTED_DATE], activeFilters[_filterConstants.SELECTED_CLASS].id);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.dataTable.isPastCertificatesExpanded !== this.state.dataTable.isPastCertificatesExpanded || prevState.dataTable.isNewCertificatesExpanded !== this.state.dataTable.isNewCertificatesExpanded) {
        this.setParticipationTableConfig(this.props.participationData, this.props.activeFilters[_filterConstants.SELECTED_GROUP].id);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props = this.props,
        activeFilters = _this$props.activeFilters,
        participationData = _this$props.participationData,
        invalidRequest = _this$props.invalidRequest,
        updateActiveFilter = _this$props.updateActiveFilter;
      var newActiveFilters = newProps.activeFilters,
        newParticipationData = newProps.participationData,
        newInvalidRequest = newProps.invalidRequest;
      if (_filterHelper["default"].shouldReloadSingleClass(activeFilters, newActiveFilters)) {
        this.getClassParticipationData(newActiveFilters[_filterConstants.SELECTED_DATE], newActiveFilters[_filterConstants.SELECTED_CLASS].id);
      }
      if (participationData !== newParticipationData) {
        this.setParticipationData(newParticipationData, newActiveFilters[_filterConstants.SELECTED_GROUP].id);
        this.setUsageTableConfig();
      }
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _singleClassActions.PARTICIPATION_CLASS_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "getClassParticipationData",
    value: function getClassParticipationData(selectedDate, classId) {
      this.props.getParticipationData(classId, selectedDate);
    }
  }, {
    key: "setParticipationData",
    value: function setParticipationData(data, groupId) {
      groupId = +groupId || 0;
      var participationData = _objectSpread({}, data);
      if (groupId) {
        var groupData = participationData.classroomGroupParticipations.find(function (group) {
          return group.id === +groupId;
        });
        if (groupData) {
          participationData.classroomGroupParticipations = [groupData];
          participationData.certificateDetails = groupData.certificateDetails;
          participationData.usage = groupData.usage;
        } else {
          var _this$getDefaultParti = this.getDefaultParticipationData(),
            classroomGroupParticipations = _this$getDefaultParti.classroomGroupParticipations,
            certificateDetails = _this$getDefaultParti.certificateDetails,
            usage = _this$getDefaultParti.usage;
          participationData.classroomGroupParticipations = classroomGroupParticipations;
          participationData.certificateDetails = certificateDetails;
          participationData.usage = usage;
        }
      }
      this.setParticipationTableConfig(participationData, groupId);
      this.setState({
        participationData: participationData
      });
    }
  }, {
    key: "updateParticipationTableConfig",
    value: function updateParticipationTableConfig(participationTableConfig, groupId) {
      var _this2 = this;
      // Update the group name
      participationTableConfig.colGroups[0].find(function (col) {
        return col.id === _singleClassConstantsUpdate.GROUP_NAME;
      }).name = this.text.groups;
      // If page is displays all groups OR no group is selected
      if (!groupId) {
        // Set group click event
        participationTableConfig.cols.find(function (col) {
          return col.id === _singleClassConstantsUpdate.GROUP_NAME;
        }).onClick = function (selectedGroup) {
          _this2.loadNewPage(_filterConstants.SELECTED_GROUP, selectedGroup);
        };
        // Set group sort
        participationTableConfig.colGroups[0].find(function (col) {
          return col.id === _singleClassConstantsUpdate.GROUP_NAME;
        }).sort = {
          colId: _singleClassConstantsUpdate.GROUP_NAME,
          sortAs: 'string',
          sortDir: 'desc'
        };
      }
      // Lokalise
      participationTableConfig.colGroups[0].map(function (col) {
        return col.name = window.i18n._(col.name);
      });
      participationTableConfig.cols.map(function (col) {
        return col.name = window.i18n._(col.name);
      });
      // Set student click event
      participationTableConfig.nestedData.cols.find(function (col) {
        return col.id === _singleClassConstantsUpdate.STUDENT_NAME;
      }).onClick = function (selectedStudent) {
        _this2.loadNewPage(_filterConstants.SELECTED_STUDENT, selectedStudent);
      };
      participationTableConfig.colGroups[0].map(function (item) {
        if (item.id === _singleClassConstantsUpdate.PAST_CERTIFICATES_TOTAL) {
          item.headerTransform = function () {
            return /*#__PURE__*/_react["default"].createElement(_headerToggle["default"], {
              title: item.name,
              onClick: function onClick(value) {
                return _this2.setState({
                  dataTable: _objectSpread(_objectSpread({}, _this2.state.dataTable), {}, {
                    isPastCertificatesExpanded: value
                  })
                });
              },
              defaultExpanded: _this2.state.isPastCertificatesExpanded
            });
          };
        }
        if (item.id === _singleClassConstantsUpdate.NEW_CERTIFICATES_TOTAL) {
          item.headerTransform = function () {
            return /*#__PURE__*/_react["default"].createElement(_headerToggle["default"], {
              title: item.name,
              onClick: function onClick(value) {
                return _this2.setState({
                  dataTable: _objectSpread(_objectSpread({}, _this2.state.dataTable), {}, {
                    isNewCertificatesExpanded: value
                  })
                });
              },
              defaultExpanded: _this2.state.isNewCertificatesExpanded
            });
          };
        }
        return item;
      });
      return participationTableConfig;
    }
  }, {
    key: "setParticipationTableConfig",
    value: function setParticipationTableConfig(participationData, groupId) {
      var activeFilters = this.props.activeFilters;
      var classroomId = activeFilters[_filterConstants.SELECTED_CLASS].id;
      var participationTableConfig = (0, _singleClassConstantsUpdate.getSingleClassParticipationTableConfig)(_objectSpread(_objectSpread({}, this.state.dataTable), {}, {
        classroomId: classroomId
      }));
      participationTableConfig = this.updateParticipationTableConfig(participationTableConfig, groupId);
      this.setState({
        participationTableConfig: (0, _cloneDeep["default"])(participationTableConfig)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        participationData = _this$state.participationData,
        participationTableConfig = _this$state.participationTableConfig;
      var _this$props2 = this.props,
        activeFilters = _this$props2.activeFilters,
        newCertificatesDownloadByType = _this$props2.newCertificatesDownloadByType,
        pastCertificatesDownloadByType = _this$props2.pastCertificatesDownloadByType;
      var selectedGroupId = activeFilters[_filterConstants.SELECTED_GROUP].id;
      var participationHeader = this.i18n._('Table Header - Participation');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"]['participation-results']
      }, /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: participationHeader
      }), /*#__PURE__*/_react["default"].createElement(_usage["default"], this.getUsageData(participationData)), /*#__PURE__*/_react["default"].createElement(_singleClassCertificates["default"], {
        selectedClassroomId: activeFilters[_filterConstants.SELECTED_CLASS].id,
        selectedGroupId: selectedGroupId === _filterConstants.ALL_GROUPS ? _allClassesConstants.ALL_GROUPS_ID : selectedGroupId,
        participationData: participationData,
        newCertificatesDownloadByType: newCertificatesDownloadByType,
        pastCertificatesDownloadByType: pastCertificatesDownloadByType,
        selectedYearGroupId: activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id,
        selectedTeacherId: activeFilters[_filterConstants.SELECTED_TEACHER].id
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: participationTableConfig,
        data: participationData && participationData.classroomGroupParticipations
      })));
    }
  }]);
}(_react.Component);
_defineProperty(SingleClass, "propTypes", {
  participationData: _singleClassPropTypes["default"].participationData,
  activeFilters: _filterPropTypes.activeFiltersPropType,
  getParticipationData: _propTypes["default"].func,
  updateActiveFilter: _propTypes["default"].func,
  invalidRequest: _propTypes["default"].string,
  newCertificatesDownloadByType: _propTypes["default"].func,
  pastCertificatesDownloadByType: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    participationData: state.participationSingleClass,
    invalidRequest: state.invalidRequest
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getParticipationData: _singleClassActions["default"].getParticipationData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter,
    newCertificatesDownloadByType: _certificatesActions["default"].newCertificatesDownloadByType,
    pastCertificatesDownloadByType: _certificatesActions["default"].pastCertificatesDownloadByType
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_singleClass["default"])(SingleClass));

/***/ }),

/***/ "pYuN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var EMPTY_STATE_VARIANTS = {
  DEFAULT: 1,
  NO_CLASSES: 2,
  NO_STUDENTS: 3
};
var _default = exports["default"] = EMPTY_STATE_VARIANTS;

/***/ }),

/***/ "pg8O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _linguiCdn = __webpack_require__("siuH");
var _attemptItem = _interopRequireDefault(__webpack_require__("JCVm"));
var _assignmentResultActions = __webpack_require__("Wr1R");
var _assignmentResultReducer = __webpack_require__("llwb");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AttemptItem = function AttemptItem(_ref) {
  var type = _ref.type;
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var dispatch = (0, _reactRedux.useDispatch)();
  var assignmentResultsType = (0, _reactRedux.useSelector)(function (state) {
    return state.assignmentResultType;
  });
  var HIGHEST = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.HIGHEST,
    TEACHER_ASSIGNED = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.TEACHER_ASSIGNED,
    VOLUNTARY = _assignmentResultReducer.ASSIGNMENT_RESULT_TYPES.VOLUNTARY;
  var ASSIGNMENT_ITEM_TEXT = _defineProperty(_defineProperty(_defineProperty({}, HIGHEST, {
    label: i18n._(
    /*i18n*/
    {
      id: "Assignment Item - All highest - Label"
    }),
    tooltip: i18n._(
    /*i18n*/
    {
      id: "Assignment Item - All highest - Tooltip"
    })
  }), TEACHER_ASSIGNED, {
    label: i18n._(
    /*i18n*/
    {
      id: "Assignment Item - Teacher assigned - Label"
    }),
    tooltip: i18n._(
    /*i18n*/
    {
      id: "Assignment Item - Teacher assigned - Tooltip"
    })
  }), VOLUNTARY, {
    label: i18n._(
    /*i18n*/
    {
      id: "Assignment Item - Voluntary attempt - Label"
    }),
    tooltip: i18n._(
    /*i18n*/
    {
      id: "Assignment Item - Voluntary attempt - Tooltip"
    })
  });
  var selectedText = ASSIGNMENT_ITEM_TEXT[type];
  function getButtonClassname() {
    var isActive = assignmentResultsType === type;
    return "".concat(_attemptItem["default"]['attempt-button'], " ").concat(isActive && _attemptItem["default"].active);
  }
  function getTooltipClassname() {
    var typeSelector = "type-".concat(type);
    return "".concat(_attemptItem["default"].tooltip, " ").concat(_attemptItem["default"][typeSelector]);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _attemptItem["default"]['attempt-item']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: 0,
    role: 'button',
    className: getButtonClassname(),
    onClick: function onClick() {
      return dispatch((0, _assignmentResultActions.setAssignmentResultsType)(type));
    }
  }, selectedText.label), /*#__PURE__*/_react["default"].createElement("div", {
    className: _attemptItem["default"]['attempt-info-button-container']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _attemptItem["default"]['attempt-info-button']
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: getTooltipClassname()
  }, selectedText.tooltip)));
};
AttemptItem.propTypes = {
  type: _propTypes["default"].oneOf(Object.values(_assignmentResultReducer.ASSIGNMENT_RESULT_TYPES))
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_attemptItem["default"])(AttemptItem);

/***/ }),

/***/ "ph81":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactRedux = __webpack_require__("RH2O");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _displayControlContainer = _interopRequireDefault(__webpack_require__("wdOd"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Admin users require a footer on some levels of reporting to use for more specific
 * export functionality.
 */

var DisplayControlContainer = function DisplayControlContainer(_ref) {
  var children = _ref.children;
  var isAdmin = (0, _reactRedux.useSelector)(function (state) {
    return state.isAdmin;
  });
  var _useState = (0, _react.useState)(230),
    _useState2 = _slicedToArray(_useState, 2),
    heightBuffer = _useState2[0],
    setHeightBuffer = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    if (isAdmin) setHeightBuffer(288);
  }, [isAdmin]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _displayControlContainer["default"]['display-control-container'],
    style: {
      height: "calc(100vh - ".concat(heightBuffer, "px)")
    }
  }, children);
};
DisplayControlContainer.propTypes = {
  children: _propTypes["default"].element
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_displayControlContainer["default"])(DisplayControlContainer);

/***/ }),

/***/ "pqZ/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".percentageLine---w8K01 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 18px; }\n\n.percentage---2Gn78 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  width: 30px;\n  font-size: 11px;\n  color: #9a9a9a;\n  margin-right: 3px; }\n\n.line---3pYyd {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  height: 0;\n  border: 1px dotted #dadfe3; }\n\n.months---1qZB_ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: calc(90% - 30px);\n  position: absolute;\n  right: 30px;\n  font-size: 11px;\n  color: #9a9a9a; }\n\n.chartPoints---hmn41 {\n  position: absolute;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  top: 105px;\n  width: calc(90% - 35px);\n  height: 185px;\n  margin-left: 30px; }\n\n.chartLine---1g68I {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.chartLine---1g68I svg {\n    overflow: visible; }\n\n.chartPoint---2Wy7l {\n  background-color: #1981c4;\n  height: 6px;\n  width: 6px;\n  border-radius: 3px;\n  position: absolute;\n  margin-top: -3px; }\n\n.chartPointContainer---2bdfF {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.contextModal---2YHPw {\n  top: -65px;\n  -webkit-transform: translate(-47%, 0%);\n          transform: translate(-47%, 0%);\n  width: 100px;\n  font-size: 12px; }\n\n.contextModal---2YHPw .accuracy---3J3mm {\n    font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"percentageLine": "percentageLine---w8K01",
	"percentage": "percentage---2Gn78",
	"line": "line---3pYyd",
	"months": "months---1qZB_",
	"chartPoints": "chartPoints---hmn41",
	"chartLine": "chartLine---1g68I",
	"chartPoint": "chartPoint---2Wy7l",
	"chartPointContainer": "chartPointContainer---2bdfF",
	"contextModal": "contextModal---2YHPw",
	"accuracy": "accuracy---3J3mm"
};

/***/ }),

/***/ "q1+m":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".report-filter-container---2dt1i {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  min-width: 1100px;\n  height: 36px; }\n  .report-filter-container---2dt1i > * {\n    margin: 0 8px; }\n  .report-filter-container---2dt1i .dropdown---3sBJ7,\n  .report-filter-container---2dt1i .report-date-filter---3DBPT {\n    -webkit-box-flex: 0;\n        -ms-flex: 0 1 auto;\n            flex: 0 1 auto;\n    min-width: 180px; }\n  .report-filter-container---2dt1i .dropdown---3sBJ7 [class*='-Menu '],\n    .report-filter-container---2dt1i .report-date-filter---3DBPT [class*='-Menu '] {\n      min-width: 180px; }\n  .report-filter-container---2dt1i .report-date-filter---3DBPT {\n    -ms-flex-negative: 0;\n        flex-shrink: 0; }\n", ""]);

// exports
exports.locals = {
	"report-filter-container": "report-filter-container---2dt1i",
	"dropdown": "dropdown---3sBJ7",
	"report-date-filter": "report-date-filter---3DBPT"
};

/***/ }),

/***/ "q6Kz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _formatPickerActions = __webpack_require__("AzNC");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  reportFormats: []
};
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _formatPickerActions.UPDATE_REPORT_FORMAT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          reportFormats: getUpdatedReportFormat(state.reportFormats, action.payload)
        });
      }
    default:
      return state;
  }
}

/**
 * Multiple report formats can be selected. If exists we remove... if not we append
 * @param currentReportFormat: state.reportFormats
 * @param payload: action.payload
 * @returns updated report formats array
 */
function getUpdatedReportFormat(currentReportFormat, payload) {
  var updatedReportFormat = _toConsumableArray(currentReportFormat);
  if (currentReportFormat.includes(payload)) {
    return updatedReportFormat.filter(function (item) {
      return item !== payload;
    });
  }
  return [].concat(_toConsumableArray(updatedReportFormat), [payload]);
}

/***/ }),

/***/ "qEGd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".empty-state---HXH5n {\n  height: 100%;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  .empty-state---HXH5n .no-students-content---d14oe {\n    font-size: 25px;\n    font-weight: bold;\n    height: calc(100% - 100px);\n    min-height: 400px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center; }\n  .empty-state---HXH5n .no-students-content---d14oe .text---3_spv {\n      margin: 0 3px; }\n  .empty-state---HXH5n .no-students-content---d14oe .manage-students-button---IQ2KB {\n      background: none;\n      color: #278bcb;\n      text-decoration: underline;\n      border: none;\n      padding: 0;\n      cursor: pointer;\n      margin: 0 3px; }\n  .empty-state---HXH5n .container-wrapper---138qD {\n    font-size: 25px;\n    font-weight: bold;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    height: calc(100vh - 180px);\n    min-height: 550px;\n    text-align: center; }\n", ""]);

// exports
exports.locals = {
	"empty-state": "empty-state---HXH5n",
	"no-students-content": "no-students-content---d14oe",
	"text": "text---3_spv",
	"manage-students-button": "manage-students-button---IQ2KB",
	"container-wrapper": "container-wrapper---138qD"
};

/***/ }),

/***/ "qS76":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SHOW_BUSY = exports.HIDE_BUSY = void 0;
var _mathleticsPortalCommunicationService = _interopRequireDefault(__webpack_require__("UTT2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SHOW_BUSY = exports.SHOW_BUSY = 'SHOW_BUSY';
var HIDE_BUSY = exports.HIDE_BUSY = 'HIDE_BUSY';
function showBusy() {
  return function (dispatch) {
    _mathleticsPortalCommunicationService["default"].requestLoadingSpinner(true);
    dispatch({
      type: SHOW_BUSY
    });
  };
}
function hideBusy() {
  return function (dispatch) {
    _mathleticsPortalCommunicationService["default"].requestLoadingSpinner(false);
    dispatch({
      type: HIDE_BUSY
    });
  };
}
var _default = exports["default"] = {
  showBusy: showBusy,
  hideBusy: hideBusy
};

/***/ }),

/***/ "qvwF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactInlinesvg = _interopRequireDefault(__webpack_require__("h2Qy"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _icon_expand = _interopRequireDefault(__webpack_require__("evse"));
var _headerToggle = _interopRequireDefault(__webpack_require__("ZeRC"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var HeaderToggle = function HeaderToggle(_ref) {
  var title = _ref.title,
    onClick = _ref.onClick,
    defaultExpanded = _ref.defaultExpanded;
  var i18n = window.i18n;
  var _useState = (0, _react.useState)(defaultExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var onClickHandler = function onClickHandler() {
    var updatedIsExpanded = !isExpanded;
    setIsExpanded(updatedIsExpanded);
    onClick(updatedIsExpanded);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _headerToggle["default"].container
  }, /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClickHandler
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: _icon_expand["default"],
    cacheGetRequests: true
  }), /*#__PURE__*/_react["default"].createElement("span", null, isExpanded ? i18n._('Collapse') : i18n._('Expand'))));
};
HeaderToggle.propTypes = {
  title: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  defaultExpanded: _propTypes["default"].bool.isRequired
};
HeaderToggle.defaultProps = {
  onClick: function onClick() {},
  defaultExpanded: false
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_headerToggle["default"])(HeaderToggle);

/***/ }),

/***/ "rFgw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _reportStateActions = __webpack_require__("ItvU");
var initialState = _reportStateActions.REPORT_STATE_ALL_YEARS;

/**
 * ReportState Reducer
 *
 * State within report - currently only applies to Participation All Years which can have
 * 3 states: All years, All classes, Top 10 students
 *
 * Consumes SET_REPORT_STATE action
 *
 * @param {string} the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {string} - new state
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _reportStateActions.SET_REPORT_STATE:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "rQyF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ClassDropdown = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _dropdownHelpers = __webpack_require__("KmGe");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ClassDropdown = exports.ClassDropdown = /*#__PURE__*/function (_PureComponent) {
  function ClassDropdown() {
    var _this;
    _classCallCheck(this, ClassDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ClassDropdown, [].concat(args));
    _defineProperty(_this, "optionSelected", function (selectedOption) {
      var _this$props = _this.props,
        setSelectedClass = _this$props.setSelectedClass,
        handleClassChange = _this$props.handleClassChange;
      setSelectedClass(selectedOption);
      handleClassChange();
    });
    return _this;
  }
  _inherits(ClassDropdown, _PureComponent);
  return _createClass(ClassDropdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        classDropdownData = _this$props2.classDropdownData,
        className = _this$props2.className;
      var data = classDropdownData.data,
        selectedOption = classDropdownData.selectedOption,
        disabled = classDropdownData.disabled;
      var i18n = window.i18n;
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
        className: className,
        options: (0, _dropdownHelpers.getTranslatedOptions)(data, _filterConstants.ALL_CLASSES, i18n),
        selectedOption: (0, _dropdownHelpers.getTranslateSelectedOption)(selectedOption, _filterConstants.ALL_CLASSES, i18n),
        onSelectOption: this.optionSelected,
        disabled: disabled
      });
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(ClassDropdown, "propTypes", {
  classDropdownData: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_filterPropTypes.dropdownItemPropType),
    selectedOption: _filterPropTypes.dropdownItemPropType,
    disabled: _propTypes["default"].bool
  }),
  className: _propTypes["default"].string,
  setSelectedClass: _propTypes["default"].func,
  handleClassChange: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    classDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.CLASS_LIST)(state)
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setSelectedClass: _dropdownDataActions["default"].setSelectedClass
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClassDropdown);

/***/ }),

/***/ "rR7D":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".dropdown-container---2W1sL {\n  width: 100%;\n  margin: 12px 0; }\n  .dropdown-container---2W1sL .dropdown-trigger---1-Uxr {\n    height: 40px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    border-radius: 6px;\n    border: 1px solid #dbe0e6;\n    background: #fff;\n    padding: 8px 10px 8px 16px;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center; }\n  .dropdown-container---2W1sL .dropdown-trigger---1-Uxr span {\n      height: 24px; }\n  .dropdown-container---2W1sL .dropdown-trigger---1-Uxr svg {\n      width: 24px;\n      height: 24px; }\n  .dropdown-container---2W1sL .dropdown-trigger---1-Uxr:hover {\n      border: 1px solid #4dc4ef; }\n  .dropdown-container---2W1sL .dropdown-trigger---1-Uxr:focus {\n      border: 1px solid #00abe8; }\n  .dropdown-container---2W1sL .dropdown-options-container---uOmaX {\n    padding: 12px;\n    border: 1px solid #ccc;\n    background: #fff;\n    border-radius: 12px;\n    max-height: 330px;\n    overflow-y: auto;\n    -webkit-transform: translateY(2px);\n            transform: translateY(2px);\n    -webkit-box-shadow: 0 4px 6px -1px rgba(0, 25, 55, .1), 0 2px 4px -1px rgba(0, 25, 55, .06);\n            box-shadow: 0 4px 6px -1px rgba(0, 25, 55, .1), 0 2px 4px -1px rgba(0, 25, 55, .06); }\n  .dropdown-container---2W1sL .dropdown-option---zIgCK {\n    padding: 10px 24px;\n    margin: 2px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-bottom: 1px solid #edf1f4; }\n  .dropdown-container---2W1sL .dropdown-option---zIgCK .check-box---xXozi {\n      margin: 0;\n      width: 24px;\n      height: 24px;\n      margin-right: 16px;\n      -webkit-transform: translateY(4px);\n              transform: translateY(4px); }\n", ""]);

// exports
exports.locals = {
	"dropdown-container": "dropdown-container---2W1sL",
	"dropdown-trigger": "dropdown-trigger---1-Uxr",
	"dropdown-options-container": "dropdown-options-container---uOmaX",
	"dropdown-option": "dropdown-option---zIgCK",
	"check-box": "check-box---xXozi"
};

/***/ }),

/***/ "rVQD":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("V289");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./table-header.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./table-header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "rjLd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTranslationKey = exports.getLocallyAcquiredI18N = void 0;
exports.localeCode = localeCode;
exports.useLokalise = exports.translateTableLabels = exports.translate = void 0;
var _linguiCdn = __webpack_require__("siuH");
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _filterConstants = __webpack_require__("cdWI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getLocallyAcquiredI18N = exports.getLocallyAcquiredI18N = function getLocallyAcquiredI18N() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  _resources["default"].getConfigurationItem('LocalisationCdnBaseUrl').then(function (linguiCdnBaseUrl) {
    var locales = localeCode();
    (0, _linguiCdn.getI18N)(linguiCdnBaseUrl, [locales]).then(function (i18n) {
      callback(i18n);
      return i18n;
    });
  });
  return false;
};
function localeCode() {
  var query = window.location.search.slice(1);
  var match = query.match(/\blocale=([-a-zA-Z]+)\b/);
  return match ? match[1] : 'en-AU';
}
var translate = exports.translate = function translate(translationKey) {
  return window.i18n._(translationKey);
};
var getTranslationKey = exports.getTranslationKey = function getTranslationKey(name) {
  if (name) {
    switch (name) {
      case _filterConstants.PARTICIPATION:
        return 'Table Header - Participation';
      case _filterConstants.SKILL_QUESTS_MASTERY:
        return 'Table Header - Skill Quests Mastery';
      case _filterConstants.LIVE_MATHS:
        return 'Table Header - Live Mathletics';
      case _filterConstants.ACTIVITY_MASTERY:
        return 'Table Header - Activity Mastery';
      case _filterConstants.NUM_ACTIVITIES:
        return 'Label - NumActivities';
      case _filterConstants.ALL_CLASSES:
        return 'Table Config - All classes';
      case _filterConstants.RESULTS:
        return 'Table Config - Results';
      case _filterConstants.ALL_YEARS:
        return 'Export - All years';
      case _filterConstants.TEACHERS:
        return 'Label - Teachers';
      case _filterConstants.TOPICS:
        return 'Table Config - Topics';
      case _filterConstants.ACTIVITIES:
        return 'Table Config - Activities';
      case _filterConstants.ACTIVITY:
        return 'Table Config - Activity';
      case _filterConstants.ATTEMPTS:
        return 'Header - Attempts';
      case _filterConstants.LEVEL:
        return 'Column Header - Level';
      case _filterConstants.LEVEL_LOWERCASE:
        return 'Column Header - LevelLowercase';
      default:
        return null;
    }
  }
  return null;
};
var useLokalise = exports.useLokalise = function useLokalise() {
  var _useLocalisation = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation.i18n;
  var teacherNumTitle = function teacherNumTitle(num) {
    return i18n._(
    /*i18n*/
    {
      id: "Label - NumTeachers {num}",
      values: {
        num: num
      }
    });
  };
  return {
    teacherNumTitle: teacherNumTitle
  };
};
var translateTableLabels = exports.translateTableLabels = function translateTableLabels(tableConfig) {
  var translateTransform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useLocalisation2 = (0, _linguiCdn.useLocalisation)(),
    i18n = _useLocalisation2.i18n;
  function translateName(col) {
    if (col.doTranslation) {
      col.name = i18n._(col.name);
      if (translateTransform) {
        var transformName = i18n._(col.transform());
        col.transform = function () {
          return transformName;
        };
      }
    }
  }
  var cols = tableConfig.cols,
    colGroups = tableConfig.colGroups,
    emptyDataMessage = tableConfig.emptyDataMessage,
    nestedData = tableConfig.nestedData;
  cols.forEach(function (col) {
    return translateName(col);
  });
  if (colGroups && colGroups.length > 0) {
    colGroups[0].forEach(function (col) {
      return translateName(col);
    });
  }
  if (emptyDataMessage) {
    tableConfig.emptyDataMessage = i18n._(emptyDataMessage);
  }
  if (nestedData) {
    if (nestedData.emptyDataMessage) {
      nestedData.emptyDataMessage = i18n._(nestedData.emptyDataMessage);
    }
    var nestedDataCols = nestedData.cols;
    nestedDataCols.forEach(function (col) {
      return translateName(col);
    });
  }
  return tableConfig;
};

/***/ }),

/***/ "rrgl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _moment = _interopRequireDefault(__webpack_require__("PJh5"));
var _constants = __webpack_require__("1QGX");
var _utils = __webpack_require__("6QRH");
var _certificates = _interopRequireDefault(__webpack_require__("wAWk"));
var _downloadButton = _interopRequireDefault(__webpack_require__("c/2N"));
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _certificateConfirmationModal = _interopRequireDefault(__webpack_require__("MKpC"));
var _useCertificatesToast2 = __webpack_require__("vS7R");
var _certificatesActions = _interopRequireDefault(__webpack_require__("PLdC"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Certificates = function Certificates(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useCertificatesToast = (0, _useCertificatesToast2.useCertificatesToast)(),
    renderedToast = _useCertificatesToast.renderedToast,
    onOpenToast = _useCertificatesToast.onOpenToast;
  var certificates = props.certificates,
    config = props.config,
    heading = props.heading,
    isOldCertificates = props.isOldCertificates,
    handleCertificateDownloadClick = props.handleCertificateDownloadClick,
    startDate = props.startDate,
    endDate = props.endDate,
    classroomId = props.classroomId,
    groupId = props.groupId,
    yearGroupEnum = props.yearGroupEnum,
    teacherUserProfileId = props.teacherUserProfileId,
    userProfileId = props.userProfileId;
  var _handleDownloadClick = function handleDownloadClick(_ref) {
    var certificateType = _ref.certificateType,
      _ref$fullColor = _ref.fullColor,
      fullColor = _ref$fullColor === void 0 ? true : _ref$fullColor,
      certificatesCount = _ref.certificatesCount,
      certificateTypeName = _ref.certificateTypeName,
      _ref$gemTypes = _ref.gemTypes,
      gemTypes = _ref$gemTypes === void 0 ? [] : _ref$gemTypes;
    var requestPayload = _objectSpread(_objectSpread(_objectSpread({
      startDate: (0, _moment["default"])(startDate).format('DD-MM-YYYY'),
      endDate: (0, _moment["default"])(endDate).format('DD-MM-YYYY'),
      classroomId: classroomId,
      groupId: groupId,
      type: certificateType,
      certificateTypeName: certificateTypeName,
      certificatesCount: certificatesCount,
      productId: _constants.MATHLETICS_ID
    }, !isOldCertificates && {
      gemTypes: gemTypes,
      fullColor: fullColor
    }), yearGroupEnum !== null && !!yearGroupEnum && {
      yearGroupEnum: yearGroupEnum
    }), teacherUserProfileId && {
      teacherUserProfileId: teacherUserProfileId
    });
    handleCertificateDownloadClick(requestPayload);
  };
  var showCertificatesDownloadConfirmationModal = function showCertificatesDownloadConfirmationModal(certificatesCount, certificateType, title) {
    dispatch(_modalActions["default"].openModal({
      content: /*#__PURE__*/_react["default"].createElement(_certificateConfirmationModal["default"], _extends({
        certificatesCount: certificatesCount,
        certificateType: certificateType,
        handleDownloadClick: function handleDownloadClick(_ref2) {
          var fullColor = _ref2.fullColor,
            gemTypes = _ref2.gemTypes,
            gemCount = _ref2.gemCount;
          _handleDownloadClick({
            certificateType: certificateType,
            fullColor: fullColor,
            certificatesCount: gemCount,
            certificateTypeName: title,
            gemTypes: gemTypes
          });
        }
      }, props)),
      buttons: []
    }));
  };
  var onClickHandler = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref3) {
      var id, type, title, maxCertificatesCanDownload, requestPayload, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            id = _ref3.id, type = _ref3.type, title = _ref3.title;
            _context.n = 1;
            return (0, _utils.getConfiguration)(_constants.CONFIGURATION_KEYS.MAX_CERTIFICATES_CAN_DOWNLOAD);
          case 1:
            _t = _context.v;
            if (_t) {
              _context.n = 2;
              break;
            }
            _t = 200;
          case 2:
            maxCertificatesCanDownload = _t;
            if (certificates[id] > maxCertificatesCanDownload) {
              onOpenToast();
            } else if (!isOldCertificates) {
              requestPayload = {
                type: type,
                startDate: (0, _moment["default"])(startDate).format('DD-MM-YYYY'),
                endDate: (0, _moment["default"])(endDate).format('DD-MM-YYYY'),
                classroomId: classroomId,
                groupId: groupId,
                studentUserProfileId: userProfileId,
                yearGroupEnum: yearGroupEnum,
                teacherUserProfileId: teacherUserProfileId
              };
              dispatch(_certificatesActions["default"].getGemCountsByType(requestPayload)).then(function () {
                showCertificatesDownloadConfirmationModal(certificates[id], type, title);
              });
            } else {
              // download old certificates without showing modal
              _handleDownloadClick({
                certificateType: type,
                certificatesCount: certificates[id],
                certificateTypeName: title
              });
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onClickHandler(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement("div", null, renderedToast, /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificates["default"].certificates
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificates["default"].certificatesContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificates["default"].heading
  }, heading), /*#__PURE__*/_react["default"].createElement("div", {
    className: _certificates["default"].container
  }, config.map(function (_ref5) {
    var id = _ref5.id,
      icon = _ref5.icon,
      title = _ref5.title,
      type = _ref5.type;
    var isDisabled = certificates === null || certificates[id] === 0;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_certificates["default"].certificate, " ").concat(isDisabled ? _certificates["default"].disabled : ''),
      key: id
    }, /*#__PURE__*/_react["default"].createElement("img", {
      width: '64px',
      height: '40px',
      src: icon,
      alt: title
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _certificates["default"].title
    }, title), /*#__PURE__*/_react["default"].createElement(_downloadButton["default"], {
      onClick: function onClick() {
        return onClickHandler({
          id: id,
          type: type,
          title: title
        });
      },
      disabled: isDisabled,
      title: certificates && certificates[id]
    }));
  })))));
};
Certificates.propTypes = {
  heading: _propTypes["default"].string,
  startDate: _propTypes["default"].string,
  endDate: _propTypes["default"].string,
  classroomId: _propTypes["default"].number,
  groupId: _propTypes["default"].number,
  userProfileId: _propTypes["default"].number,
  certificates: _propTypes["default"].shape({
    bronze: _propTypes["default"].number,
    silver: _propTypes["default"].number,
    gold: _propTypes["default"].number,
    platinum: _propTypes["default"].number,
    emerald: _propTypes["default"].number,
    diamond: _propTypes["default"].number,
    epic: _propTypes["default"].number,
    legend: _propTypes["default"].number
  }) || null,
  config: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    title: _propTypes["default"].string,
    icon: _propTypes["default"].string
  })),
  handleCertificateDownloadClick: _propTypes["default"].func,
  yearGroupEnum: _propTypes["default"].number,
  teacherUserProfileId: _propTypes["default"].number,
  isOldCertificates: _propTypes["default"].bool
};
Certificates.defaultProps = {
  certificates: {
    bronze: 0,
    silver: 0,
    gold: 0,
    platinum: 0,
    emerald: 0,
    diamond: 0,
    epic: 0,
    legend: 0
  },
  newCertificatesConfig: []
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_certificates["default"])(Certificates);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "ruIP":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/0a661ae903f80ff687c29013d0b21d81.svg";

/***/ }),

/***/ "rvRX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var certificateDetailsPropType = _propTypes["default"].shape({
  gold: _propTypes["default"].number,
  silver: _propTypes["default"].number,
  bronze: _propTypes["default"].number,
  goldBars: _propTypes["default"].number,
  total: _propTypes["default"].number
});
var pointsPropType = _propTypes["default"].shape({
  activityPoints: _propTypes["default"].number,
  livePoints: _propTypes["default"].number,
  total: _propTypes["default"].number
});
var accessDetailsPropType = _propTypes["default"].shape({
  signIns: _propTypes["default"].number,
  timeOnline: _propTypes["default"].shape({
    hours: _propTypes["default"].number,
    minutes: _propTypes["default"].number
  })
});
var participationData = _propTypes["default"].shape({
  classroomName: _propTypes["default"].string,
  certificateDetails: certificateDetailsPropType,
  points: pointsPropType,
  accessDetails: accessDetailsPropType,
  classroomGroupParticipations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    name: _propTypes["default"].string,
    courseName: _propTypes["default"].string,
    courseId: _propTypes["default"].number,
    points: pointsPropType,
    accessDetails: accessDetailsPropType,
    certificateDetails: certificateDetailsPropType,
    studentUsageDetails: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number,
      fullName: _propTypes["default"].string,
      points: pointsPropType,
      accessDetails: accessDetailsPropType,
      certificates: certificateDetailsPropType
    }))
  }))
});
var _default = exports["default"] = {
  participationData: participationData
};

/***/ }),

/***/ "sO+K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTableConfigTransformById = exports.translateTableContent = exports.renderStudentFullName = exports.renderStandardsInProgress = exports.renderStandardsCompleted = exports.renderEmptyStateMessage = exports.renderEmptyState = exports.renderCompletedQuestsGroupLevel = exports.renderCompletedQuestsClassLevel = exports.onInvalidRequest = exports.manageTranslation = exports.manageHeaderValue = exports.manageEmptyStudent = exports.manageEmptyGroup = exports.manageEmptyClass = exports.getStudentFullname = exports.alignTableConfigNested = exports.alignTableConfigHeader = exports.alignSingleClassTableConfigBody = exports.alignAllClassesTableConfigBody = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _mathleticsPortalCommunicationService = _interopRequireDefault(__webpack_require__("UTT2"));
var _reactComponents = __webpack_require__("fmgT");
var _skillQuestsMastery = _interopRequireDefault(__webpack_require__("Qf7c"));
var _singleClass = _interopRequireDefault(__webpack_require__("XiXD"));
var _progressBar = _interopRequireDefault(__webpack_require__("Hyew"));
var _skillQuestsMasteryConstants = __webpack_require__("ntjf");
var _filterConstants = __webpack_require__("cdWI");
var _constants = __webpack_require__("1QGX");
var _utils = __webpack_require__("6QRH");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * TEXT
 */
var text = {
  NO_STUDENTS_CLASS: 'Table Empty - No students in this class',
  NO_STUDENTS_GROUP: 'Table Empty - No students in this group',
  NO_STUDENTS_NO_SKILL_QUESTS_GROUP: 'Table Empty - This group has no students and no skill quests course set',
  NO_SKILL_QUESTS: 'Table Empty - Skill Quests course not set',
  GO_TO_MANAGE_STUDENTS: 'Table Empty - Go to Manage Students',
  SKILL_QUESTS_NOT_SET_GROUPS: 'Table Empty - Skill Quests course not set for any of the groups'
};

/**
 * HELPER FUNCTIONS
 */
var getStudentFullname = exports.getStudentFullname = function getStudentFullname(reportData) {
  var studentFirstName = reportData.studentFirstName,
    studentLastName = reportData.studentLastName;
  return "".concat(studentFirstName, " ").concat(studentLastName);
};
var updateTableConfigNameById = function updateTableConfigNameById(id, value, tableConfig) {
  tableConfig.cols.find(function (col) {
    return col.id === id;
  }).name = value;
  return tableConfig;
};
var updateTableConfigTransformById = exports.updateTableConfigTransformById = function updateTableConfigTransformById(id, value, tableConfig) {
  tableConfig.cols.find(function (col) {
    return col.id === id;
  }).transform = function (row) {
    return value(row);
  };
  return tableConfig;
};
var updateTableConfigNestedTransformById = function updateTableConfigNestedTransformById(id, value, tableConfig) {
  tableConfig.nestedData.cols.find(function (col) {
    return col.id === id;
  }).transform = function (row) {
    return value(row);
  };
  return tableConfig;
};
var isUndefined = function isUndefined(value) {
  return value === undefined;
};
var manageHeaderValue = exports.manageHeaderValue = function manageHeaderValue(value) {
  return value.toString();
};
var getStandardsValue = function getStandardsValue(currentValue, totalValue) {
  if (isUndefined(currentValue) || isUndefined(totalValue)) {
    return null;
  }
  return "".concat(currentValue, "/").concat(totalValue);
};
var isEmptyArray = function isEmptyArray(value) {
  return value && value.length === 0;
};

/**
 * EMPTY CELLS
 */
var manageEmptyStudent = exports.manageEmptyStudent = function manageEmptyStudent(row, defaultValue) {
  var isDataAvailable = row.isDataAvailable;
  if (!isDataAvailable) return _skillQuestsMasteryConstants.EMPTY_CELL;
  return defaultValue;
};
var manageEmptyGroup = exports.manageEmptyGroup = function manageEmptyGroup(row, defaultValue) {
  var groupCourseId = row.groupCourseId,
    students = row.students;
  var isStudentsEmpty = isEmptyArray(students);
  if (!groupCourseId || isStudentsEmpty) return _skillQuestsMasteryConstants.EMPTY_CELL;
  return defaultValue;
};
var manageEmptyClass = exports.manageEmptyClass = function manageEmptyClass(row, defaultValue) {
  var isClassEmpty = row.isClassEmpty,
    areAllClassGroupsDefaultCoursesUndefined = row.areAllClassGroupsDefaultCoursesUndefined;
  if (isClassEmpty || areAllClassGroupsDefaultCoursesUndefined) return _skillQuestsMasteryConstants.EMPTY_CELL;
  return defaultValue;
};

/**
 * RENDER FUNCTIONS
 */
var renderEmptyStateMessage = exports.renderEmptyStateMessage = function renderEmptyStateMessage(portalModuleId, selectedClassId, labelText, i18n) {
  return /*#__PURE__*/_react["default"].createElement("div", null, i18n._(labelText), " -", ' ', /*#__PURE__*/_react["default"].createElement("button", {
    className: _skillQuestsMastery["default"]['manage-students-button'],
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var moduleId;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return (0, _utils.getConfiguration)(portalModuleId);
          case 1:
            moduleId = _context.v;
            _mathleticsPortalCommunicationService["default"].requestModuleChange(moduleId, {
              classId: selectedClassId
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))
  }, i18n._(text.GO_TO_MANAGE_STUDENTS)));
};
var renderProgressBar = function renderProgressBar(row) {
  return /*#__PURE__*/_react["default"].createElement(_progressBar["default"], row);
};
var renderStandardsInProgress = exports.renderStandardsInProgress = function renderStandardsInProgress(row) {
  var standardsInProgressCount = row.standardsInProgressCount,
    standardsAvailableCount = row.standardsAvailableCount;
  return getStandardsValue(standardsInProgressCount, standardsAvailableCount);
};
var renderStandardsCompleted = exports.renderStandardsCompleted = function renderStandardsCompleted(row) {
  var standardsCompletedCount = row.standardsCompletedCount,
    standardsAvailableCount = row.standardsAvailableCount;
  return getStandardsValue(standardsCompletedCount, standardsAvailableCount);
};
var renderCompletedQuestsClassLevel = exports.renderCompletedQuestsClassLevel = function renderCompletedQuestsClassLevel(row, i18n) {
  var isClassEmpty = row.isClassEmpty,
    classId = row.classId,
    standardsAvailableCount = row.standardsAvailableCount;
  var NO_STUDENTS_CLASS = text.NO_STUDENTS_CLASS,
    SKILL_QUESTS_NOT_SET_GROUPS = text.SKILL_QUESTS_NOT_SET_GROUPS;
  if (isClassEmpty) {
    return renderEmptyStateMessage(_constants.PORTAL_MODULE.MANAGE_STUDENTS, classId, NO_STUDENTS_CLASS, i18n);
  }

  // check if Skill Quests are set for groups or not
  if (!standardsAvailableCount) {
    return renderEmptyStateMessage(_constants.PORTAL_MODULE.MANAGE_STUDENTS, classId, SKILL_QUESTS_NOT_SET_GROUPS, i18n);
  }
  return renderProgressBar(row);
};
var renderEmptyState = exports.renderEmptyState = function renderEmptyState(_ref2, selectedClassId, i18n) {
  var groupCourseId = _ref2.groupCourseId,
    students = _ref2.students;
  var NO_STUDENTS_GROUP = text.NO_STUDENTS_GROUP,
    NO_SKILL_QUESTS = text.NO_SKILL_QUESTS,
    NO_STUDENTS_NO_SKILL_QUESTS_GROUP = text.NO_STUDENTS_NO_SKILL_QUESTS_GROUP;
  var labelText = NO_SKILL_QUESTS;
  var isStudentEmpty = isEmptyArray(students);
  if (isStudentEmpty && groupCourseId === null) {
    labelText = NO_STUDENTS_NO_SKILL_QUESTS_GROUP;
  } else if (isStudentEmpty) {
    labelText = NO_STUDENTS_GROUP;
  }
  return renderEmptyStateMessage(_constants.PORTAL_MODULE.MANAGE_STUDENTS, selectedClassId, labelText, i18n);
};
var renderCompletedQuestsGroupLevel = exports.renderCompletedQuestsGroupLevel = function renderCompletedQuestsGroupLevel(row, selectedClassId, i18n) {
  var groupCourseName = row.groupCourseName,
    groupPublicationName = row.groupPublicationName,
    students = row.students;
  var isStudentEmpty = isEmptyArray(students);
  if (groupCourseName && !isStudentEmpty) {
    return /*#__PURE__*/_react["default"].createElement("div", null, "".concat(groupPublicationName, " - ").concat(groupCourseName));
  }
  return renderEmptyState(row, selectedClassId, i18n);
};
var renderStudentFullName = exports.renderStudentFullName = function renderStudentFullName(row) {
  var fullName = getStudentFullname(row);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _singleClass["default"]['student-full-name'],
    title: fullName
  }, fullName);
};

/**
 * ALIGN TABLE CONFIGURATION
 */
var alignTableConfigHeader = exports.alignTableConfigHeader = function alignTableConfigHeader(data, tableConfig) {
  var learningJourneysAssignedOrInProgressCount = data.learningJourneysAssignedOrInProgressCount,
    learningJourneysCompletedCount = data.learningJourneysCompletedCount,
    standardsInProgressCount = data.standardsInProgressCount,
    standardsCompletedCount = data.standardsCompletedCount,
    standardsAvailableCount = data.standardsAvailableCount;
  tableConfig = updateTableConfigTransformById(_skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id, renderProgressBar, tableConfig);
  tableConfig = updateTableConfigNameById(_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id, manageHeaderValue(learningJourneysAssignedOrInProgressCount), tableConfig);
  tableConfig = updateTableConfigNameById(_skillQuestsMasteryConstants.COMPLETED_QUESTS.id, manageHeaderValue(learningJourneysCompletedCount), tableConfig);
  tableConfig = updateTableConfigNameById(_skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id, renderStandardsInProgress({
    standardsInProgressCount: standardsInProgressCount,
    standardsAvailableCount: standardsAvailableCount
  }), tableConfig);
  tableConfig = updateTableConfigNameById(_skillQuestsMasteryConstants.STANDARDS_COMPLETED.id, renderStandardsCompleted({
    standardsCompletedCount: standardsCompletedCount,
    standardsAvailableCount: standardsAvailableCount
  }), tableConfig);
  return tableConfig;
};
var alignAllClassesTableConfigBody = exports.alignAllClassesTableConfigBody = function alignAllClassesTableConfigBody(tableConfig, i18n) {
  tableConfig = updateTableConfigTransformById(_skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id, function (row) {
    return renderCompletedQuestsClassLevel(row, i18n);
  }, tableConfig);
  tableConfig = updateTableConfigTransformById(_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id, function (row) {
    return manageEmptyClass(row, row[_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id]);
  }, tableConfig);
  tableConfig = updateTableConfigTransformById(_skillQuestsMasteryConstants.COMPLETED_QUESTS.id, function (row) {
    return manageEmptyClass(row, row[_skillQuestsMasteryConstants.COMPLETED_QUESTS.id]);
  }, tableConfig);
  tableConfig = updateTableConfigTransformById(_skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id, function (row) {
    return manageEmptyClass(row, renderStandardsInProgress(row));
  }, tableConfig);
  tableConfig = updateTableConfigTransformById(_skillQuestsMasteryConstants.STANDARDS_COMPLETED.id, function (row) {
    return manageEmptyClass(row, renderStandardsCompleted(row));
  }, tableConfig);
  return tableConfig;
};
var alignSingleClassTableConfigBody = exports.alignSingleClassTableConfigBody = function alignSingleClassTableConfigBody(tableConfig) {
  tableConfig = updateTableConfigTransformById(_skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id, function (row) {
    return manageEmptyGroup(row, renderStandardsInProgress(row));
  }, tableConfig);
  tableConfig = updateTableConfigTransformById(_skillQuestsMasteryConstants.STANDARDS_COMPLETED.id, function (row) {
    return manageEmptyGroup(row, renderStandardsCompleted(row));
  }, tableConfig);
  return tableConfig;
};
var alignTableConfigNested = exports.alignTableConfigNested = function alignTableConfigNested(tableConfig) {
  tableConfig = updateTableConfigNestedTransformById(_skillQuestsMasteryConstants.STUDENT_FULL_NAME.id, renderStudentFullName, tableConfig);
  tableConfig = updateTableConfigNestedTransformById(_skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id, renderProgressBar, tableConfig);
  tableConfig = updateTableConfigNestedTransformById(_skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id, function (row) {
    return manageEmptyStudent(row, renderStandardsInProgress(row));
  }, tableConfig);
  tableConfig = updateTableConfigNestedTransformById(_skillQuestsMasteryConstants.STANDARDS_COMPLETED.id, function (row) {
    return manageEmptyStudent(row, renderStandardsCompleted(row));
  }, tableConfig);
  tableConfig = updateTableConfigNestedTransformById(_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id, function (row) {
    return manageEmptyStudent(row, row[_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id]);
  }, tableConfig);
  tableConfig = updateTableConfigNestedTransformById(_skillQuestsMasteryConstants.COMPLETED_QUESTS.id, function (row) {
    return manageEmptyStudent(row, row[_skillQuestsMasteryConstants.COMPLETED_QUESTS.id]);
  }, tableConfig);
  return tableConfig;
};

/**
 * DATA HELPERS
 */
var onInvalidRequest = exports.onInvalidRequest = function onInvalidRequest(props, newProps, requestId) {
  var invalidRequest = props.invalidRequest,
    updateActiveFilter = props.updateActiveFilter;
  var newActiveFilters = newProps.activeFilters,
    newInvalidRequest = newProps.invalidRequest;
  if (invalidRequest !== newInvalidRequest && newInvalidRequest === requestId) {
    if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
      updateActiveFilter(_filterConstants.SELECTED_DATE, {
        type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
      });
    }
  }
};

/**
 * TRANSLATIONS
 */
var manageTranslation = exports.manageTranslation = function manageTranslation(tableConstant, i18n) {
  var translationKey = "Table Config - ".concat(tableConstant.name);
  return i18n._(translationKey);
};
var translateTableContent = exports.translateTableContent = function translateTableContent(i18n, tableConfig) {
  tableConfig.cols.find(function (col) {
    return col.id === _skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY.id;
  }).name = manageTranslation(_skillQuestsMasteryConstants.COMPLETED_QUESTS_SUMMARY, i18n);
  tableConfig.colGroups[0].find(function (col) {
    return col.colIds.includes(_skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS.id);
  }).name = manageTranslation(_skillQuestsMasteryConstants.STANDARDS_IN_PROGRESS, i18n);
  tableConfig.colGroups[0].find(function (col) {
    return col.colIds.includes(_skillQuestsMasteryConstants.STANDARDS_COMPLETED.id);
  }).name = manageTranslation(_skillQuestsMasteryConstants.STANDARDS_COMPLETED, i18n);
  tableConfig.colGroups[0].find(function (col) {
    return col.colIds.includes(_skillQuestsMasteryConstants.ASSIGNED_QUESTS.id);
  }).name = manageTranslation(_skillQuestsMasteryConstants.ASSIGNED_QUESTS, i18n);
  tableConfig.colGroups[0].find(function (col) {
    return col.colIds.includes(_skillQuestsMasteryConstants.COMPLETED_QUESTS.id);
  }).name = manageTranslation(_skillQuestsMasteryConstants.COMPLETED_QUESTS, i18n);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "sgyZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".button---X8YaG {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 56px;\n  height: 22px;\n  border-radius: 20px;\n  padding: 4px 6px;\n  cursor: pointer;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), linear-gradient(103.65deg, #00abe8 -2.03%, #007acc 43.7%, #0063a7 105.46%);\n  color: white;\n  font-size: 11px;\n  font-weight: 500; }\n  .button---X8YaG .title---2nZXM {\n    width: 32px;\n    text-align: center; }\n  .buttonDisabled---3T_ig {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 56px;\n  height: 22px;\n  border-radius: 20px;\n  padding: 4px 6px;\n  cursor: not-allowed;\n  font-size: 11px;\n  font-weight: 500;\n  background-color: #f2f5f7; }\n  .buttonDisabled---3T_ig .dash---2D5i1 {\n    width: 10px;\n    height: 2px;\n    background-color: #33475f; }\n", ""]);

// exports
exports.locals = {
	"button": "button---X8YaG",
	"title": "title---2nZXM",
	"buttonDisabled": "buttonDisabled---3T_ig",
	"dash": "dash---2D5i1"
};

/***/ }),

/***/ "sou6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".display-control-container---3oo8J {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 100%;\n          flex: 1 1 100%;\n  overflow: auto;\n  margin: 20px;\n  padding: 20px;\n  border-radius: 12px;\n  background-color: #fff;\n  -webkit-box-shadow: 5px 5px rgba(0, 0, 0, .07);\n          box-shadow: 5px 5px rgba(0, 0, 0, .07);\n  font-family: poppins, Arial, sans-serif;\n  color: #4e5c67;\n  border: 0 solid #fff; }\n", ""]);

// exports
exports.locals = {
	"display-control-container": "display-control-container---3oo8J"
};

/***/ }),

/***/ "t+mH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ModalContainer = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactRedux = __webpack_require__("RH2O");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _redux = __webpack_require__("2KeS");
var _reactComponents = __webpack_require__("fmgT");
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * ModalContainer Redux component
 * Passes list of modals through to ModalManager component
 *
 */

var ModalContainer = exports.ModalContainer = function ModalContainer(_ref) {
  var modalMessages = _ref.modalMessages,
    closeModal = _ref.closeModal;
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.ModalManager, {
    modals: modalMessages,
    onClose: closeModal
  });
};
ModalContainer.propTypes = {
  modalMessages: _propTypes["default"].array,
  closeModal: _propTypes["default"].func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
  return {
    modalMessages: state.modalMessages
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeModal: _modalActions["default"].closeModal
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalContainer);

/***/ }),

/***/ "t/wp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.studentDataTranslations = void 0;
var _localeHelpers = __webpack_require__("rjLd");
var studentDataTranslations = exports.studentDataTranslations = function studentDataTranslations() {
  return {
    standardText: (0, _localeHelpers.translate)('Student Data Table - Standard'),
    infoProgressText: (0, _localeHelpers.translate)('Student Data Table - Info Progress'),
    allHighestInfoText: (0, _localeHelpers.translate)('Student Data Table - Info All Highest'),
    teacherAssignedInfoText: (0, _localeHelpers.translate)('Student Data Table - Info Teacher Assigned'),
    voluntaryInfoText: (0, _localeHelpers.translate)('Student Data Table - Info Voluntary'),
    infoCompletedTextOne: (0, _localeHelpers.translate)('Student Data Table - Info Completed One'),
    infoCompletedTextTwo: (0, _localeHelpers.translate)('Student Data Table - Info Completed Two'),
    infoCompletedTextThree: (0, _localeHelpers.translate)('Student Data Table - Info Completed Three'),
    standardProgressText: (0, _localeHelpers.translate)('Student Data Table - Skill Quests - Progress through Standards'),
    completedText: (0, _localeHelpers.translate)('Student Data Table - Completed')
  };
};

/***/ }),

/***/ "t1T8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reselect = __webpack_require__("bndy");
var _filterConstants = __webpack_require__("cdWI");
var _exportReportActions = __webpack_require__("oXgP");
/**
 * Redux selectors for active filters
 */

var selectActiveFilters = function selectActiveFilters(state) {
  return state.activeFilters;
};
var selectIsAdmin = function selectIsAdmin(state) {
  return state.isAdmin;
};
var selectFilter = function selectFilter(filterName) {
  return (0, _reselect.createSelector)([selectActiveFilters], function (activeFilters) {
    return activeFilters[filterName];
  });
};
var selectItemId = function selectItemId(filterName, defaultOption) {
  return (0, _reselect.createSelector)([selectFilter(filterName)], function (filter) {
    return filter && filter.id != null ? filter.id : defaultOption;
  });
};
var selectItemName = function selectItemName(filterName) {
  return (0, _reselect.createSelector)([selectFilter(filterName)], function (filter) {
    return filter && filter.name;
  });
};
var selectDate = selectFilter(_filterConstants.SELECTED_DATE);
var selectYearGroup = selectFilter(_filterConstants.SELECTED_YEAR_GROUP);
var selectTeacher = selectFilter(_filterConstants.SELECTED_TEACHER);
var selectClass = selectFilter(_filterConstants.SELECTED_CLASS);
var selectGroup = selectFilter(_filterConstants.SELECTED_GROUP);
var selectStudent = selectFilter(_filterConstants.SELECTED_STUDENT);
var selectReport = selectFilter(_filterConstants.SELECTED_REPORT);
var selectYearGroupId = selectItemId(_filterConstants.SELECTED_YEAR_GROUP, _filterConstants.ALL_YEARS);
var selectTeacherId = selectItemId(_filterConstants.SELECTED_TEACHER, _filterConstants.ALL_TEACHERS);
var selectClassId = selectItemId(_filterConstants.SELECTED_CLASS, _filterConstants.ALL_CLASSES);
var selectGroupId = selectItemId(_filterConstants.SELECTED_GROUP, _filterConstants.ALL_GROUPS);
var selectStudentId = selectItemId(_filterConstants.SELECTED_STUDENT, _filterConstants.ALL_STUDENTS);
var selectReportId = selectItemId(_filterConstants.SELECTED_REPORT, _filterConstants.ACTIVITY_MASTERY);
var selectYearGroupIdForApi = (0, _reselect.createSelector)([selectYearGroupId], function (yearGroupId) {
  return yearGroupId !== _filterConstants.ALL_YEARS ? yearGroupId : 'all';
});
var selectTeacherIdForApi = (0, _reselect.createSelector)([selectTeacherId], function (teacherId) {
  return teacherId !== _filterConstants.ALL_TEACHERS ? teacherId : 0;
});
var selectReportLevel = (0, _reselect.createSelector)([selectStudentId, selectGroupId, selectClassId, selectTeacherId, selectYearGroupId, selectIsAdmin], function (selectedStudentId, selectedGroupId, selectedClassId, selectedTeacherId, selectedYearGroupId, isAdmin) {
  if (selectedStudentId !== _filterConstants.ALL_STUDENTS) {
    return _exportReportActions.REPORT_LEVEL_STUDENT;
  } else if (selectedGroupId !== _filterConstants.ALL_GROUPS) {
    return _exportReportActions.REPORT_LEVEL_GROUP;
  } else if (selectedClassId !== _filterConstants.ALL_CLASSES) {
    return _exportReportActions.REPORT_LEVEL_SINGLE_CLASS;
  } else if (selectedTeacherId !== _filterConstants.ALL_TEACHERS || selectedYearGroupId !== _filterConstants.ALL_YEARS) {
    return _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER;
  } else if (isAdmin) {
    return _exportReportActions.REPORT_LEVEL_ALL_YEARS;
  }
  return _exportReportActions.REPORT_LEVEL_ALL_CLASSES;
});
var selectExportReportHeading = (0, _reselect.createSelector)([selectReportLevel, selectYearGroup, selectTeacher], function (reportLevel, yearGroup, teacher) {
  var i18n = window.i18n;
  var yearGroupName = yearGroup.name === _filterConstants.ALL_YEARS ? i18n._('Report Filters - All years') : yearGroup.name;
  var teacherName = teacher.name === _filterConstants.ALL_TEACHERS ? i18n._('Report Filters - All teachers') : i18n._(teacher.name);
  var allClasses = i18n._('Export - All classes');
  switch (reportLevel) {
    case _exportReportActions.REPORT_LEVEL_ALL_YEARS:
    case _exportReportActions.REPORT_LEVEL_YEAR_GROUP_TEACHER:
      return "".concat(yearGroupName, " | ").concat(teacherName);
    case _exportReportActions.REPORT_LEVEL_ALL_CLASSES:
      return allClasses;
    default:
      return '';
  }
});
var _default = exports["default"] = {
  selectActiveFilters: selectActiveFilters,
  selectFilter: selectFilter,
  selectItemId: selectItemId,
  selectItemName: selectItemName,
  selectDate: selectDate,
  selectYearGroup: selectYearGroup,
  selectTeacher: selectTeacher,
  selectClass: selectClass,
  selectGroup: selectGroup,
  selectStudent: selectStudent,
  selectReport: selectReport,
  selectYearGroupId: selectYearGroupId,
  selectTeacherId: selectTeacherId,
  selectClassId: selectClassId,
  selectGroupId: selectGroupId,
  selectStudentId: selectStudentId,
  selectReportId: selectReportId,
  selectYearGroupIdForApi: selectYearGroupIdForApi,
  selectTeacherIdForApi: selectTeacherIdForApi,
  selectReportLevel: selectReportLevel,
  selectExportReportHeading: selectExportReportHeading
};

/***/ }),

/***/ "tAK5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ffxo");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./activity-status-bar.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./activity-status-bar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "tATg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var studentResultPropType = _propTypes["default"].shape({
  id: _propTypes["default"].number,
  studentName: _propTypes["default"].string,
  totalCorrect: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  topScore: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  accuracy: _propTypes["default"].string,
  questionsPerMinute: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
});
var groupResultPropType = _propTypes["default"].shape({
  id: _propTypes["default"].number,
  name: _propTypes["default"].string,
  courseName: _propTypes["default"].string,
  studentLiveMathsResults: _propTypes["default"].arrayOf(studentResultPropType)
});
var liveMathsDataPropType = _propTypes["default"].shape({
  id: _propTypes["default"].number,
  level: _propTypes["default"].string,
  groups: _propTypes["default"].arrayOf(groupResultPropType)
});
var _default = exports["default"] = {
  studentResultPropType: studentResultPropType,
  groupResultPropType: groupResultPropType,
  liveMathsDataPropType: liveMathsDataPropType
};

/***/ }),

/***/ "tBEy":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("XvdY");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./single-class.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./single-class.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "tBKH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.improvementTypeTranslations = void 0;
var _localeHelpers = __webpack_require__("rjLd");
var improvementTypeTranslations = exports.improvementTypeTranslations = function improvementTypeTranslations() {
  return {
    AsIs: (0, _localeHelpers.translate)('Improvement - AsIs'),
    FirstLatest: (0, _localeHelpers.translate)('Improvement - FirstLatest'),
    HighestLatest: (0, _localeHelpers.translate)('Improvement - HighestLatest'),
    FirstHighest: (0, _localeHelpers.translate)('Improvement - FirstHighest')
  };
};

/***/ }),

/***/ "tQue":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SILVER = exports.PLATINUM = exports.PAST_TOTAL = exports.NEW_TOTAL = exports.LEGEND = exports.GOLD = exports.EPIC = exports.EMERALD = exports.DIAMOND = exports.BRONZE = void 0;
var NEW_TOTAL = exports.NEW_TOTAL = {
  id: 'new',
  type: 0
};
var PAST_TOTAL = exports.PAST_TOTAL = {
  id: 'past',
  type: 0
};
var BRONZE = exports.BRONZE = {
  id: 'bronze',
  type: 1
};
var SILVER = exports.SILVER = {
  id: 'silver',
  type: 2
};
var GOLD = exports.GOLD = {
  id: 'gold',
  type: 3
};
var PLATINUM = exports.PLATINUM = {
  id: 'platinum',
  type: 4
};
var EMERALD = exports.EMERALD = {
  id: 'emerald',
  type: 5
};
var DIAMOND = exports.DIAMOND = {
  id: 'diamond',
  type: 6
};
var EPIC = exports.EPIC = {
  id: 'epic',
  type: 7
};
var LEGEND = exports.LEGEND = {
  id: 'legend',
  type: 8
};

/***/ }),

/***/ "tYGa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LIVE_MATHS_CLASS_RETRIEVED = void 0;
var _sortBy = _interopRequireDefault(__webpack_require__("KBYM"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _constants = __webpack_require__("1QGX");
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _liveMathsLevelPickerActions = _interopRequireDefault(__webpack_require__("7NtK"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LIVE_MATHS_CLASS_RETRIEVED = exports.LIVE_MATHS_CLASS_RETRIEVED = 'LIVE_MATHS_CLASS_RETRIEVED';
function getLiveMathsData(classroomId, selectedDateFilter) {
  return function (dispatch) {
    return _resources["default"].singleClassReport.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_LIVE_MATHS
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId
    })).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDateFilter)).send().then(function (payload) {
      if (payload.valid) {
        dispatch(_liveMathsLevelPickerActions["default"].resetLevel());
        dispatch({
          type: LIVE_MATHS_CLASS_RETRIEVED,
          payload: mapLiveMathsData(payload.data)
        });
      } else {
        dispatch(_errorsActions["default"].addError(LIVE_MATHS_CLASS_RETRIEVED));
      }
    });
  };
}
function mapLiveMathsData(data) {
  if (!data.groupLiveMathsLevelResult) {
    return null;
  }
  var mappedGroupResults = [];
  for (var level in data.groupLiveMathsLevelResult) {
    var groupData = data.groupLiveMathsLevelResult[level];
    mappedGroupResults.push({
      id: +level,
      level: level,
      groups: (0, _sortBy["default"])(groupData.map(mapGroup), ['id'])
    });
  }
  return {
    classroomName: data.classroomName,
    groupLiveMathsLevelResult: mappedGroupResults
  };
}
function mapGroup(group) {
  return _objectSpread(_objectSpread({}, group), {}, {
    studentLiveMathsResults: group.studentLiveMathsResults.map(function (student) {
      return {
        id: student.userProfileId,
        studentName: "".concat(student.lastName, ", ").concat(student.firstName),
        totalCorrect: mapLiveMathsScore(student.totalCorrect),
        topScore: mapLiveMathsScore(student.topScore),
        accuracy: mapLiveMathsScore(student.accuracy, '%'),
        questionsPerMinute: mapLiveMathsScore(student.questionsPerMinute)
      };
    })
  });
}
function mapLiveMathsScore(score, suffix) {
  if (score === -1) {
    return '-';
  } else if (suffix) {
    return "".concat(score).concat(suffix);
  }
  return score;
}
var _default = exports["default"] = {
  getLiveMathsData: getLiveMathsData
};

/***/ }),

/***/ "tecg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SubHeading = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _subHeading = _interopRequireDefault(__webpack_require__("E3Lx"));
var _filterConstants = __webpack_require__("cdWI");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _exportReportActions = _interopRequireDefault(__webpack_require__("oXgP"));
var _subHeadingButtons = _interopRequireDefault(__webpack_require__("Tiy6"));
var _subHeadingHeader = _interopRequireDefault(__webpack_require__("X5f6"));
var _popupMenu = _interopRequireDefault(__webpack_require__("f1U6"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import {
//     dateFilterPropType,
//     filterPropType
// } from '../report-filters/filter-prop-types';
/* global window */
/**
 * Sub Heading Component
 * Displays information which is selected via filter component - page title & selected date range
 */
var SubHeading = exports.SubHeading = /*#__PURE__*/function (_Component) {
  function SubHeading(props) {
    var _this;
    _classCallCheck(this, SubHeading);
    _this = _callSuper(this, SubHeading, [props]);
    _defineProperty(_this, "getIsDownloadEnabled", function (className, selectedReportName) {
      return (
        // Download button is not shown for class level
        className && className !== _filterConstants.ALL_CLASSES &&
        // Skill quests mastery sub heading buttons are found one level deeper as per UX requirements
        selectedReportName !== _filterConstants.SKILL_QUESTS_MASTERY
      );
    });
    _defineProperty(_this, "manageDownloadEnabled", function (newProps) {
      var activeFilters = newProps.activeFilters;
      _this.setState({
        isDownloadEnabled: _this.getIsDownloadEnabled(activeFilters[_filterConstants.SELECTED_CLASS].name, activeFilters[_filterConstants.SELECTED_REPORT].name)
      });
    });
    _defineProperty(_this, "downloadReport", function (exportedReport) {
      window.open(exportedReport.downloadUrl, '_blank');
    });
    _defineProperty(_this, "clickHandler", function () {
      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        shouldDisplayDropdown: !_this.state.shouldDisplayDropdown,
        clickedOutside: false
      }));
    });
    _defineProperty(_this, "myRef", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "handleClickOutside", function (e) {
      if (!_this.myRef.current.contains(e.target)) {
        _this.setState({
          shouldDisplayDropdown: false,
          clickedOutside: true
        });
      }
    });
    _this.state = {
      label: '',
      dateRange: '',
      isDownloadEnabled: false,
      shouldDisplayDropdown: false,
      clickedOutside: false
    };
    return _this;
  }
  _inherits(SubHeading, _Component);
  return _createClass(SubHeading, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isAdmin = this.props.isAdmin;
      if (isAdmin != null) {
        this.manageDownloadEnabled(this.props);
      }
      document.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var exportedReport = this.props.exportedReport;
      var newExportedReport = newProps.exportedReport,
        isAdmin = newProps.isAdmin;
      if (exportedReport !== newExportedReport) {
        this.downloadReport(newExportedReport);
      }
      if (isAdmin !== null) {
        this.manageDownloadEnabled(newProps);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isExportEnabled = _this$props.isExportEnabled,
        isParticipationReport = _this$props.isParticipationReport,
        exportReport = _this$props.exportReport,
        downloadStudentReport = _this$props.downloadStudentReport,
        isProcessingDownload = _this$props.isProcessingDownload;
      var isDownloadEnabled = this.state.isDownloadEnabled;
      var options = [{
        label: (0, _localeHelpers.translate)('DropDown Button Text Option - PDF')
      }, {
        label: (0, _localeHelpers.translate)('DropDown Button Text Option - Excel')
      }];
      var isStudentRoute = window.location.href.includes('student');
      var showPopup = this.state.shouldDisplayDropdown && !this.state.clickedOutside && !isStudentRoute;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _subHeading["default"].component
      }, /*#__PURE__*/_react["default"].createElement(_subHeadingHeader["default"], null), /*#__PURE__*/_react["default"].createElement(_subHeadingButtons["default"], {
        isExportEnabled: isExportEnabled,
        isProcessingDownload: isProcessingDownload,
        isDownloadEnabled: isDownloadEnabled,
        onDownloadReport: downloadStudentReport,
        onExportReport: isParticipationReport && !isStudentRoute ? this.clickHandler : exportReport,
        shouldDisplayDropdown: this.state.shouldDisplayDropdown,
        forwardedRef: this.myRef
      }), showPopup && /*#__PURE__*/_react["default"].createElement(_popupMenu["default"], {
        options: options,
        onClickHandler: this.clickHandler,
        downloadReports: exportReport
      }));
    }
  }]);
}(_react.Component);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(SubHeading, "propTypes", {
  // activeFilters: PropTypes.shape({
  //     [SELECTED_CLASS]: filterPropType,
  //     [SELECTED_GROUP]: filterPropType,
  //     [SELECTED_STUDENT]: filterPropType,
  //     [SELECTED_REPORT]: filterPropType,
  //     [SELECTED_DATE]: dateFilterPropType
  // }),
  isAdmin: _propTypes["default"].bool,
  isExportEnabled: _propTypes["default"].bool,
  isParticipationReport: _propTypes["default"].bool,
  exportReport: _propTypes["default"].func,
  exportedReport: _propTypes["default"].shape({
    key: _propTypes["default"].string,
    resourcesMethod: _propTypes["default"].string
  }),
  downloadStudentReport: _propTypes["default"].func,
  isProcessingDownload: _propTypes["default"].bool
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    exportedReport: state.exportedReport,
    isAdmin: state.isAdmin,
    isProcessingDownload: state.downloadReport.isProcessingDownload
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    exportReport: _exportReportActions["default"].exportReport,
    downloadStudentReport: _exportReportActions["default"].downloadStudentReport
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_subHeading["default"])(SubHeading));

/***/ }),

/***/ "u5Zj":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("q1+m");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./report-filters.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./report-filters.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uN3G":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".container---1dLtl {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: white;\n  font-size: 11px;\n  line-height: 20px;\n  font-weight: 500; }\n  .container---1dLtl button {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-left: 4px;\n    width: 72px;\n    height: 21px;\n    border-radius: 20px;\n    background-color: rgba(255, 255, 255, .36);\n    border: none;\n    color: white;\n    font-size: 10px;\n    font-weight: 400; }\n  .container---1dLtl button span {\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      margin-left: 1px; }\n  .container---1dLtl button span svg path {\n        fill: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"container": "container---1dLtl"
};

/***/ }),

/***/ "uOny":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _querystring = _interopRequireDefault(__webpack_require__("1nuA"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* global window */
var UrlHelper = exports["default"] = /*#__PURE__*/function () {
  function UrlHelper() {
    _classCallCheck(this, UrlHelper);
  }
  return _createClass(UrlHelper, null, [{
    key: "getQueryParamValue",
    value: function getQueryParamValue(key) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;
      if (url.charAt(0) === '?') {
        url = url.substring(1);
      }
      var params = _querystring["default"].parse(url);
      return params[key];
    }
  }, {
    key: "generateQueryString",
    value: function generateQueryString(params) {
      return _querystring["default"].stringify(params);
    }
  }, {
    key: "isRunningOnDeveloperMachine",
    value: function isRunningOnDeveloperMachine() {
      return /^https?:\/\/localhost/.test(window.location);
    }
  }]);
}();

/***/ }),

/***/ "v/Rl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCertificateFilename = void 0;
exports.getTotalCurriculumAndLivePoints = getTotalCurriculumAndLivePoints;
var getCertificateFilename = exports.getCertificateFilename = function getCertificateFilename(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    certificatesCount = _ref.certificatesCount,
    certificateTypeName = _ref.certificateTypeName,
    _ref$prefixCertificat = _ref.prefixCertificate,
    prefixCertificate = _ref$prefixCertificat === void 0 ? true : _ref$prefixCertificat;
  var i18n = window.i18n;
  var name = "".concat(title, "_").concat(certificatesCount, "_").concat(certificateTypeName);
  if (prefixCertificate) {
    return i18n._(
    /*i18n*/
    {
      id: "Filename - Certificates - {name}",
      values: {
        name: name
      }
    });
  }
  return i18n._(
  /*i18n*/
  {
    id: "Certificates - {name}",
    values: {
      name: name
    }
  });
};
function getTotalCurriculumAndLivePoints(classroomParticipations) {
  var totalCurriculumPoints = 0;
  var totalLiveMathsPoints = 0;
  if (classroomParticipations) {
    classroomParticipations.forEach(function (_ref2) {
      var activityPoints = _ref2.activityPoints,
        livePoints = _ref2.livePoints;
      totalCurriculumPoints += activityPoints;
      totalLiveMathsPoints += livePoints;
    });
  }
  return {
    totalCurriculumPoints: totalCurriculumPoints,
    totalLiveMathsPoints: totalLiveMathsPoints
  };
}

/***/ }),

/***/ "vDBE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PARTICIPATION_STUDENT_RETRIEVED = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _dateParamHelper = _interopRequireDefault(__webpack_require__("IJBn"));
var _errorsActions = _interopRequireDefault(__webpack_require__("egHy"));
var _constants = __webpack_require__("1QGX");
var _selectedImprovementsActions = _interopRequireDefault(__webpack_require__("ad0G"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PARTICIPATION_STUDENT_RETRIEVED = exports.PARTICIPATION_STUDENT_RETRIEVED = 'PARTICIPATION_STUDENT_RETRIEVED';
function getParticipationData(classroomId, studentProfileId, selectedDateFilter) {
  return function (dispatch) {
    dispatch(_selectedImprovementsActions["default"].clearSelectedImprovements());
    _resources["default"].studentReport.get(_objectSpread(_objectSpread({
      reportType: _constants.ENDPOINT_PATH_PARTICIPATION
    }, _dateParamHelper["default"].getDateTypePath(selectedDateFilter)), {}, {
      classroomId: classroomId,
      userProfileId: studentProfileId
    })).withParams(_dateParamHelper["default"].getDateQueryParams(selectedDateFilter)).send().then(function (payload) {
      if (payload.valid) {
        var participationData = payload.data;
        dispatch({
          type: PARTICIPATION_STUDENT_RETRIEVED,
          payload: participationData
        });
        dispatch(_selectedImprovementsActions["default"].setDefaultSelectedImprovements(participationData.topicParticipations));
      } else {
        dispatch(_errorsActions["default"].addError(PARTICIPATION_STUDENT_RETRIEVED));
      }
    });
  };
}
var _default = exports["default"] = {
  getParticipationData: getParticipationData
};

/***/ }),

/***/ "vIzN":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ez0K");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./all-classes.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./all-classes.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vLJg":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lXNV");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./top-level-info.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../node_modules/postcss-loader/lib/index.js!../../../../../node_modules/sass-loader/index.js!./top-level-info.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vMaD":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("R+dW");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./popup-menu.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./popup-menu.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vS7R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCertificatesToast = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _constants = __webpack_require__("1QGX");
var _utils = __webpack_require__("6QRH");
var _toast = _interopRequireDefault(__webpack_require__("cEic"));
var _useTranslations2 = __webpack_require__("ct0i");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useCertificatesToast = exports.useCertificatesToast = function useCertificatesToast() {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showToast = _useState2[0],
    setShowToast = _useState2[1];
  var _useState3 = (0, _react.useState)(200),
    _useState4 = _slicedToArray(_useState3, 2),
    maxCertificates = _useState4[0],
    setMaxCertificates = _useState4[1];
  var _useTranslations = (0, _useTranslations2.useTranslations)(),
    tooManyCertificates = _useTranslations.tooManyCertificates;
  var renderedToast = /*#__PURE__*/_react["default"].createElement(_toast["default"], {
    showToast: showToast,
    message: "".concat(tooManyCertificates, " ").concat(maxCertificates),
    onClose: function onClose() {
      return setShowToast(false);
    }
  });
  (0, _react.useEffect)(function () {
    var fetchConfiguration = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var maxCertificatesCanDownload, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _utils.getConfiguration)(_constants.CONFIGURATION_KEYS.MAX_CERTIFICATES_CAN_DOWNLOAD);
            case 1:
              _t = _context.v;
              if (_t) {
                _context.n = 2;
                break;
              }
              _t = 200;
            case 2:
              maxCertificatesCanDownload = _t;
              setMaxCertificates(maxCertificatesCanDownload);
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function fetchConfiguration() {
        return _ref.apply(this, arguments);
      };
    }();
    fetchConfiguration();
  }, []);
  return {
    renderedToast: renderedToast,
    onOpenToast: function onOpenToast() {
      setShowToast(false);
      setShowToast(true);
    }
  };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "viEY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _basicResources = _interopRequireDefault(__webpack_require__("iV3T"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.
// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
var Resources = /*#__PURE__*/function () {
  function Resources() {
    _classCallCheck(this, Resources);
  }
  return _createClass(Resources, null, [{
    key: "createResources",
    value:
    // createResources() should create a static field for each resource:
    //
    //    const env = parentEnv || Resources.env;
    //
    //    Resources.colours = env.resource('Colours')
    //                           .baseUrl('@AvatarAdminBaseUrl')
    //                           .service('colours');
    //
    //
    // Application code can then access those resources like so:
    //
    //    const allColours = Resource.colours.get().send();

    function createResources(parentEnv) {
      var env = parentEnv || Resources.env;
      var BASE_URL = '@StudentReportsGatewayBaseUrl';
      var CERTIFICATES_BASE_URL = '@CertificatesGatewayBaseUrl';

      /* Filters */

      Resources.academicYear = env.resource('academicYear').baseUrl(BASE_URL).service('school/academicYear');
      Resources.hasLifetimeData = env.resource('hasLifetimeData').baseUrl(BASE_URL).service('school/has-lifetime-data');
      Resources.isAdmin = env.resource('isAdmin').baseUrl(BASE_URL).service('/school/is-admin');
      Resources.yearGroups = env.resource('yearGroups').baseUrl(BASE_URL).service('/school/yeargroups');
      Resources.allClassrooms = env.resource('allClassrooms').baseUrl(BASE_URL).service('school/classrooms');
      Resources.studentsByGroup = env.resource('studentsByGroup').baseUrl(BASE_URL).service('school/classrooms/:classId/students');

      /* Report data */

      Resources.yearGroupReport = env.resource('yearGroupReport').baseUrl(BASE_URL).service('classrooms/years/{yearGroupId}/{reportType}/{dateType}');
      Resources.teacherReport = env.resource('teacherReport').baseUrl(BASE_URL).service('classrooms/years/{yearGroupId}/teachers/{teacherId}/{reportType}/{dateType}');
      Resources.allClassesReport = env.resource('allClassesReport').baseUrl(BASE_URL).service('classrooms/{reportType}/{dateType}');
      Resources.singleClassReport = env.resource('singleClassReport').baseUrl(BASE_URL).service('classrooms/{classroomId}/{reportType}/{dateType}');
      Resources.byClassReport = env.resource('byClassReport').baseUrl(BASE_URL).service('classrooms/years/all/participation/by-class/{dateType}');
      Resources.studentReport = env.resource('studentReport').baseUrl(BASE_URL).service('classrooms/{classroomId}/students/{userProfileId}/{reportType}/{dateType}');
      Resources.studentReportCourse = env.resource('studentReportCourse').baseUrl(BASE_URL).service('classrooms/{classroomId}/students/{userProfileId}/{reportType}/course/{dateType}');
      Resources.top10StudentsReport = env.resource('top10Students').baseUrl(BASE_URL).service('students/participation/top-n/{dateType}');

      /* Export Functionality */

      Resources.allYearsExport = env.resource('allYearsExport').baseUrl(BASE_URL).service('{fileFormat}/{reportType}/years');
      Resources.allYearsExportKey = env.resource('allYearsExportKey').baseUrl(BASE_URL).service('{fileFormat}/{reportType}/years/{downloadKey}');
      Resources.yearGroupTeacherExport = env.resource('yearGroupTeacherExport').baseUrl(BASE_URL).service('{fileFormat}/{reportType}/years/{yearGroupId}/teachers/{teacherId}');
      Resources.yearGroupTeacherExportKey = env.resource('yearGroupTeacherExportKey').baseUrl(BASE_URL).service('{fileFormat}/{reportType}/years/{yearGroupId}/teachers/{teacherId}/{downloadKey}');
      Resources.allClassesExport = env.resource('allClassesExport').baseUrl(BASE_URL).service('{fileFormat}/{reportType}/classrooms');
      Resources.allClassesExportKey = env.resource('allClassesExportKey').baseUrl(BASE_URL).service('{fileFormat}/{reportType}/classrooms/{downloadKey}');
      Resources.singleClassExport = env.resource('singleClassExport').baseUrl(BASE_URL).service('{fileFormat}/{reportType}/classrooms/{classroomId}');
      Resources.singleClassExportKey = env.resource('singleClassExportKey').baseUrl(BASE_URL).service('{fileFormat}/{reportType}/classrooms/{classroomId}/{downloadKey}');
      Resources.studentExport = env.resource('studentExport').baseUrl(BASE_URL).service('pdf/{reportType}/classrooms/{classroomId}/students/{userProfileId}');
      Resources.studentExportKey = env.resource('studentExportKey').baseUrl(BASE_URL).service('pdf/{reportType}/classrooms/{classroomId}/students/{userProfileId}/{downloadKey}');
      Resources.skillQuestsMasteryClassroomExport = env.resource('skillQuestsMasteryClassroomExport').baseUrl(BASE_URL).service('classrooms/skill-mastery/export/this-academic-year');
      Resources.skillQuestsMasteryGroupExport = env.resource('skillQuestsMasteryGroupExport').baseUrl(BASE_URL).service('classrooms/{classroomId}/skill-mastery/export/this-academic-year');
      Resources.skillQuestsMasteryStudentExport = env.resource('skillQuestsMasteryStudentExport').baseUrl(BASE_URL).service('classrooms/{classroomId}/students/{userProfileId}/skill-mastery/course/export/this-academic-year');
      Resources.skillQuestsMasteryClassroomExportCustomDate = env.resource('skillQuestsMasteryClassroomExportCustomDate').baseUrl(BASE_URL).service('classrooms/skill-mastery/export/custom-date');
      Resources.skillQuestsMasteryGroupExportCustomDate = env.resource('skillQuestsMasteryGroupExportCustomDate').baseUrl(BASE_URL).service('classrooms/{classroomId}/skill-mastery/export/custom-date');
      Resources.skillQuestsMasteryStudentExportCustomDate = env.resource('skillQuestsMasteryStudentExportCustomDate').baseUrl(BASE_URL).service('classrooms/{classroomId}/students/{userProfileId}/skill-mastery/course/export/custom-date');
      Resources.generateDownloadReport = env.resource('generateDownloadReport').baseUrl(BASE_URL).service('zip/classrooms/{classroomId}/reports');
      Resources.downloadNewCertificates = env.resource('downloadNewCertificates').baseUrl(CERTIFICATES_BASE_URL).service('api/v1/new-certificates/export');
      Resources.downloadNewCertificatesByType = env.resource('downloadNewCertificatesByType').baseUrl(CERTIFICATES_BASE_URL).service('api/v1/new-certificates/types/{type}/export');
      Resources.downloadNewCertificatesStudent = env.resource('downloadNewCertificatesStudent').baseUrl(CERTIFICATES_BASE_URL).service('api/v1/new-certificates/students/{userId}/export');
      Resources.downloadNewCertificatesStudentByType = env.resource('downloadNewCertificatesStudentByType').baseUrl(CERTIFICATES_BASE_URL).service('api/v1/new-certificates/students/{userId}/types/{type}/export');
      Resources.downloadPastCertificates = env.resource('downloadPastCertificates').baseUrl(CERTIFICATES_BASE_URL).service('api/v1/certificates/export');
      Resources.downloadPastCertificatesByType = env.resource('downloadPastCertificatesByType').baseUrl(CERTIFICATES_BASE_URL).service('api/v1/certificates/types/{type}/export');
      Resources.downloadPastCertificatesStudentByType = env.resource('downloadPastCertificatesStudentByType').baseUrl(CERTIFICATES_BASE_URL).service('api/v1/certificates/students/{userProfileId}/export');
      Resources.getGemCounts = env.resource('getGemCounts').baseUrl(CERTIFICATES_BASE_URL).service('api/v1/new-certificates/gemCounts');
      /**
       * Gets Configuration Item
       * @params: key: configuration item key
       */
      Resources.getConfigurationItem = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(key) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                return _context.a(2, env.getConfigurationItem(key));
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    }

    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.
  }, {
    key: "initialise",
    value: function initialise(envName, credentials) {
      Resources.env = _basicResources["default"].initialise(envName, credentials);
      Resources.createResources();
      return Resources.env;
    }
  }]);
}();
var _default = exports["default"] = Resources;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("py1Q")))

/***/ }),

/***/ "vuxJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _contextModal = _interopRequireDefault(__webpack_require__("kQP1"));
var _contextModalConstants = __webpack_require__("FCoq");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* global window document */
var ContextModal = /*#__PURE__*/function (_Component) {
  function ContextModal(props) {
    var _this;
    _classCallCheck(this, ContextModal);
    _this = _callSuper(this, ContextModal, [props]);
    _defineProperty(_this, "handleClickOutside", function (event) {
      var containsModalEvent = _this.contextModalRef && !_this.contextModalRef.contains(event.target);
      if (containsModalEvent) {
        _this.props.onClickOutsideHandler();
      }
    });
    _defineProperty(_this, "setContextModalRef", function (node) {
      _this.contextModalRef = node;
    });
    _this.setContextModalRef = _this.setContextModalRef.bind(_this);
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }
  _inherits(ContextModal, _Component);
  return _createClass(ContextModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.show) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_contextModal["default"]['context-modal'], " ").concat(this.props.className),
          ref: this.setContextModalRef
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_contextModal["default"]['modal-container'], " ").concat(_contextModal["default"][this.props.position])
        }, this.props.children));
      }
      return null;
    }
  }]);
}(_react.Component);
_defineProperty(ContextModal, "propTypes", {
  className: _propTypes["default"].string,
  show: _propTypes["default"].bool,
  onClickOutsideHandler: _propTypes["default"].func,
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].bool, _propTypes["default"].string]),
  position: _propTypes["default"].string
});
ContextModal.defaultProps = {
  position: _contextModalConstants.CONTEXT_MODAL_POSITION.MODAL_UP
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_contextModal["default"])(ContextModal);

/***/ }),

/***/ "w1s4":
/***/ (function(module, exports) {

module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/1f0a9c11d9fc93b24f2c0fed6cecf3ef.svg";

/***/ }),

/***/ "wAWk":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("AoEh");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificates.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./certificates.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wdOd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("sou6");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./display-control-container.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./display-control-container.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "x/jf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Student = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _filterPropTypes = __webpack_require__("1g86");
var _filterConstants = __webpack_require__("cdWI");
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _student = _interopRequireDefault(__webpack_require__("95d/"));
var _studentActions = _interopRequireWildcard(__webpack_require__("vDBE"));
var _studentPropTypes = _interopRequireDefault(__webpack_require__("DUt9"));
var _tableHeader = _interopRequireDefault(__webpack_require__("dpkF"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _topicTables = _interopRequireDefault(__webpack_require__("F6Ua"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _studentCertificates = _interopRequireDefault(__webpack_require__("ULxP"));
var _usage = _interopRequireDefault(__webpack_require__("DtE0"));
var _certificatesActions = _interopRequireDefault(__webpack_require__("PLdC"));
var _allClassesConstants = __webpack_require__("Wsmd");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Student component
 * Displays participation results table, certificates & usage for a single Student
 */
var Student = exports.Student = /*#__PURE__*/function (_Component) {
  function Student(props) {
    var _this;
    _classCallCheck(this, Student);
    _this = _callSuper(this, Student, [props]);
    _defineProperty(_this, "getUsageData", function (participationData) {
      if (participationData) {
        var _participationData$pa = participationData.participationInfo,
          liveMathsPoints = _participationData$pa.liveMathsPoints,
          activityPoints = _participationData$pa.activityPoints,
          _participationData$lo = participationData.logInInfo,
          signIns = _participationData$lo.signIns,
          timeOnline = _participationData$lo.timeOnline,
          certificates = participationData.certificates;
        return {
          totalGoldBars: certificates.goldBars,
          totalSignIns: signIns,
          totalTimeOnline: timeOnline,
          totalLiveMathsPoints: liveMathsPoints,
          totalCurriculumPoints: activityPoints
        };
      }
      return null;
    });
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(Student, _Component);
  return _createClass(Student, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeFilters = this.props.activeFilters;
      if (_filterHelper["default"].shouldLoadStudent(activeFilters)) {
        this.getStudentParticipationData(activeFilters[_filterConstants.SELECTED_STUDENT].id, activeFilters[_filterConstants.SELECTED_CLASS].id, activeFilters[_filterConstants.SELECTED_DATE]);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props = this.props,
        activeFilters = _this$props.activeFilters,
        invalidRequest = _this$props.invalidRequest,
        updateActiveFilter = _this$props.updateActiveFilter;
      var newActiveFilters = newProps.activeFilters,
        newInvalidRequest = newProps.invalidRequest;
      if (_filterHelper["default"].shouldReloadStudent(activeFilters, newActiveFilters)) {
        this.getStudentParticipationData(newActiveFilters[_filterConstants.SELECTED_STUDENT].id, newActiveFilters[_filterConstants.SELECTED_CLASS].id, newActiveFilters[_filterConstants.SELECTED_DATE]);
      }
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _studentActions.PARTICIPATION_STUDENT_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "getStudentParticipationData",
    value: function getStudentParticipationData(studentId, classId, selectedDateFilter) {
      var getParticipationData = this.props.getParticipationData;
      getParticipationData(classId, studentId, selectedDateFilter);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        participationData = _this$props2.participationData,
        newCertificatesDownloadStudentByType = _this$props2.newCertificatesDownloadStudentByType,
        pastCertificatesDownloadByType = _this$props2.pastCertificatesDownloadByType,
        activeFilters = _this$props2.activeFilters,
        studentDropdownData = _this$props2.studentDropdownData;
      var studentsData = studentDropdownData.data;
      var selectedGroupId = activeFilters[_filterConstants.SELECTED_GROUP].id;
      var selectedStudent = studentsData.find(function (data) {
        return data.value === activeFilters[_filterConstants.SELECTED_STUDENT].id;
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _student["default"].component
      }, /*#__PURE__*/_react["default"].createElement(_tableHeader["default"], {
        title: this.i18n._('Table Header - Participation')
      }), /*#__PURE__*/_react["default"].createElement(_usage["default"], _extends({
        showGoldBars: true
      }, this.getUsageData(participationData))), /*#__PURE__*/_react["default"].createElement(_studentCertificates["default"], {
        selectedClassroomId: activeFilters[_filterConstants.SELECTED_CLASS].id,
        selectedStudentId: selectedStudent && selectedStudent.userId,
        selectedGroupId: selectedGroupId === _filterConstants.ALL_GROUPS ? _allClassesConstants.ALL_GROUPS_ID : selectedGroupId,
        participationData: participationData,
        newCertificatesDownloadStudentByType: newCertificatesDownloadStudentByType,
        pastCertificatesDownloadByType: pastCertificatesDownloadByType,
        selectedYearGroupId: activeFilters[_filterConstants.SELECTED_YEAR_GROUP].id,
        selectedTeacherId: activeFilters[_filterConstants.SELECTED_TEACHER].id
      }), /*#__PURE__*/_react["default"].createElement(_topicTables["default"], null));
    }
  }]);
}(_react.Component);
_defineProperty(Student, "propTypes", {
  activeFilters: _filterPropTypes.activeFiltersPropType,
  getParticipationData: _propTypes["default"].func,
  participationData: _studentPropTypes["default"].participationData,
  invalidRequest: _propTypes["default"].string,
  updateActiveFilter: _propTypes["default"].func,
  newCertificatesDownloadStudentByType: _propTypes["default"].func,
  pastCertificatesDownloadByType: _propTypes["default"].func,
  studentDropdownData: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_filterPropTypes.dropdownItemPropType),
    selectedOption: _filterPropTypes.dropdownItemPropType
  })
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    participationData: state.participationStudent,
    invalidRequest: state.invalidRequest,
    studentDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.STUDENT_LIST)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getParticipationData: _studentActions["default"].getParticipationData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter,
    newCertificatesDownloadStudentByType: _certificatesActions["default"].newCertificatesDownloadStudentByType,
    pastCertificatesDownloadByType: _certificatesActions["default"].pastCertificatesDownloadByType
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Student);

/***/ }),

/***/ "x3lM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _exportReportActions = __webpack_require__("oXgP");
var initialState = {
  key: null,
  resourcesMethod: null
};

/**
 * Export Report Reducer
 *
 * Consumes REPORT_EXPORTED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _exportReportActions.REPORT_EXPORTED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "x4K0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactRedux = __webpack_require__("RH2O");
var _reactRouterDom = __webpack_require__("F8kA");
var _reactComponents = __webpack_require__("fmgT");
var _react2 = __webpack_require__("QruM");
__webpack_require__("nIya");
var _entryApp = _interopRequireDefault(__webpack_require__("B7He"));
var _basicApp = _interopRequireDefault(__webpack_require__("SgkA"));
var _errorHandling = _interopRequireDefault(__webpack_require__("FLtZ"));
var _constants = __webpack_require__("1QGX");
var _emptyStateConstants = _interopRequireDefault(__webpack_require__("pYuN"));
var _sessionidHelper = _interopRequireDefault(__webpack_require__("32hn"));
var _modalContainer = _interopRequireDefault(__webpack_require__("t+mH"));
var _busyIndicator = _interopRequireDefault(__webpack_require__("0Cvf"));
var _activityMastery = _interopRequireDefault(__webpack_require__("4/C/"));
var _participation = _interopRequireDefault(__webpack_require__("9JZ4"));
var _liveMaths = _interopRequireDefault(__webpack_require__("dppr"));
var _skillQuestsMastery = _interopRequireDefault(__webpack_require__("zkOa"));
var _participationFooter = _interopRequireDefault(__webpack_require__("NVCm"));
var _pageHeader = _interopRequireDefault(__webpack_require__("AJp4"));
var _emptyState = _interopRequireDefault(__webpack_require__("e7yh"));
var _displayControlContainer = _interopRequireDefault(__webpack_require__("ph81"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } /* global window */
var EntryApp = exports["default"] = /*#__PURE__*/function (_BasicApp) {
  function EntryApp() {
    _classCallCheck(this, EntryApp);
    return _callSuper(this, EntryApp, arguments);
  }
  _inherits(EntryApp, _BasicApp);
  return _createClass(EntryApp, [{
    key: "render",
    value: function render(store, i18n) {
      // When executing on demo, QA, or production, the host app will inject a property
      // called pppAppConfig into the global window variable.  This will provide the
      // base name of the app.  Most of the time that will be an empty string, but in
      // case it is not, we will extract it and pass it to the router, below.
      // eslint-disable-next-line no-underscore-dangle
      var appConfig = window._env_;
      var BASE_NAME = appConfig ? appConfig.BaseName : '';

      // Add an interceptor to handle errors when accessing resources
      _errorHandling["default"].addResourceResponseErrorInterceptor(store.dispatch);
      // Add request & response interceptors for session id
      _sessionidHelper["default"].addInterceptors(store);
      return /*#__PURE__*/_react["default"].createElement(_react2.I18nProvider, {
        i18n: i18n
      }, /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
        store: store
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.ThemeProvider, {
        theme: _objectSpread(_objectSpread({}, _reactComponents.brightTheme), {}, {
          overrides: {
            modal: {
              width: '50%',
              maxWidth: '600px',
              borderRadius: '20px'
            },
            footer: {
              spacing: 10
            }
          }
        })
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, {
        history: _reactRouterDom.browserHistory,
        basename: BASE_NAME
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _entryApp["default"].app
      }, /*#__PURE__*/_react["default"].createElement(_emptyState["default"], {
        variant: _emptyStateConstants["default"].NO_CLASSES
      }, /*#__PURE__*/_react["default"].createElement(_busyIndicator["default"], null), /*#__PURE__*/_react["default"].createElement(_pageHeader["default"], null), /*#__PURE__*/_react["default"].createElement(_displayControlContainer["default"], null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: _constants.ACTIVITY_MASTERY_PATH,
        component: _activityMastery["default"]
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: _constants.LIVE_MATHS_PATH,
        component: _liveMaths["default"]
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: _constants.PARTICIPATION_PATH,
        component: _participation["default"]
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: _constants.SKILL_QUESTS_MASTERY_PATH,
        component: _skillQuestsMastery["default"]
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        from: "*",
        to: _constants.PARTICIPATION_PATH
      }))), /*#__PURE__*/_react["default"].createElement(_participationFooter["default"], {
        className: _entryApp["default"].footer
      }), /*#__PURE__*/_react["default"].createElement(_modalContainer["default"], null)))))));
    }
  }]);
}(_basicApp["default"]);
window.EntryApp = EntryApp;

/***/ }),

/***/ "xDjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _allClassesActions = __webpack_require__("jSO5");
var initialState = null;

/**
 * Activity Mastery - All Classes Reducer
 *
 * Consumes ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED action
 *
 * @access public
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - the action's payload, or the current state if action is unhandled
 */
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;
  switch (action.type) {
    case _allClassesActions.ACTIVITY_MASTERY_ALL_CLASSES_RETRIEVED:
      return action.payload;
    default:
      return state;
  }
}

/***/ }),

/***/ "xKme":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JbS1");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./student.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../node_modules/postcss-loader/lib/index.js!../../../node_modules/sass-loader/index.js!./student.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xR72":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IS_SCHOOL_ADMIN = void 0;
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var IS_SCHOOL_ADMIN = exports.IS_SCHOOL_ADMIN = 'IS_SCHOOL_ADMIN';
function getIsSchoolAdmin() {
  return function (dispatch) {
    return _resources["default"].isAdmin.get().send().then(function (payload) {
      return dispatch({
        type: IS_SCHOOL_ADMIN,
        payload: payload.data
      });
    });
  };
}
var _default = exports["default"] = {
  getIsSchoolAdmin: getIsSchoolAdmin
};

/***/ }),

/***/ "xhvn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SingleClass = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _reactRedux = __webpack_require__("RH2O");
var _redux = __webpack_require__("2KeS");
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _reactComponents = __webpack_require__("fmgT");
var _cloneDeep = _interopRequireDefault(__webpack_require__("kvU2"));
var _singleClass = _interopRequireDefault(__webpack_require__("tBEy"));
var _singleClassActions = _interopRequireWildcard(__webpack_require__("km3k"));
var _singleClassConstants = __webpack_require__("IuTT");
var _activityStatusBar = _interopRequireDefault(__webpack_require__("jJ7R"));
var _topicActivityStrengthWeakness = _interopRequireDefault(__webpack_require__("EeH8"));
var _activeFiltersActions = _interopRequireDefault(__webpack_require__("3PpY"));
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _singleClassPropTypes = _interopRequireDefault(__webpack_require__("BOI9"));
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _filterHelper = _interopRequireDefault(__webpack_require__("mXER"));
var _activityMasteryLegends = _interopRequireDefault(__webpack_require__("S6Bi"));
var _localeHelpers = __webpack_require__("rjLd");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * SingleClass component
 * Displays Activity Mastery table and strengths & weaknesses tabs for single classes
 */
var SingleClass = exports.SingleClass = /*#__PURE__*/function (_Component) {
  function SingleClass(props) {
    var _this;
    _classCallCheck(this, SingleClass);
    _this = _callSuper(this, SingleClass, [props]);
    /**
     * Update table config, setting properties which require the backend data
     */
    _defineProperty(_this, "setTableConfig", function (payload, groupId) {
      var tableConfig = (0, _cloneDeep["default"])(_singleClassConstants.SINGLE_CLASS_TABLE_CONFIG);
      var groupCol = _this.getColFromConfig(tableConfig, _singleClassConstants.GROUP_NAME);
      groupCol.name = payload.teacherName;
      if (!groupId) {
        groupCol.sort = {
          sortAs: 'string',
          sortDir: 'desc'
        };
        groupCol.onClick = function (selectedGroup) {
          return _this.loadNewPage(_filterConstants.SELECTED_GROUP, selectedGroup);
        };
      }
      var activityMasteryData = payload.activityMastery;
      if (groupId) {
        activityMasteryData = payload.activityMastery.groupActivityMastery.find(function (group) {
          return group.id === groupId;
        });
      }
      _this.getColFromConfig(tableConfig, _singleClassConstants.COURSE_NAME).headerTransform = function () {
        return /*#__PURE__*/_react["default"].createElement(_activityStatusBar["default"], {
          activityMastery: activityMasteryData
        });
      };
      _this.getColFromConfig(tableConfig, _singleClassConstants.TOTAL_ACTIVITIES).name = "".concat(payload.activityMastery.totalActivities);
      _this.getColFromConfig(tableConfig.nestedData, _singleClassConstants.STUDENT_NAME).onClick = function (selectedStudent) {
        return _this.loadNewPage(_filterConstants.SELECTED_STUDENT, selectedStudent);
      };
      tableConfig = (0, _localeHelpers.translateTableLabels)(tableConfig);
      _this.setState({
        tableConfig: tableConfig
      });
    });
    _defineProperty(_this, "getColFromConfig", function (config, colId) {
      return config.cols.find(function (col) {
        return col.id === colId;
      });
    });
    /**
     * Loads the group or student page when user clicks on item in table
     */
    _defineProperty(_this, "loadNewPage", function (filterName, selectedItem) {
      _this.props.updateActiveFilter(filterName, {
        id: selectedItem.id,
        name: selectedItem.name
      });
    });
    _this.state = {
      tableConfig: null,
      strengthData: {
        topics: [],
        activties: []
      },
      weaknessData: {
        topics: [],
        activities: []
      },
      filteredGroups: []
    };
    _this.i18n = window.i18n;
    return _this;
  }
  _inherits(SingleClass, _Component);
  return _createClass(SingleClass, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var activeFilters = this.props.activeFilters;
      if (_filterHelper["default"].shouldLoadSingleClass(activeFilters)) {
        this.getClassActivityMasteryData(activeFilters[_filterConstants.SELECTED_DATE], activeFilters[_filterConstants.SELECTED_CLASS].id);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this$props = this.props,
        activeFilters = _this$props.activeFilters,
        activityMasteryData = _this$props.activityMasteryData,
        invalidRequest = _this$props.invalidRequest,
        updateActiveFilter = _this$props.updateActiveFilter;
      var newActiveFilters = newProps.activeFilters,
        newActivityMasteryData = newProps.activityMasteryData,
        newInvalidRequest = newProps.invalidRequest;
      if (_filterHelper["default"].shouldReloadSingleClass(activeFilters, newActiveFilters)) {
        this.getClassActivityMasteryData(newActiveFilters[_filterConstants.SELECTED_DATE], newActiveFilters[_filterConstants.SELECTED_CLASS].id);
      }
      if (activityMasteryData !== newActivityMasteryData) {
        this.setActivityMasteryData(newActivityMasteryData, activeFilters[_filterConstants.SELECTED_GROUP].id);
      }
      if (invalidRequest !== newInvalidRequest && newInvalidRequest === _singleClassActions.ACTIVITY_MASTERY_CLASS_RETRIEVED) {
        if (newActiveFilters[_filterConstants.SELECTED_DATE].type !== _reactComponents.DatePicker.THIS_SCHOOL_YEAR) {
          updateActiveFilter(_filterConstants.SELECTED_DATE, {
            type: _reactComponents.DatePicker.THIS_SCHOOL_YEAR
          });
        }
      }
    }
  }, {
    key: "getClassActivityMasteryData",
    value: function getClassActivityMasteryData(selectedDate, classId) {
      this.props.getActivityMasteryData(classId, selectedDate);
    }
  }, {
    key: "setActivityMasteryData",
    value: function setActivityMasteryData(activityMasteryData, groupId) {
      groupId = +groupId || 0;
      var strengthData;
      var weaknessData;
      var filteredGroups = activityMasteryData.activityMastery.groupActivityMastery;
      if (groupId) {
        filteredGroups = filteredGroups.filter(function (group) {
          return group.id === groupId;
        });
        strengthData = filteredGroups[0].strengths;
        weaknessData = filteredGroups[0].weaknesses;
      } else {
        strengthData = activityMasteryData.strengths;
        weaknessData = activityMasteryData.weaknesses;
      }
      this.setState({
        strengthData: strengthData,
        weaknessData: weaknessData,
        filteredGroups: filteredGroups
      });
      this.setTableConfig(activityMasteryData, groupId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        tableConfig = _this$state.tableConfig,
        filteredGroups = _this$state.filteredGroups,
        strengthData = _this$state.strengthData,
        weaknessData = _this$state.weaknessData;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_activityMasteryLegends["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"].component
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"]['data-table']
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.DataTable, {
        config: tableConfig,
        data: filteredGroups
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _singleClass["default"]['strength-weakness']
      }, /*#__PURE__*/_react["default"].createElement(_topicActivityStrengthWeakness["default"], {
        strengths: strengthData,
        weaknesses: weaknessData
      }))));
    }
  }]);
}(_react.Component);
_defineProperty(SingleClass, "propTypes", {
  activityMasteryData: _singleClassPropTypes["default"].activityMasteryData,
  activeFilters: _filterPropTypes.activeFiltersPropType,
  getActivityMasteryData: _propTypes["default"].func,
  updateActiveFilter: _propTypes["default"].func,
  invalidRequest: _propTypes["default"].string
});
function mapStateToProps(state) {
  return {
    activeFilters: _activeFiltersSelectors["default"].selectActiveFilters(state),
    activityMasteryData: state.activityMasterySingleClass,
    invalidRequest: state.invalidRequest
  };
}
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getActivityMasteryData: _singleClassActions["default"].getActivityMasteryData,
    updateActiveFilter: _activeFiltersActions["default"].updateActiveFilter
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactStyleable["default"])(_singleClass["default"])(SingleClass));

/***/ }),

/***/ "yC/G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StudentDropdown = void 0;
var _react = _interopRequireWildcard(__webpack_require__("GiK3"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _redux = __webpack_require__("2KeS");
var _reactRedux = __webpack_require__("RH2O");
var _reactComponents = __webpack_require__("fmgT");
var _filterConstants = __webpack_require__("cdWI");
var _filterPropTypes = __webpack_require__("1g86");
var _dropdownDataSelectors = _interopRequireDefault(__webpack_require__("+UNJ"));
var _dropdownDataActions = _interopRequireDefault(__webpack_require__("FkcL"));
var _dropdownHelpers = __webpack_require__("KmGe");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StudentDropdown = exports.StudentDropdown = /*#__PURE__*/function (_PureComponent) {
  function StudentDropdown() {
    var _this;
    _classCallCheck(this, StudentDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StudentDropdown, [].concat(args));
    _defineProperty(_this, "optionSelected", function (selectedOption) {
      var _this$props = _this.props,
        handleStudentChange = _this$props.handleStudentChange,
        setSelectedStudent = _this$props.setSelectedStudent;
      setSelectedStudent(selectedOption);
      handleStudentChange();
    });
    return _this;
  }
  _inherits(StudentDropdown, _PureComponent);
  return _createClass(StudentDropdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        studentDropdownData = _this$props2.studentDropdownData,
        className = _this$props2.className;
      var data = studentDropdownData.data,
        selectedOption = studentDropdownData.selectedOption,
        disabled = studentDropdownData.disabled;
      var i18n = window.i18n;
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.DropdownMenu, {
        className: className,
        options: (0, _dropdownHelpers.getTranslatedOptions)(data, _filterConstants.ALL_STUDENTS, i18n),
        selectedOption: (0, _dropdownHelpers.getTranslateSelectedOption)(selectedOption, _filterConstants.ALL_STUDENTS, i18n),
        onSelectOption: this.optionSelected,
        disabled: disabled
      });
    }
  }]);
}(_react.PureComponent);
/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
_defineProperty(StudentDropdown, "propTypes", {
  studentDropdownData: _propTypes["default"].shape({
    data: _propTypes["default"].arrayOf(_filterPropTypes.dropdownItemPropType),
    selectedOption: _filterPropTypes.dropdownItemPropType,
    disabled: _propTypes["default"].bool
  }),
  className: _propTypes["default"].string,
  setSelectedStudent: _propTypes["default"].func,
  handleStudentChange: _propTypes["default"].func
});
function mapStateToProps(state) {
  return {
    studentDropdownData: _dropdownDataSelectors["default"].selectDropdownDataByType(_filterConstants.STUDENT_LIST)(state)
  };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setSelectedStudent: _dropdownDataActions["default"].setSelectedStudent
  }, dispatch);
}
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StudentDropdown);

/***/ }),

/***/ "ygMb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("/JVf");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./activity-mastery-legends.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/sass-loader/index.js!./activity-mastery-legends.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ylJo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".assignment-results-container---3ciLz {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-left: 16px;\n  font-size: 14px; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    position: relative;\n    height: 30px; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB .assignment-button---15ewY {\n      background-color: #278bcb;\n      color: #fff;\n      border-radius: 24px;\n      width: 290px;\n      height: 30px;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB .assignment-button---15ewY .text---2x0zs {\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: center; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB .assignment-button---15ewY svg {\n        -webkit-transform: rotate(180deg);\n                transform: rotate(180deg);\n        height: 14px; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB .border---35lmb {\n      border-right: 1px solid #e4eaef;\n      height: 36px;\n      margin-left: 14px; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB .assignment-results-context-modal---t-Ai_ {\n      top: 42px;\n      right: 6px; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB .assignment-results-context-modal---t-Ai_ .assigned-attempts-container---1O23J {\n        width: 260px;\n        height: auto; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB .assignment-results-context-modal---t-Ai_ .assigned-attempts-container---1O23J .assigned-attempts-wrapper---Z_wap {\n          width: 100%;\n          height: 170px;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-orient: vertical;\n          -webkit-box-direction: normal;\n              -ms-flex-direction: column;\n                  flex-direction: column;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n          -webkit-box-pack: justify;\n              -ms-flex-pack: justify;\n                  justify-content: space-between; }\n  .assignment-results-container---3ciLz .assignment-results-wrapper---32elB .assignment-results-context-modal---t-Ai_ .assigned-attempts-container---1O23J .assigned-attempts-wrapper---Z_wap .header-text---H_n84 {\n            color: #4e5c67;\n            font-weight: 600;\n            margin-bottom: 10px; }\n", ""]);

// exports
exports.locals = {
	"assignment-results-container": "assignment-results-container---3ciLz",
	"assignment-results-wrapper": "assignment-results-wrapper---32elB",
	"assignment-button": "assignment-button---15ewY",
	"text": "text---2x0zs",
	"border": "border---35lmb",
	"assignment-results-context-modal": "assignment-results-context-modal---t-Ai_",
	"assigned-attempts-container": "assigned-attempts-container---1O23J",
	"assigned-attempts-wrapper": "assigned-attempts-wrapper---Z_wap",
	"header-text": "header-text---H_n84"
};

/***/ }),

/***/ "ylPA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_REPORT_SELECTION = exports.RESET_REPORT_SELECTION = exports.DOWNLOAD_REQUESTED = exports.DOWNLOAD_COMPLETED = void 0;
exports["default"] = downloadAction;
exports.resetReportSelections = void 0;
exports.studentReportDownload = studentReportDownload;
exports.updateReportSelection = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactComponents = __webpack_require__("fmgT");
var _localeHelpers = __webpack_require__("rjLd");
var _activeFiltersSelectors = _interopRequireDefault(__webpack_require__("t1T8"));
var _filterConstants = __webpack_require__("cdWI");
var _modalActions = _interopRequireDefault(__webpack_require__("iUhG"));
var _downloadPicker = _interopRequireDefault(__webpack_require__("9AQG"));
var _resources = _interopRequireDefault(__webpack_require__("viEY"));
var _uiHelper = _interopRequireDefault(__webpack_require__("Vhb/"));
var _exportReportActions = __webpack_require__("oXgP");
var _busyIndicatorActions = _interopRequireDefault(__webpack_require__("qS76"));
var _constants = __webpack_require__("1QGX");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UPDATE_REPORT_SELECTION = exports.UPDATE_REPORT_SELECTION = 'UPDATE_REPORT_SELECTION';
var DOWNLOAD_REQUESTED = exports.DOWNLOAD_REQUESTED = 'DOWNLOAD_REQUESTED';
var DOWNLOAD_COMPLETED = exports.DOWNLOAD_COMPLETED = 'DOWNLOAD_COMPLETED';
var RESET_REPORT_SELECTION = exports.RESET_REPORT_SELECTION = 'RESET_REPORT_SELECTION';
var downloadRequested = function downloadRequested() {
  return {
    type: DOWNLOAD_REQUESTED
  };
};
var downloadCompleted = function downloadCompleted() {
  return {
    type: DOWNLOAD_COMPLETED
  };
};
var getModalContent = function getModalContent(dispatch, getState) {
  var i18n = window.i18n;
  var modalBtnDisabled = getState().downloadReport.reportTypes.length === 0;
  var text = {
    titleText: i18n._(
    /*i18n*/
    {
      id: "Download Report - Download Student Reports",
      defaults: "Download Student Reports"
    }),
    cancelText: i18n._(
    /*i18n*/
    {
      id: "Download Report - Cancel",
      defaults: "Cancel"
    }),
    exportText: i18n._(
    /*i18n*/
    {
      id: "Download Report - Export",
      defaults: "Export"
    })
  };
  return {
    title: text.titleText,
    content: /*#__PURE__*/_react["default"].createElement(_downloadPicker["default"], null),
    buttons: [{
      text: text.cancelText,
      danger: true
    }, {
      text: text.exportText,
      primary: true,
      disabled: modalBtnDisabled,
      type: _reactComponents.Button.LOZENGE,
      handler: function handler() {
        studentReportDownload(dispatch, getState);
      }
    }]
  };
};
var updateReportSelection = exports.updateReportSelection = function updateReportSelection(reportTypes) {
  return function (dispatch, getState) {
    dispatch({
      type: UPDATE_REPORT_SELECTION,
      reportTypes: reportTypes
    });
    dispatch(_modalActions["default"].updateModal(getModalContent(dispatch, getState)));
  };
};
var resetReportSelections = exports.resetReportSelections = function resetReportSelections() {
  return function (dispatch) {
    dispatch({
      type: RESET_REPORT_SELECTION
    });
  };
};
function downloadAction() {
  return function (dispatch, getState) {
    dispatch(_modalActions["default"].openModal(getModalContent(dispatch, getState)));
  };
}
function studentReportDownload(dispatch, getState) {
  var state = getState();
  var classroomId = _activeFiltersSelectors["default"].selectClassId(state);
  var selectedDate = _activeFiltersSelectors["default"].selectDate(state);
  var dateRange = _filterConstants.DATE_RANGE_OPTIONS[selectedDate.type];
  var assignmentResultType = state.assignmentResultType;
  var locale = (0, _localeHelpers.localeCode)();
  var request = {
    reportTypes: state.downloadReport.reportTypes,
    productId: _constants.MATHLETICS_ID,
    dateRange: dateRange,
    upfReportAssignmentResultType: assignmentResultType
  };
  request.startDate = selectedDate.startDate;
  request.endDate = selectedDate.endDate;
  _resources["default"].generateDownloadReport.post({
    classroomId: classroomId
  }).withBody(request).withParams({
    locale: locale
  }).send().then(function (payload) {
    dispatch(downloadCompleted());
    if (payload.valid) {
      var _payload$data = payload.data,
        reportDate = _payload$data.reportDate,
        downloadKey = _payload$data.downloadKey;
      if (downloadKey) {
        var paramIdx = payload.verb.url.indexOf('?');
        if (paramIdx !== -1) {
          payload.verb.url = payload.verb.url.substring(0, paramIdx);
        }
        var _UIHelper$formatDate = _uiHelper["default"].formatDate({
            startDate: reportDate,
            endDate: reportDate
          }),
          startDate = _UIHelper$formatDate.startDate;
        var reportDateFormatted = startDate.replace(/\s/g, '');
        dispatch({
          type: _exportReportActions.REPORT_EXPORTED,
          payload: {
            downloadUrl: encodeURI("".concat(payload.verb.url, "/").concat(downloadKey, "/").concat(reportDateFormatted))
          }
        });
      }
    }
  });
  dispatch(_modalActions["default"].closeModal());
  dispatch(_busyIndicatorActions["default"].hideBusy());
  dispatch(downloadRequested());
}

/***/ }),

/***/ "zJFk":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4Hqn");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../../node_modules/postcss-loader/lib/index.js!../../../../../../node_modules/sass-loader/index.js!./download-button.scss", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../../../../../node_modules/postcss-loader/lib/index.js!../../../../../../node_modules/sass-loader/index.js!./download-button.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "zkOa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__("GiK3"));
var _reactStyleable = _interopRequireDefault(__webpack_require__("KJcn"));
var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));
var _skillQuestsMastery = _interopRequireDefault(__webpack_require__("Qf7c"));
var _allClasses = _interopRequireDefault(__webpack_require__("U87u"));
var _student = _interopRequireDefault(__webpack_require__("oMuz"));
var _subHeading = _interopRequireDefault(__webpack_require__("tecg"));
var _singleClass = _interopRequireDefault(__webpack_require__("YPw6"));
var _reportRoutes = _interopRequireDefault(__webpack_require__("lXLQ"));
var _emptyState = _interopRequireDefault(__webpack_require__("e7yh"));
var _emptyStateConstants = _interopRequireDefault(__webpack_require__("pYuN"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SkillQuestsMastery = function SkillQuestsMastery(_ref) {
  var location = _ref.location;
  var routeComps = {
    allClasses: _allClasses["default"],
    singleClass: _singleClass["default"],
    student: _student["default"]
  };

  /**
   * Updated UI/UX requires change to the regular structure of application
   * We do not render children for student level report
   * We will use 'student' keyword in url to match
   */
  var shouldDisplayChildren = function shouldDisplayChildren() {
    return location.pathname.indexOf('student') === -1;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _skillQuestsMastery["default"].component
  }, /*#__PURE__*/_react["default"].createElement(_emptyState["default"], {
    variant: _emptyStateConstants["default"].NO_STUDENTS
  }, /*#__PURE__*/_react["default"].createElement(_reportRoutes["default"], {
    components: routeComps
  }, shouldDisplayChildren() && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_subHeading["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: _skillQuestsMastery["default"]['report-container']
  })))));
};
SkillQuestsMastery.propTypes = {
  location: _propTypes["default"].any
};
var _default = exports["default"] = (0, _reactStyleable["default"])(_skillQuestsMastery["default"])(SkillQuestsMastery);

/***/ }),

/***/ "zmJ7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("27ps");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./page-header.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./page-header.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ })

},[2]);


// WEBPACK FOOTER //
// entry-app.ed87a15eb3414965302a.js